var uScope =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp_name_"];
/******/ 	window["webpackJsonp_name_"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			modules[moduleId] = moreModules[moduleId];
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/ 		if(moreModules[0]) {
/******/ 			installedModules[0] = 0;
/******/ 			return __webpack_require__(0);
/******/ 		}
/******/ 	};

/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		12:0
/******/ 	};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}

/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);

/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;

/******/ 			script.src = __webpack_require__.p + "" + chunkId + "." + ({"0":"annotations","1":"conferencing","2":"imageAdjust","3":"imageToolbar","4":"label","5":"magnifier","6":"performanceServices","7":"rasterScan","8":"rotationDial","9":"scalebar","10":"settingsServices","11":"thumbnail","13":"zoom"}[chunkId]||chunkId) + ".js";
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};

/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(54);
	__webpack_require__(36);
	__webpack_require__(45);
	__webpack_require__(78);
	__webpack_require__(1);
	__webpack_require__(82);
	__webpack_require__(379);
	__webpack_require__(504);
	module.exports = __webpack_require__(18);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	__webpack_require__(2);

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _defines = __webpack_require__(3);

	var _defines2 = _interopRequireDefault(_defines);

	var _annotationsPanel = __webpack_require__(4);

	var _annotationsPanel2 = _interopRequireDefault(_annotationsPanel);

	var _annotationsService = __webpack_require__(25);

	var _annotationsService2 = _interopRequireDefault(_annotationsService);

	var _colorPicker = __webpack_require__(34);

	var _colorPicker2 = _interopRequireDefault(_colorPicker);

	var _publicApi = __webpack_require__(18);

	var _publicApi2 = _interopRequireDefault(_publicApi);

	var _compatibility = __webpack_require__(6);

	__webpack_require__(27);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	// TODO: figure out a more elegant way to include this stuff


	_publicApi2.default.plugins.register({
	    name: 'us:color-picker',

	    extends: 'uScope',

	    canStart: function canStart() {
	        return !_compatibility.BrowserDetect.isIOS();
	    },


	    constructor: _colorPicker2.default
	});

	_publicApi2.default.plugins.register({
	    name: 'us:annotations:ui',

	    extends: 'uScope',

	    dependency: 'us:color-picker',

	    canStart: function canStart() {
	        return !_compatibility.BrowserDetect.isIOS();
	    },


	    constructor: function (_AnnotationsPanel) {
	        _inherits(AnnotationsComponent, _AnnotationsPanel);

	        function AnnotationsComponent(uScope, colorPicker) {
	            _classCallCheck(this, AnnotationsComponent);

	            // HACK ALERT - mutating uscope
	            var _this = _possibleConstructorReturn(this, (AnnotationsComponent.__proto__ || Object.getPrototypeOf(AnnotationsComponent)).call(this, uScope, colorPicker));

	            uScope.annotPanel = _this;

	            uScope.events.on('uscope:init', function () {
	                addAnnotationsButton();
	            });

	            var addAnnotationsButton = function addAnnotationsButton() {
	                var annotationsButton = $('<a/>', {
	                    'id': _defines2.default.TBANNOTPANEL,
	                    'class': _defines2.default.clsTBBUTTON + ' ' + _defines2.default.TBANNOTPANEL + '-e',
	                    'title': 'Open the annotation toolbox'
	                });

	                uScope.topToolbar.addButton(annotationsButton);
	            };
	            return _this;
	        }

	        return AnnotationsComponent;
	    }(_annotationsPanel2.default)
	});

	_publicApi2.default.plugins.register({
	    name: 'us:annotations:service',

	    extends: 'viewport',

	    // dependency: 'us:annotations:ui', TODO: <--

	    canStart: function canStart() {
	        return !_compatibility.BrowserDetect.isIOS();
	    },


	    constructor: function (_AnnotationsService) {
	        _inherits(AnnotationsComponent, _AnnotationsService);

	        function AnnotationsComponent(uScope, viewport) {
	            _classCallCheck(this, AnnotationsComponent);

	            // HACK ALERT - mutating the viewport
	            var _this2 = _possibleConstructorReturn(this, (AnnotationsComponent.__proto__ || Object.getPrototypeOf(AnnotationsComponent)).call(this, uScope, viewport));

	            viewport.annots = _this2;
	            return _this2;
	        }

	        return AnnotationsComponent;
	    }(_annotationsService2.default)
	});

/***/ },
/* 3 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/*
	 This file contains constants, enumerated types and ...
	 Some of these reflect AIL and therefore ImageServer specific coding.

	 Notes:
	 element class names: although the css explictly uses the values, use these constants in the code;
	 remember if you change the css value that you need to change these, and visa-versa
	 */

	var us = {};

	us.idROOT = 'uscope'; // the default viewer root node - note that this may be replaced by VIL settings
	us.idHashROOT = '#uscope'; // the default viewer root node with # prepended
	us.clsROOTSTYLE = 'us_rootstyle'; // additional class on the root div to bring in uScope styling

	// FB 23050: Some images, in some browsers (IE, FF occasionally) exhibit a "tearing" effect when rotation is applied.
	// Setting this flag will cause the renderer in viewportAP to offset the tiles 1px closer to their counterpart, closing
	// the gap. NOTE that this makes the images overlap by 1px. This could cause distortion, but we haven't been able to
	// discern it.
	// FB 23074: We found out how to discern the offset! Setting the below to true causes all tiles to be shifted, causing
	// annotations to be shifted up and to the left!
	us.EXPAND_TILE_SIZE = true;
	us.REQUEST_LARGER_TILES = false;

	us.clsPANEL = 'us_panel'; // class for all uscope panels
	us.clsPANELCLICKCLOSE = 'us_panelclickclose'; // class for all uscope panels that should be closed when the user clicks on the view
	us.clsTRANSPARENT = 'us_transparent'; // class for transparency

	us.idTOPTOOLBARV = 'us_toptoolbar_v'; // toolbar verical
	us.idIATOOLBAR = 'us_iatoolbar'; // toolbar for image analysis panels

	us.idMSGPANEL = 'us_msgPanel';
	us.idMSGPANELINPUT = 'us_msgPanelInput';

	us.clsIMAGETOOLBAR = 'us_clsimagetoolbar'; // image toolbar
	us.clsIMAGETOOLBARSTATE = 'us_clsimagetoolbarstate'; // image toolbar state indicator div
	us.clsIMAGETOOLBARBTN = 'us_clsimagetoolbarbtn'; // image toolbar button class
	us.clsIMAGETOOLBARSPC = 'us_clsimagetoolbarspc'; // image toolbar spacer vertical bar
	us.clsTBCLOSEIMAGE = 'us_tbcloseimage'; // image toolbar: close image button
	us.clsTBPINNED = 'us_tbpinned'; // image toolbar: pinned

	us.clsTBCONTROL = 'us_tbcontrol'; // image toolbar: control slide indicator
	us.clsTBPREVSLIDE = 'us_tbprevslide'; // image toolbar: previous slide
	us.clsTBNEXTSLIDE = 'us_tbnextslide'; // image toolbar: next slide

	us.clsTBBUTTON = 'us_tbbutton'; // toolbar button class
	us.idTBRESIZE = 'us_tbresize'; // toolbar resize button
	us.TBSETTINGS = 'us_tbsettings'; // toolbar settings/options button

	us.TBANNOTPANEL = 'us_tbannotpanel'; // toolbar annotation panel open icon

	us.TBRASTEROPEN = 'us_tbrasteropen'; // toolbar raster panel open icon

	us.idTBMULTIVIEW = 'us_tbmultiview'; // toolbar tiling options button
	us.TBISCOPE = 'us_tbimagescope'; // toolbar open-in-imagescope button
	us.TBSNAPSHOT = 'us_tbsnapshot'; // toolbar snapshot button
	us.TBANALYSIS = 'us_tbanalysis'; // toolbar analysis button

	us.clsRBBUTTON = 'us_rbbutton'; // region toolbar button class
	us.REGTBREDRAW = 'us_regtbredraw'; // context menu redraw
	us.REGTBCOPY = 'us_regtbcopy'; // context menu region copy
	us.REGTBMOVE = 'us_regtbmove'; // context menu regioncopy


	/* raster panels */
	us.idRASTERPANEL = 'us_idRASTERPANEL'; // raster panel container div
	us.idRPTEXT = 'us_idrptext'; //              text info
	us.idRPINSTR = 'us_idrpinstr';

	us.clsRPBUTTON = 'us_rpbutton'; // raster panel button class
	us.RPSETTINGS = 'us_rpsettings';
	us.RPSTART = 'us_rpstart';
	us.RPPAUSE = 'us_rppause';
	us.RPSLOW = 'us_rpslow';
	us.RPFAST = 'us_rpfast';
	us.RPBACKUP = 'us_rpbackup';
	us.RPRASTERBAR = 'us_rprasterbar';

	us.eSEQUENCESTYLES = { BYTISSUEPIECES: 0, ALLTISSUE: 1, WHOLESLIDE: 2 };
	us.strSEQUENCESTYLES = ['By Tissue Pieces', 'All Tissue', 'Whole Slide'];

	us.clsSEQUENCESTYLE = 'us_clsSEQUENCESTYLE'; // raster panel radio btns for seg style
	us.idRSSTYLEDIV = 'us_idRSSTYLEDIV';
	us.clsRSSTYLESEL = 'us_clsRSSTYLESEL';

	us.clsSELECTBOX = 'us_clsselectbox';
	us.idRASTERSETTINGS = 'us_idrastersettings'; // raster settings panel
	us.idRASTERMODE = 'us_idrastermode';
	us.idRASTERMAG = 'us_idrastermag';
	us.RPSETTINGSADV = 'us_rpsettingsadv';
	us.idRPSETTINGSDEF = 'us_idrpsettingsdef';

	us.idRASTERSETADV = 'us_idrastersetadv'; // raster advanced settings panel

	us.idRPPATTERN = 'us_idrppattern';
	us.idRPOVERLAP = 'us_idrpoverlap';
	us.idRPSENSITIVITY = 'us_idrpsensitivity'; //remove me?
	us.idRPTHRESHOLD = 'us_idrpthreshold';

	/* raster thumbnail */
	us.CVSRASTERIMAGE = 'cvsrasterimage';
	us.IMGRASTER = 'imgraster';

	/* image adjustment panel */
	us.idIMGADJPANEL = 'us_imgadjpanel';
	us.idBRIGHTSETTING = 'us_idbrightsetting';
	us.idCONTRASTSETTING = 'us_idcontrastsetting';
	us.BRIGHTICON = 'us_brighticon';
	us.CONTRASTICON = 'us_contrasticon';
	us.TBIMGADJOPEN = 'us_tbimgadjopen'; // toolbar annotation panel open icon

	/* annotation panel */
	us.clsAPBUTTON = 'us_apbutton'; // annot panel button class
	us.idANNOTPANEL = 'us_annotpanel'; // ann panel container div
	us.APANNOTARROW = 'us_apannotarrow'; // ann panel draw arrow
	us.APANNOTRECT = 'us_apannotrect'; // ann panel draw rectangle
	us.APANNOTPEN = 'us_apannotpen'; // ann panel draw pen
	us.APANNOTNEGPEN = 'us_apannotnegpen'; // ann panel draw negative pen
	us.APANNOTPIN = 'us_apannotpin'; // ann panel draw pin
	us.APANNOTPOLY = 'us_apannotpoly'; // ann panel draw ploygon

	us.APANNOTCALIPER = 'us_apannotcaliper'; // ann panel draw caliper
	us.APANNOTREPORT = 'us_apannotreport'; // ann panel report region button
	us.APANNOTELLIPSE = 'us_apannotellipse'; // ann panel draw ellipse
	us.APANNOTTEXT = 'us_apannottext'; // ann panel freetext tool
	us.APTRASH = 'us_apannottrash'; // ann panel trash can for annot delete
	us.APANNOTCOLOR = 'us_apannotcolor'; // ann panel color picker
	us.APNOTE = 'us_apnote'; // ann panel note


	us.idCLRPICKPANEL = 'us_clrpickpanel'; // color picker panel
	us.idCLRPICKDIV = 'us_clrpickdiv'; // container for color squares
	us.clsCLRPICKGRID = 'us_clrpickgrid'; // color picker panel
	us.idCLRPCKBAR = 'us_clrpickbar'; // color bar of selected color

	us.idANNAVDIV = 'us_anavdiv'; // container for annot nav elements
	us.clsANAVBUTTON = 'us_anavbutton'; // annotation nav button class
	////us.idANAVFIRST = 'us_anavfirst';             // icon for annot nav first region
	////us.idANAVLAST = 'us_anavlast';                 // icon for annot nav last region
	us.ANAVPREV = 'us_anavprev'; // annav panel icon for aprevious region
	us.idANAVCURRENT = 'us_anavcurrent'; // annav panel icon for current selection icon
	us.ANAVNEXT = 'us_anavnext'; // annav panel icon for next region
	us.clsBLANKBTN = 'us_blankbtn'; //

	us.clsANAVCURRENT = 'us_clsANAVCURRENT'; // annav panel icon for current selection icon


	us.idSOUNDDING = 'us_idsoundding'; // debug sound

	// context menu
	us.clsREGIONRAR = 'us_clsREGIONRAR';

	//-------------------------------------------------------------------------------------------------
	us.idSETTINGSTABS = 'us_settingstabs'; // settings/options tab
	us.idTABPREFERENCES = 'us_preferences'; // tab preferences

	us.idTABACTIONS = 'us_actions'; // tab for use actions
	us.idCREATELINK = 'us_createlink'; // icon for link / bookmark
	us.idLINKTEXTBOX = 'us_linktextbox';

	us.idTABREPORT = 'us_report'; // tab for report options
	us.idREPORTFIXEDDIV = 'us_idfixedreportdiv';
	us.idREPORTFIXEDWIDTH = 'us_idreportwidth';
	us.idREPORTFIXEDHEIGHT = 'us_idreportheight';
	us.clsREPORTTYPE = 'us_reporttype'; //

	us.idTABIMAGEINFO = 'us_imageinfo'; // tab image info
	us.idTABPERFORMANCE = 'us_performance'; // tab performance
	us.idTABABOUT = 'us_about'; // tab about
	us.idTABHOTKEYS = 'us_hotkeys'; // tab hotkeys
	us.idTABPERFTEST = 'us_perftest'; // tab performance test
	us.clsSETCHOICE = 'us_setchoice'; //
	us.clsSETBUTTON = 'us_setbutton'; // style of visibility buttons

	us.idHMCLEARBTN = 'us_idhmclearbtn'; // heat map clear btn
	us.clsVIZCHECKBOX = 'us_vizcheckbox'; // visibility checkboxes
	us.idVIZALLCHECKBOX = 'us_vizallcheckbox'; // visibility all checkbox
	us.idOPTIONSBTN = 'us_idoptionsbtn'; // options btn


	us.clsPREFBUTTON = 'us_prefbutton'; // style of preference buttons
	us.idPREFLABELROTBTN = 'us_prefsavelabelbtn'; //
	us.idPREFQUALITYSLIDER = 'us_qualitySlider'; //
	us.idCONSOLEBUTTON = 'us_consolebutton'; //
	us.idPREFDEFAULTBTN = 'us_prefdefaultbtn'; //
	us.idVISDEFAULTBTN = 'us_visdefaultbtn'; //
	us.idRPTDEFAULTBTN = 'us_rptdefaultbtn'; //

	us.idIMAGEINFODIV = 'us_imageinfodiv';
	us.idCOPYLINKBTN = 'us_copylinkbtn'; // button to copy image link
	us.idLINKIMAGE = 'us_imglink'; // link icon used on button

	us.idPTESTREPORTBTN = 'us_ptestreportbtn'; // performance testing
	us.idPTESTRUNBTN = 'us_ptestrunbtn'; // run
	us.clsPERFTESTOPTION = 'us_ptestoption'; // radio buttons
	us.clsPERFTESTINTERVAL = 'us_ptestinterval'; // radio buttons
	us.idPERFTESTINTERVAL = 'us_idptestinterval';
	us.idPTESTSHOWBTN = 'us_ptestshowbtn'; //

	us.idADVANCEDPANEL = 'us_advancedpanel'; // advanced options panel
	us.idADVCONSOLE = 'us_advconsole'; //

	us.clsADVBUTTON1 = 'us_advbutton1';
	us.clsADVBUTTON2 = 'us_advbutton2';

	us.idTEXTEDITPANEL = 'us_texteditpanel'; // text edit panel

	us.idDBGCONSOLE = 'us_debugconsole'; // debug console panel
	us.idDBGCONSOLELOG = 'us_debugconsolelog';
	us.idDBGSWITCHPANEL = 'us_dbgswitchpanel'; // debug switches panel

	//-------------------------------------------------------------------------------------------------

	us.clsOVERLAY = 'us_overlay'; // for elements place on top of viewport tiles and above graphics
	us.clsSUPEROVERLAY = 'us_superoverlay'; // for elements placed on top of overlay class elements

	us.clsPREPEND_ID = 'us_img_'; // prepended to image ID to use as a css class in viewport


	us.clsOUTERVIEWPORT = 'us_outerviewport'; // container div for the image viewport that holds overlays
	us.clsDotOUTERVIEWPORT = '.' + us.clsOUTERVIEWPORT;
	us.clsVIEWPORT = 'us_viewport'; // the image viewport class
	us.clsDotVIEWPORT = '.' + us.clsVIEWPORT;
	us.clsIMGTILE = 'us_tile'; // returned image tiles (in a viewport)

	us.clsDIVMARKUP = 'us_markup'; // the markup overlay
	us.clsTILEMARKUP = 'us_tilemarkup'; // image tiles belonging to a markup

	us.clsPROGDIV = 'us_progdiv'; // fake progressive rendering
	us.clsPROGIMG = 'us_progimg';

	us.CVSPROGIMAGE = 'cvsprogimage'; // true progressive rendering
	us.IMGPROG = 'imgprog';
	us.PROGVIEW = 'cvsprogview';

	us.clsEDGEDIV = 'us_edgediv'; // edge divs

	us.clsANNOTDIV = 'us_paper'; // container for Raphael graphics
	us.clsDotANNOTDIV = '.' + us.clsANNOTDIV;
	us.clsGRAPHICS = 'us_graphics';

	//-------------------------------------------------------------------------------------------------

	us.clsDIVTHUMBNAIL = 'us_thumbnail';
	us.clsIMGTHUMBNAIL = 'us_imgThumbnail';
	us.clsDIVVIEWFINDER = 'us_thumbviewfinder';
	us.clsDIVTHUMBHOVER = 'us_clsDIVTHUMBHOVER';
	us.idTHHOVERCHECKBOX = 'us_idTHHOVERCHECKBOX';

	us.CVSHEATMAP = 'us_cvsheatmap';

	us.clsDIVLABEL = 'us_label';
	us.clsIMGLABEL = 'us_imgLabel';

	us.ROTATE = 'us_rotate'; // prefix to rotation style

	us.clsDIVMARKER = 'us_marker';
	us.clsIMGMARKER = 'us_imgMarker';

	us.clsDIVZOOMSLIDER = 'us_zoomSlider';
	us.clsDIVZOOMCTL = 'us_zoomControl';
	us.clsDIVZOOMBTNS = 'us_zoomButtons';
	us.clsDIVZOOMBTN = 'us_zoomButton';

	us.clsDIVMAG = 'us_magnifier';
	us.clsDIVIMGWRAP = 'us_imgMagWrapper';
	us.clsIMGMAG = 'us_imgMag';
	us.clsIMGREGION = 'us_imgRegion'; // generic image region
	us.clsDIVMAGTAB = 'us_magTab';
	us.clsMAGXHAIR = 'us_clsMagXHair';

	us.clsDIVOUTERSCALEBAR = 'us_scalebarouter';
	us.clsDIVSCALEBAR = 'us_scaleBar';
	us.clsDIVSCALETEXT = 'us_scaleText';
	us.clsDIVSCALEMAG = 'us_scaleMag';
	us.clsSBROTKNOB = 'us_sbrotknob';
	us.clsSBROTKNOBANGLE = 'us_sbrotknobangle';

	us.clsROTATIONDIV = 'us_rotationDiv';
	us.clsROTATIONDIAL = 'us_rotationDial';
	us.clsROTATEPRESET = 'us_rotatePreset';

	us.clsDIVGUAGES = 'us_guagesdiv'; // tile meter
	us.clsDIVGUAGE = 'us_guagediv';
	us.clsGUAGETEXT = 'us_guagetext';
	us.clsGUAGETILES = 'us_guagetiles';
	us.clsGUAGECELL = 'us_guagecell';
	us.clsGUAGETILETEXT = 'us_guagetiletext';
	us.clsGUAGEVIEWTEXT = 'us_guageviewtext';

	us.clsGUAGEREF = 'us_guageref'; // view refresh meter

	us.clsAPANDIV = 'us_autoPanDiv'; // the auto pan indicator at the view center
	us.clsAPANCUR = 'us_autoPanCursor'; // the auto pan cursor

	//-------------------------------------------------------------------------------------------------

	// constants
	us.Rad2Deg = 180. / Math.PI;
	us.Deg2Rad = Math.PI / 180.;
	us.PI = 3.14159265359;
	us.PI_2 = us.PI / 2.;

	//-------------------------------------------------------------------------------------------------
	// use of these adds clarity to the code
	us.WITHFORCE = true;
	us.WITHOUTFORCE = false;

	us.FORCE_VIEWREFRESH = true;
	us.DONT_FORCE_VIEWREFRESH = true;

	us.DO_HIGHLIGHT = true;
	us.DONT_HIGHLIGHT = true;

	//-------------------------------------------------------------------------------------------------
	// capabilities
	us.supportsCanvas = false;
	us.renderEngine = 'aperio'; // choices: 'aperio', 'ol3'
	//-------------------------------------------------------------------------------------------------
	//    event definitions
	us.eEVENTWHICHBTN = { left: 1, middle: 2, right: 3 };

	//-------------------------------------------------------------------------------------------------
	// uScope custom events, triggers
	//--------------------------------------------------
	//    TO VIL        note: VIL watches for these events so take care if renaming
	//--------------------------------------------------
	us.evAJAXERROR = 'us_evAJAXERROR'; // parms: {imageId: @NUM, request: ImageServerRequest, jqXHR: jqXHR}
	us.evIMAGEREADY = 'us_evIMAGEREADY'; // parms: {imageId: @NUM, uScopeIdx: NUM, status: true/false}
	us.evIMAGECLOSE = 'us_evIMAGECLOSE'; // parms: {imageId: @NUM} toolbar button close event

	us.evIMAGENAVIGATED = 'us_evIMAGENAVIGATED'; // parms: {imageId: @NUM, status: 'read'}
	us.evANNOTCHANGE = 'us_evANNOTCHANGE'; // annotation has changed state; parms: {imageId: @NUM, regionId: NUM, layerId: NUM,
	//            anShape: "pen", "rect", "ellipse", "arrow", "ruler", "pin", "caliper", "text", or "report",
	//            action: 'add', 'sel', or 'del'}
	us.evRESIZECLICK = 'us_evRESIZECLICK'; // parms: {NONE}

	// note: VIL watches for these events so take care if renaming
	us.evIMAGESCOPEOPEN = 'us_evIMAGESCOPEOPEN'; // parms: {imageId: @NUM}
	us.evSNAPSHOT = 'us_evSNAPSHOT'; // parms: {imageId: @NUM, regionId: NUM,
	//      mode: "printViewport", or "reportRegion"}
	// "printViewport" - print the entire visible viewport including annotations
	// "reportRegion"  - launch settings.snapshot.URL to save the report region
	us.evOPENNEXTSLIDE = 'us_evOPENNEXTSLIDE'; // parms: {NONE}
	us.evOPENPREVSLIDE = 'us_evOPENPREVSLIDE'; // parms: {NONE}

	//--------------------------------------------------
	//    INTERNAL
	//--------------------------------------------------
	// user preference actions
	us.evUSERPREFSREADY = 'us_evUSERPREFSREADY';
	us.evUSERPREFSET = 'us_evUSERPREFSET'; // {className: STR, value: bool}
	us.evUSERPREFDEFAULTVISIBLE = 'us_evUSERPREFDEFAULTVISIBLE';
	us.evUSERPREFDEFAULTREPORT = 'us_evUSERPREFDEFAULTREPORT';
	us.evUSERPREFDEFAULTLABELROT = 'us_evUSERPREFDEFAULTLABELROT';
	us.evUSERPREFDEFAULTTHUMBHOVER = 'us_evUSERPREFDEFAULTTHUMBHOVER';

	// general purpose
	us.evIMAGEUPDATE = 'us_evIMAGEUPDATE'; // parms: { } // image added, removed, replaced
	us.evVIEWCHANGE = 'us_evVIEWCHANGE'; // parms: {imageId: @NUM, uScopeIdx: NUM, desc: STR, x: NUM, y: NUM, zoom: NUM, angleDeg: NUM }
	us.evZOOMCHANGE = 'us_evZOOMCHANGE'; // parms: {imageId: @NUM, uScopeIdx: NUM }
	us.evMOUSECHANGE = 'us_evMOUSECHANGE'; // parms: {imageId: @NUM, uScopeIdx: NUM, x: NUM, y: NUM }
	us.evIMAGESELECTED = 'us_evIMAGESELECTED'; // parms: {imageId: @NUM, uScopeIdx: NUM}
	us.evMODECHANGE = 'us_evMODECHANGE'; // parms: {navMode: NUM }

	us.evIMAGEROTATE = 'us_evIMAGEROTATE'; // parms: {imageId: @NUM, uScopeIdx: NUM, angleDeg: NUM },  imageId = "@0" or uScopeIdx = -1, all images rotated
	us.evNAVMODEHALT = 'us_evNAVMODEHALT'; // parms: {imageId: @NUM, uScopeIdx: NUM },  imageId = "@0" or uScopeIdx = -1, halt navigation of all images

	// events fired to request something to happen
	us.evREGIONSELECT = 'us_evREGIONSELECT'; // select a region by rfId, parms { imageId: @NUM, rfId: NUM, bReposition: true|false, bSaveSel: true|false }
	// when a region is selected, deleted, or added the event us.evANNOTCHANGE is fired - which could be in response to this event or a user action
	us.evLAYERSELECT = 'us_evLAYERSELECT'; // select a layer by layerId, parms {imageId: @NUM, LayerId: NUM}

	us.evVIEWRESIZE = 'us_evVIEWRESIZE'; // parms: {}
	us.evRENDERCOMPLETE = 'us_evRENDERCOMPLETE'; // parms: {imageId: @NUM}

	///////////////////////////////////////////////////////
	us.evGETMARKUPSTATE = 'us_evGETMARKUPSTATE'; // parms { imageId: @NUM }
	us.evGETMARKUPSTATE_RESP = 'us_evGETMARKUPSTATE_RESP'; // parms { imageId: @NUM, show: true|false, globalShow: true|false, imageHasMarkups: true|false }
	us.evMARKUPCHANGE = 'us_evMARKUPCHANGE'; // markup state change;  parms { imageId: @NUM, show: true|false }

	us.evREGIONDELETE = 'us_evREGIONDELETE'; // delete a region; parms { imageId: @NUM, regionId: NUM }
	///////////////////////////////////////////////////////

	// rasterscan events
	us.evSPACEBAR = 'us_evSPACEBAR';
	us.evRASTERPROGRESS = 'us_evRASTERPROGRESS';
	us.evHEATMAPCLEAR = 'us_evHEATMAPCLEAR';

	//--------------------------------------------------
	//    INTERNAL ANALYSIS RELATED
	//--------------------------------------------------
	us.evGETIALAYERLIST = 'us_evGETIALAYERLIST';
	us.evGETIALAYERLIST_RESP = 'us_evGETIALAYERLIST_RESP';

	us.evGETLAYERREGIONS = 'us_evGETLAYERREGIONS';
	us.evGETLAYERREGIONS_RESP = 'us_evGETLAYERREGIONS_RESP';

	us.evADDANALYSISLAYERS = 'us_evADDANALYSISLAYERS';
	us.evADDANALYSISLAYERS_RESP = 'us_evADDANALYSISLAYERS_RESP';

	us.evRUNANALYSIS = 'us_evRUNANALYSIS';
	us.evRUNANALYSIS_RESP = 'us_evRUNANALYSIS_RESP';

	us.evCANCELANALYSIS = 'us_evCANCELANALYSIS';

	us.evGETIAMACROS = 'us_evGETIAMACROS';
	us.evGETIAMACROS_RESP = 'us_evGETIAMACROS_RESP';
	//-------------------------------------------------------------------------------------------------
	// uScope constants
	us.TOUCHEVENT = true; // flags for mouse/touch handlers
	us.NOTTOUCHEVENT = false;

	us.kDEF_TILE_POS = -4000; // constant default left,top tile position
	us.kDEF_TILE_POS_PX = us.kDEF_TILE_POS + 'px';

	us.kSTANDARDVIEW = 1920 * 1200; // a typical monitor resolution
	//-------------------------------------------------------------------------------------------------

	// enums kept in sync with AIL, cViewport,  DataServer
	us.eAICCaptureType = { // image capture type
	    aic_i_BF: 0, // Bright Field
	    aic_i_FL: 1, // FLuorescence
	    aic_i_MIX: 2 // BF and FL (fusion)
	};
	us.captureNames = ['BrightField', 'Fluorescence', 'Fused'];

	//-------------------------------------------------------------------------------------------------
	// ANNOTATIONS
	//-------------------------------------------------------------------------------------------------
	// note: do not change the type order as ImageScope/Viewport depend upon it
	//        and do not change these strings as pin drop navigation depend upon them (at least 'pin')
	// note that the ruler creation is replaced by the caliper in this viewer
	//        but is drawn if present in annotations from an older view

	us.eAnTypes = {
	    pen: 0, rect: 1, ellipse: 2, arrow: 3, ruler: 4, // these annotation types are used as indexes into us.anShapes
	    pin: 5, caliper: 6, text: 7, report: 8,
	    polygon: 9, negpen: 10
	};

	us.anShapes = ['pen', 'rect', 'ellipse', 'arrow', 'ruler', 'pin', 'caliper', 'text', 'report', // and from here on new annotation types
	'polygon', 'negpen'];
	us.eAnAnalysis = [1, 1, 0, 0, 0, // index to anTypes that can be analyzed - IMPORTANT TO KEEP IN ORDER WITH eAnTypes!
	0, 0, 0, 0, 1, 0, 0];
	us.kREGIONTYPES = 11; // number of region types

	us.anLayerTypesSupported = {}; // annotation layer types supported
	us.anLayerTypes = {
	    aafinput: 1,
	    aafinal: 2,
	    aafresult: 3,
	    manual: 4, // user drawn
	    zstack: 5,
	    cwsregion: 6,
	    track: 7,
	    report: 8 // report layer for report region
	};

	// interpretation of status returned from ALGORITHMRUN   //todo: move to appropriate local
	us.algoRunStatus = { 'error': -1, 'queued': 0, 'active': 1, 'completed': 2, 'canceled': 3 };
	us.algoRunStatusStr = ['queued', 'active', 'completed', 'canceled'];
	us.algoRunStatusStr[-1] = 'error';

	us.AnnotLayerName = 'Annotation'; // the A-layer, the name of the layer to hold regions with colors other than that of the layer
	us.AnnotLayerRGB = '#0000FF'; // default RGB ordered color for A-layer (layer named "Annotation")
	us.ReportLayerName = 'Report Image'; // the R-layer, the name of the layer to hold the one and only report region
	us.ReportLayerRGB = '#FF0000'; // default RGB ordered color for R-layer (layer named "Report Image")


	us.colorPalette = [// hex RGB ordered formatted and configured for colorPicker
	'#ffaaaa', '#ffd4aa', '#ffffaa', '#d4ffaa', '#aaffaa', '#aaffd4', '#aaffff', '#aad4ff', '#aaaaff', '#d4aaff', '#ffaaff', '#ffaad4', '#ffffff', '#ff5656', '#ffaa56', '#ffff56', '#aaff56', '#56ff56', '#56ffaa', '#56ffff', '#56aaff', '#5656ff', '#aa56ff', '#ff56ff', '#ff007f', '#cfcfcf', '#ff0000', '#ff7f00', '#ffff00', '#7fff00', '#00ff00', '#00ff7f', '#00ffff', '#007fff', '#0000ff', '#7f00ff', '#ff00ff', '#ff007f', '#8f8f8f', '#bf0000', '#bf5f00', '#bfbf00', '#5fbf00', '#00bf00', '#00bf5f', '#00bfbf', '#005fbf', '#0000bf', '#5f00bf', '#bf00bf', '#bf005f', '#4f4f4f', '#7f0000', '#7f3f00', '#7f7f00', '#3f7f00', '#007f00', '#007f3f', '#007f7f', '#003f7f', '#00007f', '#3f007f', '#7f007f', '#7f003f', '#000000'];

	// report region settings
	us.eReportTypes = {
	    FullRes_FixedDim: 0, // Full Resolution Image, Fixed Sized Report Region
	    FullRes_UserDrawn: 1, // Full Resolution Image, User Drawn Report Region
	    CurRes_FixedDim: 2, // Current Image Resolution, Fixed Sized Report Region
	    CurRes_UserDrawn: 3 // Current Image Resolution,User Drawn Report Region
	};

	us.eReportSpec = {
	    defReportType: 0, // default report types {eReportTypes}
	    defWidthPx: 160, // default report width
	    defHeightPx: 120, // default report height

	    minDimPx: 50, // min and max width,height dims
	    maxDimPx: 1600
	};

	//-------------------------------------------------------------------------------------------------
	// COORDINATE SYSTEM DEFINITION
	//-------------------------------------------------------------------------------------------------
	// Note that this is a cheap means to differentiate
	//        "normal" graphics coordinate system
	//            ( with the origin at the top left, x-positive right, y-positive down)
	//        from the open layers 3 coordinate system
	//            ( with the origin at the top left, x-positive right, y-negative down)

	us.coordSystemNORM = { x: 1, y: 1 };
	us.coordSystemOL = { x: 1, y: -1 }; // xform to/from OL to Norm

	//-------------------------------------------------------------------------------------------------
	// NAVIGATION - for viewport and thumbnail event handlers
	//-------------------------------------------------------------------------------------------------

	us.eNavModes = { // navigation modes -really related to interpretation of the mouse actions
	    nmNone: 0, // default
	    // image nav modes
	    nmDragImage: 1,
	    nmThumbDragImage: 2,
	    nmZoom: 3,
	    nmDClickZoom: 4,
	    nmPinchZoom: 5,
	    nmSmoothZoom: 6,
	    // annotation "nav" modes
	    nmAnnotPin: 7,
	    nmAnnotArrow: 8,
	    nmAnnotRect: 9,
	    nmAnnotEllipse: 10,
	    nmAnnotPen: 11,
	    nmAnnotCaliper: 12,
	    nmAnnotText: 13,
	    nmAnnotReport: 14,
	    nmAnnotPolygon: 15,
	    nmAnnotNegPen: 16,

	    nmRedrawStarting: 17, // region redraw
	    nmRedraw: 18,

	    nmAutoPan: 19,
	    nmRasterScan: 20,

	    nmRotatingOverlay: 21, // only scalebar rotation so far

	    nmNOMORE: 22
	};

	//-------------------------------------------------------------------------------------------------
	// multiple image settings
	us.multiSpecs = {
	    maxImages: 4 // maximum number of images (views)
	};
	//-------------------------------------------------------------------------------------------------
	//    layout settings for overlay visuals (elements that are above the viewport)
	// These settings apply for all open images.

	us.kOVERLAY_ELEMENT_SPACE = 2; // space in pixels from the viewport boundary and between adjacent elements

	//-------------------------------------------------------------------------------------------------
	// annotation elements
	us.pinSpecs = {
	    'coords': [14.676, -30.3985, 14.642, -31.3935, 14.542, -32.3875, 14.373, -33.3725, 14.138, -34.3445, 13.839, -35.2905, 13.47, -36.2275, 13.04, -37.1325, 12.551, -38.0025, 12.007, -38.8335, 11.395, -39.6425, 10.744, -40.3895, 10.038, -41.0985, 9.285, -41.7585, 8.496, -42.3605, 7.658, -42.9145, 6.78, -43.4115, 5.877, -43.8435, 4.962, -44.2075, 3.996, -44.5165, 3.025, -44.7555, 2.053, -44.9255, 1.059, -45.0295, 0.047, -45.0675, -0.943, -45.0375, -1.938, -44.9405, -2.924, -44.7765, -3.898, -44.5445, -4.856, -44.2455, -5.785, -43.8835, -6.682, -43.4625, -7.554, -42.9775, -8.406, -42.4235, -9.199, -41.8275, -9.957, -41.1735, -10.669, -40.4695, -11.325, -39.7275, -11.943, -38.9235, -12.494, -38.0965, -12.989, -37.2315, -13.425, -36.3305, -13.801, -35.3965, -14.107, -34.4535, -14.35, -33.4845, -14.527, -32.4905, -14.635, -31.4985, -14.676, -30.5115, -14.649, -29.5025, -14.556, -28.5035, -14.396, -27.5255, -14.168, -26.5525, -13.871, -25.5895, -13.512, -24.6565, -13.091, -23.7545, -12.604, -22.8735, -12.069, -22.0435, -11.47, -21.2405, -10.819, -20.4815, -10.119, -19.7675, -9.372, -19.1035, -8.58, -18.4895, -7.746, -17.9305, -6.874, -17.4285, -5.981, -16.9915, -5.208, -16.4705, -4.909, -15.5245, -4.609, -14.5735, -4.307, -13.6175, -4.006, -12.6635, -3.704, -11.7085, -3.399, -10.7445, -3.101, -9.8005, -2.798, -8.8425, -2.496, -7.8865, -2.195, -6.9325, -1.893, -5.9745, -1.597, -5.0385, -1.292, -4.0735, -0.994, -3.1295, -0.688, -2.1615, -0.39, -1.2165, -0.091, -0.2705, 0.211, -0.6505, 0.512, -1.6015, 0.818, -2.5715, 1.119, -3.5235, 1.417, -4.4665, 1.718, -5.4165, 2.02, -6.3745, 2.322, -7.3285, 2.624, -8.2825, 2.925, -9.2365, 3.226, -10.1875, 3.53, -11.1505, 3.832, -12.1045, 4.132, -13.0535, 4.43, -13.9985, 4.734, -14.9595, 5.033, -15.9055, 5.444, -16.7625, 6.356, -17.1645, 7.249, -17.6325, 8.105, -18.1595, 8.907, -18.7315, 9.681, -19.3665, 10.409, -20.0515, 11.09, -20.7835, 11.72, -21.5615, 12.296, -22.3815, 12.817, -23.2415, 13.272, -24.1225, 13.668, -25.0375, 14.002, -25.9835, 14.272, -26.9585, 14.469, -27.9235, 14.602, -28.9115],
	    'width': 29.352, 'height': 44.797
	};
	us.arrowSpecs = { 'length': 80, 'tagLength': 35 };

	//-------------------------------------------------------------------------------------------------
	//
	//    image view settings
	us.kOVERTILES = 0; // number of tiles to overflow viewport boundaries //todo: probably should remove now
	us.kFRAMETILES = 1; // width in tiles of frame about the viewport boundaries
	us.kTILEMULTIPLIER = 2; // multiplier on image tile dims

	us.labelSpecs = { // label settings
	    'width': 100
	};
	us.zoomSpecs = { // zoom control settings
	    'sliderMin': 0, // zoom slider min/max values
	    'sliderMax': 200,
	    'stepFactor': 0.2,

	    'fitZoomMax': 200 // the maximum zoom that "Fit" is permitted
	};

	// debug console specs
	us.consoleSpecs = {
	    'msg': [],
	    'msgCnt': 0,
	    'msgMax': 500
	};
	//-------------------------------------------------------------------------------------------------
	//    annotation settings
	us.annotSpecs = {
	    minAnnotDim: 20, // minimum dimension of an annotation in pixels
	    minPenPointDist: 3, // minimum distance between saved pen points

	    fontSize: 14,
	    strokeWidthTextBorder: 2,
	    strokeWidthPin: 2,
	    strokeWidth: 3,
	    strokeWidthSel: 5,
	    strokeWidthHiLight: 2,
	    strokeWidthCopyMove: 4,

	    fillOpacity: '0.2',

	    textBBoxPad: 4,
	    textBBoxRadius: 8
	};

	//    text edit settings
	us.textEditSpecs = {
	    'width': 300, // width, height in pixels of text entry panel
	    'height': 200,
	    'maxChars': 275, // limit imposed by dataserver is 1023; DS fails if send it more!
	    'noteWidth': 44 // width in pixels of hover note
	};

	us.reDrawSpecs = { // region redraw tolerances
	    'thinTolerance': 10,
	    'startTolerance': 100,
	    'skipTolerance': 10,
	    'removeTolerance': 50
	};

	//-------------------------------------------------------------------------------------------------
	//    analysis related

	// Note that ImageServer has a limitation on the dimensions of its returned JPEG compressed image
	// (currently clipping each dimension to 2000 pixels).
	us.IMAGESERVER_MAXJDIM = 2000; // hardcoded ImageServer limitation on dims of JPEG

	us.markupQuality = 70;
	// types defined by cAAFParameterTypes in  AAFTypes.h
	us.AAFParameterType = ['eInteger', 'eDouble', 'eString', 'eBool', 'eList', 'eMultiSelList', 'eDynamicList'];
	us.AAFParameterTypeNames = { eInteger: 0, eDouble: 1, eString: 2, eBool: 3, eList: 4, eMultiSelList: 5, eDynamicList: 6 };

	exports.default = us;
	module.exports = exports['default'];

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = AnnotationsPanel;

	var _defines = __webpack_require__(3);

	var _defines2 = _interopRequireDefault(_defines);

	var _toolbar = __webpack_require__(5);

	var _helpers = __webpack_require__(8);

	var _annotationsService = __webpack_require__(25);

	var _compatibility = __webpack_require__(6);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function AnnotationsPanel(uScope, colorPicker) {
	    var self = this;
	    var jPanel;
	    var namespace = '.annotpanel'; // namespace for attached events (note that some events are attached to body element of page)

	    //............................................ enableDrawingIcons() public
	    //    enableDrawingIcons - This function [en|dis]ables all annotation drawing tools
	    //        and region specific tools of the annotation panel.
	    this.enableDrawingIcons = function (bEnable) {
	        var state = bEnable ? 'enabled' : 'disabled';
	        (0, _toolbar.setIconState)($('.' + _defines2.default.APANNOTPOLY), _defines2.default.APANNOTPOLY, state);
	        (0, _toolbar.setIconState)($('.' + _defines2.default.APANNOTPIN), _defines2.default.APANNOTPIN, state);
	        (0, _toolbar.setIconState)($('.' + _defines2.default.APANNOTNEGPEN), _defines2.default.APANNOTNEGPEN, state);
	        (0, _toolbar.setIconState)($('.' + _defines2.default.APANNOTPEN), _defines2.default.APANNOTPEN, state);
	        (0, _toolbar.setIconState)($('.' + _defines2.default.APANNOTRECT), _defines2.default.APANNOTRECT, state);

	        (0, _toolbar.setIconState)($('.' + _defines2.default.APANNOTARROW), _defines2.default.APANNOTARROW, state);
	        (0, _toolbar.setIconState)($('.' + _defines2.default.APANNOTCALIPER), _defines2.default.APANNOTCALIPER, state);
	        (0, _toolbar.setIconState)($('.' + _defines2.default.APANNOTREPORT), _defines2.default.APANNOTREPORT, state);
	        (0, _toolbar.setIconState)($('.' + _defines2.default.APANNOTELLIPSE), _defines2.default.APANNOTELLIPSE, state);
	        (0, _toolbar.setIconState)($('.' + _defines2.default.APANNOTTEXT), _defines2.default.APANNOTTEXT, state);

	        self.enableRegionIcons();
	        if (_defines2.default.DBGANNOTEX) (0, _toolbar.consoleWrite)('enableDrawingIcons: -' + state);
	    };

	    //............................................ setColorPickerState_() public
	    var setColorPickerState_ = function setColorPickerState_(anObj, state) {
	        if ((0, _helpers.isDefined)(anObj)) {
	            var layerId = anObj.getSelLayerId(); // double check for R12.0: allow color picking on A-layer and R-layer only
	            var canBeEnabled = anObj.layerIsNamed(layerId, _defines2.default.AnnotLayerName) || anObj.layerIsNamed(layerId, _defines2.default.ReportLayerName);
	            if (!canBeEnabled) state = 'disabled';
	        }
	        (0, _toolbar.setIconState)($('.' + _defines2.default.APANNOTCOLOR), _defines2.default.APANNOTCOLOR, state);
	    };
	    //............................................ enableRegionIcons() public
	    //    enableRegionIcons - This function [en|dis]ables all region specific icons of the annotation panel
	    //                        including the annotation navigation panel.
	    //                        Note that the passed annotation object may not be defined (no image open)
	    //                        and that this function must still set the icon states properly.
	    this.enableRegionIcons = function (anObj) {
	        if ((0, _helpers.isUnDefined)(anObj) && uScope.isThisImageValid()) anObj = uScope.getThisImage().getAnnotObj();
	        var state = 'disabled'; //
	        var jIconButton;
	        var region;

	        if ((0, _helpers.isDefined)(anObj)) {
	            // if there's an image with an annotation object
	            region = anObj.getSelRegion();
	            state = region ? 'enabled' : 'disabled'; // state is enabled if there is a region selected (vs no regions existing)
	            var buttonClass = _defines2.default.getAnTypeButtonClass(region); // get the button class of the selected annotation type
	            if (buttonClass) jIconButton = $('.' + buttonClass); // and then jq object of the icon button itself
	        }
	        //............................................  annotation navigation icons
	        (0, _toolbar.setIconState)($('#' + _defines2.default.ANAVPREV), _defines2.default.ANAVPREV, state);
	        (0, _toolbar.setIconState)($('#' + _defines2.default.ANAVNEXT), _defines2.default.ANAVNEXT, state);

	        if (jIconButton) {
	            // show the icon for this annotation type
	            var url = jIconButton.css('background-image'); // e.g. =  url("http://localhost../images/PinDrop-24.png")
	            var backColor = (0, _helpers.isDefined)(anObj) ? '#' + (0, _helpers.toHexColor)(anObj.getSelColor()) : '#FFFFFF'; // set the current tool icon background color to that of the selected icon

	            $('.' + _defines2.default.clsANAVCURRENT).css({
	                'background-image': url,
	                'width': jIconButton.width(),
	                'height': jIconButton.height(),
	                'visibility': 'visible'
	            }).show();
	            $('.' + _defines2.default.clsANAVCURRENT).css({ 'background-color': backColor });

	            if (region) {
	                var text = ''; // useful feedback to indicate region is an Analysis or Input region
	                if (region.get('isAnalyzed') == true) text = 'A';
	                //debug-only watch out may be out of date var rtnArray = anObj.layers.findByProperty('InputAnnotationId', region.get('layerId')); // is this an input/parent layer?
	                //debug-only if (rtnArray.length) text = 'I';
	                $('.' + _defines2.default.clsANAVCURRENT).text(text).css({ 'color': (0, _helpers.isLightColor)(backColor) ? 0 : 16777215 });
	            }
	        } else {
	            $('#' + _defines2.default.idANAVCURRENT).css('visibility', 'hidden'); // or hide the icon
	        }
	        if (_defines2.default.DBGANNOTEX) (0, _toolbar.consoleWrite)('enableRegionNavigation: -' + state);

	        //............................................  region icons: trash, colorpicker, note
	        state = uScope.canAnnotate() == false ? 'disabled' : state;
	        (0, _toolbar.setIconState)($('.' + _defines2.default.APTRASH), _defines2.default.APTRASH, state);
	        (0, _toolbar.setIconState)($('.' + _defines2.default.APNOTE), _defines2.default.APNOTE, state);
	        setColorPickerState_(anObj, state);

	        if (_defines2.default.DBGANNOTEX) (0, _toolbar.consoleWrite)('enableRegionIcons: -' + state);
	    };

	    //............................................ position() public
	    //    position - This function positions the annotations panel below the label or, if there is
	    //                        no label, in the position that the label would have been placed.
	    //        Note that it assume the label has room below it... instead cOverLayout should be updated to handle this.
	    this.position = function () {
	        var thisImg = uScope.getThisImage();
	        // if (curiously) opened w/o an image or that image has no label
	        if (uScope.isThisImageValid() == false || thisImg.hasALabel() == false || _defines2.default.ENABLELABEL == false) {
	            var rootPos = $(_defines2.default.idHashROOT).offset();
	            var panelPos = [rootPos.left, Math.floor(rootPos.top + $(_defines2.default.idHashROOT).height() / 3)];
	        } else {
	            var jVpDiv = thisImg.vpDivGet('outer'); // place it relative to the label
	            var offsetPos = jVpDiv.find('.' + _defines2.default.clsDIVLABEL).offset();
	            if (offsetPos == null || offsetPos == undefined) offsetPos = { 'left': 0, 'top': 0 };
	            var panelPos = [offsetPos.left, Math.floor(offsetPos.top + _defines2.default.labelSpecs.width + 2 * _defines2.default.kOVERLAY_ELEMENT_SPACE)];
	        }
	        jPanel.dialog({ left: panelPos[0], top: panelPos[1] });
	    };

	    //............................................ activateDrawIcon_() local
	    //    activateDrawIcon_ - This function sets the specified drawing icon to the active state
	    //        and all all other drawing icons to the enabled state.
	    var activateDrawIcon_ = function activateDrawIcon_(jContainer, classRoot) {
	        self.enableDrawingIcons(true);
	        (0, _toolbar.setIconState)(jContainer, classRoot, 'active');
	    };
	    //............................................ show() public
	    this.show = function (show) {
	        if (show == true) {
	            jPanel.dialog('open');
	            uScope.annotPanel.enableDrawingIcons(uScope.canAnnotate());
	        } else {
	            jPanel.dialog('close');
	        }
	    };
	    //............................................ onColorSelect() local
	    // onColorSelect - This function is called by the color picker when a color is selected.
	    var onColorSelect = function onColorSelect(clr) {
	        var iarRefs = uScope.getImageAnnotRegionRefs();
	        // The color picker in toolbar.js triggers a setColor click event when it's created. This is bound to $.ready(), and
	        // iarRefs.anObj isn't defined until the imageOpen event is called in viewportAP, which doesn't happen until after
	        // xInfo is received, so we have a little race condition going on.
	        if (iarRefs.anObj) {
	            iarRefs.anObj.setSelColor(clr);
	            self.enableRegionIcons(iarRefs.anObj); // update the color on the annot nav pan
	        }
	    };
	    //............................................ unBindEvents_() local
	    // unBindEvents_ - This function releases the namespaced annotation panel event handlers
	    var unBindEvents_ = function unBindEvents_() {
	        $(_defines2.default.idHashROOT).off(namespace);
	        $('body').off(namespace); // note - these events may linger even after uScope is removed
	    };

	    //............................................ bindEvents_() local
	    // bindEvents_ - This function adds the annotation colorpicker panel event handlers.
	    //
	    //    Note that an exception is made here and the namespace is not an image's namespace.

	    var bindEvents_ = function bindEvents_() {
	        var jRoot = $(_defines2.default.idHashROOT); // cache jQuery element of uScope root div

	        // these events are attached to the uScope root div
	        jRoot.on('click' + namespace, '.' + _defines2.default.TBANNOTPANEL + '-e', function () {
	            self.show(true);
	            (0, _toolbar.setIconState)($('#' + _defines2.default.TBANNOTPANEL), _defines2.default.TBANNOTPANEL, 'active');
	            return false;
	        });
	        jRoot.on('click' + namespace, '.' + _defines2.default.TBANNOTPANEL + '-a', function () {
	            self.show(false);
	            (0, _toolbar.setIconState)($('#' + _defines2.default.TBANNOTPANEL), _defines2.default.TBANNOTPANEL, 'enabled');
	            return false;
	        });
	        jRoot.on(_defines2.default.evIMAGESELECTED + namespace, function (e, parms) {
	            self.enableDrawingIcons(uScope.canAnnotate()); // change the drawing icon state as a function of the selected image
	        });
	        onClickAPanelNav_(jRoot);

	        // These handlers are attached to the page body so that other panels can duplicate the icons and leverage the event response
	        // however, we must then be careful to detach these handlers when removing this panel or uScope

	        var jBody = $('body');
	        onClickAnnotation_(jBody);
	        onClickTrashCan_(jBody);
	        onClickColorPicker_(jBody);
	        onClickNote_(jBody);

	        //..................................................
	        // closure functions
	        //..................................................  onClickAnnotation_
	        function onClickAnnotation_(jElement) {
	            // deselecting active drawing tool
	            jElement.on('click', '.' + _defines2.default.APANNOTPIN + '-a' + ',.' + _defines2.default.APANNOTPEN + '-a' + ',.' + _defines2.default.APANNOTNEGPEN + '-a' + ',.' + _defines2.default.APANNOTPOLY + '-a' + ',.' + _defines2.default.APANNOTRECT + '-a' + ',.' + _defines2.default.APANNOTARROW + '-a' + ',.' + _defines2.default.APANNOTCALIPER + '-a' + ',.' + _defines2.default.APANNOTREPORT + '-a' + ',.' + _defines2.default.APANNOTELLIPSE + '-a' + ',.' + _defines2.default.APANNOTTEXT + '-a', function (e) {
	                if (uScope.isThisImageValid()) {
	                    var thisImg = uScope.getThisImage();
	                    _defines2.default.navModeSwitch(thisImg, _defines2.default.eNavModes.nmNone);
	                    thisImg.vpDivGet().css('cursor', 'auto');
	                    (0, _toolbar.setIconState)($(e.currentTarget), (0, _helpers.getClassList)(e.currentTarget)[0], 'enabled');
	                }
	            });
	            // selecting enabled drawing tool
	            jElement.on('click' + namespace, '.' + _defines2.default.APANNOTPIN + '-e' + ',.' + _defines2.default.APANNOTPEN + '-e' + ',.' + _defines2.default.APANNOTNEGPEN + '-e' + ',.' + _defines2.default.APANNOTPOLY + '-e' + ',.' + _defines2.default.APANNOTRECT + '-e' + ',.' + _defines2.default.APANNOTARROW + '-e' + ',.' + _defines2.default.APANNOTCALIPER + '-e' + ',.' + _defines2.default.APANNOTREPORT + '-e' + ',.' + _defines2.default.APANNOTELLIPSE + '-e' + ',.' + _defines2.default.APANNOTTEXT + '-e', function (e) {
	                if (uScope.isThisImageValid()) {
	                    var navModeIdx = e.currentTarget.getAttribute('navmode');
	                    if (navModeIdx) {
	                        var navMode = _defines2.default.eNavModes[navModeIdx];
	                        var thisImg = uScope.getThisImage();
	                        _defines2.default.navModeSwitch(thisImg, +navMode);
	                        activateDrawIcon_($(e.currentTarget), (0, _helpers.getClassList)(e.currentTarget)[0]); // 1st class in list is base class name, change to draw icon image
	                    }
	                }
	                return false;
	            });
	        }
	        //..................................................  onClickTrashCan_
	        function onClickTrashCan_(jElement) {
	            jElement.on('click' + namespace, '.' + _defines2.default.APTRASH + '-e', function (e) {
	                if (uScope.isThisImageValid()) {
	                    var thisImg = uScope.getThisImage();
	                    thisImg.annots.regSelectDelete();
	                }
	                return false;
	            });
	        }
	        //..................................................  onClickColorPicker_
	        function onClickColorPicker_(jElement) {
	            jElement.on('click' + namespace, '.' + _defines2.default.APANNOTCOLOR + '-e', function (e) {
	                (0, _toolbar.setIconState)($('.' + _defines2.default.APANNOTCOLOR), _defines2.default.APANNOTCOLOR, 'active');
	                if (uScope.isThisImageValid()) {
	                    var thisImg = uScope.getThisImage();
	                    if (thisImg.getAnnotObj()) {
	                        var clr = thisImg.getAnnotObj().getSelColor(); // get color of currently selected region
	                        colorPicker.show(true, clr);
	                    }
	                }
	                return false;
	            });
	        }
	        //..................................................  onClickNote_
	        function onClickNote_(jElement) {
	            jElement.on('click' + namespace, '.' + _defines2.default.APNOTE + '-e', function (e) {
	                (0, _toolbar.setIconState)($('.' + _defines2.default.APNOTE), _defines2.default.APNOTE, 'active');
	                if (uScope.isThisImageValid()) {
	                    var thisImg = uScope.getThisImage();

	                    if (thisImg.getAnnotObj()) {
	                        var region = thisImg.getAnnotObj().getSelRegion();
	                        if (region === undefined) return; // sanity check

	                        if (region.shape === 'text') (0, _toolbar.openTextEditPanel)('Update on image text', region.note, _annotationsService.cb_addOnImageText);else if (region.isReportRegion) (0, _toolbar.openTextEditPanel)('Modify report region text', region.note, _annotationsService.cb_addOnImageText);else (0, _toolbar.openTextEditPanel)('Add note for this region', region.note, _annotationsService.cb_regAddNote);
	                    }
	                }
	                return false;
	            });
	        }
	        //..................................................  onClickAPanelNav_
	        function onClickAPanelNav_(jElement) {
	            jElement.on('click' + namespace, '#' + _defines2.default.ANAVPREV + ',#' + _defines2.default.idANAVCURRENT + ',#' + _defines2.default.ANAVNEXT, function (e) {
	                var nextPrev = 'previous';
	                if (e.currentTarget.id == _defines2.default.idANAVCURRENT) nextPrev = 'current';else if (e.currentTarget.id == _defines2.default.ANAVNEXT) nextPrev = 'next';
	                if (uScope.isThisImageValid()) {
	                    var thisImg = uScope.getThisImage();
	                    thisImg.getAnnotObj().regSelectNextPrev(nextPrev);
	                }
	                return false;
	            });
	        }
	    };
	    //............................................ construct_() local
	    //    construct_ - This function creates and intializes the annotations panel
	    var construct_ = function construct_() {
	        jPanel = $('<div id=' + _defines2.default.idANNOTPANEL + ' class=' + _defines2.default.clsPANEL + ' title="Annotations"></div>');
	        // annotation region tools section
	        // note that the click handler requires that the base class (w/o the "-e" or "-d" etc) is the first class listed
	        jPanel.append($('<a/>', {
	            'class': _defines2.default.APANNOTRECT + ' ' + _defines2.default.APANNOTRECT + '-e ' + _defines2.default.clsAPBUTTON,
	            'navmode': 'nmAnnotRect',
	            'title': 'Add a rectangular annotation'
	        }));
	        jPanel.append($('<a/>', {
	            'class': _defines2.default.APANNOTPOLY + ' ' + _defines2.default.APANNOTPOLY + '-e ' + _defines2.default.clsAPBUTTON,
	            'navmode': 'nmAnnotPolygon',
	            'title': 'Add a polygon annotation:\r   click set points\r   double-click to finish'
	        }));

	        // 5/12/15 - negative freeform annotation removed for 12.3  FB 20591
	        //jPanel.append($("<a/>", { "class": us.APANNOTNEGPEN + " " + us.APANNOTNEGPEN + "-e "+ us.clsAPBUTTON, "navmode":
	        jPanel.append($('<a/>', {
	            'class': _defines2.default.APANNOTPEN + ' ' + _defines2.default.APANNOTPEN + '-e ' + _defines2.default.clsAPBUTTON,
	            'navmode': 'nmAnnotPen',
	            'title': 'Add a freeform annotation'
	        }));
	        jPanel.append($('<a/>', {
	            'class': _defines2.default.APANNOTPIN + ' ' + _defines2.default.APANNOTPIN + '-e ' + _defines2.default.clsAPBUTTON,
	            'navmode': 'nmAnnotPin',
	            'title': 'Add a pin annotation'
	        }));
	        jPanel.append('<div class=\'tooldivider tooldivider0\'></div>'); // invisible horizontal line - keeps row of icons from shifting

	        jPanel.append($('<a/>', {
	            'class': _defines2.default.APANNOTARROW + ' ' + _defines2.default.APANNOTARROW + '-e ' + _defines2.default.clsAPBUTTON,
	            'navmode': 'nmAnnotArrow',
	            'title': 'Add an arrow annotation'
	        }));
	        jPanel.append($('<a/>', {
	            'class': _defines2.default.APANNOTCALIPER + ' ' + _defines2.default.APANNOTCALIPER + '-e ' + _defines2.default.clsAPBUTTON,
	            'navmode': 'nmAnnotCaliper',
	            'title': 'Add a measurement annotation:\r   click set points\r   double-click to finish'
	        }));
	        jPanel.append($('<a/>', {
	            'class': _defines2.default.APANNOTREPORT + ' ' + _defines2.default.APANNOTREPORT + '-e ' + _defines2.default.clsAPBUTTON,
	            'navmode': 'nmAnnotReport',
	            'title': 'Add a report annotation'
	        }));
	        jPanel.append($('<a/>', {
	            'class': _defines2.default.APANNOTELLIPSE + ' ' + _defines2.default.APANNOTELLIPSE + '-e ' + _defines2.default.clsAPBUTTON,
	            'navmode': 'nmAnnotEllipse',
	            'title': 'Add an elliptcal annotation'
	        }));
	        jPanel.append($('<a/>', {
	            'class': _defines2.default.APANNOTTEXT + ' ' + _defines2.default.APANNOTTEXT + '-e ' + _defines2.default.clsAPBUTTON,
	            'navmode': 'nmAnnotText',
	            'title': 'Add on-image text'
	        }));
	        jPanel.append('<div class=\'tooldivider\'></div>'); // horizontal line

	        //
	        jPanel.append($('<a/>', {
	            'class': _defines2.default.APTRASH + ' ' + _defines2.default.APTRASH + '-e ' + _defines2.default.clsAPBUTTON,
	            'title': 'Delete the selected annotation'
	        }));
	        jPanel.append($('<a/>', {
	            'class': _defines2.default.APANNOTCOLOR + ' ' + _defines2.default.APANNOTCOLOR + '-e ' + _defines2.default.clsAPBUTTON,
	            'title': 'Select a color for this annotation'
	        }));
	        jPanel.append($('<a/>', {
	            'class': _defines2.default.APNOTE + ' ' + _defines2.default.APNOTE + '-e ' + _defines2.default.clsAPBUTTON,
	            'title': 'Add or update a note for this annotation'
	        }));

	        // annotation navigation section
	        jPanel.append('<div class=\'tooldivider\'></div>'); // horizontal line
	        var jAnNavDiv = jPanel.append($('<div>', { 'id': _defines2.default.idANNAVDIV }));
	        jAnNavDiv = jPanel.find('#' + _defines2.default.idANNAVDIV);

	        jAnNavDiv.append($('<a/>', {
	            'id': _defines2.default.ANAVPREV,
	            'class': _defines2.default.clsANAVBUTTON + ' ' + _defines2.default.ANAVPREV + '-e',
	            'title': 'Select previous annotation'
	        }));
	        jAnNavDiv.append($('<a/>', {
	            'id': _defines2.default.idANAVCURRENT,
	            'class': _defines2.default.clsANAVCURRENT + ' ' + _defines2.default.clsBLANKBTN,
	            'title': 'Center the view on the selected annotation'
	        }));
	        jAnNavDiv.append($('<a/>', {
	            'id': _defines2.default.ANAVNEXT,
	            'class': _defines2.default.clsANAVBUTTON + ' ' + _defines2.default.ANAVNEXT + '-e',
	            'title': 'Select next annotation'
	        }));

	        // convert div into dialog and use defaults
	        var height = _compatibility.BrowserDetect.isIE() ? '200px' : 'auto'; // IE adds vertical scrollbar in auto mode, so be specific
	        $(jPanel).dialog({
	            autoOpen: false, closeOnEscape: true, resizable: false, width: 'auto', height: height,
	            dialogClass: 'uscope-dialog dialogMover',
	            close: function close(event, ui) {
	                (0, _toolbar.setIconState)($('#' + _defines2.default.TBANNOTPANEL), _defines2.default.TBANNOTPANEL, 'enabled');
	            }
	        });

	        // append this modeless dialog to uscope's root div - the dialog is the parent to the panel created
	        $('#' + _defines2.default.idANNOTPANEL).parent().appendTo(_defines2.default.idHashROOT);

	        self.position(); // position the panel

	        uScope.events.on('color-picker:select-color', onColorSelect); // and create the color picker
	        self.publicColorPicker = colorPicker;
	        unBindEvents_(); // removes namespaced event handlers
	        bindEvents_(); // add event handlers
	    };

	    //............................................ construction
	    construct_();
	}
	module.exports = exports['default'];

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.consoleWrite = undefined;
	exports.cToolbar = cToolbar;
	exports.openTextEditPanel = openTextEditPanel;
	exports.setIconState = setIconState;
	exports.genericMessage = genericMessage;

	var _defines = __webpack_require__(3);

	var _defines2 = _interopRequireDefault(_defines);

	var _compatibility = __webpack_require__(6);

	var _events = __webpack_require__(10);

	var _uScope = __webpack_require__(11);

	var _uScope2 = _interopRequireDefault(_uScope);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/*
	 This file creates the toolbar for uscope, creates the settings panel, and other panels and handles their events.

	 The "main" toolbar contains the feature access buttons and settings.  It is positioned below
	 the selected image's toolbar.
	 */

	function cToolbar() {
	    var self = this;
	    var jtoolbar;

	    //............................................ position() public
	    //    position - This function positions the main toolbar on the selected image.
	    this.position = function (crOffset) {
	        //debug-only if (crOffset) consoleWrite("cToobar: position: " + crOffset.toString());
	        if (crOffset == undefined) jtoolbar.css({ 'left': '2px', 'top': '2px' });else jtoolbar.css({ 'left': crOffset.x + 'px', 'top': crOffset.y + crOffset.h + 'px' });
	    };
	    //............................................ bindEvents_() local
	    // bindEvents_ - This function adds the autopan event handlers.
	    //
	    //    Note that an exception is made here and the namespace is not an image's namespace.

	    var bindEvents_ = function bindEvents_() {
	        var namespace = '.autopan';
	        if (_defines2.default.ENABLEAUTOPAN == true) {
	            $(_defines2.default.idHashROOT).on('click' + namespace, '#' + _defines2.default.idTOPTOOLBARV, function (e) {
	                if (_uScope2.default.instance.isThisImageValid() == false) return false;
	                var thisImg = _uScope2.default.instance.getThisImage();
	                thisImg.autoPan.onOffToggle();
	                return false;
	            });
	        }
	        $(_defines2.default.idHashROOT).on('click' + namespace, '.' + _defines2.default.idTBRESIZE + '-e', function (e) {
	            (0, _events.triggerUScopeEvent)(_defines2.default.evRESIZECLICK, {});
	            return false;
	        });
	        if (_compatibility.BrowserDetect.isIOS()) {
	            $(_defines2.default.idHashROOT).on('touchstart' + namespace, '.' + _defines2.default.idTBRESIZE + '-e', function (e) {
	                (0, _events.triggerUScopeEvent)(_defines2.default.evRESIZECLICK, {});
	                return false;
	            });
	        }

	        $(_defines2.default.idHashROOT).on('click' + namespace, '.' + _defines2.default.idTBMULTIVIEW + '-4' // multi image arrangement button
	        + ',.' + _defines2.default.idTBMULTIVIEW + '-v' + ',.' + _defines2.default.idTBMULTIVIEW + '-h', function (e) {
	            if (_uScope2.default.instance.getImageCount() > 1) _uScope2.default.instance.imageArrange(true);
	            return false;
	        });
	        $(_defines2.default.idHashROOT).on('click', '.' + _defines2.default.TBSNAPSHOT + '-e', function (e) {
	            // snapshot button
	            if (_uScope2.default.instance.isThisImageValid()) {
	                var thisImg = _uScope2.default.instance.getThisImage();
	                var snapshotMode = _uScope2.default.instance.toolbarSnapShotMode();
	                if (snapshotMode == 'reportRegion') {
	                    var anObj = thisImg.getAnnotObj();
	                    var regionId = anObj.getReportRegionId();
	                    if (regionId > 0) {
	                        (0, _events.triggerUScopeEvent)(_defines2.default.evSNAPSHOT, {
	                            imageId: thisImg.getImageId(),
	                            mode: snapshotMode,
	                            regionId: regionId
	                        });
	                    } else {
	                        thisImg.log('Report region does not exist. Please create a report region first.');
	                        genericMessage('Report region does not exist.<br /> Please create a report region first.', 'Snapshot of report region');
	                    }
	                } else if (snapshotMode == 'printViewport') {
	                    (0, _events.triggerUScopeEvent)(_defines2.default.evSNAPSHOT, {
	                        imageId: thisImg.getImageId(),
	                        mode: snapshotMode,
	                        div: thisImg.vpDivGet('outer')
	                    });
	                }
	            }
	            return false;
	        });
	        $(_defines2.default.idHashROOT).on('click' + namespace, '.' + _defines2.default.TBISCOPE + '-e', function (e) {
	            // open in imagescope button
	            var thisImg = _uScope2.default.instance.getThisImage();
	            (0, _events.triggerUScopeEvent)(_defines2.default.evIMAGESCOPEOPEN, { imageId: thisImg.getImageId() });
	            return false;
	        });
	    };
	    //............................................ init_() local
	    //    init_ = This function creates the toolbar, sizes it and adds its event handlers.
	    var init_ = function init_() {
	        var settingsButton;

	        jtoolbar = $(_defines2.default.idHashROOT).find('#' + _defines2.default.idTOPTOOLBARV); // if the toolbar already exists, remove it
	        if (jtoolbar.length) jtoolbar.remove();
	        jtoolbar = $('<div/>', { // build the toolbar div tag
	            'id': _defines2.default.idTOPTOOLBARV,
	            'class': _defines2.default.clsSUPEROVERLAY + ' ' + _defines2.default.clsTRANSPARENT,
	            'title': 'Click to AutoPan Up, Click Again to Stop AutoPan'
	        });

	        if (_defines2.default.SHOWALLTOOLBARICONS || _uScope2.default.instance.toolbarCanAddButton('resizeBtn')) // if there's intent to show the button
	            jtoolbar.append($('<a/>', {
	                'id': _defines2.default.idTBRESIZE,
	                'class': _defines2.default.clsTBBUTTON + ' ' + _defines2.default.idTBRESIZE + '-e',
	                'title': 'Resize the image viewer'
	            }));

	        if (_defines2.default.SHOWALLTOOLBARICONS || _uScope2.default.instance.toolbarCanAddButton('openImageScopeBtn')) // if there's intent to show the button
	            jtoolbar.append($('<a/>', {
	                'id': _defines2.default.TBISCOPE,
	                'class': _defines2.default.clsTBBUTTON + ' ' + _defines2.default.TBISCOPE + '-e',
	                'title': 'Open this image in ImageScope'
	            }));

	        // multi-image arangement
	        jtoolbar.append($('<a/>', {
	            'id': _defines2.default.idTBMULTIVIEW,
	            'class': _defines2.default.clsTBBUTTON + ' ' + _defines2.default.idTBMULTIVIEW + '-4',
	            'title': 'Change image tiling pattern'
	        }));

	        if (_defines2.default.SHOWALLTOOLBARICONS || _uScope2.default.instance.toolbarCanAddButton('snapshotBtn')) // if there's intent to show the button
	            jtoolbar.append($('<a/>', {
	                'id': _defines2.default.TBSNAPSHOT,
	                'class': _defines2.default.clsTBBUTTON + ' ' + _defines2.default.TBSNAPSHOT + '-e',
	                'title': 'Snapshot of current view'
	            }));

	        if (_defines2.default.SHOWALLTOOLBARICONS || _uScope2.default.instance.toolbarCanAddButton('imageAnalysis')) {
	            // if there's intent to show the analysis button
	            jtoolbar.append($('<a/>', {
	                'id': _defines2.default.TBANALYSIS,
	                'class': _defines2.default.clsTBBUTTON + ' ' + _defines2.default.TBANALYSIS + '-e',
	                'title': 'Open the analysis toolbox'
	            }));
	        }

	        settingsButton = $('<a/>', {
	            'id': _defines2.default.TBSETTINGS,
	            'class': _defines2.default.clsTBBUTTON + ' ' + _defines2.default.TBSETTINGS + '-e',
	            'title': 'Open the settings panel'
	        });
	        jtoolbar.append(settingsButton);

	        $(_defines2.default.idHashROOT).append(jtoolbar); // append the toolbar to the root node
	        self.position();

	        // Expose the ability to add a button externally
	        self.addButton = function (button) {
	            return $(button).insertBefore(settingsButton);
	        };

	        bindEvents_();
	    };
	    //............................................ construction
	    init_();
	}

	// Logging stuff, randomly placed inside the toolbar file...
	var logger = _defines2.default.helpers.createLogger(true, '');
	var log = logger.log;
	var consoleWrite = exports.consoleWrite = function consoleWrite(msg, imageId) {
	    msg = 'uScope: ' + (imageId ? imageId + ': ' + msg : msg);
	    log(msg);

	    updateConsoleSpec(msg);
	};
	function updateConsoleSpec(msg) {
	    // Code Smell - It looks like msgCount is a manually managed copy of msg.length. TODO: refactoring candidate
	    if (++_defines2.default.consoleSpecs.msgCnt > _defines2.default.consoleSpecs.msgMax) {
	        // update the message number
	        _defines2.default.consoleSpecs.msgCnt = 1;
	    }

	    _defines2.default.consoleSpecs.msg.push('<br>' + _defines2.default.consoleSpecs.msgCnt + ' ' + msg);

	    if (_defines2.default.consoleSpecs.msg.length > _defines2.default.consoleSpecs.msgMax) {
	        // don't keep too many old messages
	        _defines2.default.consoleSpecs.msg.shift();
	    }

	    updateConsoleUi();
	}
	function updateConsoleUi() {
	    var jPanel = $('#' + _defines2.default.idDBGCONSOLE); // return if the console hasn't been created or isn't visible
	    if (jPanel.is(':visible') === false || jPanel.length === 0) {
	        return;
	    }

	    jPanel.find('div').remove(); // remove the previous message set
	    var jInfo = $('<div id="' + _defines2.default.idDBGCONSOLELOG + '">' + _defines2.default.consoleSpecs.msg + '</div>');
	    jPanel.append(jInfo);
	}

	// Text Editor dialog, randomly placed inside the toolbar file...
	var $textEditPanel = void 0,
	    $textEditForm = void 0,
	    lastCursorPosition = void 0,
	    lastCallback = void 0;
	var createTextEditPanel = function createTextEditPanel(initialText) {
	    $textEditPanel = $('<div/>', { 'id': _defines2.default.idTEXTEDITPANEL, 'class': _defines2.default.clsPANEL });

	    $textEditForm = $('<textarea />').val(initialText).css('resize', 'none').width(_defines2.default.textEditSpecs.width - 30).height(_defines2.default.textEditSpecs.height - 120);

	    $textEditPanel.append($textEditForm);

	    $textEditPanel.dialog({
	        autoOpen: false,
	        draggable: true,
	        resizable: false,
	        stack: true,
	        modal: true,
	        width: _defines2.default.textEditSpecs.width,
	        minWidth: _defines2.default.textEditSpecs.width,
	        height: _defines2.default.textEditSpecs.height,
	        minHeight: _defines2.default.textEditSpecs.height,
	        dialogClass: 'uscope-dialog dialogMover',
	        buttons: [{
	            text: 'Cancel',
	            click: function click() {
	                $textEditPanel.find('textarea').val(''); // clear text and close
	                $textEditPanel.dialog('close');
	                lastCallback(lastCursorPosition);
	            }
	        }, {
	            text: 'Ok',
	            click: function click() {
	                var jtext = $textEditPanel.find('textarea');
	                var outText = $(jtext).val();
	                jtext.val(''); // clear text and close
	                $textEditPanel.dialog('close');
	                lastCallback(lastCursorPosition, outText);
	            }
	        }],
	        resize: function resize(event, ui) {
	            // TODO: Is this function used?
	            var w = $textEditPanel.width() - 10;
	            var h = $textEditPanel.height() - 10;
	            $textEditForm.width(w);
	            $textEditForm.height(h);
	        },

	        // append this modal dialog to body to work around a jquery issue that modal dialogs cannot be dismissed in popup mode
	        // (would normally want it appended to the uscope div)
	        appendTo: 'body'
	    });
	};
	function openTextEditPanel(title) {
	    var text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    var callback = arguments[2];
	    var cursorPosition = arguments[3];

	    if (!_uScope2.default.instance.isThisImageValid()) {
	        return;
	    }
	    var hotKeyState = _defines2.default.ENABLEDEVHOTKEYS;
	    if (hotKeyState) {
	        _defines2.default.ENABLEDEVHOTKEYS = false;
	    }

	    if (!$textEditPanel) {
	        createTextEditPanel(text);
	    } else {
	        $textEditForm.val(text);
	    }

	    lastCallback = function lastCallback() {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }

	        _defines2.default.ENABLEDEVHOTKEYS = hotKeyState;
	        callback && callback.apply(null, args);
	    };
	    lastCursorPosition = cursorPosition;
	    $textEditPanel.dialog('option', 'title', title);

	    $textEditPanel.dialog('open');
	}

	//-------------------------------------------------------------------------------------------------
	//    ICON MANAGEMENT
	//-------------------------------------------------------------------------------------------------
	//............................................ setIconState
	//    setIconState - This function sets an icon to its active, enabled or disabled state
	//            OR sets the muti-image icon to one of its 3 possible states.
	//
	//        Note that it depends upon the css class naming convention:
	//            classRoot-e - defines icon for enabled state
	//            classRoot-d - defines icon for disabled state
	//            classRoot-a - defines icon for active state
	//
	function setIconState(jContainer, classRoot, state) {
	    if (state == 'active') // most toolbar icon states
	        jContainer.addClass(classRoot + '-a').removeClass(classRoot + '-e').removeClass(classRoot + '-d');else if (state == 'enabled') jContainer.addClass(classRoot + '-e').removeClass(classRoot + '-a').removeClass(classRoot + '-d');else if (state == 'disabled') jContainer.addClass(classRoot + '-d').removeClass(classRoot + '-e').removeClass(classRoot + '-a');else if (state == 't') //multi image icon states
	        jContainer.addClass(classRoot + '-4').removeClass(classRoot + '-v').removeClass(classRoot + '-h').removeClass(classRoot + '-d');else if (state == 'v') jContainer.addClass(classRoot + '-v').removeClass(classRoot + '-4').removeClass(classRoot + '-h').removeClass(classRoot + '-d');else if (state == 'h') jContainer.addClass(classRoot + '-h').removeClass(classRoot + '-4').removeClass(classRoot + '-v').removeClass(classRoot + '-d');else if (state == 'd' || state == '1' || state == '4') jContainer.addClass(classRoot + '-d').removeClass(classRoot + '-h').removeClass(classRoot + '-v').removeClass(classRoot + '-4');else return;
	    if (_defines2.default.DBGANNOTEX) consoleWrite('setIconState: ' + classRoot + ' -' + state);
	}

	//-------------------------------------------------------------------------------------------------
	//    DIALOG HELPER METHODS
	//-------------------------------------------------------------------------------------------------

	//............................................ genericMessage
	//    genericMessage - A general purpose message panel that removes itself from the DOM when closed.
	//
	//    parameters:
	//        message:        required, string, your message to the user
	//        title:            optional, string, default "Notice"
	//
	function genericMessage(message, title) {
	    if (message == undefined) message = '';
	    title = title != undefined ? title : 'Notice';

	    var jPanel = $('<div id=' + _defines2.default.idMSGPANEL + ' title="' + title + '">' + message + '</div>');
	    $(_defines2.default.idHashROOT).append(jPanel); // add the panel to the root

	    $(jPanel).dialog({
	        autoOpen: true, modal: true, closeOnEscape: false, resizable: false,
	        dialogClass: 'uscope-dialog dialogMover',
	        close: function close(event, ui) {
	            $(this).remove();
	        },
	        buttons: [{
	            text: 'OK', click: function click() {
	                $(this).remove();
	            }
	        }]
	    });

	    // append this modal dialog to body to work around a jquery issue that modal dialogs cannot be dismissed in popup mode
	    //    (would normally want it appended to the uscope div)
	    // note that the dialog is the parent to the panel created
	    $('#' + _defines2.default.idMSGPANEL).parent().appendTo('body');
	}

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.BrowserDetect = exports.getInnerDims = undefined;

	var _objects = __webpack_require__(7);

	/*
	 This file contains helper functions related to browser compatibility issues.
	 */

	/**
	 * This method computes the inner dimensions of the window accounting for browser variations.
	 *  Taken from http://andylangton.co.uk/articles/javascript/get-viewport-size-javascript/
	 *  because IE8 was found to not support inner[width|height]
	 * @returns {cSize}
	 */
	var getInnerDims = exports.getInnerDims = function getInnerDims() {
	    var innerDims = new _objects.cSize(0, 0);
	    // the more standards compliant browsers (mozilla/netscape/opera/IE7) use window.innerWidth and window.innerHeight
	    if (typeof window.innerWidth != 'undefined') {
	        innerDims.w = window.innerWidth, innerDims.h = window.innerHeight;
	    }
	    // IE6 in standards compliant mode (i.e. with a valid doctype as the first line in the document)
	    else if (typeof document.documentElement != 'undefined' && typeof document.documentElement.clientWidth != 'undefined' && document.documentElement.clientWidth != 0) {
	            innerDims.w = document.documentElement.clientWidth, innerDims.h = document.documentElement.clientHeight;
	        }
	        // older versions of IE
	        else {
	                innerDims.w = document.getElementsByTagName('body')[0].clientWidth, innerDims.h = document.getElementsByTagName('body')[0].clientHeight;
	            }
	    return innerDims;
	};

	/**
	 * http://www.quirksmode.org/js/detect.html
	 * TODO: Remove this entirely.
	 * @type {{init: BrowserDetect.init, report: BrowserDetect.report, reportOS: BrowserDetect.reportOS, reportBrowser: BrowserDetect.reportBrowser, isIE: BrowserDetect.isIE, isIEBelow8: BrowserDetect.isIEBelow8, isIEBelow9: BrowserDetect.isIEBelow9, isIEBelow10: BrowserDetect.isIEBelow10, isIE8: BrowserDetect.isIE8, isIE9: BrowserDetect.isIE9, isIE10: BrowserDetect.isIE10, isFirefox: BrowserDetect.isFirefox, isSafari: BrowserDetect.isSafari, isChrome: BrowserDetect.isChrome, isIOS: BrowserDetect.isIOS, searchString: BrowserDetect.searchString, searchVersion: BrowserDetect.searchVersion, dataBrowser: *[], dataOS: *[]}}
	 */
	var BrowserDetect = exports.BrowserDetect = {
	    init: function init() {
	        this.browser = this.searchString(this.dataBrowser) || 'An unknown browser';
	        this.version = this.searchVersion(navigator.userAgent) || this.searchVersion(navigator.appVersion) || 'an unknown version';
	        this.OS = this.searchString(this.dataOS) || 'an unknown OS';
	    },
	    report: function report() {
	        return 'OS: ' + this.OS + ';  Browser: ' + this.browser + ' ' + this.version + ';   userAgent: ' + navigator.userAgent;
	    },
	    reportOS: function reportOS() {
	        return 'OS: ' + this.OS;
	    },
	    reportBrowser: function reportBrowser() {
	        return 'Browser: ' + this.OBrowser;
	    },
	    isIE: function isIE() {
	        return this.browser.indexOf('Explorer') == -1 ? false : true;
	    },
	    isIEBelow8: function isIEBelow8() {
	        return this.isIE() && this.version < 8 ? true : false;
	    },
	    isIEBelow9: function isIEBelow9() {
	        return this.isIE() && this.version < 9 ? true : false;
	    },
	    isIEBelow10: function isIEBelow10() {
	        return this.isIE() && this.version < 10 ? true : false;
	    },
	    isIE8: function isIE8() {
	        return this.isIE() && this.version == 8 ? true : false; //  ie8 Trident/4.0
	    },
	    isIE9: function isIE9() {
	        // ie9 in compat mode reports a 7 but compatibility is what I want to know
	        return this.isIE() && this.version == 9 ? true : false; //  ie9 Trident/5.0
	    },
	    isIE10: function isIE10() {
	        return this.isIE() && this.version == 10 ? true : false; //  ie10 Trident/6.0
	    },
	    isFirefox: function isFirefox() {
	        return this.browser.indexOf('Firefox') == -1 ? false : true;
	    },
	    isSafari: function isSafari() {
	        return this.browser.indexOf('Safari') == -1 ? false : true;
	    },
	    isChrome: function isChrome() {
	        return this.browser.indexOf('Chrome') == -1 ? false : true;
	    },
	    isIOS: function isIOS() {
	        return this.OS.indexOf('iPad') == -1 && this.OS.indexOf('iPhone') == -1 && this.OS.indexOf('iPod') == -1 ? false : true;
	    },

	    searchString: function searchString(data) {
	        for (var i = 0; i < data.length; i++) {
	            var dataString = data[i].string;
	            var dataProp = data[i].prop;
	            this.versionSearchString = data[i].versionSearch || data[i].identity;
	            if (dataString) {
	                if (dataString.indexOf(data[i].subString) != -1) return data[i].identity;
	            } else if (dataProp) return data[i].identity;
	        }
	    },
	    searchVersion: function searchVersion(dataString) {
	        var index = dataString.indexOf(this.versionSearchString);
	        if (index == -1) return;
	        return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
	    },
	    dataBrowser: [{
	        string: navigator.userAgent,
	        subString: 'Chrome',
	        identity: 'Chrome'
	    }, {
	        string: navigator.userAgent,
	        subString: 'OmniWeb',
	        versionSearch: 'OmniWeb/',
	        identity: 'OmniWeb'
	    }, {
	        string: navigator.vendor,
	        subString: 'Apple',
	        identity: 'Safari',
	        versionSearch: 'Version'
	    }, {
	        prop: window.opera,
	        identity: 'Opera',
	        versionSearch: 'Version'
	    }, {
	        string: navigator.vendor,
	        subString: 'iCab',
	        identity: 'iCab'
	    }, {
	        string: navigator.vendor,
	        subString: 'KDE',
	        identity: 'Konqueror'
	    }, {
	        string: navigator.userAgent,
	        subString: 'Firefox',
	        identity: 'Firefox'
	    }, {
	        string: navigator.vendor,
	        subString: 'Camino',
	        identity: 'Camino'
	    }, { // for newer Netscapes (6+)
	        string: navigator.userAgent,
	        subString: 'Netscape',
	        identity: 'Netscape'
	    }, {
	        string: navigator.userAgent,
	        subString: 'MSIE',
	        identity: 'Explorer',
	        versionSearch: 'MSIE'
	    }, {
	        string: navigator.userAgent,
	        subString: 'Gecko',
	        identity: 'Mozilla',
	        versionSearch: 'rv'
	    }, { // for older Netscapes (4-)
	        string: navigator.userAgent,
	        subString: 'Mozilla',
	        identity: 'Netscape',
	        versionSearch: 'Mozilla'
	    }],
	    dataOS: [{
	        string: navigator.platform,
	        subString: 'Win',
	        identity: 'Windows'
	    }, {
	        string: navigator.platform,
	        subString: 'Mac',
	        identity: 'Mac'
	    }, {
	        string: navigator.userAgent,
	        subString: 'iPhone',
	        identity: 'iPhone/iPod'
	    }, {
	        string: navigator.userAgent,
	        subString: 'iPad',
	        identity: 'iPad'
	    }, {
	        string: navigator.userAgent,
	        subString: 'iPhone/iPod',
	        identity: 'iPhone/iPod'
	    }, {
	        string: navigator.platform,
	        subString: 'Linux',
	        identity: 'Linux'
	    }]
	};
	BrowserDetect.init();

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.cPoint = cPoint;
	exports.cSize = cSize;
	exports.cRect = cRect;
	exports.cRect2 = cRect2;

	var _helpers = __webpack_require__(8);

	//-------------------------------------------------------------------------------------------------
	// objects.js
	//    This file contains handy and light weight generic objects:
	//        cPoint - x,y coordinate
	//        cSize - w,h dimensions
	//        cRect - x,y as top left coordinate and w,h dimensions of a rectangle
	//
	//    todo: cRect2 should derive from cRect
	//
	//    history
	//    1106    cperz        created with cPoint and cSize, added cRect
	//    _______________________________________end_AIHv1/PR __________________________________________
	//
	//    141222    cperz        added cRect2
	//    150318    cperz        cPoint, cSize and cRect: return 'this' for chaining
	//________________________________________________________________________________________________
	//
	// cPoint object - This is a generic x,y point object intended to expand to include common
	//                    operations performed on x,y points.

	function cPoint(x, y) {
	    this.x = +x;
	    this.y = +y;
	}
	cPoint.prototype.isValid = function () {
	    return (0, _helpers.isUnDefined)(this.x) || (0, _helpers.isUnDefined)(this.y) ? false : true;
	};
	cPoint.prototype.toString = function () {
	    return '(' + this.x + ',' + this.y + ')';
	};
	cPoint.prototype.rangeToString = function (cs) {
	    return '(' + this.x + ',' + this.y + ') to (' + (this.x + +cs.w - 1) + ',' + (this.y + +cs.h - 1) + ')';
	};
	cPoint.prototype.negate = function () {
	    this.x = -this.x;
	    this.y = -this.y;
	    return this; // for chaining
	};
	cPoint.prototype.abs = function (dx, dy) {
	    if (this.x < 0) this.x = -this.x;
	    if (this.y < 0) this.y = -this.y;
	    return this; // for chaining
	};
	cPoint.prototype.set = function (x, y) {
	    this.x = +x;
	    this.y = +y;
	};
	cPoint.prototype.setPoint = function (cp) {
	    this.x = cp.x;
	    this.y = cp.y;
	    return this; // for chaining
	};

	cPoint.prototype.add = function (dx, dy) {
	    this.x = this.x + +dx;
	    this.y = this.y + +dy;
	    return this; // for chaining
	};
	cPoint.prototype.addPoint = function (cp) {
	    this.x = this.x + +cp.x;
	    this.y = this.y + +cp.y;
	    return this; // for chaining
	};
	cPoint.prototype.subt = function (dx, dy) {
	    this.x = this.x - +dx;
	    this.y = this.y - +dy;
	    return this; // for chaining
	};
	cPoint.prototype.subtPoint = function (cp) {
	    this.x = this.x - +cp.x;
	    this.y = this.y - +cp.y;
	    return this; //for chaining
	};

	cPoint.prototype.mult = function (dx, dy) {
	    this.x = this.x * dx;
	    this.y = this.y * dy;
	};
	cPoint.prototype.div = function (dx, dy) {
	    this.x = this.x / dx;
	    this.y = this.y / dy;
	    return this; // for chaining
	};

	cPoint.prototype.toTileNums = function (tileW, tileH, zoom) {
	    this.x = Math.ceil(this.x / tileW / zoom);
	    this.y = Math.ceil(this.y / tileH / zoom);
	    return this; // for chaining
	};
	cPoint.prototype.toPosition = function (tileW, tileH, zoom) {
	    this.x = this.x * tileW * zoom;
	    this.y = this.y * tileH * zoom;
	    return this; // for chaining
	};
	cPoint.prototype.cityBlockDistance = function (cpIn) {
	    return Math.abs(cpIn.x - this.x) + Math.abs(cpIn.y - this.y);
	};
	cPoint.prototype.distance = function (cpIn) {
	    return Math.sqrt((cpIn.x - this.x) * (cpIn.x - this.x) + (cpIn.y - this.y) * (cpIn.y - this.y));
	};
	cPoint.prototype.isEqual = function (cpIn) {
	    return cpIn.x === this.x && cpIn.y === this.y ? true : false;
	};
	cPoint.prototype.toInt = function () {
	    this.x = Math.round(this.x);
	    this.y = Math.round(this.y);
	    return this; // for chaining
	};
	cPoint.prototype.toFixed = function (dec) {
	    if (dec <= 0) return this.toInt();
	    this.x = this.x.toFixed(dec);
	    this.y = this.y.toFixed(dec);
	    return this; // for chaining
	};
	cPoint.prototype.isWithin = function (csValue, bInclusive) {
	    if (this.x < 0 || this.y < 0) return false;

	    if (bInclusive === undefined) bInclusive = true;
	    if (bInclusive) return this.x >= csValue.w || this.y >= csValue.h ? false : true;else return this.x > csValue.w || this.y > csValue.h ? false : true;
	};
	cPoint.prototype.rotate = function (cosAngle, sinAngle) {
	    var rotX = this.x * cosAngle - this.y * sinAngle;
	    var rotY = this.x * sinAngle + this.y * cosAngle;
	    this.x = rotX;
	    this.y = rotY;
	    return this; // for chaining
	};
	cPoint.prototype.rotateAbout = function (cosAngle, sinAngle, cpOrigin, opt_precision) {
	    this.subtPoint(cpOrigin); // remove origin
	    var rotX = this.x * cosAngle - this.y * sinAngle;
	    var rotY = this.x * sinAngle + this.y * cosAngle;
	    this.x = rotX;
	    this.y = rotY;
	    this.addPoint(cpOrigin); // remove origin

	    if (opt_precision != undefined) {
	        this.toFixed(opt_precision);
	    }
	    return this; // for chaining
	};

	//-------------------------------------------------------------------------------------------------
	// cSize object - This is a generic w,h size object.
	//-------------------------------------------------------------------------------------------------
	function cSize(w, h) {
	    this.w = w;
	    this.h = h;
	}
	cSize.prototype.isValid = function () {
	    return (0, _helpers.isUnDefined)(this.w) || (0, _helpers.isUnDefined)(this.h) ? false : true;
	};
	cSize.prototype.toString = function () {
	    return '(' + this.w + 'x' + this.h + ')';
	};
	cSize.prototype.toString2 = function () {
	    return this.w + ' x ' + this.h;
	};
	cRect.prototype.rangeToString = function (cp) {
	    return '(' + cp.x + ',' + cp.y + ') to (' + (cp.x + +this.w - 1) + ',' + (cp.y + +this.h - 1) + ')';
	};
	cSize.prototype.set = function (w, h) {
	    this.w = w;
	    this.h = h;
	    return this; // for chaining
	};
	cSize.prototype.setSize = function (cs) {
	    this.w = cs.w;
	    this.h = cs.h;
	    return this; // for chaining
	};
	cSize.prototype.getArea = function () {
	    return this.w * this.h;
	};
	cSize.prototype.add = function (dw, dh) {
	    this.w += +dw;
	    this.h += +dh;
	    return this; // for chaining
	};
	cSize.prototype.addSize = function (cs) {
	    this.w = this.w + +cs.w;
	    this.h = this.h + +cs.h;
	    return this; // for chaining
	};
	cSize.prototype.subt = function (dw, dh) {
	    this.w -= +dw;
	    this.h -= +dh;
	    return this; // for chaining
	};
	cSize.prototype.mult = function (dx, dy) {
	    this.w = this.w * dx;
	    this.h = this.h * dy;
	    return this; // for chaining
	};
	cSize.prototype.div = function (dx, dy) {
	    this.w = this.w / dx;
	    this.h = this.h / dy;
	    return this; // for chaining
	};
	cSize.prototype.toTileNums = function (tileW, tileH, zoom) {
	    this.w = Math.ceil(this.w / tileW / zoom);
	    this.h = Math.ceil(this.h / tileH / zoom);
	    return this; // for chaining
	};
	cSize.prototype.maxDim = function () {
	    return Math.max(this.w, this.h);
	};
	cSize.prototype.toInt = function () {
	    this.w = Math.round(this.w);
	    this.h = Math.round(this.h);
	    return this; // for chaining
	};
	cSize.prototype.getCenterW = function (roundToInt) {
	    // note that 0-based counting is assumed by the -1
	    return roundToInt ? Math.round(this.w / 2 - 1) : this.w / 2 - 1;
	};
	cSize.prototype.getCenterH = function (roundToInt) {
	    // note that 0-based counting is assumed by the -1
	    return roundToInt ? Math.round(this.h / 2 - 1) : this.h / 2 - 1;
	};

	//-------------------------------------------------------------------------------------------------
	// cRect object - This is a generic rectangle object.
	//-------------------------------------------------------------------------------------------------
	function cRect(x, y, w, h) {
	    this.x = x; //left
	    this.y = y; // top
	    this.w = w;
	    this.h = h;

	    this.cx = this.x + this.w / 2.; // center x and y
	    this.cy = this.y + this.h / 2.;
	}
	cRect.prototype.setxy = function (x, y) {
	    this.x = x;
	    this.y = y;

	    this.cx = this.x + this.w / 2.; // center x and y
	    this.cy = this.y + this.h / 2.;
	    return this; // for chaining
	};
	cRect.prototype.setxywh = function (x, y, w, h) {
	    this.x = x;
	    this.y = y;
	    this.w = w;
	    this.h = h;
	    return this; // for chaining
	};
	cRect.prototype.set = function (cp, cs) {
	    this.x = cp.x;
	    this.y = cp.y;
	    this.w = cs.w;
	    this.h = cs.h;
	    return this; // for chaining
	};
	cRect.prototype.setRect = function (rect) {
	    this.x = rect.x; //left
	    this.y = rect.y; // top
	    this.w = rect.w;
	    this.h = rect.h;

	    this.cx = rect.cx; // center x and y
	    this.cy = rect.cy;
	    return this; // for chaining
	};
	cRect.prototype.addxy = function (a, b) {
	    this.x = +this.x + a;
	    this.y = +this.y + b;

	    this.cx = this.x + this.w / 2.; // center x and y
	    this.cy = this.y + this.h / 2.;
	    return this; // for chaining
	};

	cRect.prototype.toString = function () {
	    return 'X,Y:(' + this.x + ',' + this.y + ')  WxH:(' + (this.w - 1) + 'x' + (this.h - 1) + ')';
	};
	cRect.prototype.rangeToString = function () {
	    return '(' + this.x + ',' + this.y + ') to (' + (this.x + +this.w - 1) + ',' + (this.y + +this.h - 1) + ')';
	};

	//
	// cRect2 object - This is a lightwieght (cc - really???) object representing a rectangle with some caveats:
	//        o corner coords are public but if you modify them directly (not using set) then be sure to call updateGeometry()
	function cRect2(l, t, r, b) {
	    this.left = 0, this.right = 0, this.top = 0, this.bottom = 0; // corners
	    this.w = 0, this.h = 0; // width and height
	    this.area = 0; // area
	    this.cx = 0, this.cy = 0;

	    //......................................................
	    this.set = function (l, t, r, b) {
	        this.left = l;
	        this.right = r;
	        this.top = t;
	        this.bottom = b;
	        this.updateGeometry();
	    };
	    this.zero = function () {
	        this.set(0, 0, 0, 0);
	    };
	    this.isZero = function () {
	        return this.w <= 0 || this.h <= 0 ? true : false;
	    };
	    this.getCenter = function () {
	        // TODO - verify: Original line was return new cPoint(cx, cy). cx and cy are not defined.
	        return new cPoint(this.cx, this.cy);
	    };
	    this.getArea = function () {
	        return this.area;
	    };

	    this.toString = function () {
	        return 'LT:(' + this.left + ',' + this.top + ') to RB:(' + this.right + ',' + this.bottom + ')  WxH:' + this.w + ',' + this.h;
	    };
	    this.toStringLRTB = function () {
	        return 'LR(' + this.left + ',' + this.right + ') to TB(' + this.top + ',' + this.bottom + ')';
	    };

	    this.hasOverlap = function (rect2) {
	        return !(this.left > rect2.right || rect2.left > this.right || this.top > rect2.bottom || rect2.top > this.bottom);
	    };

	    this.intersect = function (rect2) {
	        // modifies the rect to be that of the intersection with the passed rect
	        if (rect2.left > this.left) this.left = rect2.left;
	        if (rect2.top > this.top) this.top = rect2.top;
	        if (rect2.right < this.right) this.right = rect2.right;
	        if (rect2.bottom < this.bottom) this.bottom = rect2.bottom;
	        if (this.left >= this.right || this.top >= this.bottom) this.zero();
	    };

	    this.getIntersectRect = function (crect2) {
	        // preserves this rect, returns the intersection between this and the passed rect
	        var rtnRect2 = new cRect2(this.left, this.top, this.right, this.bottom);
	        rtnRect2.intersect(crect2);
	        return rtnRect2;
	    };
	    this.updateGeometry = function () {
	        this.w = this.right - this.left; // width and height  ///??? should I sutbract 1?
	        this.h = this.bottom - this.top;
	        this.cx = this.left + this.w / 2.; // center x and y
	        this.cy = this.top + this.h / 2.;
	        this.area = this.w * this.h;
	    };
	    //construction
	    this.set(l, t, r, b);
	}
	//________________________________________________________________________________________________

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.isUnDefined = exports.halfLength = exports.memset = undefined;

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	exports.trimWhitespace = trimWhitespace;
	exports.circBuffer = circBuffer;
	exports.getIndexWith = getIndexWith;
	exports.toStringAssoc = toStringAssoc;
	exports.assocArrayLength = assocArrayLength;
	exports.cloneObject = cloneObject;
	exports.isEmptyObject = isEmptyObject;
	exports.isNumber = isNumber;
	exports.isDefined = isDefined;
	exports.stripLeadingAtSign = stripLeadingAtSign;
	exports.isValidArrayIndex = isValidArrayIndex;
	exports.hexColortoRGB = hexColortoRGB;
	exports.toHexColor = toHexColor;
	exports.reverseCLR = reverseCLR;
	exports.deSaturate = deSaturate;
	exports.isLightColor = isLightColor;
	exports.roundto = roundto;
	exports.limitValue = limitValue;
	exports.getClassList = getClassList;
	exports.array2DCreate = array2DCreate;
	exports.toPortable = toPortable;
	exports.fromPortable = fromPortable;
	exports.divRotate = divRotate;
	exports.computeRotationOffset = computeRotationOffset;

	var _defines = __webpack_require__(3);

	var _defines2 = _interopRequireDefault(_defines);

	var _objects = __webpack_require__(7);

	var _lodashLite = __webpack_require__(9);

	var _ = _interopRequireWildcard(_lodashLite);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	//________________________________________________________________________________________________
	// helpers.js
	// This file contains useful functions.
	//
	//    history
	//    1108    cperz    created
	//
	//    _______________________________________end_AIHv1/PR __________________________________________
	//    141222    cperz    add isEmptyObject,
	//    150318    cperz    getIndexWith: check array entry is defined
	//________________________________________________________________________________________________

	(function createGeneralUtilities() {

	    /**
	    /**
	     * Rounds `value` to the nearest decimal. Borrowed from MDN (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/round).
	     * Returns NaN if the input is not a number.
	     * @param {Number} value - the value to round
	     * @param {Number} exp - the number of decimals to round to
	     * @returns {Number}
	     */
	    function roundToDecimals(value, exp) {
	        if (arguments.length < 2) {
	            exp = 3;
	        }
	        value = Number(value);
	        exp = Number(exp);

	        if (isNaN(value) || isNaN(exp)) {
	            return NaN;
	        }

	        value = value.toString().split('e');
	        value = Math.round(Number(value[0] + 'e' + (value[1] ? +value[1] + exp : exp)));

	        value = value.toString().split('e');
	        return Number(value[0] + 'e' + (value[1] ? +value[1] - exp : -exp));
	    }

	    /**
	     * Creates a context-bound logger, allowing line number to be captured from anywhere
	     * @param isDebugEnabled - Optional and defaults to true for now, since so much logging code is wrapped in if statements. Should be required and bound to debug switches to reduce code litter.
	     * @param name - Optional. Provide logging context beyond line number
	     * @returns object containing all logging methods attached to console.log
	     */
	    var createLogger = function createLogger(isDebugEnabled, name) {
	        // this.debug used to assist with context binding
	        var logger = this.debug = {};
	        // Default to true since most logging is externally wrapped. This allows us to unpack some of the "if"s and create a logger bound directly to a switch
	        isDebugEnabled = !(isDebugEnabled === false);
	        // Optionally, provide additional logging context
	        name = name ? name + ':' : '';

	        _.forEach(console, function (method, methodName) {
	            if (_.isFunction(method)) {
	                logger[methodName] = isDebugEnabled ? method.bind(console, name) : $.noop;
	            }
	        });
	        return logger;
	    };

	    // Export helpers
	    _defines2.default.helpers = {
	        roundToDecimals: roundToDecimals,
	        createLogger: createLogger
	    };
	})();

	//-------- Begin bad practice of extending native JS objects. TODO: Stop doing this. -------------
	/*
	Array.prototype.remove = function (from, to) {
	    var rest = this.slice((to || from) + 1 || this.length);
	    this.length = from < 0 ? this.length + from : from;
	    return this.push.apply(this, rest);
	};
	Array.prototype.insert = function (index, item) {
	    this.splice(index, 0, item);
	};
	Array.max = function (array) {
	    var max = Number.MIN_VALUE;
	    for (var i = array.length; i >= 0; i--)
	        if (array[i] > max)
	            max = array[i];
	    return max;
	};
	*/
	var memset = exports.memset = function memset(arr, offset, length, value) {
	    for (var i = 0; i < length; i++) {
	        arr[offset++] = value;
	    }
	};
	var halfLength = exports.halfLength = function halfLength(arr) {
	    return parseInt(arr.length / 2);
	};

	//-------------------------------------------------------------------------------------------------

	function trimWhitespace(stringToTrim) {
	    return stringToTrim.replace(/^\s+|\s+$/g, '');
	}

	//-------------------------------------------------------------------------------------------------
	//    circBuffer - This object creates and updates a circular buffer of the specified length
	//                for numeric values and maintains the sum and average value of the buffer.
	//                Note that the average value will be skewed low until the buffer has been filled.
	//    Note that numerical values are assumed to be in the buffer.
	function circBuffer(length) {

	    var pointer = 0,
	        buffer = new Array(length);
	    var sum = 0;
	    for (var i = 0; i < length; i++) {
	        buffer[i] = 0;
	    }
	    return {
	        get: function get(key) {
	            return buffer[key];
	        },
	        push: function push(item) {
	            var nextPtr = (length + pointer + 1) % length;
	            sum -= buffer[nextPtr];
	            sum += item;
	            buffer[pointer] = item;
	            pointer = nextPtr;
	        },
	        getSum: function getSum() {
	            return sum;
	        },
	        getLength: function getLength() {
	            return length;
	        },
	        getAvg: function getAvg() {
	            return sum / length;
	        },
	        getAvgInt: function getAvgInt() {
	            return parseInt(sum / length);
	        },
	        toString: function toString() {
	            for (var rtnStr = buffer[0], i = 1; i < length; i++) {
	                rtnStr += ', ' + buffer[i];
	            }return rtnStr;
	        },
	        reset: function reset() {
	            pointer = 0;
	            sum = 0;
	            for (var i = 0; i < length; i++) {
	                buffer[i] = 0;
	            }
	        }
	    };
	}

	//-------------------------------------------------------------------------------------------------
	// getIndexWith -  in an array of json objects, find index where array[idx][key] == value
	function getIndexWith(array, key, value) {
	    if (array == undefined) return -1;
	    for (var i = 0, len = array.length; i < len; i++) {
	        if (array[i] && array[i][key] == value) return i;
	    }
	    return -1;
	}

	//-------------------------------------------------------------------------------------------------
	// toStringAssoc - This function converts an assoicative array to a string.
	function toStringAssoc(assocArray, opt_delimiter, opt_dontReport) {
	    var str = '';
	    var delimiter = opt_delimiter == undefined ? ', ' : opt_delimiter + ' ';

	    for (var key in assocArray) {
	        if (assocArray.hasOwnProperty(key)) {
	            if (opt_dontReport && opt_dontReport[key] != undefined) continue;
	            if (str.length != 0) str += delimiter;
	            str += key + ': ' + assocArray[key];
	        }
	    }
	    return str;
	}

	function assocArrayLength(assocArray) {
	    ////in test //// works for Chrome,  ...
	    return Object.keys(assocArray).length;
	}

	//-------------------------------------------------------------------------------------------------
	//    cloneObject: This function copies or clones javascript array / object
	//        use like this:
	//            var obj1 = { bla: 'blabla', foo: 'foofoo', etc: 'etc' };
	//            var obj2 = new cloneObject(obj1);
	//    http://www.hardcode.nl/subcategory_1/article_414-copy-or-clone-javascript-array-object
	//
	function cloneObject(source) {
	    var i;
	    for (i in source) {
	        if (typeof source[i] == 'source') {
	            this[i] = new cloneObject(source[i]);
	        } else {
	            this[i] = source[i];
	        }
	    }
	}

	//-------------------------------------------------------------------------------------------------
	// lenAssoc - This function returns the length of an assoicative array;
	var lenAssoc = function lenAssoc(assocArray) {
	    var key,
	        len = 0;
	    for (key in assocArray) {
	        len += Number(assocArray.hasOwnProperty(key));
	    }
	    return len;
	};

	// TODO: It's worth noting that jQuery has something called this...
	function isEmptyObject(obj) {
	    return lenAssoc(obj) == 0 ? true : false;
	}

	//-------------------------------------------------------------------------------------------------
	// note - replace with jQuery.isNumeric()  ??
	function isNumber(n) {
	    return !isNaN(parseFloat(n)) && isFinite(n);
	}

	// left in for compatibility with leg
	var isUnDefined = exports.isUnDefined = _.isUndefined;

	function isDefined(variable) {
	    return variable !== undefined;
	}

	//-------------------------------------------------------------------------------------------------
	// stripLeadingAtSign - This function returns the passed imageId without a leading '@' sign
	function stripLeadingAtSign(imageId) {
	    return imageId.indexOf('@') == 0 ? imageId.substr(1) : imageId;
	}

	//-------------------------------------------------------------------------------------------------
	// isValidArrayIndex - This function reports if the index into the array is valid
	function isValidArrayIndex(array, idx) {
	    return idx < 0 || isUnDefined(array[idx]) ? false : true;
	}

	//-------------------------------------------------------------------------------------------------
	//    hexColortoRGB -  This function converts a hex color value (e.g. "#FFFFFF") to decimal RGB
	function hexColortoRGB(hexColor) {
	    var rtnColor = hexColor;
	    if (typeof hexColor == 'string' && hexColor.indexOf('#') === 0) rtnColor = parseInt(hexColor.substr(1), 16);
	    return rtnColor;
	}

	//-------------------------------------------------------------------------------------------------
	//    toHexColor -  This function converts a decimal RGB value to hex
	function toHexColor(decRGB) {
	    var blue = decRGB & 0xFF;
	    blue = blue.toString(16);
	    if (blue.length < 2) blue = '0' + blue;

	    var green = decRGB >> 8 & 0xFF;
	    green = green.toString(16);
	    if (green.length < 2) green = '0' + green;

	    var red = decRGB >> 16 & 0xFF;
	    red = red.toString(16);
	    if (red.length < 2) red = '0' + red;

	    return red + green + blue;
	}

	//-------------------------------------------------------------------------------------------------
	//    reverseCLR - This function returns a decimal BGR ordered color from a decimal RGB ordered color
	//                or visa versa!
	function reverseCLR(decRGB) {
	    var blue = decRGB & 0xFF;
	    var green = decRGB >> 8 & 0xFF;
	    var red = decRGB >> 16 & 0xFF;

	    var bgr = (blue << 16) + (green << 8) + red;
	    return bgr;
	}

	//-------------------------------------------------------------------------------------------------
	//    deSaturate -
	//cp-this isn't really desaturating the color ... rename me?
	function deSaturate(decRGB) {
	    var blue = decRGB & 0xFF;
	    blue = Math.round(blue / 2);
	    blue = blue.toString(16);
	    if (blue.length < 2) blue = '0' + blue;

	    var green = decRGB >> 8 & 0xFF;
	    green = Math.round(green / 2);
	    green = green.toString(16);
	    if (green.length < 2) green = '0' + green;

	    var red = decRGB >> 16 & 0xFF;
	    red = Math.round(red / 2);
	    red = red.toString(16);
	    if (red.length < 2) red = '0' + red;

	    return red + green + blue;
	}

	//-------------------------------------------------------------------------------------------------
	// isLightColor - This function returns true if the input color is light, otherwise it returns false.
	//        Input 'color' can be in decimal form or hex ('#RRGGBB').
	//        Determines brightness of color by converting to the Y component of YUV, which is brightness.
	function isLightColor(color) {
	    color = hexColortoRGB(color); // if input is hex format, convert it
	    var blue = color & 0xFF;
	    var green = color >> 8 & 0xFF;
	    var red = color >> 16 & 0xFF;
	    //    don't need U and V, but fyi, they are:      U = 0.436 * (blue - Y) / (1 / 0.114);  V = 0.615 * (red - Y) / (1 / 0.299);
	    var Y = parseInt(red * 0.299 + green * 0.587 + blue * 0.114);
	    return Y > 139 ? true : false;
	}

	//-------------------------------------------------------------------------------------------------
	// roundto - This function rounds a float value to the nearest decplace //cp-who about toFixed(decplace)??
	function roundto(value, decplace) {
	    return Math.round(value * decplace) / decplace;
	}

	//-------------------------------------------------------------------------------------------------
	// limitValue - This function returns the value if it is inclusively within the min/max Value boundaries;
	//                returns the minValue if it is less than the minValue;
	//                returns the maxValue if it is greater than the maxValue;
	function limitValue(value, minValue, maxValue) {
	    return Math.min(Math.max(minValue, value), maxValue);
	}

	//-------------------------------------------------------------------------------------------------
	//    getClassList - This function returns an array of the classes associated with the passed element
	//                    or undefined if the element had no class.
	function getClassList(element) {
	    if (element.getAttribute) {
	        var sClassList = element.getAttribute('class');
	        if (sClassList == undefined) sClassList = element.getAttribute('className'); // ie7
	    }
	    //dbg-only if (us.DBGMOUSEEVENTS && isDefined(sClassList)) consoleWrite("getClassList: " + sClassList);

	    if (isDefined(sClassList)) return sClassList.split(' ');

	    //dbg-only if (us.DBGMOUSEEVENTS) consoleWrite("getClassList: " + element.toString() + " has no class!");
	    return undefined;
	}

	//-------------------------------------------------------------------------------------------------
	// arrayNDcreate - This function creates an n dimensional array.
	//     taken from http://stackoverflow.com/questions/966225/how-to-create-a-two-dimensional-array-in-javascript
	//    example: arrayNDCreate(2,4) creates a 2D array of dims 2x4
	function arrayNDCreate(length) {
	    var a = new Array(length || 0);
	    if (a.dims == undefined) {
	        a.dims = new Array(arguments.length);
	        for (var i = 0; i < arguments.length; i++) {
	            a.dims[i] = arguments[i];
	        }
	    }

	    if (arguments.length > 1) {
	        var args = Array.prototype.slice.call(arguments, 1);
	        for (var i = 0; i < length; i++) {
	            a[i] = arrayNDCreate.apply(this, args);
	        }
	    }
	    return a;
	}

	//-------------------------------------------------------------------------------------------------
	// array2DCreate - This function wraps arrayNDCreate and adds the width and height properties to the array.
	function array2DCreate(width, height) {
	    var a = arrayNDCreate(width, height);

	    a.width = a.dims[0];
	    a.height = a.dims[1];
	    return a;
	}

	//-------------------------------------------------------------------------------------------------
	//    toPortable - This function converts a string to a portable string.
	// TODO: Define what a "portable" string is...
	function toPortable(str) {
	    return str.replace(/[\"]/g, '\\"').replace(/[\\]/g, '\\\\').replace(/[\/]/g, '\\/').replace(/[\b]/g, '\\b').replace(/[\f]/g, '\\f').replace(/[\n]/g, '\\n').replace(/[\r]/g, '\\r').replace(/[\t]/g, '\\t');
	}

	//    fromPortable - This function converts a portable string to a string.
	function fromPortable(str) {
	    return str.replace(/\\"n/g, '\"').replace(/\\\\/g, '\\').replace(/\\b/g, '\b').replace(/\\f/g, '\f').replace(/\\n/g, '\n').replace(/\\r/g, '\r').replace(/\\t/g, '\t');
	}

	//-------------------------------------------------------------------------------------------------
	//    divRotate - This function rotates a div about its center and returns a rect of its position offset.
	//
	//    Depends upon:
	//        cRect object
	//
	//    Note that the DIV position must be absolute or relative
	//    Reference: http://stackoverflow.com/questions/2449668/how-to-rotate-a-div-html-layer
	//
	function divRotate(divObj, divLeft, divTop, divWidth, divHeight, angleRad) {
	    //debug-only consoleWrite("divRotate: newAngleDeg: " + Math.round(angleRad*us.Rad2Deg) + "  LT: " + divLeft + "," + divTop + "  WxH: " + divWidth + "x" + divHeight);
	    var isNotIE = window.navigator.userAgent.indexOf('MSIE ') <= 0 || typeof document.documentElement.style.opacity != 'undefined';
	    var radAngle = angleRad;
	    var spinAngle = radAngle;

	    if (window.navigator.userAgent.indexOf('MSIE ') <= 0 || typeof document.documentElement.style.opacity != 'undefined') radAngle = -radAngle;

	    var sinAngle = parseFloat(parseFloat(Math.sin(radAngle)).toFixed(8));
	    var cosAngle = parseFloat(parseFloat(Math.cos(radAngle)).toFixed(8));

	    var m11 = cosAngle;
	    var m12 = -sinAngle;
	    var m21 = sinAngle;
	    var m22 = cosAngle;

	    if (isNotIE == true) {
	        divObj.style.WebkitTransform = 'matrix(' + m11 + ',' + m12 + ',' + m21 + ',' + m22 + ',' + 0 + ',' + 0 + ')';
	        divObj.style.MozTransform = 'matrix(' + m11 + ',' + m12 + ',' + m21 + ',' + m22 + ',' + 0 + 'px,' + 0 + 'px)';
	        divObj.style.msTransform = 'matrix(' + m11 + ',' + m12 + ',' + m21 + ',' + m22 + ',' + 0 + ',' + 0 + ')';
	        divObj.style.OTransform = 'matrix(' + m11 + ',' + m12 + ',' + m21 + ',' + m22 + ',' + 0 + ',' + 0 + ')';
	        divObj.style.transform = 'matrix(' + m11 + ',' + m12 + ',' + m21 + ',' + m22 + ',' + 0 + ',' + 0 + ')';

	        divObj.style.top = divTop + 'px';
	        divObj.style.left = divLeft + 'px';
	    }
	    var sinSpinAngle = -parseFloat(parseFloat(Math.sin(-spinAngle)).toFixed(8));
	    var cosSpinAngle = parseFloat(parseFloat(Math.cos(-spinAngle)).toFixed(8));
	    var sinAnglePerp = parseFloat(parseFloat(Math.sin(radAngle - Math.PI)).toFixed(8));
	    var cosAnglePerp = parseFloat(parseFloat(Math.cos(radAngle - Math.PI)).toFixed(8));
	    var halfHeight = divHeight / 2;
	    var halfWidth = divWidth / 2;
	    var radius = Math.sqrt(halfHeight * halfHeight + halfWidth * halfWidth);

	    var ulx = divLeft + halfWidth - radius * cosSpinAngle + sinAnglePerp * halfHeight;
	    var uly = divTop + halfHeight - radius * sinSpinAngle + cosAnglePerp * halfHeight;

	    var urx = radius * cosSpinAngle + divLeft + halfWidth + sinAnglePerp * halfHeight;
	    var ury = radius * sinSpinAngle + divTop + halfHeight + cosAnglePerp * halfHeight;

	    var lrx = radius * cosSpinAngle + divLeft + halfWidth - sinAnglePerp * halfHeight;
	    var lry = radius * sinSpinAngle + divTop + halfHeight - cosAnglePerp * halfHeight;

	    var llx = divLeft + halfWidth - radius * cosSpinAngle - sinAnglePerp * halfHeight;
	    var lly = divTop + halfHeight - radius * sinSpinAngle - cosAnglePerp * halfHeight;

	    if (isNotIE == false) divObj.style.filter = 'filter: progid:DXImageTransform.Microsoft.Matrix( M11=' + m11 + ', M12=' + m12 + ', M21=' + m21 + ', M22=' + m22 + ', sizingMethod=\'auto expand\' );';

	    var spinTop = Math.min(uly, ury, lry, lly);
	    var spinRight = Math.max(ulx, urx, lrx, llx);
	    var spinBottom = Math.max(uly, ury, lry, lly);
	    var spinLeft = Math.min(ulx, urx, lrx, llx);

	    if (isNotIE == false) {
	        divObj.style.top = spinTop + 'px';
	        divObj.style.right = spinRight + 'px';
	        divObj.style.bottom = spinBottom + 'px';
	        divObj.style.left = spinLeft + 'px';
	    }
	    var crBox = new _objects.cRect(spinLeft.toFixed(2), spinTop.toFixed(2), (spinRight - spinLeft).toFixed(2), (spinBottom - spinTop).toFixed(2));
	    ///if (divWidth > 1000) consoleWrite("                 divRotate: : LT:" + spinLeft.toFixed(1) + "," + spinTop.toFixed(1) + " RB: " + spinRight.toFixed(1) + "," + spinBottom.toFixed(1) + "  dims: " + (spinRight - spinLeft).toFixed(1) + " x " + (spinBottom - spinTop).toFixed(1));
	    ///    consoleWrite("divRotate: " + crBox.toString());
	    return crBox;
	}

	//-------------------------------------------------------------------------------------------------
	//
	function computeRotationOffset(divW, divH, angleRad) {
	    var cpRtn = new _objects.cPoint(0, 0); // return point object
	    if (angleRad != 0) {
	        if (angleRad > Math.PI) angleRad = angleRad - Math.PI;

	        var xc = divW / 2,
	            yc = divH / 2;

	        // compute y offset.....................................
	        var x = 0,
	            y = 0; // use top left corner
	        var dx = angleRad <= Math.PI / 2 ? x - xc : xc - x;
	        var dy = yc - y;
	        var hypot = Math.sqrt(dx * dx + dy * dy);

	        var thetaRad = Math.atan2(dy, dx);
	        var phiRad = thetaRad - angleRad;
	        cpRtn.y = hypot * Math.sin(phiRad);

	        var yi = yc - cpRtn.y;
	        cpRtn.y = Math.round(yi);
	        if (cpRtn.y >= divH) cpRtn.y = divH - cpRtn.y;

	        // compute x offset.....................................
	        x = 0, y = divH; // use bottom left corner
	        var dx = angleRad <= Math.PI / 2 ? x - xc : xc - x;
	        dy = yc - y;
	        hypot = Math.sqrt(dx * dx + dy * dy);

	        var thetaRad = Math.atan2(dy, dx);
	        var phiRad = thetaRad - angleRad;
	        cpRtn.x = hypot * Math.cos(phiRad);

	        var xi = cpRtn.x + xc;
	        cpRtn.x = Math.round(xi);
	        if (cpRtn.x >= divW) cpRtn.x = divW - cpRtn.x;
	    }
	    return cpRtn;
	}

	////-------------------------------------------------------------------------------------------------
	//// http://whattheheadsaid.com/2010/10/a-safer-object-keys-compatibility-implementation
	//    Added to avoid compatibility issues with IE10 of all things.
	//Object.keys = Object.keys || (function () {
	_defines2.default.objectKeys = function () {
	    var hasOwnProperty = Object.prototype.hasOwnProperty,
	        hasDontEnumBug = !{ toString: null }.propertyIsEnumerable('toString'),
	        DontEnums = ['toString', 'toLocaleString', 'valueOf', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'constructor'],
	        DontEnumsLength = DontEnums.length;

	    return function (o) {
	        if ((typeof o === 'undefined' ? 'undefined' : _typeof(o)) != 'object' && typeof o != 'function' || o === null) throw new TypeError('Object.keys called on a non-object');

	        var result = [];
	        for (var name in o) {
	            if (hasOwnProperty.call(o, name)) result.push(name);
	        }

	        if (hasDontEnumBug) {
	            for (var i = 0; i < DontEnumsLength; i++) {
	                if (hasOwnProperty.call(o, DontEnums[i])) result.push(DontEnums[i]);
	            }
	        }
	        //debug-only consoleWrite(result);
	        return result;
	    };
	}();

/***/ },
/* 9 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	exports.isUndefined = isUndefined;
	// This just contains helper functions that emulate the lodash API. Once the third-party lib weight shrinks
	// this will melt away, so the API should be consistent with the most recent version of lodash.

	var genTag = '[object GeneratorFunction]';
	var funcTag = '[object Function]';
	var objectToString = Object.prototype.toString;

	/**
	 * Checks if `value` is `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	 */
	function isUndefined(value) {
	    return value === undefined;
	}

	/**
	 * Checks if value is the language type of Object. (e.g. arrays, functions, objects, regexes, new Number(0), and new String(''))
	 * @param value - object to test
	 * @returns {boolean}
	 */
	var isObject = exports.isObject = function isObject(value) {
	    // Avoid a V8 JIT bug in Chrome 19-20.
	    // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	    var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	    return !!value && (type == 'object' || type == 'function');
	};

	/**
	 * Checks if value is a function
	 * @param value - object to test
	 * @returns {boolean}
	 */
	var isFunction = exports.isFunction = function isFunction(value) {
	    // The use of `Object#toString` avoids issues with the `typeof` operator
	    // in Safari 8 which returns 'object' for typed array constructors, and
	    // PhantomJS 1.9 which returns 'function' for `NodeList` instances.
	    var tag = isObject(value) ? objectToString.call(value) : '';
	    return tag == funcTag || tag == genTag;
	};

	/**
	 * like [].forEach but works on objects as well. On objects will loop through all inherited members as well
	 * @param object - source object or array
	 * @param iteratee - function to be called on each iteration
	 */
	var forEach = exports.forEach = function forEach(object, iteratee) {
	    for (var item in object) {
	        iteratee(object[item], item);
	    }
	};

	/**
	 * Iterates over own enumerable properties of an object invoking iteratee for each property. The iteratee is invoked with three arguments: (value, key, object). Iteratee functions may exit iteration early by explicitly returning false.
	 * @param {Object} object - The object to iterate over
	 * @param {Function} iteratee - The function invoked per iteration
	 */
	var forOwn = exports.forOwn = function forOwn(object, iteratee) {
	    for (var item in object) {
	        if (object.hasOwnProperty(item)) {
	            iteratee(object[item], item);
	        }
	    }
	};

	/**
	 * Assigns own enumerable properties of source objects to the destination object. Source objects are applied from left to right. Subsequent sources overwrite property assignments of previous sources.
	 * @param {Object} object - The destination object
	 * @param {Object} [sources] The source objects
	 * @returns {Object} returns object
	 */
	var assign = exports.assign = function assign(object) {
	    for (var _len = arguments.length, sources = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        sources[_key - 1] = arguments[_key];
	    }

	    forEach(sources, function (arg) {
	        forOwn(arg, function (prop, name) {
	            object[name] = prop;
	        });
	    });
	    return object;
	};

	/**
	 * Creates a shallow clone of value.
	 * @param value - the value to clone
	 */
	var clone = exports.clone = function clone(value) {
	    return assign({}, value);
	};

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.triggerUScopeEvent = triggerUScopeEvent;
	exports.triggerImageNavigated = triggerImageNavigated;

	var _defines = __webpack_require__(3);

	var _defines2 = _interopRequireDefault(_defines);

	var _uScope = __webpack_require__(11);

	var _uScope2 = _interopRequireDefault(_uScope);

	var _publicApi = __webpack_require__(18);

	var _publicApi2 = _interopRequireDefault(_publicApi);

	var _objects = __webpack_require__(7);

	var _navigation = __webpack_require__(24);

	var _annotdraw = __webpack_require__(27);

	var _helpers = __webpack_require__(8);

	var _toolbar = __webpack_require__(5);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	//________________________________________________________________________________________________
	// events.js
	// This file contains event handlers for uScope including user events, developement events, and keystroke events.
	//
	//
	//    history
	//    1106    cperz        created
	//
	//    _______________________________________end_AIHv1/PR __________________________________________
	//    141118    cperz        added annotation hot keys control v, control c and control m
	//    150728  cboarman    added Gecko (FF) keycodes for plus/minus keys
	//________________________________________________________________________________________________
	$(document).ready(function () {
	    //............................................ iOS touch events
	    // mouse down, click work in iOS on overlay elements
	    document.ontouchstart = function (e) {
	        if (!_uScope2.default.instance.isThisImageValid()) return; // if opened with no image, do not respond
	        var thisImg = _uScope2.default.instance.getThisImage();
	        //dbg-only document.title = "ontouchstart: navMode: " + thisImg.navModeGet();
	        if (thisImg.navModeGet() != _defines2.default.eNavModes.nmNone) return;

	        var overObj = String(document.elementFromPoint(e.pageX, e.pageY).className);
	        //dbg-only document.title = overObj;
	        if (_defines2.default.DBGIOS || _defines2.default.DBGSWIPE || _defines2.default.DBGPINCH) (0, _toolbar.consoleWrite)('START: touches:' + e.touches.length + ', overObj:' + overObj + ', target:' + e.target + ', sClassList:' + (0, _helpers.getClassList)(e.target) + '  mode:' + thisImg.navModeGet());

	        // instead of viewport the raphael paper object is the target
	        // but sometimes the annot div is hidden the tile itself is touched
	        if (overObj.indexOf('SVGAnimatedString') != -1 || overObj.indexOf('us_tile') != -1) {
	            e.preventDefault();
	            (0, _navigation.vp_mousedown)(thisImg, e, _defines2.default.TOUCHEVENT);
	            return false;
	        }
	        // for reasons unknown, the edgediv overlay and the top toolbar overlay do not get bubbled click or mousedown events
	        // so capture the event here and start autopan
	        else if (overObj.indexOf(_defines2.default.clsEDGEDIV) != -1 || String(document.elementFromPoint(e.pageX, e.pageY).id) == _defines2.default.idTOPTOOLBARV) {
	                thisImg.autoPan.onOffToggle();
	                //    vpAutoPan(thisImg);
	                return false;
	            }
	        return true; // permit bubbling of event to thumbnail, dialogs, etc.
	    };
	    document.ontouchmove = function (e) {
	        var elem = document.elementFromPoint(e.pageX, e.pageY);
	        if ($(elem).closest(_defines2.default.idHashROOT).length == 0) {
	            // touch is not in uScope, ignore it
	            return true;
	        }
	        if (!_uScope2.default.instance.isThisImageValid()) return;
	        var thisImg = _uScope2.default.instance.getThisImage();

	        e.preventDefault();
	        (0, _navigation.vp_mousemove)(thisImg, e, _defines2.default.TOUCHEVENT);
	        return false;
	    };
	    document.ontouchend = function (e) {
	        // iOS equivalent to mouse up
	        if (!_uScope2.default.instance.isThisImageValid()) return;
	        var thisImg = _uScope2.default.instance.getThisImage();

	        if (thisImg.navModeGet() == _defines2.default.eNavModes.nmDragImage) {
	            // if dragging the image which starts with one touch, check if a double click occurred
	            e.preventDefault();
	            var now = new Date().getTime(); // double click event check
	            var lastTouch = $(this).attr('lastTouch') || now + 1;
	            //amnvar lastTouch = $(this).data('lastTouch') || now + 1;
	            var delta = now - lastTouch;
	            if (delta < 300 && delta > 0) {
	                // if the second touchend event happened within a certain dtime, it's a double click
	                _defines2.default.navModeSwitch(thisImg, _defines2.default.eNavModes.nmNone); // set nav mode back to none
	                (0, _navigation.vp_mousedclick)(thisImg, e, _defines2.default.TOUCHEVENT);
	                return false;
	            }
	            //amn$(this).data('lastTouch', now);             // save the time of the last touch
	            $(this).attr('lastTouch', now); // save the time of the last touch
	        }

	        // for reasons unknown, the edgediv overlay and the top toolbar overlay do not get bubbled click or mousedown events
	        // so capture the event here and stop autopan
	        else if (thisImg.navModeGet() == _defines2.default.eNavModes.nmAutoPan) {
	                thisImg.autoPan.onOffToggle();
	                return false;
	            }
	        //
	        if (thisImg.navModeGet() == _defines2.default.eNavModes.nmDragImage || thisImg.navModeGet() == _defines2.default.eNavModes.nmPinchZoom) {
	            if (_defines2.default.DBGIOS || _defines2.default.DBGSWIPE || _defines2.default.DBGPINCH) (0, _toolbar.consoleWrite)(' ontouchend: Stopping SWIPE-PAN or PINCH-ZOOM mode: ' + thisImg.navModeGet());
	            (0, _navigation.vp_mouseup)(thisImg, e, _defines2.default.TOUCHEVENT); //
	            e.preventDefault();
	            return false;
	        } else {
	            if (_defines2.default.DBGIOS) (0, _toolbar.consoleWrite)('STOP: touches:' + e.touches.length + ', target:' + e.target + ', sClassList:' + (0, _helpers.getClassList)(e.target) + '  mode:' + thisImg.navModeGet());
	        }
	        return true; // permit bubbling of event to thumbnail, dialogs, etc.
	    };

	    //............................................ debug events
	    if (_defines2.default.DBGEVENTS) {
	        $(_defines2.default.idHashROOT).on(_defines2.default.evIMAGEREADY, function (e, parms) {
	            (0, _toolbar.consoleWrite)('...... event: ' + _defines2.default.evIMAGEREADY + '  imageId: ' + parms.imageId + '  status: ' + parms.status);
	        });
	        $(_defines2.default.idHashROOT).on(_defines2.default.evIMAGECLOSE, function (e, parms) {
	            (0, _toolbar.consoleWrite)('...... event: ' + _defines2.default.evIMAGECLOSE + '  imageId: ' + parms.imageId);
	            if (_uScope2.default.instance.isModeDev() == true) {
	                var imageSet = { 'images': [{ 'imagePath': parms.imageId }] };
	                _uScope2.default.instance.imageUpdate('remove', imageSet.images);
	            }
	        });
	        $(_defines2.default.idHashROOT).on(_defines2.default.evAJAXERROR, function (e, parms) {
	            (0, _toolbar.consoleWrite)('...... event: ' + _defines2.default.evAJAXERROR + '  imageId: ' + parms.imageId + '  request: ' + parms.request + '  status: ' + parms.jqXHR.status);
	        });
	        $(_defines2.default.idHashROOT).on(_defines2.default.evIMAGENAVIGATED, function (e, parms) {
	            (0, _toolbar.consoleWrite)('...... event: ' + _defines2.default.evIMAGENAVIGATED + '  imageId: ' + parms.imageId + '  status: ' + parms.status);
	        });
	        $(_defines2.default.idHashROOT).on(_defines2.default.evANNOTCHANGE, function (e, parms) {
	            (0, _toolbar.consoleWrite)('...... event: ' + _defines2.default.evANNOTCHANGE + '  imageId: ' + parms.imageId + ' regionId:  ' + parms.regionId + ' anShape:  ' + parms.anShape + ' action: ' + parms.action);
	        });
	        $(_defines2.default.idHashROOT).on(_defines2.default.evIMAGESCOPEOPEN, function (e, parms) {
	            (0, _toolbar.consoleWrite)('...... event: ' + _defines2.default.evIMAGESCOPEOPEN + '  imageId: ' + parms.imageId);
	        });
	        $(_defines2.default.idHashROOT).on(_defines2.default.evSNAPSHOT, function (e, parms) {
	            (0, _toolbar.consoleWrite)('...... event: ' + _defines2.default.evSNAPSHOT + '  imageId: ' + parms.imageId + '   regionId: ' + parms.regionId);
	        });
	        ///////// used when DST was not yet listening for these event
	        //        $(us.idHashROOT).on(us.evOPENNEXTSLIDE, function (e, parms) {
	        //            consoleWrite("...... event: " + us.evOPENNEXTSLIDE + "  " + toStringAssoc(parms, " "));

	        //            if (UScopeViewer.instance.isModeDev() == true) {
	        //                var thisImg = UScopeViewer.instance.getThisImage();
	        //                var num = parseInt(stripLeadingAtSign(thisImg.getImageId())) + 1; // imageId of selected image + 1
	        //                imageId = '@' + num;

	        //                if (thisImg.getToken()) {            // replace selected imageId with this new one
	        //                    var fullURL = thisImg.getFullURL();
	        //                    var newURL = fullURL.slice(0, fullURL.lastIndexOf("@")) + imageId;
	        //                    var imgSettings = { "image": { "imagePath": imageId, "fullURL": newURL, "mag": "Scan"} };
	        //                }
	        //                else {
	        //                    var imgSettings = { "image": { "imagePath": imageId, "mag": "Scan"} };
	        //                }
	        //                uScopeOpen(imgSettings); // todo: use uScopeImageUpdate
	        //            }
	        //        });

	        //        $(us.idHashROOT).on(us.evOPENPREVSLIDE, function (e, parms) {
	        //            consoleWrite("...... event: " + us.evOPENPREVSLIDE + "  " + toStringAssoc(parms, " "));
	        //            if (UScopeViewer.instance.isModeDev() == true) {
	        //                var thisImg = UScopeViewer.instance.getThisImage();
	        //                var num = parseInt(stripLeadingAtSign(thisImg.getImageId())) - 1; // imageId of selected image - 1
	        //                if (num > 0) {
	        //                    imageId = '@' + num;

	        //                    if (thisImg.getToken()) {            // replace selected imageId with this new one
	        //                        var fullURL = thisImg.getFullURL();
	        //                        var newURL = fullURL.slice(0, fullURL.lastIndexOf("@")) + imageId;
	        //                        var imgSettings = { "image": { "imagePath": imageId, "fullURL": newURL, "mag": "Scan"} };
	        //                    }
	        //                    else {
	        //                        var imgSettings = { "image": { "imagePath": imageId, "mag": "Scan"} };
	        //                    }
	        //                    uScopeOpen(imgSettings); // todo: use uScopeImageUpdate
	        //                }
	        //            }
	        //        });
	    }
	}); // doc ready

	//-------------------------------------------------------------------------------------------------
	//    Hot Keys
	//-------------------------------------------------------------------------------------------------
	//Note that keydown and keyup provide a code indicating which key is pressed,
	//while keypress indicates which character was entered. For example, a lowercase "a"
	//will be reported as 65 by keydown and keyup, but as 97 by keypress. An uppercase "A"
	//is reported as 65 by all events. Because of this distinction, when catching special
	//keystrokes such as arrow keys, .keydown() or .keyup() is a better choice.
	//keycodes can be found at: http://www.webonweboff.com/tips/js/event_key_codes.aspx
	//    or http://unixpapa.com/js/key.html
	//
	//____________________________________________________________________________________________
	// Delivered keys
	// Design note: if you add a key, update the informations on the hotkeys tab for the user
	//____________________________________________________________________________________________
	// arrow key navigation:    Move the image in view up,down,left,right 1/4 of the view width,height.
	//                            If the shift key is down, Move the image in view up,down,
	//                            left,right 3/4 of the view width,height.
	// control - navigation:    zoom out
	// control + navigation:    zoom in
	//
	// delete:                    delete selected annotation
	// control c:                copy selected region
	// control v:                paste copied/selected region
	//
	// r:                        rotate cw +15 degrees
	// shift r:                    rotate cw +1 degrees
	// control r:                rotate ccw +15 degrees
	// control shift r:            rotate ccw +1 degrees
	// 0, num0:                    set rotation to 0 degrees
	//
	//    q, shift+Q                previous slide
	//    e, shift+E                next slide
	//
	// spacebar
	//____________________________________________________________________________________________
	//
	// inserted for development: only operational when us.ENABLEDEVHOTKEYS === true
	//____________________________________________________________________________________________
	//    a :
	//    c :
	//  d :
	//    e :
	//    g :                        uScopeGoToRegion unit test
	//  i :
	//  j :
	//    l :                        simlulate lockdown mode call
	//  m :
	//  n :
	//  o :                        open random image with uScopeopenImage (closes current image)
	//  p :                        open random image with public function uScopeOpen() - closes current image)
	//    r :                        create an report region layer, shift+r deletes the report region layer
	//    v :                        call viewRefresh
	//    w :
	//    x :                        close image
	//  z :                        zoom out
	//  shift z:                zoom in
	//____________________________________________________________________________________________
	var keyCodes = { // keycodes used (Note: FF has different keycodes for plus/minus keys [ref: http://unixpapa.com/js/key.html])
	    shift: 16, control: 17, alt: 18,
	    spacebar: 32,
	    arrowLeft: 37, arrowUp: 38, arrowRight: 39, arrowDown: 40,
	    zero: 48, one: 49, two: 50, three: 51, four: 52, five: 53, six: 54, seven: 55, eight: 56, nine: 57,
	    num0: 96, num1: 97, num2: 98, num3: 99, num4: 100, num5: 101, num6: 102, num7: 103, num8: 105, num9: 107,

	    numLock4: 100, numLock5: 105,
	    numPlus: 107, numMinus: 109, CapsLock: 20, deleteKey: 46,
	    a: 65, b: 66, c: 67, d: 68, e: 69, f: 70, g: 71, h: 72, i: 73, j: 74, k: 75, l: 76, m: 77, n: 78, o: 79,
	    p: 80, q: 81, r: 82, s: 83, t: 84, u: 85, v: 86, w: 87, x: 88, y: 89, z: 90,
	    F1: 112, F2: 113, F3: 114, F4: 115, F5: 116, F6: 117, F7: 118, F8: 119, F9: 120, F10: 121, F11: 122, F12: 123, // function keys
	    minus: 189, plus: 187, FF_minus: 173, FF_plus: 61
	};

	_defines2.default.events = {};
	_defines2.default.events.vpKeyEvent = function (e, thisImg) {
	    // don't bother handling if no image is selected
	    // processing keyup and keydown would cause double actions; only handle keydown
	    if (!thisImg || e.type !== 'keydown') {
	        return;
	    }

	    if (_defines2.default.DBGEVENTS) {
	        thisImg.log('vpKeyEvent (' + thisImg.getImageId() + ')  keycode: ' + keyCode + ' ' + String.fromCharCode(keyCode) + '  type: ' + e.type);
	    }

	    // Track if we've handled the event so we can intelligently prevent event propagation.
	    var eventIsHandled = true;

	    // Note that key events on special keys like control are not reported as e.ctrlKey
	    // so I use 'which' to normalizes keycodes between browsers.
	    // Note: jQuery normalizes the property name to 'which', but not the value of the property, which can vary between browsers for some keys
	    // http://stackoverflow.com/questions/18177818/why-jquerys-event-which-gives-different-results-in-firefox-and-chrome
	    var keyCode = e.which;

	    //............................................................... delivered hot keys
	    switch (keyCode) {
	        case keyCodes.spacebar:
	            // spacebar is used for rasterScan
	            triggerUScopeEvent(_defines2.default.evSPACEBAR, {});
	            break;

	        //............................................ panning
	        //.......... xy position moves
	        case keyCodes.arrowUp:
	        case keyCodes.arrowDown:
	            var zoom = thisImg.getViewZoom();
	            var overlapHigh = 0.25; // proportion of view width or height to move
	            var overlapLow = 0.75; // proportion of view width or height to move
	            var dx = 0;
	            var dy = e.shiftKey ? thisImg.getViewHeight() * overlapLow : thisImg.getViewHeight() * overlapHigh;
	            dy = dy / thisImg.getViewZoom();

	            // only when dev hot key is enabled b/c slide tray uses control + arrow
	            // if control key is pressed, add -x direction; else if alt key is pressed, add +x direction
	            if (_defines2.default.ENABLEDEVHOTKEYS == true) {
	                if (e.ctrlKey) dx = dy; // north or south west move
	                else if (e.altKey) dx = -dy; // north or south east move
	            }
	            if (e.keyCode == keyCodes.arrowUp) dy = -dy;

	            var rotXY = _defines2.default.coordUnRotToRot(dx, dy, thisImg);
	            thisImg.moveRelative(rotXY.x, rotXY.y, _defines2.default.coordSystemNORM);
	            //debug-only    thisImg.log("arrow: " + dx + "," + dy + "  rot: " + rotXY.toString());
	            break;
	        case keyCodes.arrowLeft:
	        case keyCodes.arrowRight:
	            var overlapHigh = 0.25; // proportion of view width or height to move
	            var overlapLow = 0.75; // proportion of view width or height to move
	            var dx = e.shiftKey ? thisImg.getViewWidth() * overlapLow : thisImg.getViewWidth() * overlapHigh;
	            dx = dx / thisImg.getViewZoom();
	            var dy = 0;
	            if (e.keyCode == keyCodes.arrowLeft) dx = -dx;

	            var rotXY = _defines2.default.coordUnRotToRot(dx, dy, thisImg);
	            thisImg.moveRelative(rotXY.x, rotXY.y, _defines2.default.coordSystemNORM); //xf - just for consistency,
	            //debug-only    thisImg.log("arrow: viewWidth: "  +thisImg.getViewWidth()+"  dx,dy: " + dx + "," + dy + "  rot: " + rotXY.toString() + ((e.shiftKey) ? " shift" : "  "));
	            break;
	        //............................................ annotations
	        case keyCodes.deleteKey:
	            // delete selected annotation
	            if (thisImg.getAnnotObj()) thisImg.getAnnotObj().regSelectDelete();
	            break;
	        case keyCodes.c:
	            // copy selected annotation
	            if (e.ctrlKey && _uScope2.default.instance.canAnnotate()) {
	                var iarRefs = _uScope2.default.instance.getImageAnnotRegionRefs();
	                var region = iarRefs.anObj.getSelRegion();
	                _uScope2.default.instance.startCopyMoveRegion(region, e, 'copy');
	            }
	            break;
	        case keyCodes.v:
	            // paste selected annotation
	            if (e.ctrlKey && _uScope2.default.instance.canAnnotate()) {
	                if (_uScope2.default.instance.isRegionCopyActive() == false) {
	                    //if not in copy mode, switch to it
	                    //arg... really need cursor position for this to work.....
	                    var e = jQuery.Event('', { pageX: _defines2.default.pageX, pageY: _defines2.default.pageY }); // create event
	                    var iarRefs = _uScope2.default.instance.getImageAnnotRegionRefs();
	                    var region = iarRefs.anObj.getSelRegion();
	                    _uScope2.default.instance.startCopyMoveRegion(region, e, 'copy');
	                }
	                _uScope2.default.instance.stopCopyMoveRegion(); // and place the copied region here
	            }
	            break;
	        case keyCodes.m:
	            // copy selected annotation
	            if (e.ctrlKey && _uScope2.default.instance.canAnnotate()) {
	                var iarRefs = _uScope2.default.instance.getImageAnnotRegionRefs();
	                var region = iarRefs.anObj.getSelRegion();
	                if (_uScope2.default.instance.isRegionCopyActive() == false) //if not in move/copy mode, switch to it
	                    _uScope2.default.instance.startCopyMoveRegion(region, e, 'move');else _uScope2.default.instance.stopCopyMoveRegion(); // place the moved region here
	            }
	            break;
	        //............................................ zooming
	        case keyCodes.minus: //zoom out
	        case keyCodes.numMinus:
	        case keyCodes.FF_minus:
	            if (e.ctrlKey) {
	                thisImg.zoomSlider.step(-_defines2.default.zoomSpecs.stepFactor);
	            }
	            break;
	        case keyCodes.plus: // zoom in shows more detail so a 10x could become 20x
	        case keyCodes.numPlus:
	        case keyCodes.FF_plus:
	            if (e.ctrlKey) {
	                thisImg.zoomSlider.step(_defines2.default.zoomSpecs.stepFactor);
	            }
	            break;
	        //............................................ rotation
	        case keyCodes.num0: // set rotation to 0
	        case keyCodes.zero:
	            if (_defines2.default.ENABLEROTATION == true) {
	                thisImg.viewRotate(0);
	            }
	            break;
	        case keyCodes.r:
	            // no shift key => step 1 degrees, shift key => step 15 degree; control key => rotate ccw
	            if (_defines2.default.ENABLEROTATION == true) {
	                var angleDeg = thisImg.getViewAngle(true);
	                if (e.shiftKey && e.ctrlKey) angleDeg -= 1;else if (e.shiftKey) angleDeg += 1;else if (e.ctrlKey) angleDeg -= 15;else angleDeg += 15;

	                thisImg.viewRotate(angleDeg);
	            }
	            break;
	        //............................................ next/prev slide
	        case keyCodes.e:
	            //
	            triggerUScopeEvent(_defines2.default.evOPENNEXTSLIDE, {});
	            break;
	        case keyCodes.q:
	            //
	            triggerUScopeEvent(_defines2.default.evOPENPREVSLIDE, {});
	            break;
	        //............................................
	        case keyCodes.t:
	            break;
	        default:
	            eventIsHandled = _defines2.default.ENABLEDEVHOTKEYS;
	    }

	    //............................................................... development hot keys
	    if (_defines2.default.ENABLEDEVHOTKEYS == true) {
	        var buildFULLURL_ = function buildFULLURL_(imageId) {
	            //imageId has leading @ sign
	            var rtnURL = '';
	            var fullURL = _uScope2.default.instance.getFullURL(); //assumes a selected image
	            if (fullURL) {
	                var idx = fullURL.lastIndexOf('@');
	                if (idx > 0) rtnURL = fullURL.substr(0, idx) + imageId; //imageId has leading @ sign
	            }
	            return rtnURL;
	        };

	        switch (keyCode) {
	            case keyCodes.num1:
	            case keyCodes.one:
	                var id1 = '@10'; // add image @10
	                var newURL = buildFULLURL_(id1);
	                var imageSet = {
	                    'images': [{ 'imagePath': id1, 'fullURL': buildFULLURL_(id1), 'mag': 'Fit', 'sampleType': 'patient' } // "patient", "positive", "negative"
	                    //    , { "imagePath": "@62", "mag": "Scan", "sampleType": "patient"} // "patient", "positive", "negative"
	                    ]
	                };
	                _uScope2.default.instance.imageUpdate('add', imageSet.images);
	                //thisImg.zoomAbsolute(thisImg.convertToZoom(1));
	                break;
	            case keyCodes.num2:
	            case keyCodes.two:
	                var id1 = '@55'; // add image @55
	                var imageSet = {
	                    'images': [{ 'imagePath': id1, 'fullURL': buildFULLURL_(id1), 'mag': 'Fit', 'sampleType': 'patient' } // "patient", "positive", "negative"
	                    //    , { "imagePath": "@62", "mag": "Scan", "sampleType": "patient"} // "patient", "positive", "negative"
	                    ]
	                };
	                _uScope2.default.instance.imageUpdate('add', imageSet.images);
	                //thisImg.zoomAbsolute(thisImg.convertToZoom(2));
	                break;
	            case keyCodes.num3:
	            case keyCodes.three:
	                var imageSet1 = { //remove image @10
	                    'images': [{ 'imagePath': '@10' }]
	                };

	                _uScope2.default.instance.imageUpdate('remove', imageSet1.images);

	                //thisImg.zoomAbsolute(thisImg.convertToZoom(3));
	                break;
	            case keyCodes.num4:
	            case keyCodes.four:
	                var id1 = '@43',
	                    id2 = '@62'; // add images @43 and @62
	                var imageSet = {
	                    'images': [{ 'imagePath': id1, 'fullURL': buildFULLURL_(id1), 'mag': 'Fit', 'sampleType': 'positive' } // "patient", "positive", "negative"
	                    , { 'imagePath': id2, 'fullURL': buildFULLURL_(id2), 'mag': 'Fit', 'sampleType': 'negative' } // "patient", "positive", "negative"
	                    ]
	                };
	                _uScope2.default.instance.imageUpdate('add', imageSet.images);

	                //thisImg.zoomAbsolute(thisImg.convertToZoom(4));
	                break;
	            case keyCodes.num5:
	            case keyCodes.five:
	                var id1 = '@2',
	                    id2 = '@21'; // replace image @2 with @21
	                var imageSet1 = {
	                    'images': [{ 'imagePath': id1 }]
	                };
	                var imageSet2 = {
	                    'images': [{ 'imagePath': id2, 'fullURL': buildFULLURL_(id2) }]
	                };
	                _uScope2.default.instance.imageUpdate('replace', imageSet1.images, imageSet2.images);

	                //                thisImg.zoomAbsolute(thisImg.convertToZoom(5));
	                break;
	            case keyCodes.num6:
	            case keyCodes.six:
	                var imageSet = { // convert image @10 and @55 sample type to controls
	                    'images': [{ 'imagePath': '@2', 'sampleType': 'positive' } // "patient", "positive", "negative"
	                    //    { "imagePath": "@10",  "sampleType": "positive"} // "patient", "positive", "negative"
	                    //    , { "imagePath": "@55", "sampleType": "negative"} // "patient", "positive", "negative"
	                    ]
	                };
	                _uScope2.default.instance.imageUpdate('state', imageSet.images);
	                break;
	            case keyCodes.num7:
	            case keyCodes.seven:
	                //convert currently selected image to positive control
	                var imageSet = { 'images': [{ 'imagePath': thisImg.getImageId(), 'sampleType': 'positive' }] };

	                //                var imageSet = {        // convert image @10 and @55 sample type to patient
	                //                    "images": [
	                //                           { "imagePath": "@2", "sampleType": "patient"} // "patient", "positive", "negative"
	                //                       //    { "imagePath": "@10",  "sampleType": "patient"} // "patient", "positive", "negative"
	                //                     //    , { "imagePath": "@55", "sampleType": "patient"} // "patient", "positive", "negative"
	                //                    ]
	                //                };
	                _uScope2.default.instance.imageUpdate('state', imageSet.images);
	                break;
	            case keyCodes.num8:
	            case keyCodes.eight:
	                thisImg.zoomAbsolute(thisImg.convertToZoom(8));
	                break;
	            case keyCodes.num9:
	            case keyCodes.nine:
	                thisImg.zoomAbsolute(thisImg.convertToZoom(9));
	                break;
	            case keyCodes.F9:
	                thisImg.zoomAbsolute(thisImg.convertToZoom(12));
	                break;
	            case keyCodes.F10:
	                thisImg.zoomAbsolute(thisImg.convertToZoom(15));
	                break;
	            case keyCodes.F11:
	                thisImg.zoomAbsolute(thisImg.convertToZoom(18));
	                break;

	            //............................................ next view / prev view

	            case keyCodes.F1: // previous view
	            case keyCodes.F2:
	                // next view
	                var incr = -1;
	                if (e.keyCode == keyCodes.F2) incr = 1;
	                var sv = thisImg.stateVector.getPrevNext(incr);
	                if ((0, _helpers.isDefined)(sv)) {
	                    var zoom = sv.state.zoom;
	                    var x = sv.state.left;
	                    var y = sv.state.top;
	                    //consoleWrite("F1 Prev: X,Y,Zm: " + x + "," + y + "," + zoom);
	                    var mag = thisImg.convertToMag(zoom);

	                    // state reports top left and imgSettings wants center !
	                    x += thisImg.getViewWidth() / 2;
	                    y += thisImg.getViewHeight() / 2;

	                    if (_uScope2.default.instance.getToken()) // if using token, replace previous imageId with this new one
	                        var imgSettings = {
	                            'image': {
	                                'imagePath': _uScope2.default.instance.getImageId(),
	                                'fullURL': _uScope2.default.instance.getFullURL(),
	                                'x': x,
	                                'y': y,
	                                'mag': mag
	                            }
	                        };else var imgSettings = {
	                        'image': {
	                            'imagePath': _uScope2.default.instance.getImageId(),
	                            'x': x,
	                            'y': y,
	                            'mag': mag
	                        }
	                    };
	                    _publicApi2.default.navigateTo(imgSettings);
	                }
	                break;

	            case keyCodes.a:
	                var anObj = thisImg.getAnnotObj(); //report the current layers and regions
	                var bReportResults = true;
	                var str = e.shiftKey ? anObj.toString(false, bReportResults) : anObj.toString(true, bReportResults);
	                (0, _toolbar.consoleWrite)('Layers .................................................................' + str, thisImg.getImageId());
	                (0, _toolbar.consoleWrite)('selectd layerId: ' + anObj.getSelLayerId());
	                //    UScopeViewer.instance.imageListReport();
	                //    UScopeViewer.instance.getReqQueueObj().getRefreshQueueStatus();
	                break;
	            case keyCodes.b:
	                var anObj = thisImg.getAnnotObj(); // the annot object
	                var aRegion = anObj.getSelRegion();
	                aRegion.clearRegionResults();
	                break;

	            case keyCodes.c:
	                var anObj = thisImg.getAnnotObj(); // the annot object
	                if (e.shiftKey) {
	                    (0, _toolbar.consoleWrite)('removing the annotation layer');
	                    anObj.layerDelete(anObj.layers.getLayerIdByName(_defines2.default.AnnotLayerName));

	                    (0, _toolbar.consoleWrite)('removing the report layer');
	                    anObj.layerDelete(anObj.layers.getLayerIdByName(_defines2.default.ReportLayerName));
	                } else if (e.altKey) {
	                    (0, _toolbar.consoleWrite)('removing ALL layers');
	                    anObj.layerDelete(-1);
	                } else {
	                    //consoleWrite("adding the annotation layer");
	                    //anObj.layers.create({ layerType: us.anLayerTypes.manual, layerName: us.AnnotLayerName, decRGB: us.AnnotLayerRGB });

	                    //        consoleWrite("adding the report layer");
	                    //        anObj.layers.create({ layerType: us.anLayerTypes.report, layerName: us.ReportLayerName, decRGB: us.ReportLayerRGB });

	                }
	                break;
	            case keyCodes.d:
	                _publicApi2.default.closeDialogs();
	                break;
	            case keyCodes.g:
	                // uScopeGoToRegion unit test
	                if (!_uScope2.default.instance.isThisImageValid()) return;
	                var anObj = thisImg.getAnnotObj(); // the annot object
	                var rfArray = anObj.getRegionsArray(); // the rfRegions array

	                var count = 0;
	                var regionId;
	                do {
	                    // randomly select a region of this image
	                    var r = Math.random() * rfArray.length;
	                    var idx = r >= rfArray.length - 1 ? rfArray.length - 1 : Math.round(r);
	                    if (rfArray[idx]) regionId = rfArray[idx].regionId;
	                } while ((0, _helpers.isUnDefined)(regionId) && ++count < 100);
	                if (_defines2.default.DBGANNOT) (0, _toolbar.consoleWrite)('uScope: UnitTest for uScopeGoToRegion: ' + regionId + ' count: ' + count);
	                if ((0, _helpers.isDefined)(regionId)) _publicApi2.default.goToRegion(thisImg.getImageId(), regionId);
	                break;
	            case keyCodes.h:
	                if (e.altKey || e.shiftKey) {
	                    (0, _toolbar.consoleWrite)('hotkey shift/alt h: hide annotations');
	                    thisImg.annots.show(false);
	                } else {
	                    (0, _toolbar.consoleWrite)('hotkey h: show annotations');
	                    thisImg.annots.show(true);
	                }
	                break;
	            case keyCodes.i:
	                var step = 1000;
	                if (e.shiftKey) step = -1000;
	                if (e.altKey) thisImg.moveRelative(0, step, _defines2.default.coordSystemNORM); // move in Y
	                else thisImg.moveRelative(step, 0, _defines2.default.coordSystemNORM); // move in X
	                break;
	            case keyCodes.j:
	                var deltaAngleDeg = 135;
	                var curAngleDeg = thisImg.getViewAngle(true);
	                var angleDeg = curAngleDeg + deltaAngleDeg;
	                if (e.altKey) angleDeg = 160;else if (e.shiftKey) angleDeg = curAngleDeg - deltaAngleDeg;
	                thisImg.viewRotate(angleDeg);

	                //var zm12x = thisImg.convertToZoom(12);
	                //thisImg.zoomAbsolute(zm12x);
	                break;
	            case keyCodes.k:
	                break;

	            ////////////////////////ia-dev calls //////////////////////////////////////

	            case keyCodes.l:
	                var imageId = thisImg.getImageId();
	                var xml = '<ImageId>' + imageId.substr(1) + '</ImageId>';
	                thisImg.ajax.doANALSVRREQ(undefined, undefined, 'GetAlgorithmList', xml, {
	                    'request': 'GetAlgorithmList',
	                    'imageId': imageId
	                });
	                //                thisImg.ajax.doDATASVRREQ(undefined, undefined, "ListMacros", xml, { "request": "ListMacros", "imageId": imageId });
	                //                thisImg.ajax.doDATASVRREQ(undefined, undefined, "ListMacroNames", xml, { "request": "ListMacroNames", "imageId": imageId });
	                //                thisImg.ajax.doDATASVRREQ(undefined, undefined, "GetClassifierDefinitions", xml, { "request": "GetClassifierDefinitions", "imageId": imageId });

	                //                var xmlTable = '<TableName>Macro</TableName>';
	                //                thisImg.ajax.doDATASVRREQ(undefined, undefined, "GetFilteredRecordList", xmlTable, { "request": "GetFilteredRecordList", "imageId": imageId });


	                // this call is not related to a specific image:  http: //cp-core:82/GETMACROLIST
	                //thisImg.ajax.doIMGSVRPOST(undefined, undefined, "GETMACROLIST", "", 'html', { "request": "GETMACROLIST" });

	                // this call is not related to a specific image:  http://cp-core:82/GETMACROINFO?2  where ?2 is macroId
	                var macroId = 5; //siq
	                //macroId = 8; // Her2
	                //thisImg.ajax.doIMGSVRPOST(undefined, undefined, "GETMACROINFO", ("?"+macroId), 'html', { "request": "GETMACROINFO" });


	                //DODBCALL+GetMacroInfo2+<MacroId>4<%2FMacroId>  gets information for a specific macro
	                var xmlMacro = '<MacroId>' + macroId + '</MacroId>';
	                //thisImg.ajax.doDATASVRREQ(undefined, undefined, "GetMacroInfo2", xmlMacro, { "request": "GetMacroInfo2", "imageId": imageId });
	                //    thisImg.ajax.doDATASVRREQ(undefined, undefined, "GetMacroInfo", xmlMacro, { "request": "GetMacroInfo", "imageId": imageId });


	                ///    xml += '<AnnotationId>' + "1124" + '</AnnotationId>';
	                ///    thisImg.ajax.doDATASVRREQ(undefined, undefined, "GetAnnotations2", xml, { "request": "GetAnnotations2", "imageId": imageId });


	                break;
	            case keyCodes.m:
	                var macrosObj = _uScope2.default.instance.iaInterface.getMacrosObj();
	                macrosObj.getMacroParms(8); // 5 is siq  8 is her2


	                //$(us.idHashROOT).trigger(us.evGETIAMACROS, {});


	                break;
	            case keyCodes.n:

	                ////                $(function () {
	                ////                    $.pnotify({
	                ////                        title: 'Regular Notice',
	                ////                        text: 'Check me out! I\'m a notice.',
	                ////                        styling: 'jqueryui',
	                ////                        history: false,
	                ////                        type: 'notice'
	                ////
	                ////                        , width: '200px', height: '200px'

	                ////                        ,before_open: function(pnotify) {
	                ////                            pnotify.css({
	                ////                                "top": ($(window).height() / 2) // - (pnotify.height() / 2),
	                ////                                ,"left": ($(window).width() / 2) //- (pnotify.width() / 2)
	                ////                                //, "width": '100px', "height": '100px'
	                ////                                , "z-index": 1000
	                ////                            });
	                ////                        }
	                ////                    });
	                ////                });
	                break;

	            case keyCodes.o:
	                // open an image from randomImage()
	                // swap this image id into fullURL = e.g. //localhost/imageserver/@@f5gHzmgSn6URMsJeIVbg==/@2
	                if (e.shiftKey) {
	                    // original imgSettings format, single image

	                    var imageId = '';
	                    ////////////////////////////////////////////////////
	                    imageId = '@55';
	                    ////////////////////////////////////////////////////
	                    if (_uScope2.default.instance.getToken()) {
	                        // if using token, replace previous imageId with this new one
	                        var fullURL = _uScope2.default.instance.getFullURL();
	                        var newURL = fullURL.slice(0, fullURL.lastIndexOf('@')) + imageId;
	                        var imgSettings = { 'image': { 'imagePath': imageId, 'fullURL': newURL, 'mag': 'Scan' } };
	                    } else {
	                        var imgSettings = { 'image': { 'imagePath': imageId, 'mag': 'Scan' } };
	                    }
	                    //cp-change to UScopeViewer.instance.imageUpdate("add",imgSettings);
	                } else {
	                    // multi imgSettings format, multi-image
	                    var nImages = 2;
	                    var ids = ['@12', '@12', '@12', '@12'];
	                    var partialURL;
	                    if (_uScope2.default.instance.getToken()) {
	                        var fullURL = _uScope2.default.instance.getFullURL();
	                        partialURL = fullURL.slice(0, fullURL.lastIndexOf('@'));
	                    }

	                    var imageJson;
	                    var imgSettings = []; // array of imageJson
	                    for (var i = 0; i < nImages; i++) {
	                        var id = ids[i];
	                        if (partialURL) {
	                            // if using token, replace previous imageId with this new one
	                            var newURL = partialURL + id;
	                            imageJson = { 'imagePath': id, 'fullURL': newURL, 'mag': 'Scan' };
	                        } else {
	                            imageJson = { 'imagePath': id, 'mag': 'Scan' };
	                        }
	                        imgSettings.push(imageJson);
	                        (0, _toolbar.consoleWrite)('DEBUG HOT KEY open : ' + (0, _helpers.toStringAssoc)(imageJson));
	                    }
	                    _uScope2.default.instance.imageUpdate('add', imgSettings);
	                }
	                break;
	            case keyCodes.p:
	                (0, _toolbar.consoleWrite)('p');

	                thisImg.progressive.progShowImageDBG(e.shiftKey ? false : true, 0, 0);
	                //            thisImg.progressive.progShowImageDBG((e.shiftKey) ? false : true, .25, .25);
	                //            thisImg.progressive.progShowImageDBG((e.shiftKey) ? false : true, .5, .5);
	                //            thisImg.progressive.progShowImageDBG((e.shiftKey) ? false : true, .75, .75);
	                //                showProgImage(thisImg, ((e.shiftKey)?false:true))

	                //                //hardcoded test
	                //                var imgSettings = {
	                //                    "image": {
	                //                        "URL": "@10" // "//host/redirect/@@token==/@id or URI
	                //                        ,"x": (53793 / 4).toFixed(0), "y": (45145 / 4).toFixed(0), "z": "", "mag": "Scan" //"Fit", "Scan" or "2", "4", "10",etc
	                //                        ,"regionId": 1391
	                //                    }
	                //                };
	                //                uScopeOpen(imgSettings); // todo: use uScopeImageUpdate
	                break;
	            case keyCodes.q:
	                (0, _toolbar.consoleWrite)('q');
	                thisImg.progressive.progShowViewDBG(e.shiftKey ? false : true);
	                break;
	            case keyCodes.s:

	                thisImg.progressive.refresh();

	                // uScopeGoToRegion("@2", 3630);
	                //                if (e.shiftKey)
	                //                    UScopeViewer.instance.visibilityPanel.check(us.clsROTATIONDIV, true);
	                //                else
	                //                    UScopeViewer.instance.visibilityPanel.check(us.clsROTATIONDIV, false);

	                break;
	            case keyCodes.v:
	                //do not use ... used for paste above
	                break;
	            case keyCodes.w:
	                var anObj = thisImg.annots;
	                var layers = anObj.layers;
	                layers.createAddSaveAnalysisPair('PPC', function cbOnCompletion(inLayerId, outLayerId) {
	                    (0, _toolbar.consoleWrite)('!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!cbOnCompletion: ' + inLayerId + ', ' + outLayerId);
	                });

	                ///            layers.createAddSaveAnalysisPair({ MacroName: "PPC", MacroId: "4", Incremental: "0" });
	                ////                layers.createAddSaveAnalysisPair({ MacroName: "PPC", MacroId: "4", Incremental: "0" }, cbAddLayerResponse);
	                //                anObj.save({ "action": "addLayers",  "xmlLayers": [
	                //                { Name: "TestLayer1", Type: us.anLayerTypes.manual },
	                //                { Name: "TestLayer1 output", Type: us.anLayerTypes.manual}]    },cbAddLayerResponse);
	                //                layers.createAddSave({ Name: "TestLayer2", Type: us.anLayerTypes.manual, LineColor: reverseCLR(hexColortoRGB("#00FF00")), selected: true }, cbAddLayerResponse);

	                //                function cbAddLayerResponse() {
	                //                    consoleWrite("!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!cbAddLayersResponse");
	                //                }


	                break;
	            case keyCodes.x:
	                {
	                    var vpDivOffsetGet = function vpDivOffsetGet(thisImg) {
	                        //where is the visible TLcorner of the vp in the root div ///// not right ..... need to understand the impact of rotation
	                        var rootRect = _uScope2.default.instance.rootRectGet();
	                        var jVpDiv = thisImg.vpDivGet(); /////////////// affected by rotation!!!
	                        var offset = jVpDiv.offset(); // the current position of the target relative to the document

	                        //////////////////////////////////////attempt to keep offset constant with rotation  (it is the corner pt offset)
	                        var cpVpRotOffset = thisImg.getRotationOffset();
	                        offset.left -= cpVpRotOffset.x;
	                        offset.top -= cpVpRotOffset.y;
	                        //////////////////////////////////////
	                        var cpVpOffset = new _objects.cPoint(offset.left - rootRect.x, offset.top - rootRect.y).toInt();
	                        thisImg.log('.......jVpDiv.offset: ' + Math.round(offset.left) + ',' + Math.round(offset.top) + '   root: ' + rootRect.x + ',' + rootRect.y + '  delta: ' + cpVpOffset.toString());
	                        return cpVpOffset;
	                    };
	                    var vpDivOffsetGet1 = function vpDivOffsetGet1(thisImg) {
	                        // where is the visible TLcorner of the vp in the root div?
	                        var rootRect = _uScope2.default.instance.rootRectGet();
	                        var jVpDiv = thisImg.vpDivGet('outer'); // use the outer div which does not rotate

	                        var cpVpOffsetDoc = new _objects.cPoint(jVpDiv.offset().left, jVpDiv.offset().top); // the current position of the target relative to the document
	                        var cpVpOffset = new _objects.cPoint(cpVpOffsetDoc.x - rootRect.x, cpVpOffsetDoc.y - rootRect.y).toInt();

	                        thisImg.log('.......cpVpOffsetDoc: ' + cpVpOffsetDoc.toString() + ' uScopeDiv: ' + rootRect.x + ',' + rootRect.y + '  cpVpOffset: ' + cpVpOffset.toString());
	                        return cpVpOffset;
	                    };
	                }

	                vpDivOffsetGet1(thisImg);
	                break;

	                //                var thisImg = UScopeViewer.instance.getThisImage();
	                //                var svObj = thisImg.stateVector;
	                //                var report = svObj.reportAll(us.eStateTypes.view, true);


	                //                if (report.length > 0) {
	                //                    var report2 = report.replace(/\r\n|\n\r|\r|\n/g, "<br>");
	                //                    genericMessage(report2, "Current Sequence");
	                //                }
	                //consoleWrite(report);


	                //                if (e.shiftKey) {
	                //                    thisImg.progressive.show(true);
	                //                    $("." + us.clsIMGTILE).show();
	                //                }
	                //                else {
	                //                    $("." + us.clsIMGTILE).hide();
	                //                    thisImg.progressive.show(false);
	                //                }

	                //                if (e.shiftKey) {    // close all images
	                //                    UScopeViewer.instance.imageClose();
	                //                }
	                //                else {                // close the current image
	                //                    if (UScopeViewer.instance.isThisImageValid())
	                //                        UScopeViewer.instance.imageClose1(thisImg.getImageId());
	                //                }
	                break;
	            case keyCodes.y:

	                thisImg.moveAbsoluteCenter(1000, 2000, _defines2.default.coordSystemNORM);

	                //    var cpDist = new cPoint(10, 10);
	                //    var anObj = thisImg.getAnnotObj();     // the annot object
	                //    anObj.regMove(cpDist);
	                break;
	            case keyCodes.z:
	                if (!_uScope2.default.instance.isThisImageValid()) return;
	                var anObj = thisImg.getAnnotObj(); // the annot object
	                var region = anObj.getSelRegion();
	                if (region.type == _defines2.default.eAnTypes.pen) {
	                    thisImg.log(region.toString(true));

	                    var nPtsRemoved = region.thinOutPts(10);
	                    thisImg.log('nPtsRemoved: ' + nPtsRemoved);
	                    if (nPtsRemoved > 0) {
	                        thisImg.log(region.toString(true));
	                        //                        if (UScopeViewer.instance.canSaveAnnotations()) {                    // if incremental save is enabled, automatically update the database
	                        //                            var regionXML = '<Region Id="' + region.regionId + '">';
	                        //                            var vertexXML = region.buildVertexXML();
	                        //                            regionXML += "<Vertices>" + vertexXML + "</Vertices>" + '</Region>';
	                        //                            anObj.save({ action: "updateRegion", layerId: region.layerId, regionXML: regionXML });
	                        //                        }

	                        var viewZoom = thisImg.getViewZoom();
	                        var viewAngleDeg = thisImg.getViewAngle(true);
	                        (0, _annotdraw.rfDraw)(this.paper, region, viewZoom, viewAngleDeg); // repaint the region with the new color
	                        anObj.regHighLight(region, true, viewZoom, viewAngleDeg); // update the highlight color of the selected region
	                    }
	                }

	                //if (e.shiftKey) thisImg.zoomRelative(0.5);
	                //else thisImg.zoomRelative(2.0);
	                //if (e.shiftKey) thisImg.zoomRelative(0.8);
	                //else thisImg.zoomRelative(1.25);
	                //            if (e.shiftKey) thisImg.zoomRelative(1 / 1.1);
	                //            else thisImg.zoomRelative(1.1);

	                //            var stateArray = UScopeViewer.instance.getStateArray();

	                //if (e.shiftKey) thisImg.scaleBar.rotate(-10, "relative");
	                //else thisImg.scaleBar.rotate(10, "relative");

	                ///    triggerUScopeEvent(us.evIMAGESELECTED, { imageId: thisImg.getImageId(), uScopeIdx: 0 });


	                // force thumbnail resize
	                //                var jVpDiv = thisImg.vpDivGet("outer");
	                //                var jThumbDiv = jVpDiv.find("." + us.clsDIVTHUMBNAIL);
	                //                var width = jThumbDiv.width();
	                //                if (e.altKey == true) {
	                //                    thisImg.thumbnail.heatMap.resize();
	                //                }
	                //                else if (e.shiftKey == false ) {
	                //                    jThumbDiv.width(width * 1.5);
	                //                    thisImg.thumbnail.resize({ auto: false, resizeHeatMap: true });
	                //                }
	                //                else if (e.shiftKey == true) {
	                //                    jThumbDiv.width(width / 2);
	                //                    thisImg.thumbnail.resize({ auto: false, resizeHeatMap: true });
	                //                }


	                // $("." + us.TBRASTEROPEN + "-e").click(); // open raster panel
	                break;
	            default:
	                eventIsHandled = false;
	        }
	    } // us.ENABLEDEVHOTKEYS

	    // this disables scrolling while moving around on the viewport
	    if (eventIsHandled) {
	        e.preventDefault();
	    }
	};

	//-------------------------------------------------------------------------------------------------
	//    TRIGGERS
	//-------------------------------------------------------------------------------------------------
	//............................................ triggerUScopeEvent
	// triggerUScopeEvent - This function fires the passed event with the passed parameters.
	function triggerUScopeEvent(evName, parms) {

	    $(_defines2.default.idHashROOT).trigger(evName, parms);
	    // if (us.DBGEVENTS) consoleWrite("trigger: " + evName + "  " + toStringAssoc(parms));
	}

	//............................................ triggerImageNavigated
	// triggerImageNavigated - This function fires the us.evBEENNAVIGATED event indicating the slide has been read.
	//todo: I wonder if after executing this once (per image) it could rewrite itself to do nothing.
	//        Then I need not keep the hasBeenNavigated flag.
	//        It is important that the next instantiation of a viewport this function is whole again.
	function triggerImageNavigated(thisImg) {
	    if (thisImg.hasBeenNavigated == true) return; // only issue callback once

	    // first annotation draw navigates to selected region, don't respond yet
	    if (thisImg.getAnnotObj() && thisImg.getAnnotObj().isInitialized() == false) {
	        //if (us.DBGEVENTS) thisImg.log("triggerImageNavigated: annotations NOT loaded yet, cannot trigger us.evIMAGENAVIGATED");
	        return;
	    }

	    // fire event: the image is loaded
	    // if (us.DBGEVENTS) thisImg.log("trigger: us.evIMAGENAVIGATED");
	    triggerUScopeEvent(_defines2.default.evIMAGENAVIGATED, { imageId: thisImg.getImageId(), status: 'read' });

	    thisImg.hasBeenNavigated = true; // set state to true so this call is only made once for this image
	}

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = UScopeViewer;

	var _defines = __webpack_require__(3);

	var _defines2 = _interopRequireDefault(_defines);

	var _toolbar = __webpack_require__(5);

	var _compatibility = __webpack_require__(6);

	var _objects = __webpack_require__(7);

	var _requestQueue = __webpack_require__(12);

	var _requestQueue2 = _interopRequireDefault(_requestQueue);

	var _viewportAP = __webpack_require__(13);

	var _viewportAP2 = _interopRequireDefault(_viewportAP);

	var _viewLayout = __webpack_require__(31);

	var _viewLayout2 = _interopRequireDefault(_viewLayout);

	var _regionToolbar = __webpack_require__(32);

	var _regionToolbar2 = _interopRequireDefault(_regionToolbar);

	var _events = __webpack_require__(10);

	var _userPrefs = __webpack_require__(33);

	var _userPrefs2 = _interopRequireDefault(_userPrefs);

	var _helpers = __webpack_require__(8);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/*
	 ________________________________________________________________________________________________
	 This file contains the application uScope's primary object, also called self.
	 Public functions in the uScope object are called by components within the uScope application
	 and by those functions isolated in the file public-api.js which is the exposed interface to
	 the application's parent.

	 Coding conventions: see Google JavaScript Style Guide
	 declare primary objects as cXxxxxxxx (lowercase c, Uppercase first letter of object name)
	 use var xx = [] instead of var xx = []
	 add var to loop vars: for (var i=0; i<10; i++)
	 place open bracket on the same line as the statement, e.g. if (x) {
	 place open bracket on the same line as the function declaration, e.g. function xx () {
	 use if (xxx == false) instead of if(!xxx) for clarity; same for true
	 declare closure functions this way, function f() { ... }, so they can be defined at the bottom of the parent fn
	 literally '//............................................ functionName' precedes fn declarations - this makes searched for fn easy to find

	 Legacy Naming conventions (to be phased out in favor of modern best-practices):
	 instead of this.fnname use the group name as specified at the beginning of the cUScope object (below)
	 use var xxx_ for local vars and local functions (trailing underscore)
	 jxxx is a jquery object
	 naming convention for constants: kDESC, start with a k for "konstant", use capitals for description

	 consistent var names: PLEASE ALWAYS USE THEM so search returns useful results
	 thisImg is used as a reference to a cViewport object.
	 - get it this way: var thisImg = self.getThisImage();
	 jVpDiv is used as the jquery object of the selected viewport div.
	 - get it this way: var jVpDiv = this.vpDivGet(); or var jVpDiv = thisImg.vpDivGet();
	 anObj is used as a reference to a cAnnotations object
	 - get it this way: var anObj = thisImg.getAnnotObj();

	 use BROWSER_FIX_HERE flags to identify items that are implemented in response to a browser specific piece of code.

	 use isDefined(var) and isUnDefined(var) if reasonable

	 logging:                    PLEASE DO LOG: use log() and err()
	 precede log statement with conditional if (us.DBGxxx) if the log will be useful in the long term
	 error logging:                use logging mechanisms above, start message with 'Error: ' so we know
	 tabs:                        USE 4 spaces
	 comments:                    DO COMMENT WHAT the code is up to and the reason WHY
	 TRY to put in column 61 or 65 as much as possible
	 parm passing approach:        ---
	 */

	/*
	 Object Name: uScope
	 Overview: The uScope object creates and manages the layout of viewport divs and their
	 associated viewport objects which manage the displayed images.

	 Associated Panel: none

	 Dependencies and Supporting objects:
	 o cViewLayout
	 o cViewport
	 o cUserPrefs
	 o todo: list panels and toolbars
	 o cPoint, cSize, cRect

	 Assumptions: o todo

	 Limitations:
	 o Duplicate Image:
	 The current design does NOT support the same image open more than once.
	 If that is to change the following must be done.  (Many of these items are in-work or complete.)
	 - the viewport div ids must include a unique id beyond the imageId, like the image index
	 - the namespace of event handlers must also include something unique
	 - find by id, and other such searches, need to be reviewed
	 - compare index not id

	 Terms Used: o todo

	 Functionality: o todo

	 Data Structures:
	 o images_ is an array containing references to valid, opened image viewports
	 o rootRect_ is the uScope div position and dimensions in a cRect object

	 HTML:
	 The uScope parent div is created outside of uScope and its ID is passed into uScope in uScopeStart().
	 uScope creates a viewLayout div and populates it with the viewport divs in buildVPDiv_().

	 References: o none

	 UScopeViewer - This object contains and maintains the state variables for the uScope viewer configuration.
	 */
	function UScopeViewer(eventChannel) {
	    // Expose the global uScope instance. TODO - There's no business requirement for a single uscope instance. Refactor.
	    if (UScopeViewer.instance) {
	        throw new Error('uScope Error: There can be only one.');
	    }
	    UScopeViewer.instance = this;

	    var initStatus = true;
	    var self = this;

	    // ..... to group fns in js parser, for ease of search (e.g. search for all 'USCOPE_INQUIRY')
	    var USCOPE_EXTERNAL_INTERFACE = this; // public group of fns allowed to be called external to uScope (from file public-api.js)
	    var USCOPE_IMAGE = this; // public group of fns related to open images
	    var USCOPE_INQUIRY = this; // public group of inquiry fns
	    var USCOPE_GET = this; // public group of get fns
	    var USCOPE_SET = this; // public group of set fns
	    var USCOPE_PREFS = this; // public group of fns related to user preferences
	    var USCOPE_OVERLAY = this; // public group of fns related to overlays
	    var USCOPE_REGION_COPYMOVE = this;

	    var progName = 'uScope';

	    // The following constants are injected by WebPack during the build process.
	    var progDate = ("Tue Feb 28 2017"); // eslint-disable-line no-undef
	    var progVersion = ("1.0.14-5007"); // eslint-disable-line no-undef

	    self.events = eventChannel.$new();

	    USCOPE_GET.getProgName = function () {
	        return progName;
	    };
	    USCOPE_GET.getProgVersion = function () {
	        return progVersion;
	    };
	    USCOPE_GET.getProgDate = function () {
	        return progDate;
	    };
	    USCOPE_GET.about = function () {
	        return self.getProgName() + ' ' + self.getProgVersion() + ' ' + self.getProgDate();
	    };

	    //............................................ logging fns
	    var logger = _defines2.default.helpers.createLogger();
	    var log = logger.log;
	    var err = logger.error;

	    //............................................ construct_() local
	    var construct_ = function construct_() {
	        if (_defines2.default.DBGSTART) {
	            log(_compatibility.BrowserDetect.report());
	        }

	        log(self.about()); // say hello from uScope

	        _defines2.default.renderEngine = 'aperio';
	        _defines2.default.supportsCanvas = supports_canvas(); // identify browser canvas ability

	        reqQueue_ = new _requestQueue2.default(this); // create the tile request object
	    };
	    //......................................................  tile request object
	    var reqQueue_;
	    USCOPE_GET.getReqQueueObj = function () {
	        return reqQueue_;
	    }; // accessor to tile request object

	    // initialization vars .................................
	    var createdBy = ''; // parent/creator application name
	    var userName = ''; // user's login or full name (!not loginName used in dev mode!)
	    var userId = -1; // user's id (database table 'users')
	    var title = ''; // start up title // not implemented
	    USCOPE_GET.getUserName = function () {
	        return userName;
	    };
	    USCOPE_SET.setUserName = function (newName) {
	        userName = newName;
	    };
	    USCOPE_GET.getUserId = function () {
	        return userId;
	    };
	    USCOPE_GET.getCreatedBy = function () {
	        return createdBy;
	    };

	    //............................................................................................
	    // image/viewport container
	    //............................................................................................
	    var viewLayout_; // object to implement jquery layout plugin

	    var images_ = []; // array of image/cViewport objects in view
	    var imageSelIdx_ = 0; // index of image with focus
	    var imageCountFromStart_ = 0; // count of number of images ever opened since uscopestart

	    //toconsider: I'd like to remove this array - need to replace dependency on getfullurl and the like
	    var imageInitState_ = []; // array of image initial state

	    //............................................ imageListReport() public
	    // imageListReport - This function logs information about the open images.
	    USCOPE_IMAGE.imageListReport = function () {
	        // debug use
	        log('uScope Image List: count: ' + self.getImageCount() + '  imageSelIdx_: ' + imageSelIdx_);
	        for (var i = 0, len = images_.length; i < len; i++) {
	            var thisImg = images_[i];
	            if (thisImg == undefined) log('image idx: ' + i + ' is empty');else log('image idx: ' + i + ' contains imageId: ' + thisImg.getImageId());
	        }
	    };
	    //............................................ getImageCount() public
	    // getImageCount - This function returns the open image count.
	    USCOPE_IMAGE.getImageCount = function () {
	        for (var i = 0, count = 0, len = images_.length; i < len; i++) {
	            if (images_[i] != undefined) count++;
	        }return count;
	    };

	    USCOPE_IMAGE.getImageCountFromStart = function () {
	        return imageCountFromStart_;
	    };

	    //............................................................................................
	    // image selection functions
	    //............................................................................................

	    //............................................ getImageAnnotRegionRefs() public
	    //    returns {thisImg,  anObj,  region} where region is option
	    USCOPE_GET.getImageAnnotRegionRefs = function (opt_bGetRegion) {
	        var rtn = { thisImg: self.getThisImage(), anObj: undefined, region: undefined };
	        if (rtn.thisImg) {
	            rtn.anObj = rtn.thisImg.getAnnotObj();
	            if (rtn.anObj && opt_bGetRegion == true) rtn.region = rtn.anObj.getSelRegion();
	        }
	        return rtn;
	    };
	    //............................................ getThisImage() public
	    //    getThisImage - This function returns a reference to the currently selected image or undefined.
	    USCOPE_IMAGE.getThisImage = function (idx) {
	        return idx == undefined ? images_[imageSelIdx_] : images_[idx];
	    };

	    //............................................ getThisImageById() public
	    //    getThisImageById - This function searches the images_ array for the passed imageId.
	    //                It returns the image object or return -1 if the imageId is not in images_[].
	    USCOPE_IMAGE.getThisImageById = function (imageId) {
	        // imageId includes @ sign, e.g.'@2'
	        var idx = findImageIdx_(imageId);
	        return idx < 0 ? undefined : images_[idx];
	    };

	    //............................................ getSelImageIdx() public
	    //    getSelImageIdx -  This function returns the currently selected image index.
	    USCOPE_IMAGE.getSelImageIdx = function () {
	        return imageSelIdx_;
	    };

	    //............................................ getSelImageId() public
	    //    getSelImageId -  This function returns the currently selected imageId or -1
	    USCOPE_IMAGE.getSelImageId = function () {
	        return images_[imageSelIdx_] ? images_[imageSelIdx_].getImageId() : -1;
	    };

	    //............................................ setImageSelected() public
	    //    setImageSelected -  This function selects the image related to the passed index.
	    //    If that image is already selected, the selection is not made unless the optional force
	    //    parameter is true.
	    USCOPE_IMAGE.setImageSelected = function (idx, opt_bForce) {
	        if (idx != imageSelIdx_ || opt_bForce == true) {
	            // note index is used b/c could have same image id open multiple places
	            imageSelIdx_ = idx;
	            (0, _events.triggerUScopeEvent)(_defines2.default.evIMAGESELECTED, { imageId: imageInitState_[idx].imageId, uScopeIdx: imageSelIdx_ });
	            //debug-only log("self.setImageSelected: evIMAGESELECTED: " + toStringAssoc({ imageId: imageInitState_[idx].imageId, uScopeIdx: imageSelIdx_ }));
	        }
	    };
	    //............................................ setImageNextSelected() public
	    //    setImageNextSelected -  This function selects the next image in image list.
	    // todo: it doesn't really do what it says it does... check out what is desired
	    USCOPE_IMAGE.setImageNextSelected = function (idx) {
	        if (imageSelIdx_ == idx) {
	            imageSelIdx_ = -1;
	            for (var i = 0; i < images_.length; i++) {
	                if (images_[i] != undefined) {
	                    self.setImageSelected(i);
	                    return;
	                }
	            }
	        }
	    };
	    //............................................ isThisImageValid() public
	    //    isThisImageValid - This function returns true if the currently selected image is valid and false otherwise.
	    USCOPE_IMAGE.isThisImageValid = function () {
	        //todo: rename to isSelectedImageValid
	        return (0, _helpers.isDefined)(images_[imageSelIdx_]);
	    };
	    //............................................ isThisImageAnnotReady() public
	    USCOPE_IMAGE.isThisImageAnnotReady = function () {
	        if ((0, _helpers.isDefined)(images_[imageSelIdx_])) {
	            var anObj = images_[imageSelIdx_].getAnnotObj();
	            return anObj && anObj.isInitialized ? true : false;
	        }
	        return false;
	    };
	    //............................................ isThisImageIdValid() public
	    //    isThisImageValid - This function returns true if the passed image ID is open and false otherwise.
	    USCOPE_IMAGE.isThisImageIdValid = function (imageId) {
	        for (var i = 0, len = images_.length; i < len; i++) {
	            if (images_[i] != undefined) {
	                var thisId = images_[i].getImageId();
	                if (imageId == thisId) return true;
	            }
	        }
	        return false;
	    };
	    //............................................ findImageIdx_() local
	    // findImageIdx_ - This function searches the images_ array for the passed imageId.
	    //                It returns the index to the image with this imageId or return -1 if the imageId is not in images_[].
	    var findImageIdx_ = function findImageIdx_(imageId) {
	        for (var i = 0; i < images_.length; i++) {
	            if (images_[i] != undefined) {
	                var aImageId = images_[i].getImageId();
	                if (aImageId == imageId) return i;
	            }
	        }
	        return -1;
	    };
	    //............................................................................................
	    // toolbar options from VIL
	    //............................................................................................
	    //............................................ toolbarCanAddButton() public
	    USCOPE_INQUIRY.toolbarCanAddButton = function (tbOptionName) {
	        if (self.vilSettings && self.vilSettings.toolbarOptions && self.vilSettings.toolbarOptions[tbOptionName]) return self.vilSettings.toolbarOptions[tbOptionName];else return false;
	    };
	    //............................................ toolbarSnapShotMode() public
	    USCOPE_INQUIRY.toolbarSnapShotMode = function () {
	        if (self.vilSettings && self.vilSettings.features && self.vilSettings.features['snapshotMode']) return self.vilSettings.features['snapshotMode'];else return undefined;
	    };

	    //............................................................................................
	    // region toolbar support for region copy/paste
	    //............................................................................................
	    var bRegionCopyActive = false;
	    //............................................ isRegionCopyActive() public
	    USCOPE_REGION_COPYMOVE.isRegionCopyActive = function () {
	        return bRegionCopyActive;
	    };
	    //............................................ startCopyMoveRegion() public
	    USCOPE_REGION_COPYMOVE.startCopyMoveRegion = function (regionToCopy, e, action) {
	        if (regionToCopy == undefined) return false;
	        if (regionToCopy.isReportRegion == true && action == 'copy') // cannot copy a report region
	            return false;

	        self.iarRefs = self.getImageAnnotRegionRefs(true);
	        if (self.iarRefs.thisImg == undefined || self.iarRefs.anObj == undefined) return false;

	        bRegionCopyActive = true;
	        self.iarRefs.anObj.regHighLight(self.iarRefs.region, true); // show special highlight for copy/move region

	        if (action == 'copy') {
	            if (e.pageX) var crsrPosBase = _defines2.default.coordBaseImage(e, self.iarRefs.thisImg); // compute the position of the cursor in base image coords
	            else {
	                    var crsrPosBase = regionToCopy.getCenter();
	                    crsrPosBase.add(10, 10);
	                }
	            self.iarRefs.anObj.regCopyTo(crsrPosBase, regionToCopy);
	        }
	        return true;
	    };
	    //............................................ stopCopyMoveRegion() public
	    USCOPE_REGION_COPYMOVE.stopCopyMoveRegion = function () {
	        self.iarRefs = self.getImageAnnotRegionRefs(true);
	        if (self.iarRefs.thisImg == undefined || self.iarRefs.anObj == undefined || self.iarRefs.region == undefined) return false;

	        bRegionCopyActive = false;
	        self.iarRefs.anObj.regHighLight(self.iarRefs.region, true); // return hilight to normal region select

	        if (self.canSaveAnnotations()) {
	            // update the database with the region geometry change
	            var regionXML = '<Region Id="' + self.iarRefs.region.regionId + '">';
	            var vertexXML = self.iarRefs.region.buildVertexXML();
	            regionXML += '<Vertices>' + vertexXML + '</Vertices>' + '</Region>';
	            self.iarRefs.anObj.save({
	                action: 'updateRegion',
	                layerId: self.iarRefs.region.layerId,
	                regionXML: regionXML
	            });
	        }
	    };

	    //............................................................................................
	    // mode related vars & functions
	    //............................................................................................
	    var inDevMode = false; // flag indicating developement mode
	    USCOPE_INQUIRY.isModeDev = function () {
	        return inDevMode;
	    }; // development mode indication - necessary for unit tests
	    USCOPE_SET.setInDevMode = function (dev) {
	        inDevMode = dev;
	    };

	    var inLockDownMode = false; // flag indicating lock down mode
	    var annotDrawB4LD = true; // the state of annotation draw before lockdown is on
	    //............................................ isModeLockDown() public
	    //    isModeLockDown - This function returns true if uScope is in lock down mode and false otherwise.
	    USCOPE_INQUIRY.isModeLockDown = function () {
	        return inLockDownMode;
	    }; // is in Lock Down mode?

	    //............................................ setInLockDownMode() public
	    //    setInLockDownMode - This function sets uScope into or out of lock down mode.
	    //    In lock down mode drawing of annotations is disabled.
	    USCOPE_EXTERNAL_INTERFACE.setInLockDownMode = function (enable) {
	        // switch into/out-of lock down mode
	        if (enable && !inLockDownMode) {
	            inLockDownMode = true;
	            if (self.annotPanel) self.annotPanel.enableDrawingIcons(self.canAnnotate());
	        } else if (!enable && inLockDownMode) {
	            inLockDownMode = false;
	            if (self.annotPanel) self.annotPanel.enableDrawingIcons(self.canAnnotate());
	        }
	    };

	    //............................................ canSaveAnnotations() public
	    //    canSaveAnnotations - This function returns true if uScope can save annotations and false otherwise.
	    USCOPE_INQUIRY.canSaveAnnotations = function () {
	        // can save annotations?
	        return _defines2.default.ENABLEAUTOANNOTSAVE ? true : false;
	    };
	    //............................................................................................
	    // user rights related
	    //............................................................................................

	    //............................................ canAnnotate() public
	    // canAnnotate - This function report if an annotation can be created.
	    // Note that the 'saveAnnotations' option is a user right and means the user can view but not create annotations
	    USCOPE_INQUIRY.canAnnotate = function () {
	        // can create annotations?
	        // TODO: refactor to allow uScope to be put into some kind of "read only" mode, decoupling the need for
	        // TODO: annotations to know anything about conferencing, or vice-versa
	        var thisImgCan = imageSelIdx_ >= 0 && imageInitState_[imageSelIdx_] ? // can the selected image create annots? (user rights)
	        imageInitState_[imageSelIdx_].saveAnnotations : false;
	        //debug-only log("canAnnotate: thisImgCan: " + thisImgCan + " saveAnnotations: " + imageInitState_[imageSelIdx_].saveAnnotations);
	        //debug-only log("canAnnotate: lockDown: " + self.isModeLockDown() + " inConference: " + self.isModeConference());

	        return !!(self.isModeLockDown() == false && // lockdown or conferencing mode disables annot creation
	        self.isModeConference() == false && thisImgCan == true && _defines2.default.ENABLEANNOTCREATE == true);
	    };
	    //............................................ canViewLabel() public
	    USCOPE_INQUIRY.canViewLabel = function () {
	        return _defines2.default.ENABLELABEL ? true : false;
	    }; // can view label? note this is a user right
	    //............................................ canSaveMacro() public
	    USCOPE_INQUIRY.canSaveMacro = function () {
	        return true;
	    }; // can saveMacro? note this is a user right
	    //............................................ canRunAnalysis() public
	    USCOPE_INQUIRY.canRunAnalysis = function () {
	        return true;
	    }; // can run analysis? note this is a user right

	    //............................................................................................
	    // miscellaneous functions
	    //............................................................................................

	    //............................................ overlayRefresh public
	    //    overlayRefresh - This function refreshes the overlays on all images.
	    USCOPE_OVERLAY.overlayRefresh = function () {
	        for (var i = 0; i < images_.length; i++) {
	            var thisImg = images_[i];
	            if (thisImg && thisImg.overLayout) thisImg.overLayout.refresh();
	        }
	    };
	    //............................................ memoryUsage public
	    // memoryUsage - This function returns the memory usage of uScope in MBytes.
	    //                Note- I don't think it is accurate!
	    USCOPE_INQUIRY.memoryUsage = function () {
	        return ($(_defines2.default.idHashROOT).html().length / 1024 / 1024).toFixed(3);
	    };

	    //............................................................................................
	    // credentials functions
	    //............................................................................................
	    // access to credentials ...............................
	    // - this is necessary to initialize an image/cViewport so even though each image stores its own credentials
	    // the uScope object maintains its own quick reference, unfortunately

	    //toconsider: query the images themselves so imageInitState_ can be eliminated whe conferencing moves to VIL
	    USCOPE_GET.getFullURL = function () {
	        return imageInitState_[imageSelIdx_] ? imageInitState_[imageSelIdx_].fullURL : undefined;
	    };
	    USCOPE_GET.getServer = function () {
	        return imageInitState_[imageSelIdx_] ? imageInitState_[imageSelIdx_].server : undefined;
	    };
	    USCOPE_GET.getToken = function () {
	        if (self.isModeDev() == true) return imageInitState_[imageSelIdx_] ? imageInitState_[imageSelIdx_].token : undefined;
	        return undefined;
	    };
	    USCOPE_GET.getImageId = function () {
	        return imageInitState_[imageSelIdx_] ? imageInitState_[imageSelIdx_].imageId : undefined;
	    };
	    USCOPE_GET.isConnectedViaApache = function () {
	        if (imageInitState_[imageSelIdx_] != undefined) return imageInitState_[imageSelIdx_].server.indexOf('imageserver') != -1;else return undefined;
	    };

	    // stand alone development credentials .................
	    // - use setLoginName() and setPassword() prior to uScopeStart() in test harnesses
	    var loginName;
	    var password;
	    USCOPE_GET.getLoginName = function () {
	        return loginName;
	    };
	    USCOPE_SET.setLoginName = function (lNname) {
	        loginName = lNname;
	    };
	    USCOPE_GET.getPassword = function () {
	        return password;
	    };
	    USCOPE_SET.setPassword = function (pWord) {
	        password = pWord;
	    };

	    //............................................................................................
	    // input settings management
	    //............................................................................................

	    //............................................ parseVILSettings() public
	    // parseVILSettings() - This fuction parses the passed JSON formatted parameters...
	    USCOPE_EXTERNAL_INTERFACE.parseVILSettings = function (settings) {
	        self.vilSettings = new _helpers.cloneObject(settings); // save VIL's uScopeStart settings
	        var vilSettings = self.vilSettings;
	        var status = true;

	        if (vilSettings.setup && vilSettings.setup.inDevMode) {
	            inDevMode = true;
	        }

	        enforceBrowserDependentSettings();

	        if (inDevMode == false) {
	            // insure that these dev mode options are not active if not in dev mode
	            _defines2.default.ENABLEDEVHOTKEYS = false;
	            _defines2.default.DISABLEOVERLAYITEMS = false;
	            _defines2.default.DISABLEEXTERNALCALLBACKS = false;
	            _defines2.default.SHOWALLTOOLBARICONS = false;
	            _defines2.default.DISABLEUSERPREFS2DB = false;
	            _defines2.default.DBGZMBTNPYRAMID = false;
	        } else {
	            if (_defines2.default.DISABLEOVERLAYITEMS == true) _defines2.default.ENABLELABEL = _defines2.default.ENABLEMAG = _defines2.default.ENABLETHUMB = _defines2.default.ENABLESCALEBAR = _defines2.default.ENABLEZOOMCTL = _defines2.default.ENABLEROTATION = false;
	        }

	        // settings.setup ................................
	        if (vilSettings.setup) {
	            _defines2.default.idROOT = setIfDefined(_defines2.default.idROOT, vilSettings.setup.divId);
	            _defines2.default.idHashROOT = '#' + _defines2.default.idROOT;
	            $(_defines2.default.idHashROOT).addClass(_defines2.default.clsROOTSTYLE);

	            userName = setIfDefined(userName, vilSettings.setup.userName);
	            userId = setIfDefined(userId, vilSettings.setup.userid);
	            createdBy = setIfDefined(createdBy, vilSettings.setup.createdBy);
	            title = setIfDefined(title, vilSettings.setup.title);
	        }
	        if ((0, _helpers.isUnDefined)(userName) || userName.length == 0) // default user name
	            userName = 'DefaultUser';
	        if ((0, _helpers.isUnDefined)(userId) || userId.length == 0) userId = 0; // invalidate user id - prevents calls depending upon it from executing
	        if ((0, _helpers.isUnDefined)(createdBy) || createdBy.length == 0) createdBy = 'unspecified creator';
	        log('       userName: ' + userName + '  userId: ' + userId + '  createdBy: ' + createdBy);

	        // settings.overlays .............................
	        if (vilSettings.overlays.none) {
	            // if disable all overlays
	            _defines2.default.ENABLELABEL = _defines2.default.ENABLEMAG = _defines2.default.ENABLETHUMB = _defines2.default.ENABLESCALEBAR = _defines2.default.ENABLEZOOMCTL = _defines2.default.ENABLEHEATMAP = _defines2.default.ENABLEROTATION = false;
	            //note-I don't think this should disable the toolbar us.ENABLETOOLBAR =
	        } else {
	            // else enable/disable specific overlays
	            _defines2.default.ENABLELABEL = setIfDefined(_defines2.default.ENABLELABEL, vilSettings.overlays.label);
	            _defines2.default.ENABLEMAG = setIfDefined(_defines2.default.ENABLEMAG, vilSettings.overlays.magnifier);
	            _defines2.default.ENABLETHUMB = setIfDefined(_defines2.default.ENABLETHUMB, vilSettings.overlays.thumbnail);
	            _defines2.default.ENABLESCALEBAR = setIfDefined(_defines2.default.ENABLESCALEBAR, vilSettings.overlays.scalebar);
	            _defines2.default.ENABLEZOOMCTL = setIfDefined(_defines2.default.ENABLEZOOMCTL, vilSettings.overlays.zoombar);
	            _defines2.default.ENABLEROTATION = setIfDefined(_defines2.default.ENABLEROTATION, vilSettings.overlays.rotation);
	            _defines2.default.ENABLEHEATMAP = setIfDefined(_defines2.default.ENABLEHEATMAP, vilSettings.overlays.heatMap);
	        }

	        // settings.features .............................
	        if (settings.features) {
	            _defines2.default.ENABLEAUTOANNOTSAVE = setIfDefined(_defines2.default.ENABLEAUTOANNOTSAVE, vilSettings.features.annotAutoSaveEnabled);
	            _defines2.default.ENABLELINKTOIMAGE = setIfDefined(_defines2.default.ENABLELINKTOIMAGE, vilSettings.features.linkToImage);
	        }
	        // settings.iapanels .............................
	        if (settings.iapanels == undefined || settings.iapanels.panels == undefined || settings.iapanels.panels.length == 0) {
	            // if no iapanels are specified, disable the imageAnalysis button
	            self.vilSettings.toolbarOptions['imageAnalysis'] = false;
	        }

	        // report settings ...............................
	        logSettings_();
	        return status;

	        //..................................................
	        // closure functions
	        function setIfDefined(variable, value) {
	            return (0, _helpers.isDefined)(value) ? value : variable;
	        }
	    };
	    //............................................................................................
	    // plugin and VIL interface helper functions
	    //............................................................................................

	    //............................................ getImageInfo() public
	    // getImageInfo() - This function returns json of static information about the open image(s).
	    //todo: add sample type, pinned, ....
	    USCOPE_IMAGE.getImageInfo = function () {
	        var imageJson;
	        var imgSettings = []; // array of imageJson
	        for (var i = 0; i < images_.length; i++) {
	            var thisImg = images_[i];
	            if (thisImg != undefined) {
	                imageJson = {
	                    'imagePath': thisImg.getImageId(), 'fullURL': thisImg.getFullURL(),
	                    'baseMag': thisImg.getBaseMag(), 'baseMPP': thisImg.getBaseMPP(),
	                    'captureType': thisImg.getCaptureType(), 'hasALabel': thisImg.hasALabel(),
	                    'hasAThumbnail': thisImg.hasAThumbnail(), 'thumbZoom': thisImg.getThumbZoom(),
	                    'thumbWidth': thisImg.getThumbFileDims().w, 'thumbHeight': thisImg.getThumbFileDims().h,
	                    'imageWidth': thisImg.getImageWidth(), 'imageHeight': thisImg.getImageHeight(),
	                    'tileWidth': thisImg.getTileWidth(), 'tileHeight': thisImg.getTileHeight()
	                };
	                imgSettings.push(imageJson);
	            }
	        }
	        return imgSettings;
	    };
	    //............................................ getStateArray() public
	    // getStateArray - This function returns json of the view state of the open image(s).
	    USCOPE_EXTERNAL_INTERFACE.getStateArray = function (index) {
	        var imgSettings = []; // array of imageJson
	        var imageJson;

	        //..................................................
	        if (index != undefined) {
	            imageJson = imageStateGet(index);
	            if (imageJson != undefined) imgSettings.push(imageJson);
	        } else {
	            for (var i = 0; i < images_.length; i++) {
	                imageJson = imageStateGet(i);
	                if (imageJson != undefined) imgSettings.push(imageJson);
	            }
	        }
	        return imgSettings;

	        //..................................................
	        // closure functions
	        function imageStateGet(idx) {
	            var thisImg = images_[idx];
	            imageJson = undefined;
	            if (thisImg != undefined) {
	                // return send "normal" graphics coords
	                imageJson = {
	                    'imagePath': thisImg.getImageId(), 'fullURL': thisImg.getFullURL(),
	                    'x': thisImg.getViewCenterX(true), 'y': thisImg.getViewCenterY(true), 'z': thisImg.getViewFocus(),
	                    'mag': thisImg.getViewMag(),
	                    'angle': thisImg.getViewAngle(true),
	                    'sampleType': thisImg.sampleTypeGet(),
	                    'isPinned': thisImg.isPinned(),
	                    'saveAnnotations': imageInitState_[idx].saveAnnotations
	                };
	            }
	            return imageJson;
	        }

	        //..................................................
	    };
	    //............................................ navigateTo() public
	    // navigateTo() - This function translates and zooms the current images according to passed settings.
	    USCOPE_EXTERNAL_INTERFACE.navigateTo = function (imgSettings) {
	        var saveImgIdx = imageSelIdx_;
	        var slen = imgSettings.length;

	        for (var i = 0; i < images_.length; i++) {
	            imageSelIdx_ = i;
	            var thisImg = images_[i];
	            if (thisImg != undefined) {
	                var imageId = thisImg.getImageId();

	                for (var s = 0; s < slen; s++) {
	                    // find this image in the imgSettings array
	                    if (imgSettings[s].imagePath == imageId) {
	                        var settings = imgSettings[s];
	                        if ((0, _helpers.isDefined)(settings.mag)) {
	                            var zoom = thisImg.convertToZoom(settings.mag); // because imgSettings sends magnification, get what zoom that is
	                            thisImg.zoomAbsolute(zoom); // zoom as specified
	                        }
	                        //                        else if (isDefined(settings.zoom)) {
	                        //                            thisImg.zoomAbsolute(zoom);         // else zoom as specified
	                        //                        }

	                        if ((0, _helpers.isDefined)(settings.x) && (0, _helpers.isDefined)(settings.y)) // translate as specified
	                            thisImg.moveAbsoluteCenter(settings.x, settings.y, _defines2.default.coordSystemNORM);
	                        if ((0, _helpers.isDefined)(settings.angle)) // rotate as specfied
	                            thisImg.viewRotate(settings.angle);
	                    }
	                }
	            }
	        }
	        imageSelIdx_ = saveImgIdx; // restore selected image index
	    };

	    //............................................ logSettings_() local
	    // logSettings_() - This function writes the overlay enable settings to the console.
	    var logSettings_ = function logSettings_() {
	        if (_defines2.default.DBGSTART) {
	            if (_defines2.default.DISABLEOVERLAYITEMS) log(' - us.disabled: overlayitems');
	            if (!_defines2.default.ENABLESCALEBAR) log(' - disabled: scalebar');

	            if (!_defines2.default.ENABLEAUTOANNOTSAVE) log(' -- disabled: automatic annotations save');

	            // development tools
	            if (_defines2.default.DISABLEEXTERNALCALLBACKS) log(' --- disabled: external callbacks');
	            if (_defines2.default.ENABLEDEVHOTKEYS) log(' --- enabled: developer\'s hot keys');
	            if (_defines2.default.DISABLEUSERPREFS2DB) log(' --- disabled: user preferences to/from database');

	            self.events.trigger('uScope:command:log-settings', log);
	        }
	    };

	    //............................................................................................
	    // image management
	    //............................................................................................

	    //............................................ imageUpdate() public
	    //    imageUpdate - This function adds, replaces, removes or changes the state (properties) of one or more images.
	    USCOPE_EXTERNAL_INTERFACE.imageUpdate = function (action, jsonImageSet1, jsonImageSet2) {
	        var status = false;

	        ///////////////// debug block to identify dst sending its slide object ///////////////////////////////////////////////////
	        //        log("imageUpdate: caller is " + arguments.callee.caller.name);
	        //        if (jsonImageSet1 && jsonImageSet1.image && jsonImageSet1.image.thumbnailImageSrc) {
	        //            log("!!!!!!!!!!!!!!!!!!!imageUpdate: jsonImageSet1 is slide object");
	        //        }
	        //        if (jsonImageSet2 && jsonImageSet2.image && jsonImageSet2.image.thumbnailImageSrc) {
	        //            log("!!!!!!!!!!!!!!!!!!imageUpdate: jsonImageSet2 is slide object");
	        //        }
	        ////////////////////////////////////////////////////////////////////
	        var aImageState = parseImageSet_(jsonImageSet1); // parse the input settings into local arraysthe formated exactly liek the by imageInitState_ array
	        var bImageState = parseImageSet_(jsonImageSet2);

	        // in PR DST replace action, sends imagePath of just '@' in a and valid in b //todo: remove this when DST is fixed
	        if (aImageState.length == 0 && bImageState.length == 1) {
	            aImageState = bImageState;
	            action = 'add';
	        }

	        if (aImageState.length == 0) // not a failure to have no images, just return
	            return true;

	        if (action == 'add') {
	            // dispatch by action
	            if (hasDuplicates_(aImageState) == true) return false;
	            log('imageUpdate: add: ' + aImageState[0].imageId); //todo: iterate for the N images
	            var layoutInfo = buildLayoutJSON_(aImageState);
	            status = imageAdd(aImageState, layoutInfo);
	        } else if (action == 'remove') {
	            log('imageUpdate: remove: ' + aImageState[0].imageId); //todo: iterate for the N images
	            status = imageRemove(aImageState);
	        } else if (action == 'replace') {
	            // when there is NO DST and perhaps when there is no one tracking the currently open file
	            // you can ask to replace the unpinned image without specifying it
	            // Note: this is NOT normal operation with the DST - the DST must indicate which image is to be replaced to keep uScope's views in sync with the DST display
	            if (bImageState.length == 0) {
	                // if b is not passed in then replace the single unpinned image
	                bImageState = aImageState; // b is (now, as usual) the image to be opened
	                var idx = findUnPinnedImageIdx_(); // a is the image to be closed/replaced, an empty image array will cause an image add
	                aImageState = idx != -1 ? [{ 'imageId': images_[idx].getImageId() }] : [];
	            }

	            if (bImageState && aImageState[0].imageId == bImageState[0].imageId) {
	                // don't replace an image with itself
	                log('imageUpdate: replace: ' + aImageState[0].imageId + ' already open'); //todo: iterate for the N images
	                return true;
	            }
	            if (hasDuplicates_(bImageState) == true) return false;
	            var layoutInfo = buildLayoutJSON_(bImageState);
	            log('imageUpdate: replace: ' + aImageState[0].imageId + ' with ' + bImageState[0].imageId);
	            status = imageReplace(aImageState, bImageState, layoutInfo); //todo: iterate for the N images
	        } else if (action == 'state') {
	            for (var a = 0; a < aImageState.length; a++) {
	                log('imageUpdate: ' + aImageState[a].imageId + ' to state: ' + aImageState[a].sampleType);
	            }status = imageStateChange(aImageState);
	        } else {
	            log('imageUpdate: unrecognized action: ' + action);
	            return false;
	        }
	        (0, _events.triggerUScopeEvent)(_defines2.default.evIMAGEUPDATE, {}); // fire event: imageupdate completed
	        return status;

	        //..................................................
	        // closure functions

	        //..................................................  findUnPinnedImage_
	        function findUnPinnedImageIdx_() {
	            for (var i = 0; i < images_.length; i++) {
	                if (images_[i] != undefined && images_[i].isPinned() == false) return i;
	            }
	            return -1;
	        }

	        //..................................................  parseVILImage_
	        // parseVILImage_ - This function returns a json object of validated image initial settings, return false if not parsable
	        function parseVILImage_(aImage) {
	            // initialize the return json object .............
	            var bImage = {
	                // begin official interface vars.........................................
	                fullURL: aImage.fullURL, //e.g. /imageserver/@@token/@imageid2 or //host:82/@@token/@imageid

	                // initial view settings: priority of view state:
	                //        1st: regionId  2nd: xyz&mag 3rd: last selected region from annotations xml
	                regionId: undefined,
	                centerX: undefined, centerY: undefined, // center of view X,Y position in base image coords
	                focus: undefined, // focus depth (z)
	                mag: 'Fit', // magnfication value or "Fit", "Scan", "2", "4", ...
	                zoom: undefined, // specified only when conferencing
	                angle: 0,

	                saveAnnotations: true, // default saveAnnotations to true (user rights - really means create annotations)
	                title: undefined,
	                sampleType: 'patient', // default sample type
	                isPinned: false, // default pinned status
	                // end official interface vars...........................................

	                // derived vars .........................................................
	                server: undefined, //e.g. /imageserver/  -  always via apache (not imageserver direct)
	                token: undefined, //e.g. @@f5gHzmgSn6URMsJeIVbg==
	                imageId: undefined // image identifier; e.g. @2 or imageserver/filename.ext
	            };
	            // parse image url ...............................
	            if ((0, _helpers.isDefined)(bImage.fullURL) && bImage.fullURL.length) {
	                // case 1: If you put a * in servers_list.php's External Host Names field, it will use the proxy rule, e.g./imageserver/@@token/@imageid
	                // case 2: If you make the External Host Names field empty, it will talk to ImageServer directly, e.g. //host:82/@@token/@imageid
	                // case 3: //host/redirect/@@token==/@id

	                var thisURL = bImage.fullURL;
	                bImage.server = thisURL.slice(0, thisURL.indexOf('@@')); // = /imageserver/
	                bImage.server.toLowerCase(); // url is always lowercase but just be sure

	                var tokenPlus = thisURL.slice(-(thisURL.length - thisURL.indexOf('@@'))); //  = @@f5gHzmgSn6URMsJeIVbg==/@2
	                bImage.imageId = tokenPlus.slice(-(tokenPlus.length - tokenPlus.indexOf('/@') - 1)); // = @2
	                bImage.token = tokenPlus.slice(0, tokenPlus.indexOf('/@')); // = @@f5gHzmgSn6URMsJeIVbg==

	                var partialToken = bImage.token.slice(0, 8) + bImage.token.slice(-4); // don't report the full token
	                if (_defines2.default.DBGSTART) log('parseVILImage_:  Server: ' + bImage.server + '   token: ' + partialToken + '   imageId: ' + bImage.imageId);
	            } else if (aImage.imagePath && aImage.imagePath.indexOf('@') === 0) {
	                // if fullURL is not given, this is usually uScope stand alone test harness driven (uname, pword given)
	                var rawId = (0, _helpers.stripLeadingAtSign)(aImage.imagePath);
	                if ((0, _helpers.isNumber)(rawId) == false) return err('parseVILImage_: invalid imagePath: ' + aImage.imagePath);

	                bImage.imageId = aImage.imagePath;
	                bImage.server = '/imageserver/';
	                log('parseVILImage_: fullURL missing, imagePath alone will be used.');
	            } else {
	                // here's where you'd look for a filepath but since that isn't handled yet
	                return false;
	            }

	            // parse image initial state ...............................
	            if ((0, _helpers.isDefined)(aImage.x) && (0, _helpers.isNumber)(aImage.x)) bImage.centerX = Math.round(aImage.x);
	            if ((0, _helpers.isDefined)(aImage.y) && (0, _helpers.isNumber)(aImage.y)) bImage.centerY = Math.round(aImage.y);
	            if ((0, _helpers.isDefined)(aImage.z) && (0, _helpers.isNumber)(aImage.z)) bImage.focus = Math.round(aImage.z);
	            if ((0, _helpers.isDefined)(aImage.mag) && ((0, _helpers.isNumber)(aImage.mag) || aImage.mag === 'Fit' || aImage.mag === 'Scan')) // mag can be "Fit", "Scan"
	                bImage.mag = aImage.mag;
	            if ((0, _helpers.isDefined)(aImage.zoom)) // conferencing initial state specifies a zoom not a mag - conf is only time zoom is specified
	                bImage.zoom = aImage.zoom;
	            if ((0, _helpers.isDefined)(aImage.angle)) bImage.angle = aImage.angle;

	            if ((0, _helpers.isDefined)(aImage.SaveAnnotations)) // input capital S from user rights
	                bImage.saveAnnotations = aImage.SaveAnnotations;else if ((0, _helpers.isDefined)(aImage.saveAnnotations)) // input small s from user rights
	                bImage.saveAnnotations = aImage.saveAnnotations;

	            if ((0, _helpers.isDefined)(aImage.title)) bImage.title = aImage.title;
	            if ((0, _helpers.isDefined)(aImage.sampleType)) bImage.sampleType = aImage.sampleType;
	            if ((0, _helpers.isDefined)(aImage.isPinned)) bImage.isPinned = aImage.isPinned;
	            if ((0, _helpers.isDefined)(aImage.regionId) && (0, _helpers.isNumber)(aImage.regionId)) bImage.regionId = aImage.regionId;
	            return bImage;
	        }

	        //..................................................  parseImageSet_
	        //    parseImageSet_ - This function parses the input json image data into the format used by imageInitState_ array.
	        function parseImageSet_(jsonImageSet) {
	            var rtnArray = [];
	            if (jsonImageSet != undefined) {

	                if (jsonImageSet.image) {
	                    // original single image format
	                    var imgState = parseVILImage_(jsonImageSet.image);
	                    if (imgState != false) rtnArray.push(imgState);
	                } else {
	                    // multi-image format
	                    for (var i = 0, len = jsonImageSet.length; i < len; i++) {
	                        var imgState = parseVILImage_(jsonImageSet[i]); // separates server,token,imageid; sets undefined parms to defaults
	                        if (imgState != false) rtnArray.push(imgState);else err('imageUpdate: parseImageSet_: input image object could not be parsed');
	                    }
	                }
	            }
	            return rtnArray;
	        }

	        //..................................................  buildLayoutJSON_
	        //    buildLayoutJSON_ - This function builds a list of information needed for cViewLayout to append an image.
	        //        The information includes imageId, sampleType, vpclassid, and the outer viewport div, "jImgDiv"
	        //        The outer viewport div is built here by calling buildVPDiv_() but is not sized.

	        function buildLayoutJSON_(aImageState) {
	            var appendList = [];
	            for (var i = 0; i < aImageState.length; i++) {
	                // build the appendList that contains each image's key info nec. for viewLayout_ to manage it
	                var vpclassid = _defines2.default.classFromImageId(aImageState[i].imageId); // convert the imageId into a class name
	                if (vpclassid != undefined) {
	                    // create the outer viewport div with the imageId as a class
	                    var jVpDivOuter = buildVPDiv_(vpclassid, false); //
	                    appendList.push({
	                        imageId: aImageState[i].imageId,
	                        sampleType: aImageState[i].sampleType,
	                        vpclassid: vpclassid,
	                        jImgDiv: jVpDivOuter
	                    });
	                }
	            }
	            return appendList;
	        }

	        //..................................................  hasDuplicates_
	        //    hasDuplicates_ - This function returns true if any image is duplicated in the input image list
	        //                    or if any of those images are currently opened. otherwise it returns false;
	        function hasDuplicates_(aImageState) {
	            var alen = aImageState.length;
	            for (var i = 0; i < alen; i++) {
	                // check if any image in aImageState is already open
	                var imageIdx = findImageIdx_(aImageState[i].imageId);
	                if (imageIdx != -1) {
	                    // if the imageId IS in the currently opened image list
	                    if (aImageState[i].server == images_[imageIdx].getServer()) {
	                        // if both the server name and the imageId match
	                        err('imageUpdate: input image is already opened.');
	                        return true;
	                    }
	                }
	            }

	            for (var i = 0; i < alen; i++) {
	                // check if any image in aImageState is duplicated in aImageState
	                for (var j = i + 1; j < alen; j++) {
	                    if (aImageState[i].imageId == aImageState[j].imageId && aImageState[i].server == aImageState[j].server) {
	                        err('imageUpdate: input image is duplicated.');
	                        return true;
	                    }
	                }
	            }
	            return false;
	        }

	        //..................................................
	    };

	    //............................................ buildVPDiv_() local
	    // buildVPDiv_ - This function creates the outer or inner viewport div and always returns the outer div.
	    //                It does not size the div(s).
	    // Notes:
	    //        o create the VIEWPORT divs with the imageId as a class to uniquely identify them
	    //        o vpclassid is an additional call on the viewport divs to differentiate each image's viewports
	    //        o the outer vp div  is defined with the tabindex attribute so it can recieve key strokes
	    var buildVPDiv_ = function buildVPDiv_(vpclassid, bBuildInner) {
	        var jVpDivOuter;
	        if (bBuildInner == false) {
	            // create the outer VP div
	            jVpDivOuter = $('<div/>', { 'class': _defines2.default.clsOUTERVIEWPORT + ' ' + vpclassid });
	            jVpDivOuter.attr({ 'tabindex': 0 }); // for keystroke focus
	        } else {
	            // create the inner VP div
	            jVpDivOuter = $('.' + _defines2.default.clsOUTERVIEWPORT + '.' + vpclassid); // find the outer
	            jVpDivOuter.append($('<div/>', { 'class': _defines2.default.clsVIEWPORT + ' ' + vpclassid, 'id': vpclassid })); //ol3

	            if (_defines2.default.DISPLAYMARKUP) {
	                // create the MARKUP div with the imageId as a class
	                jVpDivOuter.append($('<div/>', { 'class': _defines2.default.clsDIVMARKUP + ' ' + vpclassid })); ///how to get attr inside this here!!!
	            }
	        }
	        return jVpDivOuter;
	    };
	    //............................................ imageAdd() public
	    // This function adds images to the existing layout
	    //        or if no images exist yet (and therefore no layout) it creates a layout and adds the images.
	    //
	    //    aImageState:    an array of initial states for the images....
	    //    layoutInfo:        an array of specific information for the cViewLayout object
	    //
	    //    Note that this fn uses layout's append() to add images when none are displayed
	    //        and expand() to add images when some are already present

	    var imageAdd = function imageAdd(aImageState, layoutInfo) {
	        var curImageCount = self.getImageCount();
	        if (curImageCount == _defines2.default.multiSpecs.maxImages) // sanity check
	            return err('Maximum number of images reached, will not add new image(s)');

	        var status = true;
	        var openIdx = 0; // first image in imageInitState_ that needs to be opened

	        if (viewLayout_ == undefined) {
	            // ...................... create a new layout
	            layoutInfo.length = Math.min(layoutInfo.length, _defines2.default.multiSpecs.maxImages); // reduce num new images if necessary to enforce max image limit
	            if (layoutInfo.length == 0) return false; // nothing to do

	            rootRectCompute_(); // insure rootRect_ is up to date
	            // construct the layout into the uScope div, size it
	            viewLayout_ = new _viewLayout2.default($(_defines2.default.idHashROOT), self.rootRect_, layoutInfo.length, onResizePane_);
	            status = viewLayout_.status; // check construction status
	            if (status == true) status = viewLayout_.append(layoutInfo); // arrange the images in panes and append their outer viewports to their panes
	            if (status == true) {
	                imageInitState_ = aImageState; // initialize the image state array with this/these image[s]
	                (0, _toolbar.setIconState)($('#' + _defines2.default.idTBMULTIVIEW), _defines2.default.idTBMULTIVIEW, viewLayout_.getPaneDesc());
	            }
	        } else {
	            // ...................... change an existing layout
	            layoutInfo.length = Math.min(layoutInfo.length, _defines2.default.multiSpecs.maxImages - curImageCount); // reduce num new images if necessary to enforce max image limit
	            if (layoutInfo.length == 0) return false; // nothing to do

	            var newImageCount = curImageCount + layoutInfo.length;
	            // construct the layout into the uScope div, size it
	            var newviewLayout_ = new _viewLayout2.default($(_defines2.default.idHashROOT), self.rootRect_, newImageCount, onResizePane_);
	            status = newviewLayout_.status; // check construction status
	            if (status == true) status = newviewLayout_.expand(viewLayout_, layoutInfo);
	            if (status == true) {
	                viewLayout_ = newviewLayout_; // replace ref to viewLayout_ with new layout
	                onResizePane_();

	                openIdx = imageInitState_.length; // first image in the list that needs to be opened
	                imageInitState_ = imageInitState_.concat(aImageState);

	                (0, _toolbar.setIconState)($('#' + _defines2.default.idTBMULTIVIEW), _defines2.default.idTBMULTIVIEW, viewLayout_.getPaneDesc());
	            }
	        }

	        if (status == true) {
	            // for each new image: append the innner viewport and open the image into it

	            for (var i = openIdx, len = imageInitState_.length; i < len; i++) {
	                var vpclassid = layoutInfo[i - openIdx].vpclassid;
	                var jVpDivOuter = buildVPDiv_(vpclassid, true);
	                var imgStatus = createViewport(i); // open this image
	                status = status && imgStatus;
	            }
	        }
	        return status;
	    };

	    //............................................ imageRemove()
	    //    imageReplace - This function closes one or more open images.
	    var imageRemove = function imageRemove(aImageState) {
	        if (viewLayout_ == undefined) {
	            log('imageRemove: no layout defined');
	            return false;
	        }

	        var status = true;
	        for (var a = 0, len = aImageState.length; a < len; a++) {
	            var imageId = aImageState[a].imageId;
	            imageClose1ById(imageId);
	            // modify this viewLayout_ (change will not take immediate effect)
	            viewLayout_.remove(imageId);
	        }

	        // now create a new layout of just the current images
	        var newImageCount = self.getImageCount();
	        if (newImageCount == 0) {
	            viewLayout_ = undefined;
	            log('imageRemove: no images open.');
	            return true;
	        }

	        // construct the layout into the uScope div, size it
	        var newviewLayout_ = new _viewLayout2.default($(_defines2.default.idHashROOT), self.rootRect_, newImageCount, onResizePane_);
	        status = newviewLayout_.status; // check construction status
	        if (status == true) status = newviewLayout_.compress(viewLayout_); // move the viewport Divs from viewLayout_ into newviewLayout_
	        if (status == true) {
	            viewLayout_ = newviewLayout_; // replace ref to viewLayout_ with new layout
	            onResizePane_();
	            (0, _toolbar.setIconState)($('#' + _defines2.default.idTBMULTIVIEW), _defines2.default.idTBMULTIVIEW, viewLayout_.getPaneDesc());
	        }
	        return status;
	    };

	    //............................................ imageReplace()
	    //    imageReplace - This function closes one image and opens another in its place.
	    //    aImageState - image to be replaced
	    //    bImageState - new image
	    //    layoutInfo - of new image
	    var imageReplace = function imageReplace(aImageState, bImageState, layoutInfo) {
	        if (viewLayout_ == undefined) {
	            log('uScope: imageReplace: no layout defined, calling imageAdd');
	            return imageAdd(bImageState, layoutInfo);
	        }
	        if (aImageState.length != bImageState.length) {
	            log('imageReplace: lopsided image arrays');
	            return false;
	        }

	        var status = true;
	        for (var a = 0, len = aImageState.length; a < len; a++) {

	            var imageId = aImageState[a].imageId;
	            var imageIdx = imageClose1ById(imageId); // close image first
	            if (imageIdx != -1) imageInitState_[imageIdx] = bImageState[a]; // update the init state array with the replacement image

	            status = viewLayout_.replace(imageId, layoutInfo[a]); // update the layout with the replacement image
	            if (status == true) {
	                var vpclassid = layoutInfo[a].vpclassid;
	                // NOTE (cc): Originally  buildVPDiv_ was assigned to an implicit global called jVpDivOuter. buildVpDiv()
	                // does real work (it creates the required DOM structure for the next image's viewport), but jVpDivOuter
	                // recalculated and used elsewhere.
	                buildVPDiv_(vpclassid, true);
	                createViewport(imageIdx); // open the replacement image
	            }
	        }
	        return status;
	    };
	    //............................................ imageArrange()
	    // This function changes the arrangement of panes (aka layout) to the next in the sequence.
	    USCOPE_IMAGE.imageArrange = function (reArrange) {

	        var newPaneDesc = viewLayout_.getNextPaneDesc();
	        if (newPaneDesc.length) {
	            var curImageCount = self.getImageCount();
	            // construct the layout into the uScope div, size it
	            var newviewLayout_ = new _viewLayout2.default($(_defines2.default.idHashROOT), self.rootRect_, curImageCount, onResizePane_, newPaneDesc);
	            var status = newviewLayout_.status; // check construction status
	            if (status == true) status = newviewLayout_.compress(viewLayout_); // arrange the images in panes and append their outer viewports to their panes
	            if (status == true) {
	                viewLayout_ = newviewLayout_; // replace ref to viewLayout_ with new layout
	                onResizePane_();

	                (0, _toolbar.setIconState)($('#' + _defines2.default.idTBMULTIVIEW), _defines2.default.idTBMULTIVIEW, viewLayout_.getPaneDesc());
	            } else {//todo: and for all other layout fns
	            }
	        }
	    };
	    //............................................ imageStateChange()
	    //    This function executes external image state changes.
	    //    Image state changes handled are:
	    //        sampleType:    when an opened image's sampleType is changed
	    //
	    var imageStateChange = function imageStateChange(aImageState) {

	        if (viewLayout_ == undefined) {
	            log('imageStateChange: no layout defined');
	            return false;
	        }

	        var status = true;
	        var bDoNewLayout = false;
	        for (var a = 0, len = aImageState.length; a < len; a++) {
	            var imageId = aImageState[a].imageId;
	            var imageIdx = findImageIdx_(imageId); // find the image in images_
	            if (imageIdx >= 0) {
	                //debug-only log("....imageStateChange: " + imageId + "sampleType:   from: " + imageInitState_[imageIdx].sampleType + "  to: " + aImageState[a].sampleType);
	                if (aImageState[a].sampleType != undefined // sampleType change
	                && aImageState[a].sampleType != imageInitState_[imageIdx].sampleType) {
	                    var sampleType = aImageState[a].sampleType;

	                    //todo: should I insure there are no other sample types of this kind?
	                    imageInitState_[imageIdx].sampleType = sampleType; // change the image sample type//cp-not sure this is nec, vp holds it
	                    images_[imageIdx].sampleTypeSet(sampleType); // tell the viewport of the sample type change

	                    // modify this viewLayout_ (change will not take immediate effect)
	                    viewLayout_.stateChange(aImageState[a].imageId, 'sampleType', sampleType);

	                    bDoNewLayout = true;
	                }
	                if (aImageState[a].isPinned != undefined // isPinned change
	                && aImageState[a].isPinned != imageInitState_[imageIdx].isPinned) {
	                    //debug-only log("....imageStateChange: " + imageId + "isPinned:   from: " + imageInitState_[imageIdx].isPinned + "  to: " + aImageState[a].isPinned);
	                    var isPinned = aImageState[a].isPinned;
	                    imageInitState_[imageIdx].isPinned = isPinned; // change the image pinned state//cp-not sure this is nec, vp holds it
	                    images_[imageIdx].isPinnedSet(isPinned); // tell the viewport of the pinned state change
	                }
	            }
	        }

	        if (bDoNewLayout == true) {
	            // if a state change really was specified,

	            // note that imageInitState_.length !=  self.getImageCount() b/c holes can be created in the array
	            // construct the layout into the uScope div, size it
	            var newviewLayout_ = new _viewLayout2.default($(_defines2.default.idHashROOT), self.rootRect_, self.getImageCount(), onResizePane_);
	            status = newviewLayout_.status; // check construction status
	            if (status == true) status = newviewLayout_.compress(viewLayout_); // move the viewport Divs from viewLayout_ into newviewLayout_

	            if (status == true) {
	                viewLayout_ = newviewLayout_; // replace ref to viewLayout_ with new layout
	                onResizePane_();
	                (0, _toolbar.setIconState)($('#' + _defines2.default.idTBMULTIVIEW), _defines2.default.idTBMULTIVIEW, viewLayout_.getPaneDesc());
	            }
	        }
	        return status;
	    };
	    //............................................ imageOpen() public
	    //    imageOpen - This function opens the images parsed into the imageInitState_ array.
	    //todo: remove me soon - replaced by imageUpdate("add", ...)
	    USCOPE_IMAGE.imageOpen = function (imgSettings) {
	        if (initStatus == false) {
	            // do not open images if initialization failed
	            log('imageOpen: Cannot open image(s) because start up initialization failed');
	            return initStatus;
	        }
	        self.imageClose(); // close ALL open images
	        viewLayout_ = undefined; // destroy the current view layout
	        return self.imageUpdate('add', imgSettings); // and rebuild it with the new imageset
	    };
	    //............................................ createViewport() local
	    //    createViewport - This function opens the passed imageId by creating a viewport div,
	    //                attaching them to the root node, creating a viewport object related to that div,
	    //                and adding the new image to the image array.
	    //
	    //    Input parameters: imageInitState_[idx] contains the following - where idx is the image index -
	    //        imageID:    required, image id number starting with the @ sign or filename starting with imageserver/
	    //        rectDiv:    required, the position in the root div of this viewport
	    //
	    //        centerX:    optional, initial center of view X position
	    //        centerY:    optional, initial center of view X position
	    //        focus:        optional, initial focus (z position)
	    //        mag:         optional, initial magnfiction
	    //        regionId:    optional, initial region to center view on
	    //        zoom:        optional, initial zoom
	    //        angle:        optional, initial rotation angle in degrees
	    //    added to the json:
	    //        uScopeIdx:    required, the index into uScope's images_ array of this image
	    //
	    var createViewport = function createViewport(idx) {
	        imageInitState_[idx].uScopeIdx = idx; // add the index into uScope's images_ array  of this image
	        var initState = imageInitState_[idx]; // don't open if imageId isn't valid

	        if (self.getImageCount() == 0) {
	            // on very first open, report how uscope communicates with ImageServer
	            if (self.isConnectedViaApache() == false) log('\t*** createViewport: Communicating directly with ImageServer ***', initState.imageId);else log('\t*** createViewport: Communicating via Apache with ImageServer ***', initState.imageId);
	        }

	        if ((0, _helpers.isUnDefined)(initState.imageId) || initState.imageId.length === 0 || _defines2.default.classFromImageId(initState.imageId) === undefined) return false;

	        var imageId = initState.imageId;
	        var vpclassid = _defines2.default.classFromImageId(imageId); // convert the imageId into a class name
	        if ((0, _helpers.isUnDefined)(vpclassid)) // and return error of the class name isn't valid
	            return false;

	        var viewport = new _viewportAP2.default(initState, self); // open the image into this viewport

	        self.events.trigger('uscope:image:init', viewport);

	        viewport.open();

	        var openStatus = viewport.getStatus();
	        if (openStatus == true) {
	            images_[idx] = viewport; // add this image to image container
	            imageCountFromStart_++; // update image open count since uscopestart
	        }

	        self.events.trigger('uscope:image:open', openStatus, viewport);

	        return openStatus;
	    };
	    //............................................ closeAllButSelectedImage() public
	    //    closeAllButSelectedImage - This function closes all open images except the selected image.
	    USCOPE_IMAGE.closeAllButSelectedImage = function () {
	        if (self.getImageCount > 1) {
	            for (var i = 0; i < images_.length; i++) {
	                if (i != imageSelIdx_ && images_[i] != undefined) {
	                    //debug-only log("self.closeAllButSelectedImage: triggering us.evIMAGECLOSE", images_[i].getImageId());
	                    (0, _events.triggerUScopeEvent)(_defines2.default.evIMAGECLOSE, { imageId: images_[i].getImageId() });
	                }
	            }
	        }
	    };
	    //............................................ imageClose() public
	    //    imageClose - This function closes all open images.
	    //todo: really this is a close all function and really it could be incorportated into imageupdate and really it should use us.evIMAGECLOSE
	    USCOPE_EXTERNAL_INTERFACE.imageClose = function () {
	        for (var i = 0; i < images_.length; i++) {
	            imageClose1(i);
	        }
	        imageSelIdx_ = 0; // reset the current image ptr
	        images_.length = 0; // clear the array - maybe not necessary?

	        //toconsider: should the settings panel be deleted and protected from opening?
	    };

	    //............................................ imageClose1ById() local
	    //    imageClose1ById - This function closes the image with the passed imageId
	    var imageClose1ById = function imageClose1ById(imageId) {
	        var imageIdx = findImageIdx_(imageId); // find the image in images_
	        if (imageIdx >= 0) imageClose1(imageIdx); // close this image
	        else log('imageClose1ById: image is not open: ' + imageId);
	        return imageIdx;
	    };
	    //............................................ imageClose1() local
	    //    imageClose1 - This function closes the image at images_[imageIdx].

	    var imageClose1 = function imageClose1(imageIdx) {
	        var thisImg = images_[imageIdx];

	        if (thisImg != undefined) {
	            var imageId = thisImg.getImageId();
	            var vpclassid = _defines2.default.classFromImageId(imageId); // convert the imageId into a class name

	            thisImg.imageClose(); // close the image

	            // faster to prevent memory leak and speed up DST switching images
	            $('.' + _defines2.default.clsVIEWPORT + '.' + vpclassid).remove();
	            $('.' + _defines2.default.clsOUTERVIEWPORT + '.' + vpclassid).detach().removeData();

	            images_[imageIdx] = undefined;
	            imageInitState_[imageIdx] = undefined;
	        }
	    };
	    //............................................................................................
	    // uscope root div managment
	    //............................................................................................

	    var rootRect_; // uScope div position and dimensions; updated upon resize event

	    //............................................ rootRectCompute_() local
	    //    rootRectCompute_ - This function returns the current root div dimension and the root div desired
	    //        position.  When not-in-development-mode the root div position must be 0,0 - relative to
	    //        its normal position.
	    var rootRectCompute_ = function rootRectCompute_() {
	        var rootPos = $(_defines2.default.idHashROOT).offset(); // position relative to the document
	        self.rootRect_ = new _objects.cRect(rootPos.left, rootPos.top, $(_defines2.default.idHashROOT).width(), $(_defines2.default.idHashROOT).height());

	        //debug-only log("rootRectCompute_: " + self.rootRect_.toString() );
	        return self.rootRect_;
	    };
	    //............................................ rootRectGet() public
	    USCOPE_GET.rootRectGet = function () {
	        return self.rootRect_ == undefined ? rootRectCompute_() : self.rootRect_;
	    };
	    //............................................ resize() public
	    //    resize - This function sets the width and height of the root div.
	    //        If not in-development-mode (e.g. not on its own page but given a div next to the DST)
	    //            then there is a pr-esized 'idRoot' div for this function to return.
	    //        If in-development-mode this function determines the maximum size possible to fill the
	    //            window and sizes the 'idRoot' div accordingly.
	    USCOPE_EXTERNAL_INTERFACE.resize = function () {
	        var jRoot = $('#' + _defines2.default.idROOT);
	        if (self.isModeDev() == false) {
	            // when NOT in dev mode
	            if (jRoot.length === 0) {
	                // make sure that the uscope div is defined
	                return err('self.resize: uscope div is not defined.');
	            } else if (jRoot.width() < 10) {
	                // make sure that the uscope div is sized.
	                return err('self.resize: uscope div is not sized.');
	            }
	            if (_defines2.default.DBGRESIZE) {
	                log('self.resize: New WxH: ' + jRoot.width() + 'x' + jRoot.height());
	            }
	        }

	        // in dev mode I size the uscope div myself if it is not already sized
	        if (self.isModeDev() == true && $(_defines2.default.idHashROOT).width() < 20 && $(_defines2.default.idHashROOT).height() < 20) {
	            if (_defines2.default.DBGRESIZE) {
	                var rect = rootRectCompute_();
	                log('self.resize: rootpos initial:' + rect.toString());
	            }
	            var innerDims = (0, _compatibility.getInnerDims)(innerDims);
	            var width = Math.floor(innerDims.w - 1);
	            var height = Math.floor(innerDims.h - 1); // w/o -1 had seen scroll bars when resized
	            $(_defines2.default.idHashROOT).width(width).height(height);

	            //debug-only log("self.resize: Dev Mode: New WxH: " + jRoot.width() + "x" + jRoot.height());
	        }

	        rootRectCompute_(); // insure rootRect_ is up to date
	        if (viewLayout_) {
	            // check b/c when opened w/o an image, no layout is defined
	            viewLayout_.onResize(self.rootRect_); // update the layout panes
	            onResizePane_(); // now the viewports inside the panes can be resized

	            self.events.trigger('uscope:resize');
	        }
	        return true;
	    };
	    //............................................ onResizePane_() local
	    // onResizePane_ - This function is a callback when a pane is resized and called directly when the browser or DST resizes
	    var onResizePane_ = function onResizePane_(paneName, paneElement, paneState, paneOptions, layoutName) {
	        if (images_.length == 0) return;

	        //debug-only log("onResizePane_:  layoutName: " + viewLayout_.getLayoutName() + "   paneName: " + paneName + "  nImages: " + self.getImageCount());

	        rootRectCompute_(); // insure rootRect_ is up to date
	        for (var i = 0; i < images_.length; i++) {
	            // resize each viewport
	            var thisImg = images_[i];
	            if (thisImg) thisImg.viewResize(false); // false means do not resize thumbnail
	        }
	    };
	    //............................................................................................
	    // user preference management
	    //............................................................................................
	    var userPrefs = new _userPrefs2.default(); // create user preference object

	    // note - getAllPrefs: because imageID is req'd by DB this fn must be run when opening an image
	    //            instead of the preferred run on cUserPref construction
	    // note - prefsGetAll need only be called once
	    var prefsAllComplete = false;
	    //............................................ prefsGetAll public
	    //    prefsGetAll - This function requests all user preferences .
	    USCOPE_PREFS.prefsGetAll = function (vpObj) {
	        if (prefsAllComplete == false) // call once
	            userPrefs.getAll(vpObj);
	        prefsAllComplete = true;
	    };
	    //............................................ prefGet public
	    //    prefGet - This function returns a specific, cached, user preference.
	    USCOPE_PREFS.prefGet = function (name, defaultVal) {
	        return userPrefs.get(name, defaultVal);
	    };
	    //............................................ prefSet public
	    //    prefSet - This function sets a specific user preference.
	    USCOPE_PREFS.prefSet = function (name, value) {
	        userPrefs.set(name, value);
	    };

	    //............................................................................................
	    // initialization
	    //............................................................................................

	    //............................................ reset() public
	    // reset - This function resets to default values uScope vars that are initialized at uScopeStart.
	    USCOPE_EXTERNAL_INTERFACE.reset = function () {
	        userPrefs.reset();
	        createdBy = '';
	        userName = '';
	        userId = -1;
	        title = '';

	        imageInitState_.length = 0; // clear the array
	        images_.length = 0; // clear the array
	        imageSelIdx_ = 0; //

	        viewLayout_ = undefined;
	    };

	    //............................................ enforceBrowserDependentSettings local
	    //    This function enforces browser dependent settings.
	    //    It overwrites the input settings and sets the appropriate feature switches.
	    var enforceBrowserDependentSettings = function enforceBrowserDependentSettings() {
	        var vilSettings = self.vilSettings;
	        if (_defines2.default.supportsCanvas == false) // disable any features that are canvas dependent
	            _defines2.default.ENABLEHEATMAP = false;

	        _defines2.default.supportsLocalStorage = supports_localStorage(); // identify browser local storage ability

	        if (_compatibility.BrowserDetect.isIE()) {
	            // disable for ie.......................
	            if (_compatibility.BrowserDetect.isIEBelow9()) {
	                vilSettings.overlays.rotation = false;
	                vilSettings.overlays.heatMap = false;
	                _defines2.default.ENABLEDRAGMOMENTUM = false; // IE8 is slow enough, try doing less
	                _defines2.default.USEMULTIPYRAMIDLEVELS = false;
	            }
	        }
	        if (_compatibility.BrowserDetect.isIOS()) {
	            // disable for ios.....................
	            _defines2.default.ENABLEZOOMSLIDER = false; // no need for the slider in ios

	            _defines2.default.kTILEMULTIPLIER = 1; // small view in iOS uses single tile dims
	        }

	        if (_compatibility.BrowserDetect.isFirefox()) {// disable for firefox.................
	        }

	        if (_compatibility.BrowserDetect.isChrome()) {// disable for chrome..................
	        }
	    };

	    //............................................ init - This function initializes self.
	    // Note: because this fn sizes the uscope div, it is called by uScopeStart
	    USCOPE_EXTERNAL_INTERFACE.init = function () {
	        initStatus = self.resize(); // get uScope div size; sanity check it;

	        self.topToolbar = new _toolbar.cToolbar();

	        if (_defines2.default.ENABLECONTEXTMENU == true) {
	            self.regToolbar = (0, _regionToolbar2.default)();
	        }

	        ////////////////////////////////////////////////////////////////////////////////////////inwork
	        // settings.toolbarOptions .......................
	        _defines2.default.ENABLEANALYSIS = self.toolbarCanAddButton('imageAnalysis'); // global switch  //todo: revisit the necessity of this setting
	        _defines2.default.DISPLAYMARKUP = _defines2.default.DISPLAYMARKUP && _defines2.default.ENABLEANALYSIS; // global switch  //todo: uscope settings / user prefs will define
	        ////////////////////////////////////////////////////////////////////////////////////////

	        // set a flag indicating if function getPropertyValue is/isn't available - perf improvement
	        if (self.bHasPropertyValue == undefined) {
	            var jVar = $(document).find(_defines2.default.idHashROOT);
	            self.bHasPropertyValue = jVar[0].style.getPropertyValue ? true // Chrome, FF13, FF12,  IE9
	            : false; // IE7, IE8
	        }

	        bindEvents_();

	        if (initStatus == false) {
	            log('init: Start up initialization failed');
	        }

	        self.events.trigger('uscope:init', initStatus);

	        return initStatus;
	    };

	    function bindEvents_() {
	        var namespace = '.uscope';
	        if (_defines2.default.ENABLECONTEXTMENU == false) $(_defines2.default.idHashROOT).on('contextmenu' + namespace, function (e) {
	            return false;
	        }); // disable context menu on all of uscope
	        else $('.' + _defines2.default.clsPANEL).on('contextmenu' + namespace, function (e) {
	                return false;
	            }); // disable context menu on panels to prevent region toolbar from activating over the panels

	        $(_defines2.default.idHashROOT).on(_defines2.default.evREGIONSELECT + namespace, function (e, parms) {
	            // log("Event: " + e.type + "  " + toStringAssoc(parms));
	            var thisImg = self.getThisImageById(parms.imageId);
	            if (thisImg) {
	                thisImg.getAnnotObj().regSelect(parms);
	            }
	        });
	        $(_defines2.default.idHashROOT).on(_defines2.default.evLAYERSELECT + namespace, function (e, parms) {
	            //log("Event: " + e.type + "  " + toStringAssoc(parms));
	            var thisImg = self.getThisImageById(parms.imageId);
	            if (thisImg) {
	                thisImg.getAnnotObj().layers.selectByProperty('Id', parms.LayerId);

	                //toconsider: should this select a region in the layer?  would that cause cycling?
	                //    if no regions then rfSelected would be -1;
	            }
	        });

	        $(_defines2.default.idHashROOT).on(_defines2.default.evMARKUPCHANGE + namespace, function (e, parms) {
	            // log("Event: " + e.type + "  " + toStringAssoc(parms));
	            var thisImg = self.getThisImageById(parms.imageId);
	            if (thisImg) thisImg.showMarkup(parms.show);
	        });
	        $(_defines2.default.idHashROOT).on(_defines2.default.evREGIONDELETE + namespace, function (e, parms) {
	            // log("Event: " + e.type + "  " + toStringAssoc(parms));
	            var thisImg = self.getThisImageById(parms.imageId);
	            if (thisImg) thisImg.getAnnotObj().regDelete(parms.regionId);
	        });
	    }

	    function unbindEvents() {
	        var namespace = '.uscope';
	        var $rootNode = $(_defines2.default.idHashROOT);

	        $rootNode.off('contextmenu' + namespace);
	        $('.' + _defines2.default.clsPANEL).off('contextmenu' + namespace);

	        $rootNode.off(_defines2.default.evREGIONSELECT + namespace);
	        $rootNode.off(_defines2.default.evLAYERSELECT + namespace);
	        $rootNode.off(_defines2.default.evMARKUPCHANGE + namespace);
	        $rootNode.off(_defines2.default.evREGIONDELETE + namespace);
	    }

	    USCOPE_EXTERNAL_INTERFACE.destroy = function () {
	        self.imageClose();
	        self.reset();
	        self.events.$destroy();
	        unbindEvents();
	        UScopeViewer.instance = undefined;
	    };

	    //............................................ construction
	    construct_();
	}

	// ---------------------------------  helper functions  --------------------------------------------

	/**
	 * This function creates a dummy <canvas> element (it is never attached to the page) and tests for its presence by
	 * testing for getContext which only exists if the browser supports the canvas API.
	 * Reference:  http://diveintohtml5.info/detect.html#canvas
	 * @returns {boolean}
	 */
	function supports_canvas() {
	    return !!document.createElement('canvas').getContext;
	}

	/**
	 * Tests if the browser supports local storage
	 * @returns {boolean}
	 */
	function supports_localStorage() {
	    return window.localStorage ? true : false;
	}
	module.exports = exports['default'];

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = cRequestQueue;

	var _defines = __webpack_require__(3);

	var _defines2 = _interopRequireDefault(_defines);

	var _compatibility = __webpack_require__(6);

	var _helpers = __webpack_require__(8);

	var _events = __webpack_require__(10);

	var _toolbar = __webpack_require__(5);

	var _uScope = __webpack_require__(11);

	var _uScope2 = _interopRequireDefault(_uScope);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	//________________________________________________________________________________________________
	// requestQueue.js
	//    This file contains uScope's request queue.
	//    The purpose of the request queue is to support view context changes. By prioritizing tile requests
	//    and by throttling the number in process, when a new view is required tiles in the queue from the prior view
	//    are abandoned (never were sent) and tiles ... ....
	//
	//    history
	//    130222    cperz        created
	//    _______________________________________end AIHv1  ____________________________________________
	//    141029    cperz    sendTileRequests_: fix one contributor to missing tile mystery by concatenating img tags
	//                    and appending only once to the dom
	//    141118    cperz
	//________________________________________________________________________________________________
	//todo:
	//
	//    built in performance testing
	//        - c'out right now; must be built out for multiple images?
	//    tile cache
	//        - no tile caching right now
	//    prefetch
	//        - no prefetch operations right now
	//
	//________________________________________________________________________________________________
	//
	// predefined for addToBatch:
	_defines2.default.RQ_THROTTLE = true;
	_defines2.default.RQ_SENDNOW = !_defines2.default.RQ_THROTTLE;

	//________________________________________________________________________________________________
	//    cRequestQueue - This object queues and issues image tile/region requests
	//        It is the single engine to issue requests so all image objects rely on it.
	//
	//    The purpose of the request queue is to support view context changes. By prioritizing tile requests
	//    and by throttling the number in process, when a new view is required tiles in the queue from the
	//    prior view are abandoned (never were sent) and tiles for the new view then have priority.
	//
	//    Usage:
	//    An image object (viewport) must register with this object via register(idx, ...) with its uScope
	//    index as an input parameter that uniquely identifies this image object and therefore its tile queue.
	//    Tile(s) for a given view are organized into request batches containing, typically, multiple tiles.
	//    The image object begins a batch via startNewBatch(idx, ...) which returns the new batch number 'batchId'.
	//    Then the image object can add tile(s) to the request queue via addToBatch(idx, batchId, ..).
	//    This request queue object sends the tile requests to ImageServer and handles the response.
	//
	//    Multiple calls to addToBatch() can be made for the same batchId.  This permits the image object much
	//    flexibility in parcelling out its work. Each view refresh should start a new batch because when all
	//    the tiles queued for a batch have been returned from the server, the us.evRENDERCOMPLETE event is fired.
	//    The intent is that the image object can listen for the event and perform any post-view refresh logic desired.
	//
	//    The image object can purge its own queue'd tile requests via purge(idx) which it might do for instance
	//    when the user has disregarded the current view and jumped to a completely new area of the image.
	//
	//    A call to purge(-1) with -1 passed empties the queue of tile requests for all images.
	//
	//    Design Notes:
	//    //todo:  discuss throttling, checking for tiles already present,
	//            callback to the tile request and its signal that the view is complete.
	//            tile metering/timing, options,
	//
	function cRequestQueue() {
	    var self = this;
	    var perfTestRunning = false; // local save of performance test state

	    var isFireFox = _compatibility.BrowserDetect.isFirefox(); // cache if this is firefox - special issues with FF

	    //............................................  statistics
	    var nSent_ = 0; // cumulative number of tiles requested
	    var nPurged_ = 0; // cumulative number of tiles purged
	    var nReceived_ = 0; // cumulative number of tiles received

	    //  .......................................... tile timer related
	    var showTileMeter_ = true;
	    var tmSkipCount_ = 0; // counter to throttle tile meter update
	    var tileTimes_ = (0, _helpers.circBuffer)(3); // tile timer queue - shared by all images

	    //............................................  refresh queues per image
	    var refresh_ = []; // array of "cRQItem" objects for each image: all info regarding an image's tile requests
	    var idxPriority_ = -1; // idx into refresh_ of current image
	    var thisRefreshItem_;

	    //............................................ specs
	    var bFORCESENDNOW = false; // if true, addToBatch sends tile requests immediately overriding caller's input, debug use usually
	    var bDoTileCheck_ = true; // performance option: to check if a tile is already in the viewport div

	    //............................................  request management
	    var nAtATime_ = 5; // note that a change to this value may require a change to requestTile()
	    var maxInProc_ = 10; // must be >= nAtATIme

	    var nInProc_ = 0; // number of REfresh tiles in the current batch sent and not yet received back
	    var nPrefetchInProc_ = 0; // number of PREfetch tiles sent and not yet received back

	    //............................................ status related fns
	    self.getStatusStr = function () {
	        return '  RE,PRE tiles inProc: ' + nInProc_ + ',' + nPrefetchInProc_;
	    };

	    self.getSummaryStats = function () {
	        return '  nSent_: ' + nSent_ + '  nReceived_: ' + nReceived_ + '  nPurged_: ' + nPurged_;
	    };

	    self.getRefreshQueueStatus = function () {
	        // debug use
	        (0, _toolbar.consoleWrite)('............ uScope Request Queue Refresh List: idxPriority_: ' + idxPriority_ + '............');

	        var dontReport = { tileQ: 0, viewStartTime: 0 }; // properties I don't want reported on
	        for (var i = 0, count = 0, len = refresh_.length; i < len; i++) {
	            var thisItem = refresh_[i];
	            if (thisItem != undefined) {
	                // if this is a valid queue (unregister sets closed images to undefined)
	                var thisImg = _uScope2.default.instance.getThisImage(i);
	                var batches = thisItem.batch;
	                thisImg.log('image idx: ' + i + ' batches: ' + batches.length + '  curBatchNum: ' + thisItem.curBatchNum + '  endBatchNum: ' + thisItem.endBatchNum);

	                for (var b = 0; b < batches.length; b++) {
	                    var batch = batches[b];
	                    thisImg.log('   ...' + b + '  ' + (0, _helpers.toStringAssoc)(batch, '\t', dontReport));
	                }
	            }
	        }
	    };
	    //............................................ showTileMeter
	    self.showTileMeter = function (bShow) {
	        showTileMeter_ = bShow;
	    };

	    //............................................ register
	    //    register - This function registers an image with the request queue.
	    //
	    //    Passed parameters:
	    //        idx:        uScope's image index, used to address arrays here
	    //        vpObj:        the image's (viewport) object
	    //        jVpDiv:        the viewport div
	    //
	    // - an image registers itself with the queue when it opens and unregisters when it closes
	    // - the idx is the image identifier for subsequent calls

	    self.register = function (idx, vpObj, jVpDiv) {

	        if (refresh_[idx] == undefined) {
	            refresh_[idx] = new cRQItem(vpObj, jVpDiv, bDoTileCheck_); // add new request object to refresh queue
	            //debug-only refresh_[idx].log(" cRequestQueue: register: image at index " + idx + "  " + refresh_[idx].getImageId());
	            return true;
	        } else {
	            refresh_[idx].log(' cRequestQueue: register: ALREADY HAVE an image at index ' + idx);
	            return false;
	        }
	    };

	    //............................................ unRegister
	    //    unRegister - This function unregisters an image with the tile request queue.
	    //
	    // Note: Rapid slide close/open sequence (DST next slide clicked rapidly) can result in an image
	    //        unRegistering with some of its tile requests outstanding.Hence the number of tiles in
	    //        process is non-zero.  The removal of the image's viewport div causes the browser to
	    //        cancel the outstanding tile requests. There is no indication from the browser that this
	    //        was done so when the image unregisters the number of tiles still in the queue are
	    //        subtracted from the number of tiles in process (nInProc_).

	    self.unRegister = function (idx) {
	        if (idx >= 0 && refresh_[idx]) {
	            // if this is a valid idx
	            //debug-only refresh_[idx].log("cRequestQueue: unRegister image at index " + idx + "  nInProc_: " + nInProc_);

	            var nTiles = refresh_[idx].countTilesInProcess(-1); // get then number of tiles requested and not yet returned
	            nInProc_ = Math.max(0, nInProc_ - nTiles); // adjust nInProc_ for outstanding requests
	            // debug-only if (nTiles != 0)  refresh_[idx].log("cRequestQueue: unRegister nInProc_ adjusted by " + nTIles + " to " + nInProc_);

	            refresh_[idx].batch.length = 0; // remove all batches at this image index
	            refresh_[idx] = undefined; //

	            if (idx == idxPriority_) // if this was the priority image
	                idxPriority_ = -1; // then there is no priority image now (user will select one)
	        }
	    };
	    //............................................ startNewBatch
	    // startNewBatch - This function is called to initialize a new batch of
	    //        tile requests for the refresh queue. It returns the new batch id.
	    //        The prefetch queue's batch id is always 0 - don't call this for prefetch.
	    //
	    //    parameters:
	    //        idx :                required, uScope's image index for this batch which is used as the index into refresh_ for this image
	    //        opt_viewTileCount:    optional, the number of tiles in the batch
	    //                            if specified, when all the tiles from the batch are recv'd a refreshdone event will fire

	    self.startNewBatch = function (idx, opt_viewTileCount) {
	        if (idxPriority_ != idx) {
	            // if i'm not already engaged with this image,
	            idxPriority_ = idx; // then set the priority image (the last one to request tiles)
	            thisRefreshItem_ = refresh_[idxPriority_]; // and update quick access var
	            //debug-only  consoleWrite("cRequestQueue: startNewBatch: PRIORITY SWITCH  thisRefreshItem_ idx: " + idx);
	        }
	        // get a new tile batch number to return
	        var rtnBatchNum = thisRefreshItem_.startNewBatch(opt_viewTileCount);

	        //debug-only thisRefreshItem_.log("startNewBatch: #" + rtnBatchNum + "  tilesTotal:" + thisRefreshItem_.batch[rtnBatchNum].tilesTotal + ".............");
	        return rtnBatchNum;
	    };
	    //............................................ addToBatch
	    //    addToBatch - This function adds N tile requests to the refresh or prefetch queue
	    //                    and sets the current refresh batch number.
	    //
	    //    idx:                the image identifier
	    //    batchId:            the predefined batch number to add these tiles to; The prefetch is always batch number 0.
	    //    tiles2Add:            array of tile {tag, key} pairs; the key is a unique tile identifier
	    //    queueType:            "refresh" or "prefetch"
	    //    bThrottle:            us.RQ_THROTTLE or us.RQ_SENDNOW
	    //    opt_tileSkipCount:

	    //note: for prefetch idx and batchId are optional.... //todo: maybe I should reorder this list!
	    self.addToBatch = function (idx, batchId, tiles2Add, queueType, bThrottle) {
	        //note: still process below even if there are no tiles to add
	        if (queueType == 'refresh') {
	            if (idxPriority_ != idx) {
	                // if i'm not already engaged with this image,
	                idxPriority_ = idx; // then set the priority image (the last one to request tiles)
	                thisRefreshItem_ = refresh_[idxPriority_]; // and update quick access var
	            }

	            // add these tiles to this image's batch of tiles
	            var totalTilesInBatch = thisRefreshItem_.addToBatch(batchId, tiles2Add);

	            var bDoThrottling = bFORCESENDNOW == true ? false : bThrottle; // if override to send now, do so
	            //dbg-only thisRefreshItem_.log("   ...addToBatch(Refresh): \tBatch: " + batchId + " imageIdx: " + idx + " nNewTiles: " + tiles2Add.length + " nTilesInProcess(batch): " + thisRefreshItem_.countTilesInProcess(batchId) + " nInProc_: " + nInProc_ + " totalTilesInBatch: " + totalTilesInBatch + "  throttle tiles: " + bDoThrottling);

	            if (bDoThrottling == true) requestTile_(); // and throttle the tile requests
	            else sendTileRequestsNow_(); // or request them all right now (no throttling)
	        } else if (queueType == 'prefetch') {
	            // c'out until prefetch is reenabled
	            ///        prefetchQueues_[0] = prefetchQueues_[0].concat(tiles2Add);
	            ///        prefetchQueues_[idx] = prefetchQueues_[idx].concat(tiles2Add);
	            //dbg-only consoleWrite("cRequestQueue: addToBatch(PREfetch):  batch: " + batchId + " imageIdx: " + idx + " len: " + len + "                         queue len: " + prefetchQueues_[idx].length + " tiles inProc: " + nInProc_);
	            ///        requestTile_();
	        } else {
	            (0, _toolbar.consoleWrite)('cRequestQueue: add: unknown queueType: ' + queueType);
	        }
	    };

	    //............................................ sendTileRequestsNow_
	    // This function sends all tile requests right now for the image at refresh_[idxPriority_] (no throttling)
	    //
	    // thisRefreshItem_ is already set at time of entry

	    var sendTileRequestsNow_ = function sendTileRequestsNow_() {
	        if (idxPriority_ != -1) {
	            // if REfresh priority queue has tiles, request all of them
	            var thisBatchNum = thisRefreshItem_.selectCurrentBatch();
	            var thisBatch = thisRefreshItem_.curBatch;

	            var nToSend = thisBatch.tileQ.length;
	            if (nToSend == 0) return;

	            thisBatch.tilesInProcess += nToSend; // number of tile REfresh requests outstanding for this image
	            thisBatch.tilesRequested += nToSend; // cumulative number of REfresh tile requests for this batch
	            // - in reality some may already be present and not requested in sendTileRequests_

	            nSent_ += nToSend; // cumulative number of tiles requested
	            nInProc_ += nToSend; // cumulative number of REfresh tile requests outstanding

	            // debug-only thisRefreshItem_.log("   ...sendTileRequestsNow_(REfresh):  Batch: " + thisBatchNum + " sending: " + nToSend + " Total sent: " + nSent_ + " queue len: " + thisBatch.tileQ.length + " tiles inProc: " + nInProc_);
	            sendTileRequests_(thisBatch, thisBatchNum, nToSend);
	        }
	    };
	    //............................................ nextRefreshItem_ local
	    //    nextRefreshItem_ - This function finds the next valid image in refresh_[] with tiles not yet requested.
	    //                If found, it sets the quick access var thisRefreshItem_ and idxPriority_ and returns idxPriority_.
	    //                If not found it returns -1.
	    //
	    var nextRefreshItem_ = function nextRefreshItem_() {
	        var rqLength = refresh_.length;
	        //..................................................
	        // closure functions
	        //    This function returns the next valid index in refresh_[] after the passed index or -1 if there are no others.
	        var nextIdx_ = function nextIdx_(curIdx) {
	            var rtnIdx = curIdx; // get next index in refresh_
	            if (++rtnIdx > rqLength) rtnIdx = 0;

	            while (rtnIdx != curIdx) {
	                // loop until you're back at the current index
	                if (refresh_[rtnIdx] != undefined) // if there is a valid image in this refresh_ queue slot
	                    return rtnIdx; // then return its index
	                if (++rtnIdx > rqLength) rtnIdx = 0; // else get next index in refresh_
	            }
	            return -1; // no other valid index
	        };
	        //..................................................

	        // find the next valid image in refresh_[] with tiles not yet requested
	        var count = 0;
	        var rtnIdx = nextIdx_(idxPriority_);
	        while (rtnIdx != -1 && rtnIdx != idxPriority_ && ++count < rqLength) {
	            ///    consoleWrite("nextRefreshItem_: idxPriority_: " + idxPriority_ + "  testing idx: " + rtnIdx);

	            var thisItem = refresh_[rtnIdx]; // if this image's refresh queue
	            if (thisItem != undefined) {
	                //    is defined (valid)
	                var batches = thisItem.batch;
	                if (batches && batches.length > 0) {
	                    //     and has batches of tiles

	                    var batch = batches[batches.length - 1]; // does the last batch in this image's refresh queue have tiles to request?
	                    ////////////////////////////////////////
	                    //todo: I think I need to decr added or incr requested or count those already present into the check
	                    // see sendTileRequests_ priorityBatch.tilesTotal--;
	                    ///////////////////////////////////////

	                    if (batch.tilesRequested < batch.tilesAdded && batch.bPurged == false) {
	                        // if so, that's the next refresh item

	                        //consoleWrite("                  nextRefreshItem_ FOUND: count: " + count + "  idxPriority_: " + idxPriority_ + "  rtnIdx: " + rtnIdx);
	                        idxPriority_ = rtnIdx;
	                        thisRefreshItem_ = refresh_[idxPriority_]; // and update quick access vars
	                        return idxPriority_;
	                        return -1;
	                    }
	                }
	            }
	            rtnIdx = nextIdx_(rtnIdx);
	        }
	        //consoleWrite("                  nextRefreshItem_: NOT FOUND count: " + count + "  idxPriority_: " + idxPriority_ + "  rtnIdx: " + rtnIdx);
	        return -1;
	    };
	    //............................................ requestTile_ local
	    //    requestTile_ - This function checks the number of tiles "in process" (waiting to be returned from the server)
	    //                        and if the limit has not been reached, it requests more tiles.
	    var requestTile_ = function requestTile_() {
	        var thisBatchNum;
	        var thisBatch;

	        //..................................................
	        // closure functions
	        //    nTilesToSend_ - This function returns the number of tiles left to send for the current priority image, thisRefreshItem_
	        var nTilesToSend_ = function nTilesToSend_() {
	            var nToSend = 0;
	            if (idxPriority_ != -1) {
	                // sanity check, idxPriority_ is set to -1 when the priority image is closed
	                thisBatchNum = thisRefreshItem_.selectCurrentBatch();
	                if (thisBatchNum == 0) {
	                    (0, _toolbar.consoleWrite)('nTilesToSend_: batch num is 0 ?'); //todo: this will likely be the prefetch batch :)
	                    return nToSend = 0;
	                }
	                thisBatch = thisRefreshItem_.curBatch;

	                var nToSend = nInProc_ + nPrefetchInProc_ == 0 ? Math.min(thisBatch.tileQ.length, maxInProc_) : Math.min(thisBatch.tileQ.length, nAtATime_);
	                //debug-only thisRefreshItem_.log("   ...requestTile_(REfresh):  nToSend: " + nToSend + "  nInProc_: " + nInProc_);
	            }
	            return nToSend;
	        };
	        //..................................................

	        if (nInProc_ + nPrefetchInProc_ >= maxInProc_) {
	            // if the number of tiles in process is already enough, exit
	            //debug-only thisRefreshItem_.log("   ...requestTile_(REfresh):  tiles nInProc_ >= maxInProc_: " + nInProc_ + " >= " + maxInProc_);
	            return;
	        }

	        var nToSend = nTilesToSend_(); // get the number of tiles that can be requested of the priority image
	        if (nToSend == 0 && refresh_.length > 1) {
	            // if the priority image has no tiles to send and there are other images

	            //debug-only if (nInProc_ == 0)    thisRefreshItem_.log("   ...requestTile_(REfresh):  nToSend: " + nToSend + "  nInProc_: " + nInProc_);

	            if (nextRefreshItem_() != -1) {
	                // if another image has an un-fullfilled tile queue
	                //debug-only thisRefreshItem_.log("   ...requestTile_(REfresh): switching to image index: " + idxPriority_);
	                nToSend = nTilesToSend_();
	            } else {
	                // no tiles in any image's tile queue waiting to be requested
	                //debug-only thisRefreshItem_.log("   ...requestTile_(REfresh): nothing more to do for any image.");
	                return;
	            }
	        }
	        if (nToSend != 0) {
	            thisBatch.tilesInProcess += nToSend; // number of tile REfresh requests outstanding for this image
	            thisBatch.tilesRequested += nToSend; // cumulative number of REfresh tile requests for this batch
	            // - in reality some may already be present and not requested in sendTileRequests_
	            // I could increment with nReallyRequested returned from sendTileRequests_ (do in all places that calls sendTileRequests_)

	            nSent_ += nToSend; // cumulative number of tiles requested
	            nInProc_ += nToSend; // cumulative number of REfresh tile requests outstanding
	            //debug-only thisRefreshItem_.log("   ...requestTile_(REfresh):  batchId: " + thisBatchNum + " sending: " + nToSend + " Total sent: " + nSent_ + " queue len: " + thisBatch.tileQ.length + " tiles inProc: " + nInProc_);

	            var nReallyRequested = sendTileRequests_(thisBatch, thisBatchNum, nToSend); // request the tiles
	        }
	        // todo: if nothing to do on refresh queues so consider prefetch queues (when prefetch is re-enabled
	    };
	    //............................................ sendTileRequests_
	    // sendTileRequests_ - This function receives the tiles to request, timestamps them and issues the request.
	    //                        It returns the number of tiles sent,
	    //                        which is the number requested to send minus the number already found to be present.
	    //
	    //    parameters:
	    //        priorityBatch    :
	    //        priorityBatchNum:
	    //        nToSend            :
	    // notes:
	    //        - thisRefreshItem_ is already set at time of entry
	    //
	    //        - tag format:  "<img class="us_tile" xtile="54" ytile="45" zoom="1" src="/imageserver/@@BAsSlf0 _ug==/@2?25920+21600+480+480+1+75" alt="" style="left: -47px; top: 132px;"></img>"
	    //
	    var sendTileRequests_ = function sendTileRequests_(priorityBatch, priorityBatchNum, nToSend) {
	        var nRequested = 0; // returned value: total num tiles requested by this fn
	        var imageId = thisRefreshItem_.getImageId(); // quick access to refresh queue's image's id
	        var priorityQ = priorityBatch.tileQ; // quick access to priority batch's tile queue

	        var nToGo = nToSend; // count down var
	        while (nToGo > 0) {
	            // for each tile to send: add a timestamp; bind a callback in this object; add the tile to the cache (if enabled);
	            var tagConcated = '';
	            var nThisLoop = Math.min(10, nToGo);
	            for (var i = 0; i < nThisLoop; i++) {

	                // tag format:  "<img class="us_tile" xtile="54" ytile="45" zoom="1" src="/imageserver/@@BAsSlf0 _ug==/@2?25920+21600+480+480+1+75" alt="" style="left: -47px; top: 132px;"></img>"
	                var tile2Add = priorityQ.shift(); // get the tag & key info and remove it from the queue of tiles to be requested
	                var tag = tile2Add.tag;

	                if (thisRefreshItem_.isAlreadyPresent(tile2Add.key) == false) {
	                    // use the key to determine if this tile is not already in the vp div

	                    var tilesRequested = priorityBatch.tilesRequested; // add time stamp for tile metering and batch info
	                    var sBatchInfo = tilesRequested - nToSend + i + 1 + '/' + tilesRequested;
	                    tag = tag.replace('class', 'timestamp="' + new Date().getTime() + '" imageidx="' + idxPriority_ + '" batch="' + priorityBatchNum + '" batchinfo="' + sBatchInfo + '" class');

	                    // debug-only option to identify tile in network traffic
	                    //    var extend = "+" + priorityBatchNum + "_" + (tilesRequested - nToSend + i + 1) + "_" + tilesRequested;
	                    //    tag = tag.replace('+80"', '+80' + extend + '"'); // note that quality of 80 is expected to be found
	                    //    thisRefreshItem_.log("  reqQueue: sendTileRequests_: " + tag);
	                    tagConcated += tag; // concatenate all tags to be requested
	                    nRequested++;
	                } else {
	                    // note that for those batches that did not specify tilesTotal, tilesTotal will become < 0
	                    priorityBatch.tilesTotal--; // already have the tile so the number of tilesTotal to request is decremented
	                }
	            }
	            //dbg-only  thisRefreshItem_.log("sendTileRequests_: " + tilesToSend.length + " / " + nThisLoop);
	            nToGo -= nThisLoop; //

	            // debug-only    thisRefreshItem_.log("sendTileRequests_: " + nRequested + " / " + nThisLoop  + "\n" + tagConcated);
	            if (tagConcated.length) {
	                var jTile = $(tagConcated); // attaches to the dom which issues the image request
	                jTile.one('load', function (e) {
	                    cbTileLoaded_(e, 'refresh', idxPriority_, imageId);
	                });
	                thisRefreshItem_.jVpDiv.append(jTile);
	            }
	        }
	        return nRequested; // return the number of tiles actually requested
	    };

	    //............................................ cbTileLoaded_
	    //    cbTileLoaded_ - This function is called when a tile is received to perform the tile accounting and signal when a view is complete.
	    //
	    //    notes:
	    //        - tiles from prior batches of the current image, or from batches of a different image are returned asynchronously
	    //        - you cannot assume that the returned tile is from thisRefreshItem_: a closed image can have returning tiles

	    var cbTileLoaded_ = function cbTileLoaded_(e, strReqType, imageIdx, imageId) {
	        nReceived_++; // cumulative number of tiles received

	        //..................................................
	        // closure functions
	        var tileMeterUpdate = function tileMeterUpdate() {
	            ++tmSkipCount_; // throttle the tile meter update
	            if (showTileMeter_ == true) {
	                // update the tile meter, current image receives the update always
	                if (tmSkipCount_ > 3) {
	                    tmSkipCount_ = 0;
	                    // The timeStamp event property returns the number of in milliseconds since midnight of January 1, 1970.
	                    //Most  browsers:  1368029625853
	                    //FF:              1368029688536000  e.timeStamp > 1000000000000
	                    //FF: event.timeStamp Returns the time (in milliseconds since the epoch) at which the event was created. - not true
	                    var tileTime_msec = isFireFox == true ? e.timeStamp / 1000 - getAttr(e.currentTarget, 'timestamp') : e.timeStamp - getAttr(e.currentTarget, 'timestamp');
	                    thisRefresh.updateTileMeter(tileTime_msec, strReqType);
	                }
	            }
	        };
	        //..................................................
	        //debug-only var html = e.srcElement.outerHTML;     var anId = html.slice(html.lastIndexOf("@"), html.lastIndexOf("?")); consoleWrite(anId + "....cbTileLoaded_");
	        //debug-only consoleWrite(anId + "....cbTileLoaded_ for imageIdx: " + imageIdx + " tag:  " + e.srcElement.outerHTML);

	        if (strReqType == 'refresh') {
	            // if the returned tile was a refresh tile
	            if (--nInProc_ < 0) nInProc_ = 0; // decrement the number of tiles in progress (sent to ImageServer not yet recv'd back)

	            var imageIdx = +$(e.currentTarget).attr('imageidx'); // this tile's image index
	            var thisRefresh = refresh_[imageIdx]; // this image request object on the refresh queue
	            if (thisRefresh == undefined) {
	                //debug-only
	                (0, _toolbar.consoleWrite)('    ....cbTileLoaded_(Refresh): imageIdx: ' + imageIdx + ' --- tiles returned from non-exsiting image');
	                return;
	            }

	            var thisImg = thisRefresh.thisImg; // insure that the image the returned tile refers to is this image
	            if (thisImg.getImageId() != imageId) {
	                // - this could happen when an image is replaced into the same image index
	                //debug-only
	                (0, _toolbar.consoleWrite)('....cbTileLoaded_ for imageIdx: ' + imageIdx + ' tile\'s imageId (' + imageId + ') doesn\'t match the image\'s imageId(' + thisImg.getImageId() + ')');
	                return; // nothing more to do
	            }

	            var batchNum = +$(e.currentTarget).attr('batch'); // this tile's batch number
	            var thisBatch = thisRefresh.batch[batchNum];
	            if (thisBatch == undefined) {
	                //debug-only consoleWrite("    ....cbTileLoaded_(Refresh): imageIdx: " + imageIdx + " --- tiles returned from non-exsiting batch");
	                return; // nothing more to do
	            }
	            if (--thisBatch.tilesInProcess < 0) thisBatch.tilesInProcess = 0; // sanity check
	            thisBatch.tilesReturned++; // update count of returned tiles for this batch

	            //debug-only thisImg.log("    ....cbTileLoaded_(Refresh): imageIdx: " + imageIdx + "\tBatch: " + batchNum + "\t" + $(e.currentTarget).attr("batchinfo") + "\t\tStatus: " + self.getStatusStr());
	            //debug-only thisImg.log("    ....cbTileLoaded_(Refresh batchNum:" + batchNum + "): " + (thisBatch.tilesReturned + 1) + " / " + thisBatch.tilesTotal)

	            // a batch of tiles that specified the tilesTotal will result in a refreshdone event
	            if (thisBatch.tilesTotal > 0 && thisBatch.tilesReturned >= thisBatch.tilesTotal) {
	                (0, _events.triggerUScopeEvent)(_defines2.default.evRENDERCOMPLETE, { imageId: thisImg.getImageId(), reqQueBatchId: batchNum }); // fire refresh complete
	                //debug-only thisImg.log("    cbTileLoaded_: Completed Batch:" + batchNum + "  tilesReturned/tilesTotal: " + thisBatch.tilesReturned + "/" + thisBatch.tilesTotal + " tiles inProc: " + nInProc_);
	                //debug-only thisImg.log("    cbTileLoaded_: View Complete, Batch:" + batchNum + " zoom: " + $(e.currentTarget).attr('zoom') +" in: " +( (new Date()) - thisBatch.viewStartTime + " ms"));

	                if (showTileMeter_ == true) {
	                    ////thisImg.tileMeter.viewUpdate((new Date()) - thisBatch.viewStartTime, thisBatch.tilesTotal); // display view refresh time
	                    thisRefresh.updateViewMeter(new Date() - thisBatch.viewStartTime, thisBatch.tilesTotal); // display view refresh time
	                }
	            }

	            requestTile_(); // and request the next tile(s)
	            tileMeterUpdate(); // and now that the time critical work is done, display the tile timing

	            //todo:refactor for perf testing multi image
	            // if running the perfomance test and the view is complete
	            //            if (viewTilesReturned_ == nTilesInView_ && perfTestRunning == true)
	            //                thisImg.getPerfTestObj().refreshComplete(); // signal the perf test
	        } else if (strReqType == 'prefetch') {
	            // if the returned tile was a prefetch tile
	            //            nPrefetchInProc_--;                 //
	            //            requestTile_();                     // and request the next tile(s)
	            //if (us.DBGIMGLOAD) { var jInTile = $(e.currentTarget); consoleWrite("    ....cbTileLoaded_(Prefetch): Batch: " + jInTile.attr("batch") + "   " + jInTile.attr("batchinfo") + "   Status: " + self.getStatusStr()); }
	            return;
	        }
	    };

	    //............................................ purge
	    //    purge - This function purges the refresh and prefetch queues of a specified image
	    //            of the passed index or all queues if the passed image index is -1.
	    //    parameters:
	    //        idx:    the image index
	    self.purge = function (idx) {

	        // note: it is necessary to zero nInProc_ because the browser can and does silently cancel some of the
	        //            requests when they are removed from the DOM (from the viewport).  Those silently canceled
	        //            requests never return and nInProc is therefore never reduced.  This can prevent any new
	        //            the tile requests.  So although doing this may make the count not quite right, it is necessary.
	        nInProc_ = 0; // important!

	        if (idx < 0) {
	            // purge all .........................
	            for (var i = 0, len = refresh_.length; i < len; i++) {
	                if (refresh_[i]) nPurged_ = refresh_[i].purge();
	            }
	            //todo: prefetch queue
	            //debug-only consoleWrite(" cRequestQueue: purge(ALL): " + self.getStatusStr() + "  nPurged_: " + nPurged_);
	        } else {
	            // purge one image....................
	            if (idxPriority_ != idx) {
	                // if i'm not already engaged with this image,
	                idxPriority_ = idx; // then set the priority image (the last one to request tiles)
	                thisRefreshItem_ = refresh_[idxPriority_]; // and update quick access var
	            }
	            nPurged_ = thisRefreshItem_.purge(); // purge this image's queue

	            //todo: prefetch queue
	            //debug-only consoleWrite(" cRequestQueue: purge(" + idx + "): " + self.getStatusStr() + "  nPurged_: " + nPurged_);
	        }
	        tmSkipCount_ = 999; // insure next returned tile causes the tile meter to show

	        ////todo: rework perf test for multi image
	        ////        // save local vars for performace testing
	        ////        perfTestRunning = thisImg.getPerfTestObj().isRunning(); // the current state of performance testing
	    };
	    //.......................................................................................................
	    // construction
	    if (bFORCESENDNOW == true) (0, _toolbar.consoleWrite)('NOTE! cRequestQueue: Tiles sent immediately, NOT queuing REfresh.');
	} // end of cRequestQueue
	//________________________________________________________________________________________________
	//    cRQItem object - This object manages the batches of tile requests for an image
	//
	//    parameters:
	//        vpObj:            the image object
	//        jVpDiv:            a ref to this image's vp div
	//        bDoTileCheck:    flag

	function cRQItem(vpObj, jVpDiv, bDoTileCheck) {
	    var self = this;

	    this.thisImg = vpObj;
	    this.jVpDiv = jVpDiv; // save a reference to this image's vp div

	    var bDoTileCheck_ = bDoTileCheck;
	    var tilesPresent_ = []; // array of tiles known to be requested, in the vp's div

	    this.batch = []; // array of
	    this.curBatch; // quick access to this.batch[this.curBatchNum]
	    this.curBatchNum = 0; // current index into batch array of tiles to be sent
	    this.endBatchNum = 0; // last index into batch array " " "

	    var imageId_ = this.thisImg.getImageId();
	    //............................................

	    this.getImageId = function () {
	        return imageId_;
	    };
	    this.log = this.thisImg.log;

	    // note that these refs are code entanglement but they are done for speed purposes
	    this.updateTileMeter = this.thisImg.tileMeter.tileUpdate;
	    this.updateViewMeter = this.thisImg.tileMeter.viewUpdate;

	    //............................................ selectCurrentBatch
	    // returns current batch number
	    // updates handy this.curBatch
	    this.selectCurrentBatch = function () {
	        if (this.curBatch) {
	            //debug-only this.log("..selectCurrentBatch: batchId: " + this.curBatchNum + "  curBatch.tileQ.length: " + this.curBatch.tileQ.length + "    curBatch.tilesTotal: " + this.curBatch.tilesTotal + "   tilesAdded: " + this.curBatch.tilesAdded);

	            // Note: when tilesTotal is 0, the batch will be abandoned with tiles to go when a new batch is started
	            // - I COULD switch to use tilesAdded if I didn't want the batch abandoned
	            //    but note that the tilesTotal of 0 also is used to determine if view refresh event should fire
	            //    - this is overloading of the purpose and should be corrected.

	            if (this.curBatch.tilesRequested >= this.curBatch.tilesTotal) {
	                // if current batch has no more tiles to be sent

	                if (this.curBatchNum != this.endBatchNum) {
	                    // if there is another batch of tiles to process,
	                    this.curBatchNum++; // the new batch number
	                    //debug-only this.log("..selectCurrentBatch: batchId: " + this.curBatchNum + " SWITCH!!");

	                    this.viewStartTime = new Date(); // view refresh starts now
	                    this.curBatch = this.batch[this.curBatchNum];
	                }
	            }
	        }
	        return this.curBatchNum;
	    };

	    //............................................ startNewBatch
	    this.startNewBatch = function (opt_viewTileCount) {
	        this.endBatchNum++; //
	        if (this.curBatchNum == 0) // if this is the 1st batch,
	            this.curBatchNum = this.endBatchNum; // set the current batch number
	        this.batch[this.endBatchNum] = new cBatchItem(opt_viewTileCount);

	        //todo: ??? maybe only need to do this on first time and on when curBatchnum increments!
	        this.curBatch = this.batch[this.curBatchNum];

	        return this.endBatchNum;
	    };

	    //............................................ countTilesInProcess
	    //    countTilesInProcess - count the number of tiles requested and not yet returned for a batch or all batches
	    // parameters:
	    //    batchNum:  either a valid batch number or -1 for a count from all batches

	    this.countTilesInProcess = function (batchNum) {
	        //todo: I'd like to remove this and work out info sharing better
	        if (batchNum != -1 && batchNum < this.batch.length) {
	            var batch = this.batch[batchNum];
	            return batch ? batch.tileQ.length : 0;
	        } else {
	            var nTiles = 0;
	            for (var i = 0, len = this.batch.length; i < len; i++) {
	                if (this.batch[i]) nTiles += this.batch[i].tilesInProcess;
	            }
	            return nTiles;
	        }
	    };

	    //............................................ addToBatch
	    this.addToBatch = function (batchNum, jTileList) {
	        //todo: may want to separate calls for skip count
	        var batch = this.batch[batchNum];
	        if (batch == undefined) return 0;

	        var nTiles = jTileList.length;
	        if (nTiles > 0) {
	            batch.tilesAdded += nTiles;
	            batch.tileQ = batch.tileQ.concat(jTileList);
	        }

	        return batch.tilesTotal;
	    };
	    //............................................ isAlreadyPresent
	    //    This function checks if the tile is already present in the vp div.
	    //    This is know by keeping an array of all tiles requested for an image.
	    //    When the image's vp div is purged, this array is emptied too.
	    //
	    //    It is ok to request an already present tile but the browser then duplicates it.
	    //    Not only does the unnecessary request take extra time, the duplicated tile takes
	    //    unnecessary memory, and clutters the vp div resulting in view move operations doing
	    //    more work.
	    //
	    //    Since this this is NOT harmful, bDoTileCheck_ is an option.
	    //
	    // Note: The zoom attribute is not used currently. Tiles in the viewport div at different
	    //        pyramid levels are not going to collide.

	    this.isAlreadyPresent = function (key) {
	        if (bDoTileCheck_ == false) // if option to check tiles is not enabled
	            return false; // return indication that tile isn't already present

	        if (tilesPresent_[key] == undefined) {
	            tilesPresent_[key] = 1;
	            // debug-only consoleWrite("cRQItem: tile DOES NOT exists: " + key);
	            return false;
	        } else {
	            // debug-only consoleWrite("cRQItem: tile already exists: " + key);
	            return true;
	        }
	    };
	    //............................................ purge
	    this.purge = function () {
	        tilesPresent_ = []; // empty the array of tiles in vp div
	        var nPurged = 0;
	        if (this.curBatch) {
	            for (var b = this.curBatchNum; b <= this.endBatchNum; b++) {
	                if (b == 0 || this.batch[b] == undefined) continue;
	                var nLeft = this.batch[b].tilesTotal > 0 ? this.batch[b].tilesTotal - this.batch[b].tilesRequested : this.batch[b].tilesAdded - this.batch[b].tilesRequested;

	                //this.log(" ...cRQItem: tilesTotal: " + this.batch[b].tilesTotal + "    tilesRequested: " + this.batch[b].tilesRequested + "   purged: " + nLeft);
	                //this.log(" ...cRQItem: tilesAdded: " + this.batch[b].tilesAdded + "    tilesRequested: " + this.batch[b].tilesRequested + "   purged: " + nLeft);
	                if (nLeft > 0) {
	                    nPurged += nLeft;
	                    this.batch[b].bPurged = true;
	                }
	            }
	            this.curBatchNum = 0; // reset current batch info so next batch start initializes it
	            //do I need to do this? this.curBatch = undefined;
	        }
	        return nPurged;
	    };
	}
	//________________________________________________________________________________________________
	//    cBatchItem object - This object manages information about a single batch of tile requests for an image
	function cBatchItem(opt_viewTileCount) {
	    this.tilesTotal = opt_viewTileCount ? opt_viewTileCount : 0;
	    this.tilesAdded = 0; // # tiles added to the batch
	    this.tilesRequested = 0; // # of requests in a given batch so far... isn't this tilesReturned + tilesInProcess
	    this.tilesReturned = 0; // # tiles received back from server
	    this.tilesInProcess = 0; // # tiles requested - # tiles received back from server
	    this.bPurged = false; // flag indicating this batch was abandoned/purged

	    this.tileQ = [];
	    this.viewStartTime = new Date(); // time of first tile request to server
	}

	function getAttr(domElement, attr) {
	    if (domElement.getPropertyValue) // Chrome, FF13, FF12,  IE9
	        return domElement.getPropertyValue(attr);else // IE7, IE8
	        return domElement.getAttribute(attr);
	}
	module.exports = exports['default'];

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports,"__esModule",{value:true});exports.default=ViewportAP;var _defines=__webpack_require__(3);var _defines2=_interopRequireDefault(_defines);var _compatibility=__webpack_require__(6);var _objects=__webpack_require__(7);var _viewportBase=__webpack_require__(14);var _viewportBase2=_interopRequireDefault(_viewportBase);var _search=__webpack_require__(23);var _search2=_interopRequireDefault(_search);var _navigation=__webpack_require__(24);var _events=__webpack_require__(10);var _helpers=__webpack_require__(8);var _toolbar=__webpack_require__(5);var _overlays=__webpack_require__(17);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}//________________________________________________________________________________________________
	// viewportAP.js
	//    This file contains the ViewportAP (aperio renderer) object that manages the image view.
	//    ViewportAP is derived from ViewportBase.
	//
	//    history
	//    _______________________________________end AIHv1 _____________________________________________
	//    1410    cperz        created from cViewport, in conjunction with ViewportBase
	//    141029    cperz        viewRefresh: fix one contributor to missing tile mystery by removinging tiles by class
	//    141118    cperz        removed prefetch and cache - have been disabled for past release;
	//                        break out from cViewport to use ViewportBase;
	//    141222    cperz        add analysis support: specifically markup functionality; add viewRefreshForce();
	//    150318    cperz        build out for analysis: display markups,
	//                        convert to capitalized user vars = this for js parser clarity;
	//                        added isPtInView();
	//    _______________________________________12.3 __________________________________________________
	//    150612    cperz        openImage: call viewRotate if initialize view angle
	//                        viewRotate protect against uninitialized annot object
	//    150717    cboarman    Enable rotation during conference
	//________________________________________________________________________________________________
	//    Object Name: cViewport
	//    Overview: A cViewport obect is associated with a viewport div.  It performs the opening/closing,
	//            view presentation, navigation,and event handling for a single image and its associated markup images.
	//            It owns (creates and destroys) all overlay visuals,    an annotation object associated with
	//            its image, as well as several helper objects.
	//
	//    Associated Panel: none
	//
	//    Dependencies and Supporting objects:
	//        o ViewportBase
	//        o cRequestQueue
	//        o cOverLayout
	//        o cStateVector
	//        o all the overlay visual objects
	//
	//    Assumptions: o todo
	//
	//    Limitations:
	//        o
	//
	//    Terms Used:
	//        o Overlay Visuals: the set of imagery, controls, and viewer-defined graphics that are displayed
	//                    on top of the tiled image; e.g. the thumbnail, magnifier, scale bar and zoom control.
	//
	//    Functionality:
	//        o View tiling:
	//        o
	//
	//    Data Structures: todo
	//
	//    HTML:
	//        The viewport div associated with this object is created by the uScope object.
	//
	//    References: -
	//
	//    Coordinate systems used:
	//        o image base: the scanned image's pyramid base coordinate system;
	//                    left,top is 0,0; positive x to the right; positive y down;
	//        o viewport relative: the view coordinate system; a window into the scanned image;
	//                    left,top is 0,0; positive x to the right; positive y down;
	//________________________________________________________________________________________________
	//    ViewportAP - This function manages an image viewport.
	//
	//    Input parameters:
	//        initState:
	//            imageID:    req'd, image id number starting with the @ sign or filename starting with imageserver/
	//            centerX:    optional, initial center of view X position
	//            centerY:    optional, initial center of view X position
	//            focus:        optional, initial focus (z position)
	//            zoom:        optional, initial zoom where 0.5 = 200%, 1 = 100%, 2 = 50%, 4 = 25%, "Fit" and "Scan" are ok
	//
	function ViewportAP(initState,uScope){var self=this;// ..... to group fns in js parser, for ease of search (e.g. search for all 'VPAP_VIEW')
	var VPAP_GET=this;//
	var VPAP_IMAGE=this;var VPAP_MOUSE=this;var VPAP_MOVE=this;var VPAP_NAV=this;var VPAP_OVERLAY=this;var VPAP_PYRAMID=this;var VPAP_ROTATION=this;var VPAP_VIEW=this;var VPAP_ZOOM=this;var VPAP_MARKUP=this;// Extend base class
	_viewportBase2.default.call(self,initState,uScope);VPAP_VIEW.coordSystem=_defines2.default.coordSystemNORM;// this viewport's coordinate system
	// annotations object ..................................
	VPAP_GET.getAnnotObj=function(){return self.annots;};// accessor to annotation object for this viewport
	var baseImageOpen=self.imageOpen;// at this point nothing in base is overridden
	var baseImageClose=self.imageClose;// so get refs to base fns to be called on
	// overlay objects and assoc data .......................... (most are in ViewportBase
	VPAP_OVERLAY.progressive=undefined;// the progressive image object
	//______________________________________________________
	// operational objects and assoc data
	//    - these objects are created in construct_
	//______________________________________________________
	// tile request object .................................
	var reqQueue_=uScope.getReqQueueObj();// quick ref to the tile request object
	var reqQueBatchId_=0;// current batch id for requests
	//______________________________________________________
	// NAVIGATION RELATED
	//______________________________________________________
	// pinch and drag momentum related .....................
	self.initDist=0;// pinch zoom initial distance between fingers
	self.initMag=0;// pinch zoom initial magnfication
	var viewDragMomemtum_;// drag momentum object
	self.dragConstrainCnt=0;// used to throttle calls during drag navigation
	self.partialRefreshCnt=1;// used to monitor tile accumulation in viewport div
	// mouse wheel zoom related ............................
	self.mwZoomStopping=false;// indicates wheel stopped and rendering at that zoom
	// auto raster related .................................
	self.rasterScan=undefined;// the rasterScan navigation object
	// view refresh timer related ..........................
	var cpViewRefreshLT_=new _objects.cPoint(0,0);// current left/top corner of view
	// TODO - Investigate. timerId is the only thing used in this object, and its only used in a totally different context (overlays.js)
	var _viewRefreshSpecs={'timerId':-1,// the view refresh timer id - note viewRefreshPrep relies on its value
	'timerInterval':1000// timer interval in milliseconds
	};//______________________________________________________
	// MARKUP RELATED
	//______________________________________________________
	var jMuDiv=_defines2.default.DISPLAYMARKUP?$('.'+_defines2.default.clsDIVMARKUP+'.'+self.clsIMAGEID):undefined;// markup div
	VPAP_MARKUP.muDivGet=function(){return jMuDiv;};VPAP_MARKUP.wholeSlideMarkupImageId=undefined;// set to valid id (ex: "@1019") when selected region is wholeslide markup
	var bMarkupVisible=_defines2.default.DISPLAYMARKUP;// current visibility status; default to global setting
	//............................................ isShowingMarkup
	VPAP_MARKUP.isShowingMarkup=function(){return bMarkupVisible&&_defines2.default.DISPLAYMARKUP;};//............................................ showMarkup
	VPAP_MARKUP.showMarkup=function(enable){// show/hide markup
	bMarkupVisible=_defines2.default.DISPLAYMARKUP?enable:false;if(bMarkupVisible==false)self.markupTilesRemove();else self.viewRefreshForce('Markup Visibility');};//............................................ setWholeSlideMarkupImageId
	// This function checks if the image has a whole slide markup and if so caches the markupImageId.
	//    If asked it forces a view refresh.
	VPAP_MARKUP.setWholeSlideMarkupImageId=function(bViewRefreshForce){self.wholeSlideMarkupImageId=undefined;if(_defines2.default.ENABLEANALYSIS&&self.annots.isWholeSlideMarkup()==true){self.wholeSlideMarkupImageId=self.annots.getSelMarkupImageId();if(bViewRefreshForce)// if force refresh specified - only nec. on first annot paint
	self.viewRefreshForce('wholeSlideMarkup');}};//............................................ isShowingWholeSlideMarkup
	VPAP_MARKUP.isShowingWholeSlideMarkup=function(){return self.wholeSlideMarkupImageId&&self.isShowingMarkup();};//______________________________________________________
	// VIEWPORT DIV RELATED
	//______________________________________________________
	var viewOverFlowTiles_=0;//was us.kOVERTILES            // number of tiles to overflow viewport boundaries //todo: remove - no longer used
	var viewFrameWidthInTiles=_defines2.default.kFRAMETILES;// width in tiles of frame about the viewport boundaries
	// viewport image coordinates ..........................
	var vpView={'left':0,'top':0,// the left,top corner of the viewport corresponds to this zoom image coords
	'width':0,'height':0,// the width and height of the view in base image coords (pixels) with zoom compensation (view w,h at zoom=2 is 2x view w,h at zoom=1)
	'zoom':1.0,// the zoom factor in the system that ImageServer's GETImage likes: 0.5 = 200%, 1 = 100%, 2 = 50%, 4 = 25% (counter intuitive)
	'isFitZoom':false,// flag that zoom factor is derived from "Fit" selection
	'prevZoom':1.0,// previous zoom factor
	// ...............................
	'tileL':0,'tileT':0,// the tile numbers of the left, top, right, and bottom tiles of the visible viewport
	'tileR':0,'tileB':0,'csTiles':new _objects.cSize(0,0),// the number of tiles in each dimension of the total in a fully refreshed viewport
	'csTilesVisible':new _objects.cSize(0,0),// the number of tiles in each dimension  of the visible viewport
	// ...............................
	'angleDeg':0,'angleRad':0,// image rotation angle
	'cpRotOffset':new _objects.cPoint(0,0),// image rotation div offset
	// ...............................
	'focus':0,// the z position which will not change until 3D is implemented
	//..................
	init:function init(){},toString:function toString(){return'vpView: left,top '+self.left+','+self.top+'   WxH:'+self.width+','+self.height+'   rotation: '+self.angleDeg+'deg  zoom: '+self.zoom;}};VPAP_VIEW.getVPView=function(){return vpView;};//
	VPAP_VIEW.getVPViewRect2=function(){return new _objects.cRect2(vpView.left,vpView.top,vpView.left+vpView.width-1,vpView.top+vpView.height-1);};VPAP_VIEW.isPtInView=function(cpBase){return cpBase.x>vpView.left&&cpBase.x<vpView.left+vpView.width&&cpBase.y>vpView.top&&cpBase.y<vpView.top+vpView.height-1?true:false;};//............................................ viewPosInfoUpdate
	VPAP_VIEW.viewPosInfoUpdate=function(left,top){vpView.left=left;// set viewport left,top corner position
	vpView.top=top;self.moveConstrain();// limit left,top so viewport always includes the image content
	vpView.tileL=Math.floor(vpView.left/tileWidthXZoom);vpView.tileT=Math.floor(vpView.top/tileHeightXZoom);// the number of tiles contributing to a view varies as the view LT corner changes
	vpView.csTilesVisible.set(Math.ceil((vpView.left-vpView.tileL*tileWidthXZoom+vpView.width)/tileWidthXZoom),Math.ceil((vpView.top-vpView.tileT*tileHeightXZoom+vpView.height)/tileHeightXZoom));vpView.csTiles.set(vpView.csTilesVisible.w,vpView.csTilesVisible.h);if(viewOverFlowTiles_>0){// the total number of tiles in the viewport accounts for over tiling about the border
	vpView.tileL-=viewOverFlowTiles_;vpView.tileT-=viewOverFlowTiles_;vpView.csTiles.add(2*viewOverFlowTiles_,2*viewOverFlowTiles_);}vpView.tileR=vpView.tileL+vpView.csTiles.w-1;vpView.tileB=vpView.tileT+vpView.csTiles.h-1;//self.log("viewPosInfoUpdate: zoom: " + vpView.zoom + "   LT Pix: " + vpView.left + "," + vpView.top);
	//self.log("viewPosInfoUpdate: INSIDE LT tile: " + vpView.tileL + "," + vpView.tileT    + "  RB tile: " + vpView.tileR + "," + vpView.tileB + "   WxH tile: " + vpView.csTiles.toString());
	};//............................................ viewDimsUpdate
	// note: update position must be set to compute the new view dims in tiles
	VPAP_VIEW.viewDimsUpdate=function(bUpdatePosition){var zoom=vpView.zoom;var vpDivDims=self.vpDivDimsGet();vpView.width=Math.floor(vpDivDims.w*zoom);vpView.height=Math.floor(vpDivDims.h*zoom);if(self.isFitZoom()){// on resize, fit zoom changes but viewPosInfoUpdate() called below needs tileWidthXZoom up to date
	var fitZoom=self.fitZoomCompute();tileWidthXZoom=self.getTileWidth()*zoom;// update for quick access  //todo: I'm not certain this is that useful anymore
	tileHeightXZoom=self.getTileHeight()*zoom;}if(bUpdatePosition==true){self.viewPosInfoUpdate(vpView.left,vpView.top);}};//............................................ viewPosInfoPyramid
	VPAP_VIEW.viewPosInfoPyramid=function(zoomOfRequest){var zoomOfView=self.getViewZoom();var tileScale=zoomOfRequest/zoomOfView;if(zoomOfRequest!=self.getViewZoom()){if(self.isFitZoom(zoomOfRequest)){var imgDims=self.getImageDims();// in fit zoom, the center of the view is the center of the image
	var xCenter=Math.floor(imgDims.w/2);var yCenter=Math.floor(imgDims.h/2);}else{var xCenter=self.getViewCenterX();// from zoom absolute
	var yCenter=self.getViewCenterY();}var vpDivDims=self.vpDivDimsGet();var width=Math.floor(vpDivDims.w*zoomOfView);// from viewDimsUpdate
	var height=Math.floor(vpDivDims.h*zoomOfView);var left=Math.floor(xCenter-width/2.);// from zoom absolute
	var top=Math.floor(yCenter-height/2.);}else{var left=vpView.left;var top=vpView.top;var width=vpView.width;var height=vpView.height;}var tileWXZoom=self.getTileWidth()*zoomOfRequest;var tileHXZoom=self.getTileHeight()*zoomOfRequest;var tileL=Math.floor(left/tileWXZoom);// from viewPosInfoUpdate
	var tileT=Math.floor(top/tileHXZoom);//self.log("viewPosInfoPyramid: zoom: " + zoomOfRequest + "   LT Pix: " + vpView.left + "," + vpView.top);
	var csTilesVisible=new _objects.cSize(Math.ceil((left-tileL*tileWXZoom+width)/tileWXZoom),Math.ceil((top-tileT*tileHXZoom+height)/tileHXZoom));var csTiles=new _objects.cSize(csTilesVisible.w,csTilesVisible.h);var tileR=tileL+csTilesVisible.w-1;var tileB=tileT+csTilesVisible.h-1;if(viewOverFlowTiles_>0){//todo possibly: could increase viewOverFlowTiles_ as tileScale
	tileL-=viewOverFlowTiles_;tileT-=viewOverFlowTiles_;csTiles.add(2*viewOverFlowTiles_,2*viewOverFlowTiles_);tileR=tileL+csTiles.w-1;tileB=tileT+csTiles.h-1;}var zmView={left:left,top:top,zoom:zoomOfRequest,tileL:tileL,tileT:tileT,tileR:tileR,tileB:tileB,csTiles:csTiles,csTilesVisible:csTilesVisible};//debug-only self.log("viewPosInfoPyramid: " + toStringAssoc(zmView));
	return zmView;};//______________________________________________________
	// NAVIGATION RELATED
	//______________________________________________________
	var tileWidthXZoom,tileHeightXZoom;VPAP_NAV.navModeIsZoom=function(){return self.navMode==_defines2.default.eNavModes.nmZoom||self.navMode==_defines2.default.eNavModes.nmDClickZoom||self.navMode==_defines2.default.eNavModes.nmPinchZoom||self.navMode==_defines2.default.eNavModes.nmSmoothZoom?true:false;};var ptMouseDown=new _objects.cPoint(0,0);// viewport relative cursor position of last mouse down event
	VPAP_MOUSE.setMouseDown=function(x,y){ptMouseDown.set(x,y);};VPAP_MOUSE.getMouseDown=function(){return ptMouseDown;};var ptPrevMouseCur=new _objects.cPoint(0,0);// viewport relative previous cursor position
	var ptMouseCur=new _objects.cPoint(0,0);// viewport relative current cursor position
	VPAP_MOUSE.setMouseCur=function(x,y,option){if(option=='initPrev')ptPrevMouseCur.set(x,y);// if initializing previous too, then previous position = new position
	else ptPrevMouseCur.setPoint(ptMouseCur);// else the previous position = current position
	ptMouseCur.set(x,y);// current position = new position
	};VPAP_MOUSE.getMouseCur=function(){return ptMouseCur;};// current mouse position
	VPAP_MOUSE.setMouseCurRtnDiff=function(x,y){ptPrevMouseCur.setPoint(ptMouseCur);// previous position = current position
	ptMouseCur.set(x,y);// current position = new position
	return new _objects.cPoint(ptPrevMouseCur.x-ptMouseCur.x,ptPrevMouseCur.y-ptMouseCur.y);};VPAP_MOUSE.getMouseCurDiff=function(){// difference between previous and current mouse positions
	var ptRtn=new _objects.cPoint(ptPrevMouseCur.x-ptMouseCur.x,ptPrevMouseCur.y-ptMouseCur.y);return ptRtn;};//______________________________________________________
	// VIEW RELATED
	//______________________________________________________
	// because the rotation control's read out can be edited and that user change does not callback to the change event,
	//    a copy of the angle must be maintained and checked in the rotation dial's draw event where the viewport will be rotated if necessary.
	// ..................................................... position, dimension related
	VPAP_VIEW.getViewLeft=function(){return vpView.left;};VPAP_VIEW.getViewTop=function(){return vpView.top;};VPAP_VIEW.getViewLeftTop=function(){return new _objects.cPoint(vpView.left,vpView.top);};///perf impr: do not recompute except for on resize event
	VPAP_VIEW.getViewCenter=function(){var cpCenter=new _objects.cPoint(self.getViewCenterX(),self.getViewCenterY());return cpCenter;};// in base coords
	VPAP_VIEW.getViewCenterX=function(){return Math.round(vpView.left+vpView.width/2);};VPAP_VIEW.getViewCenterY=function(){return Math.round(vpView.top+vpView.height/2);};VPAP_VIEW.getViewWidth=function(){return vpView.width;};VPAP_VIEW.getViewHeight=function(){return vpView.height;};//note: getVisibleTileCount is only actually true when ENABLEPYRAMIDREFRESH = false (not using the pyramid)
	VPAP_VIEW.getVisibleTileCount=function(){return vpView.csTilesVisible.getArea();};VPAP_VIEW.getViewFocus=function(){return vpView.focus;};//______________________________________________________
	// ROTATION RELATED
	//______________________________________________________
	// ..................................................... rotation related
	VPAP_ROTATION.getViewAngle=function(inDegrees){return inDegrees==true?vpView.angleDeg:vpView.angleRad;};VPAP_ROTATION.saveRotationAngle=function(angleDeg){vpView.angleDeg=angleDeg;vpView.angleRad=angleDeg*_defines2.default.Deg2Rad;};VPAP_ROTATION.getRotationOffset=function(){return vpView.cpRotOffset;};VPAP_ROTATION.setRotationOffset=function(){var vpDivDims=self.vpDivDimsGet();vpView.cpRotOffset=(0,_helpers.computeRotationOffset)(vpDivDims.w,vpDivDims.h,vpView.angleRad);return vpView.cpRotOffset;};//______________________________________________________
	// ZOOM RELATED
	//______________________________________________________
	// ..................................................... fit zoom related
	var fixedZooms_;////todo: ??? copy of base var????
	var fitZoomChanged=true;VPAP_ZOOM.getFitZoom=function(){return fixedZooms_[0].zoom;};VPAP_ZOOM.setFitZoom=function(opt_zoom){if((0,_helpers.isUnDefined)(opt_zoom))opt_zoom=self.fitZoomCompute();else _defines2.default.helpers.roundToDecimals(opt_zoom);if(vpView.prevZoom===fixedZooms_[0].zoom)vpView.prevZoom=opt_zoom;else if(vpView.zoom===fixedZooms_[0].zoom)vpView.zoom=opt_zoom;//self.log("setFITZoom: curZoom= " + vpView.zoom + "  prevZoom=" + vpView.prevZoom)
	fixedZooms_[0].zoom=opt_zoom;};VPAP_ZOOM.isFitZoom=function(opt_zoom){if((0,_helpers.isDefined)(opt_zoom))return opt_zoom===fixedZooms_[0].zoom?true:false;else return vpView.isFitZoom;};VPAP_ZOOM.fitZoomChangedGet=function(){return fitZoomChanged;};VPAP_ZOOM.fitZoomChangedSet=function(){fitZoomChanged=true;};VPAP_ZOOM.fitZoomChangedReset=function(){fitZoomChanged=false;};VPAP_ZOOM.fitZoomCompute=function(){//override base
	var csImgDims=self.getImageDims();var imageWHRatio=csImgDims.w/csImgDims.h;// compute the image w/h ratio
	var viewDimsPx=self.vpDivDimsGet();var viewWHRatio=viewDimsPx.w/viewDimsPx.h;if(viewDimsPx.w<1||viewDimsPx.h<1){self.log('Error: fitZoomCompute: view dimensions are zero!  Defaulting Fit Zoom but this may cause other issues');return 2;}// select dimension to scale by
	var zoom=imageWHRatio>viewWHRatio?parseInt(csImgDims.w/viewDimsPx.w):parseInt(csImgDims.h/viewDimsPx.h);var zoom=(0,_helpers.limitValue)(zoom,1,_defines2.default.zoomSpecs.fitZoomMax);// constrain fit zoom factor between 1 and max of fitZoomMax
	var zoom=_defines2.default.helpers.roundToDecimals(zoom);// keep zoom in proper resolution
	//if (us.DBGZOOMCTL) { var mag = self.convertToMag(zoom); self.log(".. fitZoomCompute: mag: " + mag + "  fit zoom: " + zoom); }
	return zoom;};// ..................................................... view zoom related
	//todo: reconcile prev zoom with base class?
	VPAP_ZOOM.getViewPrevZoom=function(){return vpView.prevZoom;};// get previous zoom
	VPAP_ZOOM.getViewZoom=function(){return vpView.zoom;};VPAP_ZOOM.setViewZoom=function(zoom){if(self.isFitZoom()&&zoom==='Fit'){// if already at fit zoom and only updating fit zoom value
	vpView.zoom=self.fitZoomCompute();}else{vpView.prevZoom=vpView.zoom;// set vpView's prevZoom, zoom, and isFitZoom
	if(zoom==='Fit')zoom=self.fitZoomCompute();// if string passed, convert to value
	vpView.zoom=zoom;vpView.isFitZoom=self.isFitZoom(zoom);}tileWidthXZoom=self.getTileWidth()*zoom;// update for quick access  //toconsider: I'm not certain this is that useful anymore
	tileHeightXZoom=self.getTileHeight()*zoom;//debug-only  self.log("setVIEWZoom: curZoom= " + vpView.zoom + "  prevZoom=" + vpView.prevZoom)
	};// ..................................................... mag related
	VPAP_ZOOM.getViewMag=function(){return self.convertToMag(vpView.zoom);};// get current magnification
	//______________________________________________________
	// PYRAMID RELATED
	//______________________________________________________
	// ..................................................... image pyramid related
	var pyrSequence_={};// assoc array of pyramid zooms to use in tile requests for a given zoom
	var pyramid_=[];// note that the thumbnail is not on the pyramid
	VPAP_PYRAMID.getPyramid=function(){return pyramid_;};VPAP_PYRAMID.pyramidZoomsToUse=function(zoomOfRequest){if(pyrSequence_[zoomOfRequest]==undefined)// if pyramid at this zoom isn't already available, compute it
	pyrSequence_[zoomOfRequest]=self.pyramidSequenceGet(zoomOfRequest);return pyrSequence_[zoomOfRequest];};// browser capabilities related ........................
	var bHasPropertyValue_=uScope.bHasPropertyValue;// has getPropertyValue function
	//-------------------------------------------------------------------------------------------------
	//            o the area of the visible is the o's and the X is the startLeftPx coordinate at zoom
	//            + the tiles of the viewport overflow the visible viewport by a partial tile + N overTiles
	//
	//
	//            +---------+---------+---------+---------+--
	//            |         |         |         |         |
	//            | tileL,  |         |         |         |
	//            |  tileT  |         |         |         |
	//            +---------+---------+---------+---------+--
	//            |         |         |         |         |
	//            |         |    X o o o o o o o o o o o o o o o o o o
	//            |         |    o    |         |         |
	//            +---------+----o----+---------+---------+--
	//            |         |    o    |         |         |
	//            |         |    o    |         |         |
	//            |         |    o    |         |         |
	//            +---------+----o----+---------+---------+--
	//            |         |    o    |         |         |
	//
	//................................................................. viewBatchRequests
	//    This function is viewport's tile request engine.  It composes the img tags, collects them into batches of a
	//    given size for efficiency's ske and sends the collection to the tile request queue.  Prior to creating
	//    an img tag, it uses the tile watch dog to check if the tile already exists in the viewport and, if so,
	//    does not request that tile again (which would cause tile duplication in the viewport).
	//
	//    The following request variations affect the tile request coordinates, its screen position and its img tag dimensions.
	//        us.USEBASECOORDS:        base coordinate requests or direct coordinate requests
	//        us.ENABLEPYRAMIDREFRESH: pyramid zoom level requests or any zoom level request
	//
	//    parameters;
	//        viewStruct, batchSize, cpLeftTopTileNum, csRegionTiles, cpNormStartTile, searchPattern, opt_callerName
	//    returns:
	//        the number of tile requests performed
	var viewBatchRequests=function viewBatchRequests(viewStruct,batchSize,cpLeftTopTileNum,csRegionTiles,cpNormStartTile,searchPattern,reqQueInstruction,bFinalLevel,opt_callerName){//debug-only self.log("......viewBatchRequests:  called by: " + opt_callerName + ", reqQueBatchId_: " + reqQueBatchId_ + ", zoom: " + viewStruct.zoom);
	var zoomOfView=vpView.zoom;var zoomOfRequest=viewStruct.zoom;// init local vars for speed, given addressing modes
	var bNotBaseAndPyramid=_defines2.default.USEBASECOORDS==false||_defines2.default.ENABLEPYRAMIDREFRESH==true;// true for server-scaling base  and pyramid base or direct
	var tileScale=bNotBaseAndPyramid?zoomOfRequest/zoomOfView:1;// used for tile positioning
	var tileWidth=self.getTileWidth(),tileHeight=self.getTileHeight();var tstw=bNotBaseAndPyramid?Math.round(tileScale*tileWidth):tileWidth;// local vars for speed
	var tsth=bNotBaseAndPyramid?Math.round(tileScale*tileHeight):tileHeight;var tileWXZoom=bNotBaseAndPyramid?tileWidth*zoomOfRequest:tileWidth*zoomOfView;// used for base coord addressing
	var tileHXZoom=bNotBaseAndPyramid?tileHeight*zoomOfRequest:tileHeight*zoomOfView;var imgTagDims=void 0;if(_defines2.default.EXPAND_TILE_SIZE){imgTagDims=' width:'+(tstw+1)+'px; height:'+(tsth+1)+'px;';}else{imgTagDims=tileScale==1?'':' width:'+tstw+'px; height:'+tsth+'px;';// dimensions of tag to hold tile
	}var batchOfTiles=[];// container for batching tile requests
	var batchTileCount=0;// count of valid tiles in batchOfTiles batch
	//debug-only self.log("viewBatchRequests: " + callerName + "  batchId: " + reqQueBatchId_ + "  zoom:" + zoomOfRequest + "   LT tile: " + viewStruct.tileL + "," + viewStruct.tileT + "   RB tile: " + viewStruct.tileR + "," + viewStruct.tileB + "   LT pix: " + viewStruct.left + "," + viewStruct.top);
	//debug-only self.log("viewBatchRequests: " + callerName + "  batchId: " + reqQueBatchId_ + "  zoom:" + zoomOfRequest + "  cpLeftTopTileNum: " + cpLeftTopTileNum + "   csRegionTiles: " + csRegionTiles.toString());
	///width and height not reported+ "  BR pix: " + ((viewStruct.left + viewStruct.width) / zoomOfRequest) + "," + ((viewStruct.top + viewStruct.height) / zoomOfRequest));
	//debug-only self.log("... start ...viewBatchRequests: batchId: " + reqQueBatchId_ + "  zoom:" + zoomOfRequest + "  nTiles " + csRegionTiles.getArea());
	//debug-only self.log("viewBatchRequests: zoomOfRequest,View: " + zoomOfRequest + "," + zoomOfView + "   LT tile: " + viewStruct.tileL + "," + viewStruct.tileT + "  RB tile: " + viewStruct.tileR + "," + viewStruct.tileB + "   WxH tile: " + viewStruct.csTilesVisible.toString());
	var startLeftPx=Math.round(viewStruct.left/zoomOfView);// viewport relative x-position of zmView's left-most tile
	var startTopPx=Math.round(viewStruct.top/zoomOfView);var startTileL=cpLeftTopTileNum.x;var startTileT=cpLeftTopTileNum.y;var search=new _search2.default(cpNormStartTile,csRegionTiles,searchPattern);var cpTileNum=search.Next();// start with / get the 1st tile coords in the sequence
	var tilesQueuedCnt=0;var loopCnt=0;while(cpTileNum.x>=0){// and sequence through the image tiles in a spiral fill pattern (rtn pt (-1,-1) means end)
	if(_defines2.default.REQUEST_LARGER_TILES){tileWidth++;tileHeight++;}var curTileNumX=startTileL+cpTileNum.x;// convert to tile coords on image at this zoom
	var curTileNumY=startTileT+cpTileNum.y;var key=curTileNumX+'_'+curTileNumY+'_'+zoomOfRequest;// self.log("...... viewBatchRequests: tile: " + curTileNumX + "," + curTileNumY);
	var xPosVP=Math.floor(curTileNumX*tstw-startLeftPx);// the tile position in viewport coords
	var yPosVP=Math.floor(curTileNumY*tsth-startTopPx);//note: tile requests outside of image limits are returned with the background color which is ok
	//        but since moveConstrain restricts the view to real image tiles only the fit view has outside tiles
	//        so no real need to check like this:    if (curTileNumX >= 0 && curTileNumY >= 0) {
	if(_defines2.default.USEBASECOORDS==false){// tag format using zoom coords:  "<img class="us_tile" xtile="54" ytile="45" zoom="1" src="/imageserver/@@BAsSlf0 _ug==/@2?25920+21600+480+480+1+75" alt="" style="left: -47px; top: 132px;"></img>"
	var sTileSrc=self.urlBuilder.region(curTileNumX*tileWidth,curTileNumY*tileHeight,tileWidth,tileHeight,zoomOfRequest);}else{// tag format using base coords:  "<img class="us_tile" xtile="54" ytile="45" zoom="1" src="/imageserver/@@BAsSlf0 _ug==/@2?025920+021600+480+480+1+75" alt="" style="left: -47px; top: 132px;"></img>"
	var sTileSrc=self.urlBuilder.region('0'+Math.floor(0.5+curTileNumX*tileWXZoom),'0'+Math.floor(0.5+curTileNumY*tileHXZoom),tileWidth,tileHeight,zoomOfRequest);}//todo:  why not do this upstream????  if bFinalLevel is set upstream, the imageId could be set in the viewstruct....
	//todo: consider replacing quality as well?
	// if a whole slide region with a markup is selected and this is the final pyramid level of request replace the imageId in sTileSrc with the MarkupImageId
	//ia-todo: this is NOT the way to do it
	if(bFinalLevel==true&&self.isShowingMarkup()&&self.isShowingWholeSlideMarkup()){sTileSrc=sTileSrc.replace(self.getImageId()+'?',self.wholeSlideMarkupImageId+'?');}//debug-only self.log("viewBatchRequests: tile src: " + sTileSrc);
	//debug-only self.log("......viewBatchRequests:  request tile : " + curTileNumX + "," + curTileNumY + "   vpPos: " + xPosVP + "," + yPosVP + "   cpTileNum: " + cpTileNum.toString());
	// Note: Use of close img tag </img> causes IE8 problems: after removing the tag from the DOM the close tag remains. !
	//        As the user navigates more of these orphaned tags accumulate.  Closing the img tag this way '<img .../> does not cause this.
	var tag='<img class="'+_defines2.default.clsIMGTILE+'" xtile="'+curTileNumX+'" ytile="'+curTileNumY+'" zoom="'+zoomOfRequest+'" src="'+sTileSrc+'" alt="" style="left: '+xPosVP+'px; top: '+yPosVP+'px;'+imgTagDims+'"/>';//debug-only self.log("viewBatchRequests: queuing  key: " + key);
	//debug-only self.log("viewBatchRequests:  tag: " + tag);
	//debug-only self.log("viewBatchRequests:  sTileSrc: " + sTileSrc);
	//debug-only self.log("viewBatchRequests:  tag: " + tag + " \n    xtile: " + cpTileNum.x + " ytile: " + cpTileNum.y + " zoom: " + zoomOfRequest + " xcoord: " + curTileNumX * tileWidth + " ycoord: " + curTileNumY * tileHeight);
	//debug-only self.log(tilesQueuedCnt + " viewBatchRequests: search coord: " + cpTileNum.toString() + " tileNum: " + curTileNumX + "," + curTileNumY + "   vpPos: " + xPosVP + "," + yPosVP);
	batchOfTiles[batchTileCount++]={tag:tag,key:key};// add the tile tag to the batch
	if(batchTileCount==batchSize){// when batch array is full, append its tiles to the viewport div which sends the tile requests
	//debug-only self.log("viewBatchRequests: batchId: " + reqQueBatchId_ + "  batchTileCount: " + batchTileCount);
	reqQueue_.addToBatch(self.getImageIdx(),reqQueBatchId_,batchOfTiles,'refresh',reqQueInstruction);batchTileCount=0;}++tilesQueuedCnt;if(++loopCnt>200)break;// sanity check
	cpTileNum=search.Next();// get the next tile in the search pattern
	}// while
	if(batchTileCount>0){// append remainder of tiles to the viewport div
	//debug-only self.log("viewBatchRequests: batchId: " + reqQueBatchId_ + "  batchTileCount: " + batchTileCount);
	batchOfTiles.length=batchTileCount;reqQueue_.addToBatch(self.getImageIdx(),reqQueBatchId_,batchOfTiles,'refresh',reqQueInstruction);}//debug-only self.log("... end ... viewBatchRequests: batchId: " + reqQueBatchId_ + "  tilesQueuedCnt:" + tilesQueuedCnt);
	return tilesQueuedCnt;// return the actual number of tiles queued
	};//............................................ viewRefreshForce() public
	// This function forces a full view refresh.
	VPAP_VIEW.viewRefreshForce=function(action){self.viewRefreshPrep(true);// true: clear all pending tile requests
	self.viewRefresh(action);};//............................................ viewRefreshPartial() public
	// Remember to call viewRefreshPrep() first
	//    returns the maximum number of tileRequests - note that all, some or none may be requested (none?)
	VPAP_VIEW.viewRefreshPartial=function(curView,addLeftCols,addTopRows,addRightCols,addBottomRows){// self.log("viewRefreshPartial: INSIDE LT tile: " + curView.tileL + "," + curView.tileT + "  RB tile: " + curView.tileR + "," + curView.tileB + "   WxH tile: " + curView.csTiles.toString());
	self.progressive.refresh();// asap display the background, progressive image
	var partialRefreshTileCount=0;var doRequestsCols=false,doRequestsRows=false;//toconsider:  I'm not sure that bonusTiles helps as the request for tiles is repeated if you continue to pan in the same direction
	//                however it does prevent (?) seeing the tile get painted
	var bonusTiles=viewOverFlowTiles_==0?1:0;if(addLeftCols>0){// fill west side of view
	var patternCol=_defines2.default.eSEARCH_PATTERN.DOWN_LEFT;// "DOWN_LEFT(Fill W side):"
	addLeftCols+=bonusTiles;// fabricate an extra column to get
	var csRegionTilesCol=new _objects.cSize(addLeftCols,curView.csTiles.h);var leftTileNum=curView.tileL-bonusTiles;var cpLeftTopTileNumCol=new _objects.cPoint(leftTileNum,curView.tileT);var cpNormStartTileCol=new _objects.cPoint(csRegionTilesCol.w-1,0);// shift the normalized start tile on the right top of the pf region
	partialRefreshTileCount+=csRegionTilesCol.getArea();doRequestsCols=true;}else if(addRightCols>0){// fill east side of view
	addRightCols+=bonusTiles;//fabricate an extra column to get
	var patternCol=_defines2.default.eSEARCH_PATTERN.DOWN_RIGHT;//"DOWN_RIGHT(Fill E side):"
	var csRegionTilesCol=new _objects.cSize(addRightCols,curView.csTiles.h);var rightTileNum=curView.tileR-(addRightCols-bonusTiles-1);var cpLeftTopTileNumCol=new _objects.cPoint(rightTileNum,curView.tileT);var cpNormStartTileCol=new _objects.cPoint(0,0);partialRefreshTileCount+=csRegionTilesCol.getArea();doRequestsCols=true;}if(addTopRows>0){// fill north side of view
	addTopRows+=bonusTiles;var patternRow=_defines2.default.eSEARCH_PATTERN.RIGHT_UP;//"RIGHT_UP(Fill N side):"
	var csRegionTilesRow=new _objects.cSize(curView.csTiles.w,addTopRows);var topTileNum=curView.tileT-bonusTiles;var cpLeftTopTileNumRow=new _objects.cPoint(curView.tileL,topTileNum);var cpNormStartTileRow=new _objects.cPoint(0,csRegionTilesRow.h-1);partialRefreshTileCount+=csRegionTilesRow.getArea();doRequestsRows=true;}else if(addBottomRows>0){// fill south side of view
	addBottomRows+=bonusTiles;var patternRow=_defines2.default.eSEARCH_PATTERN.RIGHT_DOWN;// "RIGHT_DOWN(Fill S side):"
	var csRegionTilesRow=new _objects.cSize(curView.csTiles.w,addBottomRows);var bottomTileNum=curView.tileB-(addBottomRows-bonusTiles-1);var cpLeftTopTileNumRow=new _objects.cPoint(curView.tileL,bottomTileNum);var cpNormStartTileRow=new _objects.cPoint(0,0);partialRefreshTileCount+=csRegionTilesRow.getArea();doRequestsRows=true;}var tileRequestCount=0;var bFinalLevel_=true;// request markup tiles if there is a whole slide markup
	if(doRequestsCols==true||doRequestsRows==true){//debug-only self.log(us.searchPatternStr[pattern] + " cpLeftTopTileNum:" + cpLeftTopTileNum.toString() + "  csRegionTiles:" + csRegionTiles);
	//debug-onlyself.log("viewRefreshPartial: cols: " + doRequestsCols + "  rows: " + doRequestsRows);
	reqQueBatchId_=reqQueue_.startNewBatch(self.getImageIdx(),partialRefreshTileCount);// get new tile batch id for partial view request
	//debug-only self.log("viewRefreshPartial: batchId: " + reqQueBatchId_ + "  tileCount: " + partialRefreshTileCount);
	var batchSize=parseInt(partialRefreshTileCount/2);if(doRequestsCols==true)tileRequestCount+=viewBatchRequests(curView,batchSize,cpLeftTopTileNumCol,csRegionTilesCol,cpNormStartTileCol,patternCol,_defines2.default.RQ_SENDNOW,bFinalLevel_,'viewRefreshPartial');if(doRequestsRows==true)tileRequestCount+=viewBatchRequests(curView,batchSize,cpLeftTopTileNumRow,csRegionTilesRow,cpNormStartTileRow,patternRow,_defines2.default.RQ_SENDNOW,bFinalLevel_,'viewRefreshPartial');}return tileRequestCount;};//.................................................................
	//    viewMove - This function changes the position of tiles in the viewport.
	//
	//    Important note: This function is optimized for speed. Using jQuery to modify the css properties
	//                    left and top looks clean but at a substantial expense of time.  Because this
	//                    function is called when dragging the image on mouse move, time to complete the
	//                    operation and pick up the next move event is critical.
	//
	//                    Note that merely adding the dx,dy values to the current left,top positions of
	//                    the tiles accumulates an error at some zooms that is very noticeable especially
	//                    when an annotation is in view.  So the tile's x and y true position in the viewport
	//                    is computed.
	//
	//    Note: The thumbnail viewfinder is updated on a thread rather than each move as it is a coarse position
	//            and the drag motion of move is called say 20x before you'd notice or need a change to the vf position.
	//            This saves execution time and increases drag move responsivity.
	//
	////////////////////////////////////////////////////////////////////////////
	// tiles in the vp look like this:
	// <img timestamp="1367960612565" imageidx="0" batch="18" batchinfo="5/6"
	// class="us_tile" xtile="1" ytile="6" zoom="4" src="/imageserver/@2?480+2880+480+480+4+80" alt=""
	// style="left: 367px; top: 405px;  width:384px; height:384px; border : 1px solid #990033;">
	////////////////////////////////////////////////////////////////////////////
	//toconsider:perf impr: is it faster to store xtile,ytile,zoom as one attribute and parse it?
	VPAP_VIEW.viewMove=function(dx,dy){// incremental update just adds dx,dy to left, top of tiles but there are situations
	// where a tile can be misplaced so right now a little more work than that is employed.
	// todo: I've captured/recorded the misplaced tile events (below) but would like to know HOW it happens.
	var bDoIncremental=false;var jVpDiv=self.vpDivGet();var jTiles=jVpDiv.find('.'+_defines2.default.clsIMGTILE);// get the tiles at this zoom from the vp
	if(jTiles.length==0)return;//debug-only self.log("viewMove: nTiles: " + jTiles.length + " dx,dy: " + dx + "," + dy); // var tileCount0 = DBGreportOnVPTiles(false);
	//debug-only var positionsMatch = true;
	var tileWidth=self.getTileWidth(),tileHeight=self.getTileHeight();//todo: cache this for the image and remove all the gets for them
	var xPosVP,yPosVP;if(bDoIncremental==false){var zoomOfView=vpView.zoom;var startLeftPx=Math.round(vpView.left/zoomOfView);// viewport relative x-position of view's left-most tile
	var startTopPx=Math.round(vpView.top/zoomOfView);var scaledTileDim=[];// for each zoomOfRequest, save the scaled tile dims
	for(var t=0,len=jTiles.length;t<len;t++){// change the position of each tile in the viewport
	var tile=jTiles[t];var tileStyle=tile.style;var xtile=tile.getAttribute('xtile'),ytile=tile.getAttribute('ytile'),zoomOfRequest=tile.getAttribute('zoom');if(scaledTileDim[zoomOfRequest]==undefined){// to save time, only calculate these once
	var tileScale=zoomOfRequest/zoomOfView;var item={'tstw':Math.round(tileScale*tileWidth),'tsth':Math.round(tileScale*tileHeight)};scaledTileDim[zoomOfRequest]=item;}var xPosVP=Math.floor(xtile*scaledTileDim[zoomOfRequest].tstw-startLeftPx);// the tile position in viewport coords
	var yPosVP=Math.floor(ytile*scaledTileDim[zoomOfRequest].tsth-startTopPx);if(bHasPropertyValue_==true){// Chrome, FF13, FF12, IE9, IOS
	//debug-only    // updating incrementally (adding dx,dy) works fine for regular moves but when you pan like a maniac some tile positions go awry.
	//                    if (positionsMatch != undefined ) {// used to detect the problem.....run incremental first then this for comparison
	//                        var left = parseInt(tileStyle.getPropertyValue("left")) + dx;
	//                        var top = parseInt(tileStyle.getPropertyValue("top")) + dy;
	//                        if (left != xPosVP || top != yPosVP) {
	//                            self.log(t + "error  xtile, ytile: " + xtile + "," + ytile + "  left: " + left + "," + xPosVP + "   top: " + top + "," + yPosVP + "  tileDims: " + tstw + "x" + tsth);
	//                            positionsMatch = false;
	//                        }
	//                    }
	tileStyle.setProperty('left',xPosVP+'px','');// move the tile
	tileStyle.setProperty('top',yPosVP+'px','');}else{tileStyle.setAttribute('left',xPosVP+'px');tileStyle.setAttribute('top',yPosVP+'px');}}}else{for(var t=0,len=jTiles.length;t<len;t++){// change the position of each tile in the viewport
	var tile=jTiles[t];var tileStyle=tile.style;var xtile=tile.getAttribute('xtile'),ytile=tile.getAttribute('ytile'),zoomOfRequest=tile.getAttribute('zoom');if(bHasPropertyValue_==true){// Chrome, FF13, FF12, IE9, IOS
	xPosVP=parseInt(tileStyle.getPropertyValue('left'))+dx;yPosVP=parseInt(tileStyle.getPropertyValue('top'))+dy;tileStyle.setProperty('left',xPosVP+'px','');tileStyle.setProperty('top',yPosVP+'px','');}else{// IE7, IE8
	xPosVP=parseInt(tileStyle.getAttribute('left'))+dx;yPosVP=parseInt(tileStyle.getAttribute('top'))+dy;tileStyle.setAttribute('left',xPosVP+'px');tileStyle.setAttribute('top',yPosVP+'px');}}//debug-only var tileCount0 = DBGreportOnVPTiles(false);
	}self.markupRefresh('viewMove');// if a markup is showing, refresh it too
	};//............................................ viewRefreshPrep() public
	// This function is called in preparation for a full view refresh.
	// You can call it early, do some work, then call viewRefresh.
	// This will help responsiveness as it  purges the current tile request queue.
	VPAP_VIEW.viewRefreshPrep=function(opt_bResetRequestQueue){if(opt_bResetRequestQueue==true)reqQueue_.purge(self.getImageIdx());// clear all pending tile requests now
	};//............................................ viewRefresh() public
	//    This function performs a view refresh.
	//    It creates and places tiles in the viewport div appropriate for the current view position, dims and zoom.
	//    A callback on tile load is used to monitor the view tiles as they are loaded.
	//
	//    This function adds tiles from the center of the view outward in an ever increasing spiral pattern
	//    which is a more visually advantageous scheme to painting the view (in comparision to vpRefreshRows).
	//    Important note:  This function is optimized for speed.
	//        - reusing tiles already in the viewport rather than re-request them counting on the browser cache
	//        - adding tiles as merely img tags, not wrapped in divs
	//        - batching the tile appends to the viewport
	//        - building the tile tag without jquery
	//        - creating vars for items accessed more than once
	//        - commenting out built in debugging, e.g if (DBGXXX) needn't execute
	//
	// Remember to call viewRefreshPrep() first
	//    returns the maximum number of tileRequests - note that all, some or none may be requested (none?)
	VPAP_VIEW.viewRefresh=function(action){//debug-only self.log("viewRefresh: action: " + action + "  zoom: " + self.getViewZoom());
	//debug-only DBGcheckForDuplicateTiles();
	self.dragConstrainCnt=0;// reset moveConstrain throttle
	self.partialRefreshCnt=1;// reset conseq count of partialRefresh
	self.progressive.refresh();// display the background, progressive image
	// note that using base coords returns left most tile when negative tile numbers are requested (negative coords)
	// This only happens with Fit zoom. So switch addressing mode for fit zoom.
	var saveUSEBASECOORDS=_defines2.default.USEBASECOORDS;if(self.isFitZoom()==true&&saveUSEBASECOORDS==true)_defines2.default.USEBASECOORDS=false;/// a zmView object consist of: { left: left, top: top, zoom: zoomOfRequest, tileL: tileL, tileT: tileT, tileR: tileR, tileB: tileB,
	//                                csTiles: csTiles, csTilesVisible: csTilesVisible };
	var zmViewPackages=[];var viewRefreshTileCount=0;// this count can include overwritten lower pyramid level tiles!
	var vpView=self.getVPView();if(_defines2.default.ENABLEPYRAMIDREFRESH==false){// if requesting tiles to be scaled server-side
	viewRefreshTileCount+=vpView.csTilesVisible.getArea();zmViewPackages.push(vpView);}else{// else requesting tiles at pyramid levels and scaling client side
	var zoomSequence=self.pyramidZoomsToUse(vpView.zoom);// array of ordered zooms to request tiles e.g. 2,1 := baseZoom/2 first then baseZoom
	var startIdx=_defines2.default.USEMULTIPYRAMIDLEVELS==true?0:zoomSequence.length-1;var stopIdx=_defines2.default.ONLYLOWPYRAMIDLEVEL==false?zoomSequence.length:startIdx+1;// if smoothzoom, only use the low level choice //todo: ios pinch probably too
	if(self.navMode==_defines2.default.eNavModes.nmSmoothZoom)stopIdx=startIdx+1;for(var p=startIdx;p<stopIdx;p++){// get and save specifics of how to tile the view at each pyramid level
	var zmView=self.viewPosInfoPyramid(zoomSequence[p]);zmViewPackages.push(zmView);// a view structure for each zoomSequence
	viewRefreshTileCount+=zmView.csTilesVisible.getArea();}}//debug-only for (var i = 0; i < zmViewPackages.length; i++)    self.log("Order of zmViewPackages: " + toStringAssoc(zmViewPackages[i])); ////debug
	reqQueBatchId_=reqQueue_.startNewBatch(self.getImageIdx(),viewRefreshTileCount);// get new tile batch id for all tiles in full view request
	//debug-only self.log("viewRefresh: batchId: " + reqQueBatchId_ + "  tileCount: " + viewRefreshTileCount);
	var jVpDiv=self.vpDivGet();var jPrevTiles=jVpDiv.find('.'+_defines2.default.clsIMGTILE);// get list of the current tiles in the viewport
	jPrevTiles.addClass('removeme');// add class to identify existing tiles in the viewport div
	var tileRequestCount=0;var batchSize=6;// max number of tiles allowed in batchOfTiles - small number used to get requests out asap
	for(var p=0,len=zmViewPackages.length;p<len;p++){var zmView=zmViewPackages[p];var bFinalLevel_=p==len-1?true:false;// on the final pyramid level, request markup tiles if there is a whole slide markup
	var cpLeftTopTileNum=new _objects.cPoint(zmView.tileL,zmView.tileT);var cpNormStartTile=new _objects.cPoint(zmView.csTilesVisible.getCenterW(true),zmView.csTilesVisible.getCenterH(true));tileRequestCount+=viewBatchRequests(zmView,batchSize,cpLeftTopTileNum,zmView.csTiles,cpNormStartTile,_defines2.default.eSEARCH_PATTERN.SPIRAL_FILL,_defines2.default.RQ_THROTTLE,bFinalLevel_,'viewRefresh');}jVpDiv.find('.removeme').remove();// remove the prior viewport tiles - I'm reusing none of them
	var frameTileRequestCnt=viewRefreshFrame(zmViewPackages,action);// request a frame of tiles about this view
	self.markupRefresh(action);// for non-whole slide markup selected regions
	_defines2.default.USEBASECOORDS=saveUSEBASECOORDS;return tileRequestCount;};//............................................ viewport markupTilesRemove()
	// This function removes any prior markup tiles from the markup div and sets the markup div's regionid attribute.
	VPAP_MARKUP.markupTilesRemove=function(opt_regionId,opt_zoom){if(_defines2.default.DISPLAYMARKUP==false)return;if(jMuDiv){// if the markup div exists
	var jPrevTiles=jMuDiv.find('.'+_defines2.default.clsTILEMARKUP);// get list of the current tiles in the markup div
	//debug-onlythis.log("     markupTilesRemove: current regionid: " + jMuDiv.attr("regionid") + " changing to: " + (opt_regionId ? opt_regionId : "") + " current tileCount: " + jPrevTiles.length);
	jPrevTiles.remove();// remove the prior markup tiles
	// and add the regionId (or blank) as an attribute to the markup div
	jMuDiv.attr('regionid',opt_regionId?opt_regionId:'');jMuDiv.attr('zoom',opt_zoom?opt_zoom:'');}};//............................................ viewport markupRefresh()
	// This function paints markups of regions that do not cover the whole slide.
	////note: this is called on firstPaint, move, zoom and reSelect ALL before it is initialized.. atleast firstPaint could not call it
	// The markup div 'jMuDiv' carries an attribute 'regionid' that indicates what region the current tiles in the div are related to
	VPAP_MARKUP.markupRefresh=function(action){if(_defines2.default.DISPLAYMARKUP==false)return;// insure markup display is permitted
	if(self.isInitialized()==false){self.log('markupRefresh: viewport is not initialized');return;}if(self.annots==undefined){self.log('markupRefresh: annots are not defined');return;}if(self.annots.isInitialized()==false){self.log('markupRefresh: annots are not initialized');return;}//if (us.DBGMARKUP)  self.log("markupRefresh enter(" + action + ")");
	// perform sanity checks and verify that region has markup in view .....................
	if(self.isShowingWholeSlideMarkup()==true)// if currently showing a whole slide markup, nothing to do here
	return;// return
	if(self.annots.hasMarkup()==false){// if the image has no markups (or no longer has any markups)
	self.markupTilesRemove();// then clear out any markup tiles in the markup div
	return;// and return
	}if(self.annots.markupIsInView(self.getVPViewRect2())==false){// if the selected region is not in the view or does not have a markup
	self.markupTilesRemove();// then clear out any markup tiles in the markup div
	return;// and return
	}// prep information about the markup ...................................................
	// Currently if a region has a markup, its xinfo is requested when the regon is initialized.
	// I actually don't need the markup xinfo initialized here (defaults are fine).
	var markupInfo=self.annots.getMarkupInfo();// get markup info for the selected region
	if(markupInfo==undefined||markupInfo.MarkupImageId==undefined){//toconsider: CAN THIS HAPPEN?
	//if (us.DBGMARKUP) self.log("markupRefresh: region's markup is not defined");
	self.markupTilesRemove();// clear out any markup tiles in the markup div
	return;}if(_defines2.default.DBGMARKUP)self.log('.......... markupattr: '+(0,_helpers.toStringAssoc)(markupInfo));var markupId=markupInfo.MarkupImageId;var boundingBox=markupInfo.boundingBox;// bounding box is image base coords of markup/region
	var xPosVP00=boundingBox.left-vpView.left;// left and top position in vp of region's LT (0,0) tile
	var yPosVP00=boundingBox.top-vpView.top;self.urlBuilderMarkup.setImageId(markupId);// use this markup's id in the urlBuilder
	//if (us.DBGMARKUP) self.log("markupRefresh: bbox: " + boundingBox.toString() + "   WxH: " + boundingBox.w + "x" + boundingBox.h);
	//if (us.DBGMARKUP) self.log("markupRefresh: vpView, bbox, region: left" + vpView.left + "," + boundingBox.left + "," + xPosVP00 + "  top:" + vpView.top + "," + boundingBox.top + "," + yPosVP00);
	// render the markup region ............................................................
	// render the whole region if markup is small at scan zoom or if it is small at this zoom
	var viewZoom=vpView.zoom;if(markupInfo.isSmall==true)markupRenderByRegion();// small markups are just getting a single region, not tiled, at scan resolution and scaling to fit the region
	else markupRenderByTile();// larger markup regions are rendered tiled at varying resolutions (pyramid zooms)
	return;//..................................................
	// closure functions
	//............................................ markupRenderByRegion()
	// This function renders the entire markup as a single tile at the top left location of the associated region.
	//
	//    Note:  the region is ALWAYS requested at scan resolution (zoomOfRequest = 1).
	//            So, given the browser cache,it is only fetched from the server once.  This can be changed, of course.
	function markupRenderByRegion(){// have I already rendered this region at this zoom? if so then I just need to move that one region/tile
	if(jMuDiv.attr('regionid')==markupInfo.regionId&&jMuDiv.attr('zoom')==viewZoom){var jTiles=jMuDiv.find('.'+_defines2.default.clsTILEMARKUP);if(_defines2.default.DBGMARKUP)self.log('     isSameRegion: '+jTiles.length+'   move to: '+xPosVP00+','+yPosVP00);if(jTiles.length&&parseInt(jTiles.css('width'))==parseInt(boundingBox.w/viewZoom)){jTiles.css({'left':xPosVP00/viewZoom+'px','top':yPosVP00/viewZoom+'px'});return;}}var zoomOfRequest=1;// build the src at scan resolution
	self.markupTilesRemove(markupInfo.regionId,viewZoom);// clear out any markup tiles in the markup div
	var sTileSrc=self.urlBuilderMarkup.region(0,0,parseInt(boundingBox.w),parseInt(boundingBox.h),zoomOfRequest,_defines2.default.markupQuality);// Note: Use of close img tag </img> causes IE8 problems: after removing the tag from the DOM the close tag remains. !
	//        As the user navigates more of these orphaned tags accumulate.  Closing the img tag this way '<img .../> does not cause this.
	var imgTagDims=' width:'+parseInt(boundingBox.w/viewZoom)+'px; height:'+parseInt(boundingBox.h/viewZoom)+'px;';// dimensions of tag to hold tile
	var tag='<img class="'+_defines2.default.clsTILEMARKUP+'" xtile="'+0+'" ytile="'+0+'" zoom="'+zoomOfRequest+'" src="'+sTileSrc+'" alt="" style="left: '+xPosVP00/viewZoom+'px; top: '+yPosVP00/viewZoom+'px;'+imgTagDims+'"/>';if(_defines2.default.DBGMARKUP)self.log('     markupRenderByRegion: tag: '+tag);appendTagToMarkupDiv(tag);return true;}//............................................ markupRenderByTile()
	// This function renders the markup as a tile grid inside the associated region
	function markupRenderByTile(){self.markupTilesRemove(markupInfo.regionId,viewZoom);/////////////////////////////todo: consider above efficiency and maybe rewrite....
	// I think this needs to be thought through.... the request below start at what ever the left/top coord is, not on a tile boundary ref'd from 0,0 of the region
	// so as a region is hidden on the left or top, the tile requests shift position.... not efficient..... hmmmm
	//todo: this clipping is losing the lower right !!!!!!!!!!!!!!!!!!!!!!!!!
	//    var regBounded = setRegionBounds(boundingBox);
	//    boundingBox = regBounded;
	/////////////////////////////todo: consider above efficiency and maybe rewrite....
	var zoomSequence=self.pyramidZoomsToUse(viewZoom);// use base image to decide which zoom to request tiles for the markup
	var zoomOfRequest=zoomSequence.length?zoomSequence[zoomSequence.length-1]:2;//todo: get closest power of 2 to current zoom
	//debug-only self.log("markupRenderByTile: view zoom: " + viewZoom + " request zoom:" + zoomOfRequest);
	// note that I am using the tile width and height of the markup but that really I could request at any tile dims I want
	//todo: perhaps I don't need the xinfo request for the markup - efficient?  Meanwhile the mu tile dims default to reasonable values
	var tw=markupInfo.tileWidth,th=markupInfo.tileHeight;// set region tile dims to that of markup image
	var strDbg='Medium Sized Region Tile Reqs: ';var xTile=0,yTile=0;// x and y tile index in grid coords inside the region
	var regBottom=boundingBox.top+boundingBox.h/zoomOfRequest;for(var tileTop=boundingBox.top;tileTop<regBottom;tileTop+=th,yTile++){// tileTop is image based coord
	xTile=0;// reset x tile index
	var tileY=tileTop-boundingBox.top;// markup based coord of tile top; first tile is at 0,0
	var yPosVP=yPosVP00+tileY*zoomOfRequest;// viewport Y position of tile
	var tileH=tileTop+th>regBottom?regBottom-tileTop:th;// height of to be requested tile, clipping at bottom
	//if (tileTop and tileBottom is not in viewY) continue
	// if tileTop > view Bottom can stop?
	var regRight=boundingBox.left+boundingBox.w/zoomOfRequest;for(var tileLeft=boundingBox.left;tileLeft<regRight;tileLeft+=tw,xTile++){// tileLeft is image based coord
	var tileX=tileLeft-boundingBox.left;// markup based coord of tile left; first tile is at 0,0
	var xPosVP=xPosVP00+tileX*zoomOfRequest;// viewport X position of tile
	var tileW=tileLeft+tw>regRight?regRight-tileLeft:tw;// width of to be requested tile, clipping at right
	strDbg+=' VP:('+xPosVP+','+yPosVP+')';//if (tileLeft and tileRight is not in viewX) continue
	// if tile left > view right, break?
	var sTileSrc=self.urlBuilderMarkup.region(tileX,tileY,tileW,tileH,zoomOfRequest);var zoomFactor=viewZoom/zoomOfRequest;// Note: Use of close img tag </img> causes IE8 problems: after removing the tag from the DOM the close tag remains. !
	//        As the user navigates more of these orphaned tags accumulate.  Closing the img tag this way '<img .../> does not cause this.
	var imgTagDims=' width:'+tileW/zoomFactor+'px; height:'+tileH/zoomFactor+'px;';// dimensions of tag to hold tile
	var tag='<img class="'+_defines2.default.clsTILEMARKUP+'" xtile="'+xTile+'" ytile="'+yTile+'" zoom="'+zoomOfRequest+'" src="'+sTileSrc+'" alt="" style="left: '+xPosVP/viewZoom+'px; top: '+yPosVP/viewZoom+'px;'+imgTagDims+'"/>';if(_defines2.default.DBGMARKUP)self.log('markupRenderByTile:  tag: '+tag);appendTagToMarkupDiv(tag);}}if(_defines2.default.DBGMARKUP)self.log('markupRenderByTile: '+strDbg);}//............................................ appendTagToMarkupDiv()
	function appendTagToMarkupDiv(tag){var jTile=$(tag);// attaches to the dom which issues the image request
	jTile.on('load',function(e){markupLoaded_cb(e,markupId);});jTile.on('error',function(e){markupError_cb(e,markupId);});jMuDiv.append(jTile);return;//..................................................
	// closure functions
	//............................................ markupLoaded_cb()
	function markupLoaded_cb(e,markupId){}//debug-only self.log("markup loaded: " + markupId);
	//............................................ markupError_cb()
	function markupError_cb(e,markupId){self.log('Error: Markup request: '+markupId);}}//............................................ setRegionBounds()
	// This function defines regLeft, regTop, regW, regH for the current view given the region's bounding box
	function setRegionBounds(boundingBox){var regLeft=0;var regTop=0;var regW=boundingBox.w;var regH=boundingBox.h;// region coords and dims inside of view
	var xPosVP=boundingBox.left-vpView.left;// left position in vp of region's LT (0,0) tile
	var yPosVP=boundingBox.top-vpView.top;// top position in vp is 0
	//debug-only self.log("markupRefresh: vpView, bbox, region: left" + vpView.left + "," + boundingBox.left + "," + xPosVP + "  top:" + vpView.top + "," + boundingBox.top + "," + yPosVP);
	if(xPosVP<0){// if the region is overflowing the view left side
	regLeft=-xPosVP;// region left is > 0
	regW=regW-regLeft;// the region width that is inside the view < boundingbox.w
	xPosVP=0;// left position in vp is 0
	}if(yPosVP<0){// if the region is overflowing the view top
	regTop=-yPosVP;// region top is > 0
	regH=regH-regTop;// the region height that is inside the view < boundingbox.h
	yPosVP=0;// top position in vp is 0
	}if(xPosVP+regW>vpView.width){// if the region is overflowing the view right side
	regW=vpView.width-xPosVP;// the region width that is inside the view < boundingbox.w
	}if(yPosVP+regH>vpView.height){// if the region is overflowing the view bottom
	regH=vpView.height-yPosVP;// the region height that is inside the view < boundingbox.h
	}////debug
	//                        if (regW != boundingBox.w || regH != boundingBox.h)
	//                            self.log("....... request limited : XY: " + regLeft + "," + regTop + "  WxH: " + regW + "x" + regH);
	//                        else
	//                            self.log("....... request           XY: " + regLeft + "," + regTop + "  WxH: " + regW + "x" + regH);
	return new _objects.cRect2(regLeft,regTop,regLeft+regW,regTop+regH);}//..................................................
	};//............................................ viewRefreshFrame() local
	//    viewRefreshFrame - This function requests a frame of tiles around the current view
	//                        as specified by the passed parameter 'zmViewPackages'.
	//
	//    parameters:
	//        zmViewPackages:        a view structure for each zoomSequence
	//        action:                call context description
	//
	//    returns a count of the number of tiles requested
	var viewRefreshFrame=function viewRefreshFrame(zmViewPackages,action){if(self.isFitZoom()==true||viewFrameWidthInTiles<1)return 0;//self.log("viewRefreshFrame:  frameWidthInTiles: " + viewFrameWidthInTiles);
	// get new tile batch id but do NOT specify the total tilecount
	//    (therefore no view refresh event fires AND this batch can be abandoned when a new batch is started)
	reqQueBatchId_=reqQueue_.startNewBatch(self.getImageIdx());// get new tile batch id for view frame refresh
	//debug-only self.log("viewRefreshFrame: batchId: " + reqQueBatchId_ + "  tileCount: undefined");
	// modify the zmViewPackages for the frame geometry
	var frameViewPackages=[];for(var p=0,len=zmViewPackages.length;p<len;p++){//self.log("Orig   zmViewPackage (" + p + "): " + toStringAssoc(zmViewPackages[p]));
	var viewPackage=zmViewPackages[p];var framePackage=new _helpers.cloneObject(viewPackage);framePackage.tileL-=viewFrameWidthInTiles;framePackage.tileT-=viewFrameWidthInTiles;framePackage.tileR+=viewFrameWidthInTiles;framePackage.tileB+=viewFrameWidthInTiles;framePackage.csTiles=new _objects.cSize(viewPackage.csTiles.w+2*viewFrameWidthInTiles,viewPackage.csTiles.h+2*viewFrameWidthInTiles);framePackage.csTilesVisible=new _objects.cSize(0,0);// the frame doesn't start out visible
	frameViewPackages[p]=framePackage;//self.log("Framed framePackage (" + p + "): " + toStringAssoc(framePackage));
	}var tileRequestCount=0;var batchSize=6;// max number of tiles allowed in batchOfTiles - small number used to get requests out asap
	for(p=0,len=frameViewPackages.length;p<len;p++){var frameView=frameViewPackages[p];var cpNormStartTile=new _objects.cPoint(viewFrameWidthInTiles-1,viewFrameWidthInTiles-1);var cpLeftTopTileNum=new _objects.cPoint(frameView.tileL,frameView.tileT);var bFinalLevel_=p==len-1?true:false;// on the final pyramid level, request markup tiles if there is a whole slide markup
	tileRequestCount+=viewBatchRequests(frameView,batchSize,cpLeftTopTileNum,frameView.csTiles,cpNormStartTile,_defines2.default.eSEARCH_PATTERN.SPIRAL_FRAME,_defines2.default.RQ_THROTTLE,bFinalLevel_,'viewRefreshFrame');}return tileRequestCount;};//............................................ viewDragMomemtumGo()
	VPAP_VIEW.viewDragMomemtumGo=function(){if(viewDragMomemtum_!=undefined)viewDragMomemtum_.go();};//............................................ viewRotate() public
	// viewRotate - This function rotates the view and the thumbnail about their centers.
	VPAP_VIEW.viewRotate=function(newAngleDeg){// TODO: Create some kind of "state" object for the viewport. It should track things like zoom, rotation, whether or not it's active...
	newAngleDeg=newAngleDeg%360;// bound input angle
	var curAngleDeg=self.getViewAngle(true);// get current angle
	if(curAngleDeg==newAngleDeg)// and get out if there is nothing to do
	return;self.saveRotationAngle(newAngleDeg);// save the new rotation angle
	self.stateVector.viewUpdate(vpView,'rotate');// add rotation angle to view state vector
	var jVpDiv=self.vpDivGet();var vpDivDims=self.vpDivDimsGet();var vpW=vpDivDims.w,vpH=vpDivDims.h;// rotate the (inner) viewport div
	var angleRad=self.getViewAngle();(0,_helpers.divRotate)(jVpDiv[0],0,0,vpW,vpH,angleRad);if(self.isShowingMarkup())(0,_helpers.divRotate)(jMuDiv[0],0,0,vpW,vpH,angleRad);// note - the reported offset is always +/- 1 pixel from my result in computeRotationOffset
	//debug-only self.log("viewRotate: angle: " + newAngleDeg + "   actual div offset: " + parseInt(jVpDiv.offset().left) + "," + parseInt(jVpDiv.offset().top));
	// note- this offset is applied to the inner vpDiv automatically when rotated to keep centered
	var cpVpOffset=self.setRotationOffset();// compute and save the rotation offset
	//debug-only self.log("viewRotate: angle: " + newAngleDeg + " VIEW  WxH: " + vpW + "x" + vpH + "  computed div offset: " + cpVpOffset.x + "," + cpVpOffset.y);
	self.viewRefreshPrep(true);// now purge the request queue so the full view will refresh
	self.viewRefresh('rotate');// and do the full view refresh (all this to fill in the prior- hidden corners and update the progressive)
	self.events.trigger('viewport:rotate',angleRad);///////////////////////////////////////////////////////////
	// if (self.annots)////////// if called on image open, annots won't exist yet
	//     self.annots.rotate(newAngleDeg);                 // rotate specific annotations (the annot div rotates inside the vp, this reverse rotates pins for example)
	/////////////////////////////////////////////////////////////
	// in case this call was not rotation dial initiated, set the dial value
	self.rotationDial.setValue(newAngleDeg);};//............................................ bindEvents_() local
	// bindEvents_ - This function adds viewport event handlers.
	//
	//    Note that all event handlers bound to this image use the same namespace as this viewport.
	//    So when this viewport removes its events by namespace, they are also removed.
	var bindEvents_=function bindEvents_(){var namespace=self.eventNameSpaceGet();var jVpDiv=self.vpDivGet();$(_defines2.default.idHashROOT).on(_defines2.default.evVIEWRESIZE+namespace,function(e,parms){// self.log("viewport: " + e.type );
	if(self.isShowingMarkup()){//debug-only self.log("viewport: " + e.type + ".......................markup not fully operational yet ?? ");
	///////////////////////////////////////////////////////////////////////////////////////////////////////in work
	//if (self.isShowingMarkup())
	//vpDivDims
	//    jMuDiv.css({ "left": "0px", "top": "0px", "width": rectDiv.w + "px", "height": rectDiv.h + "px" }); // the markup div
	///////////////////////////////////////////////////////////////////////////////////////////////////////
	}});////////////////////////////////////////////////////////////////////in work
	if(self.isShowingMarkup()){// add event handlers for markup
	jMuDiv.on('mousemove'+namespace,function(e){//debug-only if (e.type != "mousemove") self.log(" - markup " + e.type);
	if(self.navModeGet()!=_defines2.default.eNavModes.nmNone||uScope.isModeConference()==true){(0,_navigation.vp_mousemove)(self,e);}e.preventDefault();// necessary for IE panning to halt properly when pan cursor moves off viewport
	return true;});jMuDiv.on('mousedown'+namespace+' mouseup'+namespace////    jMuDiv.on("mousedown" + namespace + " mousemove" + namespace + " mouseup" + namespace
	+' mouseleave'+namespace+' dblclick'+namespace,function(e){//debug-only if (e.type != "mousemove") self.log(" - markup " + e.type);
	(0,_navigation.VP_MOUSEHANDLER)(e,self);e.preventDefault();// necessary for IE panning to halt properly when pan cursor moves off viewport
	return true;});$(_defines2.default.idHashROOT).on(_defines2.default.evANNOTCHANGE,function(e,parms){// on region select, add, del all need to update markup
	//debug-only self.log("viewport: " + e.type + ": " + toStringAssoc(parms));
	self.markupRefresh('Annotatation '+parms.action);});}// isShowingMarkup()
	jVpDiv.on('mousedown'+namespace,'.'+_defines2.default.clsIMGTILE,function(e){//debug-only self.log("viewport imgtile: " + e.type);
	e.preventDefault();// to prevent the grab and drag of an individual tile (IE)
	});jVpDiv.on('mousedown'+namespace+' mousemove'+namespace+' mouseup'+namespace+' mouseleave'+namespace+' dblclick'+namespace,function(e){//debug-only if (e.type != "mousemove") self.log("viewport " + e.type);
	(0,_navigation.VP_MOUSEHANDLER)(e,self);e.preventDefault();// necessary for IE panning to halt properly when pan cursor moves off viewport
	return true;});if(_compatibility.BrowserDetect.isIOS()==false){// no mousewheel on iOS!
	jVpDiv.on('mousewheel'+namespace,function(e,delta,deltaX,deltaY){//debug-only self.log("- viewport " + e.type);
	if(self.mwZoomStopping==true)self.mwZoomStopping=false;if(self.mwZoomStopping==true)return false;// don't respond to wheel until image is resolved
	if(self.getViewZoom()==1.0&&deltaY<0)return false;// don't try to zoom > scan
	(0,_navigation.VP_MOUSEWHEEL)(self,e,delta,deltaX,deltaY);// perform mouse wheel zoom
	// if smooth zooming, set a timer to indicate mousewheel stopped rolling
	if(self.mwZoomStopping==false&&deltaY){clearTimeout($.data(this,'timer'));$.data(this,'timer',setTimeout(function(){self.mwZoomStopping=true;//if (us.DBGZOOMCTL) self.log("MouseWheel call to zoomAbsolute: " + thisImg.getViewZoom());
	_defines2.default.navModeHalt(self);self.zoomAbsolute(self.getViewZoom());// execute the zoom
	},600));}e.preventDefault();return false;});}};//............................................ imageClose()
	VPAP_IMAGE.imageClose=function(){var status=baseImageClose();if(_defines2.default.ENABLEANNOTSELSAVE==false&&self.annots)// if not saving selected annot each time the user selects one,
	self.annots.regSelectSaveAtClose();// then the last selected has yet to be saved, do so
	bindEventsOff_();// remove event handlers for viewport
	if(self.progressive)self.progressive.blurFetchStop_();// stop the progressive blur image fetch timer //todo: do I really need to do this? //does removing the object cancel the timers?
	reqQueue_.unRegister(self.getImageIdx());// UNregister this image with uScope's tile request queue
	//................................closure fns
	function bindEventsOff_(){//debug-only self.log('ViewportAP: bindEventsOff_');
	// nothing here that base does not do for me
	}};//............................................ imageOpen()
	VPAP_IMAGE.imageOpen=function(inImageId){var status=baseImageOpen(inImageId);if(status){pyramid_=self.pyramidInit(self);// build array containing the refresh pyramid
	fixedZooms_=self.getFixedZoomArray();// copy of base var
	vpView.init();self.stateVector.viewUpdate(vpView,'all');// inform state vector of initial image state
	vpView.prevZoom=fixedZooms_[0].zoom;// initialize with vpView zoom of 1 and prevZoom of fit, and let initState overrule those settings
	if(self.initState.zoom!=undefined){// the initialState zoom has priority over the initialState magnification
	self.initState.zoom=self.zoomConstrain(self.initState.zoom);// conferencing can initialize with an unrealizable fit zoom
	self.initState.mag=self.convertToMag(self.initState.zoom);self.log('fit zoom: '+self.getFitZoom()+'  initstate zoom: '+self.initState.zoom+'   initState.mag: '+self.initState.mag);}else if(self.initState.mag!=undefined){// if an initState magnification is defined, redefine zoom and view dimensions
	self.initState.zoom=1.0;// initialize the current view zoom
	if(self.initState.mag==='Fit')self.initState.zoom=self.getFitZoom();else if(self.initState.mag!=='Scan')self.initState.zoom=self.convertToZoom(self.initState.mag);}self.setViewZoom(self.initState.zoom);if(self.isFitZoom(self.initState.zoom)==true){// initialize the previous view zoom
	// opening at fit then the desired previous zoom is 4x mag when current zoom is Fit
	// if that prev zoom can be achieved use it,  otherwise set the prev zoom to the scan zoom
	var prevZoom=self.convertToZoom(4);vpView.prevZoom=prevZoom<vpView.zoom?prevZoom:fixedZooms_[fixedZooms_.length-1].zoom;}else{// not opening at fit, then set the previous zoom to fit
	vpView.prevZoom=fixedZooms_[0].zoom;// constrain zoom factor to fixed zoom min and max
	vpView.zoom=self.zoomConstrain(self.initState.zoom);// don't use setViewZoom here - it will change prevZoom
	}self.viewDimsUpdate(false);// update width, height of vpView (base image coord system)
	// initialize left, top corner of vpView (base image coord system)
	vpView.left=(0,_helpers.isDefined)(self.initState.centerX)// if the initial state value is valid
	?Math.floor(self.initState.centerX-vpView.width/2.)// use it
	:Math.floor((self.xinfo.get_imageWidth()-vpView.width)/2.);// else center the image in X
	vpView.top=(0,_helpers.isDefined)(self.initState.centerY)// if the initial state value is valid
	?Math.floor(self.initState.centerY-vpView.height/2.)// use it
	:Math.floor((self.xinfo.get_imageHeight()-vpView.height)/2.);// else center the image in Y
	self.viewPosInfoUpdate(vpView.left,vpView.top);// initialize the view and frame positions
	self.progressive=new _overlays.cProgressive(self);// create the progressive view object - large image load so do it first
	self.viewOverlayInit_();// base class fn: load the overlay visuals
	viewDragMomemtum_=new cDragMomemtum(self);// create the drag momentum object
	reqQueue_.register(self.getImageIdx(),this,self.vpDivGet());// register this image with uScope's tile request queue
	if(self.initState.angle)// .............................. now paint the first view
	self.viewRotate(self.initState.angle);// if initial rotation is set, view rotation refresh
	else self.viewRefresh('firstPaint');// otherwise normal view refresh
	bindEvents_();// add event handlers
	self.setInitialized();// indicate that initialization is successful
	self.setImageSelected(true);// inform uScope that this image is in focus
	uScope.annotPanel.enableDrawingIcons(uScope.canAnnotate());// if the annotations panel is already visible, set the drawing icon state
	}(0,_events.triggerUScopeEvent)(_defines2.default.evIMAGEREADY,{// fire event: the image is loaded
	imageId:self.getImageId(),uScopeIdx:self.getImageIdx(),status:self.getStatus()});return status;};//______________________________________________________
	// VIEW NAVIGATION RELATED
	//______________________________________________________
	//............................................ moveRelative
	// moveRelative - This function moves the selected image the specified amount in x and y.
	//
	//    Note: This function is core to panning and so speed is very important. The vpView items are directly
	//         addressed rather than use the access functions (e.g. getViewZoom, getViewLeft, getViewTop).
	//        This is permitted as the function is a part of the cViewport object.
	VPAP_MOVE.moveRelative=function(dx,dy){var vpView=self.getVPView();var zoom=vpView.zoom;var left=parseInt(vpView.left+dx*zoom);// add the relative move to the viewport left,top corner position
	var top=parseInt(vpView.top+dy*zoom);//if (us.DBGNAV) self.log("moveRelative: dXY:(" + dx + "," + dy + ")"); ///   LT: (" + vpView.left + "-->" + left + "," + vpView.top + "-->" + top + ")");
	return self.moveAbsolute(left,top);// and update the view
	};//............................................ moveAbsolute
	// moveAbsolute - This function moves the selected image to the specified position
	//                    and informs the state vector object of the position change.
	//
	//  RULE: Always adjust the viewport position first, then the image position wrt viewport.
	//
	//    parameters:
	//        left, top:        required, integer, the view's left,top position in base image coordinates
	//    return:                the maximum number of tileRequests - note that all, some or none may be requested (none?)
	//
	//todo: IOS - how many tiles CAN accumulate
	VPAP_MOVE.moveAbsolute=function(left,top){//override base
	//if (us.DBGNAV) self.log("....moveAbsolute:  left,top=(" + left + "," + top + ")");
	var tileRequestCount=0;var dx,dy;//note: do not initialize these.  They are only valid on minor viewMove updates.
	var vpView=self.getVPView();var zoom=vpView.zoom;var doFullRefresh=false;// flag to perform full verse partial view refresh
	if(self.partialRefreshCnt%8==0){// to prevent the vp from filling with tiles during long pan sessions
	doFullRefresh=true;// check the running count of vp tiles and force a refresh once in a while (clears the vp)
	//debug-only self.log("moveAbsolute: " + self.partialRefreshCnt+ " partial refreshes performed, force a full viewRefresh.");
	}else{// num tiles in vp is reasonable so now check if I can get away with a partial view refresh
	// to determine whether to partial or full view refresh, get the current view position to compare to the previous view
	if(_defines2.default.ENABLEPYRAMIDREFRESH==false){// if requesting tiles directly at their zoom
	var prevFrame={'tileL':vpView.tileL,'tileT':vpView.tileT,'tileR':vpView.tileR,'tileB':vpView.tileB,'left':vpView.left,'top':vpView.top};self.viewPosInfoUpdate(left,top);// update vpView's critical info
	var curFrame=self.getVPView();}else{var zoomSequence=self.pyramidZoomsToUse(zoom);// request at pyramid level and scale tiles
	var resIdx=_defines2.default.ONLYLOWPYRAMIDLEVEL==false?zoomSequence.length-1:0;// resolution index into zoomSequence of final zoom level
	var prevFrame=self.viewPosInfoPyramid(zoomSequence[resIdx]);// the final pyramid level info
	self.viewPosInfoUpdate(left,top);// update vpView's critical info
	var curFrame=self.viewPosInfoPyramid(zoomSequence[resIdx]);// the final pyramid level info
	}var vpWidthInTiles=curFrame.csTiles.w,vpHeightInTiles=curFrame.csTiles.h;var vpAreaInTiles=vpWidthInTiles*vpHeightInTiles;var nTilesToGet=0;var addLeftCols=prevFrame.tileL-curFrame.tileL;//
	var addTopRows=prevFrame.tileT-curFrame.tileT;//
	var addRightCols=curFrame.tileR-prevFrame.tileR;//
	var addBottomRows=curFrame.tileB-prevFrame.tileB;//
	if(addLeftCols>0)nTilesToGet+=addLeftCols*vpHeightInTiles;else if(addRightCols>0)nTilesToGet+=addRightCols*vpHeightInTiles;if(addTopRows>0)nTilesToGet+=addTopRows*vpWidthInTiles;else if(addBottomRows>0)nTilesToGet+=addBottomRows*vpWidthInTiles;// note that this can exceed 100% when the move is far away from the previous position - it doesn't matter
	var pctTilesToGet=nTilesToGet>0?parseInt(nTilesToGet/vpAreaInTiles*100):0;if(_defines2.default.DBGNAV){//debug-only
	var dbgStr='  moveAbsolute: ';if(addLeftCols>0)dbgStr+='... addLeftCols: '+addLeftCols+'  of height: '+vpHeightInTiles+' ';if(addTopRows>0)dbgStr+='... addTopRows: '+addTopRows+'  of width: '+vpWidthInTiles+' ';if(addRightCols>0)dbgStr+='... addRightCols: '+addRightCols+'  of height: '+vpHeightInTiles+' ';if(addBottomRows>0)dbgStr+='... addBottomRows: '+addBottomRows+'  of width: '+vpWidthInTiles+' ';}// if many viewport tiles need to be replaced, do a full view refresh (those that can be reused are)
	doFullRefresh=pctTilesToGet>90?true:false;//if (pctTilesToGet > 90) self.log("- - - - - doFullRefresh: pctTilesToGet: " + pctTilesToGet );
	}if(doFullRefresh){self.viewPosInfoUpdate(left,top);// update vpView fully
	self.viewRefreshPrep(true);// true: purge request queue
	tileRequestCount=self.viewRefresh('move');// otherwise need to rebuild the view
	//debug-only self.log("viewRefresh: tileRequestCount: " + tileRequestCount);
	}// if the viewport tiles still fill the view then just have to shift the view's tiles.
	// note: that autopan views can get a tile misplacement when panning slowly and using vp's viewMove
	// so until that is understood, always call for full refresh (viewRefresh)
	else{dx=parseInt((prevFrame.left-curFrame.left)/zoom);// minor move distances
	dy=parseInt((prevFrame.top-curFrame.top)/zoom);self.viewMove(dx,dy);if(nTilesToGet>0){// if some viewport tiles need to be replaced, do a partial view refresh
	self.partialRefreshCnt++;// count the number of consecutive calls to viewRefreshPartial
	self.viewRefreshPrep(false);// suspend prefetch, do not purge request queue
	//note:  this is where I'd like to update only the VISIBLE tiles -- modify cur frame AND above nTilesToGet!!!
	//        - not a problem if OverFlowTiles remains 0
	// refresh the unfilled area of the view at the curFrame zoom only (no need to do multi level of pyramid)
	tileRequestCount=self.viewRefreshPartial(curFrame,addLeftCols,addTopRows,addRightCols,addBottomRows);//self.log("viewRefreshPartial: tileRequestCount: " + tileRequestCount);
	}}self.stateVector.viewUpdate(self.getVPView(),'move');// add to view state vector
	self.annots.translate(vpView.left,vpView.top,vpView.zoom);// update the annotation position
	if(self.hasBeenNavigated==false)(0,_events.triggerImageNavigated)(this);// inform parent this image has been navigated
	return tileRequestCount;};//............................................ moveAbsoluteCenter
	// moveAbsoluteCenter - This function moves the image to the specified center coords.
	//
	VPAP_MOVE.moveAbsoluteCenter=function(centerX,centerY){self.moveAbsolute(parseInt(centerX-self.getViewWidth()/2),parseInt(centerY-self.getViewHeight()/2));};//............................................ vpConstrainView
	// vpConstrainView - This function constrains the image position to remain inside the viewport.
	//
	//    Note that for speed's sake items accessed more than once are assiged to vars.
	VPAP_MOVE.moveConstrain=function(opt_bForce){if(self.dragConstrainCnt++%10!=0&&opt_bForce!=true)// perf improvement: when dragging the view just check occasionally
	return;var vpView=self.getVPView();var bHalfViewOK=true;// allowing view to stay centered while zooming
	if(bHalfViewOK==true){var vpWidth2=vpView.width/2;var vpHeight2=vpView.height/2;if(vpView.left<-vpWidth2){// moved past left edge?
	vpView.left=-vpWidth2;//if (us.DBGNAV) self.log("......moveConstrain: vpView.left");
	}else{var imgWidth=self.getImageWidth();if(vpView.left+vpWidth2>imgWidth){// moved past right edge?
	vpView.left=Math.floor(imgWidth-vpWidth2);//if (us.DBGNAV) self.log("......moveConstrain: vpView.right");
	}}if(vpView.top<-vpHeight2){// moved past left top?
	vpView.top=-vpHeight2;//if (us.DBGNAV) self.log("......moveConstrain: vpView.top ");
	}else{var imgHeight=self.getImageHeight();if(vpView.top+vpHeight2>imgHeight){// moved past bottom?
	vpView.top=Math.floor(imgHeight-vpHeight2);//if (us.DBGNAV) self.log("......moveConstrain: vpView.top 2");
	}}}else{var vpWidth=vpView.width;//perf impr
	var vpHeight=vpView.height;if(vpView.left<0){// moved past left edge?
	vpView.left=0;//if (us.DBGNAV) self.log("......moveConstrain: vpView.left");
	}else{var imgWidth=self.getImageWidth();// moved past right edge?
	if(vpView.left+vpWidth>imgWidth){vpView.left=Math.floor(imgWidth-vpWidth);//if (us.DBGNAV) self.log("......moveConstrain: vpView.right");
	}}if(vpView.top<0){// moved past left top?
	vpView.top=0;//if (us.DBGNAV) self.log("......moveConstrain: vpView.top ");
	}else{var imgHeight=self.getImageHeight();// moved past bottom?
	if(vpView.top+vpHeight>imgHeight){vpView.top=Math.floor(imgHeight-vpHeight);//if (us.DBGNAV) self.log("......moveConstrain: vpView.top 2");
	}}}};//______________________________________________________
	// ZOOM RELATED
	//______________________________________________________
	//............................................ zoomRelative
	// zoomRelative, zoomAbsolute
	//    These functions implement image scaling on the specified image by the speicified zoom factor.
	//    The image center remains intact after scaling.  Scaling is constrained to min/max values
	//    and a input value of "Fit" causes a computation of the zoom factor that will fill the view
	//    with the image.  Finally the method informs the state vector object of the zoom change.
	//
	VPAP_ZOOM.zoomRelative=function(zoomFactor){if((0,_helpers.isUnDefined)(zoomFactor))return;var zoom=self.getViewZoom()*zoomFactor;return self.zoomAbsolute(zoom);};//............................................ zoomAbsolute
	//  zoomAbsolute - This function refreshes the view at the commanded zoom and current view center.
	//
	//    Note that even if the new zoom is the same as the original zoom the update should still happen.
	//    This is because this occurs in the iOS case and the zoom state needs to be cleaned up via viewRefresh.
	//
	//    Passed Parameters:
	//        zoom:            required, number, the zoom value
	//                        - Note that smaller zoom result in higher resolution: .5 = 200%, 2 = 50%, 4 = 25%.
	//                        - Note that incoming zoom can be "Fit" or value of zoom at Fit
	//                            or regular value of zoom (zoom is saved as a value)
	VPAP_ZOOM.zoomAbsolute=function(zoom){if(zoom==self.getViewZoom()){return;}if(zoom!='Fit')zoom=_defines2.default.helpers.roundToDecimals(zoom);var vpView=self.getVPView();self.autoPan.off();// insure autopanning is off
	self.viewRefreshPrep(true);// suspend prefetch, purge request queue, etc.  as soon as possible
	var origZoom=self.getViewZoom();if(self.navModeIsZoom()==false)// if smmothzoom, dclickzoom, etc not set,
	_defines2.default.navModeSwitch(this,_defines2.default.eNavModes.nmZoom);// then default to zooming nav mode
	var xCenter=self.getViewCenterX();// get viewport current center in base image pixel coords
	var yCenter=self.getViewCenterY();if(zoom==='Fit'||self.isFitZoom(zoom)){self.progressive.show(false);// hide progressive view b/c the fit does not always cover the view and the progressive view is at a lower z=index than the view
	zoom=self.fitZoomCompute();// fit zoom changes on resize events, so always redo it
	self.setFitZoom(zoom);self.setViewZoom('Fit');var imgDims=self.getImageDims();// in fit zoom, always center the image
	xCenter=Math.floor(imgDims.w/2);yCenter=Math.floor(imgDims.h/2);}else{zoom=self.zoomConstrain(zoom);// constrain zoom factor to fixed zoom min and max; resolve Fit zoom
	self.setViewZoom(zoom);//cp-maybe constraint should be enforced in setViewZoom?
	}self.viewDimsUpdate(false);// update vpView width and height and account for zoom
	// keep the to-be zoomed image center at the current zoom center
	vpView.left=Math.floor(xCenter-self.getViewWidth()/2.);vpView.top=Math.floor(yCenter-self.getViewHeight()/2.);self.moveConstrain(_defines2.default.WITHFORCE);// limit left,top so viewport always includes the image content
	self.viewPosInfoUpdate(vpView.left,vpView.top);//
	if(_defines2.default.DBGZOOMCTL){var fixedZooms=self.getFixedZoomArray();var z=zoom;if(self.isFitZoom())z='Fit:'+fixedZooms[0].zoom;self.log('zoomAbsolute: zoom = '+z+' View XYCenter= ('+xCenter.toFixed(0)+','+yCenter.toFixed(0)+') View WxH= ('+self.getViewWidth()+'x'+self.getViewHeight()+')');}self.viewRefresh('zoom');// repaint image............................
	//toconsider: all objects below code could listen for this event instead of this knowning what to do
	(0,_events.triggerUScopeEvent)(_defines2.default.evZOOMCHANGE,{// fire evZOOMCHANGE
	imageId:self.getImageId(),uScopeIdx:self.getImageIdx()});//todo: ios: probably need to check pinch too
	var navMode=self.navModeGet();if(navMode!=_defines2.default.eNavModes.nmSmoothZoom){// if the view refresh was a single zoom event, end the mode now
	_defines2.default.navModeHalt(this);}// update all the things that need to be updated when the zoom changes!
	self.stateVector.viewUpdate(vpView,'zoom');// add to view state vector
	if(self.annots)self.annots.scale();// update the annotations
	if(self.hasBeenNavigated==false)(0,_events.triggerImageNavigated)(this);// inform parent this image has been navigated
	};//............................................ zoomConstrain
	// zoomConstrain - This function constrains the image zoom to reasonable values and returns the zoom value.
	//
	//        Notes: Remember zoom: .5 = 200%, 2 = 50%, 4 = 25% and that for this call, "Fit" is a legal zoom.
	VPAP_ZOOM.zoomConstrain=function(zoom){var rv=zoom;if(!self.isFitZoom(zoom)){// only fit is allowed outside the zoom control fixed mag range
	var fixedZooms=self.getFixedZoomArray();// constrain zoom factor to fixed zoom min and max
	rv=(0,_helpers.limitValue)(zoom,fixedZooms[fixedZooms.length-1].zoom,fixedZooms[0].zoom);if(_defines2.default.DBGZOOMCTL)self.log('... zoomConstrain: constraining '+zoom+' to '+rv);}return zoom;};//............................................ zoomDblClick
	// zoomDblClick - This function moves the image center to the position of the event and
	//                    zooms the image to the previous zoom state.
	//
	VPAP_ZOOM.zoomDblClick=function(e,isTouchEvent){if(_defines2.default.DBGDCLICK)(0,_toolbar.consoleWrite)('\nzoomDblClick: curZoom='+self.getViewZoom()+'  prevZoom='+self.getViewPrevZoom());_defines2.default.navModeSwitch(this,_defines2.default.eNavModes.nmDClickZoom);// set nav mode to dclick zoom
	var crsrPosBase=_defines2.default.coordBaseImage(e,this);// get the position of the cursor in base image coords
	self.moveAbsoluteCenter(crsrPosBase.x,crsrPosBase.y);// move image center to the cursor position
	self.zoomAbsolute(self.getViewPrevZoom());// and execute the zoom
	};//______________________________________________________
	// PYRAMID RELATED
	//______________________________________________________
	//............................................ pyramidInit() public
	//    pyramidInit - This function creates and returns the pyramid used to select the request zooms.
	//
	//        Note that this pyramid structure is not identical to that of the image file.
	//        Specifically
	//            1) its dimensions in tiles is the tile size used by this viewport
	//            2) depending upon the state of us.ADDINTERMEDIATELEVEL
	//                it may have inserted addition levels that the viewport wants to also request at.
	//                These levels are indicated by the var 'fileLevel' set to false
	//
	// a typical pyramid for a 20x scan looks like this
	//    pyramid[0]: zoom: 1,    mag: 20,    csTiles: (111x92),    fileLevel: true
	//    pyramid[1]: zoom: 2,    mag: 10,    csTiles: (56x46),    fileLevel: false  <--- inserted level
	//    pyramid[2]: zoom: 4,    mag: 5,        csTiles: (28x23),    fileLevel: true
	//    pyramid[3]: zoom: 16,    mag: 1.25,    csTiles: (7x6),        fileLevel: true
	// toconsider : insert levels when base is 83x???
	VPAP_PYRAMID.pyramidInit=function(thisImg){var xinfo=thisImg.xinfo;var pyramid=[];var pyrLevels=xinfo.get_imageLevels();var p=0;for(var l=0;l<pyrLevels;l++,p++){// for each level in the pyramid
	var levelZoom=xinfo.get_imageZoom(l);var csTilesComputed=thisImg.getImageDimsInTiles(levelZoom);// rtns a ref - don't change it
	var mag=thisImg.convertToMag(levelZoom);pyramid[p]={zoom:levelZoom,mag:mag,csTiles:new _objects.cSize(csTilesComputed.w,csTilesComputed.h),fileLevel:true};if(_defines2.default.ADDINTERMEDIATELEVEL==true&&l<pyrLevels-1){// insert a pyramid level at an intermediate level?
	var nextLevelZoom=xinfo.get_imageZoom(l+1);var nextMag=thisImg.convertToMag(nextLevelZoom);var ratio=mag/nextMag;if(ratio>3&&nextLevelZoom<5){// add intermediate levels only for high power mags
	var mag=pyramid[l].mag/2;p++;levelZoom=thisImg.convertToZoom(mag);csTilesComputed=thisImg.getImageDimsInTiles(levelZoom);// rtns a ref- don't change it
	pyramid[p]={zoom:+levelZoom,// insure zoom is in int format
	mag:mag,csTiles:new _objects.cSize(csTilesComputed.w,csTilesComputed.h),fileLevel:false};}}}//debug-only for (l = 0; l < pyramid.length; l++) thisImg.log(" pyramid[" + l + "]: " + toStringAssoc(pyramid[l], "\t"));
	return pyramid;};//............................................ pyramidAbout() public
	//    This function returns a string indicating the pyramid settings.
	VPAP_PYRAMID.pyramidAbout=function(){var str='';if(_defines2.default.ENABLEPYRAMIDREFRESH==true){str+='Refresh Uses Image Pyramid';str+=_defines2.default.USEMULTIPYRAMIDLEVELS==false?' (single level)':' (multiple levels)';}else str+='Refresh relies on ImageServer to Zoom';return str;};//............................................ pyramidSequenceGet() public
	//    This function returns the pyramid level zoom sequence to perform tile requests at.
	//    ------ Do not call this fn directly, instead call pyramidZoomsToUse().  ------
	//    This fn is a support fn to pyramidZoomsToUse() which builds a cache of
	//    this fn's results per zoom for efficiency.
	//
	// For a given image pyramid
	//        pyramid[0]: zoom: 1, mag: 20
	//        pyramid[1]: zoom: 2, mag: 10
	//        pyramid[2]: zoom: 4, mag: 5
	//        pyramid[3]: zoom: 16, mag: 1.25
	//
	// the following zoom sequence would be performed
	//        zoomOfRequest: 1    1st zoom: 2 (mag: 10)    2nd zoom: 1 (mag: 20)
	//        zoomOfRequest: 1.5    1st zoom: 2 (mag: 10)    2nd zoom: 1 (mag: 20)
	//        zoomOfRequest: 2    1st zoom: 4 (mag: 5)    2nd zoom: 2 (mag: 10)
	//        zoomOfRequest: 3    1st zoom: 4 (mag: 5)    2nd zoom: 2 (mag: 10)
	//        zoomOfRequest: 4    1st zoom: 4 (mag: 5)
	//        zoomOfRequest: 5    1st zoom: 4 (mag: 5)
	//        zoomOfRequest: 6    1st zoom: 4 (mag: 5)
	//        zoomOfRequest: 7    1st zoom: 4 (mag: 5)
	//        zoomOfRequest: 8    1st zoom: 4 (mag: 5)
	//        zoomOfRequest: 10    1st zoom: 4 (mag: 5)
	//        zoomOfRequest: 12    1st zoom: 16 (mag: 1.25)
	//        zoomOfRequest: 14    1st zoom: 16 (mag: 1.25)
	//        zoomOfRequest: 16    1st zoom: 16 (mag: 1.25)
	//        zoomOfRequest: 17    1st zoom: 16 (mag: 1.25)
	//todo: how to handle NON-pyramid images????
	//toconsider: could improve speed by making a lut dyamically... I do that for image dim in tiles at zoom
	VPAP_PYRAMID.pyramidSequenceGet=function(zoomOfRequest,opt_doLog){var rtnZoomSequence=[];//
	var idx=-1,idx2=-1,dbgStr='';var pyramid_=self.getPyramid();var nPyrLevels=pyramid_.length;if(zoomOfRequest==self.getFitZoom()){// if zoomOfRequest is fit zoom
	rtnZoomSequence.push(self.getFitZoom());// then just get at fit zoom
	dbgStr=' 1st zoom: '+self.getFitZoom()+' (mag: Fit)';}//    if (zoomOfRequest == 1) {                            // if zoomOfRequest is scan zoom
	//        rtnZoomSequence.push(zoomOfRequest);             // then just get at scan zoom
	//        dbgStr = " 1st zoom: " + zoomOfRequest + " (mag: Scan)";
	//    }
	else if(zoomOfRequest<1){// if zoomOfRequest value > highest resolution level (zoom of 0.5 is 200%)
	idx=0;// then use highest resolution level
	rtnZoomSequence.push(pyramid_[0].zoom);}else if(zoomOfRequest>=pyramid_[nPyrLevels-1].zoom){// if zoomOfRequest value > lowest resolution level
	idx=nPyrLevels-1;// then use lowset resolution level
	rtnZoomSequence.push(pyramid_[idx].zoom);}else{// otherwise use the resolution levels bounding the zoomOfRequest
	for(var l=1;l<nPyrLevels;l++){if(zoomOfRequest>=4){// at 20x bas mag then mag < 5 ... one level to request
	if(l==nPyrLevels-1){// if at last choice of the top of the pyramid, use it
	idx=l;rtnZoomSequence.push(pyramid_[idx].zoom);break;}else{//
	if(zoomOfRequest>=pyramid_[l].zoom&&zoomOfRequest<pyramid_[l+1].zoom){var midZoom=pyramid_[l].zoom+(pyramid_[l+1].zoom-pyramid_[l].zoom)/2;idx=zoomOfRequest<=midZoom?idx=l:idx=l+1;rtnZoomSequence.push(pyramid_[idx].zoom);break;}}}else{// two levels to request when zoom < 4 (mag > 5 when 20x base mag)
	if(pyramid_[l].zoom>zoomOfRequest){idx=l;rtnZoomSequence.push(pyramid_[idx].zoom);idx2=l-1;rtnZoomSequence.push(pyramid_[idx2].zoom);break;}}}}if(idx!=-1)dbgStr='pyramidSequenceGet: magOfRequest: '+self.convertToMag(zoomOfRequest).toFixed(2)+'\t zoomOfRequest: '+zoomOfRequest+'\t1st zoom: '+pyramid_[idx].zoom+' (mag: '+self.convertToMag(pyramid_[idx].zoom)+')   ';if(idx2!=-1)dbgStr+=' 2nd zoom: '+pyramid_[idx2].zoom+' (mag: '+self.convertToMag(pyramid_[idx2].zoom)+')   ';if(opt_doLog==true)self.log(dbgStr);return rtnZoomSequence;};//............................................ pyramidDumpDBG() public
	VPAP_PYRAMID.pyramidDumpDBG=function(thisImg){var pyramid_=thisImg.getPyramid();var nPyrLevels=pyramid_.length;var mag=thisImg.getBaseMag();mag=2.0;while(mag>=1.0){var z=thisImg.convertToZoom(mag);self.pyramidSequenceGet(z,true);if(mag<5)mag-=0.5;else mag-=1;}};}//________________________________________________________________________________________________
	//    DRAG MOMENTUM OBJECT
	//________________________________________________________________________________________________
	//............................................ cDragMomemtum
	function cDragMomemtum(vpObj){var self=this;var thisImg=vpObj;// the viewport object - the parent
	var timerInterval=20;// timer interval in milliseconds
	var damper=0.8;// linear reduction on relative move
	var count=0;// drag momentum cycle number
	var maxIterations=15;// maximum number of momentum cycles
	var sweepX=0,sweepY=0;// drag momentum distances
	self.go=function(){if(thisImg.navModeGet()!=_defines2.default.eNavModes.nmNone)// don't keep going if another nav mode has started
	return;if(count==0){// if just starting momentum drag,
	var ptDelta=thisImg.getMouseCurDiff();// initialize the distance to move with the diffs between the last 2 cursor positions
	// insure that at least one iteration of drag momentum occurs (presumably will insure tile positions)
	sweepX=ptDelta.x>0?Math.max(ptDelta.x,1):Math.min(ptDelta.x,-1);sweepY=ptDelta.y>0?Math.max(ptDelta.y,1):Math.min(ptDelta.y,-1);}else{sweepX=parseInt(sweepX*damper);// otherwise dampen the distance to move
	sweepY=parseInt(sweepY*damper);}// if enough cycles have been performed or there isn't much of a move taking place, finsh
	// otherwise, move the image some more
	if(++count>maxIterations||Math.abs(sweepX)<2&&Math.abs(sweepY)<2){count=sweepX=sweepY=0;// reset momentum vars
	//if (us.DBGMOMENTUM) thisImg.log("...cDragMomemtum: done");
	}else{//if (us.DBGMOMENTUM) thisImg.log("cDragMomemtum: " + count + "  dx,dy: " + sweepX + "," + sweepY);
	thisImg.moveRelative(sweepX,sweepY);setTimeout(self.go,timerInterval);}};}//________________________________________________________________________________________________
	module.exports=exports['default'];

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = ViewportBase;

	var _defines = __webpack_require__(3);

	var _defines2 = _interopRequireDefault(_defines);

	var _toolbar = __webpack_require__(5);

	var _objects = __webpack_require__(7);

	var _statevector = __webpack_require__(15);

	var _statevector2 = _interopRequireDefault(_statevector);

	var _xinfo = __webpack_require__(16);

	var _xinfo2 = _interopRequireDefault(_xinfo);

	var _overlays = __webpack_require__(17);

	var _overLayout = __webpack_require__(21);

	var _overLayout2 = _interopRequireDefault(_overLayout);

	var _events = __webpack_require__(10);

	var _ajaxCalls = __webpack_require__(22);

	var _ajaxCalls2 = _interopRequireDefault(_ajaxCalls);

	var _helpers = __webpack_require__(8);

	var _uScope = __webpack_require__(11);

	var _uScope2 = _interopRequireDefault(_uScope);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	//________________________________________________________________________________________________
	// viewportBase.js
	//    This file contains the ViewportBase object that uScope image renderer's will derive from.
	//
	//    key functionality of viewportBase includes:
	//        o issuing of the XINFO request for the specified image, receives & parses response in imageOpen()
	//        o creates a set of overlay tools, toolbars
	//        o creates the following objects for use by derived classes: xinfo, urlBuilder, stateVector, rasterScan
	//
	//        o public logging facility: log(msg)
	//
	//    All derived objects must overridden the functions specified by 'OVERRIDE_ME_viewportBase'
	//
	//    history
	//    _______________________________________end_AIHv1/PR __________________________________________
	//    141118    cperz        created from cViewport
	//    141120    cperz        add support for negative pen
	//    141222    cperz        change call from ajaxXXXCall to doDATASVRREQ and doIMGSRVREQ with callbacks;
	//                        add analysis support;
	//    150318    cperz        update for doIMGSRVREQ signature change;
	//                        convert to capitalized user vars = this for js parser clarity;
	//                        urlBuilder: add setQuality() for markups; add coordBaseToView()
	//    150902    rellis        don't set focus to outer viewport when in conferencing. It messes up the DST for conference participants
	//
	//________________________________________________________________________________________________

	function ViewportBase(initState, uScope) {
	    var self = this;

	    // ..... to group fns in js parser, for ease of search (e.g. search for all 'VPBASE_VIEW')
	    var OVERRIDE_ME_viewportBase = self; // EVERYTHING identified with OVERRIDE_ME_viewportBase must be overridden by derived object

	    var VPBASE_GET = self;
	    var VPBASE_IMAGE = self;
	    var VPBASE_NAV = self;
	    var VPBASE_MOUSE = self;
	    var VPBASE_OVERLAY = self;
	    var VPBASE_PINNED = self;
	    var VPBASE_RASTERSCAN = self;
	    var VPBASE_SAMPLE = self;
	    var VPBASE_STATEVECTOR = self;
	    var VPBASE_STATUS = self;
	    var VPBASE_URLBUILDER = self;
	    var VPBASE_VIEW = self;
	    var VPBASE_INFO = self;
	    var VPBASE_ZOOM = self;

	    self.events = uScope.events.$new();

	    // status related ......................................
	    var status = true; // false if a show stopping error was detected
	    VPBASE_STATUS.getStatus = function () {
	        return status;
	    };
	    VPBASE_STATUS.setStatus = function (bstate) {
	        status = bstate === true;
	        return status;
	    };
	    VPBASE_STATUS.isConnectedViaApache = function () {
	        return self.initState.indexOf('imageserver') != -1;
	    };

	    var vpInitialized_ = false; // init() completed successfully
	    VPBASE_STATUS.setInitialized = function () {
	        vpInitialized_ = true;
	    };
	    VPBASE_STATUS.isInitialized = function () {
	        return vpInitialized_;
	    };
	    self.hasBeenNavigated = false; // for callback to parent

	    // initialization state info ...........................
	    self.initState = new _helpers.cloneObject(initState); // passed in initial state, save for closure     //todo: consider if initState must be pulic

	    var imageId = initState.imageId; // quick acccess to "@idnumber"
	    var uScopeIdx = initState.uScopeIdx; // quick acccess
	    var namespace_ = '.' + imageId;
	    VPBASE_IMAGE.getImageId = function () {
	        return imageId;
	    }; // includes '@' sign
	    VPBASE_IMAGE.getImageIdx = function () {
	        return uScopeIdx;
	    };
	    VPBASE_GET.eventNameSpaceGet = function () {
	        return namespace_;
	    };

	    // initialization ajax requestor ..........................
	    self.ajax = new _ajaxCalls2.default(self, imageId, self.log); // ajax object

	    //............................................ log() public
	    //    log - This function prepends the message to be logged with its imageId.
	    var logImageIdStr = '   ' + self.getImageId();
	    var logger = _defines2.default.helpers.createLogger(true, logImageIdStr);
	    self.log = logger.log;
	    self.err = logger.error;

	    self.open = function () {
	        if (_defines2.default.kTILEMULTIPLIER < 1) _defines2.default.kTILEMULTIPLIER = 1; // insure min tile multiplier
	        if (jVpDivOuter.length < 1 || jVpDiv.length < 1) {
	            // insure divs exist
	            self.err('cViewport: viewport div does not exist for imageId: ' + imageId);
	            self.setStatus(false);
	            return;
	        }
	        // create objects
	        self.xinfo = new _xinfo2.default(self.log, imageId); // this viewport's xinfo object
	        self.stateVector = new _statevector2.default(self);

	        // initialize the url builder
	        var urlRoot = self.initState.fullURL ? self.initState.fullURL : self.initState.server + imageId;
	        self.urlBuilder = new UrlBuilder(urlRoot, imageId);
	        self.urlBuilderMarkup = new UrlBuilder(urlRoot, imageId, _defines2.default.markupQuality); // markup image urlBuilder : imageId will be changed

	        // send the xinfo request
	        self.ajax.doIMGSRVREQ(cbSuccessFn, cbFailureFn, 'XINFO', { 'request': 'XINFO', 'imageId': imageId }, 'xml');

	        //..................................................
	        // closure functions
	        //............................................ cbSuccessFn()
	        function cbSuccessFn(data, textStatus, jqXHR) {
	            self.xinfo.init(data, imageId); // initialize the xinfo class
	            self.imageOpen(imageId); // and initialze the viewport
	        }

	        //............................................ cbFailureFn()
	        function cbFailureFn(jqXHR, textStatus, errorThrown) {
	            self.log('XINFO: ' + self.ajax.getErrorStr(jqXHR, textStatus, errorThrown, imageId));
	            self.setStatus(false);
	            self.xinfo.setStatus(false); // indicate that xinfo failed

	            var imageSet = { 'images': [{ 'imagePath': imageId }] };
	            uScope.imageUpdate('remove', imageSet.images); // remove the vp object and related divs

	            (0, _events.triggerUScopeEvent)(_defines2.default.evAJAXERROR, { imageId: imageId, request: 'XINFO', jqXHR: jqXHR });
	            (0, _events.triggerUScopeEvent)(_defines2.default.evIMAGEREADY, { imageId: imageId, status: false });
	        }

	        //..................................................
	    };
	    //............................................ bindEvents_() local
	    // bindEvents_ - This function adds the viewport base event handlers.
	    var bindEvents_ = function bindEvents_() {
	        var namespace = self.eventNameSpaceGet();
	        jVpDiv.on('click' + namespace, function (e) {
	            // a vp click event is image selection
	            if (_defines2.default.ENABLECONTEXTMENU == true) {
	                $('.' + _defines2.default.clsREGIONRAR).remove(); // remove the region specific toolbar (context menu)
	            }

	            if (uScope.getSelImageIdx() != uScopeIdx) {
	                self.setImageSelected(); // inform uScope that this image is in focus
	                self.focus(); // force focus here for hot keys
	                e.preventDefault(); // necessary for IE panning to halt properly when pan cursor moves off viewport
	            }
	            return true;
	        });
	        jVpDiv.on('mousedown' + namespace, function (e) {
	            //self.log('vpBase: ' + e.type);
	            var navMode = self.navModeGet();
	            if (navMode == _defines2.default.eNavModes.nmAutoPan) // mouse down when autopanning means stop
	                _defines2.default.navModeHalt(self);else if (navMode == _defines2.default.eNavModes.nmRasterScan) {
	                // mouse down when rastering means stop
	                uScope.rasterPanel.pause(); // pause raster scan
	                _defines2.default.navModeHalt(self);
	            }
	        });

	        $(_defines2.default.idHashROOT).on(_defines2.default.evIMAGESELECTED + namespace, function (e, parms) {
	            // image select event
	            //debug-only self.log("viewport us.evIMAGESELECTED event: uScopeIdx: " + uScopeIdx + "   " + ((parms.uScopeIdx == uScopeIdx) ? "selected" : "un-selected") + ", sampleType: " + self.sampleTypeGet());

	            // set the selected/unselected (green/gray) border color of the outer viewport
	            jVpDivOuter.css({ 'border-color': parms.uScopeIdx == uScopeIdx ? '#008000' : '#A6B7C7' });

	            // the main toolbar moves onto the selected image below the image toolbar
	            if (parms.uScopeIdx == uScopeIdx) {
	                // if this is the selected image
	                self.focus(); // force focus here for hot keys
	                uScope.topToolbar.position(self.toolbar.getOffsetRect()); // position the main toolbar
	                self.zoomButton.lightButton(); // insure that the zoom button light reflects the initial state
	            }
	        });

	        $(_defines2.default.idHashROOT).on(_defines2.default.evNAVMODEHALT + namespace, function (e, parms) {
	            //
	            // if this image is specified or ALL images are specified (parms.uScopeIdx == -1) then halt
	            if (parms.imageId == '@0' || parms.uScopeIdx == -1 || parms.imageId == imageId || parms.uScopeIdx == uScopeIdx) {
	                //debug-only
	                self.log('Event: ' + e.type);
	                _defines2.default.navModeHalt(self);
	            }
	        });

	        // In IE, jQuery will fire keydown(), not keypress() for the arrow keys, because they are considered 'special' keys.
	        // Note that focus must be on the viewport.  Sometimes Tab must be hit if you think these keys aren't working.
	        jVpDivOuter.on('keydown' + namespace_ + ' keyup' + namespace_, function (e) {
	            //debug-only self.log("- viewportBase Event: " + e.type + " ");
	            _defines2.default.events.vpKeyEvent(e, self);
	        });

	        //jVpDiv.on(" mouseleave" + namespace, function (e) {
	        //todo: enable this but insure that if isDrawing mode then let drawing handle it?
	        //            us.navModeHalt(thisImg);
	        //            return true;
	        //        });
	    };

	    // overlay objects and assoc data ............................................................
	    //    - most of these objects are created in viewOverlayInit_
	    VPBASE_OVERLAY.edgeNav = undefined; // the edge nav object
	    VPBASE_OVERLAY.toolbar = undefined; // the viewport's primary toolbar

	    //______________________________________________________
	    // operational objects and assoc data
	    //    - these objects are created in construct_
	    //______________________________________________________

	    // xinfo object ........................................
	    VPBASE_INFO.xinfo = undefined; // this viewport's xinfo
	    VPBASE_INFO.getXinfoObj = function () {
	        return self.xinfo;
	    };

	    // rasterScan object ...................................
	    self.rasterScan = undefined; // the rasterScan navigation object
	    VPBASE_RASTERSCAN.getRasterScan = function () {
	        return self.rasterScan;
	    };

	    // vpView state vector manager object ..................
	    // RULE: add vpView to state vector manager whenever anything in vpView is changed
	    VPBASE_STATEVECTOR.stateVector = undefined; // the state vector object
	    VPBASE_STATEVECTOR.getStateVector = function () {
	        return self.stateVector;
	    };

	    // url build object ....................................
	    VPBASE_URLBUILDER.urlBuilder = undefined; // the url build object
	    VPBASE_URLBUILDER.getUrlBuilder = function () {
	        return self.urlBuilder;
	    };

	    //______________________________________________________
	    // MOUSE RELATED
	    //______________________________________________________
	    // handy cursor set function ..............................
	    VPBASE_MOUSE.setCursor = function (type) {
	        jVpDiv.css('cursor', type);
	    };

	    //______________________________________________________
	    // NAVIGATION RELATED
	    //______________________________________________________

	    OVERRIDE_ME_viewportBase.moveAbsolute = function (left, top) {};
	    OVERRIDE_ME_viewportBase.moveAbsoluteCenter = function (centerX, centerY) {};
	    OVERRIDE_ME_viewportBase.zoomAbsolute = function (zoom) {};
	    OVERRIDE_ME_viewportBase.viewRotate = function (newAngleDeg) {};

	    //______________________________________________________
	    // VIEWPORT DIV RELATED
	    //______________________________________________________

	    // viewport div accessors ..............................
	    VPBASE_VIEW.clsIMAGEID = _defines2.default.classFromImageId(imageId); // save class name, e.g. "IMG_42"
	    VPBASE_VIEW.clsDotIMAGEID = '.' + self.clsIMAGEID; // save . class name, e.g. ".IMG_42"

	    var jVpDivOuter = $(_defines2.default.clsDotOUTERVIEWPORT + '.' + self.clsIMAGEID); // outer div
	    var jVpDiv = $(_defines2.default.clsDotVIEWPORT + '.' + self.clsIMAGEID); // inner div

	    self.$container = jVpDivOuter;

	    VPBASE_VIEW.vpDivGet = function (outer) {
	        // handy access to this image's viewport div - use it!
	        return outer == 'outer' ? jVpDivOuter : jVpDiv;
	    };
	    VPBASE_VIEW.focus = function () {
	        if (uScope.isModeConference() == false) jVpDivOuter.focus();
	    }; // outer vp has tabindex, used specifically to enable hot keys

	    var vpDivDims = new _objects.cSize(0, 0); // outer div dimensions, maintained by viewResize()
	    VPBASE_VIEW.vpDivDimsGet = function () {
	        return vpDivDims;
	    };

	    //______________________________________________________
	    // VIEW RELATED
	    //______________________________________________________
	    VPBASE_VIEW.setImageSelected = function (opt_bForce) {
	        uScope.setImageSelected(uScopeIdx, opt_bForce);
	    }; //todo:rename to setViewSelected

	    // ..................................................... position, dimension related
	    OVERRIDE_ME_viewportBase.getViewLeft = function () {
	        return 0;
	    };
	    OVERRIDE_ME_viewportBase.getViewTop = function () {
	        return 0;
	    };
	    OVERRIDE_ME_viewportBase.getViewLeftTop = function () {
	        return undefined;
	    };

	    ///perf impr: do not recompute except for on resize event
	    OVERRIDE_ME_viewportBase.getViewCenter = function () {
	        return 0;
	    }; // in base coords
	    OVERRIDE_ME_viewportBase.getViewCenterX = function () {
	        return 0;
	    }; // in base coords
	    OVERRIDE_ME_viewportBase.getViewCenterY = function () {
	        return 0;
	    }; // in base coords

	    OVERRIDE_ME_viewportBase.getViewWidth = function () {
	        return 0;
	    };
	    OVERRIDE_ME_viewportBase.getViewHeight = function () {
	        return 0;
	    };

	    OVERRIDE_ME_viewportBase.getViewFocus = function () {
	        return 0;
	    };
	    OVERRIDE_ME_viewportBase.getViewAngle = function (inDegrees) {
	        return 0;
	    };
	    //............................................ viewOverlayInit_()
	    //    viewOverlayInit_ - This function performs one-time initialization for the overlay visuals.
	    //                        Note that the tile meter overlay is initialized in imageOpen prior to tile requests.
	    VPBASE_VIEW.viewOverlayInit_ = function () {
	        if (self.isInitialized() == false) {
	            self.overLayout = new _overLayout2.default(self); // arranges overlay visuals (thumbnail, zoom control, etc.)

	            self.edgeNav = new _overlays.cEdgeNav(self); // add edge nav divs

	            self.autoPan = new _overlays.cAutoPan(self); // create the autopan object, load the center target

	            self.events.trigger('viewport:initialize-layout');

	            // TODO: Does this belong here?
	            self.getImageData(); // with all the priority calls issued, now request image data
	        }
	    };
	    //.......................................................... viewResize() public
	    // viewResize - This function performs all necessary operations to perform/respond to the viewport resize
	    //
	    //    parameters:
	    //        autoThumbResize:    a boolean defining whether the thumbnail must be resized // TODO: Find out why this is necessary
	    VPBASE_VIEW.viewResize = function (resizeThumbnail) {
	        var jOuterVpParent = jVpDivOuter.parent(); // do not cache: layout change causes parent changes
	        if (_defines2.default.DBGVIEWLAYOUT) {
	            self.log('viewport: viewResize: Entry Parent Div: dims: ' + jVpDivOuter.parent().width() + 'x' + jVpDivOuter.parent().height());
	        }

	        var borderWidthX2 = 2 * parseInt(jVpDivOuter.css('border-left-width'));
	        var rectDiv = new _objects.cRect(0, 0, jOuterVpParent.width() - borderWidthX2, jOuterVpParent.height() - borderWidthX2);

	        if (vpDivDims.w == rectDiv.w && vpDivDims.h == rectDiv.h) {
	            // don't resize if not necessary
	            if (_defines2.default.DBGRESIZE) {
	                self.log('...viewResize: NOT required: to: ' + rectDiv.toString() + '  from vpDiv: ' + vpDivDims.toString());
	            }
	            return;
	        }
	        if (_defines2.default.DBGRESIZE) self.log('...viewResize: to: ' + rectDiv.toString() + '  from vpDiv: ' + vpDivDims.toString());

	        // note that the positions and dimensions of both the outer and inner vp divs must be set
	        jVpDivOuter.css({
	            'left': rectDiv.x + 'px',
	            'top': rectDiv.y + 'px',
	            'width': rectDiv.w + 'px',
	            'height': rectDiv.h + 'px'
	        });

	        // inner vp position is relative so its left,top is always 0,0
	        jVpDiv.css({ 'left': '0px', 'top': '0px', 'width': rectDiv.w + 'px', 'height': rectDiv.h + 'px' });
	        vpDivDims.set(parseInt(jVpDivOuter.width()), parseInt(jVpDivOuter.height()));

	        if (_defines2.default.DBGRESIZE) {
	            self.log('... outer vp: X,Y: ' + jVpDivOuter.offset().left + ',' + jVpDivOuter.offset().top + '  WxH: ' + jVpDivOuter.width() + 'x' + jVpDivOuter.height());
	            self.log('... inner vp: X,Y: ' + parseInt(jVpDiv.offset().left) + ',' + parseInt(jVpDiv.offset().top) + '  WxH: ' + jVpDiv.width() + 'x' + jVpDiv.height());
	        }

	        if (vpDivDims.w < 1 || vpDivDims.h < 1) {
	            // collapsing a view forces a dimension change
	            return; // so don't update the hidden view
	        }

	        if (self.isInitialized()) {

	            if (self.isFitZoom()) {
	                self.zoomAbsolute('Fit'); // peforms image refresh at Fit zoom after updating Fit zoom
	            }
	            self.edgeNav.resize(); // now size the edge nav divs

	            if (uScope.getSelImageIdx() == uScopeIdx) {
	                // if this is the selected image
	                uScope.topToolbar.position(self.toolbar.getOffsetRect()); // position the main toolbar
	            }

	            self.events.trigger('viewport:resize', resizeThumbnail);
	            (0, _events.triggerUScopeEvent)(_defines2.default.evVIEWRESIZE, {}); // TODO: replace with local event channel above
	        }
	    };

	    //______________________________________________________
	    // IMAGE STATE RELATED
	    //______________________________________________________

	    //    - use these accessors or add new ones here, if they require data from xinfo then initialize them in init()
	    var fileName; // name of image file; see getImageData
	    VPBASE_IMAGE.getFullURL = function () {
	        return self.initState.fullURL;
	    };
	    VPBASE_IMAGE.getServer = function () {
	        return self.initState.server;
	    };
	    VPBASE_IMAGE.getToken = function () {
	        return self.initState.token;
	    };

	    VPBASE_IMAGE.getTitle = function () {
	        // VIL defined title with replacement keywords (filename, imageid); can be undefined
	        var initTitle = self.initState.title;
	        if (initTitle == 'filename') return self.getFileName();else if (initTitle == 'imageid') return self.getImageId();else return initTitle;
	    };

	    // tissue sample type, e.g. "patient", "positive"(control), "negative" (control); can be undefined
	    VPBASE_SAMPLE.sampleTypeSet = function (type) {
	        self.initState.sampleType = type;
	        // note: a race condition can occur if the image is still initializing when its state is changed
	        //        so the exisitence of the toolbar and overlay layout objects are verified
	        if (self.toolbar) self.toolbar.sampleTypeSet(type);
	        if (self.overLayout) self.overLayout.refresh();
	    };

	    VPBASE_SAMPLE.sampleTypeGet = function () {
	        return self.initState.sampleType;
	    };
	    VPBASE_SAMPLE.sampleTypeIsControl = function () {
	        return self.sampleTypeGet() != 'patient';
	    };
	    VPBASE_SAMPLE.sampleTypeIsPatient = function () {
	        return self.sampleTypeGet() == 'patient';
	    };

	    VPBASE_PINNED.isPinned = function () {
	        return self.initState.isPinned;
	    };
	    VPBASE_PINNED.isPinnedSet = function (bval) {
	        self.initState.isPinned = bval;
	        self.toolbar.isPinnedSet(bval);
	    };
	    //______________________________________________________
	    // IMAGE RELATED
	    //______________________________________________________
	    //............................................ imageOpen()
	    // derived should call this first, upon return call:
	    //             self.viewOverlayInit_(); //todo:remove the _ (OR MOVE THIS TO HERE!!!!) all overlays controlled by derived class?????                                // load the overlay visuals
	    //vpInitialized_ = true;                                     // indicate that initialization is successful
	    //self.setImageSelected(true);                                 // inform uScope that this image is in focus
	    // and fire evIMAGEREADY
	    //todo: would it be better to call a second base function?

	    VPBASE_IMAGE.imageOpen = function (inImageId) {
	        if (inImageId !== self.getImageId()) {
	            self.err('viewportBase: imageOpen: passed imageId ' + inImageId + ' is not associated with this viewport whose imageId is ' + self.getImageId());
	            return self.setStatus(false);
	        }
	        // note: better to do this on uScopeStart but because ImageServer requires an imageId for dodbcall this call happens here.
	        uScope.prefsGetAll(self);

	        self.viewResize(true); // place and size this viewport's div (size into parent div)

	        scanner = self.xinfo.scanner;
	        baseMag = self.xinfo.get_baseMag();
	        baseMPP = self.xinfo.get_MPP(); // define vars for quick access (cc - using get_MPP() doesn't actually get the base value; it gets one that's
	        // normalized for zoom. This seems risky; why not just use xinfo.MPP?)
	        captureType = +self.xinfo.capturetype;
	        hasALabel = self.xinfo.label.isValid;
	        hasAThumbnail = self.xinfo.thumb.isValid;
	        csThumbDims = new _objects.cSize(self.xinfo.thumb.width, self.xinfo.thumb.height);
	        thumbZoom = self.xinfo.thumb.zoom;

	        if (self.xinfo.tileWidth > 600 || self.xinfo.tileHeight > 600) _defines2.default.kTILEMULTIPLIER = 1; // (cc - Changing a constant... why?
	        // Won't this have potential downstream impacts? (say after a new image is opened))
	        tileWidth = self.xinfo.tileWidth * _defines2.default.kTILEMULTIPLIER;
	        tileHeight = self.xinfo.tileHeight * _defines2.default.kTILEMULTIPLIER;
	        //debug - only self.log("kTILEMULTIPLIER: " + us.kTILEMULTIPLIER + "  request tile dims: " + tileWidth + "x" + tileHeight);

	        imageWidth = self.xinfo.get_imageWidth();
	        imageHeight = self.xinfo.get_imageHeight();

	        backgroundColor = captureType == _defines2.default.eAICCaptureType.aic_i_FL ? '#000' : '#fff';
	        jVpDiv.css('background-color', backgroundColor); // set viewport background color in accordance with capture type

	        fixedZooms_ = zoomInitFixed_(self); // build array containing the zoom control options (zoom, mag, level)

	        if (_defines2.default.DBGSTART) self.log('viewport imageOpen: imageId:' + self.getImageId() + ' dims: ' + self.xinfo.get_imageWidth() + ' x ' + self.xinfo.get_imageHeight());

	        bindEvents_(); // add event handlers
	        return self.setStatus(true); // set status successful image open, return status
	    };
	    //............................................ imageClose()
	    VPBASE_IMAGE.imageClose = function () {

	        bindEventsOff_(); // remove event handlers for viewport

	        //todo: get this out of base
	        uScope.rasterPanel.pause(); // pause raster scan

	        uScope.setImageNextSelected(uScopeIdx); // inform uScope to select the next image (deselect me)

	        //................................closure fns
	        //    bindEventsOff_ - This function removes event handlers for viewport by namespace:  "." + imageId
	        function bindEventsOff_() {
	            // self.log('ViewportBase: bindEventsOff_');
	            //$(us.idHashROOT).off("." + imageId);
	            var namespace = self.eventNameSpaceGet();
	            $(_defines2.default.idHashROOT).off(namespace);
	        }
	    };

	    //................................................................. getImageData
	    //  This function issues an ajax call to get the image data.
	    VPBASE_IMAGE.getImageData = function () {
	        var imageId = self.getImageId();
	        if (uScope.isThisImageIdValid(imageId) == true) {
	            ///// note this check should not be nec.... doing it to see if strange alert that pops up is caused by it ever
	            var xml = '<ImageId>' + (0, _helpers.stripLeadingAtSign)(imageId) + '</ImageId>';
	            var parms = { 'imageId': imageId };
	            self.ajax.doDATASVRREQ(cbSuccessFn, undefined, 'GetImageData', xml, parms);
	        } else {
	            self.err('viewportBase: getImageData: not a valid imageId: ' + imageId);
	        }

	        //................................closure fns
	        //............................................ cbSuccessFn()
	        //  This function parses the response for the compressed file location.
	        function cbSuccessFn(data, textStatus, jqXHR) {
	            var idx;
	            var responseText = jqXHR.responseText;
	            if ((idx = responseText.lastIndexOf('>')) !== -1) responseText = responseText.slice(0, idx + 1); // remove the garbage char on the end of the response
	            if (_defines2.default.DBGOPTIONS) self.log('cb_getImageData: \n' + responseText);

	            var xmlDoc = $.parseXML(responseText);
	            var $xml = $(xmlDoc);
	            var jResponse = $xml.find('GetImageDataResult');
	            var jResult = jResponse.find('ASResult');

	            if (jResult.text() != '0') {
	                var jMessage = jResult.find('ASMessage'); //s/b [ asmessage ]
	                self.err('viewportBase: getImageDataRtn:   msg:' + jMessage.text() + '  code: ' + jResult.text());
	                return;
	            }
	            var jImageData = $xml.find('ImageData');
	            var jImage = jImageData.find('Image');
	            var msgImageId = jImage.find('ImageId').text();
	            if (msgImageId == (0, _helpers.stripLeadingAtSign)(self.getImageId())) {
	                // insure the ajax return is for this image
	                fileName = jImage.find('CompressedFileLocation').text(); // e.g. \\aperio-00824\images\21287_Her2.svs
	                //debug-only self.log("cb_getImageData: " + fileName);
	            }
	        }

	        //................................
	    };

	    VPBASE_IMAGE.getFileName = function () {
	        return (0, _helpers.isDefined)(fileName) ? fileName : self.xinfo.filename;
	    };
	    VPBASE_IMAGE.getFileTypeDesc = function () {
	        return self.xinfo.comptypedesc;
	    };
	    VPBASE_IMAGE.getCompQuality = function () {
	        return self.xinfo.compquality;
	    };
	    VPBASE_IMAGE.getImageICCProfile = function () {
	        return self.xinfo.iccProfile;
	    };
	    VPBASE_IMAGE.getScanScopeId = function () {
	        return self.xinfo.scanScopeId;
	    };
	    VPBASE_IMAGE.getImageDate = function () {
	        return self.xinfo.date;
	    };
	    VPBASE_IMAGE.getImageDescription = function () {
	        return self.xinfo.description;
	    };

	    var scanner, baseMag, baseMPP, captureType, hasALabel, hasAThumbnail, csThumbDims, thumbZoom, imageWidth, imageHeight, tileWidth, tileHeight;
	    VPBASE_IMAGE.getScanner = function () {
	        return scanner;
	    };
	    VPBASE_IMAGE.getMaximumMag = function () {
	        return baseMag;
	    };
	    VPBASE_IMAGE.getBaseMag = function () {
	        return baseMag * self.getNormalizationFactor();
	    };
	    VPBASE_IMAGE.getNormalizationFactor = function () {
	        if (!magNeedsNormalization()) {
	            return 1;
	        }
	        var sf = getScaleFactor();
	        return MAG_CONSTS.BASELINE_SCALE_FACTOR / sf;
	    };
	    VPBASE_IMAGE.getBaseMPP = function () {
	        return baseMPP;
	    };
	    VPBASE_IMAGE.getCaptureType = function () {
	        return captureType;
	    };
	    VPBASE_IMAGE.hasALabel = function () {
	        return hasALabel;
	    };
	    VPBASE_IMAGE.hasAThumbnail = function () {
	        return hasAThumbnail;
	    };
	    VPBASE_IMAGE.getThumbFileDims = function () {
	        return csThumbDims;
	    }; // not live thumbnail dims but the defn from xinfo
	    VPBASE_IMAGE.getThumbZoom = function () {
	        return thumbZoom;
	    }; // not live thumbnail zoom but the defn from xinfo
	    VPBASE_IMAGE.getTileWidth = function () {
	        return tileWidth;
	    }; // requested tile width
	    VPBASE_IMAGE.getTileHeight = function () {
	        return tileHeight;
	    }; // requested tile

	    var backgroundColor = '#000000';
	    VPBASE_GET.getBackgroundColor = function () {
	        return backgroundColor;
	    };

	    // image dimensions related ............................
	    VPBASE_IMAGE.getImageWidth = function () {
	        return imageWidth;
	    };
	    VPBASE_IMAGE.getImageHeight = function () {
	        return imageHeight;
	    };
	    VPBASE_IMAGE.getImageDims = function () {
	        return new _objects.cSize(imageWidth, imageHeight);
	    };

	    //todo: it would be good to also allow zoom or mag in and return image dims @ that zoom or mag
	    var imageDimInTiles_ = {}; // assoc array of zoom, image dimensions in tiles at that zoom
	    VPBASE_IMAGE.getImageDimsInTiles = function (zoom) {
	        // This function returns a reference to a cSize of the image dimensions in tiles at the given zoom.
	        if (zoom == undefined) zoom = 1;

	        if (imageDimInTiles_[zoom] == undefined) {
	            // if dims at this zoom isn't already available, compute it
	            var csImageDims = self.getImageDims(); // returns a reference
	            var csDims = new _objects.cSize(csImageDims.w, csImageDims.h);
	            csDims.toTileNums(tileWidth, tileHeight, zoom);

	            imageDimInTiles_[zoom] = new _objects.cSize(csDims.w, csDims.h);
	            //self.log("getImageDimsInTiles: zoom: " + zoom + "  computed: " + imageDimInTiles.zoom.toString());
	        }
	        return imageDimInTiles_[zoom];
	    };
	    var imageDimAtZoom_ = {}; // assoc array of zoom, image dimensions at that zoom
	    VPBASE_IMAGE.getImageDimsAtZoom = function (zoom) {
	        // This function returns a reference to a cSize of the image dimensions at the given zoom.
	        if (zoom == undefined) zoom = 1;

	        if (imageDimAtZoom_[zoom] == undefined) {
	            // if dims at this zoom isn't already available, compute it
	            var csImageDims = self.getImageDims(); // returns a reference
	            var csDims = new _objects.cSize(csImageDims.w, csImageDims.h);
	            csDims.div(zoom, zoom);
	            csDims.toInt();
	            imageDimAtZoom_[zoom] = new _objects.cSize(csDims.w, csDims.h);
	            //self.log("getImageDimsAtZoom: zoom: " + zoom + "  computed: " + imageDimAtZoom_.zoom.toString());
	        }
	        return imageDimAtZoom_[zoom];
	    };
	    // ..................................................... MPP related
	    VPBASE_IMAGE.getMPP = function (opt_zoom) {
	        // return micron/pixel for a given zoom
	        return (0, _helpers.isUnDefined)(opt_zoom) ? self.getBaseMPP() : self.getBaseMPP() * opt_zoom;
	    };

	    //______________________________________________________
	    // NAVIGATION MODE RELATED
	    //______________________________________________________
	    VPBASE_NAV.navMode = _defines2.default.eNavModes.nmNone; // navigation mode
	    VPBASE_NAV.pyrModeSave = _defines2.default.ENABLEPYRAMIDREFRESH; // backup of nav mode   //todo: this really does not belong in base
	    VPBASE_NAV.navModeGet = function () {
	        return self.navMode;
	    };

	    var navModeKeys = _defines2.default.objectKeys(_defines2.default.eNavModes);
	    VPBASE_NAV.navModeGetStr = function (opt_idx) {
	        return opt_idx ? navModeKeys[opt_idx] : navModeKeys[self.navMode];
	    };

	    //______________________________________________________
	    // ZOOM RELATED
	    //______________________________________________________

	    // ..................................................... fit zoom related
	    VPBASE_ZOOM.getFitZoom = function () {
	        return fixedZooms_[0].zoom;
	    };
	    VPBASE_ZOOM.isFitZoom = function (opt_zoom) {
	        if (opt_zoom == undefined) opt_zoom = self.getViewZoom();
	        return opt_zoom === fixedZooms_[0].zoom;
	    };
	    // fitZoomCompute -This function computes the zoom of fit magnification for the passed image.
	    VPBASE_ZOOM.fitZoomCompute = function () {
	        var csImgDims = self.getImageDims();
	        var imageWHRatio = csImgDims.w / csImgDims.h; // compute the image w/h ratio

	        var vpDivDims = self.vpDivDimsGet();
	        var viewWHRatio = vpDivDims.w / vpDivDims.h; // compute the view w/h ratio
	        var zoom = imageWHRatio > viewWHRatio ? parseInt(csImgDims.w / vpDivDims.w) : parseInt(csImgDims.h / vpDivDims.h);

	        return nextHighestPowOf2(zoom);

	        function nextHighestPowOf2(v) {
	            // ref http://graphics.stanford.edu/~seander/bithacks.html
	            v--;
	            v |= v >> 1;
	            v |= v >> 2;
	            v |= v >> 4;
	            v |= v >> 8;
	            v |= v >> 16;
	            v++;
	            return v;
	        }

	        // debug-only self.log(".. fitZoomCompute: zoom: " + zoom + ' --- > ' + zoomFit);
	    };
	    // ..................................................... view zoom related
	    //todo: reconcile prev zoom with derived
	    var prevZoom_ = 4.0;
	    var curZoom_ = 1.0;
	    VPBASE_ZOOM.getViewPrevZoom = function () {
	        return prevZoom_;
	    }; // get previous zoom
	    VPBASE_ZOOM.setViewPrevZoom = function (currentZoom) {
	        prevZoom_ = curZoom_;
	        curZoom_ = currentZoom;
	    }; // pass in the current zoom

	    OVERRIDE_ME_viewportBase.getViewZoom = function () {
	        return self.view.getResolution();
	    };

	    ////CINDY --- move convertToMag  to us namespace and pass in thisImg
	    //note: always use us.helpers.roundToDecimals and convertToZoom so zoom precision is managed consistently;
	    // TODO: extract consistent means for calculating zoom so we don't need to remember to round and convert...
	    VPBASE_ZOOM.convertToZoom = function (mag) {
	        // convert magnification to zoom
	        return _defines2.default.helpers.roundToDecimals(self.getBaseMag() / mag);
	    };

	    // ..................................................... mag related
	    VPBASE_ZOOM.getFitMag = function () {
	        return self.convertToMag(fixedZooms_[0].zoom);
	    };
	    OVERRIDE_ME_viewportBase.getViewMag = function () {
	        return 0;
	    };

	    VPBASE_ZOOM.convertToMag = function (zoom) {
	        // convert zoom to magnification
	        var mag = self.getBaseMag() / zoom;

	        if (mag >= 2) mag = roundToHalf(mag); // if mag > 2 then round it to integer or 1/2 way between
	        else mag = (0, _helpers.roundto)(mag, 10.); // otherwise round to tenths
	        return mag;
	    };

	    // ..................................................... fixed zooms related
	    var fixedZooms_; // array of fixed zooms on zoom control
	    VPBASE_ZOOM.getFixedZoomArray = function () {
	        return fixedZooms_;
	    };
	    VPBASE_ZOOM.getFixedZoomIdx = function (zoom) {
	        // if this zoom value is one of the fixed zooms, return its index; otherwise return -1;
	        for (var z = 0, len = fixedZooms_.length; z < len; z++) {
	            if (zoom == fixedZooms_[z].zoom) return z;
	        }
	        return -1;
	    };

	    //............................................ zoomInitFixed
	    //    zoomInitFixed - This function computes the zoom control magnification levels.
	    //        It sets the mag levels in one of two manners:
	    //            1) forced magnifications: The mags are forced to that of the scan resolution and
	    //                    a predefined setof magnfications followed by a "Fit" mag.
	    //            2) not forced magnifications: The mags are set to each pyramid level as well as
	    //                    fabricated pyramid levels to fill in magnifier gaps > 1.5, followed by a "Fit" mag.
	    //
	    //    The returned fixedZooms array contains:
	    //        zoom:    the image pyramid level zoom value (e.g. 1, 4, 16, FitValue)
	    //        mag:    the image pyramid level magnification value (e.g. 20, 5, 1.25, Fit) - note that the "Fit" mag really is the literal string "Fit"
	    //        level:    the image pyramid level of this zoom (>= 0 means is a pyramid level; < 0 means is a fabricated level)
	    //
	    var zoomInitFixed_ = function zoomInitFixed_(thisImg) {
	        var xinfo = thisImg.xinfo;
	        var fixedZooms = []; // array of zoom, mag, level for each mag in the zoom control

	        var baseMag = VPBASE_IMAGE.getMaximumMag(); // get the magnification factor at the base pyramid level

	        var useForcedMagnifications = true; // manner to compute
	        var l, len, zoom, item, mag;
	        if (useForcedMagnifications) {
	            item = { zoom: 'Fit', level: -1, mag: 'Fit' }; // add the fit level to the fixedZooms array
	            item.zoom = thisImg.fitZoomCompute(thisImg); // replace the fit zoom value
	            fixedZooms.push(item);

	            for (l = 0, len = FORCED_MAGNICATION_LEVELS.length; l < len; l++) {
	                // step thru the forcedMags array
	                mag = FORCED_MAGNICATION_LEVELS[l];
	                if (mag < baseMag) {
	                    // find the index in forcedMags just below scan mag
	                    zoom = thisImg.convertToZoom(mag);
	                    item = { zoom: zoom, level: -1, mag: mag };
	                    fixedZooms.push(item);
	                }
	            }

	            // add the lowest available scan level to the fixedZooms array (NOTE that this may not be the base scan level if the image is being normalized)
	            item = {
	                zoom: thisImg.convertToZoom(baseMag),
	                level: 0,
	                mag: baseMag
	            };
	            fixedZooms.push(item);
	        } else {
	            var fakeZooms = []; // temp holding for fabricated level info
	            var newLevel;

	            var minMagNotIncl = 5.0;
	            var levels = xinfo.get_imageLevels(); // get number of image pyramid levels
	            var zoomRatio;
	            for (l = 0; l < levels; l++) {
	                // for each level in the pyramid
	                //todo: IMPORTANT viewport should have the call to get image zoom at a level so this fn does not access xinfo
	                zoom = _defines2.default.helpers.roundToDecimals(xinfo.get_imageZoom(l)); // add this pyramid level to the fixedZooms array
	                if (baseMag / zoom <= minMagNotIncl) break;
	                fixedZooms[l] = { zoom: zoom, level: l, mag: thisImg.convertToMag(zoom) };

	                // if there's more than a 1.5 : 1 gap to the next level, fabricate a pyramid level
	                if (l < levels - 1 && (zoomRatio = xinfo.get_imageZoom(l + 1) / zoom / 2) > 1.5) {
	                    zoomRatio = (0, _helpers.roundto)(zoomRatio, 10.); // round to tenths
	                    var newZoom = _defines2.default.helpers.roundToDecimals(zoom * zoomRatio);
	                    newLevel = { zoom: newZoom, level: -1, mag: thisImg.convertToMag(newZoom) };
	                    if (newLevel.mag >= minMagNotIncl) fakeZooms.push(newLevel); // add this new level to the fakeZooms array
	                }
	            }
	            if (levels == 1) {
	                // create fakeZooms for the case where there is only one level
	                mag = fixedZooms[0].mag;
	                while (mag / 2 > minMagNotIncl) {
	                    mag = mag / 2;
	                    zoom = thisImg.convertToZoom(mag);
	                    newLevel = { zoom: zoom, level: -1, mag: mag };
	                    fakeZooms.push(newLevel); // add this new level to the fakeZooms array
	                }
	            }

	            newLevel = { zoom: thisImg.convertToZoom(4), level: -1, mag: 4 }; // add 4X to the fakeZooms array
	            fixedZooms.unshift(newLevel); // Note: .unshift() method does not return a length property in Internet Explorer.
	            newLevel = { zoom: thisImg.convertToZoom(2), level: -1, mag: 2 }; // add 2X to the fakeZooms array
	            fixedZooms.unshift(newLevel);
	            newLevel = { zoom: thisImg.convertToZoom(1), level: -1, mag: 1 }; // add the fit level to the fakeZooms array
	            fixedZooms.unshift(newLevel);

	            fixedZooms = fixedZooms.concat(fakeZooms); // concatentate the fixedZooms and fakeZooms arrays into the fixedZooms array

	            fixedZooms.sort(function (a, b) {
	                return a.mag - b.mag;
	            }); // sort the fixedZooms array in ascending magnification order

	            newLevel = { zoom: 'Fit', level: -1, mag: 'Fit' }; // add the fit level to the fakeZooms array
	            newLevel.zoom = thisImg.fitZoomCompute(thisImg); // replace the fit zoom value
	            fixedZooms.unshift(newLevel);
	        }

	        if (_defines2.default.DBGZOOMCTL) {
	            thisImg.log('zoomInitFixed: Zoom Control:');
	            for (l = 0; l < fixedZooms.length; l++) {
	                (0, _toolbar.consoleWrite)('level: ' + fixedZooms[l].level + '   zoom: ' + fixedZooms[l].zoom + '   mag: ' + fixedZooms[l].mag);
	            }
	        }
	        return fixedZooms;
	    };

	    //.......................................................................................................
	    // closure functions
	    var FORCED_MAGNICATION_LEVELS = !_defines2.default.DBGZMBTNPYRAMID ? [1, 2, 4, 10, 20, 40, 60, 83, 100] : [1, 1.25, 2, 4, 5, 8, 9, 10, 11, 12, 15, 16, 20, 40, 60, 83, 100];
	    var MAG_CONSTS = {
	        BASELINE_MPP: 0.5,
	        MIN_MPP: 0.45,
	        MAX_MPP: 0.55,
	        BASELINE_APP_MAG: 20,
	        BASELINE_SCALE_FACTOR: 10, // appMag * mpp
	        MIN_SCALE_FACTOR: 9,
	        MAX_SCALE_FACTOR: 11
	    };
	    var getScaleFactor = function getScaleFactor() {
	        return self.xinfo.MPP * self.xinfo.apparentMag;
	    };
	    var magNeedsNormalization = function magNeedsNormalization() {
	        var sf = getScaleFactor();
	        return !(sf >= MAG_CONSTS.MIN_SCALE_FACTOR && sf <= MAG_CONSTS.MAX_SCALE_FACTOR);
	    };
	}
	//________________________________________________________________________________________________

	// Below are viewport functions shared by cViewport and ViewportBase/OL.
	// Ideally they would all be in ViewportBase and cViewport would derive from base
	//    but since that hasn't happened yet, they just reside in the us. namespace.

	//-------------------------------------------------------------------------------------------------
	// viewport nav mode handlers
	//-------------------------------------------------------------------------------------------------
	//............................................ setAnnotNavModes()
	// This function fills the passed array with boolean true for each drawing nav mode slot.
	_defines2.default.setAnnotNavModes = function (navModesArray) {
	    navModesArray[_defines2.default.eNavModes.nmAnnotPin] = true;
	    navModesArray[_defines2.default.eNavModes.nmAnnotArrow] = true;
	    navModesArray[_defines2.default.eNavModes.nmAnnotRect] = true;
	    navModesArray[_defines2.default.eNavModes.nmAnnotEllipse] = true;
	    navModesArray[_defines2.default.eNavModes.nmAnnotPen] = true;
	    navModesArray[_defines2.default.eNavModes.nmAnnotNegPen] = true;
	    navModesArray[_defines2.default.eNavModes.nmAnnotCaliper] = true;
	    navModesArray[_defines2.default.eNavModes.nmAnnotText] = true;
	    navModesArray[_defines2.default.eNavModes.nmAnnotReport] = true;
	    navModesArray[_defines2.default.eNavModes.nmRedrawStarting] = true;
	    navModesArray[_defines2.default.eNavModes.nmRedraw] = true;
	    navModesArray[_defines2.default.eNavModes.nmAnnotPolygon] = true;
	};

	//............................................ navModeHalt
	//    navModeHalt - This function returns the state of navigation (autopan, drawing, ...) to none.
	_defines2.default.navModeHalt = function (thisImg) {
	    var navMode = thisImg.navModeGet();
	    if (navMode === _defines2.default.eNavModes.nmNone) return; // mouseleave events enter here to cancel drag, etc.

	    //if (us.DBGNAV) thisImg.log("enter navModeHalt: halt mode=" + navMode + " name: " + thisImg.navModeGetStr());

	    var fireModeChange = false;
	    switch (navMode) {
	        case _defines2.default.eNavModes.nmDragImage:
	        case _defines2.default.eNavModes.nmThumbDragImage:
	        case _defines2.default.eNavModes.nmDClickZoom:
	        case _defines2.default.eNavModes.nmZoom:
	            thisImg.navMode = _defines2.default.eNavModes.nmNone;
	            thisImg.setCursor('auto'); // return to auto cursor
	            fireModeChange = true;
	            break;

	        case _defines2.default.eNavModes.nmSmoothZoom:
	        case _defines2.default.eNavModes.nmPinchZoom:
	            _defines2.default.ENABLEPYRAMIDREFRESH = thisImg.pyrModeSave; // smooth zoom switched to use the pyramid, restore original setting
	            thisImg.navMode = _defines2.default.eNavModes.nmNone;
	            thisImg.setCursor('auto'); // return to auto cursor
	            fireModeChange = true;
	            break;
	        case _defines2.default.eNavModes.nmAnnotPin:
	        case _defines2.default.eNavModes.nmAnnotArrow:
	        case _defines2.default.eNavModes.nmAnnotReport:
	        case _defines2.default.eNavModes.nmAnnotText:
	        case _defines2.default.eNavModes.nmAnnotRect:
	        case _defines2.default.eNavModes.nmAnnotEllipse:
	        case _defines2.default.eNavModes.nmAnnotPen:
	        case _defines2.default.eNavModes.nmAnnotNegPen:
	        case _defines2.default.eNavModes.nmAnnotCaliper:
	        case _defines2.default.eNavModes.nmAnnotPolygon:

	        case _defines2.default.eNavModes.nmRedrawStarting:
	        case _defines2.default.eNavModes.nmRedraw:
	            thisImg.navMode = _defines2.default.eNavModes.nmNone;
	            fireModeChange = true;
	            thisImg.setCursor('auto'); // return to auto cursor
	            thisImg.getAnnotObj().drawingCompleted(); // and drawing was started that it is now ended
	            break;
	        case _defines2.default.eNavModes.nmAutoPan:
	            // autopan halt is special, handled by its own function,
	            thisImg.autoPan.off(); // called from autopanning and mouse down, move outside viewport
	            thisImg.navMode = _defines2.default.eNavModes.nmNone;
	            fireModeChange = true;
	            break;
	        case _defines2.default.eNavModes.nmRasterScan:
	            thisImg.navMode = _defines2.default.eNavModes.nmNone;
	            if (thisImg.rasterScan != undefined) thisImg.rasterScan.resetHeatMapState(); // insure heatmap state is reset when halting raster scan
	            fireModeChange = true;
	            break;
	        case _defines2.default.eNavModes.nmRotatingOverlay:
	            thisImg.navMode = _defines2.default.eNavModes.nmNone;
	            fireModeChange = true;
	            break;
	        default:
	    }

	    if (fireModeChange == true) // fire mode change event
	        (0, _events.triggerUScopeEvent)(_defines2.default.evMODECHANGE, {
	            imageId: thisImg.getImageId(),
	            uScopeIdx: thisImg.getImageIdx(),
	            navMode: thisImg.navMode,
	            navModePrev: navMode
	        });

	    //debug-only thisImg.log("   exit navModeHalt: halt mode=" + navMode + " name: " + thisImg.navModeGetStr());
	};
	//............................................ navModeSwitch
	//    navModeSwitch - This function changes the navigation mode.
	_defines2.default.navModeSwitch = function (thisImg, opt_newNavMode) {
	    var newNavMode = opt_newNavMode; //todo: combine these statements
	    if ((0, _helpers.isUnDefined)(opt_newNavMode)) newNavMode = _defines2.default.eNavModes.nmNone;

	    if (thisImg.navMode !== _defines2.default.eNavModes.nmNone) // halt current nav move, if any
	        _defines2.default.navModeHalt(thisImg);

	    //if (us.DBGNAV) thisImg.log("navModeSwitch: to mode=" + newNavMode + " name: " + thisImg.navModeGetStr(newNavMode));

	    var fireModeChange = false;
	    switch (newNavMode) {
	        case _defines2.default.eNavModes.nmSmoothZoom:
	        case _defines2.default.eNavModes.nmPinchZoom:
	            // smooth zoom MUST use the pyramid to operate fast enough
	            // so, I save the current refresh mode and switch to pyramid
	            thisImg.pyrModeSave = _defines2.default.ENABLEPYRAMIDREFRESH;
	            _defines2.default.ENABLEPYRAMIDREFRESH = true;
	            break;

	        case _defines2.default.eNavModes.nmAnnotPin: // drawing tools
	        case _defines2.default.eNavModes.nmAnnotArrow:
	        case _defines2.default.eNavModes.nmAnnotText:
	        case _defines2.default.eNavModes.nmAnnotReport:

	        case _defines2.default.eNavModes.nmAnnotRect:
	        case _defines2.default.eNavModes.nmAnnotEllipse:
	        case _defines2.default.eNavModes.nmAnnotPen:
	        case _defines2.default.eNavModes.nmAnnotNegPen:
	        case _defines2.default.eNavModes.nmAnnotCaliper:
	        case _defines2.default.eNavModes.nmAnnotPolygon:

	        case _defines2.default.eNavModes.nmRedrawStarting:
	        case _defines2.default.eNavModes.nmRedraw:

	            if (_uScope2.default.instance.canAnnotate() == false) {
	                // if annotation drawing is not enabled, return
	                if (_defines2.default.DBGANNOT) thisImg.log('navModeSwitch: drawing is disabled');
	                return;
	            }
	            fireModeChange = true;
	            thisImg.vpDivGet().css('cursor', 'pointer');
	            //cp-this does not belong in a base class!!!
	            if (_defines2.default.renderEngine == 'ol3') //todo: cp-could move into an evMODECHANGE listener in annots???
	                thisImg.getAnnotObj().drawModeStart(newNavMode); //binds mouse events for drawing
	            break;
	        case _defines2.default.eNavModes.nmAutoPan:
	            fireModeChange = true;
	            break;
	        case _defines2.default.eNavModes.nmRasterScan:
	            // rasterscan mode
	            fireModeChange = true;
	            break;
	        case _defines2.default.eNavModes.nmRotatingOverlay:
	            //not required triggerUScopeEvent(us.evMODECHANGE, ... );
	            break;
	        default:
	    }
	    if (fireModeChange == true) // fire mode change event
	        (0, _events.triggerUScopeEvent)(_defines2.default.evMODECHANGE, {
	            imageId: thisImg.getImageId(),
	            uScopeIdx: thisImg.getImageIdx(),
	            navMode: newNavMode,
	            navModePrev: thisImg.navMode
	        });

	    thisImg.navMode = newNavMode;
	};

	//-------------------------------------------------------------------------------------------------
	//    COORDINATE TRANSFORMS
	//-------------------------------------------------------------------------------------------------
	//............................................ coordBaseImage
	//    coordBaseImage - This function computes the image base coord position of the cursor position from
	//                    the passed vp div position and the event object. Viewport relative means viewport window
	//                    coordinates.
	_defines2.default.coordBaseImage = function (event, thisImg) {
	    var cpVpRelPos = _defines2.default.coordPageToView(event, thisImg); // the unrotated viewport relative cursor position
	    return _defines2.default.coordBaseImage2(cpVpRelPos, thisImg);
	};
	//............................................ coordBaseImage2
	//    coordBaseImage2 - This function computes the image base coord position of the cursor position
	//                    from the viewport relative coordinates.
	_defines2.default.coordBaseImage2 = function (relPos, thisImg) {
	    var basePos = new _objects.cPoint(relPos.x, relPos.y);
	    var zoom = thisImg.getViewZoom();
	    basePos.mult(zoom, zoom);
	    basePos.add(thisImg.getViewLeft(), thisImg.getViewTop());
	    basePos.toInt();
	    //debug-only thisImg.log("...coordBaseImage2: zoom: " + zoom + "  relPos: " + relPos.toString() + "  basePos: " + basePos.toString());
	    return basePos;
	};
	//............................................ coordBaseToView
	//    coordBaseToView - This function converts base coordinates to view coordinates
	//        Improvement: take rotation into account and does this work for multi-image views?
	_defines2.default.coordBaseToView = function (cpBase, thisImg) {
	    var cpLT = thisImg.getViewLeftTop(_defines2.default.coordSystemNORM);
	    var zoom = thisImg.getViewZoom();
	    return new _objects.cPoint(Math.floor((cpBase.x - cpLT.x) / zoom), Math.floor((cpBase.y - cpLT.y) / zoom));
	};
	//............................................ coordPageToView
	//    coordPageToView - This function converts page coordinates to viewport relative coordinates.
	//        Passed Parameters:    event object
	//        Returns a cPoint of the cursor position within the unrotated image
	_defines2.default.coordPageToView = function (e, thisImg) {
	    var cpRtn = new _objects.cPoint(0, 0); // return position object
	    var jVpDiv = thisImg.vpDivGet();
	    var offset = jVpDiv.offset(); // the current position of the target relative to the document

	    var vpX = e.pageX - offset.left; // translate viewport left top position
	    var vpY = e.pageY - offset.top;
	    cpRtn = _defines2.default.coordUnRotate(vpX, vpY, thisImg); // un-rotate the viewport coordinate

	    //debug-only thisImg.log("...coordPageToView:  jVpDiv.offset: " + offset.left + "," + offset.top + " vpXY: " + vpX + "," + vpY     + "  cpRtn: " + cpRtn.toString());
	    return cpRtn;
	};

	//............................................ coordUnRotate
	// coordUnRotate - This function converts a rotated vp cursor position to unrotated vp cursor position (not image, vp div position)

	_defines2.default.coordUnRotate = function (x, y, thisImg) {
	    //debug-only thisImg.log("coordUnRotate: angle: " + thisImg.getViewAngle(true) + " input => (" + x + "," + y + ")");
	    var cpRtn = new _objects.cPoint(x, y); // return position object
	    var imgRotAngleRad = thisImg.getViewAngle();
	    if (imgRotAngleRad != 0) {
	        var vpDivDims = thisImg.vpDivDimsGet();
	        var vpW = vpDivDims.w,
	            vpH = vpDivDims.h;

	        var vpOffset = thisImg.getRotationOffset();
	        var ptx = x + vpOffset.x,
	            pty = y + vpOffset.y;
	        var xc = vpW / 2,
	            yc = vpH / 2; // Thumbnail center position

	        var dx = ptx - xc,
	            dy = yc - pty; // Transform Point Coordinates to view center (xc,yc)
	        var hyp = Math.sqrt(dx * dx + dy * dy); //    Hypotenuse
	        var thetaRad = Math.atan2(dy, dx); // Transformed Point Angle

	        var phiRad = thetaRad + imgRotAngleRad; // Add Rotation to Point Angle
	        cpRtn.x = hyp * Math.cos(phiRad); // Compute Shift
	        cpRtn.y = hyp * Math.sin(phiRad);

	        //debug-only thisImg.log("........Rotate => (" + parseInt(cpRtn.x) + "," + parseInt(cpRtn.y) + ")");
	        var xi = cpRtn.x + xc,
	            yi = yc - cpRtn.y; // compute x-shift and convert to image coordiantes
	        cpRtn.x = Math.round(xi);
	        cpRtn.y = Math.round(yi);
	        //debug-only thisImg.log(".................coordUnRotate xi,yi => (" + cpRtn.x + "," + cpRtn.y + ")");
	    }
	    return cpRtn;
	};
	//............................................ coordUnRotToRot
	//    coordUnRotToRot - This function converts a distance in unrotated coords to rotated coords.
	_defines2.default.coordUnRotToRot = function (dx, dy, thisImg) {
	    var rtnXY = new _objects.cPoint(dx, dy);
	    var imgAngleRad = thisImg.getViewAngle();
	    if (imgAngleRad != 0) {

	        var movAngleRad = Math.atan2(dy, dx); // direction of move
	        var movMag = Math.sqrt(dx * dx + dy * dy); // magnitude of move

	        var rotMoveAngleRad = movAngleRad - imgAngleRad; // angle between move direction and view rotation

	        var rotDx = Math.round(movMag * Math.cos(rotMoveAngleRad)); //todo-cosolodate
	        var rotDy = Math.round(movMag * Math.sin(rotMoveAngleRad));
	        rtnXY.set(rotDx, rotDy);
	        //debug-only thisImg.log("....coordUnRotToRot (" + (imgAngleRad*us.Rad2Deg).toFixed(2) + " deg)  dx,dy:(" + dx + "-->" + rtnXY.x + "," + dy + "-->" + rtnXY.y + ")");
	    }
	    return rtnXY;
	};
	//............................................ regionBuildDiv()
	_defines2.default.regionBuildDiv = function (sRegImgSrc, thisImg, opt_cbOnRegionLoad) {
	    return $('<img/>', {
	        load: function load(e) {
	            if (opt_cbOnRegionLoad) opt_cbOnRegionLoad(self);
	            if (_defines2.default.DBGIMGLOAD) thisImg.log('..regionBuildDiv: region loaded ');
	        },
	        error: function error(e) {
	            if (_defines2.default.DBGIMGLOAD) thisImg.log('..regionBuildDiv: load error');
	        },

	        'class': _defines2.default.clsIMGREGION, 'src': sRegImgSrc, 'alt': ''
	    });
	};
	//-------------------------------------------------------------------------------------------------
	//    VIEWPORT ID & CLASS HELPERS
	//-------------------------------------------------------------------------------------------------
	//............................................ us.classFromImageId()
	//    This function converts the input imageId to a class id for the viewport    divs.
	//    In doing so it verifies that the imageId is valid.  If the image id is not valid, undefined is returned.
	//
	//        return example: "us_img_2" returned for imageId = 2 if us.clsPREPEND_ID = "us_img_"

	_defines2.default.classFromImageId = function (imageId) {
	    var rtnClass;
	    if (imageId.indexOf('@') === 0) // this is an imageId format (starts with '@')
	        return _defines2.default.clsPREPEND_ID + imageId.substr(1); // return example: "us_img_2"

	    if (imageId.toUpperCase().indexOf('IMAGESERVER') === 0) {
	        // this is format of imageserver/filename
	        rtnClass = _defines2.default.clsPREPEND_ID + imageId.slice('IMAGESERVER'.length + 1); // remove the imageserver/
	        rtnClass = rtnClass.slice(0, rtnClass.lastIndexOf('.')); // remove the .ext
	        return rtnClass;
	    }
	    return rtnClass;
	};
	//............................................ us.extractImageIdFromClass()
	// This function receives a string presumably in the format of us.clsPREPEND_ID + imageId (without the @ sign).
	//    If us.clsPREPEND_ID exists in the passed string it extracts the imageIdand returns it.
	//    If it doesn't exist, undefined is returned.

	_defines2.default.extractImageIdFromClass = function (cls) {
	    var rtnId;
	    var index = cls.indexOf(_defines2.default.clsPREPEND_ID);
	    if (index !== -1) rtnId = cls.slice(_defines2.default.clsPREPEND_ID.length - cls.length);
	    return rtnId;
	};
	//________________________________________________________________________________________________
	//    URL BUILDER
	//________________________________________________________________________________________________

	// Basic YWRtaW5pc3RyYXRvcjpzY2Fuc2NvcGU=
	function UrlBuilder(inUrlRoot, inImageId, opt_quality) {
	    var self = this;
	    var urlRoot = inUrlRoot;
	    var imageId = inImageId;
	    var imageQuality = opt_quality ? '+' + opt_quality : '+80';

	    //............................................ setImageId()
	    this.setImageId = function (id) {
	        imageId = id;
	        var idx = urlRoot.lastIndexOf('@');
	        urlRoot = urlRoot.substr(0, idx) + imageId; //imageId has leading @ sign
	    };
	    //............................................ getImageId()
	    this.getImageId = function () {
	        return imageId;
	    };
	    //............................................ getUrlRoot()
	    this.getUrlRoot = function () {
	        return urlRoot;
	    }; //ol3
	    //............................................ setQuality()
	    this.setQuality = function (quality) {
	        if (quality > 50) imageQuality = '+' + quality;
	    };

	    //............................................ thumb()
	    this.thumb = function (width, height) {
	        // example aperio imageserver format (when connected thru apache) : /imageserver/@2?0+0+435+0+-1
	        // - note that id is not used as it is appended already to the 'urlRoot'
	        return urlRoot + '?' + '0+0+' + width + '+' + height + '+-1';
	    };
	    //............................................ label()
	    this.label = function (width, height) {
	        // example aperio imageserver format (when connected thru apache) : /imageserver/@2?0+0+122+122+-2
	        // - note that id is not used as it is appended already to the 'urlRoot'
	        return urlRoot + '?' + '0+0+' + width + '+' + height + '+-2';
	    };
	    //............................................ region()
	    this.region = function (x, y, width, height, zoom, opt_progressive) {
	        // example aperio imageserver format (when connected thru apache) : /imageserver/@2?0+0+1956+1628+27
	        // - note that id is not used as it is appended already to the 'urlRoot'
	        var url = urlRoot + '?' + x + '+' + y + '+' + width + '+' + height + '+' + zoom + imageQuality;
	        if (opt_progressive) url += '+P';
	        return url;
	    };
	}

	//-------------------------------------------------------------------------------------------------
	// roundToHalf - This function rounds a float value to the nearest integer or 1/2.
	function roundToHalf(value) {
	    var ival = parseInt(value);
	    var fraction = value - ival;
	    if (fraction < 0.25) return ival;else if (fraction >= 0.75) return ival + 1;
	    return ival + 0.5;
	}
	module.exports = exports['default'];

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = cStateVector;

	var _defines = __webpack_require__(3);

	var _defines2 = _interopRequireDefault(_defines);

	var _objects = __webpack_require__(7);

	var _events = __webpack_require__(10);

	var _helpers = __webpack_require__(8);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	//________________________________________________________________________________________________
	// statevector.js
	//todo: update description
	//
	// cStateVector object - This is a generic container useful for ...
	//    Every item added to the queue is time stamped for time series analyis, playback, etc.
	//  There are optional functions onAdd[1,2,..]() that the user can define that will be //cp-not right!!!!!
	//        called each time imageUpdate() is called.
	//
	//    Note that the debug statements are commented outin some functions to reduce vpRefresh time.
	//cp-mention that this saves mouse & moves only > a fixed amount...
	//
	//    history
	//    1106    cperz    created
	//    _______________________________________end_AIHv1/PR __________________________________________
	//
	//________________________________________________________________________________________________
	// todo
	//    - could make queue trim on time instead of size (with size max still...)
	//  - add methods for getlast direction, mouse position, etc....
	//            much more straightforward, no need to understand internal storage of this object!
	//________________________________________________________________________________________________
	// state types:
	//    image: set by viewUpdate()
	//    mouse: set by mouseUpdate()
	//
	_defines2.default.eStateTypes = { image: 0, mouse: 1 };

	function cStateVector(vpObj) {
	    var thisImg = vpObj; // the viewport object - the parent
	    var self = this;
	    var imageId_ = thisImg.getImageId();
	    var uScopeIdx_ = thisImg.getImageIdx();

	    var imageSizeMax;
	    var mouseSizeMax;

	    var idxPrevNext = -1; // index in image queue
	    var idxPrevNextStart = -1; // index of starting position of prev/next sequence

	    var d = new Date();
	    var dTime = 1. / 10.; // get the start time and scale it from millisecs to 1/100th sec
	    var startTime = d.getTime() * dTime;

	    var imageQueue = []; // the image state vector queue
	    var mouseQueue = []; // the mouse state vector queue
	    var cb_imageState = []; // array of image state function callbacks
	    var cb_mouseState = []; // array of mouse state function callbacks

	    var stateTypeView = _defines2.default.eStateTypes.view;
	    var stateTypeMouse = _defines2.default.eStateTypes.mouse;

	    var minMoveMagnitude_ = 12; // the minimum magnitude in pixels of movement to record
	    var slopeLimit = 4;
	    var slopeLimtInv = 0.25; // 1. / slopeLimit

	    var kSVQUEUE_VIEW_SIZE = 500; // number of view states to retain in state vector queue
	    // this throttles the responsivity of the state vector!

	    //............................................ _sinceStartTime local
	    //    This function is used for all time stamps in this object.
	    //    It converts absolute time from "new Date().getTime()" to a differntial in seconds
	    //    (to the 3rd decimal place - milliseconds) since the start time of this object.
	    var _sinceStartTime = function _sinceStartTime(time) {
	        return (time * dTime - startTime).toFixed(3);
	    };
	    //............................................ _setSize local
	    // This function sets the image and mouse queue maximum sizes.
	    var _setSize = function _setSize(newSize) {
	        var newMax = newSize ? newSize : 200; // maximum size for queue
	        if (newMax < 1 || newMax > 2000) // sanity check on the queue size
	            return;
	        imageSizeMax = newMax;
	        mouseSizeMax = 100; //  parseInt(newMax / 2);     // limit the mouse queue to half the size


	        while (imageQueue.length > imageSizeMax) {
	            imageQueue.shift();
	        }while (mouseQueue.length > mouseSizeMax) {
	            mouseQueue.shift();
	        }
	    };
	    //............................................ registerForEvent
	    // This function adds a subscription to state change event.
	    // The imageUpdate() and mouseUpdate() functions call these subscribers.
	    //
	    this.registerForEvent = function (functionString, stateType) {
	        if (typeof functionString === 'function') {
	            if ((0, _helpers.isUnDefined)(stateType)) stateType = _defines2.default.eStateTypes.view;
	            if (_defines2.default.DBGSTATEVECTOR) thisImg.log('statevector: add callback: (' + functionString + ')  Type: ' + stateType);
	            if (stateType === _defines2.default.eStateTypes.view) cb_imageState.push(functionString);else cb_mouseState.push(functionString);
	        }
	    };
	    //............................................ unRegisterForEvent
	    // This function removes a subscription to state change event.
	    this.unRegisterForEvent = function (functionString) {
	        // find a string match in the call back arrays and remove it.
	        if (typeof functionString === 'function') {
	            functionString = functionString.toString();
	            // search image state queue for the event
	            for (var c = 0, len = cb_imageState.length; c < len; c++) {
	                var str = cb_imageState[c].toString();
	                if (str.indexOf(functionString) !== -1) {
	                    if (_defines2.default.DBGSTATEVECTOR) thisImg.log('statevector: remove image callback: (' + functionString + ')');
	                    cb_imageState.remove(c);
	                    return;
	                }
	            }
	            // search mouse state queue for the event
	            for (var c = 0, len = cb_mouseState.length; c < len; c++) {
	                var str = cb_mouseState[c].toString();
	                if (str.indexOf(functionString) !== -1) {
	                    if (_defines2.default.DBGSTATEVECTOR) thisImg.log('statevector: remove mouse callback: (' + functionString + ')');
	                    cb_mouseState.remove(c);
	                    return;
	                }
	            }
	        }
	    };
	    //............................................ viewUpdate
	    // This function adds an image state vector to its queue.
	    // If the state description is a move, the city block distance between this position and the previous state on the queue
	    // must be greater than a threshold.  Otherwise the state is not added to the queue.
	    //
	    // An Image State Vector is a definition of the view state plus:
	    //        time stamp
	    //        + desc  {"all", "move", "zoom", "focus", "dims", }
	    //        + viewport's vpView contents {left, top, width, height, zoom, focus, angleDeg}
	    //        + dir {"none", "wholeview", "north", "east", "west", "south", northwest, ...} //cp-fill in and define
	    //        + magpx { magnitude of move in pixels }
	    //
	    //    parameters
	    //        state:        {left, top, width, height, zoom, focus, angleDeg}
	    //        changeDesc: "all" or "move" or "zoom" or "focus" or "dims" or "rotate"
	    //
	    //    todo:
	    //        - I'd like to know if there are listeners, perhaps I don't do all this if not

	    var lastViewState_ = new _objects.cPoint(0, 0);
	    this.viewUpdate = function (state, changeDesc) {
	        var zoom = state.zoom;
	        var x = state.left;
	        var y = state.top;
	        //debug-only thisImg.log("image state: X,Y,ZOOM: " + x + "," + y + "," + zoom);

	        if (imageQueue.length == imageSizeMax) // maintain queue size
	            imageQueue.shift(); // remove the top element of the array to make room at the bottom

	        var magpx = 0;
	        if (changeDesc == 'move') {
	            // throttle the responsivity to motion
	            var magpx = Math.abs(state.left - lastViewState_.x) + Math.abs(state.top - lastViewState_.y); // city-street magnitude of move in pixels
	            if (magpx < minMoveMagnitude_) {
	                //dbg-only if (us.DBGSTATEVECTOREX) thisImg.log("cStateVector: viewUpdate: magnitude of move (" + magpx + ") < minimum (" + minMoveMagnitude_ + ")");
	                return;
	            }
	            //consoleWrite("cur state: " + state.left + "," + state.top + " last state: " + lastViewState_.toString() + "  magpx: " + magpx);
	        }

	        var sv = []; // add info to new state vector
	        sv.time = _sinceStartTime(new Date().getTime()); // add time stamp
	        sv.desc = changeDesc; // add input change description
	        sv.state = jQuery.extend(true, {}, state); // add input view state, must clone state first
	        if (changeDesc == 'move') //
	            sv.magpx = magpx; // add magnitude of move (units are pixels)
	        _computeDir(sv); // add computed direction 'dir'
	        imageQueue.push(sv); // add state vector to the queue
	        lastViewState_.set(state.left, state.top); // save last queue view position

	        //if (us.DBGSTATEVECTOR) sv.magpx ? thisImg.log("cStateVector: viewUpdate: dir: " + sv.dir + " magpx: " + sv.magpx)
	        //                             : thisImg.log("cStateVector: viewUpdate: desc: " + sv.desc);

	        for (var c = 0, len = cb_imageState.length; c < len; c++) {
	            // execute the callbacks to signal a SV update event
	            cb_imageState[c]();
	        } // report coords in normal graphics system space
	        var cpCenter = thisImg.getViewCenter(_defines2.default.coordSystemNORM); //report out in normal coordSystem
	        (0, _events.triggerUScopeEvent)(_defines2.default.evVIEWCHANGE, { // fire event that the view has changed
	            imageId: imageId_, uScopeIdx: uScopeIdx_, desc: sv.desc,
	            x: cpCenter.x, y: cpCenter.y, zoom: zoom, angleDeg: state.angleDeg
	        });

	        //............................................ _computeDir
	        // This function evaluates the most recent state change and concludes the view motion direction.
	        //        It then adds that direction to the passed array.
	        function _computeDir(ioSV) {

	            ioSV.dir = 'none';
	            if (imageQueue.length == 0 || ioSV.desc == 'all' || ioSV.desc != 'move') return;

	            var lastState = self.getLast(stateTypeView).state;
	            var dx = ioSV.state.left - lastState.left;
	            var dy = ioSV.state.top - lastState.top;

	            if (Math.abs(dx) > lastState.width * 2 || Math.abs(dy) > lastState.height * 2 // if moved N views  //cp-revisit factor of 2
	            || ioSV.desc == 'dim') {
	                // or resized view dimensions
	                ioSV.dir = 'wholeview'; // then indicate whole view change
	                return;
	            }
	            var dr = slopeLimit + 1; // slope of motion
	            if (dy != 0) dr = dx / dy;

	            if (_defines2.default.DBGSTATEVECTOREX) ioSV.magpx ? thisImg.log('cStateVector: computeDir: ' + dr.toFixed(2) + '  dx dy:' + dx + ' ' + dy + '  magpx:' + ioSV.magpx) : thisImg.log('cStateVector: computeDir: ' + dr.toFixed(2) + '  dx dy:' + dx + ' ' + dy);

	            var dir = 'none'; // default direction of move
	            if (Math.abs(dr) > slopeLimit) {
	                // if horizontal motion
	                if (dx < 0) // if moving left
	                    dir = 'east';else dir = 'west';
	            } else if (Math.abs(dr) < slopeLimtInv) {
	                // if vertical motion
	                if (dy < 0) // if moving up
	                    dir = 'south';else dir = 'north';
	            } else if (dx < 0) {
	                // diagnal motion, moving left
	                if (dy < 0) // if moving up, too
	                    dir = 'southeast';else dir = 'northeast';
	            } else {
	                // diagnal motion, moving right
	                if (dy < 0) // if moving up, too
	                    dir = 'southwest';else dir = 'northwest';
	            }

	            ioSV.dir = dir; // add direction to return ioSV
	        }
	    };

	    //............................................ mouseUpdate
	    // This function adds an mouse state vector to its queue.
	    // If the state description is a mousemove, the city block distance between this position and the previous state on the queue
	    // must be greater than a threshold.  Otherwise the state is not added to the queue.
	    //
	    //    A Mouse State Vector is a definition of the mouse state:
	    //        time stamp
	    //        + desc {"mousemove", "mousedown", ...}
	    //        + state   cPoint {x,y} of mouse position in base image coordinates, us.coordSystemNORM
	    //
	    //    parameters
	    //        state:            cPoint {x,y} of mouse position in base image coordinates
	    //        eventDesc:        {"mousemove", "mousedown",}
	    //        bForce:            boolean, if true the function does not exit when there are no listeners
	    //                                    so us.evMOUSECHANGE event is fired if mouse move is sufficient

	    var lastMouseState_ = new _objects.cPoint(0, 0);
	    this.mouseUpdate = function (state, eventDesc, bForce) {
	        if (bForce == false && cb_mouseState.length == 0) // do not save state if no one is subscribed
	            return;
	        //dbg-only if (us.DBGSTATEVECTOREX)    thisImg.log("cStateVector: mouseUpdate: " + state.toString() + "  desc: " + eventDesc);

	        if (mouseQueue.length == mouseSizeMax) // maintain queue size
	            mouseQueue.shift(); // remove the top element of the array to make room at the bottom

	        var magpx = 0;
	        if (eventDesc == 'mousemove') {
	            if (lastMouseState_) {
	                // throttle the responsivity to motion
	                magpx = lastMouseState_.cityBlockDistance(state);
	                //consoleWrite("cur state: " + state + " last state: " + lastMouseState_.toString() + "  magpx: " + magpx);
	                if (magpx < minMoveMagnitude_) {
	                    //dbg-only if (us.DBGSTATEVECTOREX) thisImg.log("cStateVector: mouseUpdate: magnitude of move (" + magpx + ") < minimum (" + minMoveMagnitude_ + ")");
	                    return;
	                }
	            }
	        }

	        var sv = []; // add info to new state vector
	        sv.time = _sinceStartTime(new Date().getTime()); // add time stamp

	        sv.desc = eventDesc; // add input change description
	        sv.state = jQuery.extend(true, {}, state); // add input view state, must clone state first
	        mouseQueue.push(sv); // add state vector to the queue
	        lastMouseState_.setPoint(sv.state); // save last queue mouse position

	        //dbg-only if (us.DBGSTATEVECTOREX) thisImg.log("cStateVector: mouseUpdate: desc: " + sv.desc + sv.state.toString() + " magnitude: " + magpx);

	        for (var c = 0, len = cb_mouseState.length; c < len; c++) {
	            // execute the callbacks to signal a SV update event
	            cb_mouseState[c]();
	        }(0, _events.triggerUScopeEvent)(_defines2.default.evMOUSECHANGE, {
	            imageId: imageId_,
	            uScopeIdx: thisImg.getImageIdx(),
	            x: state.x,
	            y: state.y
	        });
	    };

	    //............................................ getLastMousePosition
	    // This function returns the last recorded mouse position or undefined if none have been recorded.
	    this.getLastMousePosition = function () {
	        return mouseQueue.length > 0 ? mouseQueue[mouseQueue.length - 1].state : undefined;
	    };

	    //............................................ getMouseEventsSince
	    //    This function returns an array in ascending order of the mouse events since a specified time.
	    //    The time stamp in the list of events is in this object's format - delta time since the start of the object scaled by dTime;
	    //    Optionally a specific type of mouse event can be selected.
	    //  A maximum number of returned events is enforced but can be overridden.
	    //
	    //    parameters:
	    //        sinceTime    required, time to start collecting the event, sinceTime = new Date().getTime()
	    //        eventDesc    optional, return this mouse event type {"mousemove", "mousedown", ...}  default is all
	    //        maxRtnSize    optional, maximum number of mousestates to return, default is 100

	    this.getMouseEventsSince = function (sinceTime, eventDesc, maxRtnSize) {
	        var rtnQueue = [];
	        if ((0, _helpers.isUnDefined)(sinceTime)) return rtnQueue;

	        sinceTime = _sinceStartTime(sinceTime); // convert to same time format as used here in
	        if (mouseQueue.length > 0) {
	            eventDesc = eventDesc ? eventDesc : 'all'; // set event filter
	            maxRtnSize = maxRtnSize ? maxRtnSize + 1 : 101; // set limit of number of items returned

	            var cnt = 0;
	            var startIdx = mouseQueue.length;
	            while (--startIdx > 0 && ++cnt < maxRtnSize) {
	                if (mouseQueue[startIdx].time < sinceTime) // am I now before my time?
	                    break;
	                if (eventDesc == 'all' || eventDesc == mouseQueue[startIdx].desc) rtnQueue.unshift(mouseQueue[startIdx]); // add to the begining of the array for ascending order
	            }
	        }
	        return rtnQueue;
	    };

	    //............................................ getPrevNext
	    this.getPrevNext = function (incr) {
	        //incr s/b +/-1
	        if (imageQueue.length < 1) return undefined;

	        var rtnSV;
	        if (idxPrevNext == -1) {
	            idxPrevNext = imageQueue.length - 1 + incr;
	            idxPrevNextStart = imageQueue.length - 1;
	        } else {
	            idxPrevNext = idxPrevNext + incr;
	            if (idxPrevNext > idxPrevNextStart) idxPrevNext = idxPrevNextStart; // don't move past starting position
	        }

	        /////thisImg.log("getPrevNext: idxPrevNext: " + idxPrevNext);
	        if (idxPrevNext > 0 && idxPrevNext < imageQueue.length) rtnSV = imageQueue[idxPrevNext];

	        if (idxPrevNext == idxPrevNextStart) idxPrevNext = -1; //reset

	        return rtnSV;
	    };
	    //............................................ getLastDirection
	    // This function returns the last recorded image direction or undefined if none have been recorded.
	    this.getLastDirection = function () {
	        return imageQueue.length > 0 ? imageQueue[imageQueue.length - 1].dir : undefined;
	    };
	    //............................................ getLastDescription
	    // This function returns the last recorded image description or undefined if none have been recorded.
	    this.getLastDescription = function () {
	        return imageQueue.length > 0 ? imageQueue[imageQueue.length - 1].desc : undefined;
	    };
	    //............................................ getLast
	    // This function returns the last state vector for the specified state type.
	    this.getLast = function (stateType) {
	        //cp-todo rename to get LastState
	        if ((0, _helpers.isUnDefined)(stateType)) stateType = _defines2.default.eStateTypes.view;
	        if (stateType === _defines2.default.eStateTypes.view) return imageQueue.length > 0 ? imageQueue[imageQueue.length - 1] : undefined;else return mouseQueue.length > 0 ? mouseQueue[mouseQueue.length - 1] : undefined;
	    };
	    //............................................ reportLast
	    // This function returns a string containing the last state vector report for the specified state type.
	    this.reportLast = function (stateType) {
	        var str = '';
	        var queue = stateType === _defines2.default.eStateTypes.view ? imageQueue : mouseQueue;
	        if (queue.length > 0) {
	            str = stateType === _defines2.default.eStateTypes.view ? 'LastViewState: ' : 'LastMouseState: ';
	            var state = queue[queue.length - 1];
	            str += this.report(state, stateType);
	        }
	        return str;
	    };
	    //............................................ report
	    // This function converts the passed state into a csv string.
	    this.report = function (stateVector, stateType) {
	        var str = '';
	        if ((0, _helpers.isUnDefined)(stateVector)) return str;
	        if ((0, _helpers.isUnDefined)(stateType)) stateType = _defines2.default.eStateTypes.view;

	        if (stateType === _defines2.default.eStateTypes.view) {

	            var zoom = stateVector.state.zoom;
	            var isFit = thisImg.isFitZoom(zoom);
	            var mag = isFit ? 'Fit' : thisImg.convertToMag(zoom);
	            zoom = isFit ? 'Fit' : zoom;

	            // note that this format is copied into the performance test sequence in cPerformanceTest
	            str = parseInt(stateVector.time) + ', "' + stateVector.desc + '", ' + stateVector.state.left + ', ' + stateVector.state.top + ', ' + zoom + ', ' + mag;

	            //note: stateVector.dir & stateVector.magpx not reported (yet?)
	        } else {
	            var sv = mouseQueue[mouseQueue.length - 1];
	            str = stateVector.desc;
	            str += stateVector.state.toString();
	            if (stateVector.magpx) str += '  magnitude_px:' + stateVector.magpx;
	        }
	        return str;
	    };
	    this.reportTitle = function (stateType) {
	        var str = '';
	        if ((0, _helpers.isUnDefined)(stateType)) stateType = _defines2.default.eStateTypes.view;

	        str = 'Filename: ' + thisImg.getFileName() + ' Width: ' + thisImg.getImageWidth() + ' Height:' + thisImg.getImageHeight() + '\n';

	        if (stateType === _defines2.default.eStateTypes.view) {
	            str += 'time, desc, centerX, centerY, zoom, mag\n';
	            //note: stateVector.dir & stateVector.magpx not reported (yet?)
	        } else {
	                // not implemented
	            }
	        return str;
	    };
	    //............................................ reportAll
	    this.reportAll = function (stateType, normalize) {
	        var str = this.reportTitle(stateType);
	        if ((0, _helpers.isUnDefined)(stateType)) stateType = _defines2.default.eStateTypes.view;
	        if ((0, _helpers.isUnDefined)(normalize)) normalize = false;

	        var queue = stateType === _defines2.default.eStateTypes.view ? imageQueue : mouseQueue;
	        if (queue.length > 0) {
	            for (var s = 0, len = queue.length; s < len; s++) {
	                var svRef = queue[s]; // get state vector at index s
	                var sv = new _helpers.cloneObject(svRef); // clone the state vector so I can modify it

	                var x = sv.state.left; // state reports top left corner, convert to center position
	                var y = sv.state.top;
	                x = parseInt(x + thisImg.getViewWidth() / 2);
	                y = parseInt(y + thisImg.getViewHeight() / 2);

	                if (normalize == true) {
	                    // if normalize, x and y are proportion of the image dims
	                    x = (x / thisImg.getImageWidth()).toFixed(5);
	                    y = (y / thisImg.getImageHeight()).toFixed(5);
	                }
	                sv.state.left = x;
	                sv.state.top = y;

	                str += this.report(sv, stateType) + '\n';
	            }
	        }
	        return str;
	    };

	    //............................................................................................
	    // construction
	    _setSize(kSVQUEUE_VIEW_SIZE); // save the max queue size allowed
	}
	module.exports = exports['default'];

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = cXINFO;

	var _defines = __webpack_require__(3);

	var _defines2 = _interopRequireDefault(_defines);

	var _helpers = __webpack_require__(8);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	//-------------------------------------------------------------------------------------------------
	// xinfo.js
	//    This file contains the request for xinfo data and the class, functions to access that data.
	//    - http://localhost:82/@1?XINFO
	//
	//    history
	//    1105    cperz        created
	//    _______________________________________end_AIHv1/PR __________________________________________
	//    141118    cperz
	//    141222    cperz        change construction signature; use passed in log function; add support for analysis;
	//    150318    cperz        decoded Algorithm for markups
	//
	//________________________________________________________________________________________________
	//

	function cXINFO(logFn, imageId) {
	    // object for XINFO
	    var status = false; // initialized ok
	    var inImageId_ = imageId; //save the imageId this object is related to

	    this.scanner = 'not defined';
	    this.version = 'not defined';
	    this.bitsPerSampl = 8;
	    this.acqBitsPerSampl = 8; //todo: not parsed yet
	    this.samplPerPix = 3;
	    this.capturetype = _defines2.default.eAICCaptureType.aic_i_BF;
	    this.left = 0; //cp-i don't see it in xinfo but a tma core (sub image) should have a non-zero left,top coord - or should it when connect to imageserver?
	    this.top = 0;
	    this.width = 0;
	    this.height = 0;
	    this.depth = 0; //
	    this.tileWidth = 0;
	    this.tileHeight = 0;
	    this.title = '';
	    this.description = '';
	    this.filesize = 0;
	    this.imagesize = 0;
	    this.comptype = 0;
	    this.comptypedesc = '';
	    this.compquality = 0;
	    this.compcodec = 0;
	    this.apparentMag = 20;
	    this.MPP = 0.5;
	    this.getAlgorithmName;

	    this.isFused = false;
	    this.fusedFiles = []; // fused member image file names

	    this.layers = 0; // layer object array that contains level object arrays
	    this.layerTbl = [];

	    this.thumb = new thumb();
	    this.macro = new macro();
	    this.label = new label();

	    // public methods
	    //............................................ status related
	    this.getStatus = function () {
	        return status;
	    };
	    this.setStatus = function (bstate) {
	        status = bstate === true ? true : false;
	    };

	    //............................................ search description field related
	    this.getDescValue = function (tag, defaultValue) {
	        if (this.descArray != undefined) {
	            for (var i = 0, len = this.descArray.length; i < len; i++) {
	                if (this.descArray[i].indexOf(tag) != -1) {
	                    // if the tag is found
	                    var valIdx = this.descArray[i].indexOf('=') + 1;
	                    var value = this.descArray[i].slice(valIdx);
	                    value = (0, _helpers.trimWhitespace)(value);
	                    return value;
	                }
	            }
	        }
	        return defaultValue;
	    };
	    //............................................ image pyramid access
	    // defaults lev=0,lay=0
	    this.GetLevelObj = function (lev, lay) {
	        // get level object for pyramid(layer, level
	        var lev = (0, _helpers.isUnDefined)(lev) ? 0 : lev;
	        var lay = (0, _helpers.isUnDefined)(lay) ? 0 : lay;
	        if (lay > this.layers || lev > this.layerTbl[lay].levels) return null;
	        return this.layerTbl[lay].levelTbl[lev];
	    };
	    this.get_imageLevels = function (lay) {
	        // get number of image pyramid levels
	        var lay = (0, _helpers.isUnDefined)(lay) ? 0 : lay;
	        return +this.layerTbl[lay].levels;
	    };
	    this.get_imageZoom = function (lev, lay) {
	        // get image pyramid level zoom  (e.g. 1, 4, 16)
	        var oLevel = this.GetLevelObj(lev, lay);
	        return oLevel != null ? +oLevel.zoom : 0;
	    };
	    this.get_imageWidth = function (lev, lay) {
	        // get image width for a given layer,level
	        var oLevel = this.GetLevelObj(lev, lay);
	        return oLevel != null ? +oLevel.width : 0;
	    };
	    this.get_imageHeight = function (lev, lay) {
	        // get image height for a given layer,level
	        var oLevel = this.GetLevelObj(lev, lay);
	        return oLevel != null ? +oLevel.height : 0;
	    };
	    this.get_tilesX = function (lev, lay) {
	        // get number of tiles in X for a given layer,level
	        var oLevel = this.GetLevelObj(lev, lay);
	        return oLevel != null ? +oLevel.tilesX : 0;
	    };
	    this.get_tilesY = function (lev, lay) {
	        // get number of tiles in Y for a given layer,level
	        var oLevel = this.GetLevelObj(lev, lay);
	        return oLevel != null ? +oLevel.tilesY : 0;
	    };
	    this.get_baseMag = function () {
	        return this.apparentMag;
	    };
	    this.get_MPP = function (lev, lay) {
	        var zoom = this.get_imageZoom(lev, lay);
	        var MPP = this.MPP * zoom;
	        return MPP;
	    };
	    this.getAlgorithmName = function () {
	        return this.AlgorithmName;
	    };

	    //............................................ parse xinfo response, populate XINFO object - call back from ajaxXINFO
	    //improvement: convert to use of x2js
	    this.init = function (xinfoDoc, inImageId) {
	        if (_defines2.default.DBGXINFO) {
	            var x2js = new X2JS();
	            var jsonObj2 = x2js.xml2json(xinfoDoc);
	            //    consoleWrite("xinfo:" + toStringAssoc(jsonObj2.xinfo, "\n"));
	            var xmlstr = x2js.json2xml_str(jsonObj2);
	            logFn('xinfo: init: xmlString: \n' + xmlstr);
	        }
	        //        if (us.DBGXINFO && BrowserDetect.isIE() == false) {    // this can't be done in IE8, presumably ok in IE9
	        //            var xmlString = (new XMLSerializer()).serializeToString(xinfoDoc);
	        //            logFn("xinfo: init: xmlString: \n" + xmlString);
	        //        }

	        // verify xinfo is the response
	        if (!jQuery.isXMLDoc(xinfoDoc) || xinfoDoc.getElementsByTagName('xinfo')[0].nodeName !== 'xinfo') {
	            logFn('Error:  uScope: xinfo: init: input xinfoDoc is not xinfo content');
	            return status;
	        }
	        // verify this response is for the imageId associated with this viewport
	        if (inImageId !== inImageId_) {
	            logFn('Error:  uScope: xinfo: init: passed imageId ' + inImageId + ' is not associated with this viewport');
	            return status;
	        }

	        this.version = xinfoDoc.getElementsByTagName('version')[0].childNodes[0].nodeValue;
	        this.bitsPerSampl = +xinfoDoc.getElementsByTagName('bitsPerSampl')[0].childNodes[0].nodeValue;

	        this.samplPerPix = +xinfoDoc.getElementsByTagName('samplPerPix')[0].childNodes[0].nodeValue;
	        this.capturetype = xinfoDoc.getElementsByTagName('capturetype')[0].childNodes[0].nodeValue;
	        this.width = +xinfoDoc.getElementsByTagName('width')[0].childNodes[0].nodeValue;
	        this.height = +xinfoDoc.getElementsByTagName('height')[0].childNodes[0].nodeValue;
	        this.depth = +xinfoDoc.getElementsByTagName('depth')[0].childNodes[0].nodeValue;
	        this.tileWidth = +xinfoDoc.getElementsByTagName('tilewidth')[0].childNodes[0].nodeValue;
	        this.tileHeight = +xinfoDoc.getElementsByTagName('tileheight')[0].childNodes[0].nodeValue;
	        if (_defines2.default.DBGPYRAMID) logFn('Tiles: ' + this.tileWidth + 'x' + this.tileHeight);

	        if (xinfoDoc.getElementsByTagName('title').firstChild != null) // title not always present
	            this.title = xinfoDoc.getElementsByTagName('title')[0].childNodes[0].nodeValue;

	        // get the image description and parse it. Here's a typical description string:
	        //        "Aperio Image Library v10.0.51 42320x31454 [0,100 41392x31354] (256x256) JPEG/RGB Q=70|
	        //        AppMag = 20|StripeWidth = 1840|ScanScope ID = SS5340|Filename = 347031|Date = 11/10/09|
	        //        Time = 12:09:18|User = d74add0a-174c-468a-bf95-d7b4d274a196|MPP = 0.5015|Left = 35.625134|
	        //        Top = 21.241474|LineCameraSkew = -0.000185|LineAreaXOffset = 0.032367|LineAreaYOffset = -0.065287|
	        //        Focus Offset = -0.001000|DSR ID = dsr-mfg|ImageID = 347031|OriginalWidth = 42320|Originalheight = 31454|
	        //        ICC Profile = ScanScope v1"

	        if (xinfoDoc.getElementsByTagName('description')[0].childNodes[0]) {
	            // description not always present
	            this.description = xinfoDoc.getElementsByTagName('description')[0].childNodes[0].nodeValue;
	            this.scanner = this.description.split(' ')[0].split(';')[0]; // Ariol;ASE requires the split(';')
	            if (_defines2.default.DBGXINFO) logFn('xinfo: init: scanner: ' + this.scanner);

	            this.descArray = this.description.split('|'); // | delimits the aperio description string
	            if (_defines2.default.DBGXINFO) logFn('xinfo: init: desc: ' + this.description);
	            for (var i = 1, len = this.descArray.length; i < len; i++) {
	                // starting after the "Aperio Image Library" item

	                if (this.descArray[i].indexOf('=') != -1) {
	                    // if there is a name = value item
	                    var newObj = this.descArray[i].split('='); // then add it to this xinfo object
	                    this[jQuery.trim(newObj[0])] = jQuery.trim(newObj[1]);
	                }
	            }

	            this.apparentMag = +this.getDescValue('AppMag', 20);
	            this.MPP = +this.getDescValue('MPP', 0.5);
	            this.filename = this.getDescValue('Filename', undefined);
	            this.date = this.getDescValue('Date', undefined);
	            this.scanScopeId = this.getDescValue('ScanScope ID', undefined);
	            this.iccProfile = this.getDescValue('ICC Profile', undefined);
	            this.acqBitsPerSampl = +this.getDescValue('Acquisition Bit Depth', undefined);
	            this.AlgorithmName = this.getDescValue('Algorithm', undefined);
	            var memberFile;
	            for (var i = 0; i < 12; i++) {
	                memberFile = this.getDescValue('Fused Image ' + i, undefined);
	                if (memberFile) {
	                    this.fusedFiles[i] = memberFile;
	                } else {
	                    break;
	                }
	            }
	        }
	        this.isFused = this.fusedFiles.length > 0 ? true : false;

	        this.filesize = +xinfoDoc.getElementsByTagName('filesize')[0].childNodes[0].nodeValue;
	        this.imagesize = +xinfoDoc.getElementsByTagName('imagesize')[0].childNodes[0].nodeValue;
	        this.comptype = +xinfoDoc.getElementsByTagName('comptype')[0].childNodes[0].nodeValue;
	        this.comptypedesc = xinfoDoc.getElementsByTagName('comptypedesc')[0].childNodes[0].nodeValue;
	        this.compquality = +xinfoDoc.getElementsByTagName('compquality')[0].childNodes[0].nodeValue;
	        this.compcodec = xinfoDoc.getElementsByTagName('compcodec')[0].childNodes[0].nodeValue;

	        // get the thumbnail before the levels (seen old imageservers report AFI image levels with widths of the thumbnail and of 0)
	        var subImage = xinfoDoc.getElementsByTagName('thumb'); //thumb not always present
	        if (subImage.length) this.thumb.init(subImage[0].getElementsByTagName('width')[0].childNodes[0].nodeValue, subImage[0].getElementsByTagName('height')[0].childNodes[0].nodeValue, subImage[0].getElementsByTagName('zoom')[0].childNodes[0].nodeValue);
	        if (_defines2.default.DBGXINFO) logFn('.. xinfo:init: ' + (subImage.length ? 'has' : 'no') + ' thumbnail ' + (subImage.length ? '(' + this.thumb.width + 'x' + this.thumb.height + ')' : ''));

	        var subImage = xinfoDoc.getElementsByTagName('macro'); //macro not always present
	        if (subImage.length) this.macro.init(subImage[0].getElementsByTagName('width')[0].childNodes[0].nodeValue, subImage[0].getElementsByTagName('height')[0].childNodes[0].nodeValue);
	        if (_defines2.default.DBGXINFO) logFn('.. xinfo:init: ' + (subImage.length ? 'has' : 'no') + ' macro ' + (subImage.length ? '(' + this.macro.width + 'x' + this.macro.height + ')' : ''));

	        var subImage = xinfoDoc.getElementsByTagName('label'); //label not always present
	        if (subImage.length) this.label.init(subImage[0].getElementsByTagName('width')[0].childNodes[0].nodeValue, subImage[0].getElementsByTagName('height')[0].childNodes[0].nodeValue);
	        if (_defines2.default.DBGXINFO) logFn('.. xinfo:init: ' + (subImage.length ? 'has' : 'no') + ' label ' + (subImage.length ? '(' + this.label.width + 'x' + this.label.height + ')' : ''));

	        this.layers = xinfoDoc.getElementsByTagName('layers')[0].childNodes[0].nodeValue;
	        var xLayers = xinfoDoc.getElementsByTagName('layer');
	        for (var lay = 0, maxLay = this.layers; lay < maxLay; lay++) {
	            // for each layer
	            this.layerTbl[lay] = new layer(lay, xLayers[lay].getElementsByTagName('zoff')[0].childNodes[0].nodeValue, xLayers[lay].getElementsByTagName('depth')[0].childNodes[0].nodeValue, xLayers[lay].getElementsByTagName('focus')[0].childNodes[0].nodeValue, xLayers[lay].getElementsByTagName('levels')[0].childNodes[0].nodeValue);
	            var nlevels = 0;
	            var xLevels = xLayers[lay].getElementsByTagName('level');

	            if (_defines2.default.DBGXINFO) logFn('.. xinfo:init: layer count=' + this.layers);
	            if (_defines2.default.DBGXINFO) logFn('.... xinfo:init: level count=' + this.layerTbl[lay].levels);

	            for (var lev = 0, maxLev = this.layerTbl[lay].levels; lev < maxLev; lev++) {
	                // for each level
	                // don't add a level that is smaller than the thumbnail unless it is the base level
	                // note - sometimes XINFO of fused imagery reports this.  It may be fixed.
	                var levWidth = +xLevels[lev].getElementsByTagName('width')[0].childNodes[0].nodeValue;
	                if (lev != 0 && levWidth < this.thumb.width) {
	                    if (_defines2.default.DBGXINFO) logFn('.... xinfo:init: ignoring level ' + lev + 'width=' + levWidth);
	                    continue;
	                }
	                this.layerTbl[lay].levelTbl[lev] = new level(lev, xLevels[lev].getElementsByTagName('width')[0].childNodes[0].nodeValue, xLevels[lev].getElementsByTagName('height')[0].childNodes[0].nodeValue, xLevels[lev].getElementsByTagName('zoom')[0].childNodes[0].nodeValue, this.tileWidth, this.tileHeight);
	                if (_defines2.default.DBGXINFO) {
	                    var alevel = this.layerTbl[lay].levelTbl[lev];
	                    logFn('.... xinfo:init: level: ' + nlevels + '  id:' + alevel.id + '(' + alevel.width + 'x' + alevel.height + ')  zoom:' + alevel.zoom);
	                }
	                nlevels++;
	            }
	            this.layerTbl[lay].levels = nlevels;
	        }
	        status = true;
	        return status;
	    };

	    //............................................ xinfo subImage object
	    function subImage() {
	        // prototype for thumb, macro, label //cp-not used!!!
	        this.isValid = false;
	        this.width = 0;
	        this.height = 0;
	        this.zoom = 1.0; // n/a for macro and label

	        this.init = function (w, h, zm) {
	            this.width = +w;
	            this.height = +h;
	            this.zoom = +zm;
	            this.isValid = true; //cp-more stringent test here
	        };
	    }
	    //............................................ xinfo thumb object
	    function thumb() {
	        // object for thumbnail
	        this.isValid = false;
	        this.width = 0;
	        this.height = 0;
	        this.zoom = 1.0;

	        this.init = function (w, h, zm) {
	            this.width = +w;
	            this.height = +h;
	            this.zoom = +zm;
	            this.isValid = true; //cp-more stringent test here
	            //debug-only logFn("thumbnail: WxH: " + w + "x"+h + "  zoom: "+ zm);
	        };
	    }
	    //............................................ xinfo macro image object
	    function macro(w, h) {
	        this.isValid = false;
	        this.width = 0;
	        this.height = 0;
	        //this.zoom = 0;

	        this.init = function (w, h, zm) {
	            this.width = +w;
	            this.height = +h;
	            //this.zoom = +zm;
	            this.isValid = true; //cp-more stringent test here
	        };
	    }
	    //............................................ xinfo label object
	    function label(w, h) {
	        this.isValid = false;
	        this.width = 0;
	        this.height = 0;
	        //this.zoom = 0;

	        this.init = function (w, h, zm) {
	            this.width = +w;
	            this.height = +h;
	            //this.zoom = +zm;
	            this.isValid = true; //cp-more stringent test here
	        };
	    }
	    //............................................ xinfo level object - levels of the image pyramid
	    function level(id, w, h, zm, tileW, tileH) {
	        this.id = id;
	        this.width = w;
	        this.height = h;
	        this.zoom = zm * 1; // *1 assures numeric interpretation

	        this.tilesX = Math.round(this.width / tileW); // (this.width + tileW - 1) / tileW;
	        this.tilesY = Math.round(this.height / tileH);
	        if (_defines2.default.DBGPYRAMID) logFn('   LEVEL id:' + this.id + ' dims:' + this.width + 'x' + this.height + ' zoom:' + this.zoom + ' #tiles:' + this.tilesX + 'x' + this.tilesY);
	    }
	    //............................................ xinfo layer object - (z position of the microscope objective)
	    function layer(id, zoff, depth, focus, levels) {
	        this.id = id;
	        this.zoff = zoff;
	        this.depth = depth;
	        this.focus = focus;
	        this.levels = levels;
	        this.levelTbl = [];
	        if (_defines2.default.DBGPYRAMID) logFn('LAYER id:' + this.id + ' zoffset:' + this.zoff + ' depth:' + this.depth + ' focus:' + this.focus + ' #levels:' + this.levels);
	    }
	}
	//________________________________________________________________________________________________

	module.exports = exports['default'];

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.cAutoPan = cAutoPan;
	exports.cEdgeNav = cEdgeNav;
	exports.cProgressive = cProgressive;
	exports.getImageIdFromSrcAttr = getImageIdFromSrcAttr;

	var _defines = __webpack_require__(3);

	var _defines2 = _interopRequireDefault(_defines);

	var _compatibility = __webpack_require__(6);

	var _objects = __webpack_require__(7);

	var _helpers = __webpack_require__(8);

	var _uScope = __webpack_require__(11);

	var _uScope2 = _interopRequireDefault(_uScope);

	var _publicApi = __webpack_require__(18);

	var _publicApi2 = _interopRequireDefault(_publicApi);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	//________________________________________________________________________________________________
	// overlays.js
	//    This file contains the methods related to overlay visuals, the set of imagery, controls,
	//    and viewer-defined graphics that are displayed on top of the tiled image.
	//    For example, the thumbnail, magnifier, scale bar and zoom control as well as the
	//    autopan and dsc marker imagery.
	//

	//-------------------------------------------------------------------------------------------------
	//    AUTOPAN OBJECT
	//-------------------------------------------------------------------------------------------------
	function cAutoPan(vpObj) {
	    // improvemetns:
	    //    - instead of moving the div offscreen I could use show/hide like all the other overlays!

	    var self = this;
	    var thisImg = vpObj; // the viewport object - the parent
	    var isLoaded = false;

	    var jVpDiv = thisImg.vpDivGet('outer');
	    var jAutoPan;

	    var timerId = -1; // the autopan timer id

	    var autoPanSpecs = { //    autopan settings
	        'timerInterval': 50, // timer interval in milliseconds
	        'speedFactor': 8, // speed factor - larger number slows pan speed
	        'autoPanLT': undefined, // left-top location of center target, cPoint type, initially undefined
	        autoPanCursor: 'url(/viewer/uScope/images/autopan-cur.png), url(/viewer/uScope/images/autopan-cur.cur), auto',
	        autoPanCursorOffset: 16 // the hotspot on a cursor is not working so this hard coded offset is used
	    };

	    //............................................ construct_() local
	    var construct_ = function construct_() {
	        if (_defines2.default.ENABLEAUTOPAN == false) return;
	        load_(); // load the auto pan center target
	    };

	    //............................................ off() public
	    //    This functions turnsoff autopan.
	    this.off = function () {
	        //debug-only thisImg.log("cAutoPan: off: " + thisImg.navModeGet());
	        if (thisImg.navModeGet() == _defines2.default.eNavModes.nmAutoPan) self.onOffToggle();
	    };

	    //............................................ onOffToggle() public
	    //    This function toggles autopan on/off.
	    this.onOffToggle = function () {
	        if (jAutoPan.length == 0) return; // if no match was found, return
	        if (isLoaded == false) return;

	        if (thisImg.navModeGet() != _defines2.default.eNavModes.nmAutoPan) {
	            // if not autopanning, start autopan
	            if (_defines2.default.DBGAUTOPAN) thisImg.log('AutoPan ON'); // start the autopan timer

	            if (autoPanSpecs.autoPanLT === undefined) // place the autopan image/symbol in the center of the view
	                autoPanSpecs.autoPanLT = new _objects.cPoint();

	            var vpDivDims = thisImg.vpDivDimsGet();
	            autoPanSpecs.autoPanLT.x = Math.round((vpDivDims.w - jAutoPan.width()) / 2);
	            autoPanSpecs.autoPanLT.y = Math.round((vpDivDims.h - jAutoPan.width()) / 2);
	            jAutoPan.css({ 'left': autoPanSpecs.autoPanLT.x + 'px', 'top': autoPanSpecs.autoPanLT.y + 'px' });

	            jVpDiv.addClass(_defines2.default.clsAPANCUR); // set the autopan cursor
	            _defines2.default.navModeSwitch(thisImg, _defines2.default.eNavModes.nmAutoPan); // set autopan nav mode
	            timerId = setInterval(function () {
	                _timer();
	            }, autoPanSpecs.timerInterval);
	        } else {
	            // if autopanning, halt autopan navigation
	            if (_defines2.default.DBGAUTOPAN) thisImg.log('AutoPan OFF');
	            // note: this is called from navmodehalt so do not call back to it!

	            clearInterval(timerId); // stop the autopan timer
	            timerId = -1;
	            jVpDiv.removeClass(_defines2.default.clsAPANCUR); // return to auto cursor

	            // place the autopan image/symbol offscreen//cp-is this better than hiding it?
	            jAutoPan.css({ 'left': _defines2.default.kDEF_TILE_POS_PX, 'top': _defines2.default.kDEF_TILE_POS_PX });
	        }
	    };

	    //............................................ load_() local
	    //    This function loads the autopan center-of-the-view image.
	    var load_ = function load_() {
	        if (jAutoPan) return; // if this viewport already has a autopan div, return

	        // first create an offscreen div that will contain the autopan image and add it to the vp
	        jAutoPan = $('<div/>', { // build the div tag that contains the img tag
	            'class': _defines2.default.clsAPANDIV + ' ' + _defines2.default.clsOVERLAY, // overlay class sets the z-index
	            css: { 'left': _defines2.default.kDEF_TILE_POS_PX, 'top': _defines2.default.kDEF_TILE_POS_PX } // locate offscreen
	        });
	        jVpDiv.append(jAutoPan); // place the autopan div in the vp
	        jAutoPan = jVpDiv.find('.' + _defines2.default.clsAPANDIV); // save for quick access
	        isLoaded = true;
	    };
	    //............................................ _timer() local
	    //    This function moves the view in proportion to the distance between the cursor and view center.
	    var _timer = function _timer() {
	        if (_defines2.default.DBGAUTOPAN) thisImg.log('autopan:_timer: curMode: ' + thisImg.navModeGet());

	        if (thisImg.navModeGet() == _defines2.default.eNavModes.nmAutoPan) {
	            // move the image proportional to the distance between the cursor and view center
	            var offset = autoPanSpecs.autoPanCursorOffset; // html/js seems to ignore cursor hotspots
	            var ptMouse = thisImg.getMouseCur();
	            var cx = ptMouse.x + offset; // so add offset to correct it
	            var cy = ptMouse.y + offset; // so add offset to correct it

	            var vpDivDims = thisImg.vpDivDimsGet();
	            var speedFactor = autoPanSpecs.speedFactor; // move the image dx, dy
	            var dx = (cx - vpDivDims.w / 2) / thisImg.getViewZoom() / speedFactor;
	            var dy = (cy - vpDivDims.h / 2) / thisImg.getViewZoom() / speedFactor;
	            thisImg.moveRelative(dx, dy, _defines2.default.coordSystemNORM);

	            // rotate the autopan autopan center target to point to the cursor
	            // - note that the icon's arrow is at 45 degrees so correct for that
	            var apAngleDeg = -Math.round(Math.atan2(-dy, dx) * _defines2.default.Rad2Deg);
	            var strAngle = apAngleDeg + 45 + thisImg.getViewAngle(true) + 'deg';
	            jAutoPan.css({
	                'transform': 'rotate(' + strAngle + ')',
	                'ms-transform': 'rotate(' + strAngle + ')', /* Internet Explorer  note that the leading '-' is removed */
	                '-moz-transform': 'rotate(' + strAngle + ')', /* Firefox */
	                '-webkit-transform': 'rotate(' + strAngle + ')', /* Safari and Chrome */
	                '-o-transform': 'rotate(' + strAngle + ')' /* Opera */
	            });
	            if (_defines2.default.DBGAUTOPAN) thisImg.log('autopan:_timer: mousePt: ' + ptMouse.toString() + '   vp wxH: ' + vpDivDims.w + 'x' + vpDivDims.h + '  dXY: ' + dx + ',' + dy);
	        } else {
	            // stop this timer!  shouldn't ever happen
	            thisImg.log('Warning: autopan:_timer: But not in autopan mode - Halting Navigation' + thisImg.getImageId());
	            _defines2.default.navModeHalt(thisImg);
	        }
	    };

	    construct_();
	}

	//-------------------------------------------------------------------------------------------------
	//    EDGE NAVIGATION OBJECT
	//-------------------------------------------------------------------------------------------------
	function cEdgeNav(vpObj) {
	    // improvements:
	    //    - combine with autopan object
	    var self = this;
	    var thisImg = vpObj; // the viewport object - the parent

	    var jVpDiv = thisImg.vpDivGet('outer');
	    var jEdgeNavDivs;

	    var edgeNavSpecs = { // edgenav settings
	        'dim': 29 // = the toolbar height
	    };
	    //............................................ resize() public
	    // This function positions and sizes the edge navigation divs in the viewport.
	    this.resize = function () {
	        if (_defines2.default.ENABLEAUTOPAN == false) return;
	        var vpDivDims = thisImg.vpDivDimsGet();
	        var w = vpDivDims.w,
	            h = vpDivDims.h;
	        var dim = edgeNavSpecs.dim;
	        for (var i = 0; i < jEdgeNavDivs.length; i++) {
	            var jEdgeNavDiv = jEdgeNavDivs.eq(i);
	            var side = jEdgeNavDiv.attr('side');
	            if (side == 'left') jEdgeNavDiv.css({ 'left': 0, 'top': 0, 'width': dim, 'height': h });else if (side == 'right') jEdgeNavDiv.css({ 'left': w - dim, 'top': 0, 'width': dim, 'height': h });else if (side == 'top') jEdgeNavDiv.css({ 'left': 0, 'top': 0, 'width': w, 'height': dim });else if (side == 'bottom') jEdgeNavDiv.css({ 'left': 0, 'top': h - dim, 'width': w, 'height': dim });
	        }
	    };

	    //............................................ load_() local
	    //    This function creates and adds the edge navigation divs to the viewport.
	    var load_ = function load_() {
	        if (jEdgeNavDivs) return;

	        var jEdgeNavDiv = $('<div/>', { // build the div for the left side of this viewport
	            'class': _defines2.default.clsEDGEDIV + ' ' + _defines2.default.clsOVERLAY, 'side': 'top'
	        });
	        jVpDiv.append(jEdgeNavDiv); // place the div in the vp
	        var jEdgeNavDiv = $('<div/>', { // build the div for the left side of this viewport
	            'class': _defines2.default.clsEDGEDIV + ' ' + _defines2.default.clsOVERLAY, 'side': 'left'
	        });
	        jVpDiv.append(jEdgeNavDiv); // place the div in the vp

	        var jEdgeNavDiv = $('<div/>', { // build the div for the right side of this viewport
	            'class': _defines2.default.clsEDGEDIV + ' ' + _defines2.default.clsOVERLAY, 'side': 'right'
	        });
	        jVpDiv.append(jEdgeNavDiv);

	        var jEdgeNavDiv = $('<div/>', { // build the div for the bottom side of this viewport
	            'class': _defines2.default.clsEDGEDIV + ' ' + _defines2.default.clsOVERLAY, 'side': 'bottom'
	        });
	        jVpDiv.append(jEdgeNavDiv);
	        jEdgeNavDivs = jVpDiv.find('.' + _defines2.default.clsEDGEDIV); // save for quick access

	        self.resize(); // now size the edge nav divs
	        //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~// add edge nav (autopan) event handlers
	        if (_defines2.default.ENABLEAUTOPAN == true) {
	            jEdgeNavDivs.on('click', function (e) {
	                thisImg.autoPan.onOffToggle();
	                return false;
	            });
	        }
	    };

	    //............................................ construction
	    if (_defines2.default.ENABLEAUTOPAN == false) return;
	    load_(); // load the edge nav bars
	}

	//-------------------------------------------------------------------------------------------------
	//    PROGRESSIVE RENDERING OBJECT
	//-------------------------------------------------------------------------------------------------
	// references:
	//            http://falcon80.com/HTMLCanvas/PixelManipulation/getImageData.html
	// note that the progressive view is a background view in the inner vp div, not given the overlay class
	function cProgressive(vpObj) {
	    var self = this;
	    var thisImg = vpObj; // the viewport object - the parent

	    var isLoaded = false; // progressive image (canvas or blur) has been loaded
	    var isUsingCanvas = false; // progressive using canvas on thumbnail


	    var jVpDiv = thisImg.vpDivGet(); // progressive image rotates with the inner vpDiv - do NOT attach to the outer vp div
	    var jProgImage; // the progressive image is the whole slide image loaded from the server to create the scale up views from
	    var pImageCanvas;
	    var pImageContext;

	    var jProgView; // progressive view is a swatch from the progImage scaled to the view size
	    var pViewCanvas;
	    var pViewContext;

	    var csProgImage = new _objects.cSize(0, 0); // progressive image size
	    var progImageZoom_; // progressive image zoom

	    // image swatch / blur image related
	    var timerId = -1; // imer for fetching the blur image swatch
	    var progCenterView; // last view center
	    var progCount = 0; // cyclic call count

	    // fill background color related
	    var backColorIdx = -1; // index into us.vpBackColors
	    var backColors = [// array of colors to use for viewport background on refresh
	    '#ddddee', // lavender
	    '#ebe6dd', // linen
	    '#eff4ff', // light blue
	    '#d1d4df', // gray
	    '#eee6ee', // pink gray
	    '#f1eae3' // tanish gray
	    ];

	    var progSpecs = { // progressive rendering specs
	        'timerInterval': 5000, // timer interval in milliseconds for blur progressive
	        'maxSkipCount': 5, //
	        'minMag': 1.0, //
	        'blurScale': 60, //
	        'blurZoom': 0.25, //
	        'progImageDimMax': 2000, // Aperio imageserver limits jpeg w,h to 2000
	        'progImageDimMax4IOS': 1000 // reduced size assuming ios device has less spare memory
	    };

	    //............................................ show() public
	    //    This function is for debug.  It shows/hides the current progressive view.
	    this.show = function (show) {
	        if (_defines2.default.ENABLEPROGRESSIVE == true && jProgView != undefined) {
	            //debug-only thisImg.log(".....progressive: show: " + show);
	            if (show == true) jProgView.show();else jProgView.hide();
	        }
	    };
	    //............................................ progIsAvailable() public
	    //    This function indicates if the progressive canvas image is available
	    this.progIsAvailable = function () {
	        return isUsingCanvas;
	    };

	    //............................................ progShowViewDBG() public
	    //    This function is for debug.  It shows/hides the current progressive view by moving its z-index.
	    this.progShowViewDBG = function (show) {
	        this.show(true); //note: since this is only a debug mode option, just make sure the view is not hidden in the first place
	        if (show == false) {
	            jProgView.removeClass(_defines2.default.clsOVERLAY);
	        } else {
	            jProgView.addClass(_defines2.default.clsOVERLAY);
	        }
	    };
	    //............................................ progShowImageDBG() public
	    //    This function is for debug.  It shows/hides the current progressive imageby moving its z-index.
	    this.progShowImageDBG = function (show, xFactor, yFactor) {
	        if (show == false) {
	            jProgImage.css({ 'left': _defines2.default.kDEF_TILE_POS_PX, 'top': _defines2.default.kDEF_TILE_POS_PX });
	            jProgImage.removeClass(_defines2.default.clsOVERLAY);
	        } else {
	            var w = jProgImage.width(),
	                h = jProgImage.height();
	            var x = -xFactor * w;
	            var y = -yFactor * h;

	            jProgImage.css({ 'left': x + 'px', 'top': y + 'px' });
	            jProgImage.addClass(_defines2.default.clsOVERLAY);
	        }
	    };
	    //............................................ saveViewToFile() public
	    //    /////////////////////////////////////////////////////////////////////////////////////////////////////
	    // snapshot experiment
	    //    this.saveViewToFile = function () {

	    //        jProgView.attr("download", "test.jpeg");// attempt to coerce filename

	    //        if (0) { //client side only, to download folder, filename is 'download', does not work in ie..
	    //            //   http://www.nihilogic.dk/labs/canvas2image/
	    //            Canvas2Image.saveAsJPEG(pViewCanvas); // will prompt the user to save the image as JPEG
	    //            //Canvas2Image.saveAsPNG(pViewCanvas, false, 100, 100); //scales
	    //        }
	    //        if (0) {
	    //            // http://greenethumb.com/article/1429/user-friendly-image-saving-from-the-canvas/
	    //            //use with server side ... works in all cavas-able browsers, writes to download folder,
	    //            //var data = pViewCanvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
	    //            //window.location.href = data;
	    //        }
	    //    };

	    //    /////////////////////////////////////////////////////////////////////////////////////////////////////
	    //............................................ refresh() public
	    //    This function displays the progressive view.
	    //    If the thumbnail-based (in a canvas div) progressive image is available, it is used.
	    //    otherwise the blur progressive image is presented.
	    //    If progressive is not enabled or those images were not loaded, the background color is changed from
	    //    a predefined set instead. If progressive is enabled but the magnification is very low,
	    //    use the appropriate BF/FL back color.

	    this.refresh = function () {
	        //debug-only thisImg.log("...progressive.refresh: viewMag: " + thisImg.getViewMag());
	        if (thisImg.getViewMag() > progSpecs.minMag) {
	            // if the magnification is not low

	            if (_defines2.default.ENABLEPROGRESSIVE == true && isLoaded == true) {
	                this.show(true); // in case the progressive image is hidden, show it
	                if (isUsingCanvas == true) progRefresh_(); // thumbnail based
	                else blurRefresh_(); //blur based
	            } else {
	                // or mag is low so set the background color to a random value
	                if (backColorIdx < 0) {
	                    // restrict to one color / image
	                    backColorIdx = Math.round(Math.random() * (backColors.length - 1));
	                    jVpDiv.css({ 'background-color': backColors[backColorIdx] });
	                }
	            }
	        } else {
	            // view mag <= progSpecs.minMag, just let background color show through
	            if (_defines2.default.ENABLEPROGRESSIVE == true) {
	                var jProgDiv = jVpDiv.find('.' + _defines2.default.clsPROGDIV);
	                jProgDiv.hide(); // hide the progressive image so that background shows
	            }
	        }
	    };
	    //............................................ imgDataGet public
	    //    This function returns the progressive image data for the specifed image region.
	    //    If the browser is not able to perform canvas operations or an error occurs, it returns 'undefined'.

	    this.imgDataGet = function (viewLeftBase, viewTopBase, zoom, csVPDivDims) {
	        var imgData;
	        if (isUsingCanvas == false) // browser not able to do canvas operations?
	            return imgData; // return undefined

	        var cropLeft = Math.round(viewLeftBase / progImageZoom_); // define the grid cell location in the progressive image
	        var cropTop = Math.round(viewTopBase / progImageZoom_);

	        var cropWidth = parseInt(1 + csVPDivDims.w * zoom / progImageZoom_);
	        var cropHeight = parseInt(1 + csVPDivDims.h * zoom / progImageZoom_);
	        cropWidth = cropLeft + cropWidth < csProgImage.w ? cropWidth : csProgImage.w - cropLeft - 1;
	        cropHeight = cropTop + cropHeight < csProgImage.h ? cropHeight : csProgImage.h - cropTop - 1;

	        // Note: using try/catch is being extra careful because of cross origin issues with canvas.getImageData
	        //        - the cross-origin in its load should resolve all issues, but can still fail if url uses 'localhost'
	        try {
	            // get the image data at this grid region
	            imgData = pImageContext.getImageData(cropLeft, cropTop, cropWidth, cropHeight); // get image data at crop region from canvas
	        } catch (e) {
	            thisImg.log('imgDataGet: canvas catch');
	            return imgData;
	        }
	        //debug-only thisImg.log("imgDataGet: zoom: " + zoom + "  Crop LT: " + cropLeft + "," + cropTop + "  Crop WxH: " + cropWidth + "x" + cropHeight);
	        return imgData;
	    };
	    //............................................ progRefresh_() local
	    //    This function updates the progressive view from the progressive image in the canvas div.

	    var progRefresh_ = function progRefresh_() {
	        if (_defines2.default.ENABLEPROGRESSIVE == false || isLoaded == false) return; // if progressive is not enabled, return
	        //debug-refresh var progTime = new Date();

	        var cpRotOffset = thisImg.getRotationOffset();
	        var cpRotLT = new _objects.cPoint(thisImg.getViewLeft() + cpRotOffset.x, thisImg.getViewTop() + cpRotOffset.y);

	        var vpDivDims = thisImg.vpDivDimsGet();
	        var csVPRotDivDims = new _objects.cSize(vpDivDims.w - 2 * cpRotOffset.x, vpDivDims.h - 2 * cpRotOffset.y);
	        var zoom = thisImg.getViewZoom();

	        pViewCanvas.width = csVPRotDivDims.w; // set the progressive view to the viewport size
	        pViewCanvas.height = csVPRotDivDims.h;

	        var scale = progImageZoom_ / thisImg.getViewZoom(); // compute the view rect in the progImage and the scaling of the rect to view size

	        //debug-only thisImg.log("progRefresh_: view LT: " + thisImg.getViewLeft() + "," + thisImg.getViewTop() + "  view offset: " + cpRotOffset.toString());
	        //debug-only thisImg.log("progRefresh_: view dims: " + vpDivDims.w + "x" + vpDivDims.h);

	        try {
	            var imgData = self.imgDataGet(cpRotLT.x, cpRotLT.y, zoom, csVPRotDivDims);
	            if (imgData == undefined) {
	                thisImg.log('progRefresh_: canvas fault');
	                return;
	            }

	            var tempCanvas = $('<canvas/>').get(0); // must move the imgData into a canvas so it can be used below by drawImage()
	            tempCanvas.width = csVPRotDivDims.w;
	            tempCanvas.height = csVPRotDivDims.h;
	            tempCanvas.getContext('2d').putImageData(imgData, 0, 0);

	            pViewContext.scale(scale, scale); // put the cropped region into the view canvas and scale it up to the view size
	            pViewContext.drawImage(tempCanvas, 0, 0);

	            jProgView.css({ left: cpRotOffset.x, top: cpRotOffset.y }); // set the LT corner of the progressive view
	        } catch (e) {
	            isUsingCanvas = false;
	            isLoaded = false; // disable progressive image if an error occurs
	            jProgImage.remove(); // remove the canvas
	            jProgImage = undefined;
	            blurFetchStart_(); // start fake progressive
	            thisImg.err('progressive:progRefresh_: Error caught - disabling progressive canvas view');
	        }
	        //debug-only thisImg.log("progRefresh_: " + "  Canvs WxH: " + imgData.width + "x" + imgData.height);
	        //dbg-refresh     thisImg.log("progressive: progRefresh_: " + ((new Date()) - progTime).toFixed(1));
	    };
	    //............................................ blurRefresh_() local
	    //    This function updates the progressive view from the blur image.
	    var blurRefresh_ = function blurRefresh_() {
	        if (_defines2.default.ENABLEPROGRESSIVE == false || isLoaded == false) return; // if progressive is not enabled, return
	        //thisImg.log("blurRefresh_");
	        var jProgDiv = jVpDiv.find('.' + _defines2.default.clsPROGDIV); // or show the fake progressive view
	        jProgDiv.show();

	        var jImg = jProgDiv.find('img');
	        if (jImg && jImg.length > 0) {
	            var vpDivDims = thisImg.vpDivDimsGet();
	            var vpW = vpDivDims.w,
	                vpH = vpDivDims.h;

	            if (jImg.width() != vpW || jImg.height() < vpH) {
	                if (_defines2.default.DBGPROGRESSIVE) thisImg.log('progressive.blurRefresh_: scaling view: ' + jImg.width() + 'x' + jImg.height() + ' --> ' + vpW + 'x' + vpH);
	                jImg.width(vpW).height(vpH);
	            }
	        }
	    };
	    //............................................ blurFetchStart_() public
	    //    This function starts a timer to periodically request an updated blur image.
	    var blurFetchStart_ = function blurFetchStart_() {
	        if (timerId == -1) {
	            blurFetch_(true); // load the first progressive rendering image now and get its timer started

	            timerId = setInterval(function () {
	                if (isLoaded) blurFetch_();
	            }, progSpecs.timerInterval);
	            if (_defines2.default.DBGPROGRESSIVE || _defines2.default.DBGSTART) thisImg.log('...startBlurFetch');
	        }
	    };
	    //............................................ blurFetchStop_() public
	    //    This function stops the blur image timer.
	    this.blurFetchStop_ = function () {
	        if (timerId != -1) {
	            clearInterval(timerId); // stop the progressive timer
	            timerId = -1;
	            if (_defines2.default.DBGPROGRESSIVE) thisImg.log('...blurFetchStop_');
	        }
	    };
	    //............................................ blurFetch_() local
	    //    This function performs a poor man's substitute to create a progressive image.
	    //    It requests a small region of pixels at the center of the current view to display in the background
	    //    of the view.  This is used when a browser does not support canvas.

	    var blurFetch_ = function blurFetch_(bForce) {
	        ////was vpProgressiveRefresh
	        if (_defines2.default.ENABLEPROGRESSIVE == false) return; // if progressive is not enabled, return
	        //thisImg.log("blurFetch_");

	        if (jVpDiv.find('.' + _defines2.default.clsPROGDIV).length == 0) {
	            // if this viewport does not yet have a progressive div, make it
	            var jProgDiv = $('<div/>', { 'class': _defines2.default.clsPROGDIV });
	            jVpDiv.append(jProgDiv);
	        }

	        // update the prog image if force is applied or if it hasn't been updated in maxSkips tries,
	        //    or the view has moved sufficiently and when the magnfication warrants it
	        progCount = (progCount + 1) % progSpecs.maxSkipCount;
	        if (progCount == 0) {
	            if (_defines2.default.DBGPROGRESSIVE) thisImg.log('progressive.blurFetch_: new view request, exceeded the skip count.');
	            bForce = true;
	        }
	        var cpCenterView = thisImg.getViewCenter(); // get current center of view
	        if (bForce == false) {
	            var viewDist = cpCenterView.cityBlockDistance(progCenterView);
	            var minDist = parseInt(thisImg.getViewWidth() * 2 / thisImg.getViewZoom());
	            if (viewDist < minDist) {
	                if (_defines2.default.DBGPROGRESSIVE) thisImg.log('progressive.blurFetch_: new view unnecessary,  distance: ' + viewDist + ' < ' + minDist);
	                return;
	            }
	            if (_defines2.default.DBGPROGRESSIVE) thisImg.log('progressive.blurFetch_: new view reqeust,  distance: ' + viewDist + '  > ' + minDist);

	            if (thisImg.getViewMag() < progSpecs.minMag) {
	                if (_defines2.default.DBGPROGRESSIVE) thisImg.log('progressive.blurFetch_: new view unnecessary, current mag: ' + thisImg.getViewMag() + ' < ' + progSpecs.minMag);
	                return;
	            }
	        }
	        //optional improvement ---- if force and center dist isn't much, jitter it some!

	        progCount = 0;
	        progCenterView = cpCenterView; // update last center  of view with current

	        var w = parseInt(thisImg.getViewWidth() / progSpecs.blurScale);
	        var h = parseInt(w * thisImg.getViewHeight() / thisImg.getViewWidth());

	        // build the url
	        // append a leading 0 to the requested coordinates so they are interpreted by ImageServer as relative to the image base coords
	        var sProgImgSrc = thisImg.urlBuilder.region('0' + cpCenterView.x, '0' + cpCenterView.y, w, h, progSpecs.blurZoom);
	        // if (us.DBGPROGRESSIVE) thisImg.log("progressive:load: src: " + sProgImgSrc); // /imageserver/@2?0+0+1956+1628+27

	        var jImg = $('<img/>', { // place the labelImg in the DOM's label div
	            load: function load(e) {
	                // check that this viewport's imageId === this image source's imageId
	                var srcId = getImageIdFromSrcAttr(e.currentTarget); // format "@2"
	                if (thisImg.getImageId() !== srcId) {
	                    // if they don't match, do not load this XXX (async return from another image!)
	                    thisImg.log('...progressive.blurFetch_:load: vpDiv id=' + thisImg.getImageId() + '  srcId=' + srcId + ' - skipping load!!');
	                    return;
	                }
	                var jProgDiv = jVpDiv.find('.' + _defines2.default.clsPROGDIV);
	                var jImg = jProgDiv.find('img');
	                if (jImg.length) jImg.remove(); // remove the old progressive image
	                jProgDiv.append(e.currentTarget); // and place the progImg in the DOM's prog's div in the viewport

	                var jImg = jProgDiv.find('img'); // scale the returned image

	                var vpW = jVpDiv.width();
	                var vpH = jVpDiv.height();
	                jImg.width(vpW).height(vpH);

	                isLoaded = true;
	                if (_defines2.default.DBGPROGRESSIVE) thisImg.log('progressive.blurFetch_: scaling view: ' + jImg.width() + 'x' + jImg.height() + ' --> ' + vpW + 'x' + vpH + '  center: ' + progCenterView.toString());
	            },
	            error: function error(e) {
	                thisImg.log('progressive.blurFetch_: image load error');
	            },
	            'class': _defines2.default.clsPROGIMG,
	            'src': sProgImgSrc,
	            'alt': ''
	        });
	    };

	    //............................................ progLoad_() local
	    //    This function sizes and loads the progressive thumbnail image into a canvas tag.
	    //    If the browser is not able to perform canvas operations, the image cannot be loaded
	    //    and status() for this object will return false.
	    //    Note: this id approach assumes the same image is not opened twice - fix that with a random value

	    var progLoad_ = function progLoad_() {
	        if (_uScope2.default.instance.isThisImageIdValid(thisImg.getImageId()) == false) {
	            // protect against rapid slide close/open sequence
	            thisImg.err('progLoad_: image is not loaded');
	            return;
	        }

	        // if this image has no thumbnail or the browser does not support canvas, return
	        if (thisImg.hasAThumbnail() == false || _defines2.default.supportsCanvas == false || isLoaded == true) {
	            return;
	        }

	        var vpclassid = _defines2.default.classFromImageId(thisImg.getImageId()); // convert the imageId into a class name
	        var progViewId = _defines2.default.PROGVIEW + '_' + vpclassid; // unique ids for the progressive divs
	        var progImageId = _defines2.default.CVSPROGIMAGE + '_' + vpclassid;
	        var progImageTagId = _defines2.default.IMGPROG + '_' + vpclassid;

	        // create the progressive view canvas tag where cropped pieces of the progressive image will be sized and displayed in the background
	        jProgView = $('<canvas/>', { 'id': progViewId, 'class': _defines2.default.PROGVIEW, css: { 'left': '0px', 'top': '0px' } });
	        jVpDiv.append(jProgView); // place the prog view canvas in its viewport

	        jProgView = jVpDiv.find('#' + progViewId);
	        pViewCanvas = document.getElementById(progViewId);
	        if (pViewCanvas == undefined || pViewCanvas == null) {
	            // protect against rapid slide close/open sequence that removes elements
	            thisImg.err(' progLoad_: view canvas element not present');
	            return;
	        }
	        pViewContext = pViewCanvas.getContext('2d');

	        // create the progressive image canvas tag where the progressive image will reside (whole image but small like a thumbnail)
	        jProgImage = $('<canvas/>', {
	            'id': progImageId, 'class': _defines2.default.CVSPROGIMAGE,
	            css: { 'left': _defines2.default.kDEF_TILE_POS_PX, 'top': _defines2.default.kDEF_TILE_POS_PX, 'overflow': 'hidden' }
	            //dbg-only use this if you want to see the canvas     css: { "left": "0px", "top": "0px", "overflow": "hidden", "z-index": 1001 }
	        });
	        jVpDiv.append(jProgImage); // place the prog image canvas in its viewport
	        jProgImage = jVpDiv.find('#' + progImageId);

	        pImageCanvas = document.getElementById(progImageId);
	        pImageContext = pImageCanvas.getContext('2d');

	        var csImgDims = thisImg.getImageDims(); // compute progressive image width, height and zoom
	        var maxDim = _compatibility.BrowserDetect.isIOS() ? progSpecs.progImageDimMax4IOS : progSpecs.progImageDimMax; // enforce a max dimension limit
	        progImageZoom_ = parseInt(Math.ceil(Math.max(csImgDims.w, csImgDims.h) / maxDim));
	        csProgImage.set(parseInt(csImgDims.w / progImageZoom_), parseInt(csImgDims.h / progImageZoom_));

	        if (_defines2.default.DBGPROGRESSIVE) thisImg.log('progLoad_: Image dims: ' + csImgDims.w + ',' + csImgDims.h + '  Progressive image dims: ' + csProgImage.w + ',' + csProgImage.h + '  zoom: ' + progImageZoom_);

	        var sProgImgSrc = thisImg.urlBuilder.region(0, 0, csProgImage.w, csProgImage.h, progImageZoom_); // build the url
	        // if (us.DBGPROGRESSIVE) thisImg.log("progLoad_: src: " + sProgImgSrc); // /imageserver/@2?0+0+1956+1628+27

	        var jImg = $('<img/>', { // load the prog image into its canvas tag
	            'crossOrigin': 'Anonymous', // so direct imageserver accessed prog image can use canvas.getImageData
	            load: function load(e) {
	                // check that this viewport's imageId === this image source's imageId
	                var srcId = getImageIdFromSrcAttr(e.currentTarget); // format "@2"
	                if (thisImg.getImageId() !== srcId) {
	                    // if they don't match, do not load this thumbnaail (async return from another image!)
	                    thisImg.log('...progressive: load(' + thisImg.getImageId() + ')  srcId=' + srcId + ' - skipping load!!');
	                    return;
	                }
	                if (_defines2.default.DBGPROGRESSIVE) thisImg.log('progLoad_: Thumbnail image loaded');

	                jProgImage.append(e.currentTarget); // place the thumbnail image in the canvas div - even though I still have to draw it there
	                pImageCanvas.width = csProgImage.w; // and size the canvas
	                pImageCanvas.height = csProgImage.h;

	                var imgTag = document.getElementById(progImageTagId); // get the html element
	                if (imgTag != null) {
	                    // if it is valid - race conditions can occur where the vp was removed and this tag does not exist!
	                    pImageContext.drawImage(imgTag, 0, 0, pImageCanvas.width, pImageCanvas.height); // then draw the image into it
	                    if (_defines2.default.DBGPROGRESSIVE) thisImg.log('progressive: progLoad_(' + thisImg.getImageId() + '): progressive Image Dims: ' + pImageCanvas.width + ' x ' + pImageCanvas.height);
	                    isLoaded = true;
	                } else {
	                    // the progressive image can return for the prior image so do not disable progressive operations here
	                    thisImg.err('progLoad_: canvas element not present: ' + progImageTagId); // protect against rapid slide close/open sequence
	                }
	            },
	            error: function error(e) {
	                thisImg.err('progressive: load: Disabling progressive canvas view');
	                jProgImage.remove(); // remove the canvas
	                blurFetchStart_(); // start fake progressive
	            },
	            'id': progImageTagId, 'src': sProgImgSrc, 'alt': ''
	        });
	        isUsingCanvas = true;
	    };

	    //............................................ construction
	    if (_defines2.default.ENABLEPROGRESSIVE == false) return; // if progressive is not enabled, return
	    progLoad_(); // load the progressive image
	}

	//________________________________________________________________________________________________

	//-------------------------------------------------------------------------------------------------
	// MISCELLANEOUS FUNCTIONS
	//-------------------------------------------------------------------------------------------------
	// getImageIdFromSrcAttr - This function returns the image id encoded into the passed event's src attribute
	//            or undefined if it is not found. The returned image id has the @ sign prepended to it.
	function getImageIdFromSrcAttr(event) {
	    var id;
	    var srcAttr = $(event).attr('src'); // source attribute e.g. "/@2?0+0+122+122+-2"
	    var at = srcAttr.lastIndexOf('@');
	    var q = srcAttr.indexOf('?');
	    if (at !== -1 && q !== -1) id = srcAttr.slice(at, q);
	    return id;
	}

	//-------------------------------------------------------------------------------------------------
	// objectiveColor - This function returns the industry standard color associated with a given magnification.
	//    References:
	//         color codes for objective lens:
	//        http://zeiss-campus.magnet.fsu.edu/tut  orials/objectivecolorcoding/
	_defines2.default.objectiveColors = [];
	_defines2.default.objectiveColor = function (mag) {
	    var white = '#808080'; // because of BF and FL white and black backgrounds, change white color code to gray

	    if (_defines2.default.objectiveColors.length == 0) {
	        // fill in the objective color array
	        _defines2.default.objectiveColors.push({ 'mag': 100, color: white }); // White
	        _defines2.default.objectiveColors.push({ 'mag': 83, color: white }); // White
	        _defines2.default.objectiveColors.push({ 'mag': 80, color: white }); // White

	        _defines2.default.objectiveColors.push({ 'mag': 63, color: '#0B4EA2' }); // Cobalt Blue
	        _defines2.default.objectiveColors.push({ 'mag': 60, color: '#0B4EA2' }); // Cobalt Blue

	        _defines2.default.objectiveColors.push({ 'mag': 50, color: '#007DC5' }); // Light Blue
	        _defines2.default.objectiveColors.push({ 'mag': 40, color: '#007DC5' }); // Light Blue

	        _defines2.default.objectiveColors.push({ 'mag': 32, color: '#10B050' }); // Green
	        _defines2.default.objectiveColors.push({ 'mag': 25, color: '#10B050' }); // Green

	        _defines2.default.objectiveColors.push({ 'mag': 20, color: '#00aa00' }); // Green
	        _defines2.default.objectiveColors.push({ 'mag': 16, color: '#10B050' }); // Green

	        _defines2.default.objectiveColors.push({ 'mag': 10, color: '#FFFF00' }); // Yellow

	        _defines2.default.objectiveColors.push({ 'mag': 6, color: '#FEB811' }); // Orange
	        _defines2.default.objectiveColors.push({ 'mag': 5, color: '#990033' }); // changed from original value of "#EF3449" to distinguish mag 4 and pyramid level mag 5 // Red
	        _defines2.default.objectiveColors.push({ 'mag': 4, color: '#EF3449' }); // Red

	        _defines2.default.objectiveColors.push({ 'mag': 2.5, color: '#A78D2C' }); // Brown
	        _defines2.default.objectiveColors.push({ 'mag': 2, color: '#A78D2C' }); // Brown

	        _defines2.default.objectiveColors.push({ 'mag': 1.25, color: '#231F20' }); // Black
	        _defines2.default.objectiveColors.push({ 'mag': 1.5, color: '#231F20' }); // Black
	        _defines2.default.objectiveColors.push({ 'mag': 1, color: '#231F20' }); // Black
	    }

	    for (var i = 0, clen = _defines2.default.objectiveColors.length; i < clen; i++) {
	        if (_defines2.default.objectiveColors[i].mag == mag) return _defines2.default.objectiveColors[i].color;
	    }
	    return white;
	};

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _defines = __webpack_require__(3);

	var _defines2 = _interopRequireDefault(_defines);

	var _events = __webpack_require__(10);

	var _uScope = __webpack_require__(11);

	var _uScope2 = _interopRequireDefault(_uScope);

	var _helpers = __webpack_require__(8);

	var _toolbar = __webpack_require__(5);

	var _pluginService = __webpack_require__(19);

	var _pluginService2 = _interopRequireDefault(_pluginService);

	var _eventChannel = __webpack_require__(20);

	var _eventChannel2 = _interopRequireDefault(_eventChannel);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var publicApi = {};

	function tryRun(command) {
	    var args = [].splice.call(arguments, 1);
	    if (uScope && uScope[command]) {
	        return uScope[command].apply(uScope, args);
	    }
	    return false;
	}

	// TODO: Not sure what to do with this singleton...
	var uScope = void 0;

	//............................................ navigateTo() public
	//    navigateTo - This function positions the image(s) at the specified x,y,z and magnification.
	//                        Note that magnification must be valid.
	publicApi.navigateTo = function (imgSettings) {
	    return tryRun('navigateTo', imgSettings);
	};

	//............................................ goToRegion() public
	//    goToRegion - This function positions the image at a region and selects it.
	//        The passed imageId must already be open.
	// TODO: VIL should do this itself
	publicApi.goToRegion = function (imageId, regionId) {
	    (0, _events.triggerUScopeEvent)(_defines2.default.evREGIONSELECT, {
	        imageId: imageId,
	        regionId: regionId,
	        bReposition: true,
	        bSaveSel: false
	    });
	    return true;
	};

	//............................................ getImageState() public
	//    getImageState - This function returns the state of uScope's images.
	publicApi.getImageState = function () {
	    return tryRun('getStateArray');
	};

	//............................................ resize() public
	// resize - This function reconfigures the viewer to fit within its root div.
	//    parameters:
	//        e : optional, event data. When called by the container, no event is passed.
	publicApi.resize = function (e) {
	    if ((0, _helpers.isDefined)(e)) {
	        var sTargetClass = $(e.target).first().attr('class');
	        if (_defines2.default.DBGRESIZE) (0, _toolbar.consoleWrite)('uScopeResize: targetClass = ' + sTargetClass + ' (will not perform resize)');
	        if ((0, _helpers.isDefined)(sTargetClass)) // because in FF, resize bubbles here first and then to resizables like the scaleBar
	            return; // and that means that layout.refresh is called unnecessarily
	    }

	    return tryRun('resize'); // update root div position and dims
	};

	//............................................ imageUpdate() public
	// imageUpdate - This function adds, removes, and replaces images in uScope.
	//
	//    usage:
	//        imageUpdate("add", jsonSettings);                        adds a new view of the image specified in jsonSettings
	//        imageUpdate("remove", jsonSettings);                    removes the view of the image specified in jsonSettings
	//        imageUpdate("replace", jsonOrig, jsonSettingsNew);    replaces jsonOrig image with jsonSettingsNew image
	//        imageUpdate("replace", jsonSettings);                    replaces the single unpinned image with the image specified in jsonSettings
	//        imageUpdate("state", jsonStateChange);                changes the state (pinned, sampleType) of the image in jsonSettings
	//
	//    where:
	//        jsonSettings and opt_jsonSettings are in image setting format
	//            (image or images subset of settings into uScopeStart())
	//
	//        jsonStateChange image setting format for sampleTyle change
	//            this will do:  { "imagePath": "@2", "sampleType": "positive", "isPinned": true}
	//                where only those states that changed need be indicated
	//
	publicApi.imageUpdate = function (action, jsonSettings, opt_jsonSettings) {
	    return tryRun('imageUpdate', action, jsonSettings, opt_jsonSettings);
	};

	//............................................ closeDialogs() public
	// closeDialogs - This function closes all of uScope's dialogs.
	publicApi.closeDialogs = function () {
	    // always verify this works with Use Case: HC change from one case to another and back again
	    var jPanels = $(document.body).find('.' + _defines2.default.clsPANEL); // all uscope panels have this class
	    jPanels.each(function (index) {
	        // Note: MUST use === true below: if you call dialog("isOpen") on an element that is not yet a dialog,
	        //    it returns an object. In IE8, this is interpreted as true
	        if ($(this).dialog('isOpen') === true) {
	            //debug - only     consoleWrite("uScopeCloseDialogs: closing: " + this.id);
	            $(this).dialog('close');
	        }
	        //debug - only     consoleWrite("uScopeCloseDialogs: removing: " + this.id);
	        ///        $(this).remove();
	    });
	    jPanels.remove(); //remove all panels from the DOM
	};

	//............................................ lockDown() public
	// lockDown - This function sets the viewer's state into /out-of  lock down mode.
	publicApi.lockDown = function (on) {
	    if (!uScope) {
	        return;
	    }
	    uScope.setInLockDownMode(on);
	};

	//............................................ stop() public
	//    stop - This function stops uScope by closing all images and all open dialogs.
	//todo: should probably remove the toolbar
	publicApi.stop = function () {
	    if (!uScope) {
	        return;
	    }
	    (0, _toolbar.consoleWrite)('uScopeStop called');
	    uScope.destroy();
	    publicApi.closeDialogs();
	    uScope = undefined;
	};

	//............................................ start() public
	//    start - This function starts up uScope.
	//
	publicApi.start = function (settings) {
	    var startupStatus = true;

	    // Ensure uScope is a singleton, for now...
	    if (uScope instanceof _uScope2.default) {
	        return false;
	    }

	    uScope = new _uScope2.default(publicApi.events);

	    publicApi.events.trigger('vil:uScopeStart:instantiate', uScope);

	    uScope.reset();

	    // parse any passed settings including image ids and states
	    if (settings) {
	        startupStatus = uScope.parseVILSettings(settings);
	    }

	    publicApi.events.trigger('vil:uScopeStart:create', uScope);

	    startupStatus = startupStatus && uScope.init();

	    if (startupStatus === true && settings && settings.images && settings.images.length > 0) {
	        startupStatus = uScope.imageUpdate('add', settings.images);
	        //.................................................. debug / development accelerators
	        //dbg-only     if (us.DBGANNOT)       $("." + us.TBANNOTPANEL + "-e").click();
	        //dbg-only     if (us.DBGOPTIONS)     $("." + us.TBSETTINGS + "-e").click();
	    }

	    // note that 'didCompleteStartup' of false has multiple meanings: either parsing failed
	    //    or the uscope div sizing had problems or the specified image didn't open
	    return startupStatus;
	};

	publicApi.getLegacyUScope = function () {
	    return uScope;
	};

	// Add a global event channel (but don't let it bleed into the global space)
	publicApi.events = new _eventChannel2.default();

	// Create and expose the plugin service
	var plugins = new _pluginService2.default(publicApi.events);
	/**
	 * Expose the plugin system
	 * @param plugin
	 * @param options
	 */
	publicApi.use = function (plugin) {
	    if (plugin.installed) {
	        return;
	    }

	    for (var _len = arguments.length, options = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        options[_key - 1] = arguments[_key];
	    }

	    if (typeof plugin.install === 'function') {
	        plugin.install.apply(plugin, options);
	    } else if (typeof plugin === 'function') {
	        plugin.apply(null, options);
	    }

	    plugins.register(plugin);

	    plugin.installed = true;
	};
	publicApi.plugins = plugins;

	exports.default = publicApi;
	module.exports = exports['default'];

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = PluginService;

	var _lodashLite = __webpack_require__(9);

	var _ = _interopRequireWildcard(_lodashLite);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	// Question:    Is this a plugin or a module system? What's the difference?
	// Question:    Does it make sense to provide different types of extensions, e.g. "component", "service", "extension"?
	//              If so what types make sense? Consider
	//              Extension - "thing" that exposes new capability directly to core uScope components. Maybe "Thumbnail"
	//              Module - Stand alone "thing" that relies on but doesn't modify the core but can still be injected into
	//                          other "things". Maybe "Zoom Buttons" or "Settings"
	//              Service - Stand alone "thing" that does not have a public interface and therefore cannot be injected
	//                          into other "things". Maybe "performance indicator"
	//              Component / Directive - Some "thing" with a user interface
	function PluginService(events) {
	    var self = this;

	    var pluginLookup = {};

	    // Plugins will be instantiated in sequence based on dependencies and order of inclusion
	    var startupQueues = {
	        uScope: [],
	        viewport: []
	    };

	    var getDependencies = function getDependencies(plugin) {
	        return plugin.dependencies || (plugin.dependency ? [plugin.dependency] : []);
	    };

	    var getStartupIndex = function getStartupIndex(queue, plugin) {
	        var pluginIndex = -1;
	        var dependencies = getDependencies(plugin);

	        dependencies.forEach(function (dependency) {
	            var depIndex = queue.indexOf(pluginLookup[dependency]);
	            if (depIndex > pluginIndex) {
	                pluginIndex = depIndex;
	            }
	        });

	        pluginIndex++;
	        return pluginIndex;
	    };

	    var onUScopeCreated = function onUScopeCreated(uScope) {
	        var instances = {};
	        var handleStartupQueue = function handleStartupQueue(queue) {
	            for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	                args[_key - 1] = arguments[_key];
	            }

	            var getDepInstances = function getDepInstances(plugin) {
	                var dependencyList = getDependencies(plugin);
	                var dependencies = [];
	                var badDeps = [];

	                dependencyList.forEach(function (dependencyName) {
	                    var dependency = instances[dependencyName];
	                    if (!dependency) {
	                        badDeps.push(dependencyName);
	                    } else {
	                        dependencies.push(dependency);
	                    }
	                });

	                if (badDeps.length) {
	                    throw new Error('Could not locate dependencies: \'' + badDeps.join(', ') + '\' for plugin \'' + plugin.name + '\'.');
	                }

	                return dependencies.length ? args.concat(dependencies) : args;
	            };

	            queue.forEach(function (plugin) {
	                var dependencies = getDepInstances(plugin);
	                var context = Object.create(plugin.constructor.prototype);
	                plugin.constructor.apply(context, dependencies);
	                instances[plugin.name] = context;
	                // ES6 supports -> Reflect.construct(plugin.constructor, args.concat(dependencies)); We're not there yet...
	            });
	        };

	        handleStartupQueue(startupQueues.uScope, uScope);

	        uScope.events.on('uscope:image:init', function (viewport) {
	            viewport.events.on('viewport:initialize-layout', function () {
	                handleStartupQueue(startupQueues.viewport, uScope, viewport);
	            });
	        });
	    };

	    events.on('vil:uScopeStart:create', onUScopeCreated);

	    self.register = function (plugin) {
	        if (!plugin.name || !plugin.constructor) {
	            throw new Error('Plugins must contain `name` and `constructor` properties.');
	        }

	        var queue = startupQueues[plugin.extends];

	        if (!queue) {
	            throw new Error('Plugins must contain an `extends` property. Valid values are `uScope` or `viewport`');
	        }

	        var startupIndex = getStartupIndex(queue, plugin);

	        queue.splice(startupIndex, 0, plugin);

	        pluginLookup[plugin.name] = plugin;
	    };
	}
	module.exports = exports['default'];

/***/ },
/* 20 */
/***/ function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	// An event channel, based loosely on Backbone's implementation with some memory management ideas borrowed
	// from Angular. One problem uScope has is that events can happen in several contexts. The global space can
	// (theoretically) create multiple uScope instances. Events in each uScope instance's scope don't, for the most
	// part, care about events in another context's scope. Similarly, each uScope instance can have multiple images
	// open, and the child controls of each image don't really care about events in the other images' scope. This
	// event channel borrows from Angular's $rootscope service the ability to chain event channels.
	var EventChannel = function EventChannel() {
	    var self = this;
	    var allListeners = {};
	    var children = [];

	    /**
	     * Bind an event to a `callback` function
	     * @param {String} name - the name of the event. Since this impl is a singleton make sure it's unique!
	     * @param {Function} callback - what to do when the event is triggered
	     * @param {*} context - `this` argument for @callback
	     * @returns {Function} - handy detacher function; the equivalent of `eventChannel.off(name, callback, context)`
	     */
	    self.on = function (name, callback, context) {
	        if (!allListeners[name]) {
	            allListeners[name] = [];
	        }

	        allListeners[name].push({
	            callback: callback,
	            context: context,
	            ctx: context || this
	        });

	        return self.off.bind(null, name, callback, context);
	    };

	    /**
	     * Remove one or many callbacks
	     * @param {String} name - the name of the event
	     * @param {Function} callback - the specific handler to remove. If null removes all callbacks for the named event
	     * @param {*} context - the specific context-bound handler to remove. If null removes all callbacks for the function
	     */
	    self.off = function (name, callback, context) {
	        var retain, event, listeners, i, len;
	        if (!name && !callback && !context || !allListeners[name]) {
	            return;
	        }

	        listeners = allListeners[name];

	        allListeners[name] = retain = [];
	        if (callback || context) {
	            for (i = 0, len = listeners.length; i < len; i++) {
	                event = listeners[i];
	                if (callback && callback !== event.callback && callback !== event.callback._callback || context && context !== event.context) {
	                    retain.push(event);
	                }
	            }
	        }

	        if (retain.length === 0) {
	            delete allListeners[name];
	        }
	    };

	    /**
	     * Trigger one or many events, firing all bound callbacks. Callbacks are
	     * passed the same arguments as `trigger` is, apart from the event name
	     * @param {String} name - the name of the event to trigger
	     * @param {*} [args] - optional arguments to pass to listeners
	     */
	    self.trigger = function (name) {
	        var listeners = allListeners[name];
	        if (!listeners) {
	            return;
	        }

	        // A difficult-to-believe, but optimized internal dispatch function for
	        // triggering events. Tries to keep the usual cases speedy (most internal
	        // events have < 3 arguments).

	        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	            args[_key - 1] = arguments[_key];
	        }

	        var ev,
	            i = -1,
	            l = listeners.length,
	            a1 = args[0],
	            a2 = args[1],
	            a3 = args[2];
	        switch (args.length) {
	            case 0:
	                while (++i < l) {
	                    (ev = listeners[i]).callback.call(ev.ctx);
	                }return;
	            case 1:
	                while (++i < l) {
	                    (ev = listeners[i]).callback.call(ev.ctx, a1);
	                }return;
	            case 2:
	                while (++i < l) {
	                    (ev = listeners[i]).callback.call(ev.ctx, a1, a2);
	                }return;
	            case 3:
	                while (++i < l) {
	                    (ev = listeners[i]).callback.call(ev.ctx, a1, a2, a3);
	                }return;
	            default:
	                while (++i < l) {
	                    (ev = listeners[i]).callback.apply(ev.ctx, args);
	                }}
	    };

	    /**
	     * Create a child event channel. TODO: Consider publishing child events up the chain...
	     * @returns {EventChannel}
	     */
	    self.$new = function () {
	        var child = new EventChannel();
	        child.parent = self;
	        children.push(child);
	        return child;
	    };

	    /**
	     * Destroys all event listeners on this event channel and all its children. Use when tearing down
	     * an element. Use this to assist in the prevention of memory leaks!
	     * Note that this method doesn't actually `delete` references to its children; that's left up to
	     * the browser's garbage collector.
	     */
	    self.$destroy = function () {
	        Object.keys(allListeners).forEach(function (key, index, keys) {
	            self.off(key);
	        });
	        children.forEach(function (child) {
	            child.$destroy();
	        });
	    };
	};

	exports.default = EventChannel;
	module.exports = exports["default"];

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = cOverLayout;

	var _defines = __webpack_require__(3);

	var _defines2 = _interopRequireDefault(_defines);

	var _objects = __webpack_require__(7);

	var _helpers = __webpack_require__(8);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	//________________________________________________________________________________________________
	// overLayout.js
	//    This file contains cOverLayout, an object that places overlay objects on a viewport.
	//
	//    history
	//    1106    cperz        created
	//
	//    _______________________________________end_AIHv1/PR __________________________________________
	//    141118    cperz        moved from layout.js
	//________________________________________________________________________________________________
	//    Object Name: cOverLayout
	//    Overview: This object performs layout management for all overlayed visuals in the viewports.
	//    Its purpose is to facilitate the placement of or moving of these visuals when new
	//    visuals are added or when the viewport is repainted.
	//  Upon any change the state vector object for the viewport is informed. //cp-reword me!!!
	//
	//    Associated Panel: o todo
	//
	//    Dependencies and Supporting objects: o todo
	//
	//    Assumptions: o todo
	//
	//    Limitations: o todo
	//
	//    Terms Used: o todo
	//
	//    Functionality: o todo
	//
	//    Data Structures: o todo
	//
	//    HTML: o todo
	//
	//    References: o todo
	//
	//    Notes:
	//        An element's layout array contains = {
	//                divClass: "us.clsDIVLABEL",    - the class of the object; used to find it in the viewport div
	//                                                there must be only one item with this class per viewport
	//                precinct: "BR"                 - general location: "BR" (bottom right), "TL" (top left), "C" (center)
	//                                                "BL", "TR", ...
	//                order: 0                    - when more than one item vies for position, what horizontal order to place them;
	//                                                see the note below regarding Flow Order Scheme.
	//                bottomOffset: NUM            - a y offset to apply to the position
	//                rightOffset: NUM            - an x offset to apply to the position
	//                canBePlaced: true            - if false, reposition only if the element is not fully contained in the viewport (e.g. resize event)
	//                }
	//
	//        Flow Order Scheme: the order designations indicate a flow order from the corner of
	//                            the precinct (e.g. TL) towards the viewport center
	//
	//        "TL"                                      "TR"
	//        ==============================================
	//        =  0 1 2                              2 1 0  =
	//        =                                            =
	//        =                                            =
	//        =               Viewport                     =
	//        =                                            =
	//        =  0 1 2                              2 1 0  =
	//        ==============================================
	//        "BL"                                      "BR"
	//
	//
	//todo: in the future provide for vertical flow control
	//todo: instead of using kOVERLAY_ELEMENT_SPACE, set overlay element space in css
	//todo: rename bottomOffset and rightOffset to x and y, the sign is a little odd too
	function cOverLayout(viewport) {
	    var self = this;
	    var jVpDiv = viewport.vpDivGet('outer');

	    // Note that the queue holds refs to the original item so changes can be made to the original item
	    var queue = []; // the list of overlay visuals

	    var precincts_ = ['TL', 'TR', 'BL', 'BR', 'C']; // precincts implemented

	    //............................................ reset() public
	    self.reset = function () {
	        queue.length = 0;
	    };

	    //............................................ add() public
	    //    add - This function adds a new visual object. Upon call the item must be in the DOM,
	    //            perhaps off screen (at us.kDEF_TILE_POS). It returns true for success, false otherwise.
	    self.add = function (divLayout) {
	        if ((0, _helpers.isUnDefined)(divLayout) || (0, _helpers.isUnDefined)(divLayout.divClass) || (0, _helpers.isUnDefined)(divLayout.precinct)) //cp-check for others?
	            return false;

	        if (getIndex_(divLayout.divClass) < 0) // if the divLayout is not already in the queue, add it
	            queue.push(divLayout); // Note that the queue holds refs to the original item
	        // so changes can be made to the original item

	        var ok = self.refresh(divLayout.precinct); // and update the position of the item
	        if (_defines2.default.DBGLAYOUT) viewport.log('cOverLayout:added ' + divLayout.divClass);
	        return true;
	    };

	    //............................................ refresh() public
	    // refresh - This functions updates the positions of all visual objects in the queue
	    self.refresh = function () {
	        //debug-only viewport.log("cLayout: refresh:");
	        for (var p = 0, plen = precincts_.length; p < plen; p++) {
	            var aPrecinct = precincts_[p]; // refresh this precinct
	            self.refreshPrecinct(aPrecinct);
	        }
	    };

	    //............................................ refreshPrecinct() public
	    // refreshPrecinct - This functions updates the positions of all visual objects in the passed precinct.
	    self.refreshPrecinct = function (aPrecinct) {
	        var vpDivDims = viewport.vpDivDimsGet();
	        var vpWidth = vpDivDims.w,
	            vpHeight = vpDivDims.h;
	        //debug-only viewport.log("cLayout: refresh: precinct: " + aPrecinct + "  vpDims: " + vpWidth + "x" + vpHeight);

	        var list = getSamePrecinct_(aPrecinct); // collect a flow-order list of indices into the queue of elements in this precinct

	        if (list.length > 0) {
	            // if there are elements to arrange
	            var prevDivWidth = 0,
	                prevDivHeight = 0;
	            for (var i = 0, llen = list.length; i < llen; i++) {
	                // for this element in this precinct
	                var idx = list[i].origIdx;
	                var jthisDiv = jVpDiv.find('.' + queue[idx].divClass);

	                if (jthisDiv.is(':visible') == false) continue;

	                // if this element does not want to move, if it is in the view then do not reposition it
	                if (queue[idx].canBePlaced != undefined && queue[idx].canBePlaced == false) {
	                    //debug-only viewport.log("....." + queue[idx].divClass + "    canBePlaced: " + queue[idx].canBePlaced);
	                    var offset = jthisDiv.offset(); // is this element is fully contained in the viewport?
	                    if (offset.left + jthisDiv.width() > vpWidth && offset.top + jthisDiv.height() > vpHeight) queue[idx].canBePlaced = true; // no, then re-enable positioning of the element
	                    else continue; // yes, then don't reposition
	                }

	                var divWidth = jthisDiv.outerWidth(true); // this element's outer dimensions
	                var divHeight = jthisDiv.outerHeight(true);

	                var bottomOffset = queue[idx].bottomOffset || 0;
	                var rightOffset = queue[idx].rightOffset || 0;

	                var cpPos = new _objects.cPoint(0, 0); // the relative position in the viewport to place the element

	                // determine the desired position for the object;  note that viewport left,top not used, all placement is relative
	                if (queue[idx].precinct == 'TL') cpPos.set(_defines2.default.kOVERLAY_ELEMENT_SPACE * (i + 1) + prevDivWidth + rightOffset, _defines2.default.kOVERLAY_ELEMENT_SPACE + bottomOffset);else if (queue[idx].precinct == 'TR') cpPos.set(vpWidth - divWidth - prevDivWidth - (i + 1) * _defines2.default.kOVERLAY_ELEMENT_SPACE - rightOffset, _defines2.default.kOVERLAY_ELEMENT_SPACE + bottomOffset);else if (queue[idx].precinct == 'BR') cpPos.set(vpWidth - divWidth - prevDivWidth - (i + 1) * _defines2.default.kOVERLAY_ELEMENT_SPACE - rightOffset, vpHeight - divHeight - +_defines2.default.kOVERLAY_ELEMENT_SPACE - bottomOffset);else if (queue[idx].precinct == 'BL') cpPos.set(_defines2.default.kOVERLAY_ELEMENT_SPACE * (i + 1) + prevDivWidth + rightOffset, vpHeight - divHeight - +_defines2.default.kOVERLAY_ELEMENT_SPACE - bottomOffset);else if (queue[idx].precinct == 'C') {
	                    cpPos.set(Math.round((vpWidth - divWidth) / 2), Math.round((vpHeight - divHeight) / 2));
	                }
	                cpPos.toInt(); // set the left,top position for this element
	                jthisDiv.css({ 'left': cpPos.x + 'px', 'top': cpPos.y + 'px' });

	                prevDivWidth += divWidth; // accumulate the previous elements' dimensions
	                prevDivHeight += divHeight;

	                if (_defines2.default.DBGLAYOUT) viewport.log('.....' + queue[idx].divClass + ' precinct: ' + queue[idx].precinct + '  order: ' + queue[idx].order + ' XY:(' + cpPos.x + ',' + cpPos.y + ')' + '  WxH: ' + divWidth + 'x' + divHeight);
	            }
	        }
	    };

	    //............................................ getIndex_() local
	    //  getIndex_ - This function returns the index to the item whose name matches the value,
	    var getIndex_ = function getIndex_(theObjClass) {
	        // return -1 if no match is found
	        for (var i = 0, qlen = queue.length; i < qlen; i++) {
	            if (queue[i].divClass == theObjClass) return i;
	        }
	        return -1;
	    };
	    //............................................ getSamePrecinct_() local
	    // getSamePrecinct_ - This function returns an array of indices with precincts of the passed divLayout
	    var getSamePrecinct_ = function getSamePrecinct_(precinct) {
	        var rtnList = [];
	        for (var i = 0, qlen = queue.length; i < qlen; i++) {
	            if (queue[i].precinct === precinct) {
	                // save the order so they can be sorted, the original index for the caller;
	                var temp = { 'order': queue[i].order, 'origIdx': i };
	                rtnList.push(temp);
	            }
	        }
	        // sort the rtn list in flow order
	        rtnList.sort(function (a, b) {
	            return a.order - b.order;
	        });
	        return rtnList;
	    };

	    viewport.events.on('viewport:resize', self.refresh);
	}
	module.exports = exports['default'];

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = cAJAX;

	var _uScope = __webpack_require__(11);

	var _uScope2 = _interopRequireDefault(_uScope);

	var _toolbar = __webpack_require__(5);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	//________________________________________________________________________________________________
	// ajaxCalls.js
	//    This file contains cAJAX, the ajax request object.
	//
	//    history
	//    1108    cperz        created
	//    _______________________________________end_AIHv1/PR __________________________________________
	//    141222    cperz        refactor functions into cAJAX object; combine them into imageserver and dataserver calls
	//    1412XX    cperz        add ajax calls for IA; add callback parms to doIMGSRVREQ;
	//
	//________________________________________________________________________________________________
	//
	function cAJAX(vpObj, vpImageId, logFn) {
	    var self = this;
	    var thisImg = vpObj;
	    var imageId = vpImageId; // necessary to cache this so it is known if image is closed during async call

	    //................................................................. doIMGSRVREQ
	    //    doIMGSRVREQ: This function sends a request to image server
	    //    parameters:
	    //        cbSuccessFn            optional,callback function upon success; a default report fn is called if not specified
	    //        cbFailureFn            optional,callback function upon failure; a default report fn is called if not specified
	    //        requestName            required, dataserver request name
	    //        opt_cbParms            optional, parms to send to call back function
	    //        opt_datatype:        optional, defulat is 'xml',  {'xml, 'html}
	    //                            IE issue:  it seems that the return xml from getannotatons of "<Annotations/>"
	    //                            cannot interpreted properly so just get the text w/o interpretation.
	    //                            DataServer calls always provide the results wrapped in XML and can be interpreted properly.
	    //                            Note that when dataType is 'html' then HTML is returned as plain text
	    //
	    //        opt_reqImageId:        optional, imageId to request xinfo of; default is viewport; markup images provide this;

	    this.doIMGSRVREQ = function (cbSuccessFn, cbFailureFn, requestName, opt_cbParms, opt_datatype, opt_reqImageId) {

	        if (opt_datatype == undefined) opt_datatype = 'xml';
	        var parms = {
	            type: 'POST',
	            timeout: 6000,
	            cache: false,
	            async: true,
	            dataType: opt_datatype,
	            data: requestName,
	            success: function success(data, textStatus, jqXHR) {
	                if (isImageStillValid() == false) return;

	                if (cbSuccessFn) cbSuccessFn(data, textStatus, jqXHR, opt_cbParms); //
	                else defaultSuccessFn(data, textStatus, jqXHR, opt_cbParms, requestName);
	            },
	            error: function error(jqXHR, textStatus, errorThrown) {
	                if (isImageStillValid() == false) return;

	                if (cbFailureFn) cbFailureFn(jqXHR, textStatus, errorThrown, opt_cbParms); //
	                else defaultFailureFn(' Error: doIMGSRVREQ ' + requestName + self.getErrorStr(jqXHR, textStatus, errorThrown, imageId));
	            }
	        };
	        // add authentication to the request parameters and issue the ajax request
	        if (ajaxAddAuth('doIMGSRVREQ', parms, opt_reqImageId ? opt_reqImageId : imageId)) $.ajax(parms);
	    };

	    //................................................................. doDATASVRREQ
	    // doDATASVRREQ - This function sends a DoDBCall to ImageServer.
	    //                    e.g. ImageServer request: GET <path>?DODBCALL+<method>+<input xml to method>
	    // passed parameters:
	    //        cbSuccessFn            optional,callback function upon success; a default report fn is called if not specified
	    //        cbFailureFn            optional,callback function upon failure; a default report fn is called if not specified
	    //        requestName            required, dataserver request name
	    //        strXML                required, xml string specifying specifics of the request
	    //        opt_cbParms            optional, parms to send to call back function

	    this.doDATASVRREQ = function (cbSuccessFn, cbFailureFn, requestName, strXML, opt_cbParms) {
	        var parms = {
	            type: 'POST', timeout: 6000, cache: false, async: true, dataType: 'html', // 'html' datatype prevents IE complaints about XML
	            data: 'DODBCALL' + '+' + requestName + '+' + strXML,

	            success: function success(data, textStatus, jqXHR) {
	                if (isImageStillValid() == false) return;

	                if (cbSuccessFn) cbSuccessFn(data, textStatus, jqXHR, opt_cbParms); //
	                else defaultSuccessFn(data, textStatus, jqXHR, opt_cbParms, requestName);
	            },
	            error: function error(jqXHR, textStatus, errorThrown) {
	                if (isImageStillValid() == false) return;

	                //        if (textStatus == "parsererror") {                // IE is touchy about the garbage at the end of the xml returned from imageserver
	                //            cbSuccessFn(undefined, textStatus, jqXHR, cbParms);

	                if (cbFailureFn) cbFailureFn(jqXHR, textStatus, errorThrown, opt_cbParms); //
	                else defaultFailureFn(' Error: DODBCALL ' + requestName + self.getErrorStr(jqXHR, textStatus, errorThrown, imageId));
	            }
	        };
	        // add authentication to the request parameters and issue the ajax request
	        if (ajaxAddAuth('doDATASVRREQ: ' + requestName, parms, imageId)) $.ajax(parms);
	    };

	    //................................................................. doANALSVRREQ
	    // doANALSVRREQ - This function sends a DoIACall to ImageServer.
	    //                    e.g. ImageServer request: GET <path>?DOIACALL+<method>+<input xml to method>
	    // passed parameters:
	    //        cbSuccessFn            optional,callback function upon success; a default report fn is called if not specified
	    //        cbFailureFn            optional,callback function upon failure; a default report fn is called if not specified
	    //        requestName            required, dataserver request name
	    //        strXML                required, xml string specifying specifics of the request
	    //        opt_cbParms            optional parms to send to call back function

	    this.doANALSVRREQ = function (cbSuccessFn, cbFailureFn, requestName, strXML, opt_cbParms) {

	        var parms = {
	            type: 'POST', timeout: 6000, cache: false, async: true, dataType: 'html', // 'html' datatype prevents IE complaints about XML
	            data: 'DOIACALL' + '+' + requestName + '+' + strXML,

	            success: function success(data, textStatus, jqXHR) {
	                if (isImageStillValid() == false) return;

	                if (cbSuccessFn) cbSuccessFn(data, textStatus, jqXHR, opt_cbParms); //
	                else defaultSuccessFn(data, textStatus, jqXHR, opt_cbParms, requestName);
	            },
	            error: function error(jqXHR, textStatus, errorThrown) {
	                if (isImageStillValid() == false) return;

	                if (cbFailureFn) cbFailureFn(jqXHR, textStatus, errorThrown, opt_cbParms); //
	                else defaultFailureFn(' Error: DOIACALL ' + requestName + self.getErrorStr(jqXHR, textStatus, errorThrown, imageId));
	            }
	        };
	        // add authentication to the request parameters and issue the ajax request
	        if (ajaxAddAuth('doDATASVRREQ: ' + requestName, parms, imageId)) $.ajax(parms);
	    };

	    //................................................................. doIMGSVRPOST
	    // doIMGSVRPOST - This function posts to image server requests that are not image related
	    // passed parameters:
	    //        cbSuccessFn            optional,callback function upon success; a default report fn is called if not specified
	    //        cbFailureFn            optional,callback function upon failure; a default report fn is called if not specified
	    //        requestName            required, dataserver request name
	    //        requestData            required, request specific data
	    //        opt_cbParms            optional parms to send to call back function

	    this.doIMGSVRPOST = function (cbSuccessFn, cbFailureFn, requestName, requestData, opt_cbParms) {

	        var parms = {
	            type: 'POST', timeout: 6000, async: true, dataType: 'html', // 'html' datatype prevents IE complaints about XML

	            success: function success(data, textStatus, jqXHR) {
	                if (isImageStillValid() == false) return;

	                if (cbSuccessFn) cbSuccessFn(data, textStatus, jqXHR, opt_cbParms); //
	                else defaultSuccessFn(data, textStatus, jqXHR, opt_cbParms, requestName + requestData);
	            },
	            error: function error(jqXHR, textStatus, errorThrown) {
	                if (isImageStillValid() == false) return;

	                if (cbFailureFn) cbFailureFn(jqXHR, textStatus, errorThrown, opt_cbParms); //
	                else defaultFailureFn(' Error: doIMGSVRPOST ' + requestName + requestData + self.getErrorStr(jqXHR, textStatus, errorThrown, imageId));
	            }
	        };

	        // add authentication to the request parameters and issue the ajax request
	        if (ajaxAddAuth2('ajaxPOST', parms)) $.ajax(parms);

	        //..................................................
	        // closure functions
	        //............................................ ajaxAddAuth2
	        function ajaxAddAuth2(callerName, parms) {
	            var server = thisImg.getServer();
	            var token = thisImg.getToken();
	            if (token == undefined || token.length == 0) {
	                if (_uScope2.default.instance.getPassword() != undefined) {
	                    parms.username = _uScope2.default.instance.getLoginName();
	                    parms.password = _uScope2.default.instance.getPassword();
	                    parms.url = server + requestName + requestData;
	                }
	            } else {
	                parms.url = server + token + '/' + requestName + requestData;
	            }
	            return true;
	        }
	        //..................................................
	    };

	    //................................................................. ajaxAddAuth
	    //    ajaxAddAuth - This function adds authentication to the passed associative array
	    var ajaxAddAuth = function ajaxAddAuth(callerName, parms, reqImageId) {
	        parms.url = buildFULLURL_(reqImageId); // build url with the requested image's Id
	        if (parms.url == undefined || parms.url.length == 0) {
	            if (_uScope2.default.instance.getPassword() != undefined) {
	                thisImg.log('                *** ajaxAddAuth: not sending uname & pword ***');
	                parms.username = _uScope2.default.instance.getLoginName();
	                parms.password = _uScope2.default.instance.getPassword();
	                if (reqImageId) parms.url = _uScope2.default.instance.getServer() + reqImageId;
	            } else {
	                thisImg.log(callerName + ' ajaxAddAuth: authentication absent');
	                return false;
	            }
	        }
	        //debug-only  consoleWrite("ajaxAddAuth: " + callerName + "(" + imageId + ") parms.url: " + parms.url);
	        return true;

	        //..................................................
	        // closure functions
	        // buildFULLURL_ - This function uses the currently selected image to create a full url for the passed imageId
	        function buildFULLURL_(imageId) {
	            // note tha imageId must have leading @ sign
	            var rtnURL = '';
	            var fullURL = _uScope2.default.instance.getFullURL(); // assumes a selected image
	            if (fullURL) {
	                var idx = fullURL.lastIndexOf('@');
	                if (idx > 0) rtnURL = fullURL.substr(0, idx) + imageId;
	            }
	            return rtnURL;
	        }
	        //..................................................
	    };
	    //................................................................. getErrorStr
	    this.getErrorStr = function (jqXHR, textStatus, errorThrown, imageId) {
	        var str = ' (' + imageId + ')';
	        if (jqXHR && jqXHR.responseText) {
	            var idx = jqXHR.responseText.indexOf(';');
	            var rtext = idx != -1 ? jqXHR.responseText.slice(0, idx) : jqXHR.responseText;
	            str += ' status: ' + jqXHR.status + ', responseText: ' + rtext;

	            (0, _toolbar.consoleWrite)('I\'VE BEEN SEEING CLIPPING .... jqXHR.responseText: ' + jqXHR.responseText); /////////////TEMP DEBUG
	        } else str += ' errorThrown: ' + errorThrown;
	        return str;
	    };
	    //................................................................. isImageStillValid
	    var isImageStillValid = function isImageStillValid() {
	        if (_uScope2.default.instance.isThisImageIdValid(imageId) == false) {
	            // protect against rapid slide close/open sequence s.t. vpObj no longer is loaded
	            (0, _toolbar.consoleWrite)('Error: ajax request: image is no longer valid: ' + imageId); // logFn not valid in this case
	            return false;
	        }
	        return true;
	    };
	    //................................................................. defaultSuccessFn
	    var defaultSuccessFn = function defaultSuccessFn(data, textStatus, jqXHR, cbParms, requestName) {
	        thisImg.log('defaultSuccessFn: ' + requestName + '\n' + jqXHR.responseText);
	    };
	    //................................................................. defaultFailureFn
	    var defaultFailureFn = function defaultFailureFn(str) {
	        (0, _toolbar.consoleWrite)(str); // logFn may not be valid in this case
	    };
	}

	// TODO: (cc) This code looks very MS specific but I'm not seeing any feature/browser branching. Dead code???
	$.ajaxTransport(function (options, originalOptions, jqXHR) {
	    var xdr;
	    return {
	        send: function send(unused, completeCallback) {
	            xdr = new XDomainRequest();
	            xdr.onload = function () {
	                var responses = {
	                    text: xdr.responseText
	                };
	                if (xdr.contentType.match(/\/xml/)) {
	                    // there is no responseXML in XDomainRequest, so we have to create it manually
	                    var dom = new window.ActiveXObject('Microsoft.XMLDOM');
	                    dom.async = false;
	                    dom.loadXML(xdr.responseText);
	                    responses.xml = dom;

	                    if ($(dom).children('error').length != 0) {
	                        var $error = $(dom).find('error');
	                        completeCallback(parseInt($error.attr('response_code')), $error.attr('message_key'), responses);
	                    } else {
	                        completeCallback(200, 'success', responses);
	                    }
	                } else {
	                    // set status code to 200
	                    // XDomainRequest rejects all other successful status codes
	                    completeCallback(200, 'success', responses);
	                }
	            }; // send
	            xdr.onerror = xdr.ontimeout = function () {
	                var responses = {
	                    text: xdr.responseText
	                };
	                completeCallback(400, 'failed', responses);
	            };
	            xdr.onprogress = function () {};
	            xdr.ontimeout = function () {};
	            xdr.open(options.type, options.url);
	            if ('POST' == options.type) {
	                xdr.send(options.data);
	            }
	        },
	        abort: function abort() {
	            if (xdr) {
	                xdr.abort();
	            }
	        }
	    };
	});
	module.exports = exports['default'];

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = cSearch;

	var _defines = __webpack_require__(3);

	var _defines2 = _interopRequireDefault(_defines);

	var _objects = __webpack_require__(7);

	var _helpers = __webpack_require__(8);

	var _toolbar = __webpack_require__(5);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	//________________________________________________________________________________________________
	// search.js
	//    This file contains the cSearch object which implements sequencing through a region in a
	//            pattern of motion defined by ePattern.
	//            The region coordinate system is left,top of 0,0; positive x to the right;
	//            positive y down.  Hence all return points will have positive coordinates (except the
	//            last, end-of-search, point).
	//
	//            To start search create a cSearch object with the starting coordinate, region and pattern
	//            to sequence.  Then call Next() to get each point in succession until (-1,-1) is returned,
	//            indicating that search has completed.
	//
	//
	//    history
	//    _______________________________________end_Rel 12.1 __________________________________________
	//    141118    cperz        split cSearch out of prefetch.js
	//________________________________________________________________________________________________

	_defines2.default.eSEARCH_PATTERN = {
	    NONE: 0, RASTER: 1,
	    SPIRAL_FILL: 2, SPIRAL_FRAME: 3,
	    RIGHT_DOWN: 4, RIGHT_UP: 5,
	    DOWN_RIGHT: 6, DOWN_LEFT: 7,
	    SNAKE_RIGHT_DOWN: 8, SNAKE_DOWN_RIGHT: 9 //todo: rename to snake_rightdownleftdown, snake_down_right_up_right
	};
	_defines2.default.searchPatternStr = ['NO_SEARCH_PATTERN', 'RASTER', 'SPIRAL_FILL', 'SPIRAL_FRAME', 'RIGHT_DOWN(Fill S side)', 'RIGHT_UP(Fill N side)', 'DOWN_RIGHT(Fill E side)', 'DOWN_LEFT(Fill W side)', 'SNAKE_RIGHT_DOWN', 'SNAKE_DOWN_RIGHT'];
	//________________________________________________________________________________________________


	function cSearch(cpStart, csRegion, ePattern) {
	    if (ePattern === undefined) {
	        (0, _toolbar.consoleWrite)('cSearch: undefined search pattern');
	        return;
	    }
	    var m_cpCurrent = new _objects.cPoint(cpStart.x, cpStart.y);
	    var m_csRegion = new _objects.cSize(csRegion.w, csRegion.h);
	    var m_ePattern = ePattern;

	    var m_bInProgress = false;
	    var m_bSearchIsComplete = false;
	    var m_nCurCount = 0;
	    var m_nMaxCount = m_csRegion.getArea();
	    var m_nRadius = 0;
	    var m_nDirCurrent = 0;
	    var m_nDirCountDown = 0;
	    var m_nDirSecondary = 0;

	    // prohibit processing if settings aren't reasonable
	    if (m_csRegion.w < 1 || m_csRegion.h < 1 || m_cpCurrent.x < 0 || m_cpCurrent.y < 0) {
	        m_ePattern = _defines2.default.eSEARCH_PATTERN.NONE;
	        m_bSearchIsComplete = true;
	    }

	    // spiral motion is in a clockwise direction as defined by this order
	    var eSPIRAL_DIR = { eMOVE_RIGHT: 0, eMOVE_DOWN: 1, eMOVE_LEFT: 2, eMOVE_UP: 3 };
	    var m_cpPropDirInc = (0, _helpers.array2DCreate)(2, 4); //index [0] is for X direction; index [1] is Y
	    m_cpPropDirInc[0][eSPIRAL_DIR.eMOVE_RIGHT] = +1;
	    m_cpPropDirInc[1][eSPIRAL_DIR.eMOVE_RIGHT] = 0;
	    m_cpPropDirInc[0][eSPIRAL_DIR.eMOVE_DOWN] = 0;
	    m_cpPropDirInc[1][eSPIRAL_DIR.eMOVE_DOWN] = +1;
	    m_cpPropDirInc[0][eSPIRAL_DIR.eMOVE_LEFT] = -1;
	    m_cpPropDirInc[1][eSPIRAL_DIR.eMOVE_LEFT] = 0;
	    m_cpPropDirInc[0][eSPIRAL_DIR.eMOVE_UP] = 0;
	    m_cpPropDirInc[1][eSPIRAL_DIR.eMOVE_UP] = -1;

	    switch (m_ePattern) {
	        case _defines2.default.eSEARCH_PATTERN.SPIRAL_FILL:
	            // because the spiral can be started anywhere in the region
	            // the algorithm insures that it covers the region by allowing spiraling
	            // out of and then back into the region.  The worst case total count must is computed as safety stopping criteria.
	            m_csRegion = new _objects.cSize(csRegion.w - 1, csRegion.h - 1); // search is inclusive of the last row and col so redefine region w,h
	            m_nRadius = 0;
	            var nXRadius = Math.max(m_csRegion.w - m_cpCurrent.x + 1, m_csRegion.w);
	            var nYRadius = Math.max(m_csRegion.h - m_cpCurrent.y + 1, m_csRegion.h);
	            var nDiamMax = Math.max(2 * nXRadius, 2 * nYRadius);
	            m_nMaxCount = nDiamMax * nDiamMax;
	            m_nDirCurrent = eSPIRAL_DIR.eMOVE_UP;
	            m_nDirCountDown = 1;
	            break;
	        case _defines2.default.eSEARCH_PATTERN.SPIRAL_FRAME:
	            //  the sprial frame starts one to the right of the diagonal inner boundary
	            m_csRegion = new _objects.cSize(csRegion.w - 1, csRegion.h - 1); // search is inclusive of the last row and col so redefine region w,h
	            m_nRadius = m_csRegion.w - 2 * m_cpCurrent.x - 1;
	            m_cpCurrent.x++; //start one step to the right but requries input diagonal ...
	            m_nDirCurrent = eSPIRAL_DIR.eMOVE_UP;
	            m_nDirCountDown = 1; // so first entry switches to direction right
	            break;
	        case _defines2.default.eSEARCH_PATTERN.RIGHT_DOWN:
	        case _defines2.default.eSEARCH_PATTERN.RIGHT_UP:
	            m_nDirCurrent = eSPIRAL_DIR.eMOVE_RIGHT;
	            m_nDirSecondary = m_ePattern == _defines2.default.eSEARCH_PATTERN.RIGHT_DOWN ? eSPIRAL_DIR.eMOVE_DOWN : eSPIRAL_DIR.eMOVE_UP;
	            break;
	        case _defines2.default.eSEARCH_PATTERN.DOWN_RIGHT:
	        case _defines2.default.eSEARCH_PATTERN.DOWN_LEFT:
	            m_nDirCurrent = eSPIRAL_DIR.eMOVE_DOWN;
	            m_nDirSecondary = m_ePattern == _defines2.default.eSEARCH_PATTERN.DOWN_RIGHT ? eSPIRAL_DIR.eMOVE_RIGHT : eSPIRAL_DIR.eMOVE_LEFT;
	            break;
	        case _defines2.default.eSEARCH_PATTERN.SNAKE_RIGHT_DOWN:
	            m_nDirCurrent = eSPIRAL_DIR.eMOVE_RIGHT; //and left....
	            m_nDirSecondary = eSPIRAL_DIR.eMOVE_DOWN;
	            break;
	        case _defines2.default.eSEARCH_PATTERN.SNAKE_DOWN_RIGHT:
	            m_nDirCurrent = eSPIRAL_DIR.eMOVE_DOWN; //and up....
	            m_nDirSecondary = eSPIRAL_DIR.eMOVE_RIGHT;
	            break;
	    }

	    //............................................ get next point in pattern - PUBLIC
	    this.Next = function () {
	        if (m_bSearchIsComplete) return new _objects.cPoint(-1, -1);

	        if (m_bInProgress == false) {
	            // if just starting, return current point
	            m_bInProgress = true;
	            return new _objects.cPoint(m_cpCurrent.x, m_cpCurrent.y);
	        }

	        switch (m_ePattern) {// otherwise call on the pattern sequencing method
	            case _defines2.default.eSEARCH_PATTERN.SPIRAL_FILL:
	                return NextSpiral();
	                break;
	            case _defines2.default.eSEARCH_PATTERN.SPIRAL_FRAME:
	                return NextFrame();
	                break;
	            case _defines2.default.eSEARCH_PATTERN.RIGHT_DOWN:
	            case _defines2.default.eSEARCH_PATTERN.RIGHT_UP:
	                return NextRasterX();
	                break;
	            case _defines2.default.eSEARCH_PATTERN.DOWN_RIGHT:
	            case _defines2.default.eSEARCH_PATTERN.DOWN_LEFT:
	                return NextRasterY();
	                break;
	            case _defines2.default.eSEARCH_PATTERN.SNAKE_RIGHT_DOWN:
	                return NextSnakeX();
	                break;
	            case _defines2.default.eSEARCH_PATTERN.SNAKE_DOWN_RIGHT:
	                return NextSnakeY();
	                break;
	        }
	        return new _objects.cPoint(-1, -1);
	    };
	    //............................................ get next point in snake X direction pattern - PRIVATE
	    function NextSnakeX() {
	        var cpRtn = new _objects.cPoint(-1, -1);
	        if (m_nCurCount > m_nMaxCount) {
	            // is it time to stop
	            m_bSearchIsComplete = true;
	            return cpRtn;
	        }
	        m_nCurCount++;
	        m_cpCurrent.x += m_cpPropDirInc[0][m_nDirCurrent];

	        if (m_nDirCurrent == eSPIRAL_DIR.eMOVE_RIGHT && m_cpCurrent.x >= m_csRegion.w) {
	            m_cpCurrent.x = m_csRegion.w - 1; // x resets to 0
	            m_cpCurrent.y += m_cpPropDirInc[1][m_nDirSecondary]; // move y up or down
	            m_nDirCurrent = eSPIRAL_DIR.eMOVE_LEFT; // and switch right motion for left
	        } else if (m_nDirCurrent == eSPIRAL_DIR.eMOVE_LEFT && m_cpCurrent.x < 0) {
	            m_cpCurrent.x = 0; // x resets to 0
	            m_cpCurrent.y += m_cpPropDirInc[1][m_nDirSecondary]; // move y up or down
	            m_nDirCurrent = eSPIRAL_DIR.eMOVE_RIGHT; // and switch right motion for left
	        }
	        if (m_cpCurrent.y < m_csRegion.h && m_cpCurrent.y >= 0) cpRtn.setPoint(m_cpCurrent);
	        return cpRtn;
	    }
	    //............................................ get next point in snake Y direction pattern - PRIVATE
	    function NextSnakeY() {
	        var cpRtn = new _objects.cPoint(-1, -1);
	        if (m_nCurCount > m_nMaxCount) {
	            // is it time to stop
	            m_bSearchIsComplete = true;
	            return cpRtn;
	        }
	        m_nCurCount++;
	        m_cpCurrent.y += m_cpPropDirInc[1][m_nDirCurrent];

	        if (m_nDirCurrent == eSPIRAL_DIR.eMOVE_DOWN && m_cpCurrent.y >= m_csRegion.h) {
	            m_cpCurrent.y = m_csRegion.h - 1;
	            m_cpCurrent.x += m_cpPropDirInc[0][m_nDirSecondary];
	            m_nDirCurrent = eSPIRAL_DIR.eMOVE_UP;
	        } else if (m_nDirCurrent == eSPIRAL_DIR.eMOVE_UP && m_cpCurrent.y < 0) {
	            m_cpCurrent.y = 0;
	            m_cpCurrent.x += m_cpPropDirInc[0][m_nDirSecondary];
	            m_nDirCurrent = eSPIRAL_DIR.eMOVE_DOWN;
	        }

	        //        if (m_nDirCurrent == eSPIRAL_DIR.eMOVE_DOWN && m_cpCurrent.y >= m_csRegion.h) {
	        //            m_cpCurrent.y = m_csRegion.h-1;
	        //            m_cpCurrent.x += m_cpPropDirInc[0][m_nDirSecondary];
	        //            m_nDirCurrent = eSPIRAL_DIR.eMOVE_UP;
	        //        }
	        //        else if (m_nDirCurrent == eSPIRAL_DIR.eMOVE_UP && m_cpCurrent.y < 0) {
	        //            m_cpCurrent.y = 0;
	        //            m_cpCurrent.x += m_cpPropDirInc[1][m_nDirSecondary];
	        //            m_nDirCurrent = eSPIRAL_DIR.eMOVE_DOWN;
	        //        }

	        if (m_cpCurrent.x < m_csRegion.w && m_cpCurrent.x >= 0) cpRtn.setPoint(m_cpCurrent);
	        return cpRtn;
	    }
	    //............................................ get next point in spiral pattern - PRIVATE
	    function NextSpiral() {
	        var cpRtn = new _objects.cPoint(-1, -1);
	        do {
	            if (++m_nCurCount > m_nMaxCount) {
	                // is it time to stop?
	                m_bSearchIsComplete = true;
	                cpRtn.set(-1, -1);
	                //consoleWrite("m_nCurCount > m_nMaxCount: Next: " + cpRtn.toString());//dbg
	                return cpRtn;
	            }

	            m_nDirCountDown--;
	            if (!m_nDirCountDown) {
	                // if its time to switch directions
	                m_nDirCurrent++;
	                if (m_nDirCurrent > eSPIRAL_DIR.eMOVE_UP) m_nDirCurrent = eSPIRAL_DIR.eMOVE_RIGHT;

	                if (m_nDirCurrent == eSPIRAL_DIR.eMOVE_RIGHT || m_nDirCurrent == eSPIRAL_DIR.eMOVE_LEFT) m_nRadius++;
	                m_nDirCountDown = m_nRadius;
	            }
	            m_cpCurrent.add(m_cpPropDirInc[0][m_nDirCurrent], m_cpPropDirInc[1][m_nDirCurrent]);
	            //consoleWrite("NextSpiral: " + m_cpCurrent.toString()); //dbg
	        } while (m_cpCurrent.x < 0 || m_cpCurrent.x > m_csRegion.w || m_cpCurrent.y < 0 || m_cpCurrent.y > m_csRegion.h);
	        cpRtn.setPoint(m_cpCurrent);
	        return cpRtn;
	    }
	    //............................................ get next point in frame pattern - PRIVATE
	    function NextFrame() {
	        var cpRtn = new _objects.cPoint(-1, -1);
	        do {
	            if (++m_nCurCount > m_nMaxCount) {
	                // is it time to stop
	                m_bSearchIsComplete = true;
	                return cpRtn;
	            }

	            m_nDirCountDown--;
	            if (m_nDirCountDown <= 0) {
	                // if its time to switch directions
	                m_nDirCurrent++;
	                if (m_nDirCurrent > eSPIRAL_DIR.eMOVE_UP) m_nDirCurrent = eSPIRAL_DIR.eMOVE_RIGHT;

	                if (m_nDirCurrent == eSPIRAL_DIR.eMOVE_UP || m_nDirCurrent == eSPIRAL_DIR.eMOVE_DOWN) m_nRadius++;
	                m_nDirCountDown = m_nRadius;
	            }
	            m_cpCurrent.add(m_cpPropDirInc[0][m_nDirCurrent], m_cpPropDirInc[1][m_nDirCurrent]);
	            //consoleWrite("Next ", + cpRtn.toString());
	        } while (m_cpCurrent.x < 0 || m_cpCurrent.x > m_csRegion.w || m_cpCurrent.y < 0 || m_cpCurrent.y > m_csRegion.h);
	        cpRtn.setPoint(m_cpCurrent);
	        return cpRtn;
	    }

	    //............................................ get next point in raster X direction pattern - PRIVATE
	    function NextRasterX() {
	        var cpRtn = new _objects.cPoint(-1, -1);
	        if (m_nCurCount > m_nMaxCount) {
	            // is it time to stop
	            m_bSearchIsComplete = true;
	            return cpRtn;
	        }
	        m_nCurCount++;
	        m_cpCurrent.x += m_cpPropDirInc[0][m_nDirCurrent];
	        if (m_cpCurrent.x >= m_csRegion.w) {
	            // if too far right
	            m_cpCurrent.x = 0; // x resets to 0
	            m_cpCurrent.y += m_cpPropDirInc[1][m_nDirSecondary]; // move y up or down
	        }
	        if (m_cpCurrent.y < m_csRegion.h && m_cpCurrent.y >= 0) cpRtn.setPoint(m_cpCurrent);
	        return cpRtn;
	    }
	    //............................................ get next point in raster Y direction pattern - PRIVATE
	    function NextRasterY() {
	        var cpRtn = new _objects.cPoint(-1, -1);
	        if (m_nCurCount > m_nMaxCount) {
	            // is it time to stop
	            m_bSearchIsComplete = true;
	            return cpRtn;
	        }
	        m_nCurCount++;
	        m_cpCurrent.y += m_cpPropDirInc[1][m_nDirCurrent];
	        if (m_cpCurrent.y >= m_csRegion.h) {
	            m_cpCurrent.y = 0;
	            m_cpCurrent.x += m_cpPropDirInc[0][m_nDirSecondary];
	        }
	        if (m_cpCurrent.x < m_csRegion.w && m_cpCurrent.x >= 0) cpRtn.setPoint(m_cpCurrent);
	        return cpRtn;
	    }
	}
	module.exports = exports['default'];

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.VP_MOUSEWHEEL = VP_MOUSEWHEEL;
	exports.VP_MOUSEHANDLER = VP_MOUSEHANDLER;
	exports.vp_mousedown = vp_mousedown;
	exports.vp_mousemove = vp_mousemove;
	exports.vp_mouseup = vp_mouseup;
	exports.vp_mousedclick = vp_mousedclick;

	var _defines = __webpack_require__(3);

	var _defines2 = _interopRequireDefault(_defines);

	var _toolbar = __webpack_require__(5);

	var _annotationsService = __webpack_require__(25);

	var _helpers = __webpack_require__(8);

	var _uScope = __webpack_require__(11);

	var _uScope2 = _interopRequireDefault(_uScope);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	//________________________________________________________________________________________________
	// navigation.js
	//    This file contains the viewportAP object event handlers.
	//
	//    history
	//    1105     cperz        created
	//    _______________________________________end_AIHv1/PR __________________________________________
	//    141118    cperz        move RasterScanService to its own file;  move other fns to us namespace;
	//    141120    cperz        add support for negative pen
	//    150318    cperz        minor cleaning
	//________________________________________________________________________________________________

	//............................................ VP_MOUSEWHEEL
	// VP_MOUSEWHEEL - This function dispatches the viewport mouse wheel events.
	function VP_MOUSEWHEEL(thisImg, e, delta, deltaX, deltaY) {
	    if (_defines2.default.DISABLEWHEELZOOM) return;

	    if (deltaY != 0) {
	        // deltaY -> zoom
	        if (_defines2.default.DBGZOOMCTL) (0, _toolbar.consoleWrite)('VP_MOUSEWHEEL: curZoom: ' + thisImg.getViewZoom() + '  deltaY: ' + deltaY + ' =>  zoom step: ' + -deltaY * _defines2.default.zoomSpecs.stepFactor);
	        thisImg.zoomSlider.step(-deltaY * _defines2.default.zoomSpecs.stepFactor);
	    }

	    if (deltaX != 0) {
	        // deltaX -> pan
	        var dx = deltaX * 20;
	        if (_defines2.default.DBGZOOMCTL) (0, _toolbar.consoleWrite)('VP_MOUSEWHEEL: deltaX: ' + deltaX + '  =>  x pan (px): ' + dx);
	        thisImg.moveRelative(dx, 0);
	    }
	    return true;
	}

	//............................................ VP_MOUSEHANDLER
	//    VP_MOUSEHANDLER - This function dispatches viewport mouse click and move events.
	function VP_MOUSEHANDLER(e, thisImg) {
	    // The mousemove event is constantly captured yet it is only relevant when in conferencing or in a navmode. So get out as soon as possible
	    if (e.type == 'mousemove' && thisImg.navModeGet() == _defines2.default.eNavModes.nmNone && _uScope2.default.instance.isRegionCopyActive() == false && _uScope2.default.instance.isModeConference() == false) {
	        //debug-only thisImg.log('VP_MOUSEHANDLER: mousemove: No Navigation');
	        return;
	    }

	    var sClassList = (0, _helpers.getClassList)(e.currentTarget); // provides sTargetClass === us.clsVIEWPORT
	    if ((0, _helpers.isUnDefined)(sClassList)) return;
	    var sTargetClass = sClassList[0];
	    //dbg-only     if (us.DBGMOUSEEVENTS &&  e.type != 'mousemove') consoleWrite(thisImg.getImageId() + " VP_MOUSEHANDLER: type: " +  e.type + " curTarget: " + sClassList); //cp-test to see If this is necessary!!!

	    switch (e.type) {
	        case 'mousedown':
	            ///if (us.DBGMOUSEEVENTS) consoleWrite("- .viewport)." +  e.type + "   sTargetClass= " + sTargetClass);
	            if (sTargetClass == _defines2.default.clsVIEWPORT || sTargetClass == _defines2.default.clsAPANIMG) vp_mousedown(thisImg, e);
	            break;
	        case 'mousemove':
	            //dbg-only if (sTargetClass == us.clsIMGTILE) consoleWrite("- .viewport)." +  e.type + "   sTargetClass= " + sTargetClass);
	            //dbg-only if (us.DBGMOUSEMOVE) consoleWrite("- .viewport)." +  e.type + "   sTargetClass= " + sTargetClass);
	            if (sTargetClass == _defines2.default.clsVIEWPORT || sTargetClass == _defines2.default.clsAPANIMG) {
	                // ok if mouse cursor touches autopan image
	                vp_mousemove(thisImg, e);
	            } else {
	                (0, _toolbar.consoleWrite)('- .viewport).' + e.type + '   sTargetClass= ' + sTargetClass + ' ... forcing mouse up');
	                vp_mouseup(thisImg, e, _defines2.default.NOTTOUCHEVENT); // if targetClass is something unknown, just stop nav mode via mouseup
	            }
	            break;
	        case 'focus':
	        case 'blur':
	        case 'mouseup':
	        case 'mouseleave':
	            //dbg-only if (us.DBGMOUSEEVENTS) consoleWrite("- .viewport)." + e.type + "   sTargetClass= " + sTargetClass);
	            if (sTargetClass == _defines2.default.clsVIEWPORT) {
	                vp_mouseup(thisImg, e, _defines2.default.NOTTOUCHEVENT);
	            }
	            break;
	        case 'dblclick':
	            if (_defines2.default.DBGMOUSEEVENTS) (0, _toolbar.consoleWrite)('- .viewport).' + e.type + '   sTargetClass= ' + sTargetClass);
	            if (sTargetClass == _defines2.default.clsVIEWPORT) vp_mousedclick(thisImg, e);
	            break;
	        default:
	            //if (us.DBGMOUSEEVENTS)
	            thisImg.log('unimplemented VP_MOUSEHANDLER event: ' + e.type);
	    }
	}

	//............................................ vp_mousedown
	// vp_mousedown - This function handles mousedown and touchstart events for the viewport.
	function vp_mousedown(thisImg, e, isTouchEvent) {
	    thisImg.focus(); // force focus on this vp for hot keys
	    var anObj = thisImg.getAnnotObj();
	    if (anObj) anObj.regHoverShow(false); // hide any hovering note

	    $(_defines2.default.idHashROOT).find('.' + _defines2.default.clsPANELCLICKCLOSE).dialog('close'); // close click-closable panels

	    if (e.which == _defines2.default.eEVENTWHICHBTN.right) {
	        // on right click (context menu)
	        _uScope2.default.instance.setImageSelected(thisImg.getImageIdx()); // insure this is the selected image
	        return; // and return, nothing else to do here
	    }

	    var cpVpRelPos = _defines2.default.coordPageToView(e, thisImg); // the unrotated viewport relative cursor position
	    thisImg.setMouseDown(cpVpRelPos.x, cpVpRelPos.y); // save last mouse down position
	    //debug-only (handy click to get page, vp relative & base coords) thisImg.log("vp_mousedown: e: " + e.pageX + "," + e.pageY + "   cpVpRelPos: " + cpVpRelPos.toString() + "   cpBasePos: " + us.coordBaseImage(e, thisImg));

	    var navMode = thisImg.navModeGet(); // cache nav mode since it can be set inside the switch statement
	    if (navMode != _defines2.default.eNavModes.nmNone) // don't compute basePos unless needed
	        var basePos = _defines2.default.coordBaseImage2(cpVpRelPos, thisImg); // the cursor in base image coords

	    switch (navMode) {
	        case _defines2.default.eNavModes.nmNone:
	            // mouse down when no nav mode happening means start of drag image navigation or pinch zoom
	            if (isTouchEvent && e.touches.length > 1) {
	                // start pinch zoom
	                _defines2.default.navModeSwitch(thisImg, _defines2.default.eNavModes.nmPinchZoom);
	                if (_defines2.default.DBGPINCH) thisImg.log('vp_mousedown: start pinch zoom, mode: ' + thisImg.navMode);
	            } else {
	                // start drag mode
	                thisImg.setCursor('move'); // change to move cursor
	                _defines2.default.navModeSwitch(thisImg, _defines2.default.eNavModes.nmDragImage);
	                thisImg.setMouseCur(cpVpRelPos.x, cpVpRelPos.y, 'initPrev'); // initialize previous mouse cursor position to this too
	                //dbg-only if (us.DBGNAV) thisImg.log("vp_mousedown: start image drag, mode: " + thisImg.navMode);
	            }
	            break;
	        case _defines2.default.eNavModes.nmAnnotPin: // start (and finish) drawing the pin, arrow, text
	        case _defines2.default.eNavModes.nmAnnotArrow:
	            // mouse down when annotate pin, arrow, text and report region means set element here
	            if (anObj) {
	                var anType = _defines2.default.eAnTypes.pin;
	                if (thisImg.navModeGet() === _defines2.default.eNavModes.nmAnnotArrow) anType = _defines2.default.eAnTypes.arrow;
	                anObj.startNew(anType, basePos, thisImg.getViewZoom(), thisImg.getViewAngle(true));
	            }
	            break;
	        case _defines2.default.eNavModes.nmAnnotText:
	            (0, _toolbar.openTextEditPanel)('Add on image text', '', _annotationsService.cb_addOnImageText, basePos); // request user input on text
	            break;
	        case _defines2.default.eNavModes.nmAnnotReport:
	            if (anObj) anObj.startNew(_defines2.default.eAnTypes.report, basePos, thisImg.getViewZoom(), thisImg.getViewAngle(true));
	            break;
	        case _defines2.default.eNavModes.nmAnnotRect: // mousedown for these region types starts drawing
	        case _defines2.default.eNavModes.nmAnnotEllipse:
	        case _defines2.default.eNavModes.nmAnnotPen:
	        case _defines2.default.eNavModes.nmAnnotNegPen:
	            if (anObj) {
	                var anType = _defines2.default.eAnTypes.rect; //cp-could cure this mess with a data structure
	                if (navMode === _defines2.default.eNavModes.nmAnnotEllipse) anType = _defines2.default.eAnTypes.ellipse;else if (navMode === _defines2.default.eNavModes.nmAnnotPen) anType = _defines2.default.eAnTypes.pen;else if (navMode === _defines2.default.eNavModes.nmAnnotNegPen) anType = _defines2.default.eAnTypes.negpen;
	                anObj.startNew(anType, basePos, thisImg.getViewZoom(), thisImg.getViewAngle(true));
	            }
	            break;
	        case _defines2.default.eNavModes.nmAnnotCaliper: // caliper sets new position down on each mousedown
	        case _defines2.default.eNavModes.nmAnnotPolygon:
	            // caliper sets new position down on each mousedown
	            if (anObj) {
	                if (anObj.drawingIsStarted()) // if already drawing, update caliper tool
	                    anObj.updateNew(basePos, 'mousedown');else {
	                    // otherwise, start drawing the caliper or polygon
	                    var type = navMode == _defines2.default.eNavModes.nmAnnotCaliper ? _defines2.default.eAnTypes.caliper : _defines2.default.eAnTypes.polygon;
	                    anObj.startNew(type, basePos, thisImg.getViewZoom(), thisImg.getViewAngle(true));
	                }
	            }
	            break;
	        case _defines2.default.eNavModes.nmRedrawStarting:
	            // start pen redraw mode
	            if (anObj) {
	                if (anObj.regReDraw('start', basePos, thisImg.getViewZoom()) == true) _defines2.default.navModeSwitch(thisImg, _defines2.default.eNavModes.nmRedraw);
	            }
	            break;
	        case _defines2.default.eNavModes.nmAutoPan:
	            // mouse down when autopanning means stop
	            _defines2.default.navModeHalt(thisImg);
	            break;
	        case _defines2.default.eNavModes.nmRasterScan:
	            // mouse down when rastering means stop
	            _uScope2.default.instance.rasterPanel.pause(); // pause raster scan
	            _defines2.default.navModeHalt(thisImg);
	            break;
	        case _defines2.default.eNavModes.nmZoom:
	        case _defines2.default.eNavModes.nmDClickZoom:
	            // can this happen?
	            break;
	        default:
	    }
	}

	//............................................ vp_mousemove
	// vp_mousemove - This function dispatches the mousemove and touchmove events.
	function vp_mousemove(thisImg, e, isTouchEvent) {
	    var navMode = thisImg.navModeGet();
	    var cpVpRelPos = _defines2.default.coordPageToView(e, thisImg); // the unrotated viewport relative cursor position
	    //debug-only thisImg.log('vp_mousemove  navMode: ' + navMode);

	    if (_uScope2.default.instance.isConfLeader()) {
	        // only in conferencing are mouse states recorded
	        var basePos = _defines2.default.coordBaseImage2(cpVpRelPos, thisImg); // the cursor in base image coords
	        thisImg.stateVector.mouseUpdate(basePos, 'mousemove', true); // force a save of this mouse move event
	    }
	    if (_uScope2.default.instance.isRegionCopyActive() == true) {
	        //todo: call into a uScope region toolbar fn instead of doing this here...
	        var crsrPosBase = _defines2.default.coordBaseImage(e, thisImg); // compute the position of the cursor in base image coords
	        var anObj = thisImg.getAnnotObj();
	        anObj.regMoveCenter(crsrPosBase);
	    }
	    switch (navMode) {
	        case _defines2.default.eNavModes.nmDragImage:
	            // mouse move in drag image navigation

	            if (isTouchEvent && e.touches.length > 1) {
	                // swiping but two fingers show up, switch out of drag and start pinch zoom
	                _defines2.default.navModeSwitch(thisImg, _defines2.default.eNavModes.nmPinchZoom); // note - this is very unusual but make pinch initiation more reliable
	                if (_defines2.default.DBGSWIPE || _defines2.default.DBGPINCH) (0, _toolbar.consoleWrite)('SWIPE changed to PINCHING');
	                return;
	            }
	            var ptDelta = thisImg.setMouseCurRtnDiff(cpVpRelPos.x, cpVpRelPos.y);
	            //debug-only consoleWrite("vp_mousemove: delta: " + ptDelta.toString());
	            if (ptDelta.x != 0 || ptDelta.y != 0) // note that this occurs more than you'd imagine
	                thisImg.moveRelative(ptDelta.x, ptDelta.y); // move the image dx, dy
	            break;
	        case _defines2.default.eNavModes.nmPinchZoom:
	            //dbg-only document.title = "Pinch touches: " + e.changedTouches.length;
	            if (thisImg.initDist == 0 && e.changedTouches.length > 1) {
	                var dx = e.changedTouches[0].clientX - e.changedTouches[1].clientX;
	                var dy = e.changedTouches[0].clientY - e.changedTouches[1].clientY;
	                thisImg.initDist = parseInt(Math.sqrt(dx * dx + dy * dy));
	                thisImg.initMag = thisImg.getViewMag();

	                //dbg-only document.title = "Pinch initDist: " + thisImg.initDist;
	                if (_defines2.default.DBGPINCH) (0, _toolbar.consoleWrite)('PINCHING  initDist: ' + thisImg.initDist);
	            } else if (e.changedTouches.length > 1) {
	                // insure two touches, sometimes there is only one!
	                var dx = e.changedTouches[0].clientX - e.changedTouches[1].clientX;
	                var dy = e.changedTouches[0].clientY - e.changedTouches[1].clientY;
	                var curDist = parseInt(Math.sqrt(dx * dx + dy * dy));
	                //dbg-only document.title = "Pinch curDist: " + curDist + " vs "+thisImg.initDist;

	                var scale = (1.0 - (thisImg.initDist - curDist) / thisImg.initDist).toFixed(3);
	                var mag = thisImg.initMag * scale;
	                var zoom = thisImg.convertToZoom(mag);
	                zoom = _defines2.default.helpers.roundToDecimals(zoom);
	                if (zoom !== thisImg.getViewZoom()) {
	                    if (_defines2.default.DBGPINCH) (0, _toolbar.consoleWrite)('PINCHING  dist:' + thisImg.initDist + '->' + curDist + '= ' + ' scale:' + scale + ' Mag:' + mag.toFixed(1));
	                    thisImg.zoomAbsolute(zoom);
	                }
	            }
	            break;

	        case _defines2.default.eNavModes.nmAnnotRect:
	        case _defines2.default.eNavModes.nmAnnotEllipse:
	        case _defines2.default.eNavModes.nmAnnotPen:
	        case _defines2.default.eNavModes.nmAnnotNegPen:
	        case _defines2.default.eNavModes.nmAnnotReport:
	            var basePos = _defines2.default.coordBaseImage2(cpVpRelPos, thisImg); // the cursor in base image coords
	            if (thisImg.getAnnotObj()) thisImg.getAnnotObj().updateNew(basePos, 'mousemove');
	            break;
	        case _defines2.default.eNavModes.nmAnnotPin: // nothing to do on mouse move for pin, arrow, text
	        case _defines2.default.eNavModes.nmAnnotArrow:
	        case _defines2.default.eNavModes.nmAnnotText:
	            break;
	        case _defines2.default.eNavModes.nmAnnotCaliper:
	        case _defines2.default.eNavModes.nmAnnotPolygon:
	            // caliper sets new position down on each mousedown
	            var basePos = _defines2.default.coordBaseImage2(cpVpRelPos, thisImg); // the cursor in base image coords
	            if (thisImg.getAnnotObj()) thisImg.getAnnotObj().updateNew(basePos, 'mousemove');
	            break;
	        case _defines2.default.eNavModes.nmRedraw:
	            // continue pen redraw
	            var basePos = _defines2.default.coordBaseImage2(cpVpRelPos, thisImg); // the cursor in base image coords
	            var anObj = thisImg.getAnnotObj(); // the annot object
	            if (anObj) {
	                if (anObj.regReDraw('update', basePos, thisImg.getViewZoom()) == false) anObj.regReDraw('finish');
	            }
	            break;
	        case _defines2.default.eNavModes.nmAutoPan:
	            //  autopan motion is controlled on a timer but it needs the current mouse position
	            thisImg.setMouseCur(cpVpRelPos.x, cpVpRelPos.y); // update current mouse position in vp
	            if (_defines2.default.DBGAUTOPAN) {
	                ///var ptMouse = thisImg.getMouseCur();
	                (0, _toolbar.consoleWrite)('vp_mousemove:  mousePt: ' + thisImg.getMouseCur(_defines2.default.coordSystemNORM).toString(), thisImg.getImageId());
	            }
	            break;
	        case _defines2.default.eNavModes.nmRasterScan:
	            break;
	        case _defines2.default.eNavModes.nmRotatingOverlay:
	            thisImg.scaleBar.rotateToCursor(e); // scale bar rotation .. same code in scalebar mousemove
	            break;
	        default:
	    }
	}

	//............................................ vp_mouseup
	// vp_mouseup - This function dispatches mouse up events that usually indicate either an end to drawing
	//                or and end to a nvaigation mode, with a few exceptions.
	function vp_mouseup(thisImg, e, isTouchEvent) {

	    switch (thisImg.navModeGet()) {
	        case _defines2.default.eNavModes.nmDragImage:
	            if (_defines2.default.ENABLEDRAGMOMENTUM && thisImg.isFitZoom() == false) {
	                // if enabled and not fit zoom, finish drag with momentum
	                _defines2.default.navModeHalt(thisImg); // must halt before drag momentum
	                thisImg.viewDragMomemtumGo();
	            }
	            break;
	        case _defines2.default.eNavModes.nmThumbDragImage:
	            // thumb mouse up passes thru here
	            break;
	        case _defines2.default.eNavModes.nmDClickZoom:
	        case _defines2.default.eNavModes.nmZoom:
	            return; // do not halt nav mode zoom on a mouse up for these zoom modes
	        ////break;
	        case _defines2.default.eNavModes.nmPinchZoom:
	            thisImg.initDist = 0; // reset distance measurement
	            _defines2.default.navModeHalt(thisImg); // must halt first so that final zoom can use all pyr levels
	            var zoom = _defines2.default.helpers.roundToDecimals(thisImg.picZoom);
	            thisImg.zoomAbsolute(zoom); // execute the zoom
	            return; // do not halt nav mode pinch zoom on a mouse up
	        ////break;

	        case _defines2.default.eNavModes.nmAnnotRect:
	        case _defines2.default.eNavModes.nmAnnotEllipse:
	        case _defines2.default.eNavModes.nmAnnotPen:
	        case _defines2.default.eNavModes.nmAnnotNegPen:
	        case _defines2.default.eNavModes.nmAnnotReport:
	            // halt nav mode these drawing tools
	            if (thisImg.getAnnotObj()) thisImg.getAnnotObj().finishNew();
	            break;
	        case _defines2.default.eNavModes.nmAnnotCaliper: // halt nav mode on mouse leave for caliper but not mouse up
	        case _defines2.default.eNavModes.nmAnnotPolygon:
	            // caliper sets new position down on each mousedown
	            if (e.type == 'mouseleave' && thisImg.getAnnotObj()) {
	                thisImg.getAnnotObj().finishNew();
	            } else {
	                return;
	            }
	            break;
	        case _defines2.default.eNavModes.nmRedraw: // halt pen redraw
	        case _defines2.default.eNavModes.nmRedrawStarting:
	            if (thisImg.getAnnotObj()) thisImg.getAnnotObj().regReDraw('finish');
	            break;
	        case _defines2.default.eNavModes.nmAutoPan:
	            // halt nav mode on mouse up in autopan
	            var className = e.relatedTarget.className; // if the mouse just rolled over the autopan center target, don't halt nav
	            if (className.indexOf(_defines2.default.clsAPANIMG) != -1) // note: since there can be multiple classNames (space delimited) so string-in-string is performed
	                return;
	            break;

	        case _defines2.default.eNavModes.nmRasterScan:
	            // do not halt nav mode on mouse up in rasterScan
	            return;
	        default:
	    }
	    _defines2.default.navModeHalt(thisImg); // mouseup always means halt nav mode - with the above exceptions
	}

	//............................................ vp_mousedclick
	// vp_mousedclick - This function dispatches mouse double click events.
	function vp_mousedclick(thisImg, e, isTouchEvent) {

	    // for iOS: the manner in which the double click is detected does not provide the
	    //            touch event in e and the page coords are 0,0
	    if (isTouchEvent) {
	        var mdPos = thisImg.getMouseDown();
	        var e = jQuery.Event('', { pageX: mdPos.x, pageY: mdPos.y }); // create event
	    }

	    switch (thisImg.navModeGet()) {
	        case _defines2.default.eNavModes.nmNone:
	            thisImg.zoomDblClick(e, isTouchEvent);
	            break;
	        case _defines2.default.eNavModes.nmAnnotCaliper:
	        case _defines2.default.eNavModes.nmAnnotPolygon:
	            var anObj = thisImg.getAnnotObj();
	            if (anObj && anObj.drawingIsStarted()) {
	                var crsrPosBase = _defines2.default.coordBaseImage(e, thisImg); // compute the position of the cursor in base image coords
	                anObj.updateNew(crsrPosBase, 'mousedown');
	                anObj.finishNew();
	                _defines2.default.navModeHalt(thisImg);
	            }
	            break;
	    }
	}

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.cb_regAddNote = exports.cb_addOnImageText = undefined;
	exports.default = AnnotationsService;

	var _defines = __webpack_require__(3);

	var _defines2 = _interopRequireDefault(_defines);

	var _toolbar = __webpack_require__(5);

	var _objects = __webpack_require__(7);

	var _region = __webpack_require__(26);

	var _region2 = _interopRequireDefault(_region);

	var _regions = __webpack_require__(28);

	var _regions2 = _interopRequireDefault(_regions);

	var _layer = __webpack_require__(29);

	var _layer2 = _interopRequireDefault(_layer);

	var _layers = __webpack_require__(30);

	var _layers2 = _interopRequireDefault(_layers);

	var _annotdraw = __webpack_require__(27);

	var _events = __webpack_require__(10);

	var _helpers = __webpack_require__(8);

	var _publicApi = __webpack_require__(18);

	var _publicApi2 = _interopRequireDefault(_publicApi);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var crazyLocalReferenceToGlobalUscopeNonSingleTonThatsActuallyASingletonForNowOmgPleaseMakeItStop = void 0;

	//________________________________________________________________________________________________
	// annotations.js
	//    This file contains the AnnotationsService object that manages annotation graphics.
	//
	//    history
	//    1108    cperz        created
	//    _______________________________________end_AIHv1/PR __________________________________________
	//    141118    cperz    add support for region copy and move;
	//    141222    cperz    extended to support image analysis
	//                    change call from ajaxXXXCall to doDATASVRREQ and doIMGSRVREQ with callbacks;
	//    150318    cperz    add support for analysis; add getAnTypeButtonClass();
	//                    update for doIMGSRVREQ signature change; add local logging;
	//                    regDelete - signature change;
	//    _______________________________________12.3 __________________________________________________
	//    150615    cperz    setSelColor: remove closing tag for updateRegionAndLayer;
	//                    getSpouseLayer_: correct get for layer id
	//    150730    cboar    fixed incorrect jQuery selector for us.APNOTE
	//________________________________________________________________________________________________
	//    Object Name: AnnotationsService
	//    Overview: The AnnotationsService obect performs all annotation related functionality for a given viewport (image).
	//
	//    Associated Panel:
	//        o cAnnotPanel
	//
	//    Dependencies and Supporting objects:
	//        o Annotations are drawn by the raphael javascript library which operates on
	//            HTML5 and non-HTML5 browser versions that we support.
	//        o cRegion
	//
	//    Assumptions:
	//        o todo
	//
	//    Limitations:
	//        o Early development of annotations did not employ layers so all annotations were just a region list.  The annotation panel
	//            navigation just walked through that list of regions.  Regions belonging to layers were implemented with IA however as
	//            it stands now there is a list of layers and a list of regions.  Regions know their layer but a layer doesn't know its regions.
	//            A lot of accessor code is wrapped around working between these two arrays.  Ideally the layer would create its regions.
	//            This might not be a good idea though, it should be thoughtfully considered.
	//
	//    Terms Used:
	//        o Abbreviations:
	//            A-Layer - annotation layer containing regions that can be a color that is not the layer color
	//            R-Layer - annotation layer containing the report region
	//            IA - Image Analysis
	//
	//    Functionality:
	//        Input/Output
	//            o Read all annotation layers and regions for a given image from the server
	//            o Write incremental annotation updates to the server as they occur
	//                or write all annotation updates to the server on image close
	//        Actions that are Annotation Specific
	//            For the 'Annotation' layer
	//                o Add, Delete, Select annotions
	//                o Change an annotation's color, note
	//                o Move, Redraw an annotation (in work, may not be exposed yet)
	//            For 'Analysis' layers
	//                o Display all input layers, regardless of where they were created
	//                o Hide all output layers (because they serve no purpose without markup images and analysis results)
	//                o Allow user to add regions to 'Annotation' layer only, in which they can change the color
	//                o Disable the color picker on layers other than A-Layer or R-Layer
	//        Interaction with Image Navigation
	//            o Translation of annotations is performed by translate()
	//            o Scaling of annotations is performed by scale()
	//            o Rotation of annotations is performed by rotate()
	//            o Next/Previous annotation navigation is performed by regSelectNextPrev
	//
	//    Data Structures:
	//        There are 3 data structures of import here:
	//        1) the annotation xml, fetched from the server, parsed and maintained in a jquery object
	//            - colors maintained in BGR order here because that is the annotation format standard
	//        2) the raphael 'paper', a canvas that is contained in a div covering the viewport,
	//            that presents the annotation graphics
	//        3) the array 'rfRegions' (in cRegions) that is used to relate between the annotation xml and the graphics paper
	//            - colors maintained in RGB order here because that is natural to SVG graphics
	//
	//    HTML:
	//        The annotations    div is created in anDivBuild() and is appended to its viewport div.
	//
	// Inter-Op Annotations: between uScope and ImageScope | WebScope
	//        o Display all input layers, regardless of where they were created
	//        o Hide all output layers (because they serve no purpose without markup images and analysis results)
	//        o Allow user to add regions to 'Annotation' layer only, in which they can change the color
	//        o Disable the color picker on layers other than A-Layer or R-Layer
	//
	//    References:
	//        raphael.js is used to draw the vector graphics: http://raphaeljs.com
	//        Scalable Vector Graphics: http://www.w3.org/TR/SVG/
	//        SVG attribute index: http://www.w3.org/TR/SVG/attindex.html
	//________________________________________________________________________________________________
	function AnnotationsService(uScope, viewport) {
	    var self = this;
	    var status = false;

	    // ..... to group fns in js parser, for ease of search (e.g. search for all 'CANNOT_XFORM')
	    var CANNOT = this;
	    var CANNOT_INIT = this;
	    var CANNOT_GET = this;
	    var CANNOT_SET = this;
	    var CANNOT_PAINT = this;
	    var CANNOT_DRAW = this;
	    var CANNOT_XFORM = this;
	    var CANNOT_MARKUP = this;
	    var CANNOT_DEBUG = this;
	    var CANNOT_SAVE = this;
	    var CANNOT_LAYER = this;
	    var CANNOT_REGION = this;

	    // Wow I can't believe I'm doing this... TODO: Slap yourself a couple times. Really. Hard.
	    crazyLocalReferenceToGlobalUscopeNonSingleTonThatsActuallyASingletonForNowOmgPleaseMakeItStop = uScope;

	    var anInitialized_ = false; // true when first annotation drawing is completed
	    CANNOT.isInitialized = function () {
	        return anInitialized_;
	    };

	    var anDivSelector; // selector to this annotation's div
	    self.anDivRect = new _objects.cRect(0, 0, 0, 0); // anDiv's current geometry

	    var lastLayerId = 0; // last layer id; used to set id for new layer
	    var lastRegionId = []; // last region id in each layer; used to set id for new region

	    //............................................ get/set status
	    CANNOT_GET.getStatus = function () {
	        return status;
	    };
	    CANNOT_SET.setStatus = function (bstate) {
	        status = bstate == true ? true : false;
	        if (status == false) _defines2.default.ENABLEANNOTCREATE = false;
	    };
	    //............................................ info
	    CANNOT_GET.getMyImage = function () {
	        return viewport;
	    }; // get the viewport instance associated with these annotations
	    CANNOT_GET.getImageId = function () {
	        return viewport.getImageId();
	    };

	    //............................................ logging fns
	    var logger = _defines2.default.helpers.createLogger(true, 'cAnnots ' + viewport.getImageId());
	    var log = logger.log;
	    var err = logger.error;

	    // TODO: What's these for?
	    CANNOT_DEBUG.log = log;
	    CANNOT_DEBUG.err = err;

	    //............................................ toString
	    CANNOT_DEBUG.toString = function (bDoShort, bReportResults) {
	        var rtnStr = '';
	        var theLayers = self.layers.getLayersArray();
	        for (var lay = 0, len = theLayers.length; lay < len; lay++) {
	            // directly access layer array for efficiency, could use getFirst(), getNext()
	            if (theLayers[lay]) {
	                rtnStr += '\n' + lay + ' Layer: ' + (bDoShort ? theLayers[lay].toStringShort() : theLayers[lay].toString(bReportResults));

	                var layerId = theLayers[lay].get('Id');
	                var regionArray = self.regions.findByProperty('layerId', layerId);
	                for (var r = 0, rlen = regionArray.length; r < rlen; r++) {
	                    if (regionArray[r]) rtnStr += '\n             ' + r + ' Region: ' + (bDoShort ? regionArray[r].toStringShort() : regionArray[r].toString(bReportResults));
	                }
	            }
	        }
	        return rtnStr;
	    };
	    //............................................
	    _defines2.default.anLayerTypesSupported[_defines2.default.anLayerTypes.manual] = true; // initialize array of supported types
	    _defines2.default.anLayerTypesSupported[_defines2.default.anLayerTypes.report] = true;
	    if (_defines2.default.ENABLEANALYSIS) _defines2.default.anLayerTypesSupported[_defines2.default.anLayerTypes.aafresult] = true;

	    self.regions = new _regions2.default(this, self.getImageId()); // create the one region collection; so much user interaction is on a region, direct ref to region is expedient
	    CANNOT_GET.getRegionsObj = function () {
	        return self.regions;
	    };

	    self.layers = new _layers2.default(this, self.getImageId()); // create the one layer collection
	    CANNOT_GET.getLayersObj = function () {
	        return self.layers;
	    };

	    // AnnotationsService tracks which layer is selected
	    self.selLayerIdx = -1; // currently selected layer index in layers layerArray
	    // AnnotationsService tracks which region is selected
	    self.rfSelected = -1; // currently selected region index in rfRegions
	    self.initialRfSelected = -1; // initial selected region in rfRegions - at time of read in

	    CANNOT_GET.getRegionsArray = function () {
	        return self.regions.getRegionsArray();
	    };
	    CANNOT_GET.getSelRegion = function () {
	        return self.regions.getByRfId(self.rfSelected);
	    }; // returns undefined if none selected
	    CANNOT_GET.getSelRegionId = function () {
	        return self.rfSelected;
	    };
	    CANNOT_GET.getSelType = function () {
	        return self.regions.getType(self.rfSelected);
	    };
	    CANNOT_GET.getSelShape = function () {
	        return self.regions.getShape(self.rfSelected);
	    };
	    CANNOT_GET.getSelRegionId = function () {
	        return self.regions.getRegionId(self.rfSelected);
	    };

	    CANNOT_GET.getSelLayer = function () {
	        return self.layers.getSelected();
	    };
	    CANNOT_GET.getSelLayerId = function () {
	        return self.layers.getSelectedId();
	    };
	    CANNOT_GET.getSelLayerIdx = function () {
	        return self.layers.getSelectedIdx();
	    };

	    CANNOT_GET.getSelColor = function () {
	        return self.regions.getRGB(self.rfSelected);
	    };
	    CANNOT_GET.getReportRegionId = function () {
	        return self.regions.getReportRegionId();
	    };

	    // all on rfSelected
	    CANNOT_GET.isWholeSlide = function () {
	        return self.regions.isWholeSlide(self.rfSelected);
	    };
	    CANNOT_GET.isWholeSlideMarkup = function () {
	        return self.regions.isWholeSlideMarkup(self.rfSelected);
	    };

	    // all on rfSelected
	    CANNOT_MARKUP.markupIsInView = function (cr2View) {
	        return self.regions.markupIsInView(self.rfSelected, cr2View);
	    }; // returns true/false
	    CANNOT_MARKUP.getSelMarkupImageId = function () {
	        return self.regions.getMarkupImageId(self.rfSelected);
	    }; // returns undefined if no markup
	    CANNOT_MARKUP.getMarkupInfo = function () {
	        return self.regions.getMarkupInfo(self.rfSelected);
	    }; // returns undefined if no markup
	    CANNOT_MARKUP.hasMarkup = function () {
	        return self.regions.hasMarkup(self.rfSelected);
	    };

	    //............................................ region highlight
	    // Define a highlight region for each region type.  This is better than creating and destroying
	    // raphael objects for each selection as raphael does not reuse the removed ids.
	    self.rfRegionHiLite = [];

	    //............................................ drawing
	    self.reDrawIdx = 0; // redraw vars
	    self.reDrawCnt = 0;
	    self.reDrawPrevPt = undefined;

	    CANNOT_DRAW.drawingIsStarted = function () {
	        // when newRegion is defined, drawing is going on
	        return self.newRegion != undefined;
	    };
	    CANNOT_DRAW.drawingCompleted = function () {
	        uScope.annotPanel.enableDrawingIcons(uScope.canAnnotate()); // change drawing icon state to enabled
	        self.newRegion = undefined;
	        _defines2.default.navModeHalt(viewport);
	    };

	    //............................................ init() - call back from ajaxGetAnnotations
	    var paintInitTries = 0;
	    CANNOT_INIT.init = function (xml) {
	        anDivBuild_(); // create annot div, attach graphics paper
	        if ((0, _helpers.isUnDefined)(self.paper)) {
	            viewport.err('AnnotationsService: Could not create graphics object; Disabling annotation drawing.');
	            _defines2.default.ENABLEANNOTCREATE = false;
	            return;
	        }
	        paintInitTimer_(xml);

	        //..................................................
	        // closure functions

	        //............................................ anDivBuild()
	        //    This function builds the div that will contain the annotation graphics and appends it to the viewport.
	        //    Then it creates the raphael graphics "paper" inside the annotations div.
	        //
	        //    Note: The annotations div is the dimensions of the base image in pixels.  Its left,top coord
	        //    corresponds an offset between the viewport and the base image's left, top coord of 0,0.
	        //
	        function anDivBuild_() {
	            if (uScope.isThisImageIdValid(viewport.getImageId()) == false) {
	                // protect against rapid slide close/open sequence
	                viewport.err('anDivBuild: image is not loaded');
	                return;
	            }
	            var vpclassid = _defines2.default.classFromImageId(viewport.getImageId()); // initialize this annotation's div selector and graphics "paper"
	            anDivSelector = _defines2.default.clsDotANNOTDIV + '.' + vpclassid;

	            var jVpDiv = viewport.vpDivGet();
	            if (jVpDiv.find(anDivSelector).length) // if this viewport already has an annot div, return
	                return;

	            var jAnnotDiv = $('<div/>', { // create this viewport's annotation div
	                'class': _defines2.default.clsANNOTDIV + ' ' + vpclassid + ' ' + _defines2.default.clsGRAPHICS
	            });
	            jVpDiv.append(jAnnotDiv); // append it to the viewport

	            anDivPosition_(); // position graphics with respect to viewport

	            jAnnotDiv = $(anDivSelector).get(0);
	            if (jAnnotDiv == undefined) {
	                // protect against rapid slide close/open sequence
	                viewport.err('anDivBuild: jAnnotDiv cannot be selected.  vpclassid: ' + vpclassid);
	                return;
	            }

	            self.paper = Raphael(jAnnotDiv, '100%', '100%'); // create the raphael paper tag inside the annot div

	            //note: the following are raphael rendering bug fixes
	            self.paper.renderfix(); // Fixes the issue of Firefox and IE9 regarding subpixel rendering.
	            self.paper.safari(); // There is an inconvenient rendering bug in Safari (WebKit): sometimes the rendering should be forced.

	            if (_defines2.default.DBGSTART) log('Raphael graphics, type:' + Raphael.type);
	        }

	        //............................................ paintInitTimer_
	        function paintInitTimer_(xml) {
	            if (viewport.isInitialized()) {
	                // if the first image refresh has completed
	                if (_defines2.default.DBGANNOT) log('annot: paintInitTimer: executing: nTries: ' + paintInitTries);
	                paintInit_(xml); //   then paint the annotations (at zoom = 1.0)

	                // after all regions are initialized, get their xinfo for analysis results and for markup
	                if (_defines2.default.ENABLEANALYSIS) {
	                    ///self.regions.initAnalysisResults(); //ia: todo: inwork - maybe a good thing for worker threads -- want to get all xinfo in one shot
	                    viewport.setWholeSlideMarkupImageId(_defines2.default.FORCE_VIEWREFRESH); // indicate when selected region has whole slide markup
	                }
	            } else {
	                // otherwise come back a little later and check the image paint status again
	                if (++paintInitTries < 4) {
	                    //    but don't try forever
	                    if (_defines2.default.DBGANNOT) log('annot: paintInitTimer: waiting for firstRefreshComplete: nTries: ' + paintInitTries);
	                    setTimeout(self.paintInitTimer(), 1000);
	                } else {
	                    err('paintInitTimer: annotation first draw: nTries: ' + paintInitTries);
	                }
	            }
	        }

	        //............................................  paintInit_()
	        //    This function parses the initial annotations stored in jsonObj_ into layer and region objects
	        //    and performs the initial rendering of the annotations.
	        function paintInit_(xml) {
	            if (_defines2.default.DBGANNOT) log('.............................................................................................start of annotation paintInit_');

	            self.paper.clear(); // remove all of the raphael graphics objects
	            self.regions.clear(); // remove all regions
	            var lastRfHandle = -1; // last region added
	            var selRfHandle = -1; // selected region

	            for (var type = 0; type < _defines2.default.kREGIONTYPES; type++) {
	                // create a new region object of each region type
	                var aRegion = new _region2.default({ 'type': type, isHighLight: true }, 'json', viewport);
	                self.rfRegionHiLite[type] = aRegion;
	            }

	            var x2js = new X2JS();
	            var jsonObj_ = x2js.xml_str2json(xml); // convert input xml to json object
	            if (_defines2.default.DBGANNOTEX) log('init: input: \n' + x2js.json2xml_str(jsonObj_));

	            // note... really cLayers could take all of this in.....
	            var jsAnnots = jsonObj_.Annotations.Annotation_asArray ? jsonObj_.Annotations.Annotation_asArray : [];

	            for (var l = 0, jlen = jsAnnots.length; l < jlen; l++) {
	                var jsLayer = jsAnnots[l]; // a layer :== [Annotation]
	                var aLayer = new _layer2.default(jsLayer, 'x2js'); // create this layer object from json
	                //toconsider: verify construction is ok?
	                var strLayerDbg = '\n.....layer: #' + l + ' ' + aLayer.toString(false);
	                if (aLayer.get('isSupported') == false) {
	                    // ignore un-supported layers and their regions
	                    if (_defines2.default.DBGANNOT) log('UnSupported Layer - will be ignored:\n' + strLayerDbg);
	                    continue;
	                }
	                self.layers.add(aLayer); // add aLayer to cLayers collection
	                // could self.layers.create(jsAnnots);// to build all the layers AND regions?

	                var jsRegions = jsLayer.Regions; // has RegionAttributeHeaders, Region[]
	                var nRegions = jsRegions.Region_asArray ? jsRegions.Region_asArray.length : 0;

	                for (var r = 0, rlen = nRegions; r < rlen; r++) {
	                    var jsRegion = jsRegions.Region_asArray[r];

	                    var aRegion = new _region2.default(jsRegion, 'x2js', viewport, aLayer); // create this region
	                    strLayerDbg += '\n             ...region #' + r + ' ' + aRegion.toString(true, false);

	                    if (aRegion.rfHandle) {
	                        // if successfully drawn
	                        self.regAdd(aRegion, false, false); // add the new region to the collection, don't save back to the db

	                        lastRfHandle = aRegion.rfHandle; // update last rfHandle
	                        var Selected = jsRegion._Selected === '1' ? true : false;
	                        if (aLayer.isSelected() && Selected) // if layer and region is selected,
	                            selRfHandle = aRegion.rfHandle; // then this is the selected rfHandle
	                    }
	                }
	                if (_defines2.default.DBGANNOT) log(strLayerDbg);
	            }
	            anInitialized_ = true; // annotations initialized now; allows markupRefresh to execute
	            initialView_(selRfHandle, lastRfHandle); // set the initial view according to the initial state parameters

	            // if there is no A-layer (or R-layer), the layer named 'Annotation' (or the layer containing the report region), create it now
	            self.layers.createAddSaveSpecial(_defines2.default.AnnotLayerName);
	            self.layers.createAddSaveSpecial(_defines2.default.ReportLayerName);

	            if (viewport.getViewZoom() !== 1.0) // if the inital zoom is not 1.0
	                self.scale(); // then scale the annotations
	            if (_defines2.default.DBGANNOT) log('Sel Region Idx: ' + self.rfSelected + ' Sel Layer Idx: ' + self.layers.getSelectedIdx() + ' .....................................................end of annotation paintInit_');
	            return true;

	            //..................................................
	            // closure functions
	            //............................................ initialView
	            // This function sets the initial view according to the initial state parameters.
	            //        Priority order of first view is derived from initial state parameters:
	            //        1) initial region - if present, the code below responds
	            //        then 2) initial x,y {optional z & mag} - if present, viewport already responded - just mag present works too
	            //        then 3) last selected region - if a region exists, the code below responds
	            //        then 4) center of image  - viewport's default and already performed
	            function initialView_(selRfHandle, lastRfHandle) {
	                // save selected region rfId that came from the db
	                if (selRfHandle !== -1) self.initialRfSelected = selRfHandle.id;else if (lastRfHandle != -1) self.initialRfSelected = lastRfHandle.id;

	                var initState = viewport.initState;
	                if ((0, _helpers.isDefined)(initState.regionId)) // if the initial state specified a region, go to it
	                    _publicApi2.default.goToRegion(initState.imageId, initState.regionId); // returns false if the specified region is not found
	                else {
	                        // otherwise,  select either the region last selected or the last region if it existed
	                        // if an initial location is specified then select but don't reposition to the region
	                        var bReposition = initState.centerX && initState.centerY ? false : true;

	                        if (selRfHandle != -1) self.regSelect({
	                            rfId: selRfHandle.id,
	                            bSaveSel: false,
	                            bReposition: bReposition
	                        });else if (lastRfHandle != -1) self.regSelect({
	                            rfId: lastRfHandle.id,
	                            bSaveSel: false,
	                            bReposition: bReposition
	                        });
	                    }
	                if (self.rfSelected == -1) // select the annotation layer if no regions are selected
	                    self.layers.selectByProperty('Name', _defines2.default.AnnotLayerName);
	                uScope.annotPanel.enableRegionIcons(self); // update the annotation navigation panel display
	            }

	            //..................................................
	        }
	    };
	    //............................................ regHoverShow()
	    //    This function shows/hides a hovering note associated with a region.
	    CANNOT_PAINT.regHoverShow = function (show, rfId) {
	        if (show) {
	            if ((0, _helpers.isDefined)(self.hoverMemoHandle)) self.hoverMemoHandle.show();
	            if ((0, _helpers.isDefined)(self.hoverMemoBBoxHandle)) self.hoverMemoBBoxHandle.show();
	            if ((0, _helpers.isUnDefined)(rfId)) {
	                var region = self.getSelRegion();
	                rfId = region.rfId;
	            }
	            self.rfDrawHover(rfId); // draw the hover note
	        } else {
	            if ((0, _helpers.isDefined)(self.hoverMemoHandle)) self.hoverMemoHandle.hide();
	            if ((0, _helpers.isDefined)(self.hoverMemoBBoxHandle)) self.hoverMemoBBoxHandle.hide();
	        }
	    };
	    //............................................ show - This function shows/hides all annotation graphics
	    CANNOT_PAINT.show = function (show) {
	        if (anDivSelector) {
	            if (show) $(anDivSelector).show();else $(anDivSelector).hide();
	        }
	    };
	    //............................................ rotate - This function rotate all annotation graphics (that remain upright during rotation)
	    //    Note that the annotation div naturally rotates with the view.
	    //    This function addresses rotation of individual shapes to anages other than that of the view.
	    CANNOT_XFORM.rotate = function (angleDeg) {
	        anDivPosition_(); // shift the graphics div to coincide with the viewport at this zoom
	        var paper = self.paper; // access to raphael for this image
	        var rfRegions = self.getRegionsArray();

	        for (var g = 0, glen = rfRegions.length; g < glen; g++) {
	            // scale and position the graphics
	            if ((0, _helpers.isDefined)(rfRegions[g])) {
	                var region = rfRegions[g];
	                (0, _annotdraw.rfRotate)(region, angleDeg);

	                if (g == self.rfSelected) {
	                    // update the highlight on the selected region
	                    var type = +region.type;
	                    var hiRegion = self.rfRegionHiLite[type]; // get the region that highlights this type
	                    (0, _annotdraw.rfRotate)(hiRegion, angleDeg);
	                }
	            }
	        }
	    };
	    //............................................ scale - This function scales all annotation graphics
	    CANNOT_XFORM.scale = function () {
	        if (anDivSelector != undefined) {
	            anDivPosition_(); // shift the graphics div to coincide with the viewport at this zoom
	            paint_();
	        }
	    };
	    //............................................ translate - This function translates all annotation graphics by repositioning the annotation div
	    CANNOT_XFORM.translate = function (vpLeft, vpTop, vpZoom) {
	        if (viewport != undefined && anDivSelector != undefined) {
	            var anDivRect = self.anDivRect;
	            var left = Math.floor(vpLeft / vpZoom);
	            var top = Math.floor(vpTop / vpZoom);

	            $(anDivSelector).css({ 'left': -left + 'px', 'top': -top + 'px' });
	            //if (us.DBGANNOTEX) log("translate: left,top: (" + -left + "," + -top + ")");

	            anDivRect.x = left;
	            anDivRect.y = top; // save current position
	        } else {
	            if ((0, _helpers.isDefined)(viewport) == false) (0, _toolbar.consoleWrite)('annot: translate: my image is not defined');
	        }
	    };
	    //............................................ anDivPosition_
	    //  This function sets the paper/canvas on-screen dimensions
	    //    and position to that of the viewport. Call when the viewport size changes.
	    var anDivPosition_ = function anDivPosition_() {
	        if (anDivSelector != undefined) {
	            var zoom = viewport.getViewZoom(); // shift the graphics div to coincide with the viewport at this scale
	            var csDims = viewport.getImageDims();

	            var w = csDims.w;
	            var h = csDims.h;
	            var left = Math.floor(viewport.getViewLeft() / zoom); // viewport's left, top coord
	            var top = Math.floor(viewport.getViewTop() / zoom);

	            var anDivRect = self.anDivRect;
	            //    if (anDivRect.x != left || anDivRect.y != top || anDivRect.w != w || anDivRect.h != h) {
	            //if (us.DBGANNOTEX) log("anDivPosition_: (" + -left + "," + -top + ")i" + "   W x H:" + w + " x " + h + "  zoom: " + zoom + "  mag: " + viewport.getViewMag());
	            $(anDivSelector).css({ 'left': -left + 'px', 'top': -top + 'px', 'width': w + 'px', 'height': h + 'px' });
	            anDivRect.x = left;
	            anDivRect.y = top;
	            anDivRect.w = w;
	            anDivRect.h = h; // save current position
	            //    }
	        }
	    };
	    //............................................ paint_ - This function redraws all annotation graphics
	    var paint_ = function paint_() {
	        var paper = self.paper; // access to raphael for this image
	        var rfRegions = self.getRegionsArray();

	        for (var g = 0, glen = rfRegions.length; g < glen; g++) {
	            // scale and position the graphics
	            if ((0, _helpers.isDefined)(rfRegions[g])) {
	                (0, _annotdraw.rfDraw)(paper, rfRegions[g], viewport.getViewZoom(), viewport.getViewAngle(true));
	                if (g == self.rfSelected) // update the highlight on the selected region
	                    self.regHighLight(rfRegions[g], true, viewport.getViewZoom(), viewport.getViewAngle(true));
	            }
	        }
	    };
	    //............................................ paintSelRegion - This function redraws the selected annotation region
	    CANNOT_PAINT.paintSelRegion = function (bDoHighlight) {
	        var paper = self.paper; // access to raphael for this image
	        var region = self.getSelRegion(); // ref to the selected region
	        var viewZoom = viewport.getViewZoom();
	        var viewAngleDeg = viewport.getViewAngle(true);
	        (0, _annotdraw.rfDraw)(self.paper, region, viewZoom, viewAngleDeg);
	        if (bDoHighlight != false) // if not prohibited, update the highlight color of the selected region
	            self.regHighLight(region, true, viewZoom, viewAngleDeg);
	    };

	    //............................................ setSelColor
	    //    AnnotationsService.setSelColor - This function sets the color of the selected layer and region.
	    CANNOT_SET.setSelColor = function (decRGB) {
	        var decBGR = (0, _helpers.reverseCLR)(decRGB);
	        var thisImg = self.getMyImage();
	        var viewZoom = thisImg.getViewZoom();
	        var viewAngleDeg = thisImg.getViewAngle(true);

	        //_____
	        var aRegion = self.getSelRegion(); // reference the selected region
	        var aLayer = self.getSelLayer();
	        var alayerXML; // spouse layer is associated input or output layer
	        var sLayer; // spouse layer is associated input or output layer
	        var layerId; //
	        var regionXML, aLayerXML, slayerXML; //

	        if (aLayer && aRegion == undefined) {
	            // is there a selected layer and no selected region?
	            layerId = aLayer.get('Id');
	            sLayer = getSpouseLayer_(aLayer);

	            alayerXML = '<Annotation Id="' + layerId + '"' + ' LineColor="' + decBGR + '"' + '></Annotation>';
	            if (sLayer) alayerXML += '<Annotation Id="' + sLayer.get('Id') + '"' + ' LineColor="' + decBGR + '"' + '></Annotation>';
	            self.save({ action: 'updateLayer', layerId: layerId, layerXML: alayerXML });
	        } else if (aRegion) {
	            // if a region is selected
	            layerId = aRegion.get('layerId');
	            aLayer = self.layers.getLayerById(layerId);
	            sLayer = getSpouseLayer_(aLayer);
	            // save the region and layer color to the database
	            regionXML = '<Region Id="' + aRegion.get('regionId') + '"' + ' LineColor="' + decBGR + '"' + '></Region>';
	            alayerXML = '<Annotation Id="' + layerId + '"' + ' LineColor="' + decBGR + '"' + '>'; // do not include closing tag
	            self.save({
	                action: 'updateRegionAndLayer', layerId: layerId, layerXML: alayerXML,
	                regionId: aRegion.get('regionId'), regionXML: regionXML
	            });

	            if (sLayer) {
	                // save the spouse layer to the database
	                slayerXML = '<Annotation Id="' + sLayer.get('Id') + '"' + ' LineColor="' + decBGR + '"' + '></Annotation>';
	                self.save({ action: 'updateLayer', layerId: sLayer.get('Id'), layerXML: slayerXML });
	            }
	        } else {
	            return err('annot: setSelColor: no selected region, no selected layer, case not handled');
	        }
	        if (aLayer) aLayer.set('LineColor', decBGR); // set each layer's color
	        if (sLayer) sLayer.set('LineColor', decBGR);

	        //_____
	        if (aLayer.get('isAnnotLayer') == false) {
	            // if the layer is not the annotation layer,
	            setRegionColor(layerId); // then color all the regions of this layer
	            if (sLayer) setRegionColor(sLayer.get('Id')); // and if there exists a spouse layer, color its regions
	        }

	        if (aRegion) {
	            // if there was a selected region,
	            aRegion.setRGB(decRGB); // change the region color - necessary in case this is just a region on the annotation layer
	            (0, _annotdraw.rfDraw)(self.paper, aRegion, viewZoom, viewAngleDeg); // then repaint the region with the new color
	            self.regHighLight(aRegion, true, viewZoom, viewAngleDeg); // and update the highlight color of the selected region
	        }
	        return;

	        //..................................................
	        // closure functions
	        //............................................ getSpouseLayer_
	        function getSpouseLayer_(aLayer) {
	            var spouseLayer;
	            if (aLayer) {
	                var layerSpouseId = aLayer.get('InputAnnotationId'); // is this an output layer?
	                if (layerSpouseId) {
	                    // then its color is the same as the input layer
	                    spouseLayer = self.layers.getLayerById(layerSpouseId); // get the input layer and set its color
	                } else {
	                    // this is an input layer
	                    var layerId = aLayer.get('Id');
	                    var layerArray = self.layers.findByProperty('InputAnnotationId', layerId); // does it have an associated output layer?
	                    if (layerArray.length) {
	                        spouseLayer = layerArray[0]; //todo: note: not setting ALL output layers, assuming a single output layer here
	                    }
	                }
	            }
	            return spouseLayer;
	        }

	        //............................................ setRegionColor
	        function setRegionColor(layerId) {
	            if (layerId) {
	                var regionArray = self.regions.findByProperty('layerId', layerId); // then set the region color for all regions in the layer (no need to save to the db)
	                for (var r = 0, rlen = regionArray.length; r < rlen; r++) {
	                    regionArray[r].setRGB(decRGB); // change the region color
	                    (0, _annotdraw.rfDraw)(self.paper, regionArray[r], viewZoom, viewAngleDeg); // repaint the region with the new color
	                }
	            }
	        }

	        //..................................................
	    };

	    //............................................ saveAll
	    // AnnotationsService.saveAll - This function saves all the annotations to the database.
	    CANNOT_SAVE.saveAll = function () {
	        err('saveall:  not implemented');
	    };
	    //............................................ save
	    // AnnotationsService.save - This function saves the annotations to the database.
	    //        Although it can execute a complete save of all annotations its primary work is in saving
	    //        incremental updates to annotations.
	    //
	    // input parameters:
	    //        parms.action - required; operation to perform; choices are:
	    //                            saveAll -
	    //                            addRegion -
	    //                            delRegion -
	    //                            updateRegion -
	    //                            addLayer -
	    //                            delLayer -
	    //                            updateLayer -
	    //                            updateRegionAndLayer -
	    //
	    //      The presence of the following parameters depend upon the action specified:
	    //        parms.layerId - the id of the layer
	    //        parms.regionId - the id of the region
	    //        parms.layerXML - the xml content to attach to the <Annotations> node
	    //        parms.regionXML - the xml content to attach to the <Regions> node
	    //        parms.tag - a string to enclose in <tag> </tag> that data server will echo back - used to associate reqeusts and responses
	    //
	    //
	    CANNOT_SAVE.save = function (parms) {
	        if (parms.action === 'saveAll') return self.saveAll();

	        var preamble = 'save: ' + parms.action + ': ';
	        var xml;
	        var xmlns = 'http://www.aperio.com/webservices/';
	        var imageId = (0, _helpers.stripLeadingAtSign)(self.getImageId()); // id sent as a number, no leading '@'

	        if (parms.action === 'delRegion') {
	            if ((0, _helpers.isUnDefined)(parms.layerId) || (0, _helpers.isUnDefined)(parms.regionId)) return err(preamble + ' layer or region id undefined');

	            //    <ImageId>10</ImageId>
	            //    <AnnotationsNode><DeletedAnnotations><Annotation Id="19"><Regions><Region Id="390"/></Regions></Annotation></DeletedAnnotations></AnnotationsNode>
	            var xml = '<ImageId>' + imageId + '</ImageId>' + '<AnnotationsNode>' + (parms.tag ? '<Tag>' + parms.tag + '</Tag>' : '') + '<DeletedAnnotations>' + '<Annotation Id="' + parms.layerId + '"' + '>' + '<Regions><Region Id="' + parms.regionId + '"' + '/></Regions>' + '</Annotation></DeletedAnnotations></AnnotationsNode>';
	        } else if (parms.action === 'delLayer') {
	            if ((0, _helpers.isUnDefined)(parms.layerId)) return err(preamble + ' layer id undefined');

	            //    <ImageId>10</ImageId>
	            //    <AnnotationsNode><DeletedAnnotations><Annotation Id="19"></Annotation></DeletedAnnotations></AnnotationsNode>
	            var xml = '<ImageId>' + imageId + '</ImageId>' + '<AnnotationsNode>' + (parms.tag ? '<Tag>' + parms.tag + '</Tag>' : '') + '<DeletedAnnotations>' + '<Annotation Id="' + parms.layerId + '"' + '>' + '</Annotation></DeletedAnnotations></AnnotationsNode>';
	        } else if (parms.action === 'addRegion') {
	            if ((0, _helpers.isUnDefined)(parms.layerId) || (0, _helpers.isUnDefined)(parms.regionXML)) return err(preamble + ' layer or region id or regionXML undefined');

	            //    <ImageId>10</ImageId>
	            //    <AnnotationsNode>
	            //        <Tag>echoed information here</Tag> // return original, negative regionId so assigned Id can be replaced
	            //        <Annotations><Annotation Id="17">
	            //            <Regions><Region Id="-474" ... DisplayId="-474"> ... <Region></Regions>
	            //        </Annotation></Annotations>
	            //    </AnnotationsNode>
	            var xml = '<ImageId>' + imageId + '</ImageId>' + '<AnnotationsNode>' + (parms.tag ? '<Tag>' + parms.tag + '</Tag>' : '') + '<Annotations>' + '<Annotation Id="' + parms.layerId + '"' + '>' + '<Regions>' + parms.regionXML + '</Regions>' + '</Annotation></Annotations></AnnotationsNode>';
	        } else if (parms.action === 'updateRegion') {
	            if ((0, _helpers.isUnDefined)(parms.layerId) || (0, _helpers.isUnDefined)(parms.regionXML)) return err(preamble + ' layer or region id or regionXML undefined');

	            //    <ImageId>10</ImageId>
	            //    <AnnotationsNode><Annotations><Annotation Id="17">
	            //        <Regions><Region Id="12" ... > ... <Region></Regions>
	            //    </Annotation></Annotations></AnnotationsNode>
	            var xml = '<ImageId>' + imageId + '</ImageId>' + '<AnnotationsNode>' + (parms.tag ? '<Tag>' + parms.tag + '</Tag>' : '') + '<Annotations>' + '<Annotation Id="' + parms.layerId + '"' + '>' + '<Regions>' + parms.regionXML + '</Regions>' + '</Annotation></Annotations></AnnotationsNode>';
	        } else if (parms.action === 'addLayer') {
	            if ((0, _helpers.isUnDefined)(parms.layerXML)) return err(preamble + ' layer xml undefined');

	            //    <ImageId>10</ImageId>
	            //    <AnnotationsNode>
	            //        <Tag>echoed information here</Tag>
	            //        <Annotations><Annotation Id="-17" ...></Annotation></Annotations>
	            //    </AnnotationsNode>
	            var xml = '<ImageId>' + imageId + '</ImageId>' + '<AnnotationsNode>' + '<Tag>' + parms.tag + '</Tag>' // return original, negative layerId so assigned Id can be replaced
	            + '<Annotations>' + parms.layerXML + '</Annotations></AnnotationsNode>';

	            //debug-only log("save: addLayer: \n  XML: " + xml);
	        }
	        //    //////////////////////////////////////////////////////////////////todo: this did not work and I don't know why...
	        //    else if (parms.action === 'addLayers') {
	        //        //parms={ "action": "addLayers", "tags": [], "xmlLayers": [], "cbSuccessFn": opt_cbSuccessFn });

	        //        //todo: extract tag "tag": aLayer.get('Id'), in addLayer and addRegion... etc

	        //        var xml = '<ImageId>' + imageId + '</ImageId>' + '<AnnotationsNode>';
	        //        for (var l = 0, len = parms.xmlLayers.length; l < len; l++)
	        //            xml += '<Tag>' + parms.tags[l] + '</Tag>'            // return original, negative layerId so assigned Id can be replaced
	        //                + '<Annotations>' + parms.xmlLayers[l] + '</Annotations>';
	        //        xml += '</AnnotationsNode>';

	        //        log('save: addLayers: nLayers: ' + parms.xmlLayers.length + "\n  XML: " + xml);
	        //        ///        return;///////////temp until I like the xml
	        //    }
	        //    //////////////////////////////////////////////////////////////////
	        else if (parms.action === 'updateLayer') {
	                if ((0, _helpers.isUnDefined)(parms.layerXML)) return err(preamble + ' layer xml undefined');

	                //    <ImageId>10</ImageId>
	                //    <AnnotationsNode><Annotations><Annotation Id="-17" ...></Annotation></Annotations></AnnotationsNode>
	                var xml = '<ImageId>' + imageId + '</ImageId>' + '<AnnotationsNode>' + (parms.tag ? '<Tag>' + parms.tag + '</Tag>' : '') + '<Annotations>' + parms.layerXML + '</Annotations></AnnotationsNode>';
	            } else if (parms.action === 'updateRegionAndLayer') {
	                if ((0, _helpers.isUnDefined)(parms.layerId) || (0, _helpers.isUnDefined)(parms.regionId) || (0, _helpers.isUnDefined)(parms.layerXML) || (0, _helpers.isUnDefined)(parms.regionXML)) return err(preamble + ' layer or region id or XML undefined');

	                //    <ImageId>10</ImageId>
	                //    <AnnotationsNode><Annotations><Annotation Id="17" Selected="1">
	                //        <Regions><Region Id="12" ... > ... <Region></Regions>
	                //    </Annotation></Annotations></AnnotationsNode>
	                var xml = '<ImageId>' + imageId + '</ImageId>' + '<AnnotationsNode>' + (parms.tag ? '<Tag>' + parms.tag + '</Tag>' : '') + '<Annotations>' + parms.layerXML // note that closing tag must not be present
	                + '<Regions>' + parms.regionXML + '</Regions>' + '</Annotation></Annotations></AnnotationsNode>';
	            } else {
	                if (_defines2.default.DBGANNOT) log(preamble + 'unknown action');
	                return;
	            }

	        if (_defines2.default.DBGANNOT) log(preamble + '\n' + xml);

	        if ((0, _helpers.isDefined)(xml)) {
	            // send the request
	            self.getMyImage().ajax.doDATASVRREQ(cbSuccessFn, undefined, 'PutAnnotations3', xml, parms);
	        }

	        //..................................................
	        // closure functions
	        //............................................ cbSuccessFn()
	        function cbSuccessFn(data, textStatus, jqXHR, cbParms) {
	            var preamble = 'annot: cbSuccessFn: ' + cbParms.action + ': ';

	            var idx = -1;
	            var responseText = jqXHR.responseText;
	            if ((idx = responseText.lastIndexOf('>')) !== -1) responseText = responseText.slice(0, idx + 1); // remove the null termination and the carriage return on the end of the response
	            if (_defines2.default.DBGANNOTEX) log(preamble + '\n' + responseText);

	            //    The minimum response is:
	            //        <PutAnnotations3Response xmlns="http://www.aperio.com/webservices/">
	            //            <PutAnnotations3Result>
	            //                <ASResult>0</ASResult> <ASMessage/>
	            //                </PutAnnotations3Result>
	            //            <AnnotationsNode>
	            //                <Annotations/>
	            //            </AnnotationsNode>
	            //        </PutAnnotations3Response>

	            var xmlDoc = $.parseXML(responseText);
	            var $xml = $(xmlDoc);
	            var jResponse = $xml.find('PutAnnotations3Response');
	            var jResult = jResponse.find('ASResult');

	            if (jResult.text() != '0') {
	                var jMessage = jResponse.find('ASMessage'); //s/b [ asmessage ]
	                err(preamble + '  msg:' + jMessage.text() + '  code: ' + jResult.text());
	                return;
	            }

	            if (cbParms.action === 'addRegion') {
	                var imageId = '@' + jResponse.find('ImageId').text(); // i always precede imageId number with @

	                var layerId = jResponse.find('Annotation').attr('Id');
	                var jTag = jResponse.find('Tag'); // get the returned tag
	                var oRegionId = parseInt(jTag.text()); // the original, negative region id
	                var jRegion = jResponse.find('Region'); // s/b [  ]
	                var regionId = jRegion.attr('Id'); // the assigned region id

	                // replace the temporary negative regionId with the one assigned by dataserver
	                self.regions.addRegionResponse({ imageId: imageId, negId: oRegionId, assignedId: regionId });
	            } else if (cbParms.action === 'addLayer') {
	                if (cbParms.cbSuccessFn) cbParms.cbSuccessFn(jResponse, cbParms);
	            }
	        }
	    };

	    //............................................ construct_() local
	    var construct_ = function construct_() {
	        viewport.ajax.doIMGSRVREQ(onSuccess, onFailure, 'GETANNOTATIONS', {
	            'request': 'GETANNOTATIONS',
	            'imageId': self.getImageId()
	        }, 'html');

	        function onSuccess(data, textStatus, jqXHR) {
	            self.init(data); // initialize the annotations class
	        }

	        function onFailure(jqXHR, textStatus, errorThrown) {
	            self.setStatus(false); // indicate that GETANNOTATIONS failed
	            log('GETANNOTATIONS: ' + viewport.ajax.getErrorStr(jqXHR, self.getImageId()));
	            (0, _events.triggerUScopeEvent)(_defines2.default.evAJAXERROR, { imageId: self.getImageId(), request: 'GETANNOTATIONS', jqXHR: jqXHR });
	        }
	    };

	    viewport.events.on('viewport:rotate', self.rotate);

	    //............................................ construction
	    construct_();

	    //............................................ regSelect
	    // AnnotationsService.regSelect - This function deselects the currently selected graphics object and
	    //                selects the specified new one.
	    //
	    //    input parms:
	    //        rfId:            required if regionId not provided, index into rfRegions to select
	    //        regionId:        required if rfId not provided, id of region to select
	    //                note: if both rfId and regionId are provided, rfId is used
	    //
	    //        bReposition:    optional, default true, reposition the view to center on the selection at the region zoom
	    //        bDoZoom:        optional, default true, zoom to region's zoom
	    //        bSaveSel:        optional, default true, update the database - this region/layer selected
	    //                        - note that this may be overridden by us.ENABLEANNOTSELSAVE in which case it will not be saved
	    CANNOT_REGION.regSelect = function (parms) {
	        var thisImg = self.getMyImage();
	        var rfRegions = self.getRegionsArray(); //

	        var rfId = parms.rfId;
	        if (rfId == undefined && parms.regionId) // if rfId not defined and regionId is, find rfId of that regionId in rfRegions
	            rfId = (0, _helpers.getIndexWith)(rfRegions, 'regionId', parms.regionId); // returns -1 if regionId is not in rfRegions

	        if (rfId == undefined || rfId < 0 || (0, _helpers.isValidArrayIndex)(rfRegions, rfId) == false) {
	            // insure a valid region
	            self.log('regSelect: missing both rfId and regionId');
	            return false;
	        }

	        var region = rfRegions[rfId]; // newly selected region
	        ///    if (us.DBGANNOT) self.log("\nregSelect:" + self.rfSelected + " --> " + rfId + "\n  " + region.toString(false));

	        var bReposition = (0, _helpers.isUnDefined)(parms.bReposition) || parms.bReposition == true ? true : false;
	        var bSaveSel = _defines2.default.ENABLEANNOTSELSAVE; // if saving the selection is disabled, disregard parms.bSaveSel
	        if (bSaveSel) bSaveSel = (0, _helpers.isUnDefined)(parms.bSaveSel) || parms.bSaveSel == true ? true : false;

	        var curZoom = thisImg.getViewZoom();
	        if (self.rfSelected !== rfId) {
	            // if the passed region is not already selected

	            // deselection of the previous (current) graphic
	            if (self.rfSelected >= 0 && rfRegions[self.rfSelected] != undefined) {
	                // if the current select is valid
	                var prevSel = self.rfSelected;
	                var prevRegion = rfRegions[self.rfSelected];
	                self.regHighLight(prevRegion, false, region.zoom, thisImg.getViewAngle(true));

	                if (uScope.canSaveAnnotations() && bSaveSel) // send a layer and region update message
	                    prevRegion.onSelectChange(false);
	            }
	            var prevRfSelected = self.rfSelected;
	            self.rfSelected = rfId; // select the new region annotation xml

	            var layerId = self.regions.getLayerId(self.rfSelected); // get layerId of this region
	            self.layers.selectByProperty('Id', layerId); // and select the layer  ////////////??? maintaining this in layers and annotations??????
	            if (_defines2.default.DBGANNOT) self.log('regSelect:' + prevRfSelected + ' --> ' + self.rfSelected + '     ' + region.toStringShort(false));

	            // and highlight the region at the intended zoom
	            self.regHighLight(region, true, bReposition ? region.zoom : curZoom, thisImg.getViewAngle(true));

	            if (uScope.canSaveAnnotations() && bSaveSel) // send a layer and region update message
	                region.onSelectChange(true);

	            if (self.isInitialized() && region.regionId >= 0) {
	                // fire event that annotations have changed
	                (0, _events.triggerUScopeEvent)(_defines2.default.evANNOTCHANGE, {
	                    imageId: region.imageId, regionId: region.regionId, layerId: region.layerId,
	                    anShape: region.isReportRegion ? 'report' : region.shape, action: 'sel'
	                });
	            }
	        }

	        if (bReposition) {
	            // if specified to reposition the view (this is default behavior)
	            var pt = region.getCenter();
	            //if (us.DBGNAV || us.DBGANNOT) log("regSelect: region center: " + pt.toString() + "  zoom: " + rfRegions[self.rfSelected].zoom);

	            var bDoMove = false;
	            // if region center is within the view, no need to reposition
	            var cpViewCenter = thisImg.getViewCenter(); // in zoom image coords
	            var ptViewCenter = new _objects.cPoint(cpViewCenter.x * curZoom, cpViewCenter.y * curZoom);
	            var dx = Math.abs(pt.x - ptViewCenter.x),
	                dy = Math.abs(pt.y - ptViewCenter.y);
	            //debug-only self.log('regSelect doMove test X ' + dx + ' > ' + (thisImg.getViewWidth() /2) + '     Y ' + dy + ' > ' + (thisImg.getViewHeight()  / 2));
	            if (dx > thisImg.getViewWidth() / 2 || dy > thisImg.getViewHeight() / 2) bDoMove = true;

	            var bDoZoom = parms.bDoZoom != undefined ? parms.bDoZoom : Math.abs(region.zoom - curZoom) > 0.1;
	            //dbg-only self.log("regSelect:  bDoMove: " + bDoMove + " bDoZoom: " + bDoZoom);

	            if (bDoMove) // if the region isn't near the center of the view
	                thisImg.moveAbsoluteCenter(pt.x, pt.y); // then center it
	            if (bDoZoom) // if the region's zoom isn't close to the current zoom
	                thisImg.zoomAbsolute(region.zoom); // then change zooms
	        }
	        uScope.annotPanel.enableRegionIcons(this); // update the annotation navigation panel display

	        ///////////////////////////////////////////////////////////////////
	        ///todo: I don't think this is nec as trigger is listened for
	        //thisImg.markupRefresh('regSelect');                         // if the newly selected region has a markup, refresh markup
	        ///////////////////////////////////////////////////////////////////
	        return true;
	    };

	    //............................................ regSelectToCenter
	    // AnnotationsService.regSelectToCenter - This function zooms/centers the view at the currently selected region.
	    //
	    //    parameters:
	    //        opt_bDoZoom:    optional, boolean, default true, if false the view zoom is not changed
	    //
	    CANNOT_REGION.regSelectToCenter = function (opt_bDoZoom) {
	        var region = self.getSelRegion(); // ref to the selected region
	        if (region) {
	            var pt = region.getCenter(); // selected region's center pt
	            var thisImg = self.getMyImage();
	            if (opt_bDoZoom != false) thisImg.zoomAbsolute(region.zoom);
	            thisImg.moveAbsoluteCenter(pt.x, pt.y);
	        }
	    };

	    //............................................ regSelectSaveAtClose
	    // AnnotationsService.regSelectSaveAtClose - This function is intended to be used when closing an image
	    //        whose annotations were auto updated with the exception of the select/deselect state.
	    //        The user rights permission is checked in this function.
	    CANNOT_REGION.regSelectSaveAtClose = function () {

	        // if the user has rights to save annotations and the initial selection isn't the current selection
	        if (uScope.canSaveAnnotations() && self.initialRfSelected != self.rfSelected) {
	            var rfRegions = self.getRegionsArray();

	            if ((0, _helpers.isValidArrayIndex)(rfRegions, self.initialRfSelected)) {
	                var region = rfRegions[self.initialRfSelected];
	                region.onSelectChange(false);
	            }
	            if ((0, _helpers.isValidArrayIndex)(rfRegions, self.rfSelected)) {
	                var region = rfRegions[self.rfSelected];
	                region.onSelectChange(true);
	            }
	        }
	    };

	    //............................................ regSelectNextPrev
	    // AnnotationsService.regSelectNextPrev - This function selects the first, next, previous or last annotation.
	    //                    It returns true if it successfully selected an annotation, otherwise false.
	    //    passed parameters:
	    //        action:            required, string, "first", "next", "last", "previous", "current"
	    //        bReposition:    optional, default true, reposition the view to center on the selection
	    //
	    CANNOT_REGION.regSelectNextPrev = function (action, bReposition) {
	        if ((0, _helpers.isUnDefined)(bReposition)) bReposition = true;

	        var rfRegions = self.getRegionsArray();
	        if (rfRegions.length === 0 || self.rfSelected < 0) // if there are no regions, return
	            return false;

	        if (action == 'current') {
	            self.regSelectToCenter(); // if the current region is selected, select it which puts it in view
	            return true; // and return
	        }

	        var rfId = self.rfSelected; // start at currently selected region
	        if (action === 'first') rfId = -1; // or start at first index (once nextId is called)
	        else if (action === 'last') rfId = rfRegions.length; // or start at last index (once nextId is called)

	        var incr = action === 'next' || action === 'first' ? 1 : -1; // step through rfRegions forward or backwards?

	        rfId = nextId(rfId); // get starting next id
	        var cnt = 0; // count to insure loop is not infinite
	        do {
	            // step forward/backward thru the regions array
	            cnt++;
	            if (rfRegions[rfId] !== undefined) {
	                self.regSelect({ rfId: rfId, bReposition: bReposition }); // and select the next/previous region
	                return true; // and return
	            }
	            rfId = nextId(rfId);
	        } while (rfId !== self.rfSelected && cnt < rfRegions.length);
	        // end up here after region deletions when there is only one region left

	        self.regSelect({ rfId: self.rfSelected, bReposition: bReposition }); // select the lone region
	        return false;

	        //..................................................
	        // closure functions
	        function nextId(id) {
	            // internal fn to increment/decrement id
	            if (incr > 0) {
	                if (++id >= rfRegions.length) id = 0;
	            } else {
	                if (--id < 0) id = rfRegions.length - 1;
	            }
	            return id;
	        }

	        //..................................................
	    };

	    //............................................ regSelectDelete
	    //    AnnotationsService.regSelectDelete - This function deletes the selected annotation
	    CANNOT_REGION.regSelectDelete = function () {
	        var region = self.getSelRegion(); // ref to the selected region
	        if (region) {
	            self.regHighLight(region, false); // de-highlight the region
	            self.regDelete(region.get('regionId'));
	        }
	    };

	    //............................................ layerReInit
	    // This function is called after analysis is run to get the aafresult layer and its regions.
	    // Optionally it will select the output region associated with the passed opt_inputRegionId
	    // Optionally it will call the passed opt_cbLayerReInit with the layerId when the layer data has been loaded/parsed.
	    CANNOT_LAYER.layerReInit = function (layerId, opt_inputRegionId, opt_cbLayerReInit) {
	        /////////////////consider grouping with ther layer fns, consider just doing this inside cLayers?????????
	        var anObj = this; // for closure
	        var thisImg = self.getMyImage();
	        self.log('layerReInit: layerId: ' + layerId);
	        if (self.layers.getLayerById(layerId) == undefined) // insure the layer exists before requesting an update
	            return self.err('layerReInit: layer does not exist! layerId: ' + layerId);

	        var imageId = thisImg.getImageId();
	        var xml = '<ImageId>' + imageId.substr(1) + '</ImageId>' + '<AnnotationId>' + layerId + '</AnnotationId>';
	        thisImg.ajax.doDATASVRREQ(cbSuccessFn, cbFailureFn, 'GetAnnotations2', xml, {
	            'request': 'GetAnnotations2',
	            'imageId': imageId
	        });
	        return;

	        //..................................................
	        // closure functions
	        //............................................ cbSuccessFn()
	        // note the similarity here to paintInit
	        function cbSuccessFn(data, textStatus, jqXHR) {
	            var self = anObj;
	            var x2js = new X2JS();
	            var jsonObj_ = x2js.xml_str2json(data); // convert input xml to json object
	            ///if (us.DBGANNOTEX) self.log('layerReInit: cbSuccessFn: input: \n' + x2js.json2xml_str(jsonObj_));
	            if (_defines2.default.DBGANNOTEX) self.log('layerReInit: cbSuccessFn: input: \n' + data);

	            var jsLayer = jsonObj_.GetAnnotations2Response.AnnotationsNode.Annotations.Annotation;
	            var aLayer = new _layer2.default(jsLayer, 'x2js'); // create this layer object from json
	            //todo: verify construction is ok?
	            var strLayerDbg = '\n.....layer: ' + aLayer.toString(true);
	            self.layers.replace(aLayer); // replace aLayer to cLayers collection

	            var jsRegions = jsLayer.Regions; // has RegionAttributeHeaders, Region[]
	            var nRegions = jsRegions.Region_asArray ? jsRegions.Region_asArray.length : 0;

	            //todo: regions holds <RegionAttributeHeaders> where the ID here is that Attribute Name for a region...

	            for (var r = 0, rlen = nRegions; r < rlen; r++) {
	                var jsRegion = jsRegions.Region_asArray[r]; //

	                var bRegion = self.regions.getByRegionId(jsRegion._Id);
	                if (bRegion) // if the region already exists, remove it so it can be replaced
	                    self.regions.remove(bRegion.get('rfId')); // remove() does NOT update DB nor signal ANNOTCHANGE

	                var aRegion = new _region2.default(jsRegion, 'x2js', thisImg, aLayer); // create this region
	                strLayerDbg += '\n             ...region #' + r + ' ' + aRegion.toString(true, false);

	                if (aRegion.rfHandle) // if successfully drawn
	                    self.regAdd(aRegion); // add the new region to the collection, don't save back to the db
	            }
	            if (_defines2.default.DBGANNOT) self.log('layerReInit: ' + strLayerDbg);

	            if (opt_inputRegionId) // if the inputRegionId is defined
	                aRegion = self.regions.getByProperty('InputRegionId', opt_inputRegionId); // then find the output region with this opt_inputRegionId
	            if (aRegion) self.regSelect({ 'regionId': aRegion.get('regionId'), 'bReposition': true }); // and select the output region, show the markup
	            if (opt_cbLayerReInit) // if a callback is defined
	                opt_cbLayerReInit(aLayer.get('Id')); // then call it
	        }

	        //............................................ cbFailureFn()
	        function cbFailureFn(jqXHR, textStatus, errorThrown) {
	            var self = anObj;
	            self.err('GetAnnotations2: ' + thisImg.ajax.getErrorStr(jqXHR, self.getImageId()));
	            (0, _events.triggerUScopeEvent)(_defines2.default.evAJAXERROR, { imageId: self.getImageId(), request: 'GetAnnotations2', jqXHR: jqXHR });
	        }

	        //..................................................
	    };

	    //............................................ layerIsNamed
	    // AnnotationsService.layerIsNamed - This function returns true if the passed layerId is that of the layer named 'LayerName'.
	    //                This is useful to test if one is on the us.AnnotLayerName or us.ReportLayerName.
	    CANNOT_LAYER.layerIsNamed = function (layerId, LayerName) {
	        return self.layers.getNameById(layerId) == LayerName ? true : false;
	    };

	    //............................................ layerDelete
	    //    AnnotationsService.layerDelete - This function deletes an Annotation (layer).
	    //    parameters:
	    //        layerId:    req'd,    if <0 all layers are deleted;
	    //                            if >0 0 only the specified layer is deleted
	    CANNOT_LAYER.layerDelete = function (layerId) {
	        if (uScope.canAnnotate() == false) return;
	        if (layerId < 0) // if layerId < 0
	            self.layers.deleteAllLayers(); // then remove ALL layers
	        else // else
	            self.layers.deleteLayer(layerId); // remove the layer from the annotation xml
	    };

	    //............................................ regCopyTo
	    //    AnnotationsService.regCopyTo
	    //
	    //        cpBaseCenter:    cPoint, base coord to center region at
	    //        region:            cRegion,
	    //
	    //    potential issues:  adding to current layer, what if in a different image?  region needs to add to cRegions
	    CANNOT_REGION.regCopyTo = function (cpBaseCenter, regionToCopy) {
	        if (uScope.canAnnotate() == false) return;
	        var thisImg = self.getMyImage();
	        var paper = self.paper; // access to raphael for this image
	        //debug-only self.log('regCopyTo: Original Region: \n' + regionToCopy.toString());

	        var layerId = _defines2.default.chooseLayer(this, regionToCopy.get('type'));
	        var regionId = self.regions.getNextRegionId(); // will return a negative value that is a signal to dataserver of a new region

	        var aRegion = new _region2.default({ // create a new region object
	            'layerId': layerId, 'regionId': regionId, 'displayId': -regionId,
	            'type': regionToCopy.type, 'angleDeg': regionToCopy.angleDeg, 'zoom': regionToCopy.zoom,
	            'decRGB': regionToCopy.decRGB, 'isReportRegion': regionToCopy.isReportRegion,
	            pts: regionToCopy.copyPts()
	        }, 'json', self.getMyImage());

	        aRegion.centerAt(cpBaseCenter); // modify region points to center on input center pt
	        //if (us.DBGANNOT) self.log("Before Draw: aRegion     : " + aRegion.toString(false));

	        var rfHandle = (0, _annotdraw.rfDraw)(paper, aRegion, thisImg.getViewZoom(), thisImg.getViewAngle(true)); // draw this graphics object
	        self.regAdd(aRegion, true, true); // add the new region to the collection and save back to the db
	        //debug-only self.log('Copied Region: \n' + aRegion.toString());
	    };

	    //............................................ regAdd
	    //    AnnotationsService.regAdd - This function ...
	    CANNOT_REGION.regAdd = function (aRegion, bDoSave, bDoSelect) {
	        self.regions.add(aRegion, bDoSave);

	        //toconsider: this really doesn't belong here!!! I had to wait for the region to have a valid rfHandle but still... ol3 and all....perhaps the fn should move up to here
	        aRegion.addEventHandlers({ click: true, hover: true, textclick: true }); // register the click and hover event handlers for this region

	        // unselect the currently selected object and select this one (but don't reposition the view)
	        if (bDoSelect) self.regSelect({ rfId: aRegion.rfId, bReposition: false, bSaveSel: false });
	    };

	    //............................................ regDelete
	    //    AnnotationsService.regDelete - This function deletes the passed region object and updates, informs components and listeners.
	    CANNOT_REGION.regDelete = function (regionId) {
	        if (uScope.canAnnotate() == false) return self.log('regDelete: annotation changes not allowed for this image, this user');

	        var aRegion = self.regions.getByRegionId(regionId);
	        if (aRegion) {
	            var rfId = aRegion.get('rfId');
	            self.regions.del(rfId); // delete the region from the regions object and database

	            // if the deleted region had be the selected region
	            if (self.rfSelected == rfId && !self.regSelectNextPrev('next', false)) // select the next region but do not reposition the view
	                self.rfSelected = -1; // insure that it is understood that nothing is selected

	            uScope.annotPanel.enableDrawingIcons(uScope.canAnnotate()); // update the annotation drawing tools and navigation panel

	            //todo: i wonder that the hover event handler s/b removed and if that would eliminate the need for this call and fn
	            self.regHoverShow(false); // in case this region had hover note visible
	        }
	    };

	    //............................................ regMove
	    CANNOT_REGION.regMove = function (cpBaseDist) {
	        var region = self.getSelRegion(); // ref to the selected region
	        var ptList = region.getPts();

	        for (var i = 0, len = ptList.length; i < len; i++) {
	            ptList[i].addPoint(cpBaseDist);
	        }
	        self.paintSelRegion(_defines2.default.DO_HIGHLIGHT); // force a repaint of this region and paint the highlight
	    };

	    //............................................ regMoveCenter
	    CANNOT_REGION.regMoveCenter = function (cpBaseCenter) {
	        var region = self.getSelRegion(); // ref to the selected region
	        region.centerAt(cpBaseCenter); // modify region points to center on input cpCenter
	        self.paintSelRegion(_defines2.default.DO_HIGHLIGHT); // force a repaint of this region but do not paint the highlight
	    };

	    //............................................ regAddNote
	    //    regAddNote -
	    CANNOT_REGION.regAddNote = function (note) {
	        // add a note to the selected region
	        (0, _toolbar.setIconState)($('.' + _defines2.default.APNOTE), _defines2.default.APNOTE, 'enabled');
	        var region = self.getSelRegion();
	        if (region) {
	            region.addNote(note); // update note and save to database
	            self.regHoverShow(true, region.rfId); // show the hover note on screen
	        }
	    };
	}

	//-------------------------------------------------------------------------------------------------
	//    AnnotationsService Related
	//-------------------------------------------------------------------------------------------------

	//............................................ cb_addOnImageText
	// cb_addOnImageText - This function is a callback for placing text on the image.
	//
	//    Note that a note length equal to 0 is valid - erasing the prior note.
	//    todo: i'd like the callback inside of cAnnotation but that does not work because this callback is made from multiple services, which if you think about it, was a really bad idea.
	var cb_addOnImageText = exports.cb_addOnImageText = function cb_addOnImageText(crsrPos, onImageText) {
	    (0, _toolbar.setIconState)($('#' + _defines2.default.APANNOTTEXT), _defines2.default.APANNOTTEXT, 'enabled');
	    if (!onImageText || !crazyLocalReferenceToGlobalUscopeNonSingleTonThatsActuallyASingletonForNowOmgPleaseMakeItStop) return; // do nothing if the text is undefined

	    var iarRefs = crazyLocalReferenceToGlobalUscopeNonSingleTonThatsActuallyASingletonForNowOmgPleaseMakeItStop.getImageAnnotRegionRefs(true); // returns {thisImg,  anObj,  region}

	    if (onImageText[onImageText.length - 1] == '\n') // strip off trailing carriage return
	        onImageText = onImageText.substr(0, onImageText.length - 1);
	    onImageText = onImageText.substring(0, _defines2.default.textEditSpecs.maxChars); // limit number of characters

	    if (crsrPos) {
	        // if crsrPos is defined, add the region at crsrPos
	        if (onImageText.length != 0) {
	            // but don't add region if it has no content
	            iarRefs.anObj.startNew(_defines2.default.eAnTypes.text, crsrPos, iarRefs.thisImg.getViewZoom(), iarRefs.thisImg.getViewAngle(true), onImageText);
	        }
	    } else {
	        // else if no defined crsrPos the region text is being updated
	        if (onImageText.length != 0) {
	            // only change text if there is something to change (do not allow total clearing of on image text)
	            iarRefs.anObj.regAddNote(onImageText); // update region and database
	            (0, _annotdraw.rfDraw)(iarRefs.anObj.paper, iarRefs.region); // draw updated region
	        }
	    }
	};

	//............................................ cb_regAddNote
	// cb_regAddNote - This function is a callback for associating a memo with a region.
	//
	//    Note that a note length equal to 0 is valid - erasing the prior note.
	//    todo: i'd like the callback inside of cAnnotation but that does not work for some reason
	var cb_regAddNote = exports.cb_regAddNote = function cb_regAddNote(crsrPos, note) {
	    if (!crazyLocalReferenceToGlobalUscopeNonSingleTonThatsActuallyASingletonForNowOmgPleaseMakeItStop) return;

	    var thisImg = crazyLocalReferenceToGlobalUscopeNonSingleTonThatsActuallyASingletonForNowOmgPleaseMakeItStop.getThisImage();
	    if (thisImg.getAnnotObj()) {
	        thisImg.getAnnotObj().regAddNote(note);
	    }
	};

	// getAnTypeButtonClass - This function returns the button element class of the annotation type for the passed region or undefined
	_defines2.default.getAnTypeButtonClass = function (aRegion) {
	    var className;
	    var anType = (0, _helpers.isDefined)(aRegion) ? +aRegion.get('type') : -1;

	    if (anType >= 0) {
	        // get the element id of the selected annotation type
	        if (anType === _defines2.default.eAnTypes.pen) className = _defines2.default.APANNOTPEN;else if (anType === _defines2.default.eAnTypes.negpen) className = _defines2.default.APANNOTNEGPEN;else if (anType === _defines2.default.eAnTypes.rect && aRegion.get('isReportRegion')) className = _defines2.default.APANNOTREPORT;else if (anType === _defines2.default.eAnTypes.rect) className = _defines2.default.APANNOTRECT;else if (anType === _defines2.default.eAnTypes.ellipse) className = _defines2.default.APANNOTELLIPSE;else if (anType === _defines2.default.eAnTypes.arrow) className = _defines2.default.APANNOTARROW;else if (anType === _defines2.default.eAnTypes.pin) className = _defines2.default.APANNOTPIN;else if (anType === _defines2.default.eAnTypes.ruler) className = _defines2.default.APANNOTCALIPER;else if (anType === _defines2.default.eAnTypes.caliper) className = _defines2.default.APANNOTCALIPER;else if (anType === _defines2.default.eAnTypes.text) className = _defines2.default.APANNOTTEXT;else if (anType === _defines2.default.eAnTypes.polygon) className = _defines2.default.APANNOTPOLY;
	    }
	    return className;
	};

	// getRandomColor - This function returns a random color selection from us.colorPalette (in hex RGB format)
	_defines2.default.getRandomColor = function () {

	    var r = parseInt(Math.random() * _defines2.default.colorPalette.length);
	    return _defines2.default.colorPalette[r];
	};
	//________________________________________________________________________________________________

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = cRegion;

	var _lodashLite = __webpack_require__(9);

	var _ = _interopRequireWildcard(_lodashLite);

	var _defines = __webpack_require__(3);

	var _defines2 = _interopRequireDefault(_defines);

	var _objects = __webpack_require__(7);

	var _annotdraw = __webpack_require__(27);

	var _helpers = __webpack_require__(8);

	var _uScope = __webpack_require__(11);

	var _uScope2 = _interopRequireDefault(_uScope);

	var _xinfo = __webpack_require__(16);

	var _xinfo2 = _interopRequireDefault(_xinfo);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	//________________________________________________________________________________________________
	// region.js
	/**
	 * @file   example_action.h
	 * @Author Me (me@example.com)
	 * @date   September, 2008
	 * @brief  Brief description of file.
	 *
	 * Detailed description of file.
	 */
	//    This file contains the annotation region object 'cRegion' (single annotation region).
	//
	//    history
	//
	//    1302    cperz    created
	//    _______________________________________end_AIHv1/PR __________________________________________
	//    141118    cperz    ol3 integration
	//    141222    cperz    created to support image analysis; change call from ajaxXXXCall to doDATASVRREQ and doIMGSRVREQ
	//    150318    cperz    build out for analysis and markup;
	//                    update for doIMGSRVREQ signature change; construct: remove jquery option;
	//    _______________________________________12.3 __________________________________________________
	//    150612    cperz    construct_: draw with intiial view angle
	//    150615    cperz    onSelectChange: comment update
	//________________________________________________________________________________________________
	//    Object Name: cRegion
	//    Overview:  The cRegion object is a container for region information and is used as a reference
	//                between graphics in raphael paper and the annotation xml.
	//
	//    mu : MarkUp
	//________________________________________________________________________________________________

	//    cRegion
	//    inObj:        req'd, object containing properties for to-be-created region object
	//    inObjType:    req'd, type of inObj: {'json', 'x2js' or 'jquery'}
	//    vpObj:        req'd, cViewport object
	//    aLayer:        req'd only when inObjType == 'x2js'; a ref the cLayer this region belongs to

	function cRegion(inObj, inObjType, vpObj, aLayer) {
	    var self = this;
	    var thisImg = vpObj;
	    var thisAn = thisImg ? thisImg.getAnnotObj() : undefined;
	    var paper = thisAn ? thisAn.paper : undefined;

	    // ..... to group fns in js parser, for ease of search (e.g. search for all 'CREGION_GET')
	    var CREGION = this; //
	    var CREGION_GET = this; //
	    var CREGION_SET = this; //
	    var CREGION_MARKUP = this; //
	    var CREGION_ANALYSIS = this; //
	    var CREGION_POINTS = this; //
	    var CREGION_DEBUG = this;

	    //............................................ logging fns
	    var logger = _defines2.default.helpers.createLogger(true, 'cRegion');
	    var log = logger.log;
	    var err = logger.error;

	    // in/out from database ................................
	    //toconsider: I'd like to use the XML node names exactly here instead
	    self.regionId = 0; // current or new region id - never equal to 0
	    self.displayId = 0; // display id
	    // note that selected is not maintained in this object
	    self.Analyze = false; // means 'can run analysis', s/b in agreement with us.eAnAnalysis[self.type]

	    self.type = -1; // as given by us.eAnTypes[]
	    self.shape = undefined; // as given by us.anShapes[]
	    self.decRGB = undefined; // decimal value of color in RGB order
	    self.decBGR = undefined; // and color in BGR order too

	    self.zoom = 1.0; // zoom at time of orignal drawing
	    self.pts = []; // array of cPoints at base zoom

	    self.note = undefined; // text associated with this region
	    self.data = {}; // associative array for related data such as caliper distance measures


	    // analysis related
	    self.InputRegionId = undefined; // parent region, 0 means no parent (not analysis),  -1 means whole image
	    self.MarkupImageId = undefined; // either undefined or valid markup image id with the @ sign for internal use (saved without it)
	    self.MacroId = undefined; // copied from layer
	    self.MacroName = undefined; // copied from layer

	    // derived .............................................
	    self.isHighLight = false; // indicate region for hightlight outline
	    self.isReportRegion = false; // indicate report region status

	    self.openShape = false; // openShape is a flag for rfDraw, when true the form is not closed(while user is drawing); matters only to pen, polygon,

	    self.imageId = thisImg ? thisImg.getImageId() : 0;
	    self.layerId = 0; // associated layer id; never is a layer id 0

	    self.rfHandle = undefined; // the raphael object associated with this region
	    self.rfId = -1; // raphael id and used as index of region in rfRegions[]

	    // geometry
	    self.centerPt = new _objects.cPoint(-1, -1); // computed center of pts array, use getCenter() to compute & access
	    self.boundingBox = new _objects.cRect2(0, 0, 0, 0); // region or markup bounding box in base coords (pixels) at zoom = 1
	    self.angleDeg = 0.0; // view rotation angle at time of orignal drawing

	    // analysis and markup image related
	    self.isSmall = false; // relatively speaking, is this a small region at scan resolution? see notes on us.IMAGESERVER_MAXJDIM
	    self.isAnalyzed = false;
	    self.hasMarkup = false; // has an associated analysis markup image
	    self.isWholeSlide = false; // whole image analysis region
	    self.isWholeSlideMarkup = false; // whole image analysis region with markup

	    // markup xinfo
	    self.xinfo = undefined; // markup image xinfo
	    self.muInitialized = false; // markup image xinfo initialized
	    self.AlgorithmName = undefined; // markup algorithm name
	    self.tileWidth = 512;
	    self.tileHeight = 512; // markupmarkup tile dimensions; default to something so even if xinfo for markup isn't yet returned the render will work

	    //////////////////////////////////////////////////////todo: ia related .... still in work
	    var attributes = {};
	    CREGION_ANALYSIS.getRegionResults = function () {
	        return attributes;
	    };
	    CREGION_ANALYSIS.getRegionResultsLength = function () {
	        return (0, _helpers.assocArrayLength)(attributes);
	    };
	    CREGION_ANALYSIS.clearRegionResults = function () {
	        log(self.getRegionResultsLength());
	        attributes = {};
	        log(self.getRegionResultsLength());
	    };
	    //////////////////////////////////////////////////////

	    //todo: remove all above gets and use this approach and hide them in data = {} like cLayer does, also implement desc and descUpdate_();
	    CREGION_GET.get = function (str) {
	        return this[str];
	    };
	    CREGION_SET.set = function (key, value) {
	        this[key] = value;
	    };

	    //............................................ simple gets
	    CREGION_GET.getType = function () {
	        return self.type;
	    };
	    CREGION_GET.getShape = function () {
	        return self.shape;
	    }; //todo: better is use anShapes[] and don't keep this var
	    CREGION_GET.getZoom = function () {
	        return self.zoom;
	    };
	    CREGION_GET.getRegionId = function () {
	        return self.regionId;
	    };
	    ///    region_get.getRfId = function () { return self.rfId; };
	    CREGION_GET.getRGB = function () {
	        return self.decRGB;
	    };
	    CREGION_GET.getBGR = function () {
	        return self.decBGR;
	    };

	    CREGION_GET.getLayerId = function () {
	        return +self.layerId;
	    };

	    CREGION_ANALYSIS.getInputRegionId = function () {
	        return self.InputRegionId;
	    }; //
	    CREGION_ANALYSIS.getMacroId = function () {
	        return self.MacroId;
	    }; // from layer originally
	    CREGION_ANALYSIS.getMacroName = function () {
	        return self.MacroName;
	    }; // from layer originally

	    //............................................ markup getMarkupImageId
	    CREGION_MARKUP.getMarkupImageId = function () {
	        return self.MarkupImageId;
	    };

	    //............................................ cRegion markupIsInView
	    //    markupIsInView: returns true if region has a markup and it is in the passed view rect; otherwise false;
	    CREGION_MARKUP.markupIsInView = function (cr2View) {
	        return self.hasMarkup ? self.isInView(cr2View) : false;
	    };
	    //............................................ cRegion getMarkupInfo
	    var markupInfo = {}; // cRegion local var, cached markup info
	    CREGION_MARKUP.getMarkupInfo = function () {
	        if (markupInfo.AlgorithmName == undefined) {
	            // if this xinfo var has not been set in the object then the object has not been populated yet
	            computeGeometry_(); // insure geometry is up to date
	            markupInfo = {
	                hasMarkup: self.hasMarkup,
	                muInitialized: self.muInitialized,
	                AlgorithmName: self.AlgorithmName
	                //, // could get macro name and id from layer? getMacroName()
	                , regionId: self.regionId,
	                MarkupImageId: self.MarkupImageId,
	                boundingBox: self.boundingBox,
	                zoom: self.zoom,
	                isSmall: self.isSmall,
	                tileWidth: self.tileWidth,
	                tileHeight: self.tileHeight
	            };
	        }
	        return markupInfo;
	    };
	    //............................................ cRegion constructor
	    // This function construct the region given either a json or x2js input object.
	    // notes:
	    //        o event handlers not added because rfId is needed
	    //        o analysis results including markup imagery are not fetched at this time

	    var construct_ = function construct_(inObj, inObjType, aLayer) {
	        if (inObjType == 'json') {
	            // is input is json?  json used to create from user input
	            var json = inObj;
	            _.assign(self, inObj);

	            if (self.rfHandle) self.rfId = self.rfHandle.id;
	            if ((0, _helpers.isDefined)(json.type)) self.setType(+json.type); // remember this sets things related to type as well
	            if (json.decRGB) self.setRGB(json.decRGB);
	            if (json.decBGR) self.setBGR(json.decBGR);
	            if (json.MarkupImageId) self.MarkupImageId = '@' + json.MarkupImageId; // prepend @ sign - all image id's are in this format internally

	            if (self.shape == 'caliper' || self.shape == 'polygon') // update length for shapes that require it
	                self.computeLength();

	            //ia-todo: do derived stuff like isWholeSlideMarkup, ...
	        } else if (inObjType == 'x2js') {
	            // input is x2js object? x2js is used to create from xml input from dataserver
	            if (aLayer == undefined) // aLayer is required input
	                return err('Layer ref is required for object type x2js');
	            if (!(inObj.Vertices && inObj.Vertices.Vertex_asArray)) // sometimes regions without vertices are showing,  so just abort region creation
	                return err('Object type x2js does not contain vertices');

	            self.layerId = aLayer.get('Id');
	            //should I get the layer name, it can change right?
	            self.MacroId = aLayer.get('MacroId'); // cache the layer info needed for analysis presentation
	            self.MacroName = aLayer.get('MacroName');

	            self.regionId = inObj._Id; // '_item' is access to attribute 'item' of Region node
	            //?move back is currently in annot?            var Selected = inObj._Selected === "1" ? true : false;///if moved here, update onSelectChange()


	            //todo: probably if a region is selected then its layer should be selected
	            //debug-only  log("---region id:" + self.regionId + " xml:\n     " + $(jRegion)[0].outerHTML);

	            // if not undefined nor 0, this is the parent region (analysis only)
	            self.InputRegionId = inObj._InputRegionId && inObj._InputRegionId != '0' ? inObj._InputRegionId : undefined;

	            if (self.InputRegionId) {
	                // is this an analysis output region, a value of -1 means whole image
	                self.isAnalyzed = true;
	                self.isWholeSlide = self.InputRegionId < 0 ? true : false;
	                //todo: move this search to cRegions
	                var regionParent = self.InputRegionId != -1 ? thisAn.getRegionsObj().getByRegionId(self.InputRegionId) : undefined; // the parent region of this region

	                // the markup image is dimensioned only as large as it needs to be;  it is tiled but these tiles are not registered with image tiles, they align with the ROI
	                self.MarkupImageId = inObj._MarkupImageId ? '@' + inObj._MarkupImageId : undefined; // the imageId of a markup, can be undefined
	                self.hasMarkup = self.MarkupImageId ? true : false;
	                self.isWholeSlideMarkup = self.InputRegionId < 0 ? self.hasMarkup : false; //flag that this region is whole image analysis with a markup
	                ////Note: ImageLocation not used  // the markup path which for remote is an image id (w/o the @) (or not used by uscope: local file if this is a local tuning in imagescope)

	                if (regionParent) {
	                    var anType = regionParent.get('type'); // if Type is from parent region b/c iscope keeps changing output region rects to pen
	                    self.setType(anType);
	                    self.zoom = regionParent.get('zoom');
	                } else {
	                    // valid InputRegionId but no regionParent
	                    self.setType(_defines2.default.eAnTypes.rect);
	                    self.zoom = 1.0;
	                }

	                if (inObj.Attributes) {
	                    var IdNameLUT = aLayer.getRegionResultsLUT();
	                    //debug-only log("Region Id,Name LUT: " + toStringAssoc(regAttrIdName)); //debug-only

	                    var regAttrs = inObj.Attributes;
	                    for (var a = 0, alen = regAttrs.__cnt; a < alen; a++) {
	                        var attr = regAttrs.Attribute[a];
	                        if (attr == undefined) // because of same problem mentioned for layer attributes
	                            break;

	                        var Name = IdNameLUT[attr._Name] ? IdNameLUT[attr._Name] : attr._Name;
	                        attributes[Name] = attr._Value;
	                        if (IdNameLUT[attr._Name] == undefined) // if the look up failed
	                            err('Region Attributes numeric name: ' + attr._Name + ' has no match in Regions.RegionAttributeHeaders');
	                    }
	                    //debug-only log("              Region Results: " + toStringAssoc(attributes)); //debug-only
	                }

	                //no DisplayId??? but defined on output regions
	            } else {
	                // this is a non-analysis region
	                self.setType(inObj._Type);
	                var NegativeROA = inObj._NegativeROA == '1' ? true : false;
	                if (self.type == _defines2.default.eAnTypes.pen && NegativeROA) // if negativeROA indicated, switch to negative pen type
	                    self.setType(_defines2.default.eAnTypes.negpen);

	                var Zoom = 1. / inObj._Zoom; // the annotation zoom is the inverse of the image zoom
	                self.zoom = _defines2.default.helpers.roundToDecimals(Zoom);

	                // not impl var ImageFocus = inObj._ImageFocus;

	                self.displayId = inObj._DisplayId; //todo: capitalize my var!
	                self.isReportRegion = aLayer.get('isReportLayer');
	            }

	            self.Analyze = _defines2.default.eAnAnalysis[self.type] ? true : false; // means can run analysis

	            // LineColor for a region is only valid on the layer named 'Annotation'
	            var RegionBGR = aLayer.get('isAnnotLayer') && inObj._LineColor ? inObj._LineColor : aLayer.get('LineColor');
	            self.setBGR(RegionBGR);

	            var jsVertex = inObj.Vertices.Vertex_asArray;
	            self.pts = jsVertexToPtList(jsVertex);

	            if (inObj._Length) {
	                // ImageScope saves attribute "Length" (pixels)
	                self.data.lengthPixels = inObj._Length; // add additional info to region.data
	                self.data.lengthMicrons = distance_({ 'value': self.data.lengthPixels, 'toMicrons': true });
	            } else if (inObj._LengthMicrons) {
	                // WebScope saves attribute "LengthMicrons"
	                self.data.lengthMicrons = inObj._LengthMicrons;
	                self.data.lengthPixels = (self.data.lengthMicrons / thisImg.getMPP()).toFixed(1);
	            }
	            //todo: what to do about area input?
	            //if (jRegion.attr("Area")) {                                // ImageScope saves attribute "Area" (pixels)
	            //else if (jRegion.attr("AreaMicrons")) {                    // WebScope saves attribute "AreaMicrons"

	            self.note = inObj._Text ? (0, _helpers.fromPortable)(inObj._Text) : '';
	            self.rfHandle = (0, _annotdraw.rfDraw)(paper, self, thisImg.getViewZoom(), thisImg.getViewAngle(true)); // draw this graphics object
	            if (self.rfHandle) {
	                self.rfId = self.rfHandle.id;
	            } else {
	                return err('construct_: rfId: ' + self.rfId + ' Drawing failed');
	            }
	        } else {
	            return err('construct_: unrecognized inObjType: ' + inObjType);
	        }

	        if (self.decRGB == undefined) // if region color was not defined, randomly select a color
	            self.setRGB((0, _helpers.hexColortoRGB)(_defines2.default.getRandomColor()), false);
	        computeGeometry_(); //

	        //todo: I get the markup without needing its xinfo.  Waiting to see if I need its xinfo for anything
	        //      It is best not to have to get it if I don't have to
	        //if (us.ENABLEANALYSIS && self.hasMarkup) self.initMarkup();
	        return true;

	        //..................................................
	        // closure functions
	        //............................................ initMarkup
	        function initMarkup() {
	            if (self.hasMarkup) thisImg.ajax.doIMGSRVREQ(cbSuccessFn, cbFailureFn, 'XINFO', {
	                'request': 'XINFO',
	                'imageId': self.imageId
	            }, 'xml', self.MarkupImageId);
	            return;
	            //............................................ cbSuccessFn
	            function cbSuccessFn(data, textStatus, jqXHR) {
	                self.xinfo = new _xinfo2.default(log, self.MarkupImageId);
	                self.xinfo.init(data, self.MarkupImageId); // decode the markup's xinfo

	                self.AlgorithmName = self.xinfo.getAlgorithmName(); // save anything useful from markup's xinfo now
	                self.tileWidth = self.xinfo.tileWidth * _defines2.default.kTILEMULTIPLIER; //note that a markup's tile dims is not nec. the same as its parent tile dims
	                self.tileHeight = self.xinfo.tileHeight * _defines2.default.kTILEMULTIPLIER;
	                //debug - only if (us.DBGMARKUPEX) log("XINFO for markup successful, markup imageId: " + self.MarkupImageId + "  request tile dims: " + self.tileWidth + "x" + self.tileHeight);

	                self.xinfo = undefined; // to free up memory
	                self.muInitialized = true; // indicate markup info is initialized
	            }
	            //............................................ cbFailureFn()
	            function cbFailureFn(jqXHR, textStatus, errorThrown) {
	                log('doXINFO: (markup image): ' + thisImg.ajax.getErrorStr(jqXHR, self.MarkupImageId));
	            }
	            //..................................................
	        }
	        //............................................ jVertexToPtList
	        //    jVertexToPtList - This function converts a jq object of x,y vertices to an array of cPoints
	        function jVertexToPtList(jVertex) {
	            var ptList = [];
	            for (var v = 0, vlen = jVertex.length; v < vlen; v++) {
	                var x = jVertex.eq(v).attr('X');
	                var y = jVertex.eq(v).attr('Y');
	                var pt = new _objects.cPoint(x, y);
	                ptList.push(pt);
	            }
	            return ptList;
	        }
	        //    jsVertexToPtList - This function converts a x2js object of x,y vertices to an array of cPoints
	        function jsVertexToPtList(jsVertex) {
	            var ptList = [];
	            for (var v = 0, vlen = jsVertex.length; v < vlen; v++) {
	                var x = jsVertex[v]._X;
	                var y = jsVertex[v]._Y;
	                var pt = new _objects.cPoint(x, y);
	                ptList.push(pt);
	            }
	            return ptList;
	        }
	    };
	    //............................................ removeGraphics()
	    CREGION.removeGraphics = function () {
	        if (self.rfHandle) // remove the region from the graphics paper
	            self.rfHandle.remove();

	        if (self.data.rfTextHandle) // remove any custom handles
	            self.data.rfTextHandle.remove();
	        if (self.data.textBBoxHandle) self.data.textBBoxHandle.remove();
	    };

	    //............................................ addEventHandlers()
	    // note: event handlers for region can only be added after region is drawn and has a valid rfHandle
	    CREGION.addEventHandlers = function (json) {

	        if (self.isWholeSlide == false && self.rfHandle) {
	            //debug-only log("addEventHandlers: rfId: " + self.rfId + " " + toStringAssoc(json));
	            if (json.click && json.click == true) self.rfHandle.click(cb_regClick); // register the click handler
	            if (json.hover && json.hover == true) self.rfHandle.hover(cb_regHover); // register the hover hanlder

	            if (json.textclick && json.textclick == true) {
	                var rfTextHandle = self.data.rfTextHandle;
	                if (rfTextHandle) {
	                    rfTextHandle.click(cb_regClick); // register the buddy text for on click events
	                    rfTextHandle.data('parentRfId', self.rfId); // save parent id so it can be used as the highlighted graphic
	                }
	            }
	        } else {
	            log(' addEventHandlers: not added, rfHandle: ' + self.rfHandle);
	        }
	        //..................................................
	        // closure functions
	        //............................................ cb_regClick()
	        // This function sorts out the parent region for a click (associated text is a child region)
	        function cb_regClick() {
	            // note that self is cRegion, this is raphael object
	            //if (us.DBGANNOT)  log("cb_regClick: rfId:" + self.id);
	            if ((0, _helpers.isDefined)(self.id)) {
	                var parentId = self.data('parentRfId');
	                if ((0, _helpers.isDefined)(parentId)) // if the annot has a parent, select the parent  (buddy text annots haveparentRfId)
	                    thisAn.regSelect({ rfId: parentId, bReposition: false }); // unselect the currently selected parent object and select this one
	                else thisAn.regSelect({ rfId: self.id, bReposition: false }); // unselect the currently selected object and select this one
	            }
	        }
	        //............................................ cb_regHover()
	        //    This function is the region hover callback. It displays a hovering note associated with the region, if it exists.
	        function cb_regHover() {
	            //if (us.DBGANNOT) log("cb_regHover: rfId:" + self.id);
	            thisAn.regHoverShow(true, self.id); // note that self is cRegion, this is raphael object
	        }
	        //..................................................
	    };

	    //............................................ simple computations
	    CREGION.computeLength = function () {
	        if (self.getPtsLen()) {
	            self.data.lengthPixels = distance_({ 'pointList': self.getPts() });
	            self.data.lengthMicrons = distance_({ 'value': self.data.lengthPixels, 'toMicrons': true });
	        }
	    };
	    //............................................ setRegionId
	    CREGION_SET.setRegionId = function (regionId) {
	        self.regionId = regionId;
	    };
	    //............................................ setType
	    CREGION_SET.setType = function (type) {
	        self.type = +type;
	        self.shape = _defines2.default.anShapes[self.type];
	        self.openShape = self.type == _defines2.default.eAnTypes.pen || self.type == _defines2.default.eAnTypes.caliper ? true : false;
	        self.Analyze = _defines2.default.eAnAnalysis[self.type] ? true : false; // means can run analysis
	    };
	    //............................................ setRGB
	    CREGION_SET.setRGB = function (decRGB) {
	        self.decRGB = decRGB;
	        self.decBGR = (0, _helpers.reverseCLR)(decRGB);
	    };
	    //............................................ setBGR
	    CREGION_SET.setBGR = function (decBGR) {
	        self.decBGR = decBGR;
	        self.decRGB = (0, _helpers.reverseCLR)(decBGR);
	    };
	    //............................................ region onSelectChange
	    //        bSelect:        required, true/false, save state as selected/deselected
	    //        cb_function:    optional, response callback function
	    CREGION_SET.onSelectChange = function (bSelect) {
	        // note that the region doesn't keep a var that it is selected

	        var bSelect = (0, _helpers.isUnDefined)(bSelect) || bSelect == false ? 0 : 1; // convert bSelect to 0,1
	        var layerXML = '<Annotation Id="' + self.layerId + '" Selected="' + bSelect + '">'; // do not include closing tag
	        var regionXML = '<Region Id="' + self.regionId + '" Selected="' + bSelect + '"></Region>';

	        thisAn.save({
	            action: 'updateRegionAndLayer', layerId: self.layerId, layerXML: layerXML,
	            regionId: self.regionId, regionXML: regionXML
	        });
	    };
	    //............................................ region addNote
	    CREGION.addNote = function (note) {
	        if (note == undefined) note = '';
	        self.note = noteFormat_(note); // limit # chars and insert line feeds for display
	        if (_defines2.default.DBGANNOT) log('regAddNote; rfId:' + self.rfId + '  shape: ' + self.shape + '   note:' + note);

	        if (_uScope2.default.instance.canSaveAnnotations()) {
	            // if incremental save is enabled, automatically update the database
	            var regionXML = '<Region Id="' + self.regionId + '"' + ' Text="' + (0, _helpers.toPortable)(self.note) + '"' + '></Region>';
	            thisAn.save({ action: 'updateRegion', layerId: self.layerId, regionXML: regionXML });
	        }
	        //..................................................
	        // closure functions
	        //............................................ noteFormat
	        //    noteFormat - This function limits the number of characters and adds newlines for display.
	        function noteFormat_(note) {
	            if (note[note.length - 1] == '\n') // strip off trailing carriage return
	                note = note.substr(0, note.length - 1);
	            var oNote = note.substring(0, _defines2.default.textEditSpecs.maxChars); // limit number of characters
	            var words = oNote.split(' '); // split into words
	            var rtnNote = ''; // return string

	            var line = words[0]; // line of text
	            var curWidth = 0; // current line width
	            var goalWidth = _defines2.default.textEditSpecs.noteWidth; // display note width
	            for (var i = 1, len = words.length; i < len; i++) {
	                var crIndex = words[i].indexOf('\n');

	                if (crIndex != -1) {
	                    var words2 = words[i].split('\n'); // check for, handle user-defined carriage returns
	                    if (words2.length == 2) {
	                        // two words with user-defined cr between them
	                        rtnNote += line + ' ' + words2[0] + '\n';
	                        line = words2[1];
	                        continue;
	                    } else if (crIndex == 0) {
	                        // user-defined cr at start of word
	                        line += '\n';
	                        words[i] = words2[0];
	                        line = words2[1];
	                        continue;
	                    } else {
	                        // user-defined cr at end of word
	                        rtnNote += line + ' ' + words2[0] + '\n';
	                        line = '';
	                        continue;
	                    }
	                }
	                if (words[i].length + line.length < goalWidth) {
	                    line += ' ' + words[i];
	                } else {
	                    rtnNote += line + '\n';
	                    line = words[i];
	                }
	            }
	            if (line.length) rtnNote += line;
	            return rtnNote;
	        }
	        //..................................................
	    };

	    //............................................ related to points
	    CREGION_POINTS.clrPts = function () {
	        self.pts = [];
	    };
	    CREGION_POINTS.getPts = function () {
	        return self.pts;
	    };
	    CREGION_POINTS.getPtsLen = function () {
	        return self.pts ? self.pts.length : 0;
	    };
	    CREGION_POINTS.setPtsLen = function (len) {
	        if (len > -1) self.pts.length = len;
	    };
	    CREGION_POINTS.getPt = function (index) {
	        return index < self.pts.length ? self.pts[index] : undefined;
	    };
	    CREGION_POINTS.addPt = function (pt) {
	        self.pts.push(pt);
	    };
	    CREGION_POINTS.insertPt = function (pt, at) {
	        self.pts.splice(at, 0, pt);
	    };
	    CREGION_POINTS.setPt = function (pt, index) {
	        self.pts[index] = pt;
	    };

	    //............................................ region rotatePtsAbout
	    CREGION_POINTS.rotatePtsAbout = function (angleDeg, cpOrigin, opt_precision) {
	        if (angleDeg == 0) return;

	        var angleRad = angleDeg * _defines2.default.Deg2Rad;
	        var cos = Math.cos(angleRad),
	            sin = Math.sin(angleRad);

	        for (var p = 0, len = self.pts.length; p < len; p++) {
	            self.pts[p].rotateAbout(cos, sin, cpOrigin, opt_precision);
	        }
	        return self.pts.length;
	    };
	    //............................................ region copyPts
	    CREGION_POINTS.copyPts = function () {
	        var curPts = self.pts;
	        var newPts = [];
	        for (var p = 0, len = curPts.length; p < len; p++) {
	            var pt = new _objects.cPoint(curPts[p].x, curPts[p].y);
	            newPts.push(pt);
	        }
	        return newPts;
	    };
	    //............................................ replacePts
	    CREGION_POINTS.replacePts = function (ptList) {
	        self.clrPts();
	        if (ptList && ptList.length) {
	            for (var p = 0, len = ptList.length; p < len; p++) {
	                self.pts.push(new _objects.cPoint(ptList[p].x, ptList[p].y));
	            }
	        }
	        return self.pts;
	    };
	    //............................................ centerAt
	    CREGION_POINTS.centerAt = function (cpCenterNew) {
	        var cpCenterCur = self.getCenter();
	        var dx = cpCenterNew.x - cpCenterCur.x;
	        var dy = cpCenterNew.y - cpCenterCur.y;

	        for (var p = 0, len = self.pts.length; p < len; p++) {
	            self.pts[p].x += dx;
	            self.pts[p].y += dy;
	        }
	        self.getCenter(_defines2.default.WITHFORCE); // force update of center point
	    };
	    //............................................ thinOutPts
	    CREGION_POINTS.thinOutPts = function (minDist) {
	        var nPtsRemoved = 0;
	        if (self.type != _defines2.default.eAnTypes.pen) return nPtsRemoved; // only thin out pen drawings

	        var newPts = self.copyPts();
	        var len = newPts.length;
	        if (len > 5) {
	            var TOOCLOSE = minDist == undefined ? 5 : minDist; // define what too closely spaced means
	            var pt0 = newPts[0]; // left-adjacent point
	            for (var p = 1; p < len; p++) {
	                // compare adjacent point city block distance
	                var pt1 = newPts[p]; // right-adjacent point
	                if (pt1.cityBlockDistance(pt0) < TOOCLOSE) {
	                    // if left and right adjacent points are"too close"
	                    newPts[p].set(-1, -1); // then flag that the right one to be removed
	                    nPtsRemoved++;
	                } else {
	                    pt0 = pt1; // otherwise the left-adjacent becomes the right adjacent
	                }
	            }
	            var lastPt = newPts[len - 1]; // test the last point against the first point
	            if (lastPt.x != -1 && newPts[0].cityBlockDistance(lastPt) < TOOCLOSE) {
	                newPts[len - 1].set(-1, -1); // and flag that the last point to be removed
	            }

	            self.clrPts(); // copy valid points from newPts to self.pts
	            var curPts = self.pts;
	            len = newPts.length;
	            for (var p = 0; p < len; p++) {
	                if (newPts[p].x != -1) {
	                    curPts.push(newPts[p]);
	                }
	            }
	            computeGeometry_(); // recompute center point, bounding box
	        }
	        return nPtsRemoved;
	    };
	    //............................................ countDuplicates
	    CREGION_POINTS.countDuplicates = function () {
	        var dupCount = 0;
	        for (var p = 1, len = self.pts.length; p < len; p++) {
	            if (self.pts[p].isEqual(self.pts[p - 1])) dupCount++;
	        }
	        return dupCount;
	    };
	    //............................................ removeDuplicatePtsAtEnd
	    CREGION_POINTS.removeDuplicatePtsAtEnd = function () {
	        var dupCount = 0;
	        var ptList = self.pts;
	        var lastIdx = ptList.length - 1;

	        var pt1 = ptList[lastIdx];
	        var pt0 = ptList[lastIdx - 1];
	        while (lastIdx > 1 && pt0.x == pt1.x && pt0.y == pt1.y) {
	            dupCount++;
	            ptList.length = ptList.length - 1; // remove pt1
	            pt1 = pt0;
	            lastIdx--;
	            pt0 = ptList[lastIdx - 1];
	        }
	        computeGeometry_(); // recompute center point, bounding box
	        return dupCount;
	    };
	    //............................................ setLastPtToFirstPt
	    CREGION_POINTS.setLastPtToFirstPt = function () {
	        if (self.pts.length) {
	            var pt0 = self.pts[0];
	            var pt99 = self.pts[self.pts.length - 1];
	            if (pt0.x != pt99.x && pt0.y != pt99.y) {
	                var pt = new _objects.cPoint(pt0.x, pt0.y);
	                self.addPt(pt);
	            }
	        }
	    };
	    //............................................ region computeGeometry_
	    // This function computes the center point and the bounding box of the region.
	    //    Note that the center point is biased for regions with few points and first==last
	    //    and that the center of the bbox could be used.

	    var computeGeometry_ = function computeGeometry_() {
	        // really I know arrows and pins are one point, just use them
	        // especially since the arrow carries two points for imagescope compatibility
	        if (self.type == _defines2.default.eAnTypes.arrow || self.type == _defines2.default.eAnTypes.pin) {
	            // Note that in the original code the line above referred to `this` rather than `self`, and `this` sometimes
	            // pointed at `window`, so this branch never actually executed, so I'm not sure what it was supposed to do.
	            // After correcting the context .setPoint started failing because self.pts[0] was empty. TODO: Figure out what it's supposed to be doing!
	            if (self.pts.length) {
	                self.centerPt.setPoint(self.pts[0]);
	                //todo: implement bbox for arrow and pin, self.boundingBox.setxywh();
	                err('computeGeometry_: not implemented for arrow or pin yet');
	            }
	        } else {
	            if (self.pts.length) {
	                var xsum = 0,
	                    ysum = 0; // compute the centerPt once
	                var xleft = Number.MAX_VALUE,
	                    ytop = Number.MAX_VALUE; //
	                var xright = Number.MIN_VALUE,
	                    ybottom = Number.MIN_VALUE; //
	                for (var p = 0, len = self.pts.length; p < len; p++) {
	                    var x = +self.pts[p].x;
	                    var y = +self.pts[p].y;
	                    xsum += x;
	                    ysum += y;
	                    if (x < xleft) xleft = x;
	                    if (y < ytop) ytop = y;
	                    if (x > xright) xright = x;
	                    if (y > ybottom) ybottom = y;
	                }
	                self.centerPt.set(xsum / self.pts.length, ysum / self.pts.length);
	                self.centerPt.toInt();
	                self.boundingBox.set(xleft, ytop, xright, ybottom);
	                // Note that ImageServer has a limitation on the dimensions of its returned JPEG compressed image
	                // (currently clipping each dimension to 2000 pixels). So this limitiation is used to define smallness.
	                self.isSmall = self.boundingBox.w < _defines2.default.IMAGESERVER_MAXJDIM && self.boundingBox.h < _defines2.default.IMAGESERVER_MAXJDIM ? true : false;

	                //debug-only log("computeGeometry_: center: " + self.centerPt.toString() + "  bbox: " + self.boundingBox.toStringLRTB() + " isSmall: " + self.isSmall);
	            }
	        }
	    };
	    //............................................ getCenter
	    CREGION_GET.getCenter = function (opt_bForce) {
	        if (opt_bForce == false) {
	            // if not forcing a recomputation
	            // if centerPt has been computed or if it cannot yet be computed, return it
	            if (self.centerPt.x > 0 || (0, _helpers.isUnDefined)(self.pts) || self.pts.length === 0) return self.centerPt;
	        }
	        computeGeometry_();
	        return self.centerPt;
	    };
	    //............................................ getBBox
	    CREGION_GET.getBBox = function (opt_bForce) {
	        if (opt_bForce == false) {
	            // if not forcing a recomputation
	            // if boundingBox has been computed or if it cannot yet be computed, return it
	            if (self.boundingBox.isZero() == false || (0, _helpers.isUnDefined)(self.pts) || self.pts.length === 0) return self.boundingBbox;
	        }
	        computeGeometry_();
	        return self.boundingBbox;
	    };
	    //............................................ cRegion isInView
	    CREGION.isInView = function (cr2View) {
	        return self.boundingBox.hasOverlap(cr2View);
	    };
	    CREGION_GET.getIntersectRect = function (cr2View) {
	        return self.boundingBox.getIntersectRect(cr2View);
	    };

	    //............................................ getStrokeWidth
	    //toconsider-could have var of strokeWidth in the region and only return differently if isHighLight - faster
	    CREGION_GET.getStrokeWidth = function () {
	        if (self.isHighLight && _uScope2.default.instance.isRegionCopyActive()) return _defines2.default.annotSpecs.strokeWidthCopyMove;else if (self.shape == 'pin') return _defines2.default.annotSpecs.strokeWidthPin;else if (self.shape == 'text') return _defines2.default.annotSpecs.strokeWidthTextBorder;else return _defines2.default.annotSpecs.strokeWidth;
	    };
	    //............................................ buildXML
	    //    buildXML - This function converts a cRegion to XML
	    //        input parameters:
	    //            selected {true, false}
	    // note:
	    //        o region type of negative pen is translated to a pen with a NegativeROA for backward compatibility
	    //        o region type of polygon is translated to a pen for backward compatibility
	    //        o region LineColor is saved as BGR for backward compatibility
	    //        o Analyze is saved but should not be known to any viewer, still probably need it for backward compatibility
	    //        o InputRegionId is set and saved by AAF; ImageScope defaults a parent region's value to "0"

	    CREGION.buildXML = function (selected) {

	        // if my local type is negative pen, save it as a pen (with NegativeROA set)
	        var saveType = self.type == _defines2.default.eAnTypes.negpen ? _defines2.default.eAnTypes.pen : self.type;
	        // if my local type is polygon, save it as a pen
	        saveType = self.type == _defines2.default.eAnTypes.polygon ? _defines2.default.eAnTypes.pen : self.type;

	        var regionXML = '<Region Id="' + self.regionId + '"' + ' Type="' + saveType + '"' + ' Zoom="' + 1. / self.zoom + '"' // the annotation zoom is the inverse of the image zoom
	        + ' Selected="' + ((0, _helpers.isUnDefined)(selected) || selected == false ? 0 : 1) + '"' + ' LineColor="' + self.decBGR + '"'
	        //        + ' ImageLocation=""'
	        //        + ' ImageFocus=""'
	        + ' NegativeROA="' + (self.type == _defines2.default.eAnTypes.negpen ? 1 : 0) + '"' + ' InputRegionId="' + (self.InputRegionId ? self.InputRegionId : '0') + '"' + ' Analyze="' + _defines2.default.eAnAnalysis[self.type] + '"' + ' DisplayId="' + self.displayId + '"';
	        if (self.data.lengthPixels) regionXML += ' Length="' + self.data.lengthPixels + '"';
	        if (self.data.lengthMicrons) regionXML += ' LengthMicrons="' + self.data.lengthMicrons + '"';
	        if (self.note) regionXML += ' Text="' + (0, _helpers.toPortable)(self.note) + '"'; // convert to a portable string
	        regionXML += '>';

	        var vertexXML = self.buildVertexXML();
	        regionXML += '<Vertices>' + vertexXML + '</Vertices>' + '</Region>';
	        return regionXML;
	    };
	    //............................................ buildVertexXML
	    //    buildVertexXML - This function converts an array of cPoints to XML
	    CREGION.buildVertexXML = function () {
	        var ptList = self.getPts();
	        var str = '';
	        for (var v = 0, vlen = ptList.length; v < vlen; v++) {
	            str += '<Vertex X="' + ptList[v].x + '" Y="' + ptList[v].y + '"></Vertex>';
	        }return str;
	    };
	    //............................................ toStringShort
	    CREGION_DEBUG.toStringShort = function () {
	        var str = ' rfId:' + self.rfId + '  regionId:' + self.regionId + '  InputRegionId:' + self.InputRegionId + '  layerId:' + self.layerId + ' shape:' + self.shape;
	        if (self.isAnalyzed) str += ' isAnalyzed:' + self.isAnalyzed;
	        if (self.MarkupImageId) {
	            str += ' isSmall:' + self.isSmall + ' MarkupImageId:' + self.MarkupImageId;
	            if (self.isWholeSlideMarkup) str += '  isWholeSlideMarkup: ' + self.isWholeSlideMarkup;
	        }

	        //debug-only str += "\n                           center:" + self.centerPt.toString() + "  bbox:" + self.boundingBox.toString(); ////////temp
	        //debug-only str += self.toStringPts();
	        return str;
	    };
	    CREGION_DEBUG.toString = function (bReportResults, bReportPts) {
	        var str = ' rfId:' + self.rfId + '   regionId:' + self.regionId + '   InputRegionId:' + self.InputRegionId + '   layerId:' + self.layerId + '\n                           shape:' + self.shape + '   type:' + self.type + '   angleDeg:' + self.angleDeg + ' zoom:' + self.zoom + '\n                           reportReg:' + self.isReportRegion + ' decRGB: #' + (0, _helpers.toHexColor)(self.decRGB) + ' displayId:' + self.displayId + '\n                           center:' + self.centerPt.toString() + '  bbox:' + self.boundingBox.toString() + ' Note:' + self.note;

	        if (self.isAnalyzed) str += '     isAnalyzed: ' + self.isAnalyzed;
	        if (self.isWholeSlideMarkup) str += ' isWholeSlideMarkup: ' + self.isWholeSlideMarkup;
	        if (self.MarkupImageId) str += '  isSmall: ' + self.isSmall + ' MarkupImageId: ' + self.MarkupImageId;

	        if ((0, _helpers.isEmptyObject)(self.data) == false) {
	            str += '\n                           Data: ';
	            for (var key in self.data) {
	                str += key + ':' + self.data[key] + ' ';
	            }
	        }
	        if (bReportResults == true && (0, _helpers.assocArrayLength)(attributes)) str += '\n                           Region Results (' + (0, _helpers.assocArrayLength)(attributes) + '):  ' + (0, _helpers.toStringAssoc)(attributes);

	        if (bReportPts == true) str += self.toStringPts();
	        return str;
	    };
	    //............................................ toStringPts
	    CREGION_DEBUG.toStringPts = function () {
	        var str = '\n                           Points: len:' + self.pts.length + ' \n';
	        for (var i = 0; i < self.pts.length; i++) {
	            str += self.pts[i].toString() + ', ';
	        }return str;
	    };
	    //............................................ toStringPtDeltas
	    CREGION_DEBUG.toStringPtDeltas = function (bReportPts) {
	        var str = self.toString(false);
	        if (bReportPts) {
	            str += '\n                Points: len:' + self.pts.length + ' \n';
	            var ptDiff = new _objects.cPoint();
	            ptDiff.setPoint(self.pts[self.pts.length - 1]);
	            ptDiff.subtPoint(self.pts[0]);
	            str += ptDiff.toString();
	            for (var i = 1; i < self.pts.length; i++) {
	                ptDiff.setPoint(self.pts[i - 1]);
	                ptDiff.subtPoint(self.pts[i]);
	                str += ptDiff.toString();
	            }
	        }
	        return str;
	    };

	    //    //............................................ reset
	    //    self.reset = function () {
	    //        if (self.rfHandle) rfHandle.remove();
	    //        self.rfHandle = undefined;
	    //        self.rfId = -1; // note that 0 is a valid rfId

	    //        self.imageId = 0; self.layerId = 0; self.regionId = 0; self.displayId = 0;
	    //        self.isReportRegion = false; self.isHighLight = false;
	    //        self.shape = ""; self.type = 0; self.decRGB = 0xFF; self.decBGR = 0xFF0000;
	    //        self.angleDeg = 0; self.zoom = 1.0; self.pts = []; self.centerPt.set(-1, -1);

	    //        self.data = {}; // clear the associative array
	    //    };


	    //............................................ distance_
	    //    cRegion.distance - This function computes the distance in pixels or microns of an array
	    //                            of cPoints or of a passed value.
	    // input parms:
	    //        "pointList" :     an array of cPoint pixel values
	    //        "value" :        the pixel value to convert to microns
	    //        "toMicrons":    boolean, convert to microns

	    var distance_ = function distance_(parms) {
	        var distInPix = 0;
	        if (parms.pointList) {
	            var distInPix = 0;
	            var ptList = parms.pointList;
	            for (var i = 1, len = ptList.length; i < len; i++) {
	                var apt = ptList[i - 1];
	                var bpt = ptList[i];
	                distInPix += apt.distance(bpt);
	            }
	        } else if (parms.value) {
	            distInPix = parms.value;
	        }
	        if (distInPix) return parms.toMicrons ? (0, _helpers.roundto)(distInPix * thisImg.getBaseMPP(), 10.) : Math.round(distInPix);else return distInPix;
	    };
	    //............................................ construction
	    construct_(inObj, inObjType, aLayer);
	}
	module.exports = exports['default'];

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.rfDraw = rfDraw;
	exports.rfRotate = rfRotate;

	var _uScope = __webpack_require__(11);

	var _uScope2 = _interopRequireDefault(_uScope);

	var _defines = __webpack_require__(3);

	var _defines2 = _interopRequireDefault(_defines);

	var _helpers = __webpack_require__(8);

	var _objects = __webpack_require__(7);

	var _region = __webpack_require__(26);

	var _region2 = _interopRequireDefault(_region);

	var _toolbar = __webpack_require__(5);

	var _annotationsService = __webpack_require__(25);

	var _annotationsService2 = _interopRequireDefault(_annotationsService);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	//________________________________________________________________________________________________
	// annotdraw.js
	//    This file contains functions performing annotations drawing and rapahel SVG graphics calls.
	//        All are prototypes of AnnotationsService.
	//
	//    references:
	//        raphael.js is used to draw the vector graphics: http://raphaeljs.com
	//        Scalable Vector Graphics: http://www.w3.org/TR/SVG/    http://www.w3.org/TR/SVG/Overview.html
	//        SVG attribute index: http://www.w3.org/TR/SVG/attindex.html
	//        Future options: http://www.graphdracula.net/
	//
	//    history
	//    1109    cperz        created
	//    _______________________________________end_AIHv1 __________________________________________
	//    141118    cperz        add support for polygon
	//    141120    cperz        add support for negative pen; simplified rfDraw attr; improved arrow head;
	//    141222    cperz        support changes made for analysis; fix on image text font to be more readable;
	//                        startNew: remove adding click handler to caliper - performed elsewhere now
	//    150318    cperz        add support for analysis; add initializeRegion();
	//                        refactor to utilize region's new fns; refactor use of var 'openShape';
	//                        be like ImageScope and don't close the pen annot;
	//________________________________________________________________________________________________

	var CANNOT_DRAW = _annotationsService2.default.prototype;
	var CANNOT_REGION = _annotationsService2.default.prototype;

	//............................................ startNew
	//    AnnotationsService.startNew - This function begins the drawing of a new annotation object.
	//
	//    parameters:
	//        anType - us.eAnTypes type, annotation type to be created
	//        crsrPos    - cPoint type, cursor position in base image coords
	//        viewZoom - numeric type, zoom of current view
	//        optText - optional, content for text annotation
	//
	CANNOT_DRAW.startNew = function (anType, crsrPos, viewZoom, viewAngleDeg, optText) {
	    var preamble = 'annot: startNew: ';
	    var self = this;

	    var myLayerId = _defines2.default.chooseLayer(this, anType); // get the annotation layer this region will belong to
	    if (myLayerId < 0 || myLayerId == undefined) {
	        // we cannot send an addRegion request to dataserver without an assigned layer id
	        this.log('Error:' + preamble + ' Layer not yet created or drawing is on an output layer w/o an input layer - Prohibiting region creation');
	        return;
	    }

	    var isReportRegion = anType === _defines2.default.eAnTypes.report ? true : false;
	    this.newRegion = initializeRegion.call(this); // create a new region object
	    var newRegion = this.newRegion; // and a handy ref

	    var MINANNOTDIM = _defines2.default.annotSpecs.minAnnotDim;
	    switch (newRegion.shape) {
	        case 'pen':
	        case 'negpen':
	            newRegion.addPt(crsrPos);
	            rfDraw(this.paper, newRegion);
	            break;
	        case 'caliper':
	        case 'polygon':
	            newRegion.addPt(crsrPos);
	            newRegion.data.lengthPixels = 0;
	            newRegion.data.lengthMicrons = 0;
	            //debug-only this.log("Caliper distance = pix:" + newRegion.data.lengthPixels + " mic:" + newRegion.data.lengthMicrons);
	            rfDraw(this.paper, newRegion);
	            newRegion.addPt(crsrPos); // add the same pt again so update has one to remove
	            break;
	        case 'report':
	            // only fixed resolution report regions filter through here
	            newRegion.addPt(crsrPos);
	            rfDraw(this.paper, newRegion);

	            if (_defines2.default.isReportFixedDim(newRegion.reportType)) // fixed dimension report regions require only a single point
	                this.finishNew();
	            break;
	        case 'rect':
	            newRegion.addPt(crsrPos); // top left
	            var x1 = crsrPos.x + MINANNOTDIM;
	            var y1 = crsrPos.y + MINANNOTDIM;

	            var pt = new _objects.cPoint(x1, crsrPos.y);
	            newRegion.addPt(pt); // top right
	            pt = new _objects.cPoint(x1, y1);
	            newRegion.addPt(pt); // bottom right
	            pt = new _objects.cPoint(crsrPos.x, y1);
	            newRegion.addPt(pt); // bottom left

	            if (isReportRegion == false && newRegion.angleDeg != 0) {
	                // rect is squared with the view frame so unrotate it
	                var ptList = newRegion.getPts();
	                var cpOrigin = new _objects.cPoint(ptList[0].x, ptList[0].y);
	                newRegion.rotatePtsAbout(-newRegion.angleDeg, cpOrigin, 0);
	            }
	            rfDraw(this.paper, newRegion, viewZoom, newRegion.angleDeg);
	            break;
	        case 'ellipse':
	            newRegion.addPt(crsrPos); // top right
	            var pt = new _objects.cPoint(crsrPos.x + MINANNOTDIM, crsrPos.y + MINANNOTDIM);
	            newRegion.addPt(pt); // bottom left
	            rfDraw(this.paper, newRegion);
	            break;
	        case 'ruler':
	            // the ruler is never created by uScope; only by ImageScope or WebScope - nothing to do
	            return;
	            break;
	        case 'pin':
	        case 'arrow':
	            newRegion.addPt(crsrPos);
	            rfDraw(this.paper, newRegion, viewZoom, viewAngleDeg);
	            this.finishNew(); // finish the pin, arrow annotation
	            break;

	        case 'text':
	            if ((0, _helpers.isUnDefined)(optText)) {
	                // sanity check that there is text to write
	                this.drawingCompleted(); // if not, Signal The End of Drawing
	                return; // and return
	            }
	            newRegion.note = optText; // add the text to the region's data
	            newRegion.addPt(crsrPos);
	            rfDraw(this.paper, newRegion);
	            this.finishNew(); // finish the text annotation
	            break;
	        default:
	            break;
	    }
	    if (_defines2.default.DBGANNOT) this.log(preamble + newRegion.toString(true));
	    return;

	    //..................................................
	    // closure functions
	    //............................................ initializeRegion
	    function initializeRegion() {
	        var regionId = self.regions.getNextRegionId(); // will return a negative value that is a signal to dataserver of a new region
	        var layer = self.layers.getLayerById(myLayerId);

	        var newRegion = new _region2.default({ // create a new region object
	            'layerId': myLayerId, 'regionId': regionId,
	            'displayId': -regionId, // display id is positive value of new region id
	            'decBGR': layer.get('LineColor'), // region color is the layer color
	            'type': anType,
	            'angleDeg': viewAngleDeg, 'zoom': viewZoom, 'isReportRegion': isReportRegion
	        }, 'json', self.getMyImage());

	        // openShape is a flag for rfDraw, when true shape is not closed; override default setting at draw start - don't close these shapes during draw
	        newRegion.set('openShape', anType == _defines2.default.eAnTypes.pen || anType == _defines2.default.eAnTypes.negpen || anType == _defines2.default.eAnTypes.caliper || anType == _defines2.default.eAnTypes.polygon ? true : false);

	        //        consoleWrite(';;;;;;;;;;;;;;;;;;;;;;;;;;;initializeRegion: ' + layer.get('Name') + '   layer BGR: ' + layer.get('LineColor') + "  region BGR, RGB: " + newRegion.get('decBGR') +
	        //    "," + newRegion.get('decRGB'));

	        // Note: There are 4 report region styles. The fixed size report regions are handled as report regions
	        //            and the user drawn report regions are switched to rects for drawing.
	        if (isReportRegion) {
	            newRegion.reportType = _uScope2.default.instance.prefGet('reportRegionType', _defines2.default.eReportSpec.defReportType); // save report region type here for convenience
	            newRegion.note = 'Report Image'; // report region on-image text

	            if (_defines2.default.isReportFixedDim(newRegion.reportType) == false) {
	                newRegion.setType(_defines2.default.eAnTypes.rect); // if user drawn report then switch to a rect draw
	            }
	            if (_defines2.default.isReportFullRes(newRegion.reportType)) {
	                newRegion.viewZoom = viewZoom; // save special data to draw at this zoom
	                newRegion.zoom = this.getMyImage().getNormalizationFactor(); // report region overrides viewZoom  when full resolution preference is set
	            }
	        }
	        return newRegion;
	    }
	    //..................................................
	};

	//............................................ updateNew
	//    AnnotationsService.updateNew - This function updates with a new cursor position the drawing of a new annotation process.
	//        The caliper needs the mouse event.
	//
	CANNOT_DRAW.updateNew = function (crsrPos, mouseAction) {
	    if (this.drawingIsStarted() == false) return; // if called before startNew, return
	    var self = this;

	    var newRegion = this.newRegion;
	    switch (newRegion.shape) {
	        case 'pen':
	        case 'negpen':
	            if (newRegion.getPtsLen() < 1) return; // sanity
	            var lastPt = newRegion.getPt(newRegion.getPtsLen() - 1);
	            var dist = lastPt.cityBlockDistance(crsrPos);
	            if (dist > _defines2.default.annotSpecs.minPenPointDist) {
	                // don't add points that are too close together
	                newRegion.addPt(crsrPos);
	                rfDraw(this.paper, newRegion);
	            }
	            break;
	        case 'caliper':
	        case 'polygon':
	            if (newRegion.getPtsLen() < 1) return; // sanity
	            if (mouseAction === 'mousemove') {
	                // mouse move updates only if move is sufficiently different
	                var lastPt = newRegion.getPt(newRegion.getPtsLen() - 1); // otherwise the control is sticky, unresponsive
	                var dist = lastPt.cityBlockDistance(crsrPos);
	                if (dist <= _defines2.default.annotSpecs.minPenPointDist) return;
	            }
	            newRegion.setPt(crsrPos, newRegion.getPtsLen() - 1); // overwrite prevous point
	            newRegion.computeLength();
	            //debug-only this.log("updateNew.... Caliper distance = pix:" + newRegion.data.lengthPixels + " mic:" + newRegion.data.lengthMicrons);
	            rfDraw(this.paper, newRegion); // draw the region

	            if (mouseAction === 'mousedown') // mousedown duplicates the end point in anticipation of the next call's overwrite
	                newRegion.addPt(crsrPos);
	            break;
	        case 'rect':
	            if (newRegion.getPtsLen() < 4) return; // sanity
	            var ptList = newRegion.getPts();

	            if (newRegion.angleDeg != 0) {
	                // if the view is rotated, rotate the cursor (indicating rect RB coord) about the LT of the rect
	                var angleRad = newRegion.angleDeg * _defines2.default.Deg2Rad;
	                var cpOrigin = new _objects.cPoint(ptList[0].x, ptList[0].y);
	                crsrPos.rotateAbout(Math.cos(angleRad), Math.sin(angleRad), cpOrigin);
	                crsrPos.toInt();
	            }

	            ptList[2] = crsrPos; // define the 4 corners of the rect
	            ptList[1].x = ptList[2].x;
	            ptList[1].y = ptList[0].y;
	            ptList[3].x = ptList[0].x;
	            ptList[3].y = ptList[2].y;
	            enforceDims_(); // force a minimim dimension

	            if (newRegion.isReportRegion == false && newRegion.angleDeg != 0) {
	                // rect is squared with the view frame so unrotate it
	                var cpOrigin = new _objects.cPoint(ptList[0].x, ptList[0].y);
	                newRegion.rotatePtsAbout(-newRegion.angleDeg, cpOrigin, 0);
	            }
	            rfDraw(this.paper, newRegion);
	            break;
	        case 'ellipse':
	            if (newRegion.getPtsLen() < 2) return; // sanity
	            var ptList = newRegion.getPts();
	            ptList[1] = crsrPos;
	            enforceDims_(); // force a minimim dimension
	            rfDraw(this.paper, newRegion);
	            break;
	        case 'report':
	            if (_defines2.default.isReportFixedDim()) {
	                newRegion.setPt(crsrPos, 0); // overwrite prevous left-top point
	            } else {
	                    // act like a rectangle at this
	                }
	            rfDraw(this.paper, newRegion);
	            break;
	        case 'ruler': // note: rulers are not created in this viewer - the caliper replaces it.
	        case 'pin': // no updates are necessary for these annotation types
	        case 'arrow':
	            return;
	            break;
	        default:
	            break;
	    }
	    //if (us.DBGANNOTEX) this.log("updateNew: " + newRegion.toString(true));

	    //..................................................
	    // closure functions
	    //............................................ enforceDims_
	    //    This function insures that the user did not shrink the new region shape beyond the minimum dimensions
	    function enforceDims_() {
	        var ptList = newRegion.getPts();
	        var MINANNOTDIM = _defines2.default.annotSpecs.minAnnotDim;
	        switch (newRegion.shape) {
	            case 'rect':
	                if (ptList[2].x < ptList[0].x + MINANNOTDIM) ptList[2].x = ptList[0].x + MINANNOTDIM; // bottom right
	                if (ptList[2].y < ptList[0].y + MINANNOTDIM) ptList[2].y = ptList[0].y + MINANNOTDIM;
	                ptList[1].x = ptList[2].x;
	                ptList[1].y = ptList[0].y; // top right
	                ptList[3].x = ptList[0].x;
	                ptList[3].y = ptList[2].y; // bottom left
	                break;
	            case 'ellipse':
	                // if somehow the dimension is < minimum allowed, fix it
	                if (ptList[1].x < ptList[0].x + MINANNOTDIM) ptList[1].x = ptList[0].x + MINANNOTDIM; // bottom right
	                if (ptList[1].y < ptList[0].y + MINANNOTDIM) ptList[1].y = ptList[0].y + MINANNOTDIM;
	                break;
	            default:
	                break;
	        }
	    }
	    //..................................................
	};

	//............................................ finishNew
	//    AnnotationsService.finishNew - This function completes the drawing of a new annotation object.
	//                Some annotations are checked if they are of reasonable size and removed rather
	//                than keep a silly user mistake.
	//    returns: true if annotation was saved; false otherwise
	CANNOT_DRAW.finishNew = function () {
	    var self = this;
	    if (this.drawingIsStarted() == false) {
	        // if called before startNew, return
	        this.log('Error: AnnotationsService.finishNew: called but drawing is not started!');
	        return false;
	    }
	    var newRegion = this.newRegion;
	    var bDisqualified = false;
	    switch (newRegion.shape) {
	        case 'pen':
	        case 'negpen':
	            if (newRegion.getPtsLen() < 3) {
	                // don't save freeforms with less than 3 points
	                bDisqualified = true;
	                this.getMyImage().log('Not saving freeform annotation: too few points');
	            } else {
	                //dbg-only var dupCount = newRegion.countDuplicates();    // note: check for duplicates with raphael graphics yeilds 0; otherwise I'd remove duplicates
	                rfDraw(this.paper, newRegion); // so perform the draw to complete the outline
	            }
	            break;
	        case 'caliper':
	        case 'polygon':
	            newRegion.removeDuplicatePtsAtEnd();

	            if (newRegion.getPtsLen() < 2) {
	                // don't save caliper with less than 2 points
	                this.getMyImage().log('Not saving caliper/polygon annotation: only 1 point');
	                bDisqualified = true;
	            } else if (newRegion.getPtsLen() < 3 && newRegion.shape == 'polygon') {
	                this.getMyImage().log('Not saving polygon annotation: only 2 points');
	                bDisqualified = true;
	            } else {
	                newRegion.computeLength();
	                //debug-only this.log("Caliper distance = pix:" + newRegion.data.lengthPixels + " mic:" + newRegion.data.lengthMicrons);
	                if (newRegion.data.lengthMicrons < 3) {
	                    // don't save caliper with very small measurement
	                    this.getMyImage().log('Not saving caliper/polygon annotation: too small');
	                    bDisqualified = true;
	                }
	                if (bDisqualified == false && newRegion.shape == 'polygon') {
	                    newRegion.setLastPtToFirstPt(); // since when I read a polygon back it is a pen shape, close the shape by setting the last point to the first
	                    rfDraw(this.paper, newRegion); // perform the draw to display the closed polygon shape
	                }
	            }
	            break;
	        case 'report':
	        case 'rect':
	            if (newRegion.isReportRegion) {
	                newRegion.setType(_defines2.default.eAnTypes.rect); // report region is always a rectangle, switch types now
	                rfDraw(this.paper, newRegion, newRegion.viewZoom); // redraw to show the report's associated text
	                newRegion.viewZoom = undefined; // remove special data
	            }
	            break;
	    }

	    if (bDisqualified == false) {
	        // if a region is qualified
	        this.regAdd(newRegion, true, true); // add the new region to the collection and save back to the db
	        if (_defines2.default.DBGANNOT) this.log('annot: finishNew: ' + newRegion.toString(false));
	    } else {
	        // otherwise ...
	        newRegion.removeGraphics();
	        if (_defines2.default.DBGANNOT) this.log('annot: finishNew: region is disqualified');
	    }
	    this.drawingCompleted(); // finishNew: return to not-drawing state
	    return bDisqualified;
	};

	//............................................ regReDraw
	// regReDraw - This function modifies the outline of a freeform annotation.
	//                It returns false if drawing is complete or cannot start.
	CANNOT_REGION.regReDraw = function (phase, crsrPos, opt_viewZoom) {
	    var self = this;
	    var closestIdx;
	    //this.log("annots: regReDraw: phase: " + phase + "  viewZoom: " + opt_viewZoom);
	    var thinTolerance_ = _defines2.default.reDrawSpecs.thinTolerance; // initialize tolerances
	    var startTolerance_ = _defines2.default.reDrawSpecs.startTolerance * (opt_viewZoom != undefined ? opt_viewZoom : 1);
	    var skipTolerance_ = _defines2.default.reDrawSpecs.skipTolerance * (opt_viewZoom != undefined ? opt_viewZoom : 1);
	    var removeTolerance_ = _defines2.default.reDrawSpecs.removeTolerance * (opt_viewZoom != undefined ? opt_viewZoom : 1);

	    var region = this.getSelRegion(); // reference the redraw region

	    if (phase == 'start') {
	        //........ start region redraw mode: mouse down in redraw mode
	        if (region.shape != 'pen') {
	            // redraw is only valid for pen regions
	            this.drawingCompleted(); // redraw: false start
	            return false;
	        }

	        this.reDrawIdx = 0; // the current position in the points array
	        this.reDrawCnt = 0;
	        this.reDrawPrevPt = undefined; // signal no points changed yet
	        region.priorPts = region.copyPts(); // save original point list so it can be restored
	        if (_defines2.default.DBGREDRAW) this.log(this.reDrawIdx + ' start');
	        this.log(region.toString(true));

	        var ptList = region.getPts();
	        var nPtsRemoved = region.thinOutPts(thinTolerance_); // thin point list of this region in preparation for redraw
	        if (_defines2.default.DBGREDRAW) this.log(this.reDrawIdx + ' thinOutPts: ' + nPtsRemoved);
	        this.log(region.toString(true));
	        ptList = region.getPts(); // update reference to region points

	        var closest = findClosestPt(crsrPos, ptList, startTolerance_);
	        closestIdx = closest.idx;
	        if (closestIdx != -1) {
	            var newPtList = createNewList(ptList, crsrPos, closestIdx);
	            region.replacePts(newPtList);
	            if (_defines2.default.DBGREDRAW) this.log(this.reDrawIdx + '   closest idx: ' + closestIdx + ' inserted crsr: ' + crsrPos.toString());
	            (0, _toolbar.consoleWrite)(region.toString(true));

	            this.paintSelRegion(_defines2.default.DONT_HIGHLIGHT); // force a repaint of this region but do not paint the highlight
	            this.reDrawCnt++; // increment redraw iteration count
	            this.reDrawPrevPt = new _objects.cPoint(crsrPos.x, crsrPos.y); // save the previous point
	            return true; // return true indicates a position close enough to the region was clicked
	        } else {
	            if (_defines2.default.DBGREDRAW) this.log(this.reDrawIdx + ' regReDraw: start : not close enough!  dist: ' + closest.dist);
	            return false; // return false not starting redraw
	        }
	    } else if (phase == 'update') {
	        //........ update region redraw mode: mouse down in redraw mode

	        // don't react to new cursor positions that aren't far from the previously inserted point
	        if (this.reDrawPrevPt.cityBlockDistance(crsrPos) < skipTolerance_) return true;

	        var ptList = region.getPts(); // reference to region points

	        // find the closest point in list starting at the next index from last insert
	        var closest = findClosestPtFrom(this.reDrawIdx + 1, ptList, crsrPos); //{ idx: idx, dist: closestDist };
	        closestIdx = closest.idx;
	        if (closestIdx != -1) {

	            if (++this.reDrawIdx >= ptList.length - 1) {
	                // if the cursor has lapped back to first point, end drawing
	                if (_defines2.default.DBGREDRAW) this.log(this.reDrawIdx + '------------------------------------------ finished - lapping back onto the new points --------------------------');
	                return false;
	            }

	            if (closestIdx - this.reDrawIdx > (0, _helpers.halfLength)(ptList)) {
	                // if the direction of motion is CCW (probably only happens early in the drawing)
	                changeListDirection(ptList); // reverse the order of the points in the list
	                if (_defines2.default.DBGREDRAW) this.log(this.reDrawIdx + ' closestIdx: ' + closestIdx + '------------------------------------------ changeListDirection');
	                (0, _toolbar.consoleWrite)(region.toString(true));

	                var ptList = region.getPts(); // update reference to region points and the closest point
	                closest = findClosestPtFrom(this.reDrawIdx, ptList, crsrPos);
	                ///???? closest = findClosestPtFrom(this.reDrawIdx + 1, ptList, crsrPos);
	                closestIdx = closest.idx;
	            }

	            if (closest.dist < removeTolerance_) {
	                // if it is reasonable to remove array points, do so
	                ptList.remove(this.reDrawIdx, closestIdx);
	                if (_defines2.default.DBGREDRAW) this.log(this.reDrawIdx + ' crsr: ' + crsrPos.toString() + '   closest idx: ' + closestIdx + ' removed from: ' + this.reDrawIdx + '  to: ' + closestIdx);
	                (0, _toolbar.consoleWrite)(region.toString(true)); //////////////
	            }

	            ptList.insert(this.reDrawIdx, crsrPos); // insert this new point right after this.reDrawIdx
	            if (_defines2.default.DBGREDRAW) this.log(this.reDrawIdx + '  inserted crsr: ' + crsrPos.toString());
	            (0, _toolbar.consoleWrite)(region.toString(true));

	            this.paintSelRegion(_defines2.default.DONT_HIGHLIGHT); // force a repaint of this region but do not paint the highlight
	            this.reDrawCnt++; // increment redraw iteration count
	            this.reDrawPrevPt = new _objects.cPoint(crsrPos.x, crsrPos.y); // replace the previous point

	            if (_defines2.default.DBGREDRAW) if (this.reDrawIdx == ptList.length - 1) this.log(this.reDrawIdx + ' finished1 - lapping back onto the new points');
	            return this.reDrawIdx == ptList.length - 1 ? false : true; // signal drawing finished or can continue
	        } else {
	            if (_defines2.default.DBGREDRAW) this.log(this.reDrawIdx + ' regReDraw: update : not close enough!   dist: ' + closest.dist);
	            return false; // return false finishes drawing
	        }
	    } else if (phase == 'finish') {
	        //........ finish region redraw mode
	        this.drawingCompleted(); // redraw: finshed
	        var callbackJson = { anObj: this, region: region };
	        if (this.reDrawCnt > 3) // if the drawing changed enough points in the region
	            genericConfirm('Do you want to save this change?', // then ask user if he wants to save these changes
	            'Save Changes', this.regReDrawFinish_cb, callbackJson);else this.regReDrawFinish_cb(callbackJson, false); // otherwise draw original region
	        return false;
	    } else {
	        // unknown phase passed in, should never get here
	        this.drawingCompleted(); // redraw: unknown phase
	        return false;
	    }

	    //..................................................
	    // closure functions
	    //............................................ findClosestPt()
	    // findClosestPt - finds the point in the passed list that is closest to the passed point
	    //                    and optionally within an  maximum distance
	    //                    and optionally can ignore a point at a specific list index
	    function findClosestPt(pt, list, opt_tolerance, opt_skipIdx) {
	        var idx = -1;
	        var closestDist = Number.MAX_VALUE;
	        var tolerance = opt_tolerance ? opt_tolerance : Number.MAX_VALUE;
	        for (var p = 0, len = list.length; p < len; p++) {
	            if (p == opt_skipIdx) // ignore the skip index if it is defined
	                continue;
	            var adist = list[p].cityBlockDistance(pt); // compute distance to the pt
	            self.log('findClosestPtInList: ' + list[p].toString() + '  dist: ' + adist);
	            if (adist < closestDist) {
	                idx = p; // save the list point closest to the passed point
	                closestDist = adist;
	            }
	        }

	        if (closestDist < tolerance) return { idx: idx, dist: closestDist };else {
	            //self.log("annots: regReDraw: findClosestPt:    failed closestDist: " + closestDist + "   tolerance: " + tolerance);
	            return { idx: -1, dist: Number.MAX_VALUE };
	        }
	    }
	    //............................................ findClosestPtFrom()
	    //    findClosestPtFrom - finds the point the the passed list starting at the passed start index
	    //                        that is closest to the passed point
	    function findClosestPtFrom(start, list, pt) {
	        var idx = -1;
	        var closestDist = Number.MAX_VALUE;
	        for (var p = start, len = list.length; p < len; p++) {
	            var dist = list[p].cityBlockDistance(pt);
	            //    self.log("findClosestPtInList: " + list[p].toString() + "  dist: " + dist);
	            if (dist < closestDist) {
	                idx = p;
	                closestDist = dist;
	            }
	        }
	        return { idx: idx, dist: closestDist };
	    }

	    //............................................ createNewList()
	    //    createNewList - replace or insert into the passed list a new point
	    //                    and reorder the list starting at the new point
	    function createNewList(ptList, crsrPos, closestIdx) {
	        var len = ptList.length;

	        var insertIdx = closestIdx + 1;
	        ptList.insert(insertIdx, crsrPos);

	        var len = ptList.length; // update the new list length
	        var newPtList = []; // new, temporary array

	        for (var p = 0, o = insertIdx; p < len; p++) {
	            // now put this point at index 0 of list
	            newPtList[p] = ptList[o];
	            if (++o >= ptList.length) // wrap index around original list
	                o = 0;
	        }
	        return newPtList;
	    }
	    //............................................ changeListDirection()
	    function changeListDirection(ptList) {
	        // index 0,1,2,3,4....99 ---> 0,99,98,97...
	        var item0 = ptList.shift(); // remove 1st list item
	        ptList.reverse(); // reverse the list
	        ptList.unshift(item0); // insert the saved 1st item
	    }
	    //..................................................
	};

	//............................................ regReDrawFinish_cb
	CANNOT_REGION.regReDrawFinish_cb = function (json, save) {
	    //note: although this is a prototype when called it does not know itself (this is window)
	    var anObj = json.anObj;
	    var region = json.region;
	    if (save == false) {
	        region.replacePts(region.priorPts); // restore the original region points
	    } else {
	        // save this region's points
	        if (_uScope2.default.instance.canSaveAnnotations()) {
	            // if incremental save is enabled, automatically update the database
	            var regionXML = '<Region Id="' + region.regionId + '">';
	            var vertexXML = region.buildVertexXML();
	            regionXML += '<Vertices>' + vertexXML + '</Vertices>' + '</Region>';
	            anObj.save({ action: 'updateRegion', layerId: region.layerId, regionXML: regionXML });
	            //this.log("regReDrawFinish_cb: saved region");
	        }
	    }
	    anObj.paintSelRegion(); // force a repaint of this region
	};

	//-------------------------------------------------------------------------------------------------
	//    raphael interface functions
	//-------------------------------------------------------------------------------------------------

	//............................................ rfSelect
	//    rfSelect - This function sets the outline width of the region.
	function rfSelect(aRegion, select) {
	    var strokeWidth = select ? _defines2.default.annotSpecs.strokeWidthSel : aRegion.getStrokeWidth();
	    if (aRegion.type != +_defines2.default.eAnTypes.text) aRegion.rfHandle.attr({ 'stroke-width': strokeWidth });else aRegion.data.textBBoxHandle.attr({ 'stroke-width': strokeWidth });
	}

	//............................................ rfDraw
	//    rfDraw - raphael graphics draw - This function draws the specfied shape in its defined position
	//            at scale.  When called with a defined rf handle the graphic's shape is updated,
	//            otherwise a new one is created and the newRegion's rfHandle and rfId are asigned.
	//            It always returns the rf handle to the annotation object.
	//    Notes:
	//        - Vertices of regions are always in base coordinate system and scaled for the current zoom.
	//        - IE8 would fill all regions and outlines with white at opacity 1.0.  To resolve this the
	//            attributes could not assume defaults and had to repeat all settings when updating the graphic.
	//
	function rfDraw(paper, newRegion, opt_viewZoom, opt_viewAngleDeg) {
	    if (newRegion === undefined) return; // sanity check
	    if (opt_viewAngleDeg == undefined) opt_viewAngleDeg = 0;

	    // closure vars
	    var pad = _defines2.default.annotSpecs.textBBoxPad;
	    var padX2 = pad * 2;
	    var decColor = newRegion.decRGB;
	    var hexColor = '#' + (0, _helpers.toHexColor)(decColor);
	    var hexBackColor = (0, _helpers.isLightColor)(decColor) ? '#000' : '#FFF'; // if forecolor is light, backcolor is dark and visa versa
	    var fillColor = '#' + (0, _helpers.deSaturate)(decColor);
	    var ptList = newRegion.getPts(); // point list is in base (zoom = 1.0) coords
	    var vtxCnt = ptList.length;
	    if (vtxCnt < 1) return; // odd things happen when ending a caliper behind the magnifier, for example

	    // if a opt_viewZoom value is not passed in, draw at the region's zoom value
	    var scale = (0, _helpers.isDefined)(opt_viewZoom) ? 1. / opt_viewZoom : 1. / newRegion.zoom;

	    var strokeWidth = newRegion.getStrokeWidth(); // select the proper stroke width for this region
	    var attrs; // rf draw attributes array

	    var rfCurHandle = newRegion.rfHandle;
	    switch (newRegion.shape) {
	        // path format: "M 100 100 L 300 100 L 200 300" (open path) - we are using this form during draw
	        // path format: "M 100 100 L 300 100 L 200 300 Z" (closed path) - we are using this once drawn item is completed
	        case 'pen':
	        case 'negpen':
	            if (newRegion.shape === 'pen' && vtxCnt < 3) return rfCurHandle;
	            var spath = 'M ' + ptList[0].x * scale + ' ' + ptList[0].y * scale;
	            if (vtxCnt > 1) spath += ' L ' + ptList[1].x * scale + ' ' + ptList[1].y * scale;

	            for (var v = 2, vlen = vtxCnt; v < vlen; v++) {
	                spath += ' ' + ptList[v].x * scale + ' ' + ptList[v].y * scale;
	            }spath += newRegion.openShape == false ? ' Z' : ''; // closepath ?

	            var strokeDash = newRegion.shape == 'negpen' ? '- ' : '';
	            var fillOpacity = newRegion.shape == 'negpen' ? _defines2.default.annotSpecs.fillOpacity : 0.0;
	            attrs = {
	                'stroke': hexColor,
	                'stroke-width': strokeWidth,
	                'fill': fillColor,
	                'stroke-dasharray': strokeDash,
	                'fill-opacity': fillOpacity
	            };
	            rfCurHandle = rfDrawPath_();
	            break;
	        case 'ruler':
	        case 'caliper':
	        case 'polygon':
	            var spath = 'M ' + ptList[0].x * scale + ' ' + ptList[0].y * scale;
	            if (vtxCnt > 1) spath += ' L ' + ptList[1].x * scale + ' ' + ptList[1].y * scale;

	            for (var v = 2; v < vtxCnt; v++) {
	                spath += ' ' + ptList[v].x * scale + ' ' + ptList[v].y * scale;
	            }spath += newRegion.openShape == false ? ' Z' : ''; // closepath ?

	            attrs = { 'stroke': hexColor, 'stroke-width': strokeWidth, 'fill': fillColor, 'fill-opacity': 0.0 };
	            rfCurHandle = rfDrawPath_();

	            if (newRegion.shape == 'ruler' || newRegion.shape == 'caliper') {
	                if (newRegion.isHighLight == false) {
	                    // if not drawing the outline of the highlight, draw the caliper distance metric
	                    var xloc = newRegion.getPt(vtxCnt - 1).x * scale - 20;
	                    var yloc = newRegion.getPt(vtxCnt - 1).y * scale - 25;
	                    var str = newRegion.data.lengthMicrons + ' um';
	                    rfDrawRegionText(paper, newRegion, str, xloc, yloc);
	                }
	            }
	            break;
	        case 'rect':
	            // note iscope always draws a rect (regardless of the vertex's stored) but, since this is defined with 4 vertices, use path here
	            if (vtxCnt < 4) return rfCurHandle;
	            // report region scale is passed in
	            if (newRegion.isReportRegion && newRegion.viewZoom) scale = 1. / newRegion.viewZoom;

	            var spath = 'M ' + ptList[0].x * scale + ' ' + ptList[0].y * scale + ' L ' + ptList[1].x * scale + ' ' + ptList[1].y * scale + ' ' + ptList[2].x * scale + ' ' + ptList[2].y * scale + ' ' + ptList[3].x * scale + ' ' + ptList[3].y * scale + ' Z';
	            attrs = { 'stroke': hexColor, 'stroke-width': strokeWidth, 'fill': fillColor, 'fill-opacity': 0.0 };
	            rfCurHandle = rfDrawPath_();

	            // for report region (not for other rects with text), draw the on-image text
	            if (newRegion.isHighLight == false && newRegion.isReportRegion) {
	                if (newRegion.note.length) {
	                    // if the note has content, draw it
	                    var bbox = newRegion.rfHandle.getBBox();
	                    var xloc = newRegion.getPt(2).x * scale;
	                    var yloc = newRegion.getPt(2).y * scale + 15;
	                    rfDrawRegionText(paper, newRegion, newRegion.note, xloc, yloc);
	                } else {
	                    if (newRegion.data.rfTextHandle) {
	                        newRegion.data.rfTextHandle.hide(); // if the note does not have content
	                        newRegion.data.textBBoxHandle.hide(); // hide the text box and text
	                        newRegion.data = {}; // and clear the associative array
	                    }
	                }
	            }
	            break;
	        case 'report':
	            // This handler fires for fixed resolution regions only. In other cases, the report is converted to a rect,
	            // and once drawing is finished its textbox is added.
	            if (vtxCnt < 1) return rfCurHandle;
	            // the following is only good for report types of fixed size, user drawn are drawn as type rect from the start
	            if (newRegion.viewZoom) scale = 1 / newRegion.viewZoom;

	            // fixed report size but drawn at any resolution requires scaling the fixed report region coords
	            var expandToBase;
	            if (newRegion.reportType == _defines2.default.eReportTypes.CurRes_FixedDim) {
	                expandToBase = newRegion.zoom;
	            } else if (newRegion.reportType == _defines2.default.eReportTypes.FullRes_FixedDim) {
	                expandToBase = _uScope2.default.instance.getThisImage().getNormalizationFactor();
	            } else {
	                expandToBase = 1;
	            }

	            var width = _uScope2.default.instance.prefGet('reportRegionWidth', _defines2.default.eReportSpec.defWidthPx) * expandToBase;
	            var height = _uScope2.default.instance.prefGet('reportRegionHeight', _defines2.default.eReportSpec.defHeightPx) * expandToBase;

	            // the first point is to be the center of the image so form the fixed size report rect around it
	            ptList[0].x = ptList[0].x - parseInt(width / 2);
	            ptList[0].y = ptList[0].y - parseInt(height / 2);
	            ptList.length = 1; // insure only top left point in array
	            var pt = new _objects.cPoint(ptList[0].x + width, ptList[0].y);
	            newRegion.addPt(pt); // top right = ptList[1]
	            pt = new _objects.cPoint(ptList[1].x, ptList[0].y + height);
	            newRegion.addPt(pt); // bottom right ptList[2]
	            pt = new _objects.cPoint(ptList[0].x, ptList[2].y);
	            newRegion.addPt(pt); // bottom left = ptList[3]

	            ptList = newRegion.getPts(); // now draw the report region at the current zoom
	            var spath = 'M ' + ptList[0].x * scale + ' ' + ptList[0].y * scale + ' L ' + ptList[1].x * scale + ' ' + ptList[1].y * scale + ' ' + ptList[2].x * scale + ' ' + ptList[2].y * scale + ' ' + ptList[3].x * scale + ' ' + ptList[3].y * scale + ' Z';
	            attrs = { 'fill': fillColor, 'fill-opacity': 0.0 };
	            rfCurHandle = rfDrawPath_();
	            break;
	        case 'ellipse':
	            var left = ptList[0].x * scale; // ptList[0] is top left corner and ptList[1] is bottom right corner
	            var top = ptList[0].y * scale;
	            var rx = Math.round((ptList[1].x * scale - left + 1) / 2);
	            var ry = Math.round((ptList[1].y * scale - top + 1) / 2);
	            var cx = Math.round(+left + +rx);
	            var cy = Math.round(+top + +ry);

	            attrs = { 'stroke': hexColor, 'stroke-width': strokeWidth, 'fill': fillColor, 'fill-opacity': 0.0 };

	            if ((0, _helpers.isDefined)(rfCurHandle)) {
	                attrs.cx = cx;
	                attrs.cy = cy;
	                attrs.rx = rx;
	                attrs.ry = ry;
	                rfCurHandle.attr(attrs);
	            } else {
	                newRegion.rfHandle = paper.ellipse(cx, cy, rx, ry).attr(attrs);
	                newRegion.rfId = newRegion.rfHandle.id;
	            }
	            break;
	        case 'arrow':
	            var x = Math.floor(ptList[0].x * scale);
	            var y = Math.floor(ptList[0].y * scale);
	            var alen = _defines2.default.arrowSpecs.length;
	            var tlen = _defines2.default.arrowSpecs.tagLength;
	            var tlenVert = newRegion.isHighLight == true ? tlen - 2 : tlen;
	            var tlenHoriz = newRegion.isHighLight == true ? tlen - 1 : tlen;
	            var spath = 'M ' + (x + tlen / 2) + ' ' + (y - tlen / 2) + ' L' + (x + alen) + ' ' + (y - alen) // fixed 45 degree arrow path
	            + 'M ' + x + ' ' + y + ' L' + (x + tlenHoriz) + ' ' + y // horiz line of arrow head
	            + 'M ' + x + ' ' + y + ' L' + x + ' ' + (y - tlenVert) // vertical line of arrow head
	            + ' L' + (x + tlenHoriz) + ' ' + y // diag line of arrow head
	            + 'Z';

	            attrs = { 'stroke': hexColor, 'stroke-width': strokeWidth, 'stroke-linecap': 'square' };
	            if (newRegion.isHighLight == false) {
	                attrs.fill = fillColor;
	                attrs['fill-opacity'] = 1.0;
	            }
	            rfCurHandle = rfDrawPath_();

	            if (ptList.length == 1) {
	                // for ImageScope inter-operability,
	                var bbox = rfCurHandle.getBBox(); // add bounding box corner to point list
	                var pt = new _objects.cPoint(parseInt(ptList[0].x + bbox.width), parseInt(ptList[0].y - bbox.height));
	                newRegion.addPt(pt);
	            }
	            break;
	        case 'pin':
	            var coords = _defines2.default.pinSpecs.coords; // the normalized coord path of the pin drop
	            var x = Math.floor(ptList[0].x * scale);
	            var y = Math.floor(ptList[0].y * scale);
	            //debug-only if (newRegion.isHighLight == false) consoleWrite("\nPin Drop: " + ptList[0].x + "," + ptList[0].y + " scaled: " + x + "," + y + "  scale: " + scale);

	            var spath = 'M ' + (+coords[0] + x) + ' ' + (+coords[1] + y) + ' L'; // build the pin drop path
	            for (var p = 2, len = coords.length; p < len; p += 2) {
	                spath = spath + ' ' + (+coords[p] + x) + ' ' + (+coords[p + 1] + y);
	            }
	            spath = spath + ' Z';

	            attrs = {
	                'stroke': hexColor,
	                'stroke-width': strokeWidth,
	                'fill': fillColor,
	                'fill-opacity': _defines2.default.annotSpecs.fillOpacity
	            };
	            rfCurHandle = rfDrawPath_();

	            if (opt_viewAngleDeg != undefined) {
	                rfRotate(newRegion, opt_viewAngleDeg);
	            }
	            break;
	        ////        case "pinHackDebug":                                    //debug-only - comment out pin so can use pin position to add shape of your own
	        ////            var coords = us.pinSpecs.coords;                     // the normalized coord path of the pin drop

	        ////            ptList[0].x = Math.floor(ptList[0].x / 1000) * 1000;
	        ////            ptList[0].y = Math.floor(ptList[0].y / 1000) * 1000;

	        ////            var x = Math.floor(ptList[0].x * scale);
	        ////            var y = Math.floor(ptList[0].y * scale);
	        ////            //debug-only if (newRegion.isHighLight == false) consoleWrite("\nPin Drop: " + ptList[0].x + "," + ptList[0].y + " scaled: " + x + "," + y + "  scale: " + scale);

	        ////            newRegion.setType(us.eAnTypes.pen);
	        ////            var spath = "M " + ptList[0].x + " " + ptList[0].y;
	        ////            var pt;
	        ////            var delta = 25;
	        ////            pt = new cPoint(ptList[0].x + 111, ptList[0].y); newRegion.addPt(pt);
	        ////            pt = new cPoint(ptList[0].x + 100, ptList[0].y + 100); newRegion.addPt(pt);
	        ////            pt = new cPoint(ptList[0].x, ptList[0].y + 100); newRegion.addPt(pt);

	        ////            for (var v = 2, vlen = vtxCnt; v < vlen; v++)
	        ////                spath += " " + ptList[v].x * scale + " " + ptList[v].y * scale;
	        ////            spath += " Z";                                         // closepath when pen is completed

	        ////            if (isDefined(rfCurHandle))
	        ////                rfCurHandle.attr({ "path": spath, stroke: hexColor, fill: fillColor, 'stroke-width': strokeWidth, "fill-opacity": 0.0 });
	        ////            else {
	        ////                newRegion.rfHandle = paper.path(spath).attr({ stroke: hexColor, 'stroke-width': strokeWidth, fill: fillColor, "fill-opacity": 0.0 });
	        ////                newRegion.rfId = newRegion.rfHandle.id;
	        ////            }
	        ////            break;
	        case 'text':
	            if (newRegion.isHighLight == false) {
	                if ((0, _helpers.isDefined)(rfCurHandle)) // draw the text
	                    rfCurHandle.attr({
	                        fill: hexColor, 'font-size': _defines2.default.annotSpecs.fontSize, 'font-weight': 'bold',
	                        text: newRegion.note, x: ptList[0].x * scale, y: ptList[0].y * scale
	                    });else {
	                    newRegion.rfHandle = paper.text(ptList[0].x * scale, ptList[0].y * scale, newRegion.note).attr({ fill: hexColor, 'font-size': _defines2.default.annotSpecs.fontSize, 'font-weight': 'bold' });
	                    newRegion.rfId = newRegion.rfHandle.id;
	                }

	                var bbox = newRegion.rfHandle.getBBox(); // draw the bounding box around the text
	                newRegion.data.bbox = bbox; // save for highlight

	                if ((0, _helpers.isDefined)(newRegion.data.textBBoxHandle)) newRegion.data.textBBoxHandle.attr({
	                    'stroke': hexColor, 'fill': hexBackColor,
	                    x: bbox.x - pad, y: bbox.y - pad, width: bbox.width + padX2, height: bbox.height + padX2
	                });
	                ///            , "font-family": "Arial, Helvetica, sans-serif" });
	                else newRegion.data.textBBoxHandle = paper.rect(bbox.x - pad, bbox.y - pad, bbox.width + padX2, bbox.height + padX2, _defines2.default.annotSpecs.textBBoxRadius).attr({ 'stroke': hexColor, 'stroke-width': strokeWidth, fill: hexBackColor });

	                newRegion.rfHandle.toFront(); // move the text in front of the bbox
	            } else {
	                var bbox = newRegion.data.bbox;
	                if ((0, _helpers.isDefined)(newRegion.rfHandle)) rfCurHandle.attr({
	                    'stroke': hexColor, 'stroke-width': strokeWidth, 'fill-opacity': 0.0,
	                    x: bbox.x - pad, y: bbox.y - pad, width: bbox.width + padX2, height: bbox.height + padX2
	                });else newRegion.rfHandle = paper.rect(bbox.x - pad, bbox.y - pad, bbox.width + padX2, bbox.height + padX2, _defines2.default.annotSpecs.textBBoxRadius).attr({ 'stroke': hexColor, 'stroke-width': strokeWidth, 'fill-opacity': 0.0 });
	            }
	            break;
	    }

	    if (newRegion.isHighLight && newRegion.rfHandle) // if this region is the high light region
	        newRegion.rfHandle.toFront(); // move the highlight in front of the outline

	    if (_defines2.default.DBGANNOTEX && !newRegion.isHighLight) (0, _toolbar.consoleWrite)('rfDraw: scale: ' + scale + '  ' + newRegion.toString(false));
	    return newRegion.rfHandle; // return the raphael reference to the graphics object


	    //..................................................
	    // closure functions
	    //............................................ rfDrawPath_()
	    function rfDrawPath_() {
	        if ((0, _helpers.isDefined)(rfCurHandle)) {
	            attrs.path = spath;
	            rfCurHandle.attr(attrs);
	            return rfCurHandle;
	        } else {
	            newRegion.rfHandle = paper.path(spath).attr(attrs);
	            newRegion.rfId = newRegion.rfHandle.id;
	            return newRegion.rfHandle;
	        }
	    }

	    //............................................ rfDrawRegionText()
	    // This function draws text assoicated with a region at the specified location with a white,
	    //  round cornered bounding box behind it.  If the raphael objects for the text and its box
	    //  do not exist, they are created and the region object data is updated to retain them.
	    //    This is used for ruler and caliper annotation.
	    function rfDrawRegionText(paper, newRegion, str, xloc, yloc) {
	        ////    var rfDrawRegionText = function (paper, newRegion, str, xloc, yloc) {
	        var fontSize = _defines2.default.annotSpecs.fontSize;
	        // draw the text
	        if ((0, _helpers.isDefined)(newRegion.data.rfTextHandle)) newRegion.data.rfTextHandle.attr({
	            text: str,
	            x: xloc,
	            y: yloc,
	            fill: hexColor,
	            'stroke': hexColor,
	            'font-size': fontSize
	        });else newRegion.data.rfTextHandle = paper.text(xloc, yloc, str).attr({ fill: hexColor, 'stroke': hexColor, 'font-size': fontSize });

	        var bbox = newRegion.data.rfTextHandle.getBBox(); // draw the bounding box around the text
	        //currently not used newRegion.data.bbox = bbox;                         // save for highlight
	        if ((0, _helpers.isDefined)(newRegion.data.textBBoxHandle)) newRegion.data.textBBoxHandle.attr({
	            'stroke': hexColor,
	            fill: hexBackColor,
	            x: bbox.x - pad,
	            y: bbox.y - pad,
	            width: bbox.width + padX2,
	            height: bbox.height + padX2
	        });else newRegion.data.textBBoxHandle = paper.rect(bbox.x - pad, bbox.y - pad, bbox.width + padX2, bbox.height + padX2, _defines2.default.annotSpecs.textBBoxRadius).attr({ 'stroke': hexColor, fill: hexBackColor });
	        newRegion.data.rfTextHandle.toFront(); // move the text in front of the bbox
	    }
	    //..................................................
	}

	//............................................ rfRotate
	//    This function rotates the passed region.
	//    Note that the input angle is negated as uScope's positive direction is the reverse of Raphael's
	function rfRotate(region, angleDeg) {
	    var rfCurHandle = region.rfHandle;
	    switch (region.shape) {
	        case 'pin':
	            rfCurHandle.transform(''); // must clear the transform or the rotation center wanders away!
	            var bbox = rfCurHandle.getBBox();
	            var xformStr = ' R' + -angleDeg; // absolute rotation angle
	            xformStr += ',' + Math.round(bbox.x + bbox.width / 2) // center of rotation
	            + ',' + Math.round(bbox.y + bbox.height);
	            rfCurHandle.transform(xformStr); // perform the transform
	            break;
	        default:
	            break;
	    }
	}

	//............................................ regHighLight
	// AnnotationsService.regHighLight - This function [de]highlights a region.
	//
	//    aRegion - region to highlight, or not
	//    select - required, {true, false} to highlight or not
	//    viewZoom = optional, view zoom of region to pass to rfDraw
	CANNOT_REGION.regHighLight = function (aRegion, select, opt_viewZoom, opt_viewAngleDeg) {
	    var type = +aRegion.type;
	    rfSelect(aRegion, select); // increase/decrease the width of the region outline
	    if (select) {
	        var hiRegion = this.rfRegionHiLite[type]; // get the region that highlights this type

	        hiRegion.decRGB = (0, _helpers.isLightColor)(aRegion.decRGB) ? 0 : 16777215; // if forecolor is light, backcolor is dark and visa versa
	        hiRegion.zoom = aRegion.zoom;
	        hiRegion.pts = aRegion.pts;
	        hiRegion.centerPt = aRegion.centerPt;

	        if (type == +_defines2.default.eAnTypes.text) // for on image text, highlight the bounding box
	            hiRegion.data.bbox = aRegion.data.bbox;

	        rfDraw(this.paper, hiRegion, opt_viewZoom, opt_viewAngleDeg); // draw the highlight
	        hiRegion.rfHandle.show();
	        //if (us.DBGANNOT) consoleWrite("regHighLight: rfId: " + aRegion.rfHandle.id + "  shape: " + aRegion.shape + "   Highlighted Region rfId: " + hiRegion.rfHandle.id);

	        if ((0, _helpers.isDefined)(aRegion.data.rfTextHandle)) // if this region has buddy text, like a caliper measurement
	            aRegion.data.rfTextHandle.toFront(); // move the text in front of the region outline so the highlight doesn't cover it
	    } else {
	        this.rfRegionHiLite[type].rfHandle.hide(); // hide this outline
	    }
	};

	//............................................ rfDrawHover
	//    rfDrawHover - This function draws the hover note for the passed rfId.
	//                    Note that a note length equal to 0 is valid - erasing the prior note.
	//    Improvements:
	//        -would like to pass region of note and region for hover graphic
	CANNOT_DRAW.rfDrawHover = function (rfId) {
	    var rfRegions = this.getRegionsArray();
	    var region = rfRegions[rfId];

	    if (region.shape === 'text' || region.isReportRegion) // if the region is on-image-text or is report region, nothing to do
	        return;

	    if ((0, _helpers.isUnDefined)(region.note) || region.note.length == 0) {
	        // if the note for this region is not defined or its length is 0
	        if ((0, _helpers.isDefined)(this.hoverMemoHandle)) this.hoverMemoHandle.hide();
	        if ((0, _helpers.isDefined)(this.hoverMemoBBoxHandle)) this.hoverMemoBBoxHandle.hide();
	        return;
	    }
	    if ((0, _helpers.isDefined)(this.hoverMemoHandle)) this.hoverMemoHandle.show();
	    if ((0, _helpers.isDefined)(this.hoverMemoBBoxHandle)) this.hoverMemoBBoxHandle.show();

	    var viewZoom = this.getMyImage().getViewZoom();

	    var ptList = region.getPts(); // point list is in base (zoom = 1.0) coords
	    var xloc = +ptList[0].x / viewZoom;
	    var yloc = +ptList[0].y / viewZoom;
	    if (region.shape === 'pin') yloc = Math.round(ptList[0].y / viewZoom - _defines2.default.pinSpecs.height);

	    var pad = _defines2.default.annotSpecs.textBBoxPad;
	    var padX2 = pad * 2;
	    var decColor = 0; // black text
	    var hexColor = '#' + (0, _helpers.toHexColor)(decColor);
	    var hexBackColor = '#F6EFBA'; // sticky note yellow
	    if ((0, _helpers.isDefined)(this.hoverMemoHandle)) // draw the text
	        this.hoverMemoHandle.attr({ text: region.note, x: xloc, y: yloc, fill: hexColor });else this.hoverMemoHandle = this.paper.text(xloc, yloc, region.note).attr({ 'text-anchor': 'start', fill: hexColor, 'font-size': _defines2.default.annotSpecs.fontSize });

	    var bbox = this.hoverMemoHandle.getBBox();
	    if ((0, _helpers.isDefined)(this.hoverMemoBBoxHandle)) // draw the bounding box around the text
	        this.hoverMemoBBoxHandle.attr({
	            'stroke': hexColor,
	            fill: hexBackColor,
	            x: bbox.x - pad,
	            y: bbox.y - pad,
	            width: bbox.width + padX2,
	            height: bbox.height + padX2
	        });else this.hoverMemoBBoxHandle = this.paper.rect(bbox.x - pad, bbox.y - pad, bbox.width + padX2, bbox.height + padX2, _defines2.default.annotSpecs.textBBoxRadius).attr({ 'stroke': hexColor, fill: hexBackColor, opacity: 1.0 });

	    yloc = yloc - bbox.height / 2; // adjust the note position for the height of the bounding box
	    this.hoverMemoHandle.attr({ y: yloc }).toFront(); // and set the text in front of the bbox

	    bbox = this.hoverMemoHandle.getBBox(); // move the bounding box to where the note text moved
	    this.hoverMemoBBoxHandle.attr({ y: bbox.y - pad });

	    if (_defines2.default.DBGANNOT) (0, _toolbar.consoleWrite)('rfDrawHover: rfId: ' + rfId + '  note: ' + region.note + '\n    hoverMemoHandle: ' + this.hoverMemoHandle.id + '  hoverMemoBBoxHandle: ' + this.hoverMemoBBoxHandle.id);
	};

	//________________________________________________________________________________________________
	//............................................ chooseLayer
	//    us.chooseLayer - This function selects the appropriate layer for the passed annotation type and returns the layerId to assign to the region;
	//                    A negative Id is returned if no layer can be selected.
	//                    If a new region is being added to the report layer, if there is a report region already that region is deleted.
	//ia-todo: us.chooseLayer, and others - assign to a base annot class
	//todo: replace consoleWrites with log() and err() ?
	// improvements:
	//    - move this fn to annotations base classs
	_defines2.default.chooseLayer = function (anObj, anType) {
	    var preamble = 'annot: chooseLayer: ';
	    var layers = anObj.getLayersObj();
	    var rtnSelLayerId = -1;

	    if (anType == _defines2.default.eAnTypes.report) {
	        // if anType is report, select/created report layer
	        rtnSelLayerId = getSpecialLayerIdOrCreate_(_defines2.default.ReportLayerName);
	        if (rtnSelLayerId != -1) layers.deleteRegions(rtnSelLayerId); // remove any existing regions from the report layer (since only one is allowed to exist)
	    } else {
	        // otherwise we are creating an annotation that is not a report region
	        var selLayer = layers.getSelected();
	        if (selLayer) {
	            // if selected layer is valid
	            if (selLayer.get('isReportLayer') == false) {
	                // if selected layer is NOT a report layer

	                if (selLayer.get('Type') != _defines2.default.anLayerTypes.aafresult) rtnSelLayerId = selLayer.get('Id'); // as long as the currently selecte layer isn't a result layer, it will be used
	                else rtnSelLayerId = selLayer.get('InputAnnotationId'); // but if aafresult layer is currently selected, switch to its parent layer
	            }
	        }
	    }
	    if (rtnSelLayerId < 0) // if the layerId is still not valid then just use/create annotation layer
	        rtnSelLayerId = getSpecialLayerIdOrCreate_(_defines2.default.AnnotLayerName);
	    layers.selectByProperty('Id', rtnSelLayerId); // now, finally, select that layer; note that passing in a -1 deselects all layers

	    if (_defines2.default.DBGANNOT) (0, _toolbar.consoleWrite)(preamble + ' selected layer, id:' + rtnSelLayerId + ' Name: ' + layers.getNameById());
	    return rtnSelLayerId;

	    //..................................................
	    // closure functions
	    //............................................ getSpecialLayerIdOrCreate_()
	    //    getSpecialLayerIdOrCreate_ - This function returns the selected layerId or -1 if not able to select it and requested it be created
	    function getSpecialLayerIdOrCreate_(specName) {
	        var layerId = layers.getLayerIdByName(specName);
	        if (layerId < 0) {
	            // if the layer does not exist,
	            var status = layers.createAddSaveSpecial({ 'layerName': specName }); // and create this special layer
	            if (_defines2.default.DBGANNOT) this.log('Error:' + preamble + '  ' + specName + ' layer creation requested.');
	        }
	        return layerId;
	    }
	    //..................................................
	};

	//............................................ isReportFullRes
	// us.isReportFullRes - This function returns true if the passed report type is a full resolution image.
	_defines2.default.isReportFullRes = function (reportType) {
	    return reportType == _defines2.default.eReportTypes.FullRes_FixedDim || reportType == _defines2.default.eReportTypes.FullRes_UserDrawn ? true : false;
	};

	//............................................ isReportFixedDim
	// us.isReportFixedDim - This function returns true if the passed report type is a fixed size region.
	_defines2.default.isReportFixedDim = function (reportType) {
	    return reportType == _defines2.default.eReportTypes.FullRes_FixedDim || reportType == _defines2.default.eReportTypes.CurRes_FixedDim ? true : false;
	};

	//............................................ genericConfirm
	//    genericConfirm - A general purpose confirm panel that removes itself from the DOM when closed.
	//
	//    parameters:
	//        message:        required, string, your message to the user
	//        title:            required, string
	//        callback:        required
	function genericConfirm(message, title, callback, callbackJson) {
	    if (message == undefined) message = '';
	    if (title == undefined) title = '';
	    if (message.length == 0 && message.length == 0) return;

	    var jPanel = $('<div class=' + _defines2.default.clsPANEL + ' title="' + title + '">' + message + '</div>');
	    $(_defines2.default.idHashROOT).append(jPanel); // add the panel to the root


	    $(jPanel).dialog({
	        autoOpen: true, modal: true, closeOnEscape: false, resizable: false,
	        dialogClass: 'uscope-dialog dialogMover',
	        close: function close(event, ui) {
	            $(this).remove();
	        },
	        buttons: [{
	            text: 'No', click: function click() {
	                $(this).remove();
	                if (callback) callback(callbackJson, false);
	                return false;
	            }
	        }, {
	            text: 'Yes', click: function click() {
	                $(this).remove();
	                if (callback) callback(callbackJson, true);
	                return true;
	            }
	        }]
	    });

	    // append this modal dialog to body to work around a jquery issue that modal dialogs cannot be dismissed in popup mode
	    //    (would normally want it appended to the uscope div)
	    // note that the dialog is the parent to the panel created
	    $('#' + _defines2.default.idMSGPANEL).parent().appendTo('body');
	}

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = cRegions;

	var _defines = __webpack_require__(3);

	var _defines2 = _interopRequireDefault(_defines);

	var _events = __webpack_require__(10);

	var _helpers = __webpack_require__(8);

	var _uScope = __webpack_require__(11);

	var _uScope2 = _interopRequireDefault(_uScope);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	//________________________________________________________________________________________________
	// regions.js
	/**
	 * @file   example_action.h
	 * @Author Me (me@example.com)
	 * @date   September, 2008
	 * @brief  Brief description of file.
	 *
	 * Detailed description of file.
	 */
	//    This file contains the annotation region collection object 'cRegions'.
	//
	//    history
	//
	//    1302    cperz    created
	//    _______________________________________end_AIHv1/PR __________________________________________
	//    141118    cperz    ol3 integration
	//    141222    cperz    cRegions created; move cRegion (singular) into its own file; add support for image analysis:
	//    150318    cperz    build out for analysis and markup;
	//
	//________________________________________________________________________________________________
	//    Object Name: cRegions
	//    Overview:  The cRegions object is a container for cRegion objects

	function cRegions(anObj, inImageId) {
	    var self = this;
	    var thisAn = anObj; // the annotation object - the parent
	    var imageId = inImageId;

	    // ..... to group fns in js parser, for ease of search (e.g. search for all 'us_region_pts')
	    var CREGIONS = this; //
	    var CREGIONS_GET = this; //
	    var CREGIONS_SET = this; //
	    var CREGIONS_LAYER = this; //
	    var CREGIONS_MARKUP = this; //
	    var CREGIONS_ANALYSIS = this; //
	    var CREGIONS_DEBUG = this; //

	    var logger = _defines2.default.helpers.createLogger(true, 'cRegions');
	    var log = logger.log;
	    var err = logger.error;

	    // The array containing all regions, rfId (live assigned) is the index into the array (not regionId)
	    // Note that the length of this array is NOT the number of regions.  Deleted regions are undefined slots in the array.
	    var rfRegions = [];
	    CREGIONS_GET.getRegionsArray = function () {
	        return rfRegions;
	    };

	    var isValidRegion_ = function isValidRegion_(rfId) {
	        return rfRegions[rfId] ? true : false;
	    };

	    CREGIONS_GET.getRegionId = function (rfId) {
	        return isValidRegion_(rfId) ? rfRegions[rfId].getRegionId() : undefined;
	    };

	    CREGIONS_GET.getType = function (rfId) {
	        return isValidRegion_(rfId) ? rfRegions[rfId].getType() : undefined;
	    };
	    CREGIONS_GET.getShape = function (rfId) {
	        return isValidRegion_(rfId) ? rfRegions[rfId].getShape() : undefined;
	    };
	    CREGIONS_GET.getLayerId = function (rfId) {
	        return isValidRegion_(rfId) ? rfRegions[rfId].getLayerId() : -1;
	    }; // return -1 if region does not exist
	    CREGIONS_GET.getRGB = function (rfId) {
	        return isValidRegion_(rfId) ? rfRegions[rfId].getRGB() : undefined;
	    };

	    CREGIONS_ANALYSIS.isAnalyzed = function (rfId) {
	        return isValidRegion_(rfId) ? rfRegions[rfId].isAnalyzed : false;
	    };
	    CREGIONS_GET.isWholeSlide = function (rfId) {
	        return isValidRegion_(rfId) ? rfRegions[rfId].isWholeSlide : false;
	    };
	    CREGIONS_MARKUP.getMarkupImageId = function (rfId) {
	        return isValidRegion_(rfId) ? rfRegions[rfId].getMarkupImageId() : undefined;
	    };
	    CREGIONS_MARKUP.isWholeSlideMarkup = function (rfId) {
	        return isValidRegion_(rfId) ? rfRegions[rfId].isWholeSlideMarkup : false;
	    };

	    CREGIONS_MARKUP.markupIsInView = function (rfId, cr2View) {
	        return isValidRegion_(rfId) ? rfRegions[rfId].markupIsInView(cr2View) : false;
	    };
	    CREGIONS_MARKUP.getMarkupInfo = function (rfId) {
	        return isValidRegion_(rfId) ? rfRegions[rfId].getMarkupInfo() : undefined;
	    };
	    CREGIONS_MARKUP.hasMarkup = function (rfId) {
	        return isValidRegion_(rfId) ? rfRegions[rfId].get('hasMarkup') : false;
	    };

	    //............................................ cRegions getReportRegionId
	    CREGIONS_GET.getReportRegionId = function () {
	        // note: this is inefficient if there are a lot of regions...
	        for (var r = 0, len = rfRegions.length; r < len; r++) {
	            if (rfRegions[r] && rfRegions[r].get('isReportRegion')) return rfRegions[r].get('regionId');
	        }
	        return -1;
	    };
	    //............................................ cRegions createRegionResponse
	    // { imageId: imageId, negId: oRegionId, assignedId: regionId, layerId: layerId }
	    CREGIONS.createRegionResponse = function (json) {
	        var aRegion = this.getByRegionId(json.negId);
	        if (aRegion) {
	            var negId = json.negId;
	            var posId = json.assignedId;
	            aRegion.setRegionId(+posId);
	            //debug-only consoleWrite("cRegions: createRegionResponse: id update: " + negId + " --> " + posId);

	            (0, _events.triggerUScopeEvent)(_defines2.default.evANNOTCHANGE, {
	                imageId: json.imageId, regionId: posId, // fire event that annotations have changed (add)
	                anShape: aRegion.isReportRegion ? 'report' : aRegion.getShape(), action: 'add'
	            });
	        } else {
	            err('createRegionResponse:  imageId: ' + json.imageId + '  assigned id: ' + json.assignedId + ' not reconciled with temp id: ' + json.negId);
	        }
	    };

	    //............................................ get/set NextRegionId()
	    var lastRegionId = 0; // last region id in each layer; used to set id for new region
	    // this regionId is not the true id assigned by DataServer. It is a unique neg id used to request a new region id... it is most likely neg of rfId
	    CREGIONS_GET.getNextRegionId = function () {
	        // new region id's are negative values so they are flagged for dataserver
	        return -++lastRegionId;
	    };
	    CREGIONS_SET.setNextRegionId = function (id) {
	        if (id > lastRegionId) // save the maximum region id
	            lastRegionId = id;
	    };

	    //............................................ cRegions clear
	    CREGIONS.clear = function () {
	        rfRegions.length = 0;
	    };

	    //............................................ cRegions add
	    CREGIONS.add = function (aRegion, opt_bDoSave) {
	        //toconsider: could validate region and return true/false
	        rfRegions[aRegion.rfId] = aRegion; // add region to array

	        this.setNextRegionId(aRegion.regionId); // keep next regionId up to date

	        if (opt_bDoSave == true && _uScope2.default.instance.canSaveAnnotations()) {
	            var regionXML = aRegion.buildXML(true); // build the region xml for the new annotation
	            thisAn.save({ action: 'addRegion', layerId: aRegion.layerId, regionXML: regionXML, tag: aRegion.regionId });
	        }
	    };
	    //............................................ cRegions addRegionResponse
	    // addRegionResponse -
	    //        input json = { imageId: , negId: , assignedId:   }
	    CREGIONS.addRegionResponse = function (json) {
	        var negId = json.negId;
	        var posId = json.assignedId;
	        this.setNextRegionId(posId); // track the highest value region id

	        for (var i = 0, len = rfRegions.length; i < len; i++) {
	            if ((0, _helpers.isDefined)(rfRegions[i]) && rfRegions[i].regionId == negId) {
	                rfRegions[i].regionId = posId;
	                //debug-only log("addRegionResponse: id update: " + negId + " --> " + posId);

	                (0, _events.triggerUScopeEvent)(_defines2.default.evANNOTCHANGE, {
	                    imageId: json.imageId, regionId: posId, // fire event that annotations have changed
	                    anShape: rfRegions[i].isReportRegion ? 'report' : rfRegions[i].shape, action: 'add'
	                });
	                return;
	            }
	        }
	        err('addRegionResponse:  imageId: ' + json.imageId + '  assigned id: ' + json.assignedId + ' not reconciled with temp id: ' + json.negId);
	    };
	    //............................................ cRegions del
	    //    delete a single region
	    CREGIONS.del = function (rfId) {
	        if (rfId < 0 || rfRegions[rfId] == undefined) return;

	        var aRegion = rfRegions[rfId]; // temp ref to region
	        this.remove(rfId); // remove region from rfRegions

	        if (_uScope2.default.instance.canSaveAnnotations()) // if incremental save is enabled, automatically send the new region to the server, get the assigned region id back
	            thisAn.save({ action: 'delRegion', layerId: aRegion.layerId, regionId: aRegion.regionId });

	        // broadcase the region deletion last, it is important that it no longer can be referenced in rfRegions
	        (0, _events.triggerUScopeEvent)(_defines2.default.evANNOTCHANGE, {
	            imageId: aRegion.imageId, // fire event that annotations have changed (del)
	            regionId: aRegion.regionId, anShape: aRegion.isReportRegion ? 'report' : aRegion.shape, action: 'del'
	        });
	    };
	    //............................................ cRegions delByRegionId
	    CREGIONS.delByRegionId = function (regionId) {
	        var aRegion = this.getByRegionId(regionId);
	        if (aRegion) this.del(aRegion.get(aRegion.get('rfId')));
	    };
	    //............................................ cRegions remove
	    //    This function removes a single region from rfRegions and its graphics dependencies.
	    //        It does not update the database
	    CREGIONS.remove = function (rfId) {
	        if (rfId < 0 || rfRegions[rfId] == undefined) return false;

	        var aRegion = rfRegions[rfId];
	        aRegion.removeGraphics(); // removes the graphics handles

	        rfRegions[rfId] = undefined; // remove this item from the regions array
	        return true;
	    };
	    //............................................ delAllFromLayer
	    //    delete all regions in the passed layerId
	    CREGIONS_LAYER.delAllFromLayer = function (layerId) {
	        for (var r = 0, len = rfRegions.length; r < len; r++) {
	            if (rfRegions[r] && rfRegions[r].layerId == layerId) this.del(rfRegions[r].rfId);
	        }
	    };
	    //............................................ getRegionsByLayerId
	    // return an array of regions refs associated with the passed layerId
	    CREGIONS_LAYER.getRegionsByLayerId = function (layerId) {
	        var rtnArray = [];
	        for (var r = 0, rlen = rfRegions.length; r < rlen; r++) {
	            if (rfRegions[r] && rfRegions[r].get('layerId') == layerId) rtnArray.push(rfRegions[r]);
	        }
	        return rtnArray;
	    };
	    //............................................ cRegions findByProperty
	    // This function returns an array of region objects whose property matches the passed value
	    CREGIONS.findByProperty = function (propName, propValue) {
	        var rtnArray = [];
	        for (var r = 0, rlen = rfRegions.length; r < rlen; r++) {
	            if (rfRegions[r] && rfRegions[r].get(propName) == propValue) rtnArray.push(rfRegions[r]);
	        }
	        return rtnArray;
	    };
	    //............................................ cRegions toString
	    // This function returns a string of all regions or if opt_LayerId all regions related to the specified layerId
	    CREGIONS_DEBUG.toString = function (opt_LayerId, opt_bDoShort) {
	        var rtnStr = opt_LayerId ? 'Regions for LayerId: ' + opt_LayerId : '';
	        for (var r = 0, len = rfRegions.length; r < len; r++) {
	            if (rfRegions[r]) {
	                if (opt_LayerId == undefined || rfRegions[r].get('layerId') == opt_LayerId) rtnStr += opt_bDoShort == true ? '\n' + rfRegions[r].toStringShort() : '\n' + rfRegions[r].toString();
	            }
	        }
	        return rtnStr;
	    };
	    //............................................ getByProperty
	    CREGIONS_GET.getByProperty = function (propName, propValue) {
	        var i, len;
	        for (i = 0; len = rfRegions.length, i < len; i++) {
	            if (rfRegions[i] && rfRegions[i].get(propName) == propValue) return rfRegions[i];
	        }
	        return undefined;
	    };
	    //............................................ getByRegionId
	    // return a ref to the region with passed regionId or undefined if not found
	    CREGIONS_GET.getByRegionId = function (regionId) {
	        var i;
	        var len;
	        for (i = 0; len = rfRegions.length, i < len; i++) {
	            if (rfRegions[i] && rfRegions[i].get('regionId') == regionId) return rfRegions[i];
	        }
	        return undefined;
	    };
	    //............................................ getByRfId
	    // return a ref to the region with passed rfId or undefined if not found
	    CREGIONS_GET.getByRfId = function (rfId) {
	        return rfRegions[rfId];
	    };
	    //us_public_getSelected.getSelRegion = function () {
	    //        return (this.rfSelected < 0) ? undefined : this.rfRegions[this.rfSelected];
	    //    };
	    //    us_public_getSelected.getSelType = function () {
	    //        return (this.rfSelected < 0) ? -1 : +this.rfRegions[this.rfSelected].type;
	    //    };
	    //    us_public_getSelected.getSelShape = function () {
	    //        return (this.rfSelected < 0) ? -1 : this.rfRegions[this.rfSelected].shape;
	    //    };
	    //    us_public_getSelected.getSelRegionId = function () {
	    //        return (this.rfSelected < 0) ? -1 : +this.rfRegions[this.rfSelected].regionId;
	    //    };
	    //    us_public_getSelected.getSelLayerId = function () {
	    //        return (this.rfSelected < 0) ? -1 : +this.rfRegions[this.rfSelected].layerId;
	    //    };
	    //    us_public_getSelected.getSelColor = function () { // returns rgb
	    //        return (this.rfSelected < 0) ? hexColortoRGB(us.AnnotLayerRGB) : this.rfRegions[this.rfSelected].decRGB;
	    //    };

	    //////////////soon this obj will own the regions array and this will be unnecessary
	} //cRegions
	//________________________________________________________________________________________________

	module.exports = exports['default'];

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = cLayer;

	var _defines = __webpack_require__(3);

	var _defines2 = _interopRequireDefault(_defines);

	var _helpers = __webpack_require__(8);

	var _toolbar = __webpack_require__(5);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	//________________________________________________________________________________________________
	// layer.js
	/**
	 * @file   example_action.h
	 * @Author Me (me@example.com)
	 * @date   September, 2008
	 * @brief  Brief description of file.
	 *
	 * Detailed description of file.
	 */
	//    This file contains the annotation layer object 'cLayer' (single annotation layer).
	//
	//    _______________________________________end_AIHv1/PR __________________________________________
	//    141222    cperz    created to support image analysis
	//    150318    cperz    build out to support analysis;
	//________________________________________________________________________________________________
	//    Object Name: cLayer
	//    Overview:  The cLayer object is a container for a layer's information
	//
	//________________________________________________________________________________________________
	function cLayer(inObj, type) {
	    // type can be 'json' (creating a new layer) or 'x2js' (dataserver read of layer) or 'jquery' XML object (dataserver read of layer)
	    var self = this;
	    this.desc = ''; // allows you to see private vars in debugger

	    var CLAYER = this; // ..... to group fns in js parser, for ease of search
	    var CLAYER_REG = this;
	    var CLAYER_ANALYSIS = this;
	    var CLAYER_DEBUG = this;

	    var data = { // by putting local vars in an object I can enumerate them easily
	        // nodes defined in annotation (layer) XML from DataServer - note that I am retaining the exact XML node names as my var names
	        Name: undefined, //
	        Id: 0,

	        ReadOnly: false, //not implemented!
	        NameReadOnly: false, //not implemented!
	        LineColorReadOnly: false, //not implemented!
	        Incremental: true, //note: it is unclear why the layer is carrying the macro's incremental status.  Presumably imagescope needs it
	        Selected: false,
	        Visible: true,

	        Type: undefined,
	        InputAnnotationId: undefined,
	        MacroName: undefined,
	        MacroId: undefined,

	        LineColor: undefined, // color in BGR

	        // derived information
	        isSupported: true, // see us.anLayerTypesSupported
	        typeName: undefined, // string of layer type
	        isReportLayer: false,
	        isAnnotLayer: false,
	        nRegions: 0 //not implemented!  nothing is keeping this up to date...
	    };
	    //............................................ logging
	    var logger = _defines2.default.helpers.createLogger(true, 'cLayer');
	    var log = logger.log;
	    var err = logger.error;

	    //............................................ analysis
	    var attributes = {}; // analysis results for the layer { name, value }
	    var regAttrIdName = {}; // lookup of region's analysis results (attribute) Id to the actual attribute Name
	    CLAYER_ANALYSIS.getLayerResults = function () {
	        return attributes;
	    };
	    CLAYER_ANALYSIS.getLayerResultsLength = function () {
	        return (0, _helpers.assocArrayLength)(attributes);
	    };
	    CLAYER_ANALYSIS.getRegionResultsLUT = function () {
	        return regAttrIdName;
	    };

	    //............................................ getters
	    CLAYER.isVisible = function () {
	        return data.Visible;
	    };
	    CLAYER.isSelected = function () {
	        return data.Selected;
	    };

	    CLAYER.get = function (key) {
	        return data[key];
	    };
	    CLAYER.set = function (key, value) {
	        data[key] = value;
	        descUpdate_();
	    };
	    CLAYER.serialize = function (bCopy) {
	        return bCopy == true ? new _helpers.cloneObject(data) : data;
	    };

	    //............................................ toString
	    CLAYER_DEBUG.toString = function (bReportResults) {
	        var str = (0, _helpers.toStringAssoc)(data);
	        if (bReportResults == true && (0, _helpers.assocArrayLength)(attributes)) str += '\n              ..... Layer Results (' + (0, _helpers.assocArrayLength)(attributes) + '):  ' + (0, _helpers.toStringAssoc)(attributes);
	        return str;
	    };
	    CLAYER_DEBUG.toStringShort = function () {
	        return 'Name: ' + data.Name + ' Id: ' + data.Id + ' typeName: ' + data.typeName + (data.InputAnnotationId ? ' InputAnnotationId: ' + data.InputAnnotationId + ' MacroName: ' + data.MacroName : '');
	    };
	    var descUpdate_ = function descUpdate_() {
	        self.desc = self.toString();
	    }; // keep description updated on current private vars

	    //............................................ cLayer construct_
	    // example XML input
	    //<Annotation Id="2022" Name="Annotation" ReadOnly="0" NameReadOnly="0" LineColorReadOnly="0" Incremental="0" Type="4" LineColor="16744576" Visible="1" Selected="1" MarkupImagePath="" MacroName=""><Attributes><Attribute Name="Description" Id="40" Value=""/>
	    //<Annotation Id="2023" Name="Report Image" ReadOnly="0" NameReadOnly="0" LineColorReadOnly="0" Incremental="0" Type="8" LineColor="255" Visible="1" Selected="0" MarkupImagePath="" MacroName=""><Attributes></Attributes><Regions><RegionAttributeHeaders><AttributeHeader Id="10011" Name="Region" ColumnWidth="-1"/><AttributeHeader Id="10012" Name="Length" ColumnWidth="-1"/><AttributeHeader Id="10013" Name="Area" ColumnWidth="-1"/><AttributeHeader Id="10014" Name="Text" ColumnWidth="-1"/></RegionAttributeHeaders><Region Id="14" Type="1" Zoom="0.250000" Selected="1" ImageLocation="" ImageFocus="0" Length="2240.0" Area="307200.0" LengthMicrons="1126.3" AreaMicrons="77662.6" Text="Report Image" NegativeROA="0" InputRegionId="0" Analyze="1" DisplayId="1"><Attributes></Attributes><Vertices><Vertex X="35912" Y="32656"/><Vertex X="36552" Y="32656"/><Vertex X="36552" Y="33136"/><Vertex X="35912" Y="33136"/></Vertices></Region></Regions><Plots></Plots></Annotation>
	    //<Annotation Id="2026" Name="Griff2" ReadOnly="0" NameReadOnly="0" LineColorReadOnly="0" Incremental="0" Type="4" LineColor="0" Visible="1" Selected="0" MarkupImagePath="" MacroName=""><Attributes><Attribute Name="Description" Id="86" Value=""/>
	    //<Annotation Id="2028" Name="SQa-v1 output" ReadOnly="1" NameReadOnly="0" LineColorReadOnly="0" Incremental="0" Type="3" LineColor="0" Visible="1" Selected="0" MarkupImagePath="" MacroName="SQa-v1"><InputAnnotationId>2026</InputAnnotationId><MacroId>1</MacroId><Attributes><Attribute Name="Algorithm" Id="131" Value="Scan Quality v1"/>

	    var construct_ = function construct_(inObj, type) {
	        // cLayer construction
	        if (type == 'json') {
	            // is input a json object?
	            for (var key in inObj) {
	                if (inObj.hasOwnProperty(key)) self.set(key, inObj[key]);
	            }
	        } else if (type == 'x2js') {
	            // is input a x2js object?
	            data.Id = inObj._Id; // '_item' is access to attribute 'item' of Annotation node
	            data.Name = inObj._Name ? inObj._Name : data.Id; // Name can be undefined

	            data.ReadOnly = inObj._ReadOnly == '0' ? false : true;
	            data.NameReadOnly = inObj._NameReadOnly == '0' ? false : true;
	            data.LineColorReadOnly = inObj._LineColorReadOnly == '0' ? false : true;
	            data.Incremental = inObj._Incremental == '0' ? false : true;

	            data.LineColor = inObj._LineColor;
	            data.Visible = inObj._Visible;
	            data.Selected = inObj._Selected === '1' ? true : false;

	            //toconsider: when the type is aafresult, THEN a lot of these macro and input annot ids matter, so maybe if (aafresult type ) then { }

	            data.Type = inObj._Type; // do not bother with some annotation layer types
	            data.MacroName = inObj._MacroName;

	            if (data.MacroName) {
	                data.MacroId = inObj.MacroId; //e.g. <MacroId>4</MacroId>
	                //note that there is no macro version available
	                data.InputAnnotationId = inObj.InputAnnotationId; //e.g. <InputAnnotationId>784</InputAnnotationId>
	            }
	            if (data.InputAnnotationId && data.InputAnnotationId != 0) {
	                //
	                if (inObj.Attributes_asArray.length) {
	                    var inAttrs = inObj.Attributes;
	                    for (var a = 0, alen = inAttrs.__cnt; a < alen; a++) {
	                        // e.g. <Attribute Name="Date" Id="728" Value="2014/06/03"/>  note that Id of attribute isn't useful
	                        //////////////////////ok on getannotations2 (dodbcall) for an aafresult layer
	                        //
	                        // Attribute: Array[62] and Attribute_asArray: Array[62] but ___cnt = 125
	                        // and then there is ___text: Array[63] is full of wierd character and space "↵                    "
	                        //
	                        // WHen I get the same layer with getannotations (imgserver call)
	                        // Attribute: Array[62] and Attribute_asArray: Array[62] and ___cnt = 62
	                        // and there is no ___text array
	                        //
	                        if (inAttrs.Attribute[a] == undefined) break;
	                        //////////////////////////////////////////////////////////////////////
	                        //todo: some attributes contain _DisplayColor as well..... (_Id too but who needs it?)
	                        var displayColor = inAttrs.Attribute[a]._DisplayColor | '';

	                        var colorRGB = '#' + (0, _helpers.toHexColor)((0, _helpers.reverseCLR)(displayColor));
	                        if (colorRGB == '#000000') colorRGB = '#FFFFFF';
	                        attributes[inAttrs.Attribute[a]._Name] = {
	                            'value': inAttrs.Attribute[a]._Value,
	                            'colorRGB': colorRGB
	                        };
	                    }
	                    //debug-only consoleWrite("Layer Results: " + toStringAssoc(attributes)); //debug-only
	                }
	            }

	            // build a region attribute Id to Name lookup table
	            //        - inObj.Regions holds <RegionAttributeHeaders> with Id, Name;  The Id here is the Name in the Region.Attributes.Attribute items
	            if (inObj.Regions && inObj.Regions.RegionAttributeHeaders) {
	                var regAttrs = inObj.Regions.RegionAttributeHeaders; ///inObj.Regions.RegionAttributeHeaders.AttributeHeader_asArray;
	                for (var a = 0, alen = regAttrs.__cnt; a < alen; a++) {
	                    var attr = regAttrs.AttributeHeader[a];
	                    if (attr == undefined) // because of same problem mentioned for layer attributes
	                        break;
	                    regAttrIdName[attr._Id] = attr._Name;
	                }
	                //debug-only consoleWrite("           Layer. Regions.RegionAttributeHeaders: {Id,Name} LUT: " + toStringAssoc(regAttrIdName)); //debug-only
	            }

	            data.nRegions = inObj.Regions.Region_asArray ? inObj.Regions.Region_asArray.length : 0;
	            //... more to do  RegionAttributeHeaders, and each Region???
	            ////consoleWrite(self.desc);
	        } else {
	            (0, _toolbar.consoleWrite)('layer: construct_ failure: missing input object type');
	            return false;
	        }

	        if (data.LineColor == undefined) {
	            // if layer color was not defined, randomly select a color
	            var hexcolor = _defines2.default.getRandomColor();
	            data.LineColor = (0, _helpers.reverseCLR)((0, _helpers.hexColortoRGB)(hexcolor));
	        }

	        ////        data.isReportLayer = (data.Name === us.ReportLayerName) ? true : false;
	        data.isReportLayer = data.Type == _defines2.default.anLayerTypes.report;
	        data.isAnnotLayer = data.Name === _defines2.default.AnnotLayerName;
	        ////        data.isAnnotLayer = (data.Name === us.AnnotLayerName) ? true : false;

	        data.typeName = getAssocKey(_defines2.default.anLayerTypes, data.Type);
	        data.isSupported = _defines2.default.anLayerTypesSupported[data.Type] ? _defines2.default.anLayerTypesSupported[data.Type] : false;

	        descUpdate_();
	    };
	    //............................................ buildXML
	    //    buildXML - This function generates a layer ('Annotation') XML node;
	    CLAYER.buildXML = function () {
	        var layerXML = '<Annotation ' + ' Id="' + data.Id + '"' + ' Name="' + data.Name + '"' + ' Type="' + data.Type + '"' + ' Selected="' + (data.Selected ? 1 : 0) + '"' + ' Incremental="' + (data.Incremental ? 1 : 0) + '"' + ' LineColor="' + data.LineColor + '"' // note that layer color is saved BGR
	        + ' Visible="' + (data.Visible ? 1 : 0) + '"';

	        if (data.MacroName) layerXML += ' InputAnnotationId="' + data.InputAnnotationId + '"' + ' MacroName="' + data.MacroName + '"' + ' MacroId="' + data.MacroId + '"';

	        layerXML += ' ReadOnly="0" NameReadOnly="0" LineColorReadOnly="0" '; // not implemented!
	        layerXML += '>' + '</Annotation>'; // close
	        return layerXML;
	    };

	    //............................................ construction
	    construct_(inObj, type);
	}

	//-------------------------------------------------------------------------------------------------
	// getAssocKey - This function returns the key of an assoicative array at the value.
	//                  If there is no such value, an empty string is returned.
	function getAssocKey(assocArray, value) {

	    for (var key in assocArray) {
	        if (assocArray.hasOwnProperty(key)) {
	            if (assocArray[key] == value) return key;
	        }
	    }
	    return '';
	}
	module.exports = exports['default'];

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = cLayers;

	var _defines = __webpack_require__(3);

	var _defines2 = _interopRequireDefault(_defines);

	var _helpers = __webpack_require__(8);

	var _layer = __webpack_require__(29);

	var _layer2 = _interopRequireDefault(_layer);

	var _uScope = __webpack_require__(11);

	var _uScope2 = _interopRequireDefault(_uScope);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	//________________________________________________________________________________________________
	// layers.js
	/**
	 * @file   example_action.h
	 * @Author Me (me@example.com)
	 * @date   September, 2008
	 * @brief  Brief description of file.
	 *
	 * Detailed description of file.
	 */
	//    This file contains the annotation layer collection object 'cLayers'.
	//
	//    _______________________________________end_AIHv1/PR __________________________________________
	//    140603    cperz    split off from regions file
	//    141222    cperz    first checkin
	//    150318    cperz    build out for analysis;
	//    _______________________________________12.3 __________________________________________________
	//    150615    cperz    findByProperty: check for undefined propValue
	//________________________________________________________________________________________________
	//    Object Name: cLayer
	//    Overview:  The cLayers object is a container for cLayer objects
	//
	//    toconsider:
	//        - WHERE macros should reside (? uScope) and how to track image permissions

	function cLayers(anObj, inImageId) {
	    var self = this;
	    this.desc = ''; // allows you to see private vars in debugger
	    var thisAn = anObj; // the annotation object - the parent
	    var thisRegions = anObj.getRegionsObj(); // the cRegions object
	    var imageId = inImageId; //save the imageId this object is related to

	    // ..... to group fns in js parser, for ease of search (e.g. search for all 'us_region_pts')
	    var CLAYERS = this; //
	    var CLAYERS_GET = this; //
	    var CLAYERS_SET = this; //
	    var CLAYERS_REG = this; // regions assoicated with a layer related functions


	    var data = {};
	    CLAYERS_GET.get = function (key) {
	        return data[key];
	    };
	    CLAYERS_SET.set = function (key, value) {
	        data[key] = value;
	        descUpdate_();
	    };

	    //............................................ toString
	    CLAYERS.toString = function () {
	        return (0, _helpers.toStringAssoc)(data);
	    };
	    var descUpdate_ = function descUpdate_() {
	        self.desc = self.toString();
	    }; // keep description updated on current private vars

	    //............................................ logging
	    var logger = _defines2.default.helpers.createLogger(true, 'cLayers');
	    var log = logger.log;
	    var err = logger.error;

	    //todo: ? var isValidLayer_ = function (layerId) { return rfLayer[layerId] ? true : false; };

	    //............................................  The array containing all layers, layerId is not the index into this array
	    // Note that the length of this array is NOT the number of layers.  Deleted layers are undefined slots in the array.
	    var theLayers = []; // the collection of layer objects;
	    CLAYERS_GET.getLayersArray = function () {
	        return theLayers;
	    };
	    this.selectedIdx = -1; // handy access into theLayers to the currently selected layer (or -1 if none selected)


	    //    //............................................ cLayers getFirst
	    //    CLAYERS_GET.getFirst = function () {                        // returns a ref to the first layer or undefined
	    //        for (var lay = 0, len = theLayers.length; lay < len; lay++) {
	    //            if (theLayers[lay])
	    //                return theLayers[lay];
	    //        }
	    //        return undefined;
	    //    };
	    //    //............................................ cLayers getNext
	    //    CLAYERS_GET.getNext = function (prevLayer) {                // returns a ref to the layer after the passed layer or undefined
	    //        var prevId = prevLayer.get('Id');
	    //        var bRtnNext = false;
	    //        for (var lay = 0, len = theLayers.length; lay < len; lay++) {
	    //            if (theLayers[lay] && theLayers[lay].get('Id') == prevId)
	    //                bRtnNext = true;
	    //            if (bRtnNext && theLayers[lay])
	    //                return theLayers[lay];
	    //        }
	    //        return undefined;
	    //    };
	    //............................................ cLayers getLayerById
	    CLAYERS_GET.getLayerById = function (layerId) {
	        // returns a ref to the layer or undefined
	        for (var lay = 0, len = theLayers.length; lay < len; lay++) {
	            if (theLayers[lay] && theLayers[lay].get('Id') == layerId) return theLayers[lay];
	        }
	        return undefined;
	    };
	    //............................................ cLayers getLayerIdxById
	    CLAYERS_GET.getLayerIdxById = function (layerId) {
	        // returns index in theLayers to layer or -1
	        for (var lay = 0, len = theLayers.length; lay < len; lay++) {
	            if (theLayers[lay] && theLayers[lay].get('Id') == layerId) return lay;
	        }
	        return -1;
	    };
	    //............................................ cLayers getLayerByName
	    CLAYERS_GET.getLayerByName = function (name) {
	        // returns a ref to the layer or undefined
	        for (var lay = 0, len = theLayers.length; lay < len; lay++) {
	            if (theLayers[lay] && theLayers[lay].get('Name') == name) return theLayers[lay];
	        }
	        return undefined;
	    };
	    //............................................ cLayers getLayerIdByName
	    CLAYERS_GET.getLayerIdByName = function (name) {
	        // returns the layer Id or -1
	        for (var lay = 0, len = theLayers.length; lay < len; lay++) {
	            if (theLayers[lay] && theLayers[lay].get('Name') == name) return theLayers[lay].get('Id');
	        }
	        return -1;
	    };
	    //............................................ cLayers getNameById
	    CLAYERS_GET.getNameById = function (layerId) {
	        // returns the layer name or undefined
	        var aLayer = this.getLayerById(layerId);
	        return aLayer ? aLayer.get('Name') : undefined;
	    };
	    //............................................ cLayers createAddSave
	    // createAddSave - This function creates a layer object from the jsonLayer input, adds it to theLayers array and saves it to the database
	    CLAYERS.createAddSave = function (jsonLayer, opt_cbSuccessFn) {
	        jsonLayer.Id = this.getNextLayerId(); // assign a negative Id to the newly created layer (will be re-assigned by DataServer and resolved on callback)
	        var aLayer = new _layer2.default(jsonLayer, 'json'); // create the new layer
	        return this.addAndSave(aLayer, opt_cbSuccessFn); // add add and save the layer
	    };
	    //............................................ cLayers createAddSaveAnalysisPair
	    //    createAddSaveAnalysisPair - This function creates an input and an output layer for a specified macro.
	    //        It returns true if the input layer was successfully requested; ow false;
	    //
	    //    improvement: I should be able to request both layer creation at once but that did not work and I wanted to keep moving forward.
	    //                I had added the save action 'addLayers' in annots.save that would request any number of layers.
	    //
	    //    inputs:
	    //        macroName:                required, the macroName associated with this analysis pair layers
	    //        opt_cbOnCompletion:        optional, callback function when both layers are added and have dataserver assigned id's

	    CLAYERS.createAddSaveAnalysisPair = function (macroName, opt_cbOnCompletion) {
	        var rtnStatus = false;

	        var macrosObj = _uScope2.default.instance.iaInterface.getMacrosObj();
	        if (macrosObj == undefined) return err('createAddSaveAnalysisPair: macros object is undefined');

	        var macro = macrosObj.getMacroByName(macroName); // get the macro object with this name
	        if (macro) {
	            var inLayerId = self.getNextLayerId(); // create the input layer object
	            var inLayer = new _layer2.default({
	                'Id': inLayerId,
	                'Name': macroName + ' input',
	                'Type': _defines2.default.anLayerTypes.manual
	            }, 'json');

	            var outLayer = new _layer2.default({ // create the output, aafresult layer object
	                'Id': self.getNextLayerId(), 'InputAnnotationId': inLayerId, 'Name': macroName + ' output',
	                'Type': _defines2.default.anLayerTypes.aafresult, 'MacroName': macroName, 'MacroId': macro.get('Id'),
	                'LineColor': inLayer.get('LineColor'), // assign the aafresult layer the same color as the input layer
	                'Incremental': macro.get('Incremental') //issue: WHY DOES THE LAYER CARRY MACRO INFORMATION and DOES IMAGESCOPE REQUIRE THIS?
	            }, 'json');

	            var layerInProgress = 'input'; // set flag to cbAnalysisPair fn
	            rtnStatus = self.addAndSave(inLayer, cbAnalysisPair); // add add and save the input layer, callback deals with the output layer
	        }
	        return rtnStatus;

	        //..................................................
	        // closure functions
	        //............................................ cbAnalysisPair()
	        function cbAnalysisPair(jResponse, cbParms) {

	            if (layerInProgress == 'input') {
	                self.saveLayerResponse(jResponse, cbParms); // replace the input layer's temporary negative layerId with the one assigned by dataserver

	                layerInProgress = 'output'; // request the associated output layer
	                outLayer.set('InputAnnotationId', inLayer.get('Id')); // the output layer references the input layer id
	                var status = self.addAndSave(outLayer, cbAnalysisPair); // add and save the input layer, callback deals with the output layer
	            } else {
	                self.saveLayerResponse(jResponse, cbParms); // replace the output layer's temporary negative layerId with the one assigned by dataserver

	                if (opt_cbOnCompletion) // if callback onCompletion is specified, call it
	                    opt_cbOnCompletion(inLayer.get('Id'), outLayer.get('Id'));
	            }
	        }
	        //..................................................
	    };

	    //............................................ cLayers addAndSave
	    // addAndSave - This function adds the layer to the layers array and saves it to the database.
	    //                    Call it for layers newly created layer objects.
	    //    parameters:
	    //        aLayer:                a layer object.
	    //                            Note that its Id should be assigned by layers.setNextLayerId_  and be negative;
	    //                            Note also that the save callback will resolve the negative Id with that assigned by the database
	    //        opt_cbSuccessFn:    optional callback function
	    CLAYERS.addAndSave = function (aLayer, opt_cbSuccessFn) {
	        if (aLayer) {
	            //log("layers: addAndSave" + aLayer.toString());

	            if (self.add(aLayer) == true) {
	                // add the layer to the array
	                var layerXML = aLayer.buildXML(); // build the layer xml
	                //debug-only if (us.DBGANNOT) log("layerAdd: input xml: " + layerXML);

	                if (_uScope2.default.instance.canSaveAnnotations()) {
	                    // if save is enabled, automatically send the new layer to the server, get the assigned layer id back
	                    var successFn = opt_cbSuccessFn ? opt_cbSuccessFn : this.saveLayerResponse;
	                    thisAn.save({
	                        'action': 'addLayer',
	                        'layerXML': layerXML,
	                        'tag': aLayer.get('Id'),
	                        'cbSuccessFn': successFn
	                    });
	                }
	                return true;
	            }
	            return false;
	        }
	        return false;
	    };
	    //............................................ cLayers saveLayerResponse
	    // saveLayerResponse - This function is a callback when a layer is saved to the database.
	    //
	    CLAYERS.saveLayerResponse = function (jResponse, cbParms) {
	        var imageId = '@' + jResponse.find('ImageId').text(); // i always precede imageId number with @

	        var jTag = jResponse.find('Tag'); // note that jquery converts xml to lower case
	        var negId = parseInt(jTag.text()); // the original, negative layer id
	        var posId = jResponse.find('Annotation').attr('Id'); // the assigned layer id
	        var layerName = jResponse.find('Annotation').attr('Name'); // the layer Name

	        setNextLayerId_(posId); // track the highest value layer id

	        for (var l = 0, len = theLayers.length; l < len; l++) {
	            // change the layerId from negId to posId
	            if (theLayers[l] && theLayers[l].get('Id') == negId) {
	                //debug-only log("saveLayerResponse: id update: " + negId + " --> " + posId);
	                theLayers[l].set('Id', posId);
	                descUpdate_(); // update layers description
	                return;
	            }
	        }
	        err('saveLayerResponse:  imageId: ' + imageId + '  name:' + layerName + '  assigned id: ' + posId + ' not reconciled with temp id: ' + negId);
	    };
	    //............................................ cLayers add
	    // add - This function adds the passed layer to theLayers array.
	    //
	    CLAYERS.add = function (aLayer) {
	        if (aLayer.get('isSupported')) {
	            if (aLayer.get('isReportLayer') && this.getLayerByName(_defines2.default.ReportLayerName)) // if adding a report layer,insure a report layer does not already exist
	                return false;
	            if (aLayer.get('isAnnotLayer') && this.getLayerByName(_defines2.default.AnnotLayerName)) // if adding an annotation layer, insure a annotation layer does not already exist
	                return false;

	            theLayers.push(aLayer); // add the layer to the container
	            setNextLayerId_(aLayer.get('Id')); // update the next layer id
	            return true;
	        } else {
	            // layer not supported
	            return err('add: layer type is not yet supported'); // so just log the error
	        }
	        return false;
	    };

	    //............................................ cLayers replace
	    CLAYERS.replace = function (aLayer) {
	        var layerId = aLayer.get('Id');
	        var idx = this.getLayerIdxById(layerId);
	        if (idx != -1) {
	            theLayers[idx] = aLayer;
	            return true;
	        }
	        return false;
	    };
	    //............................................ cLayers createAddSaveSpecial
	    //    createAddSaveSpecial - This function creates a new special layer and adds it to the container array.
	    //            It returns true if it was sucessfully created and false if not.
	    //    layerName:  us.ReportLayerName | us.AnnotLayerName

	    CLAYERS.createAddSaveSpecial = function (layerName, opt_cbSuccessFn) {
	        if (_uScope2.default.instance.canAnnotate() == false) return;

	        if (layerName == _defines2.default.ReportLayerName) {
	            if (this.getLayerByName(_defines2.default.ReportLayerName)) return false; // insure a report layer does not already exist
	            return this.createAddSave({
	                'Name': _defines2.default.ReportLayerName,
	                'Type': _defines2.default.anLayerTypes.report,
	                'LineColor': (0, _helpers.reverseCLR)((0, _helpers.hexColortoRGB)(_defines2.default.ReportLayerRGB)),
	                'selected': true
	            }, opt_cbSuccessFn);
	        } else if (layerName == _defines2.default.AnnotLayerName) {
	            if (this.getLayerByName(_defines2.default.AnnotLayerName)) return false; // insure a annotation layer does not already exist
	            return this.createAddSave({
	                'Name': _defines2.default.AnnotLayerName,
	                'Type': _defines2.default.anLayerTypes.manual,
	                'LineColor': (0, _helpers.reverseCLR)((0, _helpers.hexColortoRGB)(_defines2.default.AnnotLayerRGB)),
	                'selected': true
	            }, opt_cbSuccessFn);
	        } else {
	            return err('createAddSaveSpecial: called for non-special layer');
	        }
	        return true;
	    };

	    //............................................ cLayers del
	    //    This function deletes the layer with the passed layerId and all its regions.
	    //    It will update the database if opt_bDoSave isn't false and annotation changes are allowed.
	    //    parameters:
	    //        layerId:        required, valid id of layer to delete
	    //        opt_bDoSave:    optional, true/false, default true, whether or not to save the change to the database
	    CLAYERS.deleteLayer = function (layerId, opt_bDoSave) {
	        var idx = this.getLayerIdxById(layerId);
	        if (idx < 0) return;

	        // since layer does not contain its regions, it must ask cRegions for help
	        thisRegions.delAllFromLayer(layerId); // remove all regions from this layer
	        theLayers[idx] = undefined;

	        if (opt_bDoSave != false && _uScope2.default.instance.canSaveAnnotations()) //
	            thisAn.save({ action: 'delLayer', layerId: layerId });
	    };
	    //............................................ cLayers deleteAllLayers
	    //note: this is not efficient (saving each layer change) but is currently used only for development so who cares
	    //    parameters:
	    //        opt_bDoSave:    optional, true/false, default true, whether or not to save the change to the database
	    CLAYERS.deleteAllLayers = function (opt_bDoSave) {
	        for (var l = 0, len = theLayers.length; l < len; l++) {
	            if (theLayers[l]) this.deleteLayer(theLayers[l].get('Id'), opt_bDoSave);
	        }
	        theLayers.length = 0;
	    };
	    //............................................ cLayers getSelected
	    CLAYERS_GET.getSelected = function () {
	        return this.selectedIdx < 0 ? undefined : theLayers[this.selectedIdx];
	    };
	    //............................................ cLayers getSelectedIdx
	    CLAYERS_GET.getSelectedIdx = function () {
	        return this.selectedIdx;
	    };

	    //............................................ cLayers getSelectedProperty
	    CLAYERS_GET.getSelectedProperty = function (propName) {
	        return this.selectedIdx < 0 || theLayers[this.selectedIdx] == undefined ? undefined : theLayers[this.selectedIdx].get('propName');
	    };
	    //............................................ cLayers getSelectedId
	    CLAYERS_GET.getSelectedId = function () {
	        return this.selectedIdx < 0 || theLayers[this.selectedIdx] == undefined ? -1 : theLayers[this.selectedIdx].get('Id');
	    };
	    //............................................ cLayers selectByProperty
	    //    This function sets the 'Selected' property of the layer whose property matches the passed value
	    //        and clears the Selected property on all all other layers.
	    //    Note that the layer object keeps its 'Selected' property up to date
	    //        yet a property of the layers object keeps a handy access to its index

	    CLAYERS.selectByProperty = function (propName, propValue) {
	        for (var lay = 0, len = theLayers.length; lay < len; lay++) {
	            if (theLayers[lay] == undefined) continue;
	            if (theLayers[lay].get(propName) == propValue) {
	                theLayers[lay].set('Selected', true); // this is the layer that is selected
	                this.selectedIdx = lay;
	            } else {
	                theLayers[lay].set('Selected', false); // no other layers can be selected
	            }
	        }
	        if (_defines2.default.DBGANNOT) log('selectByName: idx: ' + this.selectedIdx + ' .............  ' + (this.selectedIdx != -1 ? theLayers[this.selectedIdx].toStringShort() : ''));
	        return this.selectedIdx;
	    };

	    //............................................ cLayers findByProperty
	    // This function returns an array of layer objects whose property matches the passed value
	    CLAYERS.findByProperty = function (propName, propValue) {
	        var rtnArray = [];
	        if (propValue != undefined) {
	            for (var lay = 0, len = theLayers.length; lay < len; lay++) {
	                if (theLayers[lay] && theLayers[lay].get(propName) == propValue) rtnArray.push(theLayers[lay]);
	            }
	        }
	        return rtnArray;
	    };

	    //............................................ cLayers deleteRegions
	    CLAYERS.deleteRegions = function (fromLayerId) {
	        thisRegions.delAllFromLayer(fromLayerId);

	        var aLayer = this.getLayerById(fromLayerId); // reset the region count in the layer
	        aLayer.set('nRegions', 0);
	    };
	    ////    //............................................ cLayers deleteResults
	    ////    CLAYERS_REG.deleteResults = function (fromLayerId) {
	    ////        thisRegions.deleteResultsFromLayer(fromLayerId);
	    ////    };

	    //............................................ cLayers get/set NextLayerId()
	    var lastLayerId = 0; // last layer id; used to set id for new layer
	    // Note that this isn't really the assigned layer id but a unique (to uscope) id prior to assignment
	    CLAYERS.getNextLayerId = function () {
	        return -++lastLayerId; // new layer id's are negative values so they are flagged for dataserver
	    };
	    var setNextLayerId_ = function setNextLayerId_(id) {
	        //
	        if (id >= 0 && id > lastLayerId) lastLayerId = id;
	    };
	    //............................................ cLayers construct_
	    var construct_ = function construct_() {};

	    //............................................ construction
	    construct_();
	}
	module.exports = exports['default'];

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = cViewLayout;

	var _defines = __webpack_require__(3);

	var _defines2 = _interopRequireDefault(_defines);

	var _toolbar = __webpack_require__(5);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	//________________________________________________________________________________________________
	// viewLayout.js
	//    This file contains cViewLayout,    an object that provides arrangements of viewport panes for multi-image viewing.
	//
	//    history
	//    1106    cperz        created
	//
	//    _______________________________________end_AIHv1/PR __________________________________________
	//    141118    cperz        moved from layout.js
	//
	//________________________________________________________________________________________________
	//    Object Name: cViewLayout
	//    Overview: todo
	//
	//    Associated Panel: o todo
	//
	//    Dependencies and Supporting objects:
	//        o jquery plugin 'layout'
	//            - reference:     http://layout.jquery-dev.net/index.cfm
	//            - https://groups.google.com/forum/#!topic/jquery-ui-layout/71vyVOrngfc //  options example
	//            If changes need to be made to the fundamental structure of the layout,
	//            you could use methods like removePane() and addPane() to change a single pane,
	//            or you could destroy() the entire layout and then recreate it with completely new options.
	//            This normally happens so quickly that you would not even see it, except for any changes you have specified.
	//
	//    Assumptions: o todo
	//
	//    Limitations: o todo
	//
	//    Terms Used: o todo
	//
	//    Functionality: o todo
	//
	//    Data Structures: o todo
	//
	//    HTML: o todo
	//
	//    References: o http://layout.jquery-dev.net/index.cfm
	//
	//
	//    construction parameters:
	//        jParentDiv
	//        crContainer
	//        nImages: number of images/views
	//        cb_onResizeRef
	//        opt_paneDesc: one of the choices for the arrangement in us.viewLayoutMode[imgCount][]
	//
	//    Notes:
	//        after construction, check this.status
	function cViewLayout(jParentDiv, crContainer, nImages, cb_onResizeRef, opt_paneDesc) {
	    var self = this;
	    this.status = true;

	    var jContainer; // div created on construction that contains this layout
	    var myLayout_; //
	    var state = []; // array of size imageCount, each slot contains the following assoc array:
	    //    {
	    //        divId:            id of the pane's div
	    //        jPane:            jquery object ref to the pane
	    //        samplePref:        pane's preference for sample type - not currently used by mapImagesToPanes()
	    //        imageIdx:        related index into jsonList used to assign images
	    //
	    //        sampleType:        image's sample type
	    //        jImgDiv:        attached jquery object of the image's viewport; if == undefined, the image is not present
	    //        imageId:        image's id (prefixed with '@')
	    //    }

	    // view layout settings

	    var viewLayoutMode = []; // viewLayoutMode[imageCount][paneDesc_]
	    viewLayoutMode[1] = ['1']; // note that the paneDesc_ text match suffixes of the corresponding toolbar icon
	    viewLayoutMode[2] = ['v', 'h']; //        so don't change these assignments without considering that impact
	    viewLayoutMode[3] = ['t', 'v', 'h'];
	    viewLayoutMode[4] = ['4'];

	    var imageCount = 0; // # of images = # of panes; constrained by max allowed
	    var paneDesc_; // description of the pane layout
	    var minSize = 100; // minimum pane width/height on resizer drag in pixels

	    //............................................ construct_() local
	    // This function constructs the layout html and attaches it to the DOM, initializes the layout options
	    //    and sizes the layout container to fill the passed jParentDiv.
	    var construct_ = function construct_() {
	        imageCount = Math.min(nImages, _defines2.default.multiSpecs.maxImages); // # of images = # of panes; constrained by max allowed
	        if (imageCount < 1) {
	            self.status = false;
	            (0, _toolbar.consoleWrite)('Error: cViewLayout: construction: illegal image count: ' + imageCount);
	            return;
	        }
	        paneDesc_ = opt_paneDesc ? opt_paneDesc // if an arrangement is specified then use it,
	        : viewLayoutMode[imageCount][0]; // otherwise select the first as the default layout for this arrangement

	        var layoutName = self.getLayoutName(); // create a container and attach to parent element
	        jContainer = $('<div/>', { 'id': layoutName }); // will have class .ui-layout-container added to it
	        jParentDiv.append(jContainer);

	        var html = buildContainerHTML_(imageCount); // define panes for this number of images
	        jContainer.append($(html)); // inject panes into jContainer
	        var options = buildOptions_(cb_onResizeRef, crContainer); // define the layout options: proportional size of the panes, minsize, resize callbacks, ...
	        myLayout_ = jContainer.layout(options); // perform the layout and sizes the panes in pixels

	        if (_defines2.default.DBGVIEWLAYOUT) (0, _toolbar.consoleWrite)('cViewLayout: construct_: layoutName: ' + layoutName + ', dims: ' + jContainer.width() + 'x' + jContainer.height());
	    };

	    //............................................ accessor fns public
	    this.getImageCount = function () {
	        return imageCount;
	    };
	    this.getPaneDesc = function () {
	        return paneDesc_;
	    }; // return the pane descriptions (e.g. "v", "h", "t")
	    this.getImageState = function (paneIdx) {
	        return state[paneIdx];
	    }; // return the image state assoc array for the given pane

	    this.detatchFromDom = function () {
	        // detach conataining element from the DOM
	        if (jContainer) jContainer.detach();
	    };

	    //............................................ getLayoutName() public
	    //    This function provides a unique and descriptive name for each layout.
	    //
	    //    todo: should generalize this to use the viewLayoutMode array contents.
	    this.getLayoutName = function () {
	        if (imageCount == 1 || imageCount == 4) return 'viewLayout_' + imageCount;else if (imageCount == 2 || imageCount == 3) return 'viewLayout_' + imageCount + '_' + paneDesc_;else return undefined;
	    };
	    //............................................ getNextPaneDesc() public
	    // This function returns the NEXT layout arrangement in the viewLayoutMode sequence.
	    //
	    //    todo: should generalize this to use the viewLayoutMode array contents.
	    this.getNextPaneDesc = function () {
	        var rtnDesc = '';
	        if (imageCount == 2) // us.viewLayoutMode[2] = ["v", "h"];
	            rtnDesc = paneDesc_ == 'v' ? 'h' : 'v';else if (imageCount == 3) // us.viewLayoutMode[3] = ["t", "v", "h"];
	            rtnDesc = paneDesc_ == 't' ? 'v' : paneDesc_ == 'v' ? 'h' : 't';
	        return rtnDesc;
	    };

	    //-------------------------------------------------------------------------------------------------
	    //    LAYOUT CONFIGURATION FUNCTIONS
	    //-------------------------------------------------------------------------------------------------

	    //............................................ mapImagesToPanes() local
	    //    This function maps the index of an image in jsonList to the state[pane] it is to be rendered in.
	    //    The pane preference for positive and negative controls samples are implemented for each layout.
	    //
	    //    note:    If the jsonList has more than 1 positive control (or more than 1 negative control)
	    //            those additional controls are treated as patient samples with no pane preference.
	    //
	    //    note:  The state[]'s samplePref are not yet filled in, if they were this fn could obey the
	    //            prefered pane location for controls.  Right now the preference panes for controls is
	    //            just coded in.

	    var mapImagesToPanes = function mapImagesToPanes(jsonList) {

	        //..................................................
	        //    This function identifies the first image in the jsonList of the given sample type
	        //    and returns that index into the jsonList or -1 if not found.
	        var findSampleTypeIdx = function findSampleTypeIdx(jsonList, sampleType) {
	            for (var i = 0; i < imageCount; i++) {
	                if (sampleType == jsonList[i].sampleType) return i;
	            }
	            return -1;
	        };
	        //..................................................
	        //    This function ...
	        var assignPatientSamples = function assignPatientSamples() {
	            for (var i = 0; i < imageCount; i++) {
	                // then assign patient sample types
	                if (jsonList[i].assigned == false) {
	                    // find unassigned image
	                    for (var p = 0; p < imageCount; p++) {

	                        if (state[p].imageIdx == undefined) {
	                            //assign it to the first empty pane
	                            state[p].imageIdx = i;
	                            jsonList[i].assigned = true;
	                            break;
	                        }
	                    }
	                }
	            }
	        };
	        //..................................................
	        for (var i = 0; i < imageCount; i++) {
	            // set all images unassigned to a pane
	            jsonList[i].assigned = false;
	        }var posIdx = findSampleTypeIdx(jsonList, 'positive'); // identify the 1st positive and 1st negative control imgaes
	        var negIdx = findSampleTypeIdx(jsonList, 'negative');
	        if (posIdx != -1) jsonList[posIdx].assigned = true;
	        if (negIdx != -1) jsonList[negIdx].assigned = true;

	        if (imageCount == 1) {
	            // for each layout configuration, place the controls then the patient samples
	            state[0].imageIdx = 0;
	        } else if (imageCount == 2) {
	            if (posIdx != -1 && negIdx != -1) {
	                state[0].imageIdx = posIdx;
	                state[1].imageIdx = negIdx;
	            } else if (posIdx != -1) {
	                state[0].imageIdx = posIdx == 0 ? 1 : 0;
	                state[1].imageIdx = posIdx;
	            } else if (negIdx != -1) {
	                state[0].imageIdx = negIdx == 0 ? 1 : 0;
	                state[1].imageIdx = negIdx;
	            } else {
	                state[0].imageIdx = 0;
	                state[1].imageIdx = 1;
	            }
	        } else if (imageCount == 3) {
	            if (paneDesc_ == 't' // assign pos and neg controls first
	            || posIdx != -1 && negIdx != -1) {
	                if (posIdx != -1) {
	                    state[1].imageIdx = posIdx;
	                }
	                if (negIdx != -1) {
	                    state[2].imageIdx = negIdx;
	                }
	            } else {
	                if (posIdx != -1) {
	                    state[2].imageIdx = posIdx;
	                }
	                if (negIdx != -1) {
	                    state[2].imageIdx = negIdx;
	                }
	            }
	            assignPatientSamples(); // then the other images in the list
	        } else if (imageCount == 4) {
	            if (posIdx != -1 && negIdx != -1) {
	                // assign pos and neg controls first
	                if (posIdx != -1) {
	                    state[2].imageIdx = posIdx;
	                }
	                if (negIdx != -1) {
	                    state[3].imageIdx = negIdx;
	                }
	            } else {
	                if (posIdx != -1) {
	                    state[3].imageIdx = posIdx;
	                }
	                if (negIdx != -1) {
	                    state[3].imageIdx = negIdx;
	                }
	            }
	            assignPatientSamples(); // then the other images in the list
	        }
	    };

	    //............................................ append() public
	    // This function appends, assigns the passed image divs in the newly constructed layout panes.
	    this.append = function (jsonList) {
	        if (self.status == false) return false;

	        if (jsonList.length != imageCount) {
	            (0, _toolbar.consoleWrite)('Error: cViewLayout: append: incorrect input list length');
	            return false;
	        }

	        mapImagesToPanes(jsonList);

	        for (var p = 0; p < imageCount; p++) {
	            var imageIdx = state[p].imageIdx;
	            var imageInfo = jsonList[imageIdx];

	            var jPane = $(_defines2.default.idHashROOT).find('#' + state[p].divId);
	            jPane.append(imageInfo.jImgDiv);
	            paneStateUpdate(p, jPane, imageInfo.imageId, imageInfo.sampleType, imageInfo.jImgDiv); //todo? pass imageInfo and let pane update choose what it wants??
	        }

	        if (_defines2.default.DBGVIEWLAYOUT) paneReportDBG_();
	        return true;
	    };
	    //............................................ stateChange() public
	    // This function xxxx pane in this layout.
	    this.stateChange = function (imageId, typeName, typeValue) {
	        var idxPane = paneIdxFind('imageId', imageId);
	        if (idxPane == -1) {
	            (0, _toolbar.consoleWrite)('Error: cViewLayout: stateChange: image not found: imageId: ' + imageId);
	            return false;
	        }

	        if (typeName == 'sampleType') state[idxPane].sampleType = typeValue;

	        return idxPane;
	    };
	    //............................................ remove() public
	    // This function removes an image from its pane in this layout.
	    this.remove = function (imageId) {
	        var idxPane = paneIdxFind('imageId', imageId);
	        if (idxPane == -1) {
	            (0, _toolbar.consoleWrite)('Error: cViewLayout: remove: image not found: imageId: ' + imageId);
	            return false;
	        }

	        var jImgDiv = state[idxPane].jImgDiv;
	        jImgDiv.detach();

	        state[idxPane].jImgDiv = undefined; // indicates that the image is no longer appended

	        return idxPane;
	    };
	    //............................................ replace() public
	    // This function replaces an image in its pane with another.
	    this.replace = function (imageId, jsonItem) {
	        if (self.status == false) return false;

	        var idxPane = this.remove(imageId);
	        if (idxPane == -1) return false;

	        var jPane = state[idxPane].jPane;
	        jPane.append(jsonItem.jImgDiv);
	        paneStateUpdate(idxPane, jPane, jsonItem.imageId, jsonItem.sampleType, jsonItem.jImgDiv);

	        if (_defines2.default.DBGVIEWLAYOUT) paneReportDBG_();
	        return true;
	    };

	    //............................................ compress() public
	    // This function moves the images in the passed layout into this layout.
	    //    It is typically called on
	    //    - when the panes are reconfigured due to the removal of an image
	    //    - or when the panes are reconfigured due to the user initiated layout change (3 't' to 3 'v' for instance)

	    this.compress = function (curLayout) {
	        if (self.status == false) return false;

	        curLayout.detatchFromDom(); // current layout is being replaced with new
	        var jsonList = curLayoutToJsonList(curLayout);
	        return this.append(jsonList);
	    };
	    //............................................ expand() public
	    // This function moves the images in the passed layout into this layout and adds new images.
	    this.expand = function (curLayout, jsonList) {
	        if (self.status == false) return false;

	        curLayout.detatchFromDom(); // current layout is being extended
	        var jsonList2 = curLayoutToJsonList(curLayout); //
	        jsonList = jsonList2.concat(jsonList); //
	        return this.append(jsonList); //
	    };

	    //............................................ curLayoutToJsonList() local
	    var curLayoutToJsonList = function curLayoutToJsonList(curLayout) {
	        var jsonList = [];

	        var priorImageCount = curLayout.getImageCount(); // # images moving to this layout
	        for (var i = 0; i < priorImageCount; i++) {
	            var aState = curLayout.getImageState(i);
	            if (aState.jImgDiv != undefined) jsonList.push({ imageId: aState.imageId, sampleType: aState.sampleType, jImgDiv: aState.jImgDiv });
	        }
	        return jsonList;
	    };
	    //............................................ paneReportDBG_() local
	    var paneReportDBG_ = function paneReportDBG_() {
	        for (var i = 0; i < imageCount; i++) {
	            if (state[i].jPane) (0, _toolbar.consoleWrite)(' ... cViewLayout: pane: ' + i + ' ' + state[i].divId + ', dims: ' + state[i].jPane.width() + 'x' + state[i].jPane.height());
	        }
	    };
	    //-------------------------------------------------------------------------------------------------
	    //
	    //-------------------------------------------------------------------------------------------------
	    //............................................ onResize() public
	    // This function recomputes the maximum pane size such that adjacent views' minimum size is respected.
	    //    It is called when the browser resizes.
	    //
	    //    params:
	    //        crContainer: the size in a cRect of the layout container div

	    this.onResize = function (crContainer) {
	        if (self.status == false) return false;
	        var containWidth = crContainer.w,
	            containHeight = crContainer.h;

	        myLayout_.resizeAll(); // insures that when DST collapses/expands the layout constainer's dims is updated

	        if (imageCount == 1) {} else if (imageCount == 2) {
	            if (paneDesc_ == 'v') {
	                myLayout_.options.east.maxSize = containWidth - minSize;
	            } else {
	                myLayout_.options.east.maxSize = containHeight - minSize;
	            }
	        } else if (imageCount == 3) {
	            if (paneDesc_ == 't') {
	                myLayout_.options.east.maxSize = containWidth - minSize;
	                myLayout_.options.south.maxSize = containHeight - minSize;
	            } else if (paneDesc_ == 'v') {
	                //todo: not quite right for center pane - can get too small
	                myLayout_.options.east.maxSize = containWidth - 2 * minSize;
	                myLayout_.options.west.maxSize = containWidth - 2 * minSize;
	            } else {
	                //todo: not quite right for center pane - can get too small
	                myLayout_.options.north.maxSize = containHeight - 2 * minSize;
	                myLayout_.options.south.maxSize = containHeight - 2 * minSize;
	            }
	        } else if (imageCount == 4) {
	            //todo: not quite right after resize for move horiz up when increse window or decrease window
	            myLayout_.options.center.maxSize = containWidth - minSize;
	            myLayout_.options.east.maxSize = containWidth - minSize;
	            myLayout_.options.south.maxSize = containHeight - minSize;
	        }
	    };

	    //-------------------------------------------------------------------------------------------------
	    //    HTML AND OPTIONS FUNCTIONS
	    //-------------------------------------------------------------------------------------------------
	    //............................................ buildOptions_() local
	    // This function builds the option string that defines the pane features for the layout such as
	    //    its minimum size, callbacks when the resizer is dragged, ...
	    //
	    //    params:
	    //        cb_onResize:
	    //        crContainer: cRect of containter
	    //
	    //    notes:
	    //    - onresize_end fires when a pane is resized, not the browser window
	    //    - size is the initial size proportion (e.g. 0.5 is 50%)
	    //    - center panes minSize can't be set so the other panes' maxSize provides for the center pane's minSize
	    //    - closable true/false enables/disables visibility and operation of pane togglers
	    //
	    var buildOptions_ = function buildOptions_(cb_onResize, crContainer) {
	        var options = {};
	        var containWidth = crContainer.w,
	            containHeight = crContainer.h;
	        var layoutName = self.getLayoutName();

	        var closable = true;
	        var spacing_closed = 10;

	        if (imageCount == 1) {
	            options = {
	                name: layoutName, onresize_end: cb_onResize, onclose: cb_onResize, minSize: minSize, closable: false
	                ////, enableCursorHotkey: false //////test
	            };
	        } else if (imageCount == 2) {
	            if (paneDesc_ == 'v') {
	                options = {
	                    name: layoutName, onresize_end: cb_onResize, onopen: cb_onResize, onclose: cb_onResize,
	                    minSize: minSize,
	                    closable: closable, spacing_open: 6, spacing_closed: spacing_closed // ALL panes

	                    , east: {
	                        name: layoutName, onresize_end: cb_onResize, onopen: cb_onResize, onclose: cb_onResize,
	                        minSize: minSize, maxSize: containWidth - minSize, size: .5
	                    }
	                };
	            } else {
	                options = {
	                    name: layoutName, onresize_end: cb_onResize, onopen: cb_onResize, onclose: cb_onResize,
	                    minSize: minSize,
	                    closable: closable, spacing_open: 6, spacing_closed: spacing_closed // ALL panes

	                    , south: {
	                        name: layoutName, onresize_end: cb_onResize, onopen: cb_onResize, onclose: cb_onResize,
	                        minSize: minSize, maxSize: containHeight - minSize, size: .5
	                    }
	                };
	            }
	        } else if (imageCount == 3) {
	            if (paneDesc_ == 't') {

	                options = {
	                    name: layoutName, onresize_end: cb_onResize, onopen: cb_onResize, onclose: cb_onResize,
	                    minSize: minSize, east__size: .33, maxSize: containWidth - minSize,
	                    closable: closable, spacing_open: 6, spacing_closed: spacing_closed // ALL panes

	                    , east__children: {
	                        name: layoutName,
	                        onresize_end: cb_onResize, //insures pulling north/south divider down resizes north
	                        south: {
	                            name: layoutName, onresize_end: cb_onResize, onopen: cb_onResize, onclose: cb_onResize,
	                            minSize: minSize, maxSize: containHeight - minSize, size: .5
	                        }
	                    }
	                };
	            } else if (paneDesc_ == 'v') {
	                options = {
	                    name: layoutName, onresize_end: cb_onResize, onopen: cb_onResize, onclose: cb_onResize,
	                    minSize: minSize, maxSize: containWidth - 2 * minSize,
	                    closable: closable, spacing_open: 6, spacing_closed: spacing_closed // ALL panes
	                    , east: {
	                        name: layoutName, onresize_end: cb_onResize, onopen: cb_onResize, onclose: cb_onResize,
	                        minSize: minSize, size: .33,
	                        closable: closable, spacing_closed: spacing_closed
	                    },
	                    west: {
	                        name: layoutName, onresize_end: cb_onResize, onopen: cb_onResize, onclose: cb_onResize,
	                        minSize: minSize, maxSize: containWidth - 2 * minSize, size: .33,
	                        closable: closable, spacing_closed: spacing_closed
	                    }
	                };
	            } else {
	                options = {
	                    name: layoutName, onresize_end: cb_onResize, onopen: cb_onResize, onclose: cb_onResize,
	                    minSize: minSize, maxSize: containHeight - 2 * minSize,
	                    closable: closable, spacing_open: 6, spacing_closed: spacing_closed // ALL panes

	                    , north: {
	                        name: layoutName, onresize_end: cb_onResize, onopen: cb_onResize, onclose: cb_onResize,
	                        minSize: minSize, size: .33
	                    },
	                    south: {
	                        name: layoutName, onresize_end: cb_onResize, onopen: cb_onResize, onclose: cb_onResize,
	                        minSize: minSize, maxSize: containHeight - 2 * minSize, size: .33
	                    }
	                };
	            }
	        } else if (imageCount == 4) {
	            options = {
	                name: layoutName,
	                onresize_end: cb_onResize, onopen: cb_onResize, onclose: cb_onResize,
	                minSize: minSize, maxSize: containWidth - minSize, east__size: .5,
	                closable: closable, spacing_open: 6, spacing_closed: spacing_closed // ALL panes

	                , center__children: {
	                    name: layoutName, onresize_end: cb_onResize, onopen: cb_onResize, onclose: cb_onResize,
	                    minSize: minSize, maxSize: containHeight - minSize, south__size: .5
	                },
	                east__children: {
	                    name: layoutName,
	                    onresize_end: cb_onResize, //insures pulling north/south divider down resizes north
	                    south: {
	                        onresize_end: cb_onResize, onopen: cb_onResize, onclose: cb_onResize,
	                        minSize: minSize, maxSize: containHeight - minSize, size: .5
	                    }
	                }
	            };
	        }
	        ////////////////////////////////////////// not working for all views!
	        options.togglerTip_open = 'Hide View';
	        options.togglerTip_closed = 'Show View';
	        options.resizerTip = 'Drag to Resize Views';
	        options.sliderTip = 'Drag to Show View';
	        //////////////////////////////////////////

	        return options;
	    };

	    //............................................ buildContainerHTML_() local
	    // This function builds the html string that defines the layout panes as a function of imageCount.
	    //    It initializes the state array with the pane id.

	    var buildContainerHTML_ = function buildContainerHTML_() {
	        var html = '';
	        if (imageCount == 1) {
	            state[0] = paneStateInit('us_centerpane', 'none');
	            html = '<div class="ui-layout-center"     id="us_centerpane">patient sample1</div>';
	        } else if (imageCount == 2) {
	            if (paneDesc_ == 'v') {
	                state[0] = paneStateInit('us_leftpane', 'none');
	                state[1] = paneStateInit('us_rightpane', 'none');

	                html = '<div class="ui-layout-center" id="us_leftpane">patient sample1</div>' + '<div class="ui-layout-east"   id="us_rightpane">patient sample2</div>';
	            } else {
	                //"h"
	                state[0] = paneStateInit('us_toppane', 'none');
	                state[1] = paneStateInit('us_bottompane', 'none');

	                html = '<div class="ui-layout-center" id="us_toppane">patient sample1</div>' + '<div class="ui-layout-south"  id="us_bottompane">patient sample2</div>';
	            }
	        } else if (imageCount == 3) {
	            if (paneDesc_ == 't') {
	                state[0] = paneStateInit('us_leftpane', 'none');
	                state[1] = paneStateInit('us_toprightpane', 'none');
	                state[2] = paneStateInit('us_bottomrightpane', 'none');

	                html = '<div class="ui-layout-center"  id="us_leftpane">patient sample</div>' + '<div class="ui-layout-east"><b><u>Outer East</u></b>' // right side pane (east of center)
	                + '<div class="ui-layout-center"  id="us_toprightpane">posControl</div>' + '<div class="ui-layout-south"   id="us_bottomrightpane">negControl</div>';
	            } else if (paneDesc_ == 'v') {
	                state[0] = paneStateInit('us_leftpane', 'none');
	                state[1] = paneStateInit('us_centerpane', 'none');
	                state[2] = paneStateInit('us_rightpane', 'none');

	                html = '<div class="ui-layout-west"    id="us_leftpane">patient sample1</div>' + '<div class="ui-layout-center"  id="us_centerpane">patient sample2</div>' + '<div class="ui-layout-east"    id="us_rightpane">patient sample3</div>';
	            } else {
	                //"h"
	                state[0] = paneStateInit('us_toppane', 'none');
	                state[1] = paneStateInit('us_centerpane', 'none');
	                state[2] = paneStateInit('us_bottompane', 'none');

	                html = '<div class="ui-layout-north"  id="us_toppane">patient sample1</div>' + '<div class="ui-layout-center" id="us_centerpane">patient sample2</div>' + '<div class="ui-layout-south"  id="us_bottompane">patient sample3</div>';
	            }
	        } else if (imageCount == 4) {
	            state[0] = paneStateInit('us_topleftpane', 'none');
	            state[1] = paneStateInit('us_bottomleftpane', 'none');
	            state[2] = paneStateInit('us_toprightpane', 'none');
	            state[3] = paneStateInit('us_bottomrightpane', 'none');

	            html = '<div class="ui-layout-center">patient sample' + '<div class="ui-layout-center"  id="us_topleftpane">top left</div>' + '<div class="ui-layout-south"   id="us_bottomleftpane">bottom left</div>' + '</div>' + '<div class="ui-layout-east"><b><u>Outer East</u></b>' // right side pane (east of center)
	            + '<div class="ui-layout-center"  id="us_toprightpane">northeast</div>' + '<div class="ui-layout-south"   id="us_bottomrightpane">southeast</div>' + '</div>';
	        }
	        return html;
	    };
	    //-------------------------------------------------------------------------------------------------
	    //    STATE ARRAY HELPERS
	    //-------------------------------------------------------------------------------------------------
	    //............................................ buipaneStateInitldHTML() local
	    // This function returns an initialized pane object for the state array.
	    var paneStateInit = function paneStateInit(divId, pref) {
	        return {
	            divId: divId, samplePref: pref,
	            imageIdx: undefined, jPane: undefined,
	            sampleType: undefined, imageId: undefined, jImgDiv: undefined
	        };
	    };
	    //............................................ paneStateUpdate() local
	    // This function updates a specific pane object in the state array.
	    var paneStateUpdate = function paneStateUpdate(idx, jPane, imageId, sampleType, jImgDiv) {
	        state[idx].jPane = jPane; // save a ref to the pane's div

	        state[idx].imageId = imageId; // save the image's id
	        state[idx].sampleType = sampleType; // save the image's sample type
	        state[idx].jImgDiv = jImgDiv; // save a ref to the appended image's div
	    };
	    //............................................ paneIdxFind() local
	    // This function finds the index in the state array with the key value specified
	    //    or -1 if the key value pair doesn't exist in the state array.
	    var paneIdxFind = function paneIdxFind(key, value) {
	        for (var s = 0; s < imageCount; s++) {
	            if (state[s][key] == value) return s;
	        }
	        return -1;
	    };

	    //............................................ construction
	    construct_();
	}
	//________________________________________________________________________________________________

	module.exports = exports['default'];

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = cRegionToolbar;

	var _defines = __webpack_require__(3);

	var _defines2 = _interopRequireDefault(_defines);

	var _toolbar = __webpack_require__(5);

	var _objects = __webpack_require__(7);

	var _annotationsService = __webpack_require__(25);

	var _helpers = __webpack_require__(8);

	var _uScope = __webpack_require__(11);

	var _uScope2 = _interopRequireDefault(_uScope);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	//________________________________________________________________________________________________
	// regionToolbar.js
	//    This file contains the context (right click) toolbar
	//
	//    Dependencies and Supporting objects:
	//        o  jQuery.fn.contextToolbar
	//
	//    history
	//
	//    _______________________________________end_AIHv1/PR __________________________________________
	//    141118    cperz    created
	//    141125    cperz    show context toolbar only when regions exist;
	//                    show redraw icon only for region shapes pen and negpen
	//    141222    cperz    createMenu: hide region copy for report region
	//    150318    cperz    modify iconList id's and classes due to changes of anpanel change from id to class;
	//    150713    cperz    cRegionToolbar: on redraw remove the call to regSelectToCenter() to allow user to edit
	//                    freeform with view as it currently is
	//________________________________________________________________________________________________
	//    regionToolbar - This function builds the context menu region toolbar.
	function cRegionToolbar() {
	    var iconList = [null // divider
	    , {
	        id: 'us_regtbtrash', className: _defines2.default.clsRBBUTTON + ' ' + _defines2.default.APTRASH + ' ' + _defines2.default.APTRASH + '-e',
	        tooltip: 'Delete region',
	        action: function action(e) {
	            var json = _uScope2.default.instance.getImageAnnotRegionRefs(true);
	            if (json.region) json.anObj.regSelectDelete();
	            $('.' + _defines2.default.clsREGIONRAR).remove();
	            return false;
	        }
	    }, {
	        id: 'us_regtbcolor', className: _defines2.default.clsRBBUTTON + ' ' + _defines2.default.APANNOTCOLOR + ' ' + _defines2.default.APANNOTCOLOR + '-e',
	        tooltip: 'Change region color',
	        action: function action(e) {
	            var json = _uScope2.default.instance.getImageAnnotRegionRefs(true);
	            if (json.region) {
	                var clr = json.anObj.getSelColor(); // get color of currently selected region
	                _uScope2.default.instance.annotPanel.publicColorPicker.show(true, clr);
	            }
	            $('.' + _defines2.default.clsREGIONRAR).remove();
	            return false;
	        }
	    }, {
	        // icon: '../images/note.png',
	        id: 'us_regtbnote', className: _defines2.default.clsRBBUTTON + ' ' + _defines2.default.APNOTE + ' ' + _defines2.default.APNOTE + '-e',
	        tooltip: 'Add region note',
	        action: function action(e) {
	            var json = _uScope2.default.instance.getImageAnnotRegionRefs(true);
	            if (json.region) {
	                if (json.region.shape === 'text') (0, _toolbar.openTextEditPanel)('Update on image text', json.region.note, _annotationsService.cb_addOnImageText);else if (json.region.isReportRegion) (0, _toolbar.openTextEditPanel)('Modify report region text', json.region.note, _annotationsService.cb_addOnImageText);else (0, _toolbar.openTextEditPanel)('Add note for this region', json.region.note, _annotationsService.cb_regAddNote);
	            }
	            $('.' + _defines2.default.clsREGIONRAR).remove();
	            return false;
	        }
	    }, {
	        id: 'us_regtbcopy', className: _defines2.default.clsRBBUTTON + ' ' + _defines2.default.REGTBCOPY + ' ' + _defines2.default.REGTBCOPY + '-e',
	        tooltip: 'Copy selected region:\r    Navigate to desired location \r    and right click to place the region',
	        action: function action(e) {
	            var json = _uScope2.default.instance.getImageAnnotRegionRefs(true);
	            if (json.region) _uScope2.default.instance.startCopyMoveRegion(json.region, e, 'copy');
	            $('.' + _defines2.default.clsREGIONRAR).remove();
	            return false;
	        }
	    }, {
	        id: 'us_regtbmove', className: _defines2.default.clsRBBUTTON + ' ' + _defines2.default.REGTBMOVE + ' ' + _defines2.default.REGTBMOVE + '-e',
	        tooltip: 'Move selected region:\r    Navigate to desired location \r    and right click to place the region',
	        action: function action(e) {
	            var json = _uScope2.default.instance.getImageAnnotRegionRefs(true);
	            if (json.region) _uScope2.default.instance.startCopyMoveRegion(json.region, e, 'move');
	            $('.' + _defines2.default.clsREGIONRAR).remove();
	            return false;
	        }
	    }];

	    iconList.push(null);
	    iconList.push({
	        id: 'us_regtbredraw', className: _defines2.default.clsRBBUTTON + ' ' + _defines2.default.REGTBREDRAW + ' ' + _defines2.default.REGTBREDRAW + '-e',
	        tooltip: 'Redraw freeform:\n    o Hold left mouse button down\r      near the region to start redraw\r    o Drag mouse to redraw\n    o Release mouse button to stop.',
	        action: function action(e) {
	            var json = _uScope2.default.instance.getImageAnnotRegionRefs(true); // get refs to image, annot and selected region
	            if (json.region) _defines2.default.navModeSwitch(json.thisImg, _defines2.default.eNavModes.nmRedrawStarting); // switch to redraw mode
	            $('.' + _defines2.default.clsREGIONRAR).remove();
	            return false;
	        }
	    });

	    var rtnObject = $(_defines2.default.idHashROOT).contextToolbar({
	        parent: _defines2.default.idHashROOT,
	        title: 'Region',
	        toolbarClass: _defines2.default.clsREGIONRAR,
	        //additionalClass: '',
	        callback: undefined, // could use regionToolbar_cb
	        items: iconList
	    });
	    return rtnObject;

	    //..................................................
	    // closure functions

	    //............................................ regionToolbar_cb
	    function regionToolbar_cb(x, y) {
	        var json = _uScope2.default.instance.getImageAnnotRegionRefs();
	        // placeholder for default callback functionality
	    }
	    //..................................................
	}
	//________________________________________________________________________________________________
	//
	// jQuery.fn.contextToolbar:  jQuery plugin for right click context toolbar.
	//
	// Usage:
	//   $('.something').contextToolbar({
	//     title: 'Some title',
	//     items: [
	//       {icon:'/images/icon1.png', action:function() {  }, tooltip: 'friendly'},
	//       {icon:'/images/icon2.png', action:function() {  }, tooltip: 'philly'},
	//       null, // divider
	//       {icon:'/images/icon3.png', action:function() { }, tooltip: 'city'},
	//     ]
	//   });
	//    This code is derived from Joe Walnes https://github.com/joewalnes/jquery-simple-context-menu

	jQuery.fn.contextToolbar = function (options) {
	    var settings = { // define default settings
	        parent: document.body,
	        toolbarClass: 'contextToolBar',
	        additionalClass: '',
	        titleClass: 'title',
	        spacerClass: 'divider',
	        title: 'Title',
	        callback: undefined,
	        items: []
	    };
	    $.extend(settings, options);

	    //............................................ bind
	    this.bind('contextmenu', function (e) {
	        // On contextmenu event (right click)
	        if (_uScope2.default.instance.canAnnotate() == false) return false; // if this image isn't annotatable, return and do not propigate the event

	        if (_uScope2.default.instance.isRegionCopyActive() == true) // complete the prior copy or move region action
	            _uScope2.default.instance.stopCopyMoveRegion();

	        var menu = createMenu(e); // create the menu
	        if (menu != false) {
	            var json = _uScope2.default.instance.getImageAnnotRegionRefs(true);
	            var thisImg = json.thisImg;
	            if (json.region.isInView(thisImg.getVPViewRect2()) == false) // if the selected region is not in the view, center it in the view
	                json.anObj.regSelect({ rfId: json.anObj.rfSelected, bReposition: true }); //todo: could really use a fn that centers selected region

	            menu.show(); // show the context toolbar - must do b4 positioning
	            //todo: does not work multi-image
	            var cpRtn = new _objects.cPoint(0, 0); // return position object
	            var jVpDiv = thisImg.vpDivGet();
	            var offset = jVpDiv.offset(); // the current position of the target relative to the document

	            var cpVPcoord = new _objects.cPoint(e.pageX - offset.left, e.pageY - offset.top); // translate viewport left top position
	            var angleRad = thisImg.getViewAngle();
	            var vpDivDims = thisImg.vpDivDimsGet();
	            var cpRotOffset = (0, _helpers.computeRotationOffset)(vpDivDims.w, vpDivDims.h, angleRad); //
	            cpVPcoord.addPoint(cpRotOffset);
	            menu.css({ left: cpVPcoord.x + 10, top: cpVPcoord.y + 5 }).bind('contextmenu', function () {
	                return false;
	            });

	            if (settings.callback) settings.callback(cpVPcoord.x, cpVPcoord.y);
	        }
	        return false; // cancel event, so real browser popup doesn't appear.
	    });
	    //............................................ createMenu
	    function createMenu(e) {
	        var json = _uScope2.default.instance.getImageAnnotRegionRefs(true);
	        if (json.region == undefined || _uScope2.default.instance.canAnnotate() == false) // if no region selected or cannot annotate,
	            return false; // then do not create the menu

	        if ($('.' + settings.toolbarClass + ' ' + settings.additionalClass).length) // if already present,
	            return false; // then do not create the menu

	        // Build toolbar HTML
	        var menu = $('<div class="' + settings.toolbarClass + ' ' + settings.additionalClass + '"></div>').appendTo(settings.parent);
	        if (settings.title) $('<div class="' + settings.titleClass + '"></div>').text(settings.title).appendTo(menu);

	        settings.items.forEach(function (item) {
	            if (item) {
	                //toconsider: extend item info to do this test instead of hard coding this knowledge at this level
	                // do not show the redraw icon unless the region is a pen or negpen
	                if (item.id == _defines2.default.REGTBREDRAW && json.region.shape != 'pen' && json.region.shape != 'negpen') {
	                    //debug-only json.thisImg.log("regionToolbar: createMenu: not adding REDRAW icon because shape is " + json.region.shape);
	                    return; //stop processing this iteration
	                }
	                if (item.id == _defines2.default.REGTBCOPY && json.region.isReportRegion) {
	                    //debug-only json.thisImg.log("regionToolbar: createMenu: not adding REDRAW icon because shape is " + json.region.shape);
	                    return; //stop processing this iteration
	                }

	                if (item.icon || item.className || item.id) {
	                    var row = $('<div></div>').appendTo(menu);
	                    var icon = $('<a>');
	                    if (item.icon) icon.attr('src', item.icon);
	                    if (item.className) icon.attr('class', item.className);
	                    if (item.id) icon.attr('id', item.id);
	                    if (item.tooltip) icon.attr('title', item.tooltip);
	                    $(row).append(icon);

	                    if (item.action) row.find('a').click(function () {
	                        item.action(e);
	                    });
	                }
	            } else {
	                $('<div class="' + settings.spacerClass + '"></div>').appendTo(menu);
	            }
	        });
	        menu.find('.' + settings.titleClass).text(settings.title);

	        menu.mouseleave(function () {
	            // when the mouse leaves the toolbar, remove it from the DOM
	            menu.remove();
	            return false;
	        });
	        return menu;
	    }
	    return this;
	};
	//________________________________________________________________________________________________

	module.exports = exports['default'];

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = cUserPrefs;

	var _defines = __webpack_require__(3);

	var _defines2 = _interopRequireDefault(_defines);

	var _events = __webpack_require__(10);

	var _helpers = __webpack_require__(8);

	var _toolbar = __webpack_require__(5);

	var _uScope = __webpack_require__(11);

	var _uScope2 = _interopRequireDefault(_uScope);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	//________________________________________________________________________________________________
	// userPrefs.js
	//    This file contains the user preference object.
	//
	//    _______________________________________end_AIHv1/PR __________________________________________
	//    1412XX    cperz    change call from ajaxDoDBCall to doDATASVRREQ;
	//    150318    cpers    use thisImg.err();
	//
	//________________________________________________________________________________________________
	function cUserPrefs() {
	    var self = this;

	    var userPrefsKnown = false; // true when getUserPrefs is sucessful
	    var userPrefTable = []; // user preference settings
	    this.getPrefTable = function () {
	        return userPrefTable;
	    };

	    //............................................ getAll() public
	    //    This function gets ALL uScope user preferences from the database
	    this.getAll = function (vpObj) {
	        if (_defines2.default.DISABLEUSERPREFS2DB == true) return; // if disabled, don't read from database
	        if (userPrefsKnown) return;

	        var userId = parseInt(_uScope2.default.instance.getUserId()); // only make request if prefs are not know and userId is valid
	        if (userId <= 0 || (0, _helpers.isUnDefined)(userId)) {
	            (0, _toolbar.consoleWrite)('ERROR: cUserPrefs: getAll: userId: ' + userId + '  is invalid.  User preferences cannot be read.');
	            return;
	        }

	        var xml = '<TableName>UserConfig</TableName>' + '<FilterBy Column="Component" FilterOperator="="FilterValue="uScope" Table="UserConfig"></FilterBy>' + '<FilterBy Column="UserId" FilterOperator="=" FilterValue="' + userId + '" Table="UserConfig"></FilterBy>';
	        //if (us.DBGOPTIONS) consoleWrite("userPrefs:getAll: GetFilteredRecordList: " + xml);

	        // note - an image is required by imageserver dodbcall even if request isn't image related
	        var thisImg = vpObj;
	        thisImg.ajax.doDATASVRREQ(cbSuccessFn, cbFailureFn, 'GetFilteredRecordList', xml);

	        //..................................................
	        // closure functions
	        //............................................ cbSuccessFn()
	        // This function receives the response message from getUserPrefs
	        //    and parses the returned user prefs into the user pref table.
	        function cbSuccessFn(data, textStatus, jqXHR) {
	            var idx = -1;
	            var responseText = jqXHR.responseText;
	            if ((idx = responseText.lastIndexOf('>')) !== -1) responseText = responseText.slice(0, idx + 1); // remove the garbage char on the end of the response
	            if (_defines2.default.DBGOPTIONS) (0, _toolbar.consoleWrite)('cb_getUserPrefs: \n' + responseText);

	            var xmlDoc = $.parseXML(responseText);
	            var $xml = $(xmlDoc);
	            var jResponse = $xml.find('GetFilteredRecordListResponse');
	            var jResult = jResponse.find('ASResult');

	            if (jResult.text() != '0') {
	                var jMessage = jResult.find('ASMessage'); //s/b [ asmessage ]
	                (0, _toolbar.consoleWrite)('Error: cb_getUserPrefs: msg:' + jMessage.text() + '  code: ' + jResult.text());
	                return;
	            }

	            // parse and update entry in prefs table for value and id
	            var jDataRows = jResponse.find('DataRow'); //ex: [ DataRow] [ DataRow ] [ DataRow ]
	            for (var l = 0, len = jDataRows.length; l < len; l++) {
	                var jRow = jDataRows.eq(l);
	                var dbId = jRow.find('Id').text();
	                var name = jRow.find('Name').text();
	                var value = jRow.find('Value').text();
	                if (name && dbId && value) {
	                    if (value === 'true') value = true; // replace string values with bools
	                    else if (value === 'false') value = false;

	                    initPref(name, value, dbId);
	                    reportPref(name);
	                }
	            }
	            userPrefsKnown = true;

	            (0, _events.triggerUScopeEvent)(_defines2.default.evUSERPREFSREADY, { status: true });
	        }
	        //............................................ cbFailureFn()
	        function cbFailureFn(jqXHR, textStatus, errorThrown) {
	            thisImg.err('cUserPrefs: getAll: doDATASVRREQ: GetFilteredRecordList: ' + thisImg.ajax.getErrorStr(jqXHR, thisImg.getImageId()));
	        }
	        //..................................................
	    };
	    //............................................ get() public
	    //    This function returns the user preference value for the given name.
	    //    If the name is not in the pref table and is not a special access pref, undefined is returned.
	    this.get = function (name, defaultVal) {
	        var rtnVal;
	        if (userPrefTable[name]) // if in the user pref table...
	            rtnVal = userPrefTable[name].value; // then return that
	        else // otherwise,
	            rtnVal = defaultVal == undefined ? true : defaultVal;

	        //debug-only if (name != us.clsDIVGUAGES)consoleWrite("cUserPrefs: get: " + name + "  value: " + rtnVal);
	        return rtnVal;
	    };
	    //............................................ set() public
	    // This function updates a user preference and stores it in the database.
	    //    If the preference does not exist in the table it is added.
	    this.set = function (name, value) {
	        if (!userPrefTable[name]) // if the name is not in the table
	            initPref(name, value); //   add it
	        else if (userPrefTable[name].value == value) // else if the name's value is already the passed value
	                return; //   nothing to do

	        userPrefTable[name].value = value; // update table

	        (0, _events.triggerUScopeEvent)(_defines2.default.evUSERPREFSET, { className: name, value: value }); // fire event

	        if (_defines2.default.DISABLEUSERPREFS2DB) return; // if disabled, don't save to database

	        var userId = parseInt(_uScope2.default.instance.getUserId()); // only make request if prefs are not know and userId is valid
	        if ((0, _helpers.isUnDefined)(userId) || userId <= 0) return;
	        var dbId = (0, _helpers.isDefined)(userPrefTable[name].dbId) ? userPrefTable[name].dbId : 0;

	        var xml = '<TableName>UserConfig</TableName>' + '<Tag>' + name + '</Tag>';
	        if (dbId > 0) xml += '<Id>' + userPrefTable[name].dbId + '</Id>';
	        xml += '<DataRow>' + '<Name>' + name + '</Name>' + '<Value>' + value + '</Value>';
	        if (dbId <= 0) xml += '<Component>uScope</Component>' + '<UserId>' + userId + '</UserId>';
	        xml += '</DataRow>';

	        if (_defines2.default.DBGOPTIONS) (0, _toolbar.consoleWrite)('userPrefs:set: PutRecordData: ' + xml);

	        // note - imageId required by imageserver dodbcall even if the request isn't image related!
	        if (_uScope2.default.instance.isThisImageValid() == true) {
	            var thisImg = _uScope2.default.instance.getThisImage();
	            thisImg.ajax.doDATASVRREQ(cbSuccessFn, cbFailureFn, 'PutRecordData', xml);
	        }

	        //..................................................
	        // closure functions
	        //............................................ cbSuccessFn()
	        // This function receives the response message from setPref
	        //    and parses the response for the id related to the preference.
	        function cbSuccessFn(data, textStatus, jqXHR) {
	            var idx = -1;
	            var responseText = jqXHR.responseText;
	            if ((idx = responseText.lastIndexOf('>')) !== -1) responseText = responseText.slice(0, idx + 1); // remove the garbage char on the end of the response
	            if (_defines2.default.DBGOPTIONS) (0, _toolbar.consoleWrite)('userPrefs:cb_setPref: \n' + responseText);

	            var xmlDoc = $.parseXML(responseText);
	            var $xml = $(xmlDoc);
	            var jResponse = $xml.find('PutRecordDataResponse');

	            var name = jResponse.find('Tag').text(); // get the returned tag
	            if (name) {
	                var dbId = jResponse.find('Id').text(); // get the returned preferences id
	                if (dbId) userPrefTable[name].dbId = dbId;
	                reportPref(name);
	            }
	        }
	        //............................................ cbFailureFn()
	        function cbFailureFn(jqXHR, textStatus, errorThrown) {
	            thisImg.err('cUserPrefs: set: doDATASVRREQ: PutRecordData: ' + thisImg.ajax.getErrorStr(jqXHR, thisImg.getImageId()));
	        }
	        //..................................................
	    };

	    //............................................ reset() local
	    //    This function resets the object:
	    //        - initializes the user preference table
	    this.reset = function () {
	        userPrefsKnown = false;
	        userPrefTable.length = 0;
	    };
	    //............................................ initPref() local
	    var initPref = function initPref(name, value, dbId) {
	        var row = { 'value': value, 'dbId': dbId };
	        userPrefTable[name] = row;
	        return row;
	    };
	    //............................................ reportPref() local
	    var reportPref = function reportPref(name) {
	        if (_defines2.default.DBGOPTIONS) {
	            var str = userPrefTable[name] ? 'USER pref: ' : 'DEFAULT pref:  ';
	            (0, _toolbar.consoleWrite)(str + name + ': ' + (0, _helpers.toStringAssoc)(userPrefTable[name]));
	        }
	    };
	    //...............................................................................................
	    // construction
	    self.reset();
	}
	module.exports = exports['default'];

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = ColorPicker;

	var _defines = __webpack_require__(3);

	var _defines2 = _interopRequireDefault(_defines);

	var _toolbar = __webpack_require__(5);

	var _helpers = __webpack_require__(8);

	var _colorPickerControl = __webpack_require__(35);

	var _colorPickerControl2 = _interopRequireDefault(_colorPickerControl);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function ColorPicker(uScope) {
	    var jPanel = void 0;
	    var jColorPickerContainer = void 0;
	    var jColorPickerBar = void 0;
	    var control = void 0;
	    var jColorPickerGrid = void 0;

	    this.show = function (show, curColor) {
	        if (show == true) {
	            jPanel.dialog('open');
	            position();
	            set(curColor);
	        } else jPanel.dialog('close');
	    };

	    var position = function position() {
	        var position = $('#' + _defines2.default.idANNOTPANEL).offset(); // position color picker with respect to the annotation panel
	        var panelPos = [Math.floor(position.left), Math.floor(position.top)];
	        jPanel.dialog({
	            left: panelPos[0],
	            top: panelPos[1],
	            width: getGridWidth() + 20
	        });
	    };

	    var set = function set(curColor) {
	        if (jPanel.is(':visible')) {
	            // if the colorpicker is visible, display the current color bar
	            var curColorHex = '#' + (0, _helpers.toHexColor)(curColor); // returns decimal RGB value in lower case hex characters
	            control.selectByColor(curColorHex);
	            jColorPickerBar.css({ 'background-color': curColorHex });
	        }
	    };

	    var getGridWidth = function getGridWidth() {
	        return jColorPickerGrid.width();
	    };

	    var init = function init() {
	        jColorPickerContainer = $('<div id=' + _defines2.default.idCLRPICKDIV + '></div>');
	        jPanel = $('<div/>', {
	            'id': _defines2.default.idCLRPICKPANEL,
	            'class': _defines2.default.clsPANEL,
	            'title': 'Select a Color'
	        });

	        // $('#' + us.idCLRPICKPANEL).remove();                // Remove any existing color pickers from the DOM (TODO - shouldn't there be a destructor?)
	        $(_defines2.default.idHashROOT).append(jPanel); // Add the panel to the root to be able to move it

	        jPanel.dialog({
	            autoOpen: false,
	            closeOnEscape: false,
	            modal: true,
	            draggable: true,
	            resizable: false,
	            stack: true,
	            position: ['center', 'bottom'],
	            dialogClass: 'uscope-dialog dialogMover',
	            buttons: [{
	                text: 'OK', click: function click() {
	                    (0, _toolbar.setIconState)($('.' + _defines2.default.APANNOTCOLOR), _defines2.default.APANNOTCOLOR, 'enabled');
	                    $(this).dialog('close');
	                }
	            }, {
	                text: 'Cancel', click: function click() {
	                    (0, _toolbar.setIconState)($('.' + _defines2.default.APANNOTCOLOR), _defines2.default.APANNOTCOLOR, 'enabled');
	                    $(this).dialog('close');
	                }
	            }]
	        });

	        // append this modal dialog to body to work around a jquery issue that modal dialogs cannot be dismissed in popup mode
	        //    (would normally want it appended to the uscope div)
	        // note that the dialog is the parent to the panel created
	        jPanel.parent().appendTo('body');

	        // add the div of color squares to the panel
	        jPanel.append(jColorPickerContainer);

	        control = new _colorPickerControl2.default(jColorPickerContainer, {
	            columns: 13,
	            click: function click(clr) {
	                uScope.events.trigger('color-picker:select-color', (0, _helpers.hexColortoRGB)(clr));
	                jPanel.dialog('close');
	                (0, _toolbar.setIconState)($('.' + _defines2.default.APANNOTCOLOR), _defines2.default.APANNOTCOLOR, 'enabled');
	            }
	        });

	        jColorPickerGrid = $('.' + _defines2.default.clsCLRPICKGRID);
	        jColorPickerBar = $('<div/>', { 'id': _defines2.default.idCLRPCKBAR, 'width': getGridWidth() - 5, 'height': 14 });

	        // and add a color bar div to display the selected color
	        jPanel.append(jColorPickerBar);
	    };

	    init();
	}
	module.exports = exports['default'];

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = ColorPickerControl;

	var _defines = __webpack_require__(3);

	var _defines2 = _interopRequireDefault(_defines);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function ColorPickerControl(selector, options) {
	    var $colorCells = void 0;
	    var selectedIdx = void 0;
	    var settings = void 0;

	    var init = function init(selector, options) {
	        var defaults = {
	            defaultColorIdx: 0, // default color index
	            columns: 13, // number of color cells per row (0 means 1 row)
	            divClass: _defines2.default.clsCLRPICKGRID, // the div to place the color picker grid in
	            colorPalette: _defines2.default.colorPalette, // color selections
	            click: function click($colorCells) {}
	        };
	        settings = $.extend({}, defaults, options);

	        // in the immediate scope of the plugin function, the this keyword refers to the jQuery object the plugin was invoked on.
	        var $this = $(selector); // the associated parent html element
	        selectedIdx = settings.defaultColorIdx;
	        settings.columns = settings.columns > 0 ? settings.columns : settings.color.length;

	        var sCells = ''; // create abd add the color grid to the parent with the specified class
	        for (var i = 0; i < settings.colorPalette.length; i++) {
	            sCells += '<div style="background-color:' + settings.colorPalette[i] + ';"></div>';
	        }$this.html('<div class="' + settings.divClass + '">' + sCells + '</div>');

	        $colorCells = $this.children('.' + settings.divClass).children('div'); // select the grid's color cells

	        var w = ($colorCells.width() + 4) * settings.columns; // set width of cell grid =  space between cells x N cells/row
	        $('.' + settings.divClass).css('width', w);

	        $colorCells.each(function (i) {
	            // add click event to each cell
	            $(this).click(function () {
	                setCheckState(i); // check the appropriate div
	                settings.click(settings.colorPalette[i]); // issue user click
	            });
	        });
	        setCheckState(settings.defaultColorIdx); // check the appropriate div
	        selectedIdx = settings.defaultColorIdx; // save the selected color idx
	    };

	    var setCheckState = function setCheckState(i) {
	        var $cell = void 0;
	        if (selectedIdx == i) return; // nothing to do
	        if (i == -1 || i > settings.colorPalette.length - 1) i = 0; // keep index in-bounds

	        if (selectedIdx > -1) {
	            // clean up check state in previous color cell
	            $cell = $colorCells.eq(selectedIdx);
	            if ($cell.hasClass('check')) $cell.removeClass('check').removeClass('checkwht').removeClass('checkblk');
	        }

	        selectedIdx = i; // save the selected color idx
	        $cell = $colorCells.eq(selectedIdx); // set checkmark in selected color
	        var whiteFont = setWhiteFont(settings.colorPalette[i]);
	        $cell.addClass('check').addClass(whiteFont ? 'checkwht' : 'checkblk');
	    };

	    var setWhiteFont = function setWhiteFont(hexColor) {
	        // compute brightness of color by converting to the Y component of YUV, which is brightness or luminance
	        var decRGB = parseInt(hexColor.substr(1), 16); // integer RGB value
	        var blue = decRGB & 0xFF;
	        var green = decRGB >> 8 & 0xFF;
	        var red = decRGB >> 16 & 0xFF;
	        //    don't need U and V, but fyi, they are:      U = 0.436 * (blue - Y) / (1 / 0.114);  V = 0.615 * (red - Y) / (1 / 0.299);
	        var Y = parseInt(red * 0.299 + green * 0.587 + blue * 0.114);
	        return Y <= 139;
	    };

	    this.selectByColor = function (hexColor) {
	        // set the color selection to the passed hex color, e.g. "#ffff56"
	        for (var i = 0; i < settings.colorPalette.length; i++) {
	            if (settings.colorPalette[i] == hexColor) {
	                setCheckState(i);
	                break;
	            }
	        }
	    };

	    init(selector, options);
	}
	module.exports = exports['default'];

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	__webpack_require__(37);

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _defines = __webpack_require__(3);

	var _defines2 = _interopRequireDefault(_defines);

	var _publicApi = __webpack_require__(18);

	var _publicApi2 = _interopRequireDefault(_publicApi);

	var _compatibility = __webpack_require__(6);

	var _constants = __webpack_require__(38);

	var CONSTANTS = _interopRequireWildcard(_constants);

	var _conferencingFactory = __webpack_require__(39);

	var _conferencingFactory2 = _interopRequireDefault(_conferencingFactory);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_publicApi2.default.plugins.register({
	    name: 'us:conferencing',

	    extends: 'uScope',

	    canStart: function canStart(uScope) {
	        return !_compatibility.BrowserDetect.isIOS() && uScope.toolbarCanAddButton('dscSetupBtn');
	    },


	    constructor: function constructor(uScope) {
	        var conferencingService = _conferencingFactory2.default.createService(uScope);

	        uScope.events.on('uscope:init', function () {
	            addToolbarButton(conferencingService, uScope);
	        });
	    }
	});

	var addToolbarButton = function addToolbarButton(conferencingService, uScope) {
	    var button = $('<a/>', {
	        'id': CONSTANTS.CREATE_BUTTON_ID,
	        'class': _defines2.default.clsTBBUTTON + ' ' + CONSTANTS.CREATE_BUTTON_ID + '-e',
	        'title': 'Create a conference'
	    });

	    var handleMainButtonClick = function handleMainButtonClick(event) {
	        if (!conferencingService.isInConference()) {
	            conferencingService.confCreate();
	        }

	        event.preventDefault();
	        event.stopImmediatePropagation();
	        return false;
	    };

	    button.on('click', handleMainButtonClick);

	    uScope.topToolbar.addButton(button);
	};

/***/ },
/* 38 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CREATE_BUTTON_ID = exports.CREATE_BUTTON_ID = 'us_tbconfcreate';
	var CONFERENCE_MARKER_EVENT = exports.CONFERENCE_MARKER_EVENT = 'us_evCONFMARKER';

	/**
	 * Dev Mode has two side effects:
	 *   1. Turns on additional event logging in the Conferencing service
	 *   2. If the test-panel is enabled (by including it in the build), adds a bunch of buttons triggering various conf events
	 */
	var ENABLE_DEV_MODE = exports.ENABLE_DEV_MODE = true;

	/**
	 * If the test-panel is enabled, adds a button that does a bunch of stuff. It doesn't actually look conferencing related
	 * but the button's title says "Exit Conferencing", so what the heck do I know?
	 */
	var ENABLE_TEST_ICON = exports.ENABLE_TEST_ICON = true;

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _conferencingService = __webpack_require__(40);

	var _conferencingService2 = _interopRequireDefault(_conferencingService);

	var _conferencingMarker = __webpack_require__(41);

	var _conferencingMarker2 = _interopRequireDefault(_conferencingMarker);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	// The conferencing service operates in global scope and can destroy or spin up uScope instances. In order to do this it
	// needs to be able to exist in global scope. Note that it shouldn't need to destroy uScope, but since that's a
	// singleton, we're doing this for now...
	var conferencingSingleton = void 0;

	exports.default = {
	    createService: function createService(uScope) {
	        if (!conferencingSingleton) {
	            conferencingSingleton = new _conferencingService2.default(uScope);
	        } else {
	            conferencingSingleton.setUScope(uScope);
	        }

	        // HACK ALERT - extend uScope with conferencing methods. Don't want to break existing implementations
	        uScope.confCreate = conferencingSingleton.confCreate;
	        uScope.isConfLeader = conferencingSingleton.isConfLeader;
	        uScope.isModeConference = conferencingSingleton.isInConference;
	        uScope.isConfMember = conferencingSingleton.isConfMember;

	        // Note that this can be refactored to "extend" the viewport and simplify this nest a little
	        uScope.events.on('uscope:image:init', function (viewport) {
	            viewport.events.on('viewport:initialize-layout', function () {
	                new _conferencingMarker2.default(viewport);
	            });
	        });

	        uScope.events.on('uScope:command:log-settings', function (log) {
	            log('--- enabled: Conferencing');
	        });

	        return conferencingSingleton;
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = ConferencingService;

	var _defines = __webpack_require__(3);

	var _defines2 = _interopRequireDefault(_defines);

	var _toolbar = __webpack_require__(5);

	var _objects = __webpack_require__(7);

	var _events = __webpack_require__(10);

	var _helpers = __webpack_require__(8);

	var _constants = __webpack_require__(38);

	var CONSTANTS = _interopRequireWildcard(_constants);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	//    This file contains the uScope portion of the Conferencing Service, for both leader and joiner
	//    of a conference in conjunction with DSCClient.  It also contains cConfTestPanel which
	//    provides unit testing of uScope's conferencing features.
	//
	//    Design notes:
	//        Conference Leader Role:
	//            - recvs VIL-issued join conference event specifies role of leader or becomes leader
	//                on VIL-issued leaderChange event
	//            - recvs view and cursor events issued by cStateVector, sends view and marker updates to VIL
	//                who transmits them to the followers via the DSC server
	//            - recvs VIL-issued exit event and no longer performs conferencing actions
	//            - note that the leader's tray can open, close, and change attributes such as positive/negative control
	//                 of an image and that VIL recvs tray actions to be transmitted to the followers  via the DSC server
	//
	//        Conference Follower Role:
	//            - recvs VIL-issued join conference event specifies role of follower or becomes follower
	//                on VIL-issued leaderChange event
	//            - recvs VIL-issued view and marker events, updates the view and marker states
	//            - recvs VIL-issued exit event and no longer performs conferencing actions
	//            - note that the follower's tray can open, close, and change attributes such as positive/negative
	//                control of an image in response to VIL-issued events originating from the leader's tray
	//
	//    Handy conferencing URLs
	//            http://localhost/dscserver/RESET        to clear all current conferences
	//            http://localhost/dscserver/STATS        to see if a conference is running
	//

	// Compatibility only. confEvents is defined in AIH to conference folder
	var confEvent = window.confEvent || {};

	// Main class
	function ConferencingService(uScopeInstance) {
	    var uScope = uScopeInstance;
	    var self = this;
	    var bAmInConf_;
	    var ptName_;
	    var bAmLeader_;

	    var thisImg;
	    var namespace_ = '.usconference';
	    var confMarkerLT_ = new _objects.cPoint(0, 0);

	    var minViewMovePx_ = 6; // the minimum distance in pixels of view change to respond to

	    //............................................ queries public
	    this.isInConference = function () {
	        return bAmInConf_;
	    };
	    this.isConfLeader = function () {
	        return bAmInConf_ && bAmLeader_;
	    };
	    this.isConfMember = function () {
	        return bAmInConf_ && (bAmLeader_ ? false : true);
	    };

	    //____________________________________________________________________________________________
	    //     CONFERENCE EVENTS TO VIL FROM CONFERENCE INITIATOR
	    //____________________________________________________________________________________________

	    //............................................ confCreate public
	    //    This function fires an event indicating the user wants to create a conference.
	    this.confCreate = function () {
	        if (confEvent.createBtn) {
	            triggerConfEvent(confEvent.createBtn, { src: 'uScope' });
	        }
	    };

	    this.setUScope = function (uScopeInstance) {
	        return uScope = uScopeInstance;
	    };

	    //____________________________________________________________________________________________
	    //     LOCAL FUNCTIONS
	    //____________________________________________________________________________________________
	    var eventLog = function eventLog(str, eventName, parms) {
	        if (CONSTANTS.ENABLE_DEV_MODE) {
	            (0, _toolbar.consoleWrite)('conf: user: ' + ptName_ + ' ' + str + ' ' + eventName + ': {' + (0, _helpers.toStringAssoc)(parms) + '}');
	        }
	    };
	    //............................................ triggerConfEvent
	    // triggerConfEvent - This function fires the passed event with the passed parameters.
	    var triggerConfEvent = function triggerConfEvent(evName, parms) {
	        $(document).trigger(evName, parms);
	        // if (us.DBGEVENTS) consoleWrite('trigger: ' + evName + '  ' + toStringAssoc(parms));
	    };
	    //............................................ bindEvents_() local
	    //    This function is called when joining a conference.
	    var bindEvents_ = function bindEvents_() {
	        //............................................ confEvent.openimage
	        // Listen for a conference open image event.
	        //{src: 'uScope', imageId: @NUM, uScopeIdx: NUM, 'imagePath': STR }
	        $(document).on(confEvent.openimage + namespace_, function (e, json) {
	            if (self.isInConference() == true && self.isConfLeader() == false) {

	                if (json == undefined) {
	                    (0, _toolbar.consoleWrite)('Error: confEvent.openimage: json input undefined');
	                    return;
	                }
	                eventLog('recieved', confEvent.openimage, json);
	                thisImg = uScope.getThisImage();
	                if (thisImg == undefined) {
	                    // no image in view, so open the passed image
	                    var imageSet1 = {
	                        'images': [{
	                            'imagePath': json.imageId, 'fullURL': json.imagePath //the image that is opening
	                            , x: json.x, y: json.y, zoom: json.zoom, angle: json.angleDeg
	                        }]
	                    };
	                    uScope.imageUpdate('add', imageSet1.images);

	                    //debug-only consoleWrite('....conf: new image opened: ' + json.imageId);
	                    thisImg = uScope.getThisImage(); // now reference to the newly opened image
	                } else {
	                    // uScope already has an image, so replace it with this one
	                    var _imageSet = { 'images': [{ 'imagePath': thisImg.getImageId() }] }; // the image that is closing
	                    // NOTE: the mess here is that 'imagePath' means the fullURL to the conference and it means the imageId to uScope.
	                    var imageSet2 = {
	                        'images': [{
	                            'imagePath': json.imageId, 'fullURL': json.imagePath,
	                            x: json.x, y: json.y, zoom: json.zoom, angle: json.angleDeg
	                        }]
	                    }; // the image that is opening
	                    uScope.imageUpdate('replace', _imageSet.images, imageSet2.images);

	                    //debug-only consoleWrite('....conf: current image ' + thisImg.getImageId() + ' replaced by ' + json.imageId);
	                    thisImg = uScope.getThisImage(); // now reference to the newly opened image
	                }

	                if (thisImg) {
	                    // angle is not handled in the general, non-conference, image opening yet - if ever
	                    if (json.angleDeg) {
	                        if (json.angleDeg !== thisImg.getViewAngle(true)) {// update the view rotation if it has changed
	                            // todo: rotation angle here
	                        }
	                    }

	                    if (json.MarkerX && json.MarkerY) {
	                        // if a marker position is present
	                        confMarkerLT_.set(json.MarkerX, json.MarkerY); // update the marker position
	                        (0, _events.triggerUScopeEvent)(CONSTANTS.CONFERENCE_MARKER_EVENT, json); // and fire event of conferencing follower's marker position update
	                    }
	                    triggerConfEvent(confEvent.imageChange, { src: 'uScope', imageId: thisImg.getImageId() }); // tell listeners (like slide tray) that image has changed (from no image to first image of conference)
	                }
	            }
	        });
	        //............................................ confEvent.closeimage
	        // Listen for a conference close image event.
	        //{src: 'uScope', imageId: @NUM }
	        $(document).on(confEvent.closeimage + namespace_, function (e, json) {
	            if (self.isInConference() == true && self.isConfLeader() == false) {
	                eventLog('recieved', confEvent.closeimage, json);

	                var imageSet = { 'images': [{ 'imagePath': json.imageId }] };
	                uScope.imageUpdate('remove', imageSet.images);
	            }
	        });

	        //............................................ confEvent.leadChange
	        // Listen for a conference leadership change event.
	        $(document).on(confEvent.leadChange + namespace_, function (e, json) {
	            if (self.isInConference() == true) {
	                if (json == undefined) {
	                    (0, _toolbar.consoleWrite)('Error: confEvent.leadChange: json input undefined');
	                    return;
	                }
	                eventLog('recieved', confEvent.leadChange, json);
	                var newLeaderState = json.lead == true ? true : false;
	                if (bAmLeader_ != newLeaderState) {
	                    bAmLeader_ = newLeaderState;
	                    roleInit_(); // bind/unbind events depending upon leader/follower role
	                }
	            }
	        });

	        //............................................ confEvent.update
	        // Listen for a conference view change event and
	        //    If this is the conference leader, do nothing
	        //    If this is a conference follower, update the image views accordingly
	        //
	        // where json = {imageId: @NUM, x: baseCoordX, y: baseCoordY, zoom: viewZoom, angle: viewAngleDeg };
	        $(document).on(confEvent.update + namespace_, function (e, json) {
	            if (self.isConfLeader() == true) {
	                // nothing to do, actually won't even see this event
	            } else {
	                //todo: consider issuing an internal event (that checks if it is already at this pos,zoom,angle and if so does nothing)
	                if (json == undefined) {
	                    (0, _toolbar.consoleWrite)('Error: confEvent.update: json input undefined');
	                    return;
	                }
	                eventLog('recieved', confEvent.update, json);
	                var thisImg = uScope.getThisImageById(json.imageId); // thisImg is vp of the passed imageId to update

	                if (thisImg == undefined) {
	                    // open thisImg if it is not the currently opened image
	                    triggerConfEvent(confEvent.imageChange, { src: 'uScope', imageId: json.imageId });

	                    thisImg = uScope.getThisImage();
	                    if (thisImg == undefined) {
	                        // no image in view,
	                        var imageSet1 = { 'images': [{ 'imagePath': json.imageId, 'fullURL': json.imagePath }] }; //the image that is opening
	                        uScope.imageUpdate('add', imageSet1.images);

	                        thisImg = uScope.getThisImage(); // now reference to the newly opened image
	                        //debug-only  thisImg.log('....conf: new image opened: ' + json.imageId);
	                    } else {
	                        // uScope has an image, replace it with this one
	                        var imageId0 = thisImg.getImageId();
	                        var imageSet1 = { 'images': [{ 'imagePath': thisImg.getImageId() }] }; // the image that is closing
	                        // NOTE: the mess here is that 'imagePath' means the fullURL to the conference and it means the imageId to uScope.
	                        /////remove me //////    var imageSet2 = { 'images': [{ 'imagePath': json.imageId, 'fullURL': buildFULLURL_(json.imageId)}] }; //the image that is opening
	                        var imageSet2 = { 'images': [{ 'imagePath': json.imageId, 'fullURL': json.imagePath }] }; //the image that is opening

	                        uScope.imageUpdate('replace', imageSet1.images, imageSet2.images);

	                        thisImg = uScope.getThisImage(); // now reference to the newly opened image
	                        //debug-onlythisImg.log('....conf: current image ' + imageId0 + ' replaced by ' + json.imageId);
	                    }

	                    return; // note!  to prevent a race condition that the vp is not fully initialized and so cannot zoom or pan, get out now
	                }

	                if (thisImg) {
	                    // prevent race conditions (image switched and view or marker change followed fast before vp was initialized
	                    if (thisImg.isInitialized() == false) return;

	                    if (json.zoom && json.zoom !== thisImg.getViewZoom()) // update the view zoom if it has changed
	                        thisImg.zoomAbsolute(json.zoom);

	                    if (json.x && json.y) {
	                        var cpCenter = thisImg.getViewCenter(true); //xform coords?        // update the view center if it has changed
	                        var ptNewCenter = new _objects.cPoint(json.x, json.y);
	                        if (ptNewCenter.cityBlockDistance(cpCenter) > minViewMovePx_) thisImg.moveAbsolute(ptNewCenter.x - thisImg.getViewWidth() / 2, ptNewCenter.y - thisImg.getViewHeight() / 2, _defines2.default.coordSystemNORM);
	                    }
	                    if (json.z) {
	                        // todo: zstack position here
	                    }
	                    if (typeof json.angleDeg != 'undefined') {
	                        if (json.angleDeg !== thisImg.getViewAngle(true)) {
	                            // update the view rotation if it has changed
	                            thisImg.viewRotate(json.angleDeg);
	                        }
	                    }
	                    if (json.MarkerX && json.MarkerY) {
	                        // if a marker position is present
	                        if (json.MarkerX != confMarkerLT_.x || json.MarkerY != confMarkerLT_.y) {
	                            // and if it has changed
	                            confMarkerLT_.set(json.MarkerX, json.MarkerY); // then update the marker position
	                            (0, _events.triggerUScopeEvent)(CONSTANTS.CONFERENCE_MARKER_EVENT, json); // and fire event of conferencing follower's marker position update
	                        }
	                    }
	                } else {
	                    (0, _toolbar.consoleWrite)('... Error: conf: view change requested of image that is not opened: ' + json.imageId);
	                }
	            }
	        });

	        // Hide conferencing icon for pinned images, because only unpinned image is opened in a conference (and pinned are closed at start)
	        // This function was pulled from Annotations because yea it makes total sense for conferencing to be part of annotations. There's
	        // some kind of bleed over that we will need to decouple thought. TODO - reverse engineer what the hell is going on here and fix it.
	        var namespace = '.annotpanel';
	        var jRoot = $(_defines2.default.idHashROOT);
	        jRoot.on(_defines2.default.evIMAGESELECTED + namespace, function (e, parms) {
	            var thisImg = uScope.getThisImage();
	            (0, _toolbar.setIconState)($('#' + CONSTANTS.CREATE_BUTTON_ID), CONSTANTS.CREATE_BUTTON_ID, thisImg.isPinned() ? 'disabled' : 'enabled');
	        });
	    };
	    //............................................ buildFULLURL_() local //todo: may not be used in the future.. remove me?
	    var buildFULLURL_ = function buildFULLURL_(imageId) {
	        //imageId has leading @ sign
	        var rtnURL;
	        var fullURL = uScope.getFullURL(); //assumes a selected image
	        if (fullURL != undefined) {
	            var idx = fullURL.lastIndexOf('@');
	            if (idx > 0) rtnURL = fullURL.substr(0, idx) + imageId; // imageId has leading @ sign
	        }
	        return rtnURL;
	    };
	    //............................................ bindEventsOff_ local
	    //    This function is called when exiting a conference.
	    var bindEventsOff_ = function bindEventsOff_() {
	        $(_defines2.default.idHashROOT).off(namespace_);
	    };
	    //............................................ roleInit_ local
	    //    roleInit_ -  This function binds/unbinds events according to the conference participant's role.
	    //    Specifically the conference leader monitors uScope-internal events evVIEWCHANGE and evMOUSECHANGE
	    var roleInit_ = function roleInit_() {
	        eventLog('conf: roleInit_: as ' + (self.isConfLeader() == true ? 'Leader' : 'Follower'));
	        if (self.isConfLeader() == true) {

	            // enable the next/prev slide toolbar buttons
	            (0, _toolbar.setIconState)($('.' + _defines2.default.clsTBNEXTSLIDE), _defines2.default.clsTBNEXTSLIDE, 'enabled');
	            (0, _toolbar.setIconState)($('.' + _defines2.default.clsTBPREVSLIDE), _defines2.default.clsTBPREVSLIDE, 'enabled');

	            // as conference leader, listen for internal view change event and fire conference view event
	            $(_defines2.default.idHashROOT).on(_defines2.default.evIMAGEREADY, function (e, parms) {
	                (0, _toolbar.consoleWrite)('...... event: ' + _defines2.default.evIMAGEREADY + '  imageId: ' + parms.imageId);
	                if (sendOpenImage_(parms.imageId) == false) (0, _toolbar.consoleWrite)('conf: evIMAGEREADY event received but I cannot get thisImage: ' + parms.imageId);
	            });
	            $(_defines2.default.idHashROOT).on(_defines2.default.evIMAGECLOSE, function (e, parms) {
	                (0, _toolbar.consoleWrite)('...... event: ' + _defines2.default.evIMAGECLOSE + '  imageId: ' + parms.imageId);
	                var json = { 'src': 'uScope', 'imageId': parms.imageId };
	                eventLog('sending', confEvent.imageclose, json);
	                triggerConfEvent(confEvent.imageclose, json); // fire event to close image
	            });

	            (0, _events.triggerUScopeEvent)(CONSTANTS.CONFERENCE_MARKER_EVENT, { imageId: undefined }); // hide the conference marker, imageId == undefined hides the marker

	            // as conference leader, listen for internal view change event and fire conference view event
	            // us.evVIEWCHANGE
	            //            parms = {
	            //                imageId:    required, imageId of selected image
	            //                x:            required, view center X base coord in 'normal' graphics coord space
	            //                y:            required, view center Y base coord in 'normal' graphics coord space
	            //                zoom:        required, view zoom
	            //                angleDeg:    optional, rotation angle in degrees
	            //            };                $(us.idHashROOT).on(us.evVIEWCHANGE + namespace_, function (e, parms) {
	            $(_defines2.default.idHashROOT).on(_defines2.default.evVIEWCHANGE + namespace_, function (e, parms) {
	                // internal view change event
	                if (parms.desc == 'move' || parms.desc == 'zoom' || parms.desc == 'rotate') {
	                    parms.src = 'uScope';
	                    var thisImg = uScope.getThisImageById(parms.imageId);
	                    if (thisImg) {
	                        var json = {
	                            'src': 'uScope',
	                            'imageId': parms.imageId,
	                            'uScopeIdx': parms.uScopeIdx,
	                            'x': parms.x,
	                            'y': parms.y,
	                            'z': '',
	                            'zoom': parms.zoom,
	                            'angleDeg': parms.angleDeg,
	                            'imagePath': thisImg.getFullURL()
	                        };
	                        eventLog('sending', confEvent.view, json);
	                        triggerConfEvent(confEvent.view, json); // fire event that conferencing leader's view has changed
	                    } else {
	                        (0, _toolbar.consoleWrite)('conf: evVIEWCHANGE event received but I cannot get thisImage');
	                    }
	                }
	            });

	            // as conference leader, listen for internal mouse change event and fire conference marker event
	            // us.evMOUSECHANGE
	            //            parms = {
	            //                imageId:    required, imageId of selected image
	            //                x:            required, X base coord of marker
	            //                y:            required, Y base coord of marker
	            //            };
	            $(_defines2.default.idHashROOT).on(_defines2.default.evMOUSECHANGE + namespace_, function (e, parms) {
	                if (uScope.isThisImageValid()) {
	                    var thisImg = uScope.getThisImage();
	                    var json = {
	                        'src': 'uScope',
	                        'imageId': parms.imageId,
	                        'uScopeIdx': thisImg.getImageIdx(),
	                        'MarkerX': parms.x,
	                        'MarkerY': parms.y,
	                        'imagePath': thisImg.getFullURL()
	                    };
	                    eventLog('sending', confEvent.marker, json);
	                    triggerConfEvent(confEvent.marker, json); // fire event for VIL that conferencing leader's view has changed
	                }
	            });

	            //            ////////////////// temporary events for development prior to DST integration - single image operation ///////////////////
	            //            // temporarily force a view change event to be sent on by VIL to conf server and on to conf participants
	            //            if (uScope.isThisImageValid()) {
	            //                var thisImg = uScope.getThisImage();
	            //                eKey = jQuery.Event('', { type: 'keydown', which: us.keyCodes.arrowLeft }); // create keydown event
	            //                vpKeyEvent(eKey, thisImg);
	            //            }
	            //            ////////////////// temporary events for development prior to DST integration - single image operation ///////////////////
	        } else {
	            // is conference follower
	            // disable the next/prev slide toolbar buttons
	            (0, _toolbar.setIconState)($('.' + _defines2.default.clsTBNEXTSLIDE), _defines2.default.clsTBNEXTSLIDE, 'disabled');
	            (0, _toolbar.setIconState)($('.' + _defines2.default.clsTBPREVSLIDE), _defines2.default.clsTBPREVSLIDE, 'disabled');

	            // a conference follower does not listen to internal view change events
	            $(_defines2.default.idHashROOT).off(_defines2.default.evVIEWCHANGE + namespace_);

	            // a conference follower does not listen to internal mouse change events
	            $(_defines2.default.idHashROOT).off(_defines2.default.evMOUSECHANGE + namespace_);
	        }
	    };
	    //............................................ configure_ local
	    //    configure_ -  This function informs viewport that a conference is starting or stopping
	    //                    so that it can configure itself as necessary.
	    //    parameters:
	    //        inConference - required, boolen, true indicates joining conference;
	    //                                        false indicates exiting conference;

	    var configure_ = function configure_(inConference) {
	        var iScopeBtnExists = _defines2.default.SHOWALLTOOLBARICONS || uScope.toolbarCanAddButton('openImageScopeBtn');
	        if (inConference == true) {

	            triggerConfEvent(_defines2.default.evNAVMODEHALT, { uScopeIdx: -1 }); // fire event to halt navigation for all images

	            if (uScope.annotPanel) {
	                // Until annotations are supported during a conference,
	                uScope.annotPanel.enableDrawingIcons(false); // disable the annotation drawing tools
	                uScope.annotPanel.show(false); // close the annotation panel
	            }
	            if (uScope.toolbarCanAddButton('dscSetupBtn')) // give user feedback that conf is active by toolbar icon
	                (0, _toolbar.setIconState)($('#' + CONSTANTS.CREATE_BUTTON_ID), CONSTANTS.CREATE_BUTTON_ID, 'active');
	            if (iScopeBtnExists) // disable open-in-imagescope
	                (0, _toolbar.setIconState)($('#' + _defines2.default.TBISCOPE), _defines2.default.TBISCOPE, 'disabled');
	            // The following code to rotate to zero and uncheck the rotation check box is no longer needed now that rotation is supported during a conference -cb
	            //            if (us.ENABLEROTATION == true && uScope.visibilityPanel) {
	            //              triggerUScopeEvent(us.evIMAGEROTATE, { imageId: '@0', uScopeIdx: -1, angleDeg: 0 }); // fire event to rotate all images to 0
	            //                uScope.visibilityPanel.check(us.clsROTATIONDIV, false);
	            //            }
	            bindEvents_();
	        } else {
	            // not in conference
	            bindEventsOff_();
	            (0, _events.triggerUScopeEvent)(CONSTANTS.CONFERENCE_MARKER_EVENT, { imageId: undefined }); // hide the conference marker, imageId == undefined hides the marker

	            if (uScope.annotPanel) uScope.annotPanel.enableDrawingIcons(uScope.canAnnotate()); // set state of annotation drawing tools

	            if (uScope.toolbarCanAddButton('dscSetupBtn')) // change the toolbar icon to enabled if it is active
	                (0, _toolbar.setIconState)($('#' + CONSTANTS.CREATE_BUTTON_ID), CONSTANTS.CREATE_BUTTON_ID, 'enabled');
	            if (iScopeBtnExists) (0, _toolbar.setIconState)($('#' + _defines2.default.TBISCOPE), _defines2.default.TBISCOPE, 'enabled');

	            // enable the next/prev slide toolbar buttons
	            (0, _toolbar.setIconState)($('.' + _defines2.default.clsTBNEXTSLIDE), _defines2.default.clsTBNEXTSLIDE, 'enabled');
	            (0, _toolbar.setIconState)($('.' + _defines2.default.clsTBPREVSLIDE), _defines2.default.clsTBNEXTSLIDE, 'enabled');
	        }
	    };

	    //............................................ reportState public
	    this.reportState = function () {
	        var str = 'Not in conference';
	        if (this.isConfLeader()) str = 'Is conference leader';else if (this.isConfMember()) str = 'Is conference member';
	        return str;
	    };

	    //............................................ reset_ local
	    var reset_ = function reset_() {
	        bAmInConf_ = false;
	        ptName_ = 'ptName';
	        bAmLeader_ = false;
	        confMarkerLT_.set(0, 0);
	    };
	    //............................................ sendOpenImage_() local
	    var sendOpenImage_ = function sendOpenImage_(opt_imageId) {
	        var thisImg = opt_imageId == undefined ? uScope.getThisImage() : uScope.getThisImageById(opt_imageId);
	        if (thisImg) {
	            var imageId = thisImg.getImageId();
	            // send 'normal' graphics coords
	            var json = {
	                src: 'uScope',
	                imageId: thisImg.getImageId(),
	                uScopeIdx: thisImg.getImageIdx(),
	                'imagePath': thisImg.getFullURL(),

	                x: thisImg.getViewCenterX(true),
	                y: thisImg.getViewCenterY(true),
	                zoom: thisImg.getViewZoom(),
	                angleDeg: thisImg.getViewAngle(true),

	                MarkerX: thisImg.getViewCenterX(true),
	                MarkerY: thisImg.getViewCenterY(true) // initially place the marker at the image center
	            };
	            eventLog('sending', confEvent.openimage, json);
	            triggerConfEvent(confEvent.openimage, json); // fire event that the leader has opened an image
	            return true;
	        }
	        return false;
	    };
	    //............................................ construct_() local
	    var construct_ = function construct_() {
	        reset_();

	        //............................................ confEvent.join
	        var nspace = '.confStatic'; // these two events do not bind/unbind .....
	        // Listen for a conference join event.
	        $(document).on(confEvent.join + nspace, function (e, json) {

	            if (self.isInConference() == false) {
	                eventLog('recieved', confEvent.join, json);
	                configure_(true); // enable/disable for conferencing - must be done prior to setting state to 'in-conference'

	                ptName_ = json.userName;
	                bAmLeader_ = json.lead == true ? true : false;
	                bAmInConf_ = true;

	                if (bAmLeader_ == true) {
	                    uScope.closeAllButSelectedImage(); // close all but the currently selected image
	                    if (sendOpenImage_() == false) // if leader has an image open, send the openimage event
	                        (0, _toolbar.consoleWrite)('conf: leader: no image open yet');
	                }
	                roleInit_(); // bind/unbind events depending upon leader/follower role
	            }
	        });
	        //............................................ confEvent.exit
	        // Listen for a conference exit event.
	        $(document).on(confEvent.exit + nspace, function (e, json) {
	            if (self.isInConference() == true) {
	                eventLog('received', confEvent.exit, json);
	                reset_(); //
	                configure_(false); //
	            }
	        });
	    };

	    //............................................ construction
	    construct_();
	}
	module.exports = exports['default'];

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = ConferenceMarker;

	var _defines = __webpack_require__(3);

	var _defines2 = _interopRequireDefault(_defines);

	var _objects = __webpack_require__(7);

	var _constants = __webpack_require__(38);

	var CONSTANTS = _interopRequireWildcard(_constants);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function ConferenceMarker(viewport) {
	    var jVpDiv = viewport.vpDivGet();
	    var jConfMarker;

	    var cpOffset = new _objects.cPoint(0, 0);

	    //............................................ move_local
	    //    This function positions the conference marker offset from the current cursor
	    //    or can hide the marker.  CoordSystem of marker is us.coordSystemNORM
	    var move_ = function move_(xBase, yBase) {
	        if (jConfMarker == undefined) return;
	        var cpLT = viewport.getViewLeftTop(_defines2.default.coordSystemNORM);
	        var zoom = viewport.getViewZoom();
	        var x = Math.floor((xBase - cpLT.x) / zoom - cpOffset.x);
	        var y = Math.floor((yBase - cpLT.y) / zoom - cpOffset.y);
	        jConfMarker.css({ 'left': x + 'px', 'top': y + 'px' });
	    };
	    //............................................ load_() local
	    //    This function loads the conference marker
	    var load_ = function load_() {
	        if (jConfMarker) return; // if this viewport already has a marker, return

	        // first create an offscreen div that will contain the marker img and add it to the vp
	        jConfMarker = $('<div/>', { // build the div tag that contains the img tag
	            'class': _defines2.default.clsDIVMARKER, // dsc marker class sets its own z-index
	            css: { 'left': _defines2.default.kDEF_TILE_POS_PX, 'top': _defines2.default.kDEF_TILE_POS_PX }
	        });
	        jVpDiv.append(jConfMarker); // place the marker div in the vp
	        jConfMarker = jVpDiv.find('.' + _defines2.default.clsDIVMARKER);

	        cpOffset.x = Math.floor(jConfMarker.width() / 2); // define marker's offset from cursor
	        cpOffset.y = Math.floor(jConfMarker.height() / 2);
	        //viewport.log("confMarker: load: offset from cursor: " + cpOffset.toString());

	        bindEvents_(); // add event handlers

	        //..................................................
	        // closure functions
	        //............................................ bindEvents_()
	        function bindEvents_() {
	            var namespace = viewport.eventNameSpaceGet();

	            // show/hide conference marker of conference leader/follower
	            $(_defines2.default.idHashROOT).on(CONSTANTS.CONFERENCE_MARKER_EVENT + namespace, function (e, parms) {
	                //viewport.log("conf marker: CONSTANTS..CONFERENCE_MARKER_EVENT recvd: " + toStringAssoc(parms));
	                if (viewport.getImageId() == parms.imageId) // move marker on the matching image
	                    move_(parms.MarkerX, parms.MarkerY);else // hide the marker on non-matching images
	                    jConfMarker.css({ 'left': _defines2.default.kDEF_TILE_POS_PX, 'top': _defines2.default.kDEF_TILE_POS_PX });
	            });
	        }
	        //..................................................
	    };
	    //............................................ construction

	    load_(); // load the conference marker image
	}
	module.exports = exports['default'];

/***/ },
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	__webpack_require__(46);

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _imageToolbar = __webpack_require__(47);

	var _imageToolbar2 = _interopRequireDefault(_imageToolbar);

	var _publicApi = __webpack_require__(18);

	var _publicApi2 = _interopRequireDefault(_publicApi);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var loader = {
	    name: 'us:image-adjust-ui',

	    extends: 'viewport',

	    constructor: function (_ImageToolbar) {
	        _inherits(ImageToolbarHack, _ImageToolbar);

	        function ImageToolbarHack(uScope, viewport) {
	            _classCallCheck(this, ImageToolbarHack);

	            // HACK ALERT - mutating the viewport
	            var _this = _possibleConstructorReturn(this, (ImageToolbarHack.__proto__ || Object.getPrototypeOf(ImageToolbarHack)).call(this, uScope, viewport));

	            viewport.toolbar = _this;
	            return _this;
	        }

	        return ImageToolbarHack;
	    }(_imageToolbar2.default)
	};

	_publicApi2.default.plugins.register(loader);

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = ImageToolbar;

	var _defines = __webpack_require__(3);

	var _defines2 = _interopRequireDefault(_defines);

	var _objects = __webpack_require__(7);

	var _toolbar = __webpack_require__(5);

	var _events = __webpack_require__(10);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	//-------------------------------------------------------------------------------------------------
	//    IMAGE TITLE TOOLBAR OBJECT
	//
	//    Each image has an associated toolbar in its top left corner containing:
	//        Active Buttons
	//            - a close button
	//            - possibly the previous and next slide buttons
	//        Indicators
	//            - an icon indicating the sample is a positive or negative control, if applicable
	//            - an icon indicating the image is pinned, if applicable
	//

	function ImageToolbar(uScope, viewport) {
	    var self = this;
	    var isLoaded = false; // image tooblar has been loaded

	    var jVpDiv = viewport.vpDivGet('outer');
	    var jToolbar;
	    var jToolbarStateDiv;
	    var spacerWidth_;
	    var jCloseIcon;
	    var jPinnedIcon;
	    var jControlIcon;
	    var jPrevSlideIcon;
	    var jNextSlideIcon;

	    //............................................ pinnedSet() public
	    this.isPinnedSet = function () {
	        //viewport.log("isPinnedSet:  isPinned: " + viewport.isPinned() + "  sampleTypeIsControl:" + viewport.sampleTypeIsControl());
	        if (viewport.sampleTypeIsControl() == false) {
	            // no need to show pinned when is a control sample
	            if (viewport.isPinned()) jPinnedIcon.show();else jPinnedIcon.hide();
	            showStateDiv_(); // show/hide the state indicator div
	        } else {
	            jPinnedIcon.hide();
	        }
	    };
	    //............................................ sampleTypeSet() public
	    // This function hides or (shows and sets) the sample type icon
	    this.sampleTypeSet = function () {
	        if (viewport.sampleTypeIsControl() == false) {
	            jControlIcon.hide();
	        } else {
	            jControlIcon.removeClass(_defines2.default.clsTBCONTROL + '-p').removeClass(_defines2.default.clsTBCONTROL + '-n');
	            jControlIcon.addClass(getControlClass_());
	            jControlIcon.attr('title', getControlTip_());
	            jControlIcon.show();
	        }

	        nextPrevSlideSet_(); // show/hide the next slide, previous slide buttons
	        showStateDiv_(); // show/hide the state indicator div
	    };

	    //............................................ nextPrevSlideSet() public
	    // This function shows/disables/hides the next slide and previous slide buttons
	    var nextPrevSlideSet_ = function nextPrevSlideSet_() {
	        if (viewport.sampleTypeIsControl() == true // control slides don't show prev/next slide on the image's toolbar
	        || viewport.isPinned() == true // pinned slides don't either
	        || uScope.toolbarCanAddButton('nextPrevSlide') == false) {
	            jPrevSlideIcon.hide();
	            jNextSlideIcon.hide();
	        } else {

	            if (uScope.isConfMember() == true) {
	                // disable the buttons if in conference as follower
	                // TODO: Create some kind of "read-only" mode in uScope and use it to eliminate coupling between
	                // TODO: ITB and Conferencing and vice-versa
	                (0, _toolbar.setIconState)($('.' + _defines2.default.clsTBPREVSLIDE), _defines2.default.clsTBPREVSLIDE, 'disabled');
	                (0, _toolbar.setIconState)($('.' + _defines2.default.clsTBNEXTSLIDE), _defines2.default.clsTBNEXTSLIDE, 'disabled');
	            } else {
	                // enable and show the buttons
	                (0, _toolbar.setIconState)($('.' + _defines2.default.clsTBPREVSLIDE), _defines2.default.clsTBPREVSLIDE, 'enabled');
	                (0, _toolbar.setIconState)($('.' + _defines2.default.clsTBNEXTSLIDE), _defines2.default.clsTBNEXTSLIDE, 'enabled');
	                jPrevSlideIcon.show();
	                jNextSlideIcon.show();
	            }
	        }
	    };
	    //............................................ getOffsetRect() public
	    this.getOffsetRect = function () {
	        var pos = jToolbar.offset();
	        var rect = uScope.rootRectGet();
	        var rtnOffset = new _objects.cRect(pos.left - rect.x, pos.top - rect.y, jToolbar.width(), jToolbar.height());
	        //debug-only viewport.log("imageToolbar: rootRect: " + rect.toString());
	        //debug-only viewport.log("imageToolbar: getOffsetRect: " + pos.left + "," + pos.top + "  root left: " + rect.x + "    offset rect: " + rtnOffset.toString());

	        return rtnOffset;
	    };
	    //............................................ showStateDiv_() local
	    //    If only the spacer bar is displayed on the state indicator div, hide the div
	    var showStateDiv_ = function showStateDiv_() {
	        if (jToolbarStateDiv.width() > spacerWidth_) jToolbarStateDiv.show();else jToolbarStateDiv.hide();
	    };
	    //............................................ getControlClass_() local
	    var getControlClass_ = function getControlClass_() {
	        var ext = '-o';
	        var type = viewport.sampleTypeGet();
	        if (type == 'positive') ext = '-p';else if (type == 'negative') ext = '-n';

	        return _defines2.default.clsTBCONTROL + ext;
	    };
	    //............................................ getControlTip_() local
	    var getControlTip_ = function getControlTip_() {
	        var type = viewport.sampleTypeGet();
	        if (type == 'positive') return 'Image is a Positive Control';else if (type == 'negative') return 'Image is a Negative Control';

	        return '';
	    };
	    //............................................ bindEvents_() local
	    // bindEvents_ - This function adds the image toolbar event handlers.
	    //
	    //    Note that by using the same namespace as the viewport when the
	    //    viewport removes its events by namespace, these are also removed.

	    var bindEvents_ = function bindEvents_() {
	        var namespace = viewport.eventNameSpaceGet();

	        jCloseIcon.on('click' + namespace, function (e) {
	            if (uScope.getImageCount() > 1) (0, _events.triggerUScopeEvent)(_defines2.default.evIMAGECLOSE, { imageId: viewport.getImageId() });
	            return false;
	        });
	        jVpDiv.on('click' + namespace, '.' + _defines2.default.clsTBNEXTSLIDE + '-e', function (e) {
	            (0, _events.triggerUScopeEvent)(_defines2.default.evOPENNEXTSLIDE, {});
	            return false;
	        });
	        jVpDiv.on('click' + namespace, '.' + _defines2.default.clsTBPREVSLIDE + '-e', function (e) {
	            (0, _events.triggerUScopeEvent)(_defines2.default.evOPENPREVSLIDE, {});
	            return false;
	        });

	        $(_defines2.default.idHashROOT).on(_defines2.default.evIMAGEUPDATE, function (e, parms) {
	            // set close button icon to enabled if > 1 image open
	            (0, _toolbar.setIconState)(jCloseIcon, _defines2.default.clsTBCLOSEIMAGE, uScope.getImageCount() == 1 ? 'disabled' : 'enabled');
	            nextPrevSlideSet_(); // disable the next/prev slide buttons if in conference as a member
	        });
	    };

	    //............................................ init_() local
	    //    init_ = This function creates the toolbar, sizes it and adds its event handlers.
	    var init_ = function init_() {
	        jToolbar = $('<div/>', { 'class': _defines2.default.clsIMAGETOOLBAR + ' ' + _defines2.default.clsTRANSPARENT });

	        //toconsider: an image title
	        //        var title = viewport.getTitle();
	        //        if (title && title.length > 0) jToolbar.text(title);

	        // action buttons .....................................
	        jToolbar.append($('<a/>', {
	            'class': _defines2.default.clsTBCLOSEIMAGE + (uScope.getImageCount() == 1 ? '-d' : '-e') // set close button icon to enabled if > 1 image open
	            + ' ' + _defines2.default.clsTBCLOSEIMAGE + ' ' + _defines2.default.clsIMAGETOOLBARBTN, 'title': 'Close this image'
	        }));

	        // because slide state can change from patient to a control in which case the next/prev slide button is hidden,
	        // always load the buttons and hide them if the slide is a control via nextPrevSlideSet_()
	        jToolbar.append($('<a/>', {
	            'class': _defines2.default.clsTBPREVSLIDE + ' ' + _defines2.default.clsTBPREVSLIDE + '-e' + ' ' + _defines2.default.clsIMAGETOOLBARBTN,
	            'title': 'Open the previous slide in the tray (keyboard: q, Q)'
	        }));
	        jToolbar.append($('<a/>', {
	            'class': _defines2.default.clsTBNEXTSLIDE + ' ' + _defines2.default.clsTBNEXTSLIDE + '-e' + ' ' + _defines2.default.clsIMAGETOOLBARBTN,
	            'title': 'Open the next slide in the tray (keyboard: e, E)'
	        }));

	        //status indicators .....................................
	        jVpDiv.append(jToolbar); // place the toolbar div in the vp
	        jToolbar.append($('<div/>', { 'class': _defines2.default.clsIMAGETOOLBARSTATE }));
	        jToolbarStateDiv = jToolbar.find('.' + _defines2.default.clsIMAGETOOLBARSTATE);

	        jToolbarStateDiv.append($('<div/>', { 'class': _defines2.default.clsIMAGETOOLBARSPC + ' ' + _defines2.default.clsIMAGETOOLBARBTN }));
	        spacerWidth_ = jToolbarStateDiv.width(); //save

	        jToolbarStateDiv.append($('<a/>', {
	            'class': _defines2.default.clsTBPINNED + ' ' + _defines2.default.clsIMAGETOOLBARBTN,
	            'title': 'Status: Image is Pinned Open'
	        }));
	        jToolbarStateDiv.append($('<a/>', {
	            'class': _defines2.default.clsTBCONTROL + ' ' + getControlClass_() + ' ' + _defines2.default.clsIMAGETOOLBARBTN,
	            'title': 'Status: Image is a Positive Control'
	        }));

	        jCloseIcon = jToolbar.find('.' + _defines2.default.clsTBCLOSEIMAGE);
	        jPrevSlideIcon = jToolbar.find('.' + _defines2.default.clsTBPREVSLIDE + '-e');
	        jNextSlideIcon = jToolbar.find('.' + _defines2.default.clsTBNEXTSLIDE + '-e');

	        jPinnedIcon = jToolbarStateDiv.find('.' + _defines2.default.clsTBPINNED);
	        jControlIcon = jToolbarStateDiv.find('.' + _defines2.default.clsTBCONTROL);

	        self.sampleTypeSet(); // update the status of sampleType
	        self.isPinnedSet(); // update the status of pinned
	        bindEvents_(); // add event handlers
	        isLoaded = true;
	    };

	    //............................................ construction
	    init_();
	}
	module.exports = exports['default'];

/***/ },
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	__webpack_require__(55);

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _performanceMeterControl = __webpack_require__(56);

	var _performanceMeterControl2 = _interopRequireDefault(_performanceMeterControl);

	var _performanceTest = __webpack_require__(57);

	var _performanceTest2 = _interopRequireDefault(_performanceTest);

	var _publicApi = __webpack_require__(18);

	var _publicApi2 = _interopRequireDefault(_publicApi);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var tileMeterLoader = {
	    name: 'us:tile-meter',

	    extends: 'viewport',

	    constructor: function HackPerformanceTools(uScope, viewport) {
	        _classCallCheck(this, HackPerformanceTools);

	        // Polluting the viewport is a temp hack till I find a better way of handling however this is used.
	        viewport.tileMeter = new _performanceMeterControl2.default(uScope, viewport);

	        uScope.events.on('uScope:command:log-settings', function (log) {
	            log('--- enabled: Performance Meter');
	        });
	    }
	};

	var performanceTesterLoader = {
	    name: 'us:performance-tester',

	    extends: 'viewport',

	    constructor: function HackPerformanceTools(uScope, viewport) {
	        _classCallCheck(this, HackPerformanceTools);

	        var tester = new _performanceTest2.default(uScope, viewport);
	        // Polluting the viewport is a temp hack till I find a better way of handling however this is used.
	        viewport.getPerfTestObj = function () {
	            return tester;
	        };
	    }
	};

	_publicApi2.default.plugins.register(tileMeterLoader);
	_publicApi2.default.plugins.register(performanceTesterLoader);

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = PerformanceMeterControl;

	var _lodashLite = __webpack_require__(9);

	var _ = _interopRequireWildcard(_lodashLite);

	var _defines = __webpack_require__(3);

	var _defines2 = _interopRequireDefault(_defines);

	var _helpers = __webpack_require__(8);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	var defaults = {
	    layout: { 'divClass': _defines2.default.clsDIVGUAGES, 'precinct': 'BR', 'order': 4 }
	};

	function PerformanceMeterControl(uScope, viewport) {
	    var self = this;

	    var isLoaded = false; // performance meter has been "loaded"
	    var layout = _.clone(defaults.layout);

	    var jVpDiv = viewport.vpDivGet('outer');
	    var jGuagesDiv;
	    var jGuageTiles; // jq object to tile meter guage
	    var jGuageTilesParent;
	    var jBars;
	    var jGuageRefresh; // jq object to view refresh guage
	    var circRefTimes = (0, _helpers.circBuffer)(3); // circular buffer of view refresh times in milli-seconds

	    var prefVisibleDef = false; // tile meter visibility preference default
	    var prefVisibleCur = prefVisibleDef;

	    // ................................... settings
	    var bEnableHiding = true; // default true, useful when doing timetests to inhibit hiding
	    var showReadOut = false; // display the tile time (msec) - really more for development, not user

	    var timerId_ = -1; // the hide meter timer id
	    var maxBarCount = 20; // the number of bars drawn in the tile meter
	    var barTime = 100; // each bar in tile meter represent this much time in msec
	    var maxTime = maxBarCount * barTime; // max tile time the meter can display - clip longer tile times
	    var prevBarCount = maxBarCount; // previous tileUpdate() bar count

	    var blueToOrange_ = ['#2a339c', '#224797', '#2a60aa', '#216d9f', '#1c6a9a', '#068300', '#2c9600', '#46a300', '#5eaf00', '#7abd00', '#91c800', '#abd500', '#c3e100', '#d7eb00', '#f3f900', '#fff500', '#ffdd00', '#ffc100', '#ffa900', '#ff9300'];
	    var greenToRed_ = ['#068300', '#2c9600', '#46a300', '#5eaf00', '#7abd00', '#91c800', '#abd500', '#c3e100', '#d7eb00', '#f3f900', '#fff500', '#ffdd00', '#ffc100', '#ffa900', '#ff9300', '#ff7a00', '#ff5a00', '#F74a00', '#ff2a00', '#ff1a00'];

	    //............................................ show() public
	    // the tile meter shows/hides itself as tiles are returned and tileUpdate is called
	    // this function's show/hide relates to the tile meter's visibility
	    // when its visiblity is set false the tile meter does not update
	    self.show = function (show) {
	        //debug-only viewport.log("tilemeter show(" + show + ")" + "   prefVisibleCur: " + prefVisibleCur);

	        if (uScope.prefGet(_defines2.default.clsDIVGUAGES) == false) // prevent show if preference is not to show
	            show = false;

	        //todo: only need to do this once, say the selected image does it
	        if (prefVisibleCur != show && uScope.getReqQueueObj()) {
	            // inform the request queue on visibility change
	            uScope.getReqQueueObj().showTileMeter(show); // toconsider: rework ... this is entanglement!
	        }
	        prefVisibleCur = show; // save preference state for quick access
	        resetHideMeterTimer_(); // and reset the hide-meter timer
	    };

	    //............................................ tileUpdate() public
	    //    This function updates the tile meter.
	    //
	    //    inputs:
	    //        millisecs:        the current tile load time
	    //        strReqType:        the purpose of the tile request, either "refresh" or "prefetch"
	    //
	    //    Note: since this is inside the critical refresh view loop, make it as efficient as possible
	    self.tileUpdate = function (millisecs, strReqType) {
	        if (isLoaded == false || prefVisibleCur == false) {
	            return;
	        }
	        // debug-only viewport.log("tilemeter: tileUpdate: Tile time (ms): " + millisecs);

	        clearInterval(timerId_); // stop the clear-this-meter timer

	        var backColor = strReqType == 'refresh' ? '#a2b4c4' : '#C2D6D6';
	        jGuageTiles.css('background-color', backColor); // adjust back color to visually distinguish refresh tiles from prefetch tiles

	        if (millisecs > maxTime || millisecs < 0) // clip the time displayed to the meter's limit
	            millisecs = maxTime;
	        var curBarCount = Math.floor(millisecs / barTime); // comute the number of bars to be shown

	        var diff = prevBarCount - curBarCount;

	        var method = diff > 0 ? 'hide' : 'show';
	        for (var c = curBarCount + 1; c < prevBarCount + 1; c++) {
	            $(jBars[c])[method]();
	        }

	        prevBarCount = curBarCount;

	        if (showReadOut == true) // if enabled to show numeric read out, do so
	            jGuageTilesParent.text(millisecs);

	        if (jGuagesDiv.is(':visible') == false) {
	            setVisibility(true);
	        } else {
	            resetHideMeterTimer_();
	        }
	    };

	    //............................................ viewUpdate() public
	    self.viewUpdate = function (millisecs, count) {
	        if (_defines2.default.ENABLEREFRESHMETER == false || prefVisibleCur == false || isLoaded == false) {
	            return;
	        }
	        //debug-only viewport.log("    view refresh meter: " + count + " tiles . . . . " + millisecs + " (ms)");

	        // update the refresh view meter text
	        jGuageRefresh.text(' ' + count + ' tiles . . . . ' + millisecs + ' (ms)');

	        if (showReadOut == true) {
	            // if enabled, also show the avg view time
	            circRefTimes.push(millisecs); // update the average view refresh time
	            jGuageRefresh.parent().find('.' + _defines2.default.clsGUAGEVIEWTEXT).text(circRefTimes.getAvgInt());
	        }
	    };

	    var resetHideMeterTimer_ = function resetHideMeterTimer_() {
	        if (bEnableHiding == true) {
	            timerId_ = setTimeout( // start the clear-this-meter timer
	            function () {
	                setVisibility(false); // now hide the meter
	                clearInterval(timerId_); // stop the clear-this-meter timer
	                //viewport.log("tilemeter: resetHideMeterTimer_: hidden for 2 seconds");
	            }, 2000);
	        }
	    };
	    //............................................ setVisibility()
	    //    This function forces the visibilty of the tilemeter.
	    //
	    //    parameters:
	    //        opt_bVisible:    if undefined then the default visibility is used to show/hide the tilemeter
	    var setVisibility = function setVisibility(opt_bVisible) {
	        if (opt_bVisible == undefined) opt_bVisible = prefVisibleCur;
	        //debug-only viewport.log("tilemeter setVisible(" + opt_bVisible + ")");
	        if (opt_bVisible == true) jGuagesDiv.show();else jGuagesDiv.hide();
	    };
	    //............................................ load_() local
	    //    This function loads a panel that can contain multiple meters.
	    //    Currently it contains a meter for average tile response time.
	    var load_ = function load_() {
	        if (jGuagesDiv) return;

	        jGuagesDiv = $('<div/>', { // build the guage container div
	            'class': _defines2.default.clsDIVGUAGES + ' ' + _defines2.default.clsOVERLAY + ' ' + _defines2.default.clsTRANSPARENT,
	            css: { 'left': _defines2.default.kDEF_TILE_POS_PX, 'top': _defines2.default.kDEF_TILE_POS_PX }
	        });
	        jVpDiv.append(jGuagesDiv); // place the guages div in the vp
	        jGuagesDiv = jVpDiv.find('.' + _defines2.default.clsDIVGUAGES);

	        // ................................................. add the view refresh time
	        if (_defines2.default.ENABLEREFRESHMETER == true) {
	            jGuageRefresh = $('<div/>', {
	                'class': _defines2.default.clsDIVGUAGE + ' ' + _defines2.default.clsGUAGEREF + ' ' + _defines2.default.clsGUAGETEXT,
	                'title': 'View Refresh Time'
	            }); // build a guage div
	            jGuagesDiv.append(jGuageRefresh);
	            if (showReadOut == true) // if enabled to show numeric read out, add its div
	                jGuagesDiv.append($('<div/>', {
	                    'class': _defines2.default.clsGUAGEVIEWTEXT + ' ' + _defines2.default.clsGUAGETEXT,
	                    text: '',
	                    'title': 'Average View Refresh Time in milliseconds'
	                }));
	        }

	        // ................................................. add the average tile load time meter
	        jGuagesDiv.append('<div class=\'guagedivider\'></div>');

	        var jAvgGuage = $('<div/>', {
	            'class': _defines2.default.clsDIVGUAGE + ' ' + _defines2.default.clsGUAGETILES,
	            'title': 'Tile load time meter'
	        }); // build a guage div
	        var barColors = blueToOrange_;
	        jGuagesDiv.append(jAvgGuage);

	        for (var c = 0; c < maxBarCount; c++) {
	            // build each bar and append to the guage
	            $('<div/>', { 'class': _defines2.default.clsGUAGECELL, css: { 'background-color': barColors[c] } }).appendTo(jAvgGuage);
	        }
	        jGuageTiles = jVpDiv.find('.' + _defines2.default.clsGUAGETILES); // save for quick access
	        jBars = jGuageTiles.find('.' + _defines2.default.clsGUAGECELL); // save for quick access

	        if (showReadOut == true) {
	            // if enabled to show numeric read out, add its div
	            jGuagesDiv.append($('<div/>', {
	                'class': _defines2.default.clsGUAGETILETEXT + ' ' + _defines2.default.clsGUAGETEXT,
	                text: '',
	                'title': 'Tile Load Time in milliseconds'
	            }));
	            var w = jGuagesDiv.width();
	            jGuagesDiv.width(w + 30);
	            jGuageTilesParent = jGuageTiles.parent().find('.' + _defines2.default.clsGUAGETILETEXT); // save for quick access
	        }
	        // .................................................
	        isLoaded = true;

	        viewport.overLayout.add(layout); // and call into layout with parms to place the div
	        jGuagesDiv.click(); // initiate live binding to draggable
	        self.show(uScope.prefGet(_defines2.default.clsDIVGUAGES));

	        bindEvents_();

	        //..................................................
	        // closure functions
	        //............................................ bindEvents_()
	        // bindEvents_ - This function adds the rotation dial event handlers.
	        //
	        //    Note that by using the same namespace as the viewport when the
	        //    viewport removes its events by namespace, these are also removed.

	        function bindEvents_() {
	            var namespace = viewport.eventNameSpaceGet();

	            // user preference update
	            $(_defines2.default.idHashROOT).on(_defines2.default.evUSERPREFSREADY + namespace, function (e, parms) {
	                //viewport.log("tile meter us.evUSERPREFSREADY recvd: " + uScope.prefGet(us.clsDIVGUAGES));
	                self.show(uScope.prefGet(_defines2.default.clsDIVGUAGES));
	            });
	            $(_defines2.default.idHashROOT).on(_defines2.default.evUSERPREFSET + namespace, function (e, parms) {
	                // parms: {className: STR, value: bool}
	                if (parms.className == _defines2.default.clsDIVGUAGES) {
	                    //viewport.log("tile meter us.evUSERPREFSET recvd: " + uScope.prefGet(us.clsDIVGUAGES));
	                    self.show(parms.value);
	                }
	            });
	            $(_defines2.default.idHashROOT).on(_defines2.default.evUSERPREFDEFAULTVISIBLE + namespace, function (e, parms) {
	                //viewport.log("tile meter us.evUSERPREFDEFAULTVISIBLE recvd: " + prefVisibleDef);
	                uScope.prefSet(_defines2.default.clsDIVGUAGES, prefVisibleDef);
	            });
	        }

	        //..................................................
	    };

	    if (bEnableHiding == false) {
	        viewport.log('Tile meter hiding is disabled!');
	    }

	    load_();
	}
	module.exports = exports['default'];

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = PerformanceTest;

	var _defines = __webpack_require__(3);

	var _defines2 = _interopRequireDefault(_defines);

	var _compatibility = __webpack_require__(6);

	var _publicApi = __webpack_require__(18);

	var _publicApi2 = _interopRequireDefault(_publicApi);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	//  This file contains uScope's built in performance test

	//todo: note that this needs to be updated

	function PerformanceTest(uScope, viewport) {
	    var self = this;

	    var testNumber = 0;
	    var testStep = 0;
	    var testName = '';
	    var stepStartTime_ms = 0;
	    var stepStopTime_ms = 0;
	    var stepReport = '';
	    var testReport = '';

	    var testTime = 0;
	    var testDeltaTime = 0;

	    var useRecorded = true;
	    var fixedInterval_ms = 0;

	    var running = false;
	    this.isRunning = function () {
	        return running;
	    };

	    var imgWidth = 1000,
	        imgHeight = 10000,
	        imgBaseMag = 20; // image under test


	    //............................................ getTestNames
	    this.getTestNames = function () {
	        var nameList = [];
	        for (var i = 0; i < perfTests.length; i++) {
	            nameList.push(perfTests[i].name);
	        }
	        return nameList;
	    };
	    //............................................ getTestReport
	    this.getTestReport = function () {
	        return testReport;
	    };

	    //............................................ run
	    this.run = function (testNum, doRecorded, interval_ms) {
	        if (running == true) return this.stop(); // if called while running, stop now.
	        if (testNum < 0 || testNum > perfTests.length - 1) return false;
	        if (doRecorded == false && interval_ms < 100) return false;

	        running = true;
	        testNumber = testNum;
	        useRecorded = doRecorded;
	        fixedInterval_ms = interval_ms;
	        testName = perfTests[testNumber].name;
	        testStep = stepStartTime_ms = stepStopTime_ms = 0;
	        stepReport = '';

	        ///cp---!!! I think the get tile counts below should be examined....

	        var now = new Date(); // initialize the first row of test report
	        testReport = ',,,,,,,, OS, browser,  view wxh, tiles/view, username, image filename, filetype, req quality, test date, test time\n';
	        testReport += 'test, step, interval, action, xpos, ypos, mag, time' + ', ' + _compatibility.BrowserDetect.OS + ', ' + _compatibility.BrowserDetect.browser + ' ' + _compatibility.BrowserDetect.version + ', ' + viewport.vpDivGet().width() + 'x' + viewport.vpDivGet().height() + ', ' + viewport.getVisibleTileCount() * _defines2.default.kTILEMULTIPLIER * _defines2.default.kTILEMULTIPLIER // normalize to file tile count
	        + ', ' + uScope.getUserName() + ', ' + viewport.getFileName() + ',' + viewport.getFileTypeDesc() + ',' + uScope.prefGet('imageQuality') + ', ' + now.getFullYear() + '/' + (1 + now.getMonth()) + '/' + now.getDate() + ', ' + now.toLocaleTimeString() + '\n';

	        if (_defines2.default.DBGPERFTEST == true) {
	            var len = perfTests[testNumber].sequence.length;
	            if (doRecorded) viewport.log('running: ' + perfTests[testNumber].name + ' nSteps: ' + len + ' recorded intervals: ' + doRecorded);else viewport.log('running: ' + perfTests[testNumber].name + ' nSteps: ' + len + ' fixed intervals: ' + interval_ms + ' msec');
	            viewport.log(testReport);
	        }

	        imgWidth = viewport.getImageWidth();
	        imgHeight = viewport.getImageHeight();
	        imgBaseMag = viewport.getBaseMag();

	        setTimeout(function () {
	            self.perfTestThread();
	        }, 0);
	        return running;
	    };

	    //............................................ refreshComplete
	    this.refreshComplete = function () {
	        stepStopTime_ms = new Date();
	    };
	    //............................................ stop
	    this.stop = function () {
	        running = false;
	        return running;
	    };
	    //............................................ perfTestThread
	    this.perfTestThread = function () {
	        if (running == false) return; // if running has been stopped, get out now

	        if (testStep > 0) {
	            // if not just starting then report on the prior step
	            var stepTime_ms = stepStopTime_ms != 0 ? stepStopTime_ms - stepStartTime_ms : 0;
	            stepReport += ',' + stepTime_ms; // update prior step report
	            testReport += stepReport + '\n'; // update test report

	            stepStopTime_ms = 0; // stepStopTime_ms equal to 0 indicates the prior step never completed
	            if (_defines2.default.DBGPERFTEST == true) viewport.log('perfTestThread: ' + stepReport);
	        }

	        var sequence = perfTests[testNumber].sequence; // get the new test step's parms
	        if (testStep == sequence.length) {
	            // if there's no more steps to process
	            running = false; // then the run is complete
	            $('#' + _defines2.default.idPTESTRUNBTN).text('Run');
	            sendPerfReport(testReport);
	            if (_defines2.default.DBGPERFTEST == true) viewport.log('Test Report:\n' + testReport);
	            return;
	        }

	        var state = sequence[testStep]; // if necessary, de-normalize the position and magnification for the current image
	        var isNormalized = perfTests[testNumber].isNormalized;
	        if (state.mag != 'Fit') {
	            var xpos = isNormalized == true ? parseInt(state.centerX * imgWidth) : state.centerX;
	            var ypos = isNormalized == true ? parseInt(state.centerY * imgHeight) : state.centerY;
	            var mag = isNormalized == true ? viewport.convertToMag(state.zoom) : state.mag;
	        } else {
	            var mag = viewport.getFitMag();
	            var xpos = parseInt(imgWidth / 2);
	            var ypos = parseInt(imgHeight / 2);
	        }

	        var now = new Date(); // get the current time and the time between this and the last call
	        testDeltaTime = testStep == 0 ? testDeltaTime = 0 : testDeltaTime = now - testTime;
	        testTime = now;
	        // form the test step report
	        var dx = viewport.getViewCenterX() - xpos;
	        var dy = viewport.getViewCenterY() - ypos;
	        var dist = parseInt(Math.sqrt(dx * dx + dy * dy));
	        var action = state.desc == 'zoom' ? state.desc + '_' + mag + 'x' : state.desc + '_' + dist;
	        stepReport = testName + ',' + testStep + ',' + testDeltaTime + ',' + action + ',' + xpos + ',' + ypos + ',' + mag;

	        var dTime = fixedInterval_ms; // trigger the timeout to return to this function for the next step
	        if (++testStep < sequence.length && useRecorded == true) dTime = sequence[testStep].dTime;
	        setTimeout(function () {
	            self.perfTestThread();
	        }, dTime);

	        if (uScope.getToken()) // initialize this test step's settings
	            var imgSettings = {
	                'image': {
	                    'imagePath': viewport.getImageId(),
	                    'fullURL': viewport.getFullURL(),
	                    'x': xpos,
	                    'y': ypos,
	                    'mag': mag
	                }
	            };else var imgSettings = { 'image': { 'imagePath': viewport.getImageId(), 'x': xpos, 'y': ypos, 'mag': mag } };

	        stepStartTime_ms = new Date(); // initialize this test step's start time
	        _publicApi2.default.navigateTo(imgSettings); // and execute this test step
	    };

	    //............................................ reporting
	    var sendPerfReport = function sendPerfReport(perfData) {
	        var perfDataXHR;
	        var createXHRObj = function createXHRObj() {
	            var xhr = null;
	            if (window.XMLHttpRequest) {
	                xhr = new XMLHttpRequest();
	            } else {
	                if (window.ActiveXObject) {
	                    try {
	                        xhr = new window.ActiveXObject('Microsoft.XMLHTTP');
	                    } catch (e) {
	                        return null;
	                    }
	                }
	            }
	            return xhr;
	        };

	        var respHandler = function respHandler() {
	            //output response XML to debug div
	            if (perfDataXHR.readyState == 4) {
	                //debug-only
	                //if (perfDataXHR.status == 200)     viewport.log('sendPerfReport succeeded');
	                //else                             viewport.log('sendPerfReport failed');
	            }
	        };

	        perfDataXHR = createXHRObj();
	        if (perfDataXHR) {
	            perfDataXHR.open('POST', window.location.protocol + '//' + window.location.host + '/uScopePerfDataLog.php?Id=' + Math.floor(Math.random() * 10000), true);
	            perfDataXHR.setRequestHeader('Content-type', 'text/xml');
	            // perfDataXHR.setRequestHeader("Connection", "open"); // JavaScript doesn't allow this!
	            perfDataXHR.onreadystatechange = respHandler;
	            perfDataXHR.send(perfData);
	        }
	    };

	    //............................................ construction
	    var perfTests = []; // array containing performance tests

	    var addState = function addState(sequence, time, desc, centerX, centerY, zoom, mag) {
	        var state = { 'time': time, 'desc': desc, 'centerX': centerX, 'centerY': centerY, 'zoom': zoom, 'mag': mag };
	        sequence.push(state);
	    };
	    var finishSequence = function finishSequence(sequence) {
	        sequence[0].dTime = 0;
	        for (var s = 1; s < sequence.length; s++) {
	            // add time between sequence steps
	            sequence[s].dTime = (sequence[s].time - sequence[s - 1].time).toFixed(2);
	        }
	    };
	    var stateToString = function stateToString(state) {
	        //cp-use state vector string function?
	        var str = '';
	        if (state.dTime != undefined) str += 'dTtime: ' + state.dTime + ' ';
	        str += 'time: ' + state.time + ' desc: ' + state.desc + ' centerX: ' + state.centerX + ' centerY: ' + state.centerY + ' zoom: ' + state.zoom + ' mag: ' + state.mag;
	        return str;
	    };
	    //cp-want to convert centers to proportion of image.... what about zoom?  document scan mag, file name, image size,

	    // create a test
	    // note that the sequence parameters below are the output of cStateVector reportAll()

	    // create a test
	    var sequence2 = []; // create a test sequence
	    addState(sequence2, 0, 'zoom', 0.70, 0.30, 5, 4);
	    addState(sequence2, 3000, 'zoom', 0.70, 0.30, 2, 10);
	    addState(sequence2, 9000, 'zoom', 0.70, 0.30, 1, 20);
	    addState(sequence2, 12000, 'move', 0.30, 0.50, 1, 20);
	    addState(sequence2, 15000, 'zoom', 0.30, 0.50, 2, 10);
	    addState(sequence2, 18000, 'zoom', 0.30, 0.50, 5, 4);
	    addState(sequence2, 21000, 'zoom', 0.50, 0.50, 'Fit', 'Fit');
	    addState(sequence2, 24000, 'zoom', 0.20, 0.40, 5, 4);
	    addState(sequence2, 27000, 'zoom', 0.20, 0.40, 2, 10);
	    addState(sequence2, 30000, 'zoom', 0.20, 0.40, 1, 20);
	    finishSequence(sequence2);
	    var test2 = {
	        'name': 'Zooms',
	        'sequence': sequence2,
	        'isNormalized': true,
	        'file': '21287_Her2.svs',
	        'width': 52833,
	        'height': 43975
	    };
	    perfTests.push(test2);

	    // create a test
	    var sequence3 = []; // create a test sequence
	    //                 time, desc, centerX, centerY, zoom, mag
	    addState(sequence3, 0, 'move', 0.25, 0.25, 1, 20);
	    addState(sequence3, 3000, 'move', 0.50, 0.25, 1, 20);
	    addState(sequence3, 9000, 'move', 0.75, 0.25, 1, 20);
	    addState(sequence3, 12000, 'move', 0.25, 0.50, 1, 20);
	    addState(sequence3, 15000, 'move', 0.50, 0.50, 1, 20);
	    addState(sequence3, 18000, 'move', 0.75, 0.50, 1, 20);
	    addState(sequence3, 21000, 'move', 0.25, 0.75, 1, 20);
	    addState(sequence3, 24000, 'move', 0.50, 0.75, 1, 20);
	    addState(sequence3, 27000, 'move', 0.75, 0.75, 1, 20);

	    addState(sequence3, 30000, 'move', 0.75, 0.75, 2, 10);
	    addState(sequence3, 33000, 'move', 0.50, 0.75, 2, 10);
	    addState(sequence3, 36000, 'move', 0.25, 0.75, 2, 10);
	    addState(sequence3, 39000, 'move', 0.75, 0.50, 2, 10);
	    addState(sequence3, 42000, 'move', 0.50, 0.50, 2, 10);
	    addState(sequence3, 45000, 'move', 0.25, 0.50, 2, 10);
	    addState(sequence3, 48000, 'move', 0.75, 0.25, 2, 10);
	    addState(sequence3, 51000, 'move', 0.50, 0.25, 2, 10);
	    addState(sequence3, 54000, 'move', 0.25, 0.25, 2, 10);

	    addState(sequence3, 54000, 'move', 0.25, 0.25, 1, 20);
	    finishSequence(sequence3);
	    var test3 = {
	        'name': 'Move and Zoom',
	        'sequence': sequence3,
	        'isNormalized': true,
	        'file': '21287_Her2.svs',
	        'width': 52833,
	        'height': 43975
	    };
	    perfTests.push(test3);

	    // create a test
	    var sequence4 = []; // create a test sequence
	    //                 time, desc, centerX, centerY, zoom, mag
	    addState(sequence4, 1256, 'zoom', 0.42882, 0.46179, 10, 2);
	    addState(sequence4, 1756, 'move', 0.14639, 0.32251, 10, 2);
	    addState(sequence4, 4561, 'move', 0.26676, 0.31813, 10, 2);
	    addState(sequence4, 4848, 'move', 0.37787, 0.32251, 10, 2);
	    addState(sequence4, 5426, 'zoom', 0.44905, 0.36069, 5, 4);
	    addState(sequence4, 5880, 'zoom', 0.49176, 0.38362, 2, 10);
	    addState(sequence4, 6437, 'move', 0.49639, 0.37484, 2, 10);
	    addState(sequence4, 6757, 'move', 0.48250, 0.36164, 2, 10);
	    addState(sequence4, 7141, 'move', 0.50566, 0.34404, 2, 10);
	    addState(sequence4, 7460, 'zoom', 0.51989, 0.35166, 1, 20);
	    addState(sequence4, 7884, 'move', 0.53379, 0.33408, 1, 20);
	    addState(sequence4, 8313, 'move', 0.52453, 0.32528, 1, 20);
	    addState(sequence4, 8795, 'zoom', 0.39639, 0.25654, 10, 2);
	    addState(sequence4, 9101, 'move', 0.51676, 0.26532, 10, 2);
	    addState(sequence4, 9433, 'move', 0.52139, 0.31813, 10, 2);
	    addState(sequence4, 9705, 'move', 0.63713, 0.29612, 10, 2);
	    addState(sequence4, 10034, 'move', 0.63250, 0.34891, 10, 2);
	    addState(sequence4, 10358, 'zoom', 0.74639, 0.41003, 2, 10);
	    addState(sequence4, 10857, 'move', 0.75103, 0.38802, 2, 10);
	    addState(sequence4, 11410, 'zoom', 0.63713, 0.32691, 10, 2);
	    addState(sequence4, 11786, 'move', 0.53529, 0.56887, 10, 2);
	    addState(sequence4, 12058, 'move', 0.47974, 0.56887, 10, 2);
	    addState(sequence4, 12296, 'move', 0.41029, 0.57327, 10, 2);
	    addState(sequence4, 12656, 'move', 0.35937, 0.53368, 10, 2);
	    addState(sequence4, 12963, 'zoom', 0.43055, 0.57187, 5, 4);
	    addState(sequence4, 13437, 'move', 0.39813, 0.57187, 5, 4);
	    addState(sequence4, 13564, 'move', 0.43518, 0.57627, 5, 4);
	    addState(sequence4, 13848, 'zoom', 0.47789, 0.59920, 2, 10);
	    addState(sequence4, 14421, 'move', 0.45474, 0.60360, 2, 10);
	    addState(sequence4, 14687, 'move', 0.45474, 0.59920, 2, 10);
	    addState(sequence4, 14941, 'zoom', 0.46897, 0.60683, 1, 20);
	    addState(sequence4, 15416, 'zoom', 0.34084, 0.53808, 10, 2);
	    addState(sequence4, 15617, 'move', 0.35011, 0.52048, 10, 2);
	    addState(sequence4, 15777, 'move', 0.24361, 0.55569, 10, 2);
	    addState(sequence4, 15971, 'move', 0.34084, 0.59527, 10, 2);
	    addState(sequence4, 16116, 'move', 0.38250, 0.63046, 10, 2);
	    addState(sequence4, 16276, 'move', 0.47511, 0.63926, 10, 2);
	    addState(sequence4, 16483, 'move', 0.56768, 0.62606, 10, 2);
	    addState(sequence4, 16713, 'move', 0.61400, 0.57767, 10, 2);
	    addState(sequence4, 16867, 'move', 0.44268, 0.72726, 10, 2);
	    addState(sequence4, 17226, 'zoom', 0.51387, 0.76544, 5, 4);
	    addState(sequence4, 17455, 'move', 0.54166, 0.74784, 5, 4);
	    finishSequence(sequence4);
	    var test4 = {
	        'name': 'Pathologist Sequence 1',
	        'sequence': sequence4,
	        'isNormalized': true,
	        'file': 'Breast ER20x.svs',
	        'width': 38000,
	        'height': 39990
	    };

	    perfTests.push(test4);
	}
	module.exports = exports['default'];

/***/ },
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	__webpack_require__(79);

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _zoomSliderControl = __webpack_require__(80);

	var _zoomSliderControl2 = _interopRequireDefault(_zoomSliderControl);

	var _zoomButtonsControl = __webpack_require__(81);

	var _zoomButtonsControl2 = _interopRequireDefault(_zoomButtonsControl);

	var _publicApi = __webpack_require__(18);

	var _publicApi2 = _interopRequireDefault(_publicApi);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var zoomButtonLoader = {
	    name: 'us:zoom-button',

	    extends: 'viewport',

	    constructor: function (_ZoomButtonsControl) {
	        _inherits(hackZoomButton, _ZoomButtonsControl);

	        function hackZoomButton(uScope, viewport) {
	            _classCallCheck(this, hackZoomButton);

	            // Polluting the viewport is a temp hack till I find a better way of handling however this is used.
	            var _this = _possibleConstructorReturn(this, (hackZoomButton.__proto__ || Object.getPrototypeOf(hackZoomButton)).call(this, uScope, viewport));

	            viewport.zoomButton = _this;

	            // insure that the zoom button light reflects the initial state
	            _this.lightButton();

	            uScope.events.on('uScope:command:log-settings', function (log) {
	                log('--- enabled: Zoom!');
	            });
	            return _this;
	        }

	        return hackZoomButton;
	    }(_zoomButtonsControl2.default)
	};

	var zoomSliderLoader = {
	    name: 'us:zoom-slider',

	    extends: 'viewport',

	    dependencies: ['us:zoom-button'], // TODO: Remove this dependency.

	    constructor: function (_ZoomSliderControl) {
	        _inherits(hackZoomSlider, _ZoomSliderControl);

	        function hackZoomSlider(uScope, viewport) {
	            _classCallCheck(this, hackZoomSlider);

	            // Polluting the viewport is a temp hack till I find a better way of handling however this is used.
	            var _this2 = _possibleConstructorReturn(this, (hackZoomSlider.__proto__ || Object.getPrototypeOf(hackZoomSlider)).call(this, uScope, viewport));

	            viewport.zoomSlider = _this2;
	            return _this2;
	        }

	        return hackZoomSlider;
	    }(_zoomSliderControl2.default)
	};

	_publicApi2.default.plugins.register(zoomButtonLoader);
	_publicApi2.default.plugins.register(zoomSliderLoader);

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = ZoomSliderControl;

	var _defines = __webpack_require__(3);

	var _defines2 = _interopRequireDefault(_defines);

	var _lodashLite = __webpack_require__(9);

	var _ = _interopRequireWildcard(_lodashLite);

	var _helpers = __webpack_require__(8);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var defaults = {
	    layout: { 'divClass': _defines2.default.clsDIVZOOMSLIDER, 'precinct': 'BL', 'rightOffset': 12, 'order': 0 }
	};

	function ZoomSliderControl(uScope, viewport) {
	    var self = this;
	    var isLoaded = false; // zoom slider has been loaded

	    var jVpDiv = viewport.vpDivGet('outer');
	    var jZoomSliderDiv;

	    var prefVisibleDef = true; // zoom slider visibility preference default

	    var navModesImHiddenIn = {}; // what navigation modes not to display the zoom slider control

	    var layout = _.clone(defaults.layout); // zoom slider layout info, clone the global set so I can modify it
	    var reLayout = viewport.overLayout.refreshPrecinct;

	    //............................................ construct_ local
	    var construct_ = function construct_() {
	        if (_defines2.default.ENABLEZOOMCTL == false || _defines2.default.ENABLEZOOMSLIDER == false) return;
	        if (_defines2.default.DOVERTICALZOOMCTL == false) {
	            viewport.log('Slider control not coded for horizontal yet!');
	            return;
	        }

	        navModesImHiddenIn[_defines2.default.eNavModes.nmRasterScan] = true; // hide zoom slider in rasterscan mode
	        _defines2.default.setAnnotNavModes(navModesImHiddenIn); // hide zoom slider when drawing any annotation

	        load_(); // load the zoom slider
	    };
	    //............................................ show() public
	    this.show = function (show) {
	        if (isLoaded == false) return;

	        // prevent show if preference is not to show
	        if (uScope.prefGet(_defines2.default.clsDIVZOOMSLIDER, prefVisibleDef) == false) jZoomSliderDiv.hide();else if (show == true) jZoomSliderDiv.show();else jZoomSliderDiv.hide();

	        reLayout(layout.precinct); // layout just this overlay's precinct
	    };

	    //............................................ enable() public
	    //    This function enables the zoom slider control which is disabled when the slider stops
	    //    to prevent slider changes while image is being resolved.
	    this.enable = function () {
	        if (isLoaded == false) return;
	        if (jZoomSliderDiv.is(':visible') == true) jZoomSliderDiv.slider('enable');
	    };
	    //............................................ step() public
	    //    This function steps the zoom up/down within the range and quantization of the slider.
	    this.step = function (step) {
	        _defines2.default.navModeSwitch(viewport, _defines2.default.eNavModes.nmSmoothZoom);

	        var mag = viewport.getViewMag();
	        step = 1 + step;
	        mag = constrainMag(mag * step);
	        var zoom = viewport.convertToZoom(mag);

	        viewport.zoomAbsolute(zoom);
	    };

	    //............................................ constrainMag
	    // constrainMag - This function constrains the image magnfication to the fit to allowable mag range.
	    var constrainMag = function constrainMag(mag) {
	        if (mag > viewport.getMaximumMag()) mag = viewport.getMaximumMag();else if (mag < viewport.getFitMag()) mag = viewport.getFitMag();
	        return mag;
	    };

	    //............................................ load_() local
	    //    This function builds the zoom slider control and calls into the layout manager
	    //         to position it according to its layout settings.
	    //    Note that the sizing of the slider uses the fixed zoom control so it must be created first.
	    //    Note that the bottom of the slider is value 0 and the top is its max value.
	    //
	    //    references:
	    //        http://jqueryui.com/demos/slider/#slider-vertical
	    var load_ = function load_() {
	        if (jZoomSliderDiv) return; // if this viewport already has a zoom slider, return
	        if (jVpDiv.find('.' + _defines2.default.clsDIVZOOMCTL).length === 0) {
	            // if this viewport does NOT already have a FIXED zoom control, return
	            viewport.log('vpLoadZoomSlider(' + viewport.getImageId() + '): Fixed zoom control not present, cannot create slider.');
	            return;
	        }

	        // first create an offscreen div that will contain the zoom slider
	        jZoomSliderDiv = $('<div/>', { // build the div tag that contains the zoom slider
	            'class': _defines2.default.clsDIVZOOMSLIDER + ' ' + _defines2.default.clsOVERLAY, // overlay class sets the z-index
	            css: { 'left': _defines2.default.kDEF_TILE_POS_PX, 'top': _defines2.default.kDEF_TILE_POS_PX }
	        });

	        jZoomSliderDiv.slider({ // create the slider associated with this div
	            orientation: 'vertical',
	            range: 'min',
	            min: _defines2.default.zoomSpecs.sliderMin,
	            max: _defines2.default.zoomSpecs.sliderMax,
	            value: 0,
	            start: function start(event, ui) {
	                _defines2.default.navModeSwitch(viewport, _defines2.default.eNavModes.nmSmoothZoom);
	                if (_defines2.default.DBGZOOMCTL) viewport.log('slider start: STOP PF');
	            },
	            slide: function slide(event, ui) {
	                // catch the slide event only to update the handle's text
	                var jHandle = $(ui.handle);
	                var maxVal = $(this).slider('option', 'max');
	                var value = $(this).slider('value');
	                var zoom = sliderValToZoom_(maxVal, value);
	                zoom = _defines2.default.helpers.roundToDecimals(zoom); // keep zoom in proper resolution
	                if (zoom !== viewport.getViewZoom()) {
	                    var mag = viewport.convertToMag(zoom); // display the latest mag
	                    jHandle.text(mag + 'x');
	                    //if (us.DBGZOOMCTL) viewport.log("Slider slide " + value + "  mag: " + viewport.convertToMag(zoom) + "  zoom: " + zoom );
	                    viewport.zoomAbsolute(zoom); // execute the zoom
	                }
	            },
	            stop: function stop(event, ui) {
	                // catch the stop event to zoom the view
	                // TODO - Verify. (cc) `zoom` is undefined and unused in this context.
	                // zoom = us.helpers.roundToDecimals(viewport.getViewZoom());     // keep zoom in proper resolution
	                //if (us.DBGZOOMCTL) viewport.log("Slider reads " + $(this).slider("value") + "  mag: " + viewport.convertToMag(zoom) + "  zoom: " + zoom);

	                viewport.setCursor('wait'); // set the cursor to wait state
	                _defines2.default.navModeHalt(viewport);
	                viewport.zoomAbsolute(viewport.getViewZoom());
	            }
	        });

	        var zoomHeight = jVpDiv.find('.' + _defines2.default.clsDIVZOOMCTL).height(); //get the height of the zoom button control
	        var btnHeight = jVpDiv.find('.' + _defines2.default.clsDIVZOOMBTN).height();
	        jZoomSliderDiv.height(zoomHeight - 2 * btnHeight); // set the slider height relative to the fixed zoom control

	        var hWidth = jVpDiv.find('.' + _defines2.default.clsDIVZOOMBTNS).width(); // desired handle width is the width of the fixed zoom control
	        var barWidth = Math.max(jZoomSliderDiv.width(), 9); // IE bar width is reported as 0 so insure there's a reasonable offset here
	        var leftOffset = -Math.ceil((hWidth - barWidth) / 2);

	        var jHandle = jZoomSliderDiv.find('.ui-slider-handle'); // set the width of the slider handle
	        jHandle.css({ 'left': leftOffset + 'px' });

	        jVpDiv.append(jZoomSliderDiv); // place the zoom slider div in the vp
	        jZoomSliderDiv = jVpDiv.find('.' + _defines2.default.clsDIVZOOMSLIDER); // save for quick access

	        layout.bottomOffset = btnHeight; // set the slider bottom offset to be about the middle of the fixed zoom control's bottom btn
	        viewport.overLayout.add(layout); // and call into layout with parms to place the div

	        isLoaded = true;
	        self.update(); // update the text and position of the zoom slider handle
	        self.show(true); // show/hide according to user preferences

	        bindEvents_(); // add event handlers
	        return;

	        //..................................................
	        // closure functions
	        //............................................ bindEvents_()
	        // bindEvents_ - This function adds the zoom slider control event handlers.
	        //
	        //    Note that by using the same namespace as the viewport when the
	        //    viewport removes its events by namespace, these are also removed.

	        function bindEvents_() {
	            var namespace = viewport.eventNameSpaceGet();

	            // show/hide zoom buttons on mode change
	            $(_defines2.default.idHashROOT).on(_defines2.default.evMODECHANGE + namespace, function (e, parms) {
	                // show is true if this is the image selected and not in a mode that I'm supposed to hide during
	                var bshow = viewport.getImageIdx() == uScope.getSelImageIdx() && navModesImHiddenIn[parms.navMode] == undefined ? true : false;
	                self.show(bshow);
	            });

	            $(_defines2.default.idHashROOT).on(_defines2.default.evZOOMCHANGE + namespace, function (e, parms) {
	                if (viewport.getImageId() == parms.imageId) {
	                    self.update();
	                }
	            });

	            // show/hide zoom slider
	            $(_defines2.default.idHashROOT).on(_defines2.default.evIMAGESELECTED + namespace, function (e, parms) {
	                self.show(parms.uScopeIdx == viewport.getImageIdx());
	            });

	            // user preference update
	            $(_defines2.default.idHashROOT).on(_defines2.default.evUSERPREFSREADY + namespace, function (e, parms) {
	                //viewport.log("zoomSlider us.evUSERPREFSREADY recvd:  " + uScope.prefGet(us.clsDIVZOOMSLIDER));
	                self.show(uScope.prefGet(_defines2.default.clsDIVZOOMSLIDER));

	                reLayout(layout.precinct); // layout just this overlay's precinct
	            });
	            $(_defines2.default.idHashROOT).on(_defines2.default.evUSERPREFSET + namespace, function (e, parms) {
	                // parms: {className: STR, value: bool}
	                if (parms.className == _defines2.default.clsDIVZOOMSLIDER) {
	                    //viewport.log("zoomSlider us.evUSERPREFSET recvd: " + uScope.prefGet(us.clsDIVZOOMSLIDER));
	                    self.show(parms.value);
	                }
	            });
	            $(_defines2.default.idHashROOT).on(_defines2.default.evUSERPREFDEFAULTVISIBLE + namespace, function (e, parms) {
	                //viewport.log("zoomSlider us.evUSERPREFDEFAULTVISIBLE recvd:" + prefVisibleDef);
	                uScope.prefSet(_defines2.default.clsDIVZOOMSLIDER, prefVisibleDef);
	            });

	            // mouse, ...
	            jZoomSliderDiv.on('mousedown' + namespace, function (e) {
	                viewport.setImageSelected(); // inform uScope that this image is in focus
	                return false; // prevent propigation to VP
	            });
	            jZoomSliderDiv.on('mouseleave' + namespace, function (e) {
	                return false; // prevent propigation to VP
	            });
	            jZoomSliderDiv.on('mousemove' + namespace + ' mouseup' + namespace, function (e) {
	                return true; // propigate necessary for slider operation
	            });
	        }
	    };
	    //............................................ update() local
	    //    This function updates the text and position of the zoom slider handle.
	    //        magValue: optional, if passed used as the magnfication value, otherwise the current view magnification is used
	    this.update = function (magValue) {
	        if (_defines2.default.ENABLEZOOMSLIDER == false) return;
	        if (jZoomSliderDiv === undefined) return;
	        var mag = (0, _helpers.isDefined)(magValue) ? magValue : viewport.getViewMag();

	        var jHandle = jZoomSliderDiv.find('.ui-slider-handle'); // set the mag on the slider handle
	        jHandle.text(mag + 'x');

	        var maxVal = $(jZoomSliderDiv).slider('option', 'max'); // and position the handle along the slider
	        var value = sliderMagToVal_(maxVal, mag);
	        $(jZoomSliderDiv).slider('value', value);
	    };
	    //............................................ sliderMagToVal_() local
	    //    This function converts a passed magnification to the zoom slider's value.
	    var sliderMagToVal_ = function sliderMagToVal_(maxVal, mag) {
	        var value = Math.ceil(maxVal * Math.sqrt(mag / viewport.getMaximumMag()));
	        value = maxVal - value;
	        if (_defines2.default.DBGZOOMCTL) viewport.log('sliderMagToVal_: mag: ' + mag + '  value: ' + value);
	        return value;
	    };
	    //............................................ sliderValToZoom_() local
	    //    This function converts the current zoom slider value to its zoom.
	    var sliderValToZoom_ = function sliderValToZoom_(maxVal, value) {
	        value = maxVal - value;
	        if (value > maxVal - 2) value = maxVal; // this control has a hard time reaching 0 (so when reversed it doesn't reach max)

	        // compute the magnification for this slider position
	        var mag = (value / maxVal * (value / maxVal) * viewport.getMaximumMag()).toFixed(1);
	        if (mag < viewport.getFitMag()) mag = viewport.getFitMag();
	        if (mag > viewport.getMaximumMag()) mag = viewport.getMaximumMag();
	        var zoom = viewport.convertToZoom(mag); // compute the zoom
	        if (_defines2.default.DBGZOOMCTL) viewport.log('sliderValToZoom_: value: ' + value + '  mag: ' + mag + '  zoom: ' + zoom);
	        return zoom;
	    };

	    //............................................ construction
	    construct_();
	}
	module.exports = exports['default'];

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = ZoomButtonsControl;

	var _defines = __webpack_require__(3);

	var _defines2 = _interopRequireDefault(_defines);

	var _lodashLite = __webpack_require__(9);

	var _ = _interopRequireWildcard(_lodashLite);

	var _compatibility = __webpack_require__(6);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var defaults = {
	    layout: { 'divClass': _defines2.default.clsDIVZOOMCTL, 'precinct': 'BL', 'order': 1 }
	};

	function ZoomButtonsControl(uScope, viewport) {
	    var self = this;
	    var isLoaded = false; // zoom button control has been loaded

	    var jVpDiv = viewport.vpDivGet('outer');
	    var jZoomCtlDiv;
	    var jZoomButtons;
	    var jZoomButton;

	    var prefVisibleDef = true; // zoom button visibility preference default

	    var navModesImHiddenIn = {}; // what navigation modes not to display the zoom control

	    var layout = _.clone(defaults.layout); // zoom button layout info, clone the global set so I can modify it
	    var reLayout = viewport.overLayout.refreshPrecinct;

	    //............................................ construct_ local
	    var construct_ = function construct_() {
	        if (_defines2.default.ENABLEZOOMCTL == false) return;

	        navModesImHiddenIn[_defines2.default.eNavModes.nmRasterScan] = true; // hide zoom buttons in rasterscan mode
	        _defines2.default.setAnnotNavModes(navModesImHiddenIn); // hide zoom buttons when drawing any annotation

	        load_(); // load the zoom button control
	    };

	    //............................................ show() public
	    this.show = function (show) {
	        if (isLoaded == false) return;
	        // prevent show if preference is not to show
	        if (uScope.prefGet(_defines2.default.clsDIVZOOMCTL, prefVisibleDef) == false) jZoomCtlDiv.hide();else if (show == true) jZoomCtlDiv.show();else jZoomCtlDiv.hide();

	        reLayout(layout.precinct); // layout just this overlay's precinct
	    };
	    //............................................ lightButton() public
	    // This function lights the zoom button according to the zoom of the image
	    //    If the image's zoom is not one of the zoom button values, all buttons are un-lit.
	    //
	    //    This function is necessary because the zoom control buttons must un-light if the current zoom
	    //    is not a fixed zoom and because they must light if any of the means to change the zoom other
	    //    than the zoomButton control changes the zoom. Also, in multi-image clicking a zoom button
	    //    on one image seems to clear the active setting on all zoom buttons.
	    //
	    //    improvements: This just doesn't seem to be the best way to resolve the issues,
	    //            possible rework http://api.jquery.com/val/

	    this.lightButton = function () {
	        if (_defines2.default.ENABLEZOOMCTL == false) return;

	        jZoomButton.removeClass('ui-state-active'); // remove active state from all buttons
	        var zoom = viewport.getViewZoom();
	        var fixedZooms = viewport.getFixedZoomArray();
	        for (var z = 0, len = fixedZooms.length; z < len; z++) {
	            // find the index in the fixed zoom array of this zoom
	            if (fixedZooms[z].zoom == zoom) {
	                // if found, there is an associated zoom button
	                var jLabel = jZoomButton[2 * z + 1]; // get the label associated with this zoom
	                $(jLabel).addClass('ui-state-active'); // and add the active state to it
	                ///if (us.DBGZOOMCTL) viewport.log("lightButton: match found mag of " + fixedZooms[z].mag);
	                break;
	            }
	        }
	        if (z === fixedZooms.length) {
	            // if the zoom is none of the fixed mags
	            jZoomButton.removeClass('ui-state-active'); // remove active state from all buttons
	            ///if (us.DBGZOOMCTL) viewport.log("lightButton: zoom of " + zoom + " not a fixed zoom button value.");
	        }
	    };

	    //............................................ load_() local
	    var load_ = function load_() {
	        if (jZoomCtlDiv) return;

	        // first create an offscreen div that will contain the zoom control
	        jZoomCtlDiv = $('<div/>', { // build the div tag that contains the zoom control
	            'class': _defines2.default.clsDIVZOOMCTL + ' ' + _defines2.default.clsOVERLAY, // overlay class sets the z-index
	            css: { 'left': _defines2.default.kDEF_TILE_POS_PX, 'top': _defines2.default.kDEF_TILE_POS_PX }
	        });

	        jZoomButtons = $('<div/>', { 'class': _defines2.default.clsDIVZOOMBTNS }); // zoom button container div

	        if (_compatibility.BrowserDetect.isIOS()) // ios make buttons bigger by increasing the font for ios
	            jZoomButtons.addClass('ios');

	        var fixedZooms = viewport.getFixedZoomArray();
	        for (var l = 0, zlen = fixedZooms.length; l < zlen; l++) {
	            var id = 'zoom' + l + Math.random().toString().replace('.', ''); // generate a unique id for each zoom button
	            jZoomButton = $('<input/>', { 'class': _defines2.default.clsDIVZOOMBTN, 'type': 'radio', 'id': id, 'name': 'radio' });

	            var mag = l == 0 ? 'Fit' : fixedZooms[l].mag;
	            var color = _defines2.default.objectiveColor(mag); // get color related to this magnification
	            //debug-only viewport.log(l + " " + color);

	            var text = l == 0 ? 'Fit' : mag + 'x'; // set label text
	            if (l == fixedZooms.length - 1) {
	                // initially check the first mag //cp-maybe an option - match with initial zoom state in vpView
	                jZoomButton.attr('checked', 'checked');
	                //    viewport.log("zoomButtons: load: check button: "+ l);
	            }
	            // the zoom button label is either a numeric mag like "1.25x" or it is"Fit"
	            var jZoomLabel = $('<label/>', { 'class': _defines2.default.clsDIVZOOMBTN, 'for': id, 'text': text });

	            var jElement = _defines2.default.DOVERTICALZOOMCTL == true ? $('<div/>') : $('<span/>');
	            if (_defines2.default.DOZOOMCOLOR) jElement.css({ 'border-left': '4px solid', 'border-color': color }); // left bar color code
	            jElement.append(jZoomButton); // add this button to the div
	            jElement.append(jZoomLabel); // add this label to the div
	            jZoomButtons.append(jElement); // add the div to the button container
	        }
	        jZoomCtlDiv.append(jZoomButtons); // add the button container to the zoom control

	        jVpDiv.append(jZoomCtlDiv); // place the zoom control div in the vp
	        jZoomButtons = jVpDiv.find('.' + _defines2.default.clsDIVZOOMBTNS);
	        jZoomButton = jVpDiv.find('.' + _defines2.default.clsDIVZOOMBTN);

	        jZoomButtons.buttonset(); // initialize the buttonset
	        viewport.overLayout.add(layout); // and call into layout with parms to place the div

	        isLoaded = true;
	        self.show(true); // show/hide according to user preferences
	        bindEvents_(); // add event handlers
	        return;

	        //..................................................
	        // closure functions
	        //............................................ bindEvents_()
	        // bindEvents_ - This function adds the zoom button control event handlers.
	        //
	        //    Note that by using the same namespace as the viewport when the
	        //    viewport removes its events by namespace, these are also removed.

	        function bindEvents_() {
	            var namespace = viewport.eventNameSpaceGet();

	            // show/hide zoom buttons on mode change
	            $(_defines2.default.idHashROOT).on(_defines2.default.evMODECHANGE + namespace, function (e, parms) {
	                // show is true if this is the image selected and not in a mode that I'm supposed to hide during
	                var bshow = viewport.getImageIdx() == uScope.getSelImageIdx() && navModesImHiddenIn[parms.navMode] == undefined ? true : false;
	                self.show(bshow);
	            });
	            $(_defines2.default.idHashROOT).on(_defines2.default.evZOOMCHANGE + namespace, function (e, parms) {
	                if (viewport.getImageId() == parms.imageId) {
	                    self.lightButton();
	                }
	            });

	            // show/hide zoom buttons if image is selected/not-selected
	            $(_defines2.default.idHashROOT).on(_defines2.default.evIMAGESELECTED + namespace, function (e, parms) {
	                self.show(parms.uScopeIdx == viewport.getImageIdx());
	            });
	            // user preference update
	            $(_defines2.default.idHashROOT).on(_defines2.default.evUSERPREFSREADY + namespace, function (e, parms) {
	                //viewport.log("zoomButtons us.evUSERPREFSREADY recvd");
	                self.show(uScope.prefGet(_defines2.default.clsDIVZOOMCTL));
	            });
	            $(_defines2.default.idHashROOT).on(_defines2.default.evUSERPREFSET + namespace, function (e, parms) {
	                // parms: {className: STR, value: bool}
	                if (parms.className == _defines2.default.clsDIVZOOMCTL) {
	                    //viewport.log("zoomButtons us.evUSERPREFSET recvd");
	                    self.show(parms.value);
	                }
	            });
	            $(_defines2.default.idHashROOT).on(_defines2.default.evUSERPREFDEFAULTVISIBLE + namespace, function (e, parms) {
	                //viewport.log("zoomButtons us.evUSERPREFDEFAULTVISIBLE recvd");
	                uScope.prefSet(_defines2.default.clsDIVZOOMCTL, prefVisibleDef);
	            });

	            // mouse, ...
	            jZoomButton.on('mousedown' + namespace + ' mousemove' + namespace + '  mouseup' + namespace + '  mouseleave' + namespace, function (e) {
	                return false; // because these events propigate to the vp and starts dragging, etc the image, intercept them
	            });
	            jZoomButton.on('click' + namespace, function (e) {
	                //viewport.log("Zoom button clicked ");
	                click_(e);
	                return false;
	            });
	        }
	        //..................................................
	    };
	    //............................................ click_() local
	    //    This function is the fixed zoom button click handler.
	    //    If you only want to light a fixed zoom button, call lightButton
	    var click_ = function click_(e) {
	        var magx = $(e.currentTarget).text(); // determine what zoom value was selected; returns magnification with x, e.g. "5x" or "2x" or "Fit"
	        var mag = magx !== 'Fit' ? parseFloat(magx) : viewport.getFitMag(); // remove the x : convert "Fit" to mag value
	        //debug-only viewport.log("zoomButtons: click_: mag: " + mag + "    viewMag: " + viewport.getViewMag());

	        // Note: it is very IMPORTANT to exit if you're already at this mag b/c vp's zoom click can cycle back to zm_click otherwise
	        // that is, without this infinite recursion will happen, stack overflow, bad things like that
	        if (mag == viewport.getViewMag()) // if already viewing at this magnification, nothing to do
	            return;

	        if (_compatibility.BrowserDetect.isIOS()) {
	            // iOS does not light the active button nor dim the inactive button automatically
	            jZoomButton.removeClass('ui-state-active'); // remove active state from all buttons
	            $(e.currentTarget).addClass('ui-state-active'); // add active state to this zoom button
	        }

	        var zoom = magx !== 'Fit' ? viewport.convertToZoom(mag) : 'Fit'; // note - for fit zoom zoomAbsolute can take the string 'Fit'
	        viewport.zoomAbsolute(zoom); // execute the zoom and indicate the zoom is a click event
	    };

	    //............................................ construction
	    construct_();
	}
	module.exports = exports['default'];

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";

	__webpack_require__(83);

	__webpack_require__(374);

	__webpack_require__(376);

	/* eslint max-len: 0 */

	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;

	// Should be removed in the next major release:

	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}

	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);

	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(84);
	__webpack_require__(133);
	__webpack_require__(134);
	__webpack_require__(135);
	__webpack_require__(136);
	__webpack_require__(138);
	__webpack_require__(141);
	__webpack_require__(142);
	__webpack_require__(143);
	__webpack_require__(144);
	__webpack_require__(145);
	__webpack_require__(146);
	__webpack_require__(147);
	__webpack_require__(148);
	__webpack_require__(149);
	__webpack_require__(151);
	__webpack_require__(153);
	__webpack_require__(155);
	__webpack_require__(157);
	__webpack_require__(160);
	__webpack_require__(161);
	__webpack_require__(162);
	__webpack_require__(166);
	__webpack_require__(168);
	__webpack_require__(170);
	__webpack_require__(173);
	__webpack_require__(174);
	__webpack_require__(175);
	__webpack_require__(176);
	__webpack_require__(178);
	__webpack_require__(179);
	__webpack_require__(180);
	__webpack_require__(181);
	__webpack_require__(182);
	__webpack_require__(183);
	__webpack_require__(184);
	__webpack_require__(186);
	__webpack_require__(187);
	__webpack_require__(188);
	__webpack_require__(190);
	__webpack_require__(191);
	__webpack_require__(192);
	__webpack_require__(194);
	__webpack_require__(195);
	__webpack_require__(196);
	__webpack_require__(197);
	__webpack_require__(198);
	__webpack_require__(199);
	__webpack_require__(200);
	__webpack_require__(201);
	__webpack_require__(202);
	__webpack_require__(203);
	__webpack_require__(204);
	__webpack_require__(205);
	__webpack_require__(206);
	__webpack_require__(207);
	__webpack_require__(212);
	__webpack_require__(213);
	__webpack_require__(217);
	__webpack_require__(218);
	__webpack_require__(219);
	__webpack_require__(220);
	__webpack_require__(222);
	__webpack_require__(223);
	__webpack_require__(224);
	__webpack_require__(225);
	__webpack_require__(226);
	__webpack_require__(227);
	__webpack_require__(228);
	__webpack_require__(229);
	__webpack_require__(230);
	__webpack_require__(231);
	__webpack_require__(232);
	__webpack_require__(233);
	__webpack_require__(234);
	__webpack_require__(235);
	__webpack_require__(236);
	__webpack_require__(237);
	__webpack_require__(238);
	__webpack_require__(240);
	__webpack_require__(241);
	__webpack_require__(247);
	__webpack_require__(248);
	__webpack_require__(250);
	__webpack_require__(251);
	__webpack_require__(252);
	__webpack_require__(256);
	__webpack_require__(257);
	__webpack_require__(258);
	__webpack_require__(259);
	__webpack_require__(260);
	__webpack_require__(262);
	__webpack_require__(263);
	__webpack_require__(264);
	__webpack_require__(265);
	__webpack_require__(268);
	__webpack_require__(270);
	__webpack_require__(271);
	__webpack_require__(272);
	__webpack_require__(274);
	__webpack_require__(276);
	__webpack_require__(278);
	__webpack_require__(279);
	__webpack_require__(280);
	__webpack_require__(282);
	__webpack_require__(283);
	__webpack_require__(284);
	__webpack_require__(285);
	__webpack_require__(292);
	__webpack_require__(295);
	__webpack_require__(296);
	__webpack_require__(298);
	__webpack_require__(299);
	__webpack_require__(302);
	__webpack_require__(303);
	__webpack_require__(305);
	__webpack_require__(306);
	__webpack_require__(307);
	__webpack_require__(308);
	__webpack_require__(309);
	__webpack_require__(310);
	__webpack_require__(311);
	__webpack_require__(312);
	__webpack_require__(313);
	__webpack_require__(314);
	__webpack_require__(315);
	__webpack_require__(316);
	__webpack_require__(317);
	__webpack_require__(318);
	__webpack_require__(319);
	__webpack_require__(320);
	__webpack_require__(321);
	__webpack_require__(322);
	__webpack_require__(323);
	__webpack_require__(325);
	__webpack_require__(326);
	__webpack_require__(327);
	__webpack_require__(328);
	__webpack_require__(329);
	__webpack_require__(330);
	__webpack_require__(332);
	__webpack_require__(333);
	__webpack_require__(334);
	__webpack_require__(335);
	__webpack_require__(336);
	__webpack_require__(337);
	__webpack_require__(338);
	__webpack_require__(339);
	__webpack_require__(341);
	__webpack_require__(342);
	__webpack_require__(344);
	__webpack_require__(345);
	__webpack_require__(346);
	__webpack_require__(347);
	__webpack_require__(350);
	__webpack_require__(351);
	__webpack_require__(352);
	__webpack_require__(353);
	__webpack_require__(354);
	__webpack_require__(355);
	__webpack_require__(356);
	__webpack_require__(357);
	__webpack_require__(359);
	__webpack_require__(360);
	__webpack_require__(361);
	__webpack_require__(362);
	__webpack_require__(363);
	__webpack_require__(364);
	__webpack_require__(365);
	__webpack_require__(366);
	__webpack_require__(367);
	__webpack_require__(368);
	__webpack_require__(369);
	__webpack_require__(372);
	__webpack_require__(373);
	module.exports = __webpack_require__(90);

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global         = __webpack_require__(85)
	  , has            = __webpack_require__(86)
	  , DESCRIPTORS    = __webpack_require__(87)
	  , $export        = __webpack_require__(89)
	  , redefine       = __webpack_require__(99)
	  , META           = __webpack_require__(103).KEY
	  , $fails         = __webpack_require__(88)
	  , shared         = __webpack_require__(104)
	  , setToStringTag = __webpack_require__(105)
	  , uid            = __webpack_require__(100)
	  , wks            = __webpack_require__(106)
	  , wksExt         = __webpack_require__(107)
	  , wksDefine      = __webpack_require__(108)
	  , keyOf          = __webpack_require__(110)
	  , enumKeys       = __webpack_require__(123)
	  , isArray        = __webpack_require__(126)
	  , anObject       = __webpack_require__(93)
	  , toIObject      = __webpack_require__(113)
	  , toPrimitive    = __webpack_require__(97)
	  , createDesc     = __webpack_require__(98)
	  , _create        = __webpack_require__(127)
	  , gOPNExt        = __webpack_require__(130)
	  , $GOPD          = __webpack_require__(132)
	  , $DP            = __webpack_require__(92)
	  , $keys          = __webpack_require__(111)
	  , gOPD           = $GOPD.f
	  , dP             = $DP.f
	  , gOPN           = gOPNExt.f
	  , $Symbol        = global.Symbol
	  , $JSON          = global.JSON
	  , _stringify     = $JSON && $JSON.stringify
	  , PROTOTYPE      = 'prototype'
	  , HIDDEN         = wks('_hidden')
	  , TO_PRIMITIVE   = wks('toPrimitive')
	  , isEnum         = {}.propertyIsEnumerable
	  , SymbolRegistry = shared('symbol-registry')
	  , AllSymbols     = shared('symbols')
	  , OPSymbols      = shared('op-symbols')
	  , ObjectProto    = Object[PROTOTYPE]
	  , USE_NATIVE     = typeof $Symbol == 'function'
	  , QObject        = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function(){
	  return _create(dP({}, 'a', {
	    get: function(){ return dP(this, 'a', {value: 7}).a; }
	  })).a != 7;
	}) ? function(it, key, D){
	  var protoDesc = gOPD(ObjectProto, key);
	  if(protoDesc)delete ObjectProto[key];
	  dP(it, key, D);
	  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
	} : dP;

	var wrap = function(tag){
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};

	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
	  return typeof it == 'symbol';
	} : function(it){
	  return it instanceof $Symbol;
	};

	var $defineProperty = function defineProperty(it, key, D){
	  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if(has(AllSymbols, key)){
	    if(!D.enumerable){
	      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
	      D = _create(D, {enumerable: createDesc(0, false)});
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P){
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P))
	    , i    = 0
	    , l = keys.length
	    , key;
	  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P){
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key){
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
	  it  = toIObject(it);
	  key = toPrimitive(key, true);
	  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
	  var D = gOPD(it, key);
	  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it){
	  var names  = gOPN(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
	  var IS_OP  = it === ObjectProto
	    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
	  } return result;
	};

	// 19.4.1.1 Symbol([description])
	if(!USE_NATIVE){
	  $Symbol = function Symbol(){
	    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function(value){
	      if(this === ObjectProto)$set.call(OPSymbols, value);
	      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
	    return this._k;
	  });

	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f   = $defineProperty;
	  __webpack_require__(131).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(125).f  = $propertyIsEnumerable;
	  __webpack_require__(124).f = $getOwnPropertySymbols;

	  if(DESCRIPTORS && !__webpack_require__(109)){
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }

	  wksExt.f = function(name){
	    return wrap(wks(name));
	  }
	}

	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});

	for(var symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);

	for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);

	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function(key){
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key){
	    if(isSymbol(key))return keyOf(SymbolRegistry, key);
	    throw TypeError(key + ' is not a symbol!');
	  },
	  useSetter: function(){ setter = true; },
	  useSimple: function(){ setter = false; }
	});

	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});

	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it){
	    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
	    var args = [it]
	      , i    = 1
	      , replacer, $replacer;
	    while(arguments.length > i)args.push(arguments[i++]);
	    replacer = args[1];
	    if(typeof replacer == 'function')$replacer = replacer;
	    if($replacer || !isArray(replacer))replacer = function(key, value){
	      if($replacer)value = $replacer.call(this, key, value);
	      if(!isSymbol(value))return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});

	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(91)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);

/***/ },
/* 85 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 86 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(88)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 88 */
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(85)
	  , core      = __webpack_require__(90)
	  , hide      = __webpack_require__(91)
	  , redefine  = __webpack_require__(99)
	  , ctx       = __webpack_require__(101)
	  , PROTOTYPE = 'prototype';

	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
	    , key, own, out, exp;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if(target)redefine(target, key, out, type & $export.U);
	    // export
	    if(exports[key] != out)hide(exports, key, exp);
	    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ },
/* 90 */
/***/ function(module, exports) {

	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(92)
	  , createDesc = __webpack_require__(98);
	module.exports = __webpack_require__(87) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	var anObject       = __webpack_require__(93)
	  , IE8_DOM_DEFINE = __webpack_require__(95)
	  , toPrimitive    = __webpack_require__(97)
	  , dP             = Object.defineProperty;

	exports.f = __webpack_require__(87) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(94);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 94 */
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(87) && !__webpack_require__(88)(function(){
	  return Object.defineProperty(__webpack_require__(96)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(94)
	  , document = __webpack_require__(85).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(94);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ },
/* 98 */
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(85)
	  , hide      = __webpack_require__(91)
	  , has       = __webpack_require__(86)
	  , SRC       = __webpack_require__(100)('src')
	  , TO_STRING = 'toString'
	  , $toString = Function[TO_STRING]
	  , TPL       = ('' + $toString).split(TO_STRING);

	__webpack_require__(90).inspectSource = function(it){
	  return $toString.call(it);
	};

	(module.exports = function(O, key, val, safe){
	  var isFunction = typeof val == 'function';
	  if(isFunction)has(val, 'name') || hide(val, 'name', key);
	  if(O[key] === val)return;
	  if(isFunction)has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if(O === global){
	    O[key] = val;
	  } else {
	    if(!safe){
	      delete O[key];
	      hide(O, key, val);
	    } else {
	      if(O[key])O[key] = val;
	      else hide(O, key, val);
	    }
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString(){
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});

/***/ },
/* 100 */
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(102);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 102 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	var META     = __webpack_require__(100)('meta')
	  , isObject = __webpack_require__(94)
	  , has      = __webpack_require__(86)
	  , setDesc  = __webpack_require__(92).f
	  , id       = 0;
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	var FREEZE = !__webpack_require__(88)(function(){
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function(it){
	  setDesc(it, META, {value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  }});
	};
	var fastKey = function(it, create){
	  // return primitive with prefix
	  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return 'F';
	    // not necessary to add metadata
	    if(!create)return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function(it, create){
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return true;
	    // not necessary to add metadata
	    if(!create)return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function(it){
	  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY:      META,
	  NEED:     false,
	  fastKey:  fastKey,
	  getWeak:  getWeak,
	  onFreeze: onFreeze
	};

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(85)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(92).f
	  , has = __webpack_require__(86)
	  , TAG = __webpack_require__(106)('toStringTag');

	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	var store      = __webpack_require__(104)('wks')
	  , uid        = __webpack_require__(100)
	  , Symbol     = __webpack_require__(85).Symbol
	  , USE_SYMBOL = typeof Symbol == 'function';

	var $exports = module.exports = function(name){
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};

	$exports.store = store;

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(106);

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	var global         = __webpack_require__(85)
	  , core           = __webpack_require__(90)
	  , LIBRARY        = __webpack_require__(109)
	  , wksExt         = __webpack_require__(107)
	  , defineProperty = __webpack_require__(92).f;
	module.exports = function(name){
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
	};

/***/ },
/* 109 */
/***/ function(module, exports) {

	module.exports = false;

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(111)
	  , toIObject = __webpack_require__(113);
	module.exports = function(object, el){
	  var O      = toIObject(object)
	    , keys   = getKeys(O)
	    , length = keys.length
	    , index  = 0
	    , key;
	  while(length > index)if(O[key = keys[index++]] === el)return key;
	};

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys       = __webpack_require__(112)
	  , enumBugKeys = __webpack_require__(122);

	module.exports = Object.keys || function keys(O){
	  return $keys(O, enumBugKeys);
	};

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	var has          = __webpack_require__(86)
	  , toIObject    = __webpack_require__(113)
	  , arrayIndexOf = __webpack_require__(117)(false)
	  , IE_PROTO     = __webpack_require__(121)('IE_PROTO');

	module.exports = function(object, names){
	  var O      = toIObject(object)
	    , i      = 0
	    , result = []
	    , key;
	  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while(names.length > i)if(has(O, key = names[i++])){
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(114)
	  , defined = __webpack_require__(116);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(115);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ },
/* 115 */
/***/ function(module, exports) {

	var toString = {}.toString;

	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ },
/* 116 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(113)
	  , toLength  = __webpack_require__(118)
	  , toIndex   = __webpack_require__(120);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(119)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ },
/* 119 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(119)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(104)('keys')
	  , uid    = __webpack_require__(100);
	module.exports = function(key){
	  return shared[key] || (shared[key] = uid(key));
	};

/***/ },
/* 122 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(111)
	  , gOPS    = __webpack_require__(124)
	  , pIE     = __webpack_require__(125);
	module.exports = function(it){
	  var result     = getKeys(it)
	    , getSymbols = gOPS.f;
	  if(getSymbols){
	    var symbols = getSymbols(it)
	      , isEnum  = pIE.f
	      , i       = 0
	      , key;
	    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
	  } return result;
	};

/***/ },
/* 124 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;

/***/ },
/* 125 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(115);
	module.exports = Array.isArray || function isArray(arg){
	  return cof(arg) == 'Array';
	};

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject    = __webpack_require__(93)
	  , dPs         = __webpack_require__(128)
	  , enumBugKeys = __webpack_require__(122)
	  , IE_PROTO    = __webpack_require__(121)('IE_PROTO')
	  , Empty       = function(){ /* empty */ }
	  , PROTOTYPE   = 'prototype';

	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function(){
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(96)('iframe')
	    , i      = enumBugKeys.length
	    , lt     = '<'
	    , gt     = '>'
	    , iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(129).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};

	module.exports = Object.create || function create(O, Properties){
	  var result;
	  if(O !== null){
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty;
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	var dP       = __webpack_require__(92)
	  , anObject = __webpack_require__(93)
	  , getKeys  = __webpack_require__(111);

	module.exports = __webpack_require__(87) ? Object.defineProperties : function defineProperties(O, Properties){
	  anObject(O);
	  var keys   = getKeys(Properties)
	    , length = keys.length
	    , i = 0
	    , P;
	  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(85).document && document.documentElement;

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(113)
	  , gOPN      = __webpack_require__(131).f
	  , toString  = {}.toString;

	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];

	var getWindowNames = function(it){
	  try {
	    return gOPN(it);
	  } catch(e){
	    return windowNames.slice();
	  }
	};

	module.exports.f = function getOwnPropertyNames(it){
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys      = __webpack_require__(112)
	  , hiddenKeys = __webpack_require__(122).concat('length', 'prototype');

	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
	  return $keys(O, hiddenKeys);
	};

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	var pIE            = __webpack_require__(125)
	  , createDesc     = __webpack_require__(98)
	  , toIObject      = __webpack_require__(113)
	  , toPrimitive    = __webpack_require__(97)
	  , has            = __webpack_require__(86)
	  , IE8_DOM_DEFINE = __webpack_require__(95)
	  , gOPD           = Object.getOwnPropertyDescriptor;

	exports.f = __webpack_require__(87) ? gOPD : function getOwnPropertyDescriptor(O, P){
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if(IE8_DOM_DEFINE)try {
	    return gOPD(O, P);
	  } catch(e){ /* empty */ }
	  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
	};

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(89)
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', {create: __webpack_require__(127)});

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(89);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(87), 'Object', {defineProperty: __webpack_require__(92).f});

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(89);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(87), 'Object', {defineProperties: __webpack_require__(128)});

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject                 = __webpack_require__(113)
	  , $getOwnPropertyDescriptor = __webpack_require__(132).f;

	__webpack_require__(137)('getOwnPropertyDescriptor', function(){
	  return function getOwnPropertyDescriptor(it, key){
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(89)
	  , core    = __webpack_require__(90)
	  , fails   = __webpack_require__(88);
	module.exports = function(KEY, exec){
	  var fn  = (core.Object || {})[KEY] || Object[KEY]
	    , exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
	};

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject        = __webpack_require__(139)
	  , $getPrototypeOf = __webpack_require__(140);

	__webpack_require__(137)('getPrototypeOf', function(){
	  return function getPrototypeOf(it){
	    return $getPrototypeOf(toObject(it));
	  };
	});

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(116);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has         = __webpack_require__(86)
	  , toObject    = __webpack_require__(139)
	  , IE_PROTO    = __webpack_require__(121)('IE_PROTO')
	  , ObjectProto = Object.prototype;

	module.exports = Object.getPrototypeOf || function(O){
	  O = toObject(O);
	  if(has(O, IE_PROTO))return O[IE_PROTO];
	  if(typeof O.constructor == 'function' && O instanceof O.constructor){
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(139)
	  , $keys    = __webpack_require__(111);

	__webpack_require__(137)('keys', function(){
	  return function keys(it){
	    return $keys(toObject(it));
	  };
	});

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(137)('getOwnPropertyNames', function(){
	  return __webpack_require__(130).f;
	});

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(94)
	  , meta     = __webpack_require__(103).onFreeze;

	__webpack_require__(137)('freeze', function($freeze){
	  return function freeze(it){
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(94)
	  , meta     = __webpack_require__(103).onFreeze;

	__webpack_require__(137)('seal', function($seal){
	  return function seal(it){
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(94)
	  , meta     = __webpack_require__(103).onFreeze;

	__webpack_require__(137)('preventExtensions', function($preventExtensions){
	  return function preventExtensions(it){
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(94);

	__webpack_require__(137)('isFrozen', function($isFrozen){
	  return function isFrozen(it){
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(94);

	__webpack_require__(137)('isSealed', function($isSealed){
	  return function isSealed(it){
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(94);

	__webpack_require__(137)('isExtensible', function($isExtensible){
	  return function isExtensible(it){
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(89);

	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(150)});

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys  = __webpack_require__(111)
	  , gOPS     = __webpack_require__(124)
	  , pIE      = __webpack_require__(125)
	  , toObject = __webpack_require__(139)
	  , IObject  = __webpack_require__(114)
	  , $assign  = Object.assign;

	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(88)(function(){
	  var A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , aLen  = arguments.length
	    , index = 1
	    , getSymbols = gOPS.f
	    , isEnum     = pIE.f;
	  while(aLen > index){
	    var S      = IObject(arguments[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  } return T;
	} : $assign;

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(89);
	$export($export.S, 'Object', {is: __webpack_require__(152)});

/***/ },
/* 152 */
/***/ function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y){
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(89);
	$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(154).set});

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(94)
	  , anObject = __webpack_require__(93);
	var check = function(O, proto){
	  anObject(O);
	  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function(test, buggy, set){
	      try {
	        set = __webpack_require__(101)(Function.call, __webpack_require__(132).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch(e){ buggy = true; }
	      return function setPrototypeOf(O, proto){
	        check(O, proto);
	        if(buggy)O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(156)
	  , test    = {};
	test[__webpack_require__(106)('toStringTag')] = 'z';
	if(test + '' != '[object z]'){
	  __webpack_require__(99)(Object.prototype, 'toString', function toString(){
	    return '[object ' + classof(this) + ']';
	  }, true);
	}

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(115)
	  , TAG = __webpack_require__(106)('toStringTag')
	  // ES3 wrong here
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';

	// fallback for IE11 Script Access Denied error
	var tryGet = function(it, key){
	  try {
	    return it[key];
	  } catch(e){ /* empty */ }
	};

	module.exports = function(it){
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(89);

	$export($export.P, 'Function', {bind: __webpack_require__(158)});

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction  = __webpack_require__(102)
	  , isObject   = __webpack_require__(94)
	  , invoke     = __webpack_require__(159)
	  , arraySlice = [].slice
	  , factories  = {};

	var construct = function(F, len, args){
	  if(!(len in factories)){
	    for(var n = [], i = 0; i < len; i++)n[i] = 'a[' + i + ']';
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};

	module.exports = Function.bind || function bind(that /*, args... */){
	  var fn       = aFunction(this)
	    , partArgs = arraySlice.call(arguments, 1);
	  var bound = function(/* args... */){
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if(isObject(fn.prototype))bound.prototype = fn.prototype;
	  return bound;
	};

/***/ },
/* 159 */
/***/ function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function(fn, args, that){
	  var un = that === undefined;
	  switch(args.length){
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return              fn.apply(that, args);
	};

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(92).f
	  , createDesc = __webpack_require__(98)
	  , has        = __webpack_require__(86)
	  , FProto     = Function.prototype
	  , nameRE     = /^\s*function ([^ (]*)/
	  , NAME       = 'name';

	var isExtensible = Object.isExtensible || function(){
	  return true;
	};

	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(87) && dP(FProto, NAME, {
	  configurable: true,
	  get: function(){
	    try {
	      var that = this
	        , name = ('' + that).match(nameRE)[1];
	      has(that, NAME) || !isExtensible(that) || dP(that, NAME, createDesc(5, name));
	      return name;
	    } catch(e){
	      return '';
	    }
	  }
	});

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isObject       = __webpack_require__(94)
	  , getPrototypeOf = __webpack_require__(140)
	  , HAS_INSTANCE   = __webpack_require__(106)('hasInstance')
	  , FunctionProto  = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if(!(HAS_INSTANCE in FunctionProto))__webpack_require__(92).f(FunctionProto, HAS_INSTANCE, {value: function(O){
	  if(typeof this != 'function' || !isObject(O))return false;
	  if(!isObject(this.prototype))return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while(O = getPrototypeOf(O))if(this.prototype === O)return true;
	  return false;
	}});

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(89)
	  , $parseInt = __webpack_require__(163);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), {parseInt: $parseInt});

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(85).parseInt
	  , $trim     = __webpack_require__(164).trim
	  , ws        = __webpack_require__(165)
	  , hex       = /^[\-+]?0[xX]/;

	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix){
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(89)
	  , defined = __webpack_require__(116)
	  , fails   = __webpack_require__(88)
	  , spaces  = __webpack_require__(165)
	  , space   = '[' + spaces + ']'
	  , non     = '\u200b\u0085'
	  , ltrim   = RegExp('^' + space + space + '*')
	  , rtrim   = RegExp(space + space + '*$');

	var exporter = function(KEY, exec, ALIAS){
	  var exp   = {};
	  var FORCE = fails(function(){
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if(ALIAS)exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};

	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function(string, TYPE){
	  string = String(defined(string));
	  if(TYPE & 1)string = string.replace(ltrim, '');
	  if(TYPE & 2)string = string.replace(rtrim, '');
	  return string;
	};

	module.exports = exporter;

/***/ },
/* 165 */
/***/ function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	var $export     = __webpack_require__(89)
	  , $parseFloat = __webpack_require__(167);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), {parseFloat: $parseFloat});

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(85).parseFloat
	  , $trim       = __webpack_require__(164).trim;

	module.exports = 1 / $parseFloat(__webpack_require__(165) + '-0') !== -Infinity ? function parseFloat(str){
	  var string = $trim(String(str), 3)
	    , result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global            = __webpack_require__(85)
	  , has               = __webpack_require__(86)
	  , cof               = __webpack_require__(115)
	  , inheritIfRequired = __webpack_require__(169)
	  , toPrimitive       = __webpack_require__(97)
	  , fails             = __webpack_require__(88)
	  , gOPN              = __webpack_require__(131).f
	  , gOPD              = __webpack_require__(132).f
	  , dP                = __webpack_require__(92).f
	  , $trim             = __webpack_require__(164).trim
	  , NUMBER            = 'Number'
	  , $Number           = global[NUMBER]
	  , Base              = $Number
	  , proto             = $Number.prototype
	  // Opera ~12 has broken Object#toString
	  , BROKEN_COF        = cof(__webpack_require__(127)(proto)) == NUMBER
	  , TRIM              = 'trim' in String.prototype;

	// 7.1.3 ToNumber(argument)
	var toNumber = function(argument){
	  var it = toPrimitive(argument, false);
	  if(typeof it == 'string' && it.length > 2){
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0)
	      , third, radix, maxCode;
	    if(first === 43 || first === 45){
	      third = it.charCodeAt(2);
	      if(third === 88 || third === 120)return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if(first === 48){
	      switch(it.charCodeAt(1)){
	        case 66 : case 98  : radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79 : case 111 : radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default : return +it;
	      }
	      for(var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++){
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if(code < 48 || code > maxCode)return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};

	if(!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')){
	  $Number = function Number(value){
	    var it = arguments.length < 1 ? 0 : value
	      , that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function(){ proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for(var keys = __webpack_require__(87) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++){
	    if(has(Base, key = keys[j]) && !has($Number, key)){
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(99)(global, NUMBER, $Number);
	}

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	var isObject       = __webpack_require__(94)
	  , setPrototypeOf = __webpack_require__(154).set;
	module.exports = function(that, target, C){
	  var P, S = target.constructor;
	  if(S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf){
	    setPrototypeOf(that, P);
	  } return that;
	};

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(89)
	  , toInteger    = __webpack_require__(119)
	  , aNumberValue = __webpack_require__(171)
	  , repeat       = __webpack_require__(172)
	  , $toFixed     = 1..toFixed
	  , floor        = Math.floor
	  , data         = [0, 0, 0, 0, 0, 0]
	  , ERROR        = 'Number.toFixed: incorrect invocation!'
	  , ZERO         = '0';

	var multiply = function(n, c){
	  var i  = -1
	    , c2 = c;
	  while(++i < 6){
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function(n){
	  var i = 6
	    , c = 0;
	  while(--i >= 0){
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function(){
	  var i = 6
	    , s = '';
	  while(--i >= 0){
	    if(s !== '' || i === 0 || data[i] !== 0){
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function(x, n, acc){
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function(x){
	  var n  = 0
	    , x2 = x;
	  while(x2 >= 4096){
	    n += 12;
	    x2 /= 4096;
	  }
	  while(x2 >= 2){
	    n  += 1;
	    x2 /= 2;
	  } return n;
	};

	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128..toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(88)(function(){
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits){
	    var x = aNumberValue(this, ERROR)
	      , f = toInteger(fractionDigits)
	      , s = ''
	      , m = ZERO
	      , e, z, j, k;
	    if(f < 0 || f > 20)throw RangeError(ERROR);
	    if(x != x)return 'NaN';
	    if(x <= -1e21 || x >= 1e21)return String(x);
	    if(x < 0){
	      s = '-';
	      x = -x;
	    }
	    if(x > 1e-21){
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if(e > 0){
	        multiply(0, z);
	        j = f;
	        while(j >= 7){
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while(j >= 23){
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if(f > 0){
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(115);
	module.exports = function(it, msg){
	  if(typeof it != 'number' && cof(it) != 'Number')throw TypeError(msg);
	  return +it;
	};

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(119)
	  , defined   = __webpack_require__(116);

	module.exports = function repeat(count){
	  var str = String(defined(this))
	    , res = ''
	    , n   = toInteger(count);
	  if(n < 0 || n == Infinity)throw RangeError("Count can't be negative");
	  for(;n > 0; (n >>>= 1) && (str += str))if(n & 1)res += str;
	  return res;
	};

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(89)
	  , $fails       = __webpack_require__(88)
	  , aNumberValue = __webpack_require__(171)
	  , $toPrecision = 1..toPrecision;

	$export($export.P + $export.F * ($fails(function(){
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function(){
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision){
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision); 
	  }
	});

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(89);

	$export($export.S, 'Number', {EPSILON: Math.pow(2, -52)});

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export   = __webpack_require__(89)
	  , _isFinite = __webpack_require__(85).isFinite;

	$export($export.S, 'Number', {
	  isFinite: function isFinite(it){
	    return typeof it == 'number' && _isFinite(it);
	  }
	});

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(89);

	$export($export.S, 'Number', {isInteger: __webpack_require__(177)});

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(94)
	  , floor    = Math.floor;
	module.exports = function isInteger(it){
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(89);

	$export($export.S, 'Number', {
	  isNaN: function isNaN(number){
	    return number != number;
	  }
	});

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export   = __webpack_require__(89)
	  , isInteger = __webpack_require__(177)
	  , abs       = Math.abs;

	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number){
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(89);

	$export($export.S, 'Number', {MAX_SAFE_INTEGER: 0x1fffffffffffff});

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(89);

	$export($export.S, 'Number', {MIN_SAFE_INTEGER: -0x1fffffffffffff});

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	var $export     = __webpack_require__(89)
	  , $parseFloat = __webpack_require__(167);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', {parseFloat: $parseFloat});

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(89)
	  , $parseInt = __webpack_require__(163);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', {parseInt: $parseInt});

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(89)
	  , log1p   = __webpack_require__(185)
	  , sqrt    = Math.sqrt
	  , $acosh  = Math.acosh;

	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN 
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x){
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});

/***/ },
/* 185 */
/***/ function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x){
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(89)
	  , $asinh  = Math.asinh;

	function asinh(x){
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}

	// Tor Browser bug: Math.asinh(0) -> -0 
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', {asinh: asinh});

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(89)
	  , $atanh  = Math.atanh;

	// Tor Browser bug: Math.atanh(-0) -> 0 
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x){
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(89)
	  , sign    = __webpack_require__(189);

	$export($export.S, 'Math', {
	  cbrt: function cbrt(x){
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});

/***/ },
/* 189 */
/***/ function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x){
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(89);

	$export($export.S, 'Math', {
	  clz32: function clz32(x){
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(89)
	  , exp     = Math.exp;

	$export($export.S, 'Math', {
	  cosh: function cosh(x){
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(89)
	  , $expm1  = __webpack_require__(193);

	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', {expm1: $expm1});

/***/ },
/* 193 */
/***/ function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x){
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export   = __webpack_require__(89)
	  , sign      = __webpack_require__(189)
	  , pow       = Math.pow
	  , EPSILON   = pow(2, -52)
	  , EPSILON32 = pow(2, -23)
	  , MAX32     = pow(2, 127) * (2 - EPSILON32)
	  , MIN32     = pow(2, -126);

	var roundTiesToEven = function(n){
	  return n + 1 / EPSILON - 1 / EPSILON;
	};


	$export($export.S, 'Math', {
	  fround: function fround(x){
	    var $abs  = Math.abs(x)
	      , $sign = sign(x)
	      , a, result;
	    if($abs < MIN32)return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	    a = (1 + EPSILON32 / EPSILON) * $abs;
	    result = a - (a - $abs);
	    if(result > MAX32 || result != result)return $sign * Infinity;
	    return $sign * result;
	  }
	});

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(89)
	  , abs     = Math.abs;

	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2){ // eslint-disable-line no-unused-vars
	    var sum  = 0
	      , i    = 0
	      , aLen = arguments.length
	      , larg = 0
	      , arg, div;
	    while(i < aLen){
	      arg = abs(arguments[i++]);
	      if(larg < arg){
	        div  = larg / arg;
	        sum  = sum * div * div + 1;
	        larg = arg;
	      } else if(arg > 0){
	        div  = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(89)
	  , $imul   = Math.imul;

	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(88)(function(){
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y){
	    var UINT16 = 0xffff
	      , xn = +x
	      , yn = +y
	      , xl = UINT16 & xn
	      , yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(89);

	$export($export.S, 'Math', {
	  log10: function log10(x){
	    return Math.log(x) / Math.LN10;
	  }
	});

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(89);

	$export($export.S, 'Math', {log1p: __webpack_require__(185)});

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(89);

	$export($export.S, 'Math', {
	  log2: function log2(x){
	    return Math.log(x) / Math.LN2;
	  }
	});

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(89);

	$export($export.S, 'Math', {sign: __webpack_require__(189)});

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(89)
	  , expm1   = __webpack_require__(193)
	  , exp     = Math.exp;

	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(88)(function(){
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x){
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(89)
	  , expm1   = __webpack_require__(193)
	  , exp     = Math.exp;

	$export($export.S, 'Math', {
	  tanh: function tanh(x){
	    var a = expm1(x = +x)
	      , b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(89);

	$export($export.S, 'Math', {
	  trunc: function trunc(it){
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	var $export        = __webpack_require__(89)
	  , toIndex        = __webpack_require__(120)
	  , fromCharCode   = String.fromCharCode
	  , $fromCodePoint = String.fromCodePoint;

	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x){ // eslint-disable-line no-unused-vars
	    var res  = []
	      , aLen = arguments.length
	      , i    = 0
	      , code;
	    while(aLen > i){
	      code = +arguments[i++];
	      if(toIndex(code, 0x10ffff) !== code)throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(89)
	  , toIObject = __webpack_require__(113)
	  , toLength  = __webpack_require__(118);

	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite){
	    var tpl  = toIObject(callSite.raw)
	      , len  = toLength(tpl.length)
	      , aLen = arguments.length
	      , res  = []
	      , i    = 0;
	    while(len > i){
	      res.push(String(tpl[i++]));
	      if(i < aLen)res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(164)('trim', function($trim){
	  return function trim(){
	    return $trim(this, 3);
	  };
	});

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at  = __webpack_require__(208)(true);

	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(209)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(119)
	  , defined   = __webpack_require__(116);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY        = __webpack_require__(109)
	  , $export        = __webpack_require__(89)
	  , redefine       = __webpack_require__(99)
	  , hide           = __webpack_require__(91)
	  , has            = __webpack_require__(86)
	  , Iterators      = __webpack_require__(210)
	  , $iterCreate    = __webpack_require__(211)
	  , setToStringTag = __webpack_require__(105)
	  , getPrototypeOf = __webpack_require__(140)
	  , ITERATOR       = __webpack_require__(106)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';

	var returnThis = function(){ return this; };

	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
	    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
	    , methods, key, IteratorPrototype;
	  // Fix native
	  if($anyNative){
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
	    if(IteratorPrototype !== Object.prototype){
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if(DEF_VALUES && $native && $native.name !== VALUES){
	    VALUES_BUG = true;
	    $default = function values(){ return $native.call(this); };
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES ? $default : getMethod(VALUES),
	      keys:    IS_SET     ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ },
/* 210 */
/***/ function(module, exports) {

	module.exports = {};

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create         = __webpack_require__(127)
	  , descriptor     = __webpack_require__(98)
	  , setToStringTag = __webpack_require__(105)
	  , IteratorPrototype = {};

	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(91)(IteratorPrototype, __webpack_require__(106)('iterator'), function(){ return this; });

	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(89)
	  , $at     = __webpack_require__(208)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos){
	    return $at(this, pos);
	  }
	});

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export   = __webpack_require__(89)
	  , toLength  = __webpack_require__(118)
	  , context   = __webpack_require__(214)
	  , ENDS_WITH = 'endsWith'
	  , $endsWith = ''[ENDS_WITH];

	$export($export.P + $export.F * __webpack_require__(216)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /*, endPosition = @length */){
	    var that = context(this, searchString, ENDS_WITH)
	      , endPosition = arguments.length > 1 ? arguments[1] : undefined
	      , len    = toLength(that.length)
	      , end    = endPosition === undefined ? len : Math.min(toLength(endPosition), len)
	      , search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(215)
	  , defined  = __webpack_require__(116);

	module.exports = function(that, searchString, NAME){
	  if(isRegExp(searchString))throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(94)
	  , cof      = __webpack_require__(115)
	  , MATCH    = __webpack_require__(106)('match');
	module.exports = function(it){
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(106)('match');
	module.exports = function(KEY){
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch(e){
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch(f){ /* empty */ }
	  } return true;
	};

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export  = __webpack_require__(89)
	  , context  = __webpack_require__(214)
	  , INCLUDES = 'includes';

	$export($export.P + $export.F * __webpack_require__(216)(INCLUDES), 'String', {
	  includes: function includes(searchString /*, position = 0 */){
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(89);

	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(172)
	});

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export     = __webpack_require__(89)
	  , toLength    = __webpack_require__(118)
	  , context     = __webpack_require__(214)
	  , STARTS_WITH = 'startsWith'
	  , $startsWith = ''[STARTS_WITH];

	$export($export.P + $export.F * __webpack_require__(216)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /*, position = 0 */){
	    var that   = context(this, searchString, STARTS_WITH)
	      , index  = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length))
	      , search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(221)('anchor', function(createHTML){
	  return function anchor(name){
	    return createHTML(this, 'a', 'name', name);
	  }
	});

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(89)
	  , fails   = __webpack_require__(88)
	  , defined = __webpack_require__(116)
	  , quot    = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function(string, tag, attribute, value) {
	  var S  = String(defined(string))
	    , p1 = '<' + tag;
	  if(attribute !== '')p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function(NAME, exec){
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function(){
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(221)('big', function(createHTML){
	  return function big(){
	    return createHTML(this, 'big', '', '');
	  }
	});

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(221)('blink', function(createHTML){
	  return function blink(){
	    return createHTML(this, 'blink', '', '');
	  }
	});

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(221)('bold', function(createHTML){
	  return function bold(){
	    return createHTML(this, 'b', '', '');
	  }
	});

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(221)('fixed', function(createHTML){
	  return function fixed(){
	    return createHTML(this, 'tt', '', '');
	  }
	});

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(221)('fontcolor', function(createHTML){
	  return function fontcolor(color){
	    return createHTML(this, 'font', 'color', color);
	  }
	});

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(221)('fontsize', function(createHTML){
	  return function fontsize(size){
	    return createHTML(this, 'font', 'size', size);
	  }
	});

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(221)('italics', function(createHTML){
	  return function italics(){
	    return createHTML(this, 'i', '', '');
	  }
	});

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(221)('link', function(createHTML){
	  return function link(url){
	    return createHTML(this, 'a', 'href', url);
	  }
	});

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(221)('small', function(createHTML){
	  return function small(){
	    return createHTML(this, 'small', '', '');
	  }
	});

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(221)('strike', function(createHTML){
	  return function strike(){
	    return createHTML(this, 'strike', '', '');
	  }
	});

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(221)('sub', function(createHTML){
	  return function sub(){
	    return createHTML(this, 'sub', '', '');
	  }
	});

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(221)('sup', function(createHTML){
	  return function sup(){
	    return createHTML(this, 'sup', '', '');
	  }
	});

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(89);

	$export($export.S, 'Date', {now: function(){ return new Date().getTime(); }});

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export     = __webpack_require__(89)
	  , toObject    = __webpack_require__(139)
	  , toPrimitive = __webpack_require__(97);

	$export($export.P + $export.F * __webpack_require__(88)(function(){
	  return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({toISOString: function(){ return 1; }}) !== 1;
	}), 'Date', {
	  toJSON: function toJSON(key){
	    var O  = toObject(this)
	      , pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(89)
	  , fails   = __webpack_require__(88)
	  , getTime = Date.prototype.getTime;

	var lz = function(num){
	  return num > 9 ? num : '0' + num;
	};

	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (fails(function(){
	  return new Date(-5e13 - 1).toISOString() != '0385-07-25T07:06:39.999Z';
	}) || !fails(function(){
	  new Date(NaN).toISOString();
	})), 'Date', {
	  toISOString: function toISOString(){
	    if(!isFinite(getTime.call(this)))throw RangeError('Invalid time value');
	    var d = this
	      , y = d.getUTCFullYear()
	      , m = d.getUTCMilliseconds()
	      , s = y < 0 ? '-' : y > 9999 ? '+' : '';
	    return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	      '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	      'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	      ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	  }
	});

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	var DateProto    = Date.prototype
	  , INVALID_DATE = 'Invalid Date'
	  , TO_STRING    = 'toString'
	  , $toString    = DateProto[TO_STRING]
	  , getTime      = DateProto.getTime;
	if(new Date(NaN) + '' != INVALID_DATE){
	  __webpack_require__(99)(DateProto, TO_STRING, function toString(){
	    var value = getTime.call(this);
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(106)('toPrimitive')
	  , proto        = Date.prototype;

	if(!(TO_PRIMITIVE in proto))__webpack_require__(91)(proto, TO_PRIMITIVE, __webpack_require__(239));

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var anObject    = __webpack_require__(93)
	  , toPrimitive = __webpack_require__(97)
	  , NUMBER      = 'number';

	module.exports = function(hint){
	  if(hint !== 'string' && hint !== NUMBER && hint !== 'default')throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(89);

	$export($export.S, 'Array', {isArray: __webpack_require__(126)});

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx            = __webpack_require__(101)
	  , $export        = __webpack_require__(89)
	  , toObject       = __webpack_require__(139)
	  , call           = __webpack_require__(242)
	  , isArrayIter    = __webpack_require__(243)
	  , toLength       = __webpack_require__(118)
	  , createProperty = __webpack_require__(244)
	  , getIterFn      = __webpack_require__(245);

	$export($export.S + $export.F * !__webpack_require__(246)(function(iter){ Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
	    var O       = toObject(arrayLike)
	      , C       = typeof this == 'function' ? this : Array
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , index   = 0
	      , iterFn  = getIterFn(O)
	      , length, result, step, iterator;
	    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
	      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for(result = new C(length); length > index; index++){
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(93);
	module.exports = function(iterator, fn, value, entries){
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch(e){
	    var ret = iterator['return'];
	    if(ret !== undefined)anObject(ret.call(iterator));
	    throw e;
	  }
	};

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators  = __webpack_require__(210)
	  , ITERATOR   = __webpack_require__(106)('iterator')
	  , ArrayProto = Array.prototype;

	module.exports = function(it){
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(92)
	  , createDesc      = __webpack_require__(98);

	module.exports = function(object, index, value){
	  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(156)
	  , ITERATOR  = __webpack_require__(106)('iterator')
	  , Iterators = __webpack_require__(210);
	module.exports = __webpack_require__(90).getIteratorMethod = function(it){
	  if(it != undefined)return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR     = __webpack_require__(106)('iterator')
	  , SAFE_CLOSING = false;

	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function(){ SAFE_CLOSING = true; };
	  Array.from(riter, function(){ throw 2; });
	} catch(e){ /* empty */ }

	module.exports = function(exec, skipClosing){
	  if(!skipClosing && !SAFE_CLOSING)return false;
	  var safe = false;
	  try {
	    var arr  = [7]
	      , iter = arr[ITERATOR]();
	    iter.next = function(){ return {done: safe = true}; };
	    arr[ITERATOR] = function(){ return iter; };
	    exec(arr);
	  } catch(e){ /* empty */ }
	  return safe;
	};

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export        = __webpack_require__(89)
	  , createProperty = __webpack_require__(244);

	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(88)(function(){
	  function F(){}
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */){
	    var index  = 0
	      , aLen   = arguments.length
	      , result = new (typeof this == 'function' ? this : Array)(aLen);
	    while(aLen > index)createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export   = __webpack_require__(89)
	  , toIObject = __webpack_require__(113)
	  , arrayJoin = [].join;

	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(114) != Object || !__webpack_require__(249)(arrayJoin)), 'Array', {
	  join: function join(separator){
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	var fails = __webpack_require__(88);

	module.exports = function(method, arg){
	  return !!method && fails(function(){
	    arg ? method.call(null, function(){}, 1) : method.call(null);
	  });
	};

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export    = __webpack_require__(89)
	  , html       = __webpack_require__(129)
	  , cof        = __webpack_require__(115)
	  , toIndex    = __webpack_require__(120)
	  , toLength   = __webpack_require__(118)
	  , arraySlice = [].slice;

	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(88)(function(){
	  if(html)arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end){
	    var len   = toLength(this.length)
	      , klass = cof(this);
	    end = end === undefined ? len : end;
	    if(klass == 'Array')return arraySlice.call(this, begin, end);
	    var start  = toIndex(begin, len)
	      , upTo   = toIndex(end, len)
	      , size   = toLength(upTo - start)
	      , cloned = Array(size)
	      , i      = 0;
	    for(; i < size; i++)cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export   = __webpack_require__(89)
	  , aFunction = __webpack_require__(102)
	  , toObject  = __webpack_require__(139)
	  , fails     = __webpack_require__(88)
	  , $sort     = [].sort
	  , test      = [1, 2, 3];

	$export($export.P + $export.F * (fails(function(){
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function(){
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(249)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn){
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export  = __webpack_require__(89)
	  , $forEach = __webpack_require__(253)(0)
	  , STRICT   = __webpack_require__(249)([].forEach, true);

	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */){
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx      = __webpack_require__(101)
	  , IObject  = __webpack_require__(114)
	  , toObject = __webpack_require__(139)
	  , toLength = __webpack_require__(118)
	  , asc      = __webpack_require__(254);
	module.exports = function(TYPE, $create){
	  var IS_MAP        = TYPE == 1
	    , IS_FILTER     = TYPE == 2
	    , IS_SOME       = TYPE == 3
	    , IS_EVERY      = TYPE == 4
	    , IS_FIND_INDEX = TYPE == 6
	    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX
	    , create        = $create || asc;
	  return function($this, callbackfn, that){
	    var O      = toObject($this)
	      , self   = IObject(O)
	      , f      = ctx(callbackfn, that, 3)
	      , length = toLength(self.length)
	      , index  = 0
	      , result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined
	      , val, res;
	    for(;length > index; index++)if(NO_HOLES || index in self){
	      val = self[index];
	      res = f(val, index, O);
	      if(TYPE){
	        if(IS_MAP)result[index] = res;            // map
	        else if(res)switch(TYPE){
	          case 3: return true;                    // some
	          case 5: return val;                     // find
	          case 6: return index;                   // findIndex
	          case 2: result.push(val);               // filter
	        } else if(IS_EVERY)return false;          // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(255);

	module.exports = function(original, length){
	  return new (speciesConstructor(original))(length);
	};

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(94)
	  , isArray  = __webpack_require__(126)
	  , SPECIES  = __webpack_require__(106)('species');

	module.exports = function(original){
	  var C;
	  if(isArray(original)){
	    C = original.constructor;
	    // cross-realm fallback
	    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
	    if(isObject(C)){
	      C = C[SPECIES];
	      if(C === null)C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(89)
	  , $map    = __webpack_require__(253)(1);

	$export($export.P + $export.F * !__webpack_require__(249)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */){
	    return $map(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(89)
	  , $filter = __webpack_require__(253)(2);

	$export($export.P + $export.F * !__webpack_require__(249)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */){
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(89)
	  , $some   = __webpack_require__(253)(3);

	$export($export.P + $export.F * !__webpack_require__(249)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */){
	    return $some(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(89)
	  , $every  = __webpack_require__(253)(4);

	$export($export.P + $export.F * !__webpack_require__(249)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */){
	    return $every(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(89)
	  , $reduce = __webpack_require__(261);

	$export($export.P + $export.F * !__webpack_require__(249)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */){
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(102)
	  , toObject  = __webpack_require__(139)
	  , IObject   = __webpack_require__(114)
	  , toLength  = __webpack_require__(118);

	module.exports = function(that, callbackfn, aLen, memo, isRight){
	  aFunction(callbackfn);
	  var O      = toObject(that)
	    , self   = IObject(O)
	    , length = toLength(O.length)
	    , index  = isRight ? length - 1 : 0
	    , i      = isRight ? -1 : 1;
	  if(aLen < 2)for(;;){
	    if(index in self){
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if(isRight ? index < 0 : length <= index){
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for(;isRight ? index >= 0 : length > index; index += i)if(index in self){
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(89)
	  , $reduce = __webpack_require__(261);

	$export($export.P + $export.F * !__webpack_require__(249)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */){
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export       = __webpack_require__(89)
	  , $indexOf      = __webpack_require__(117)(false)
	  , $native       = [].indexOf
	  , NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(249)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /*, fromIndex = 0 */){
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export       = __webpack_require__(89)
	  , toIObject     = __webpack_require__(113)
	  , toInteger     = __webpack_require__(119)
	  , toLength      = __webpack_require__(118)
	  , $native       = [].lastIndexOf
	  , NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(249)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /*, fromIndex = @[*-1] */){
	    // convert -0 to +0
	    if(NEGATIVE_ZERO)return $native.apply(this, arguments) || 0;
	    var O      = toIObject(this)
	      , length = toLength(O.length)
	      , index  = length - 1;
	    if(arguments.length > 1)index = Math.min(index, toInteger(arguments[1]));
	    if(index < 0)index = length + index;
	    for(;index >= 0; index--)if(index in O)if(O[index] === searchElement)return index || 0;
	    return -1;
	  }
	});

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(89);

	$export($export.P, 'Array', {copyWithin: __webpack_require__(266)});

	__webpack_require__(267)('copyWithin');

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(139)
	  , toIndex  = __webpack_require__(120)
	  , toLength = __webpack_require__(118);

	module.exports = [].copyWithin || function copyWithin(target/*= 0*/, start/*= 0, end = @length*/){
	  var O     = toObject(this)
	    , len   = toLength(O.length)
	    , to    = toIndex(target, len)
	    , from  = toIndex(start, len)
	    , end   = arguments.length > 2 ? arguments[2] : undefined
	    , count = Math.min((end === undefined ? len : toIndex(end, len)) - from, len - to)
	    , inc   = 1;
	  if(from < to && to < from + count){
	    inc  = -1;
	    from += count - 1;
	    to   += count - 1;
	  }
	  while(count-- > 0){
	    if(from in O)O[to] = O[from];
	    else delete O[to];
	    to   += inc;
	    from += inc;
	  } return O;
	};

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(106)('unscopables')
	  , ArrayProto  = Array.prototype;
	if(ArrayProto[UNSCOPABLES] == undefined)__webpack_require__(91)(ArrayProto, UNSCOPABLES, {});
	module.exports = function(key){
	  ArrayProto[UNSCOPABLES][key] = true;
	};

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(89);

	$export($export.P, 'Array', {fill: __webpack_require__(269)});

	__webpack_require__(267)('fill');

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(139)
	  , toIndex  = __webpack_require__(120)
	  , toLength = __webpack_require__(118);
	module.exports = function fill(value /*, start = 0, end = @length */){
	  var O      = toObject(this)
	    , length = toLength(O.length)
	    , aLen   = arguments.length
	    , index  = toIndex(aLen > 1 ? arguments[1] : undefined, length)
	    , end    = aLen > 2 ? arguments[2] : undefined
	    , endPos = end === undefined ? length : toIndex(end, length);
	  while(endPos > index)O[index++] = value;
	  return O;
	};

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(89)
	  , $find   = __webpack_require__(253)(5)
	  , KEY     = 'find'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(267)(KEY);

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(89)
	  , $find   = __webpack_require__(253)(6)
	  , KEY     = 'findIndex'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(267)(KEY);

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(273)('Array');

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global      = __webpack_require__(85)
	  , dP          = __webpack_require__(92)
	  , DESCRIPTORS = __webpack_require__(87)
	  , SPECIES     = __webpack_require__(106)('species');

	module.exports = function(KEY){
	  var C = global[KEY];
	  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
	    configurable: true,
	    get: function(){ return this; }
	  });
	};

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(267)
	  , step             = __webpack_require__(275)
	  , Iterators        = __webpack_require__(210)
	  , toIObject        = __webpack_require__(113);

	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(209)(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');

	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;

	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

/***/ },
/* 275 */
/***/ function(module, exports) {

	module.exports = function(done, value){
	  return {value: value, done: !!done};
	};

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	var global            = __webpack_require__(85)
	  , inheritIfRequired = __webpack_require__(169)
	  , dP                = __webpack_require__(92).f
	  , gOPN              = __webpack_require__(131).f
	  , isRegExp          = __webpack_require__(215)
	  , $flags            = __webpack_require__(277)
	  , $RegExp           = global.RegExp
	  , Base              = $RegExp
	  , proto             = $RegExp.prototype
	  , re1               = /a/g
	  , re2               = /a/g
	  // "new" creates a new object, old webkit buggy here
	  , CORRECT_NEW       = new $RegExp(re1) !== re1;

	if(__webpack_require__(87) && (!CORRECT_NEW || __webpack_require__(88)(function(){
	  re2[__webpack_require__(106)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))){
	  $RegExp = function RegExp(p, f){
	    var tiRE = this instanceof $RegExp
	      , piRE = isRegExp(p)
	      , fiU  = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function(key){
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function(){ return Base[key]; },
	      set: function(it){ Base[key] = it; }
	    });
	  };
	  for(var keys = gOPN(Base), i = 0; keys.length > i; )proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(99)(global, 'RegExp', $RegExp);
	}

	__webpack_require__(273)('RegExp');

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(93);
	module.exports = function(){
	  var that   = anObject(this)
	    , result = '';
	  if(that.global)     result += 'g';
	  if(that.ignoreCase) result += 'i';
	  if(that.multiline)  result += 'm';
	  if(that.unicode)    result += 'u';
	  if(that.sticky)     result += 'y';
	  return result;
	};

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(279);
	var anObject    = __webpack_require__(93)
	  , $flags      = __webpack_require__(277)
	  , DESCRIPTORS = __webpack_require__(87)
	  , TO_STRING   = 'toString'
	  , $toString   = /./[TO_STRING];

	var define = function(fn){
	  __webpack_require__(99)(RegExp.prototype, TO_STRING, fn, true);
	};

	// 21.2.5.14 RegExp.prototype.toString()
	if(__webpack_require__(88)(function(){ return $toString.call({source: 'a', flags: 'b'}) != '/a/b'; })){
	  define(function toString(){
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if($toString.name != TO_STRING){
	  define(function toString(){
	    return $toString.call(this);
	  });
	}

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if(__webpack_require__(87) && /./g.flags != 'g')__webpack_require__(92).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(277)
	});

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	// @@match logic
	__webpack_require__(281)('match', 1, function(defined, MATCH, $match){
	  // 21.1.3.11 String.prototype.match(regexp)
	  return [function match(regexp){
	    'use strict';
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[MATCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	  }, $match];
	});

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var hide     = __webpack_require__(91)
	  , redefine = __webpack_require__(99)
	  , fails    = __webpack_require__(88)
	  , defined  = __webpack_require__(116)
	  , wks      = __webpack_require__(106);

	module.exports = function(KEY, length, exec){
	  var SYMBOL   = wks(KEY)
	    , fns      = exec(defined, SYMBOL, ''[KEY])
	    , strfn    = fns[0]
	    , rxfn     = fns[1];
	  if(fails(function(){
	    var O = {};
	    O[SYMBOL] = function(){ return 7; };
	    return ''[KEY](O) != 7;
	  })){
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function(string, arg){ return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function(string){ return rxfn.call(string, this); }
	    );
	  }
	};

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	// @@replace logic
	__webpack_require__(281)('replace', 2, function(defined, REPLACE, $replace){
	  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
	  return [function replace(searchValue, replaceValue){
	    'use strict';
	    var O  = defined(this)
	      , fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	    return fn !== undefined
	      ? fn.call(searchValue, O, replaceValue)
	      : $replace.call(String(O), searchValue, replaceValue);
	  }, $replace];
	});

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	// @@search logic
	__webpack_require__(281)('search', 1, function(defined, SEARCH, $search){
	  // 21.1.3.15 String.prototype.search(regexp)
	  return [function search(regexp){
	    'use strict';
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[SEARCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	  }, $search];
	});

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	// @@split logic
	__webpack_require__(281)('split', 2, function(defined, SPLIT, $split){
	  'use strict';
	  var isRegExp   = __webpack_require__(215)
	    , _split     = $split
	    , $push      = [].push
	    , $SPLIT     = 'split'
	    , LENGTH     = 'length'
	    , LAST_INDEX = 'lastIndex';
	  if(
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ){
	    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
	    // based on es5-shim implementation, need to rework it
	    $split = function(separator, limit){
	      var string = String(this);
	      if(separator === undefined && limit === 0)return [];
	      // If `separator` is not a regex, use native split
	      if(!isRegExp(separator))return _split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var separator2, match, lastIndex, lastLength, i;
	      // Doesn't need flags gy, but they don't hurt
	      if(!NPCG)separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
	      while(match = separatorCopy.exec(string)){
	        // `separatorCopy.lastIndex` is not reliable cross-browser
	        lastIndex = match.index + match[0][LENGTH];
	        if(lastIndex > lastLastIndex){
	          output.push(string.slice(lastLastIndex, match.index));
	          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
	          if(!NPCG && match[LENGTH] > 1)match[0].replace(separator2, function(){
	            for(i = 1; i < arguments[LENGTH] - 2; i++)if(arguments[i] === undefined)match[i] = undefined;
	          });
	          if(match[LENGTH] > 1 && match.index < string[LENGTH])$push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if(output[LENGTH] >= splitLimit)break;
	        }
	        if(separatorCopy[LAST_INDEX] === match.index)separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if(lastLastIndex === string[LENGTH]){
	        if(lastLength || !separatorCopy.test(''))output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if('0'[$SPLIT](undefined, 0)[LENGTH]){
	    $split = function(separator, limit){
	      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
	    };
	  }
	  // 21.1.3.17 String.prototype.split(separator, limit)
	  return [function split(separator, limit){
	    var O  = defined(this)
	      , fn = separator == undefined ? undefined : separator[SPLIT];
	    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
	  }, $split];
	});

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY            = __webpack_require__(109)
	  , global             = __webpack_require__(85)
	  , ctx                = __webpack_require__(101)
	  , classof            = __webpack_require__(156)
	  , $export            = __webpack_require__(89)
	  , isObject           = __webpack_require__(94)
	  , aFunction          = __webpack_require__(102)
	  , anInstance         = __webpack_require__(286)
	  , forOf              = __webpack_require__(287)
	  , speciesConstructor = __webpack_require__(288)
	  , task               = __webpack_require__(289).set
	  , microtask          = __webpack_require__(290)()
	  , PROMISE            = 'Promise'
	  , TypeError          = global.TypeError
	  , process            = global.process
	  , $Promise           = global[PROMISE]
	  , process            = global.process
	  , isNode             = classof(process) == 'process'
	  , empty              = function(){ /* empty */ }
	  , Internal, GenericPromiseCapability, Wrapper;

	var USE_NATIVE = !!function(){
	  try {
	    // correct subclassing with @@species support
	    var promise     = $Promise.resolve(1)
	      , FakePromise = (promise.constructor = {})[__webpack_require__(106)('species')] = function(exec){ exec(empty, empty); };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	  } catch(e){ /* empty */ }
	}();

	// helpers
	var sameConstructor = function(a, b){
	  // with library wrapper special case
	  return a === b || a === $Promise && b === Wrapper;
	};
	var isThenable = function(it){
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var newPromiseCapability = function(C){
	  return sameConstructor($Promise, C)
	    ? new PromiseCapability(C)
	    : new GenericPromiseCapability(C);
	};
	var PromiseCapability = GenericPromiseCapability = function(C){
	  var resolve, reject;
	  this.promise = new C(function($$resolve, $$reject){
	    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject  = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject  = aFunction(reject);
	};
	var perform = function(exec){
	  try {
	    exec();
	  } catch(e){
	    return {error: e};
	  }
	};
	var notify = function(promise, isReject){
	  if(promise._n)return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function(){
	    var value = promise._v
	      , ok    = promise._s == 1
	      , i     = 0;
	    var run = function(reaction){
	      var handler = ok ? reaction.ok : reaction.fail
	        , resolve = reaction.resolve
	        , reject  = reaction.reject
	        , domain  = reaction.domain
	        , result, then;
	      try {
	        if(handler){
	          if(!ok){
	            if(promise._h == 2)onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if(handler === true)result = value;
	          else {
	            if(domain)domain.enter();
	            result = handler(value);
	            if(domain)domain.exit();
	          }
	          if(result === reaction.promise){
	            reject(TypeError('Promise-chain cycle'));
	          } else if(then = isThenable(result)){
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch(e){
	        reject(e);
	      }
	    };
	    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if(isReject && !promise._h)onUnhandled(promise);
	  });
	};
	var onUnhandled = function(promise){
	  task.call(global, function(){
	    var value = promise._v
	      , abrupt, handler, console;
	    if(isUnhandled(promise)){
	      abrupt = perform(function(){
	        if(isNode){
	          process.emit('unhandledRejection', value, promise);
	        } else if(handler = global.onunhandledrejection){
	          handler({promise: promise, reason: value});
	        } else if((console = global.console) && console.error){
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if(abrupt)throw abrupt.error;
	  });
	};
	var isUnhandled = function(promise){
	  if(promise._h == 1)return false;
	  var chain = promise._a || promise._c
	    , i     = 0
	    , reaction;
	  while(chain.length > i){
	    reaction = chain[i++];
	    if(reaction.fail || !isUnhandled(reaction.promise))return false;
	  } return true;
	};
	var onHandleUnhandled = function(promise){
	  task.call(global, function(){
	    var handler;
	    if(isNode){
	      process.emit('rejectionHandled', promise);
	    } else if(handler = global.onrejectionhandled){
	      handler({promise: promise, reason: promise._v});
	    }
	  });
	};
	var $reject = function(value){
	  var promise = this;
	  if(promise._d)return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if(!promise._a)promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function(value){
	  var promise = this
	    , then;
	  if(promise._d)return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if(promise === value)throw TypeError("Promise can't be resolved itself");
	    if(then = isThenable(value)){
	      microtask(function(){
	        var wrapper = {_w: promise, _d: false}; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch(e){
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch(e){
	    $reject.call({_w: promise, _d: false}, e); // wrap
	  }
	};

	// constructor polyfill
	if(!USE_NATIVE){
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor){
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch(err){
	      $reject.call(this, err);
	    }
	  };
	  Internal = function Promise(executor){
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(291)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected){
	      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail   = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if(this._a)this._a.push(reaction);
	      if(this._s)notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function(onRejected){
	      return this.then(undefined, onRejected);
	    }
	  });
	  PromiseCapability = function(){
	    var promise  = new Internal;
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject  = ctx($reject, promise, 1);
	  };
	}

	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
	__webpack_require__(105)($Promise, PROMISE);
	__webpack_require__(273)(PROMISE);
	Wrapper = __webpack_require__(90)[PROMISE];

	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r){
	    var capability = newPromiseCapability(this)
	      , $$reject   = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x){
	    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
	    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
	    var capability = newPromiseCapability(this)
	      , $$resolve  = capability.resolve;
	    $$resolve(x);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(246)(function(iter){
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable){
	    var C          = this
	      , capability = newPromiseCapability(C)
	      , resolve    = capability.resolve
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      var values    = []
	        , index     = 0
	        , remaining = 1;
	      forOf(iterable, false, function(promise){
	        var $index        = index++
	          , alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function(value){
	          if(alreadyCalled)return;
	          alreadyCalled  = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable){
	    var C          = this
	      , capability = newPromiseCapability(C)
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      forOf(iterable, false, function(promise){
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  }
	});

/***/ },
/* 286 */
/***/ function(module, exports) {

	module.exports = function(it, Constructor, name, forbiddenField){
	  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	var ctx         = __webpack_require__(101)
	  , call        = __webpack_require__(242)
	  , isArrayIter = __webpack_require__(243)
	  , anObject    = __webpack_require__(93)
	  , toLength    = __webpack_require__(118)
	  , getIterFn   = __webpack_require__(245)
	  , BREAK       = {}
	  , RETURN      = {};
	var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
	  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
	    , f      = ctx(fn, that, entries ? 2 : 1)
	    , index  = 0
	    , length, step, iterator, result;
	  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if(result === BREAK || result === RETURN)return result;
	  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
	    result = call(iterator, f, step.value, entries);
	    if(result === BREAK || result === RETURN)return result;
	  }
	};
	exports.BREAK  = BREAK;
	exports.RETURN = RETURN;

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject  = __webpack_require__(93)
	  , aFunction = __webpack_require__(102)
	  , SPECIES   = __webpack_require__(106)('species');
	module.exports = function(O, D){
	  var C = anObject(O).constructor, S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	var ctx                = __webpack_require__(101)
	  , invoke             = __webpack_require__(159)
	  , html               = __webpack_require__(129)
	  , cel                = __webpack_require__(96)
	  , global             = __webpack_require__(85)
	  , process            = global.process
	  , setTask            = global.setImmediate
	  , clearTask          = global.clearImmediate
	  , MessageChannel     = global.MessageChannel
	  , counter            = 0
	  , queue              = {}
	  , ONREADYSTATECHANGE = 'onreadystatechange'
	  , defer, channel, port;
	var run = function(){
	  var id = +this;
	  if(queue.hasOwnProperty(id)){
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function(event){
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if(!setTask || !clearTask){
	  setTask = function setImmediate(fn){
	    var args = [], i = 1;
	    while(arguments.length > i)args.push(arguments[i++]);
	    queue[++counter] = function(){
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id){
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if(__webpack_require__(115)(process) == 'process'){
	    defer = function(id){
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if(MessageChannel){
	    channel = new MessageChannel;
	    port    = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
	    defer = function(id){
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if(ONREADYSTATECHANGE in cel('script')){
	    defer = function(id){
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function(id){
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set:   setTask,
	  clear: clearTask
	};

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(85)
	  , macrotask = __webpack_require__(289).set
	  , Observer  = global.MutationObserver || global.WebKitMutationObserver
	  , process   = global.process
	  , Promise   = global.Promise
	  , isNode    = __webpack_require__(115)(process) == 'process';

	module.exports = function(){
	  var head, last, notify;

	  var flush = function(){
	    var parent, fn;
	    if(isNode && (parent = process.domain))parent.exit();
	    while(head){
	      fn   = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch(e){
	        if(head)notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if(parent)parent.enter();
	  };

	  // Node.js
	  if(isNode){
	    notify = function(){
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver
	  } else if(Observer){
	    var toggle = true
	      , node   = document.createTextNode('');
	    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
	    notify = function(){
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if(Promise && Promise.resolve){
	    var promise = Promise.resolve();
	    notify = function(){
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function(){
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }

	  return function(fn){
	    var task = {fn: fn, next: undefined};
	    if(last)last.next = task;
	    if(!head){
	      head = task;
	      notify();
	    } last = task;
	  };
	};

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(99);
	module.exports = function(target, src, safe){
	  for(var key in src)redefine(target, key, src[key], safe);
	  return target;
	};

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(293);

	// 23.1 Map Objects
	module.exports = __webpack_require__(294)('Map', function(get){
	  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key){
	    var entry = strong.getEntry(this, key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value){
	    return strong.def(this, key === 0 ? 0 : key, value);
	  }
	}, strong, true);

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var dP          = __webpack_require__(92).f
	  , create      = __webpack_require__(127)
	  , redefineAll = __webpack_require__(291)
	  , ctx         = __webpack_require__(101)
	  , anInstance  = __webpack_require__(286)
	  , defined     = __webpack_require__(116)
	  , forOf       = __webpack_require__(287)
	  , $iterDefine = __webpack_require__(209)
	  , step        = __webpack_require__(275)
	  , setSpecies  = __webpack_require__(273)
	  , DESCRIPTORS = __webpack_require__(87)
	  , fastKey     = __webpack_require__(103).fastKey
	  , SIZE        = DESCRIPTORS ? '_s' : 'size';

	var getEntry = function(that, key){
	  // fast case
	  var index = fastKey(key), entry;
	  if(index !== 'F')return that._i[index];
	  // frozen object case
	  for(entry = that._f; entry; entry = entry.n){
	    if(entry.k == key)return entry;
	  }
	};

	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      anInstance(that, C, NAME, '_i');
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear(){
	        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
	          entry.r = true;
	          if(entry.p)entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function(key){
	        var that  = this
	          , entry = getEntry(that, key);
	        if(entry){
	          var next = entry.n
	            , prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if(prev)prev.n = next;
	          if(next)next.p = prev;
	          if(that._f == entry)that._f = next;
	          if(that._l == entry)that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /*, that = undefined */){
	        anInstance(this, C, 'forEach');
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
	          , entry;
	        while(entry = entry ? entry.n : this._f){
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while(entry && entry.r)entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key){
	        return !!getEntry(this, key);
	      }
	    });
	    if(DESCRIPTORS)dP(C.prototype, 'size', {
	      get: function(){
	        return defined(this[SIZE]);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var entry = getEntry(that, key)
	      , prev, index;
	    // change existing entry
	    if(entry){
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if(!that._f)that._f = entry;
	      if(prev)prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if(index !== 'F')that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function(C, NAME, IS_MAP){
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function(iterated, kind){
	      this._t = iterated;  // target
	      this._k = kind;      // kind
	      this._l = undefined; // previous
	    }, function(){
	      var that  = this
	        , kind  = that._k
	        , entry = that._l;
	      // revert to the last existing entry
	      while(entry && entry.r)entry = entry.p;
	      // get next entry
	      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if(kind == 'keys'  )return step(0, entry.k);
	      if(kind == 'values')return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);

	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global            = __webpack_require__(85)
	  , $export           = __webpack_require__(89)
	  , redefine          = __webpack_require__(99)
	  , redefineAll       = __webpack_require__(291)
	  , meta              = __webpack_require__(103)
	  , forOf             = __webpack_require__(287)
	  , anInstance        = __webpack_require__(286)
	  , isObject          = __webpack_require__(94)
	  , fails             = __webpack_require__(88)
	  , $iterDetect       = __webpack_require__(246)
	  , setToStringTag    = __webpack_require__(105)
	  , inheritIfRequired = __webpack_require__(169);

	module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
	  var Base  = global[NAME]
	    , C     = Base
	    , ADDER = IS_MAP ? 'set' : 'add'
	    , proto = C && C.prototype
	    , O     = {};
	  var fixMethod = function(KEY){
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a){
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a){ fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b){ fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if(typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
	    new C().entries().next();
	  }))){
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance             = new C
	      // early implementations not supports chaining
	      , HASNT_CHAINING       = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance
	      // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	      , THROWS_ON_PRIMITIVES = fails(function(){ instance.has(1); })
	      // most early implementations doesn't supports iterables, most modern - not close it correctly
	      , ACCEPT_ITERABLES     = $iterDetect(function(iter){ new C(iter); }) // eslint-disable-line no-new
	      // for early implementations -0 and +0 not the same
	      , BUGGY_ZERO = !IS_WEAK && fails(function(){
	        // V8 ~ Chromium 42- fails only with 5+ elements
	        var $instance = new C()
	          , index     = 5;
	        while(index--)$instance[ADDER](index, index);
	        return !$instance.has(-0);
	      });
	    if(!ACCEPT_ITERABLES){ 
	      C = wrapper(function(target, iterable){
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base, target, C);
	        if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if(THROWS_ON_PRIMITIVES || BUGGY_ZERO){
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if(BUGGY_ZERO || HASNT_CHAINING)fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if(IS_WEAK && proto.clear)delete proto.clear;
	  }

	  setToStringTag(C, NAME);

	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);

	  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);

	  return C;
	};

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(293);

	// 23.2 Set Objects
	module.exports = __webpack_require__(294)('Set', function(get){
	  return function Set(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value){
	    return strong.def(this, value = value === 0 ? 0 : value, value);
	  }
	}, strong);

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var each         = __webpack_require__(253)(0)
	  , redefine     = __webpack_require__(99)
	  , meta         = __webpack_require__(103)
	  , assign       = __webpack_require__(150)
	  , weak         = __webpack_require__(297)
	  , isObject     = __webpack_require__(94)
	  , getWeak      = meta.getWeak
	  , isExtensible = Object.isExtensible
	  , uncaughtFrozenStore = weak.ufstore
	  , tmp          = {}
	  , InternalMap;

	var wrapper = function(get){
	  return function WeakMap(){
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};

	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key){
	    if(isObject(key)){
	      var data = getWeak(key);
	      if(data === true)return uncaughtFrozenStore(this).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value){
	    return weak.def(this, key, value);
	  }
	};

	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(294)('WeakMap', wrapper, methods, weak, true, true);

	// IE11 WeakMap frozen keys fix
	if(new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7){
	  InternalMap = weak.getConstructor(wrapper);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function(key){
	    var proto  = $WeakMap.prototype
	      , method = proto[key];
	    redefine(proto, key, function(a, b){
	      // store frozen objects on internal weakmap shim
	      if(isObject(a) && !isExtensible(a)){
	        if(!this._f)this._f = new InternalMap;
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll       = __webpack_require__(291)
	  , getWeak           = __webpack_require__(103).getWeak
	  , anObject          = __webpack_require__(93)
	  , isObject          = __webpack_require__(94)
	  , anInstance        = __webpack_require__(286)
	  , forOf             = __webpack_require__(287)
	  , createArrayMethod = __webpack_require__(253)
	  , $has              = __webpack_require__(86)
	  , arrayFind         = createArrayMethod(5)
	  , arrayFindIndex    = createArrayMethod(6)
	  , id                = 0;

	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function(that){
	  return that._l || (that._l = new UncaughtFrozenStore);
	};
	var UncaughtFrozenStore = function(){
	  this.a = [];
	};
	var findUncaughtFrozen = function(store, key){
	  return arrayFind(store.a, function(it){
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function(key){
	    var entry = findUncaughtFrozen(this, key);
	    if(entry)return entry[1];
	  },
	  has: function(key){
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function(key, value){
	    var entry = findUncaughtFrozen(this, key);
	    if(entry)entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function(key){
	    var index = arrayFindIndex(this.a, function(it){
	      return it[0] === key;
	    });
	    if(~index)this.a.splice(index, 1);
	    return !!~index;
	  }
	};

	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      anInstance(that, C, NAME, '_i');
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function(key){
	        if(!isObject(key))return false;
	        var data = getWeak(key);
	        if(data === true)return uncaughtFrozenStore(this)['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key){
	        if(!isObject(key))return false;
	        var data = getWeak(key);
	        if(data === true)return uncaughtFrozenStore(this).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var data = getWeak(anObject(key), true);
	    if(data === true)uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(297);

	// 23.4 WeakSet Objects
	__webpack_require__(294)('WeakSet', function(get){
	  return function WeakSet(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value){
	    return weak.def(this, value, true);
	  }
	}, weak, false, true);

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(89)
	  , $typed       = __webpack_require__(300)
	  , buffer       = __webpack_require__(301)
	  , anObject     = __webpack_require__(93)
	  , toIndex      = __webpack_require__(120)
	  , toLength     = __webpack_require__(118)
	  , isObject     = __webpack_require__(94)
	  , ArrayBuffer  = __webpack_require__(85).ArrayBuffer
	  , speciesConstructor = __webpack_require__(288)
	  , $ArrayBuffer = buffer.ArrayBuffer
	  , $DataView    = buffer.DataView
	  , $isView      = $typed.ABV && ArrayBuffer.isView
	  , $slice       = $ArrayBuffer.prototype.slice
	  , VIEW         = $typed.VIEW
	  , ARRAY_BUFFER = 'ArrayBuffer';

	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), {ArrayBuffer: $ArrayBuffer});

	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it){
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});

	$export($export.P + $export.U + $export.F * __webpack_require__(88)(function(){
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end){
	    if($slice !== undefined && end === undefined)return $slice.call(anObject(this), start); // FF fix
	    var len    = anObject(this).byteLength
	      , first  = toIndex(start, len)
	      , final  = toIndex(end === undefined ? len : end, len)
	      , result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first))
	      , viewS  = new $DataView(this)
	      , viewT  = new $DataView(result)
	      , index  = 0;
	    while(first < final){
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});

	__webpack_require__(273)(ARRAY_BUFFER);

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(85)
	  , hide   = __webpack_require__(91)
	  , uid    = __webpack_require__(100)
	  , TYPED  = uid('typed_array')
	  , VIEW   = uid('view')
	  , ABV    = !!(global.ArrayBuffer && global.DataView)
	  , CONSTR = ABV
	  , i = 0, l = 9, Typed;

	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');

	while(i < l){
	  if(Typed = global[TypedArrayConstructors[i++]]){
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}

	module.exports = {
	  ABV:    ABV,
	  CONSTR: CONSTR,
	  TYPED:  TYPED,
	  VIEW:   VIEW
	};

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global         = __webpack_require__(85)
	  , DESCRIPTORS    = __webpack_require__(87)
	  , LIBRARY        = __webpack_require__(109)
	  , $typed         = __webpack_require__(300)
	  , hide           = __webpack_require__(91)
	  , redefineAll    = __webpack_require__(291)
	  , fails          = __webpack_require__(88)
	  , anInstance     = __webpack_require__(286)
	  , toInteger      = __webpack_require__(119)
	  , toLength       = __webpack_require__(118)
	  , gOPN           = __webpack_require__(131).f
	  , dP             = __webpack_require__(92).f
	  , arrayFill      = __webpack_require__(269)
	  , setToStringTag = __webpack_require__(105)
	  , ARRAY_BUFFER   = 'ArrayBuffer'
	  , DATA_VIEW      = 'DataView'
	  , PROTOTYPE      = 'prototype'
	  , WRONG_LENGTH   = 'Wrong length!'
	  , WRONG_INDEX    = 'Wrong index!'
	  , $ArrayBuffer   = global[ARRAY_BUFFER]
	  , $DataView      = global[DATA_VIEW]
	  , Math           = global.Math
	  , RangeError     = global.RangeError
	  , Infinity       = global.Infinity
	  , BaseBuffer     = $ArrayBuffer
	  , abs            = Math.abs
	  , pow            = Math.pow
	  , floor          = Math.floor
	  , log            = Math.log
	  , LN2            = Math.LN2
	  , BUFFER         = 'buffer'
	  , BYTE_LENGTH    = 'byteLength'
	  , BYTE_OFFSET    = 'byteOffset'
	  , $BUFFER        = DESCRIPTORS ? '_b' : BUFFER
	  , $LENGTH        = DESCRIPTORS ? '_l' : BYTE_LENGTH
	  , $OFFSET        = DESCRIPTORS ? '_o' : BYTE_OFFSET;

	// IEEE754 conversions based on https://github.com/feross/ieee754
	var packIEEE754 = function(value, mLen, nBytes){
	  var buffer = Array(nBytes)
	    , eLen   = nBytes * 8 - mLen - 1
	    , eMax   = (1 << eLen) - 1
	    , eBias  = eMax >> 1
	    , rt     = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0
	    , i      = 0
	    , s      = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0
	    , e, m, c;
	  value = abs(value)
	  if(value != value || value === Infinity){
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if(value * (c = pow(2, -e)) < 1){
	      e--;
	      c *= 2;
	    }
	    if(e + eBias >= 1){
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if(value * c >= 2){
	      e++;
	      c /= 2;
	    }
	    if(e + eBias >= eMax){
	      m = 0;
	      e = eMax;
	    } else if(e + eBias >= 1){
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for(; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for(; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	};
	var unpackIEEE754 = function(buffer, mLen, nBytes){
	  var eLen  = nBytes * 8 - mLen - 1
	    , eMax  = (1 << eLen) - 1
	    , eBias = eMax >> 1
	    , nBits = eLen - 7
	    , i     = nBytes - 1
	    , s     = buffer[i--]
	    , e     = s & 127
	    , m;
	  s >>= 7;
	  for(; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for(; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if(e === 0){
	    e = 1 - eBias;
	  } else if(e === eMax){
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	};

	var unpackI32 = function(bytes){
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	};
	var packI8 = function(it){
	  return [it & 0xff];
	};
	var packI16 = function(it){
	  return [it & 0xff, it >> 8 & 0xff];
	};
	var packI32 = function(it){
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	};
	var packF64 = function(it){
	  return packIEEE754(it, 52, 8);
	};
	var packF32 = function(it){
	  return packIEEE754(it, 23, 4);
	};

	var addGetter = function(C, key, internal){
	  dP(C[PROTOTYPE], key, {get: function(){ return this[internal]; }});
	};

	var get = function(view, bytes, index, isLittleEndian){
	  var numIndex = +index
	    , intIndex = toInteger(numIndex);
	  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b
	    , start = intIndex + view[$OFFSET]
	    , pack  = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	};
	var set = function(view, bytes, index, conversion, value, isLittleEndian){
	  var numIndex = +index
	    , intIndex = toInteger(numIndex);
	  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b
	    , start = intIndex + view[$OFFSET]
	    , pack  = conversion(+value);
	  for(var i = 0; i < bytes; i++)store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	};

	var validateArrayBufferArguments = function(that, length){
	  anInstance(that, $ArrayBuffer, ARRAY_BUFFER);
	  var numberLength = +length
	    , byteLength   = toLength(numberLength);
	  if(numberLength != byteLength)throw RangeError(WRONG_LENGTH);
	  return byteLength;
	};

	if(!$typed.ABV){
	  $ArrayBuffer = function ArrayBuffer(length){
	    var byteLength = validateArrayBufferArguments(this, length);
	    this._b       = arrayFill.call(Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };

	  $DataView = function DataView(buffer, byteOffset, byteLength){
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH]
	      , offset       = toInteger(byteOffset);
	    if(offset < 0 || offset > bufferLength)throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if(offset + byteLength > bufferLength)throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };

	  if(DESCRIPTORS){
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }

	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset){
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset){
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /*, littleEndian */){
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /*, littleEndian */){
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /*, littleEndian */){
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /*, littleEndian */){
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /*, littleEndian */){
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /*, littleEndian */){
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value){
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value){
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /*, littleEndian */){
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /*, littleEndian */){
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /*, littleEndian */){
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if(!fails(function(){
	    new $ArrayBuffer;     // eslint-disable-line no-new
	  }) || !fails(function(){
	    new $ArrayBuffer(.5); // eslint-disable-line no-new
	  })){
	    $ArrayBuffer = function ArrayBuffer(length){
	      return new BaseBuffer(validateArrayBufferArguments(this, length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for(var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j; ){
	      if(!((key = keys[j++]) in $ArrayBuffer))hide($ArrayBuffer, key, BaseBuffer[key]);
	    };
	    if(!LIBRARY)ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2))
	    , $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if(view.getInt8(0) || !view.getInt8(1))redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value){
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value){
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(89);
	$export($export.G + $export.W + $export.F * !__webpack_require__(300).ABV, {
	  DataView: __webpack_require__(301).DataView
	});

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(304)('Int8', 1, function(init){
	  return function Int8Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	if(__webpack_require__(87)){
	  var LIBRARY             = __webpack_require__(109)
	    , global              = __webpack_require__(85)
	    , fails               = __webpack_require__(88)
	    , $export             = __webpack_require__(89)
	    , $typed              = __webpack_require__(300)
	    , $buffer             = __webpack_require__(301)
	    , ctx                 = __webpack_require__(101)
	    , anInstance          = __webpack_require__(286)
	    , propertyDesc        = __webpack_require__(98)
	    , hide                = __webpack_require__(91)
	    , redefineAll         = __webpack_require__(291)
	    , toInteger           = __webpack_require__(119)
	    , toLength            = __webpack_require__(118)
	    , toIndex             = __webpack_require__(120)
	    , toPrimitive         = __webpack_require__(97)
	    , has                 = __webpack_require__(86)
	    , same                = __webpack_require__(152)
	    , classof             = __webpack_require__(156)
	    , isObject            = __webpack_require__(94)
	    , toObject            = __webpack_require__(139)
	    , isArrayIter         = __webpack_require__(243)
	    , create              = __webpack_require__(127)
	    , getPrototypeOf      = __webpack_require__(140)
	    , gOPN                = __webpack_require__(131).f
	    , getIterFn           = __webpack_require__(245)
	    , uid                 = __webpack_require__(100)
	    , wks                 = __webpack_require__(106)
	    , createArrayMethod   = __webpack_require__(253)
	    , createArrayIncludes = __webpack_require__(117)
	    , speciesConstructor  = __webpack_require__(288)
	    , ArrayIterators      = __webpack_require__(274)
	    , Iterators           = __webpack_require__(210)
	    , $iterDetect         = __webpack_require__(246)
	    , setSpecies          = __webpack_require__(273)
	    , arrayFill           = __webpack_require__(269)
	    , arrayCopyWithin     = __webpack_require__(266)
	    , $DP                 = __webpack_require__(92)
	    , $GOPD               = __webpack_require__(132)
	    , dP                  = $DP.f
	    , gOPD                = $GOPD.f
	    , RangeError          = global.RangeError
	    , TypeError           = global.TypeError
	    , Uint8Array          = global.Uint8Array
	    , ARRAY_BUFFER        = 'ArrayBuffer'
	    , SHARED_BUFFER       = 'Shared' + ARRAY_BUFFER
	    , BYTES_PER_ELEMENT   = 'BYTES_PER_ELEMENT'
	    , PROTOTYPE           = 'prototype'
	    , ArrayProto          = Array[PROTOTYPE]
	    , $ArrayBuffer        = $buffer.ArrayBuffer
	    , $DataView           = $buffer.DataView
	    , arrayForEach        = createArrayMethod(0)
	    , arrayFilter         = createArrayMethod(2)
	    , arraySome           = createArrayMethod(3)
	    , arrayEvery          = createArrayMethod(4)
	    , arrayFind           = createArrayMethod(5)
	    , arrayFindIndex      = createArrayMethod(6)
	    , arrayIncludes       = createArrayIncludes(true)
	    , arrayIndexOf        = createArrayIncludes(false)
	    , arrayValues         = ArrayIterators.values
	    , arrayKeys           = ArrayIterators.keys
	    , arrayEntries        = ArrayIterators.entries
	    , arrayLastIndexOf    = ArrayProto.lastIndexOf
	    , arrayReduce         = ArrayProto.reduce
	    , arrayReduceRight    = ArrayProto.reduceRight
	    , arrayJoin           = ArrayProto.join
	    , arraySort           = ArrayProto.sort
	    , arraySlice          = ArrayProto.slice
	    , arrayToString       = ArrayProto.toString
	    , arrayToLocaleString = ArrayProto.toLocaleString
	    , ITERATOR            = wks('iterator')
	    , TAG                 = wks('toStringTag')
	    , TYPED_CONSTRUCTOR   = uid('typed_constructor')
	    , DEF_CONSTRUCTOR     = uid('def_constructor')
	    , ALL_CONSTRUCTORS    = $typed.CONSTR
	    , TYPED_ARRAY         = $typed.TYPED
	    , VIEW                = $typed.VIEW
	    , WRONG_LENGTH        = 'Wrong length!';

	  var $map = createArrayMethod(1, function(O, length){
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });

	  var LITTLE_ENDIAN = fails(function(){
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });

	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function(){
	    new Uint8Array(1).set({});
	  });

	  var strictToLength = function(it, SAME){
	    if(it === undefined)throw TypeError(WRONG_LENGTH);
	    var number = +it
	      , length = toLength(it);
	    if(SAME && !same(number, length))throw RangeError(WRONG_LENGTH);
	    return length;
	  };

	  var toOffset = function(it, BYTES){
	    var offset = toInteger(it);
	    if(offset < 0 || offset % BYTES)throw RangeError('Wrong offset!');
	    return offset;
	  };

	  var validate = function(it){
	    if(isObject(it) && TYPED_ARRAY in it)return it;
	    throw TypeError(it + ' is not a typed array!');
	  };

	  var allocate = function(C, length){
	    if(!(isObject(C) && TYPED_CONSTRUCTOR in C)){
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };

	  var speciesFromList = function(O, list){
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };

	  var fromList = function(C, list){
	    var index  = 0
	      , length = list.length
	      , result = allocate(C, length);
	    while(length > index)result[index] = list[index++];
	    return result;
	  };

	  var addGetter = function(it, key, internal){
	    dP(it, key, {get: function(){ return this._d[internal]; }});
	  };

	  var $from = function from(source /*, mapfn, thisArg */){
	    var O       = toObject(source)
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , iterFn  = getIterFn(O)
	      , i, length, values, result, step, iterator;
	    if(iterFn != undefined && !isArrayIter(iterFn)){
	      for(iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++){
	        values.push(step.value);
	      } O = values;
	    }
	    if(mapping && aLen > 2)mapfn = ctx(mapfn, arguments[2], 2);
	    for(i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++){
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };

	  var $of = function of(/*...items*/){
	    var index  = 0
	      , length = arguments.length
	      , result = allocate(this, length);
	    while(length > index)result[index] = arguments[index++];
	    return result;
	  };

	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function(){ arrayToLocaleString.call(new Uint8Array(1)); });

	  var $toLocaleString = function toLocaleString(){
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };

	  var proto = {
	    copyWithin: function copyWithin(target, start /*, end */){
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /*, thisArg */){
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /*, start, end */){ // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /*, thisArg */){
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /*, thisArg */){
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /*, thisArg */){
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /*, thisArg */){
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /*, fromIndex */){
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /*, fromIndex */){
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator){ // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /*, fromIndex */){ // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /*, thisArg */){
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse(){
	      var that   = this
	        , length = validate(that).length
	        , middle = Math.floor(length / 2)
	        , index  = 0
	        , value;
	      while(index < middle){
	        value         = that[index];
	        that[index++] = that[--length];
	        that[length]  = value;
	      } return that;
	    },
	    some: function some(callbackfn /*, thisArg */){
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn){
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end){
	      var O      = validate(this)
	        , length = O.length
	        , $begin = toIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toIndex(end, length)) - $begin)
	      );
	    }
	  };

	  var $slice = function slice(start, end){
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };

	  var $set = function set(arrayLike /*, offset */){
	    validate(this);
	    var offset = toOffset(arguments[1], 1)
	      , length = this.length
	      , src    = toObject(arrayLike)
	      , len    = toLength(src.length)
	      , index  = 0;
	    if(len + offset > length)throw RangeError(WRONG_LENGTH);
	    while(index < len)this[offset + index] = src[index++];
	  };

	  var $iterators = {
	    entries: function entries(){
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys(){
	      return arrayKeys.call(validate(this));
	    },
	    values: function values(){
	      return arrayValues.call(validate(this));
	    }
	  };

	  var isTAIndex = function(target, key){
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key){
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc){
	    if(isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ){
	      target[key] = desc.value;
	      return target;
	    } else return dP(target, key, desc);
	  };

	  if(!ALL_CONSTRUCTORS){
	    $GOPD.f = $getDesc;
	    $DP.f   = $setDesc;
	  }

	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty:           $setDesc
	  });

	  if(fails(function(){ arrayToString.call({}); })){
	    arrayToString = arrayToLocaleString = function toString(){
	      return arrayJoin.call(this);
	    }
	  }

	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice:          $slice,
	    set:            $set,
	    constructor:    function(){ /* noop */ },
	    toString:       arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function(){ return this[TYPED_ARRAY]; }
	  });

	  module.exports = function(KEY, BYTES, wrapper, CLAMPED){
	    CLAMPED = !!CLAMPED;
	    var NAME       = KEY + (CLAMPED ? 'Clamped' : '') + 'Array'
	      , ISNT_UINT8 = NAME != 'Uint8Array'
	      , GETTER     = 'get' + KEY
	      , SETTER     = 'set' + KEY
	      , TypedArray = global[NAME]
	      , Base       = TypedArray || {}
	      , TAC        = TypedArray && getPrototypeOf(TypedArray)
	      , FORCED     = !TypedArray || !$typed.ABV
	      , O          = {}
	      , TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function(that, index){
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function(that, index, value){
	      var data = that._d;
	      if(CLAMPED)value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function(that, index){
	      dP(that, index, {
	        get: function(){
	          return getter(this, index);
	        },
	        set: function(value){
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if(FORCED){
	      TypedArray = wrapper(function(that, data, $offset, $length){
	        anInstance(that, TypedArray, NAME, '_d');
	        var index  = 0
	          , offset = 0
	          , buffer, byteLength, length, klass;
	        if(!isObject(data)){
	          length     = strictToLength(data, true)
	          byteLength = length * BYTES;
	          buffer     = new $ArrayBuffer(byteLength);
	        } else if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if($length === undefined){
	            if($len % BYTES)throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if(byteLength < 0)throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if(byteLength + offset > $len)throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if(TYPED_ARRAY in data){
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while(index < length)addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if(!$iterDetect(function(iter){
	      // V8 works with iterators, but fails in many other cases
	      // https://code.google.com/p/v8/issues/detail?id=4552
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)){
	      TypedArray = wrapper(function(that, data, $offset, $length){
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if(!isObject(data))return new Base(strictToLength(data, ISNT_UINT8));
	        if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if(TYPED_ARRAY in data)return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function(key){
	        if(!(key in TypedArray))hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if(!LIBRARY)TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator   = TypedArrayPrototype[ITERATOR]
	      , CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined)
	      , $iterator         = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

	    if(CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)){
	      dP(TypedArrayPrototype, TAG, {
	        get: function(){ return NAME; }
	      });
	    }

	    O[NAME] = TypedArray;

	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES,
	      from: $from,
	      of: $of
	    });

	    if(!(BYTES_PER_ELEMENT in TypedArrayPrototype))hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

	    $export($export.P, NAME, proto);

	    setSpecies(NAME);

	    $export($export.P + $export.F * FORCED_SET, NAME, {set: $set});

	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

	    $export($export.P + $export.F * (TypedArrayPrototype.toString != arrayToString), NAME, {toString: arrayToString});

	    $export($export.P + $export.F * fails(function(){
	      new TypedArray(1).slice();
	    }), NAME, {slice: $slice});

	    $export($export.P + $export.F * (fails(function(){
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString()
	    }) || !fails(function(){
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, {toLocaleString: $toLocaleString});

	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if(!LIBRARY && !CORRECT_ITER_NAME)hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function(){ /* empty */ };

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(304)('Uint8', 1, function(init){
	  return function Uint8Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(304)('Uint8', 1, function(init){
	  return function Uint8ClampedArray(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	}, true);

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(304)('Int16', 2, function(init){
	  return function Int16Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(304)('Uint16', 2, function(init){
	  return function Uint16Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(304)('Int32', 4, function(init){
	  return function Int32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(304)('Uint32', 4, function(init){
	  return function Uint32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(304)('Float32', 4, function(init){
	  return function Float32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(304)('Float64', 8, function(init){
	  return function Float64Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export   = __webpack_require__(89)
	  , aFunction = __webpack_require__(102)
	  , anObject  = __webpack_require__(93)
	  , rApply    = (__webpack_require__(85).Reflect || {}).apply
	  , fApply    = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(88)(function(){
	  rApply(function(){});
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList){
	    var T = aFunction(target)
	      , L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export    = __webpack_require__(89)
	  , create     = __webpack_require__(127)
	  , aFunction  = __webpack_require__(102)
	  , anObject   = __webpack_require__(93)
	  , isObject   = __webpack_require__(94)
	  , fails      = __webpack_require__(88)
	  , bind       = __webpack_require__(158)
	  , rConstruct = (__webpack_require__(85).Reflect || {}).construct;

	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function(){
	  function F(){}
	  return !(rConstruct(function(){}, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function(){
	  rConstruct(function(){});
	});

	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /*, newTarget*/){
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if(ARGS_BUG && !NEW_TARGET_BUG)return rConstruct(Target, args, newTarget);
	    if(Target == newTarget){
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch(args.length){
	        case 0: return new Target;
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args));
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto    = newTarget.prototype
	      , instance = create(isObject(proto) ? proto : Object.prototype)
	      , result   = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP          = __webpack_require__(92)
	  , $export     = __webpack_require__(89)
	  , anObject    = __webpack_require__(93)
	  , toPrimitive = __webpack_require__(97);

	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(88)(function(){
	  Reflect.defineProperty(dP.f({}, 1, {value: 1}), 1, {value: 2});
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes){
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export  = __webpack_require__(89)
	  , gOPD     = __webpack_require__(132).f
	  , anObject = __webpack_require__(93);

	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey){
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export  = __webpack_require__(89)
	  , anObject = __webpack_require__(93);
	var Enumerate = function(iterated){
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = []       // keys
	    , key;
	  for(key in iterated)keys.push(key);
	};
	__webpack_require__(211)(Enumerate, 'Object', function(){
	  var that = this
	    , keys = that._k
	    , key;
	  do {
	    if(that._i >= keys.length)return {value: undefined, done: true};
	  } while(!((key = keys[that._i++]) in that._t));
	  return {value: key, done: false};
	});

	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target){
	    return new Enumerate(target);
	  }
	});

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD           = __webpack_require__(132)
	  , getPrototypeOf = __webpack_require__(140)
	  , has            = __webpack_require__(86)
	  , $export        = __webpack_require__(89)
	  , isObject       = __webpack_require__(94)
	  , anObject       = __webpack_require__(93);

	function get(target, propertyKey/*, receiver*/){
	  var receiver = arguments.length < 3 ? target : arguments[2]
	    , desc, proto;
	  if(anObject(target) === receiver)return target[propertyKey];
	  if(desc = gOPD.f(target, propertyKey))return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if(isObject(proto = getPrototypeOf(target)))return get(proto, propertyKey, receiver);
	}

	$export($export.S, 'Reflect', {get: get});

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD     = __webpack_require__(132)
	  , $export  = __webpack_require__(89)
	  , anObject = __webpack_require__(93);

	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey){
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export  = __webpack_require__(89)
	  , getProto = __webpack_require__(140)
	  , anObject = __webpack_require__(93);

	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target){
	    return getProto(anObject(target));
	  }
	});

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(89);

	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey){
	    return propertyKey in target;
	  }
	});

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export       = __webpack_require__(89)
	  , anObject      = __webpack_require__(93)
	  , $isExtensible = Object.isExtensible;

	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target){
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(89);

	$export($export.S, 'Reflect', {ownKeys: __webpack_require__(324)});

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN     = __webpack_require__(131)
	  , gOPS     = __webpack_require__(124)
	  , anObject = __webpack_require__(93)
	  , Reflect  = __webpack_require__(85).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it){
	  var keys       = gOPN.f(anObject(it))
	    , getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export            = __webpack_require__(89)
	  , anObject           = __webpack_require__(93)
	  , $preventExtensions = Object.preventExtensions;

	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target){
	    anObject(target);
	    try {
	      if($preventExtensions)$preventExtensions(target);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP             = __webpack_require__(92)
	  , gOPD           = __webpack_require__(132)
	  , getPrototypeOf = __webpack_require__(140)
	  , has            = __webpack_require__(86)
	  , $export        = __webpack_require__(89)
	  , createDesc     = __webpack_require__(98)
	  , anObject       = __webpack_require__(93)
	  , isObject       = __webpack_require__(94);

	function set(target, propertyKey, V/*, receiver*/){
	  var receiver = arguments.length < 4 ? target : arguments[3]
	    , ownDesc  = gOPD.f(anObject(target), propertyKey)
	    , existingDescriptor, proto;
	  if(!ownDesc){
	    if(isObject(proto = getPrototypeOf(target))){
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if(has(ownDesc, 'value')){
	    if(ownDesc.writable === false || !isObject(receiver))return false;
	    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
	    existingDescriptor.value = V;
	    dP.f(receiver, propertyKey, existingDescriptor);
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}

	$export($export.S, 'Reflect', {set: set});

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export  = __webpack_require__(89)
	  , setProto = __webpack_require__(154);

	if(setProto)$export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto){
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export   = __webpack_require__(89)
	  , $includes = __webpack_require__(117)(true);

	$export($export.P, 'Array', {
	  includes: function includes(el /*, fromIndex = 0 */){
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});

	__webpack_require__(267)('includes');

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(89)
	  , $at     = __webpack_require__(208)(true);

	$export($export.P, 'String', {
	  at: function at(pos){
	    return $at(this, pos);
	  }
	});

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(89)
	  , $pad    = __webpack_require__(331);

	$export($export.P, 'String', {
	  padStart: function padStart(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(118)
	  , repeat   = __webpack_require__(172)
	  , defined  = __webpack_require__(116);

	module.exports = function(that, maxLength, fillString, left){
	  var S            = String(defined(that))
	    , stringLength = S.length
	    , fillStr      = fillString === undefined ? ' ' : String(fillString)
	    , intMaxLength = toLength(maxLength);
	  if(intMaxLength <= stringLength || fillStr == '')return S;
	  var fillLen = intMaxLength - stringLength
	    , stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if(stringFiller.length > fillLen)stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(89)
	  , $pad    = __webpack_require__(331);

	$export($export.P, 'String', {
	  padEnd: function padEnd(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(164)('trimLeft', function($trim){
	  return function trimLeft(){
	    return $trim(this, 1);
	  };
	}, 'trimStart');

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(164)('trimRight', function($trim){
	  return function trimRight(){
	    return $trim(this, 2);
	  };
	}, 'trimEnd');

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export     = __webpack_require__(89)
	  , defined     = __webpack_require__(116)
	  , toLength    = __webpack_require__(118)
	  , isRegExp    = __webpack_require__(215)
	  , getFlags    = __webpack_require__(277)
	  , RegExpProto = RegExp.prototype;

	var $RegExpStringIterator = function(regexp, string){
	  this._r = regexp;
	  this._s = string;
	};

	__webpack_require__(211)($RegExpStringIterator, 'RegExp String', function next(){
	  var match = this._r.exec(this._s);
	  return {value: match, done: match === null};
	});

	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp){
	    defined(this);
	    if(!isRegExp(regexp))throw TypeError(regexp + ' is not a regexp!');
	    var S     = String(this)
	      , flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp)
	      , rx    = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(108)('asyncIterator');

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(108)('observable');

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export        = __webpack_require__(89)
	  , ownKeys        = __webpack_require__(324)
	  , toIObject      = __webpack_require__(113)
	  , gOPD           = __webpack_require__(132)
	  , createProperty = __webpack_require__(244);

	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object){
	    var O       = toIObject(object)
	      , getDesc = gOPD.f
	      , keys    = ownKeys(O)
	      , result  = {}
	      , i       = 0
	      , key;
	    while(keys.length > i)createProperty(result, key = keys[i++], getDesc(O, key));
	    return result;
	  }
	});

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(89)
	  , $values = __webpack_require__(340)(false);

	$export($export.S, 'Object', {
	  values: function values(it){
	    return $values(it);
	  }
	});

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(111)
	  , toIObject = __webpack_require__(113)
	  , isEnum    = __webpack_require__(125).f;
	module.exports = function(isEntries){
	  return function(it){
	    var O      = toIObject(it)
	      , keys   = getKeys(O)
	      , length = keys.length
	      , i      = 0
	      , result = []
	      , key;
	    while(length > i)if(isEnum.call(O, key = keys[i++])){
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export  = __webpack_require__(89)
	  , $entries = __webpack_require__(340)(true);

	$export($export.S, 'Object', {
	  entries: function entries(it){
	    return $entries(it);
	  }
	});

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export         = __webpack_require__(89)
	  , toObject        = __webpack_require__(139)
	  , aFunction       = __webpack_require__(102)
	  , $defineProperty = __webpack_require__(92);

	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(87) && $export($export.P + __webpack_require__(343), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter){
	    $defineProperty.f(toObject(this), P, {get: aFunction(getter), enumerable: true, configurable: true});
	  }
	});

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(109)|| !__webpack_require__(88)(function(){
	  var K = Math.random();
	  // In FF throws only define methods
	  __defineSetter__.call(null, K, function(){ /* empty */});
	  delete __webpack_require__(85)[K];
	});

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export         = __webpack_require__(89)
	  , toObject        = __webpack_require__(139)
	  , aFunction       = __webpack_require__(102)
	  , $defineProperty = __webpack_require__(92);

	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(87) && $export($export.P + __webpack_require__(343), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter){
	    $defineProperty.f(toObject(this), P, {set: aFunction(setter), enumerable: true, configurable: true});
	  }
	});

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export                  = __webpack_require__(89)
	  , toObject                 = __webpack_require__(139)
	  , toPrimitive              = __webpack_require__(97)
	  , getPrototypeOf           = __webpack_require__(140)
	  , getOwnPropertyDescriptor = __webpack_require__(132).f;

	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(87) && $export($export.P + __webpack_require__(343), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P){
	    var O = toObject(this)
	      , K = toPrimitive(P, true)
	      , D;
	    do {
	      if(D = getOwnPropertyDescriptor(O, K))return D.get;
	    } while(O = getPrototypeOf(O));
	  }
	});

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export                  = __webpack_require__(89)
	  , toObject                 = __webpack_require__(139)
	  , toPrimitive              = __webpack_require__(97)
	  , getPrototypeOf           = __webpack_require__(140)
	  , getOwnPropertyDescriptor = __webpack_require__(132).f;

	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(87) && $export($export.P + __webpack_require__(343), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P){
	    var O = toObject(this)
	      , K = toPrimitive(P, true)
	      , D;
	    do {
	      if(D = getOwnPropertyDescriptor(O, K))return D.set;
	    } while(O = getPrototypeOf(O));
	  }
	});

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(89);

	$export($export.P + $export.R, 'Map', {toJSON: __webpack_require__(348)('Map')});

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(156)
	  , from    = __webpack_require__(349);
	module.exports = function(NAME){
	  return function toJSON(){
	    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(287);

	module.exports = function(iter, ITERATOR){
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(89);

	$export($export.P + $export.R, 'Set', {toJSON: __webpack_require__(348)('Set')});

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-global
	var $export = __webpack_require__(89);

	$export($export.S, 'System', {global: __webpack_require__(85)});

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(89)
	  , cof     = __webpack_require__(115);

	$export($export.S, 'Error', {
	  isError: function isError(it){
	    return cof(it) === 'Error';
	  }
	});

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(89);

	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1){
	    var $x0 = x0 >>> 0
	      , $x1 = x1 >>> 0
	      , $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(89);

	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1){
	    var $x0 = x0 >>> 0
	      , $x1 = x1 >>> 0
	      , $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(89);

	$export($export.S, 'Math', {
	  imulh: function imulh(u, v){
	    var UINT16 = 0xffff
	      , $u = +u
	      , $v = +v
	      , u0 = $u & UINT16
	      , v0 = $v & UINT16
	      , u1 = $u >> 16
	      , v1 = $v >> 16
	      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(89);

	$export($export.S, 'Math', {
	  umulh: function umulh(u, v){
	    var UINT16 = 0xffff
	      , $u = +u
	      , $v = +v
	      , u0 = $u & UINT16
	      , v0 = $v & UINT16
	      , u1 = $u >>> 16
	      , v1 = $v >>> 16
	      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	var metadata                  = __webpack_require__(358)
	  , anObject                  = __webpack_require__(93)
	  , toMetaKey                 = metadata.key
	  , ordinaryDefineOwnMetadata = metadata.set;

	metadata.exp({defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey){
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	}});

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	var Map     = __webpack_require__(292)
	  , $export = __webpack_require__(89)
	  , shared  = __webpack_require__(104)('metadata')
	  , store   = shared.store || (shared.store = new (__webpack_require__(296)));

	var getOrCreateMetadataMap = function(target, targetKey, create){
	  var targetMetadata = store.get(target);
	  if(!targetMetadata){
	    if(!create)return undefined;
	    store.set(target, targetMetadata = new Map);
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if(!keyMetadata){
	    if(!create)return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map);
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function(MetadataKey, O, P){
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function(MetadataKey, O, P){
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function(MetadataKey, MetadataValue, O, P){
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function(target, targetKey){
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false)
	    , keys        = [];
	  if(metadataMap)metadataMap.forEach(function(_, key){ keys.push(key); });
	  return keys;
	};
	var toMetaKey = function(it){
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function(O){
	  $export($export.S, 'Reflect', O);
	};

	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(358)
	  , anObject               = __webpack_require__(93)
	  , toMetaKey              = metadata.key
	  , getOrCreateMetadataMap = metadata.map
	  , store                  = metadata.store;

	metadata.exp({deleteMetadata: function deleteMetadata(metadataKey, target /*, targetKey */){
	  var targetKey   = arguments.length < 3 ? undefined : toMetaKey(arguments[2])
	    , metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if(metadataMap === undefined || !metadataMap['delete'](metadataKey))return false;
	  if(metadataMap.size)return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	}});

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(358)
	  , anObject               = __webpack_require__(93)
	  , getPrototypeOf         = __webpack_require__(140)
	  , ordinaryHasOwnMetadata = metadata.has
	  , ordinaryGetOwnMetadata = metadata.get
	  , toMetaKey              = metadata.key;

	var ordinaryGetMetadata = function(MetadataKey, O, P){
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if(hasOwn)return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};

	metadata.exp({getMetadata: function getMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	var Set                     = __webpack_require__(295)
	  , from                    = __webpack_require__(349)
	  , metadata                = __webpack_require__(358)
	  , anObject                = __webpack_require__(93)
	  , getPrototypeOf          = __webpack_require__(140)
	  , ordinaryOwnMetadataKeys = metadata.keys
	  , toMetaKey               = metadata.key;

	var ordinaryMetadataKeys = function(O, P){
	  var oKeys  = ordinaryOwnMetadataKeys(O, P)
	    , parent = getPrototypeOf(O);
	  if(parent === null)return oKeys;
	  var pKeys  = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};

	metadata.exp({getMetadataKeys: function getMetadataKeys(target /*, targetKey */){
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	}});

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(358)
	  , anObject               = __webpack_require__(93)
	  , ordinaryGetOwnMetadata = metadata.get
	  , toMetaKey              = metadata.key;

	metadata.exp({getOwnMetadata: function getOwnMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	var metadata                = __webpack_require__(358)
	  , anObject                = __webpack_require__(93)
	  , ordinaryOwnMetadataKeys = metadata.keys
	  , toMetaKey               = metadata.key;

	metadata.exp({getOwnMetadataKeys: function getOwnMetadataKeys(target /*, targetKey */){
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	}});

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(358)
	  , anObject               = __webpack_require__(93)
	  , getPrototypeOf         = __webpack_require__(140)
	  , ordinaryHasOwnMetadata = metadata.has
	  , toMetaKey              = metadata.key;

	var ordinaryHasMetadata = function(MetadataKey, O, P){
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if(hasOwn)return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};

	metadata.exp({hasMetadata: function hasMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(358)
	  , anObject               = __webpack_require__(93)
	  , ordinaryHasOwnMetadata = metadata.has
	  , toMetaKey              = metadata.key;

	metadata.exp({hasOwnMetadata: function hasOwnMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	var metadata                  = __webpack_require__(358)
	  , anObject                  = __webpack_require__(93)
	  , aFunction                 = __webpack_require__(102)
	  , toMetaKey                 = metadata.key
	  , ordinaryDefineOwnMetadata = metadata.set;

	metadata.exp({metadata: function metadata(metadataKey, metadataValue){
	  return function decorator(target, targetKey){
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	}});

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export   = __webpack_require__(89)
	  , microtask = __webpack_require__(290)()
	  , process   = __webpack_require__(85).process
	  , isNode    = __webpack_require__(115)(process) == 'process';

	$export($export.G, {
	  asap: function asap(fn){
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export     = __webpack_require__(89)
	  , global      = __webpack_require__(85)
	  , core        = __webpack_require__(90)
	  , microtask   = __webpack_require__(290)()
	  , OBSERVABLE  = __webpack_require__(106)('observable')
	  , aFunction   = __webpack_require__(102)
	  , anObject    = __webpack_require__(93)
	  , anInstance  = __webpack_require__(286)
	  , redefineAll = __webpack_require__(291)
	  , hide        = __webpack_require__(91)
	  , forOf       = __webpack_require__(287)
	  , RETURN      = forOf.RETURN;

	var getMethod = function(fn){
	  return fn == null ? undefined : aFunction(fn);
	};

	var cleanupSubscription = function(subscription){
	  var cleanup = subscription._c;
	  if(cleanup){
	    subscription._c = undefined;
	    cleanup();
	  }
	};

	var subscriptionClosed = function(subscription){
	  return subscription._o === undefined;
	};

	var closeSubscription = function(subscription){
	  if(!subscriptionClosed(subscription)){
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};

	var Subscription = function(observer, subscriber){
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup      = subscriber(observer)
	      , subscription = cleanup;
	    if(cleanup != null){
	      if(typeof cleanup.unsubscribe === 'function')cleanup = function(){ subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch(e){
	    observer.error(e);
	    return;
	  } if(subscriptionClosed(this))cleanupSubscription(this);
	};

	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe(){ closeSubscription(this); }
	});

	var SubscriptionObserver = function(subscription){
	  this._s = subscription;
	};

	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value){
	    var subscription = this._s;
	    if(!subscriptionClosed(subscription)){
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if(m)return m.call(observer, value);
	      } catch(e){
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value){
	    var subscription = this._s;
	    if(subscriptionClosed(subscription))throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if(!m)throw value;
	      value = m.call(observer, value);
	    } catch(e){
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value){
	    var subscription = this._s;
	    if(!subscriptionClosed(subscription)){
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch(e){
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});

	var $Observable = function Observable(subscriber){
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};

	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer){
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn){
	    var that = this;
	    return new (core.Promise || global.Promise)(function(resolve, reject){
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next : function(value){
	          try {
	            return fn(value);
	          } catch(e){
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});

	redefineAll($Observable, {
	  from: function from(x){
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if(method){
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function(observer){
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function(observer){
	      var done = false;
	      microtask(function(){
	        if(!done){
	          try {
	            if(forOf(x, false, function(it){
	              observer.next(it);
	              if(done)return RETURN;
	            }) === RETURN)return;
	          } catch(e){
	            if(done)throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function(){ done = true; };
	    });
	  },
	  of: function of(){
	    for(var i = 0, l = arguments.length, items = Array(l); i < l;)items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function(observer){
	      var done = false;
	      microtask(function(){
	        if(!done){
	          for(var i = 0; i < items.length; ++i){
	            observer.next(items[i]);
	            if(done)return;
	          } observer.complete();
	        }
	      });
	      return function(){ done = true; };
	    });
	  }
	});

	hide($Observable.prototype, OBSERVABLE, function(){ return this; });

	$export($export.G, {Observable: $Observable});

	__webpack_require__(273)('Observable');

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global     = __webpack_require__(85)
	  , $export    = __webpack_require__(89)
	  , invoke     = __webpack_require__(159)
	  , partial    = __webpack_require__(370)
	  , navigator  = global.navigator
	  , MSIE       = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
	var wrap = function(set){
	  return MSIE ? function(fn, time /*, ...args */){
	    return set(invoke(
	      partial,
	      [].slice.call(arguments, 2),
	      typeof fn == 'function' ? fn : Function(fn)
	    ), time);
	  } : set;
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout:  wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var path      = __webpack_require__(371)
	  , invoke    = __webpack_require__(159)
	  , aFunction = __webpack_require__(102);
	module.exports = function(/* ...pargs */){
	  var fn     = aFunction(this)
	    , length = arguments.length
	    , pargs  = Array(length)
	    , i      = 0
	    , _      = path._
	    , holder = false;
	  while(length > i)if((pargs[i] = arguments[i++]) === _)holder = true;
	  return function(/* ...args */){
	    var that = this
	      , aLen = arguments.length
	      , j = 0, k = 0, args;
	    if(!holder && !aLen)return invoke(fn, pargs, that);
	    args = pargs.slice();
	    if(holder)for(;length > j; j++)if(args[j] === _)args[j] = arguments[k++];
	    while(aLen > k)args.push(arguments[k++]);
	    return invoke(fn, args, that);
	  };
	};

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(85);

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(89)
	  , $task   = __webpack_require__(289);
	$export($export.G + $export.B, {
	  setImmediate:   $task.set,
	  clearImmediate: $task.clear
	});

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	var $iterators    = __webpack_require__(274)
	  , redefine      = __webpack_require__(99)
	  , global        = __webpack_require__(85)
	  , hide          = __webpack_require__(91)
	  , Iterators     = __webpack_require__(210)
	  , wks           = __webpack_require__(106)
	  , ITERATOR      = wks('iterator')
	  , TO_STRING_TAG = wks('toStringTag')
	  , ArrayValues   = Iterators.Array;

	for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
	  var NAME       = collections[i]
	    , Collection = global[NAME]
	    , proto      = Collection && Collection.prototype
	    , key;
	  if(proto){
	    if(!proto[ITERATOR])hide(proto, ITERATOR, ArrayValues);
	    if(!proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    for(key in $iterators)if(!proto[key])redefine(proto, key, $iterators[key], true);
	  }
	}

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */

	!(function(global) {
	  "use strict";

	  var hasOwn = Object.prototype.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }

	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided, then outerFn.prototype instanceof Generator.
	    var generator = Object.create((outerFn || Generator).prototype);
	    var context = new Context(tryLocsList || []);

	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);

	    return generator;
	  }
	  runtime.wrap = wrap;

	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }

	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";

	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};

	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}

	  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype;
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";

	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }

	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };

	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };

	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `value instanceof AwaitArgument` to determine if the yielded value is
	  // meant to be awaited. Some may consider the name of this method too
	  // cutesy, but they are curmudgeons.
	  runtime.awrap = function(arg) {
	    return new AwaitArgument(arg);
	  };

	  function AwaitArgument(arg) {
	    this.arg = arg;
	  }

	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value instanceof AwaitArgument) {
	          return Promise.resolve(value.arg).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }

	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }

	    if (typeof process === "object" && process.domain) {
	      invoke = process.domain.bind(invoke);
	    }

	    var previousPromise;

	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }

	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }

	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }

	  defineIteratorMethods(AsyncIterator.prototype);

	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );

	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };

	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;

	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }

	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }

	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }

	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          if (method === "return" ||
	              (method === "throw" && delegate.iterator[method] === undefined)) {
	            // A return or throw (when the delegate iterator has no throw
	            // method) always terminates the yield* loop.
	            context.delegate = null;

	            // If the delegate iterator has a return method, give it a
	            // chance to clean up.
	            var returnMethod = delegate.iterator["return"];
	            if (returnMethod) {
	              var record = tryCatch(returnMethod, delegate.iterator, arg);
	              if (record.type === "throw") {
	                // If the return method threw an exception, let that
	                // exception prevail over the original return or throw.
	                method = "throw";
	                arg = record.arg;
	                continue;
	              }
	            }

	            if (method === "return") {
	              // Continue with the outer return, now that the delegate
	              // iterator has been terminated.
	              continue;
	            }
	          }

	          var record = tryCatch(
	            delegate.iterator[method],
	            delegate.iterator,
	            arg
	          );

	          if (record.type === "throw") {
	            context.delegate = null;

	            // Like returning generator.throw(uncaught), but without the
	            // overhead of an extra function call.
	            method = "throw";
	            arg = record.arg;
	            continue;
	          }

	          // Delegate generator ran and handled its own exceptions so
	          // regardless of what the method was, we continue as if it is
	          // "next" with an undefined arg.
	          method = "next";
	          arg = undefined;

	          var info = record.arg;
	          if (info.done) {
	            context[delegate.resultName] = info.value;
	            context.next = delegate.nextLoc;
	          } else {
	            state = GenStateSuspendedYield;
	            return info;
	          }

	          context.delegate = null;
	        }

	        if (method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = arg;

	        } else if (method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw arg;
	          }

	          if (context.dispatchException(arg)) {
	            // If the dispatched exception was caught by a catch block,
	            // then let that catch block handle the exception normally.
	            method = "next";
	            arg = undefined;
	          }

	        } else if (method === "return") {
	          context.abrupt("return", arg);
	        }

	        state = GenStateExecuting;

	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;

	          var info = {
	            value: record.arg,
	            done: context.done
	          };

	          if (record.arg === ContinueSentinel) {
	            if (context.delegate && method === "next") {
	              // Deliberately forget the last sent value so that we don't
	              // accidentally pass it on to the delegate.
	              arg = undefined;
	            }
	          } else {
	            return info;
	          }

	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(arg) call above.
	          method = "throw";
	          arg = record.arg;
	        }
	      }
	    };
	  }

	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);

	  Gp[iteratorSymbol] = function() {
	    return this;
	  };

	  Gp[toStringTagSymbol] = "Generator";

	  Gp.toString = function() {
	    return "[object Generator]";
	  };

	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };

	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }

	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }

	    this.tryEntries.push(entry);
	  }

	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }

	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }

	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();

	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }

	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };

	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }

	      if (typeof iterable.next === "function") {
	        return iterable;
	      }

	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }

	          next.value = undefined;
	          next.done = true;

	          return next;
	        };

	        return next.next = next;
	      }
	    }

	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;

	  function doneResult() {
	    return { value: undefined, done: true };
	  }

	  Context.prototype = {
	    constructor: Context,

	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;

	      this.tryEntries.forEach(resetTryEntry);

	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },

	    stop: function() {
	      this.done = true;

	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }

	      return this.rval;
	    },

	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }

	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	        return !!caught;
	      }

	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;

	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }

	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");

	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }

	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }

	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }

	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },

	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }

	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }

	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;

	      if (finallyEntry) {
	        this.next = finallyEntry.finallyLoc;
	      } else {
	        this.complete(record);
	      }

	      return ContinueSentinel;
	    },

	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }

	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = record.arg;
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	    },

	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },

	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }

	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },

	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };

	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(375)))

/***/ },
/* 375 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};

	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.

	var cachedSetTimeout;
	var cachedClearTimeout;

	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }


	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }



	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;

	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}

	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;

	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}

	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};

	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};

	function noop() {}

	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;

	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};

	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(377);
	module.exports = __webpack_require__(90).RegExp.escape;

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(89)
	  , $re     = __webpack_require__(378)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

	$export($export.S, 'RegExp', {escape: function escape(it){ return $re(it); }});


/***/ },
/* 378 */
/***/ function(module, exports) {

	module.exports = function(regExp, replace){
	  var replacer = replace === Object(replace) ? function(part){
	    return replace[part];
	  } : replace;
	  return function(it){
	    return String(it).replace(regExp, replacer);
	  };
	};

/***/ },
/* 379 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _defines = __webpack_require__(3);

	var _defines2 = _interopRequireDefault(_defines);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/*
	 This file contains debug switches for console reporting and disabling of features.

	 The following switches can be overridden by uScopeStart's settings ...................
	 */

	_defines2.default.DISABLEOVERLAYITEMS = false; // default false, enable load label, mag, thumb, scalebar, zoom, toolbar
	_defines2.default.ENABLELABEL = true; // default true, enable load/create of the label
	_defines2.default.ENABLEMAG = true; // default true, enable load/create of the magnifier
	_defines2.default.ENABLETHUMB = true; // default true, enable load/create of the thumbnail
	_defines2.default.ENABLESCALEBAR = true; // default true, enable load/create of the scale bar
	_defines2.default.ENABLEZOOMCTL = true; // default true, enable load/create of the zoom control
	_defines2.default.ENABLEZOOMSLIDER = true; // default true, enable load/create of the zoom slider control
	_defines2.default.ENABLEROTATION = true; // default true, enable image rotation
	_defines2.default.ENABLEHEATMAP = true; // default true, visibility and draw switch
	_defines2.default.ENABLEAUTOANNOTSAVE = true; // default true, enable automatic (as drawn) save annotations
	_defines2.default.ENABLEANNOTCREATE = true; // default true, [dis|en]able annotation creation
	_defines2.default.ENABLEANNOTSELSAVE = false; // default false, enable save each region select action - NOT overridden (yet) by start settings
	_defines2.default.ENABLELINKTOIMAGE = false; // default false, provide link to image

	////////////////////////////////////in work
	_defines2.default.ENABLEANALYSIS = false; // global switch  //todo: uscope settings will define
	_defines2.default.DISPLAYMARKUP = true; // global switch  //todo: uscope settings or user prefs will define
	////////////////////////////////////

	//........................... the following switches are used for development purposes  ...................

	_defines2.default.ENABLEDEVHOTKEYS = false; // default false, permit development hotkey action
	_defines2.default.SHOWALLTOOLBARICONS = false; // default false, display all top toolbar icons
	_defines2.default.ENABLEPERFTEST = false; // disabled on purpose until fixed in multi-image        // default true, permit performance testing (expose on settings panel)

	_defines2.default.ENABLEVIEWPREVNEXT = false; // default false, previous/next VIEW .... until this is exposed to the user

	_defines2.default.ENABLEADDTOANYLAYER = false; // default false, add all new regions to A-layer

	_defines2.default.DISABLEEXTERNALCALLBACKS = false; // default false, do not issue any callbacks; useful when callbacks crash

	_defines2.default.DISABLEUSERPREFS2DB = false; // default false, inhibit read/write to database

	_defines2.default.DISABLEWHEELZOOM = false; // default false, inhibit zoom with mouse wheel
	_defines2.default.ENABLEDRAGMOMENTUM = true; // default true, perform drag momentum

	_defines2.default.ENABLEPROGRESSIVE = true; // default true, perform fake progressive rendering

	_defines2.default.ENABLETILEMETER = true; // default false, don't perform tile timing
	_defines2.default.ENABLEREFRESHMETER = false; // default false, display refresh meter with tilemeter

	_defines2.default.ENABLECONTEXTMENU = true; // default true, right click context toolbar


	// the following are performance and visual options .....................
	_defines2.default.DOVERTICALZOOMCTL = true; // default true, zoom controls can be horizontal
	_defines2.default.DOZOOMCOLOR = true; // default true, add objective color codes to zoom buttons
	_defines2.default.ENABLETHUMBHOVER = true; // default true, allows hover over thumbnail to enlarge thumbnail
	_defines2.default.ENABLEIMAGEQUALITYSETTING = false; // This does nothing but display an image qualify slider, which isn't actually hooked up.
	_defines2.default.ENABLEAUTOPAN = true; // default true,

	// the following are view refresh and tile construction option .........
	_defines2.default.ENABLEPYRAMIDREFRESH = true; // default true, tile requests at pyramid levels (as opposed to server side scaling)
	_defines2.default.USEMULTIPYRAMIDLEVELS = true; // default true, refresh at multiple pyrmaid levels
	_defines2.default.ADDINTERMEDIATELEVEL = true; // default true, add intermediate pyramid level half way between gaps > 3x (e.g 10x between 20 and 5)
	_defines2.default.USEBASECOORDS = false; // default false, tile url to use base level coords or directly address the zoom level

	_defines2.default.ONLYLOWPYRAMIDLEVEL = false; // default false, override multiple level to only display refresh of low pyr level zoom.... for testing

	//________________________________________________________________________________________________
	// the following switches are used for debug  purposes  ...................

	_defines2.default.DBGTILEBOUNDARIES = false; // outline tile boundaries

	_defines2.default.DBGSTART = false; // console startup and image open reports
	_defines2.default.DBGLOAD = false; // console load script reports
	_defines2.default.DBGXINFO = false; // console xinfo reports
	_defines2.default.DBGPYRAMID = false; // console xinfo pyramid reports

	_defines2.default.DBGANNOT = false; // console annotation reports
	_defines2.default.DBGREDRAW = false; // console freeform/pen redraw reports
	_defines2.default.DBGANNOTEX = false; // console annotation reports - extreme
	_defines2.default.DBGPDNAV = false; // console pin drop navigation reports

	_defines2.default.DBGTILEMETER = false; // console tile meter reports
	_defines2.default.DBGVIEWMETER = false; // console view meter reports

	_defines2.default.DBGMULTIVIEW = false; // console multi-image reports

	_defines2.default.DBGANALYSIS = false; // console analysis reports
	_defines2.default.DBGMARKUP = false; // console markup reports
	_defines2.default.DBGMARKUPEX = false; // console markup reports extended
	_defines2.default.DBGMACROS = false; // console macro reports
	_defines2.default.DBGALGOS = false; // console algorithm reports

	_defines2.default.DBGTHREAD = false; // console thread reports
	_defines2.default.DBGEVENTS = false; // console event reports - all but mouse
	_defines2.default.DBGMOUSEEVENTS = false; // console mouse event reports - all but mouse move
	_defines2.default.DBGMOUSEMOVE = false; // console mouse move reports
	_defines2.default.DBGDCLICK = false; // console mouse double click reports

	_defines2.default.DBGNAV = false; // console navigation reports
	_defines2.default.DBGMOMENTUM = false; // console drag momentum reports
	_defines2.default.DBGRESIZE = false; // console resize reports

	_defines2.default.DBGIOS = false; // console ios reports
	_defines2.default.DBGSWIPE = false; // console ios swipe reports
	_defines2.default.DBGPINCH = false; // console ios pinch zoom reports

	_defines2.default.DBGRASTERSCAN = false; // console rasterScan reports
	_defines2.default.DBGAUTOPAN = false; // console autopan reports
	_defines2.default.DBGEDGENAV = false; // console edge nav reports

	_defines2.default.DBGMSGING = false; // console messaging reports
	_defines2.default.DBGIMAGEPAINT = false; // console refresh reports and tile coords printed on each tile
	_defines2.default.DBGIMAGEPAINTEX = false; // console refresh reports - extreme
	_defines2.default.DBGTILEBUILD = false; // console build tile reports

	_defines2.default.DBGPROGRESSIVE = false; // console progressive image reports

	_defines2.default.DBGIMGLOAD = false; // console tile load reports
	_defines2.default.DBGTIME = false; // console time reports for: tile, row of tiles,

	_defines2.default.DBGMOVETIME = false; // console time reports for view move
	_defines2.default.DBGREFRESHTIME = false; // console time reports for view refresh
	_defines2.default.DBGPERFTEST = false && _defines2.default.ENABLEPERFTEST; // console reports on performance testing


	_defines2.default.DBGSTATEVECTOR = false; // console state vector reports
	_defines2.default.DBGSTATEVECTOREX = false; // console state vector reports - extreme

	_defines2.default.DBGLAYOUT = false; // console overlay layout reports
	_defines2.default.DBGVIEWLAYOUT = false; // console view layout reports
	_defines2.default.DBGTHUMBCTL = false; // console thumbnail reports
	_defines2.default.DBGTHUMBVFCTL = false; // console thumbnail viewfinderreports
	_defines2.default.DBGLABELCTL = false; // console label reports
	_defines2.default.DBGMARKERCTL = false; // console marker reports
	_defines2.default.DBGMAGCTL = false; // console magnifier reports

	_defines2.default.DBGZOOMCTL = false; // console zoom control and zoom execution reports
	_defines2.default.DBGZMBTNPYRAMID = false; // construct a zoom button control with LOTS of zoom choices

	_defines2.default.DBGTOOLBAR = false; // toolbar reports
	_defines2.default.DBGOPTIONS = false; // options (settings) panel reports

/***/ }
/******/ ]);